import type { ID } from './customScalarTypes';
import type { String } from './customScalarTypes';
import type { Boolean } from './customScalarTypes';
import type { Int } from './customScalarTypes';
import type { Float } from './customScalarTypes';
import type { Blob } from './customScalarTypes';
import type { Cursor } from './customScalarTypes';
import type { Date } from './customScalarTypes';
import type { DateTime } from './customScalarTypes';
import type { FederationVersion } from './customScalarTypes';
import type { GraphQLDocument } from './customScalarTypes';
import type { JSON } from './customScalarTypes';
import type { Long } from './customScalarTypes';
import type { NaiveDateTime } from './customScalarTypes';
import type { Object } from './customScalarTypes';
import type { SHA256 } from './customScalarTypes';
import type { StringOrInt } from './customScalarTypes';
import type { Timestamp } from './customScalarTypes';
import type { UUID } from './customScalarTypes';
import type { Void } from './customScalarTypes';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: ID['input']; output: ID['output']; }
  String: { input: String['input']; output: String['output']; }
  Boolean: { input: Boolean['input']; output: Boolean['output']; }
  Int: { input: Int['input']; output: Int['output']; }
  Float: { input: Float['input']; output: Float['output']; }
  /** A blob (base64'ed in JSON & GraphQL) */
  Blob: { input: Blob['input']; output: Blob['output']; }
  Cursor: { input: Cursor['input']; output: Cursor['output']; }
  /** ISO 8601 date format, e.g. 'yyyy-MM-dd' */
  Date: { input: Date['input']; output: Date['output']; }
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: DateTime['input']; output: DateTime['output']; }
  /** The Federation Version of a Supergraph. */
  FederationVersion: { input: FederationVersion['input']; output: FederationVersion['output']; }
  /** A GraphQL document, such as the definition of an operation or schema. */
  GraphQLDocument: { input: GraphQLDocument['input']; output: GraphQLDocument['output']; }
  /** A scalar that can represent any JSON value. */
  JSON: { input: JSON['input']; output: JSON['output']; }
  /** Long type */
  Long: { input: Long['input']; output: Long['output']; }
  /**
   * ISO 8601 combined date and time without timezone.
   *
   * # Examples
   *
   * * `2015-07-01T08:59:60.123`,
   */
  NaiveDateTime: { input: NaiveDateTime['input']; output: NaiveDateTime['output']; }
  /** An arbitrary JSON object. */
  Object: { input: Object['input']; output: Object['output']; }
  /** A SHA-256 hash, represented as a lowercase hexadecimal string. */
  SHA256: { input: SHA256['input']; output: SHA256['output']; }
  StringOrInt: { input: StringOrInt['input']; output: StringOrInt['output']; }
  /** ISO 8601, extended format with nanoseconds, Zulu (or "[+-]seconds" as a string or number relative to now) */
  Timestamp: { input: Timestamp['input']; output: Timestamp['output']; }
  /**
   * A UUID is a unique 128-bit number, stored as 16 octets. UUIDs are parsed as
   * Strings within GraphQL. UUIDs are used to assign unique identifiers to
   * entities without requiring a central allocating authority.
   *
   * # References
   *
   * * [Wikipedia: Universally Unique Identifier](http://en.wikipedia.org/wiki/Universally_unique_identifier)
   * * [RFC4122: A Universally Unique Identifier (UUID) URN Namespace](http://tools.ietf.org/html/rfc4122)
   */
  UUID: { input: UUID['input']; output: UUID['output']; }
  /** Always null */
  Void: { input: Void['input']; output: Void['output']; }
};

/**
 * A user-submitted petition to be granted access to a specific set of fields
 * on an upstream service within an application, following a policy denial.
 */
export type AccessRequest = {
  __typename: 'AccessRequest';
  /** Application the access is being requested for. */
  appId: Scalars['UUID']['output'];
  /**
   * Application the access is being requested for, as a resolved record.
   * Same lookup as `Account.application`, so clients can render app names
   * without joining against the application roster; `appId` remains for
   * consumers that only need the id. Null when the application has since
   * been deleted — access requests outlive their app, and an error here
   * would null-cascade over the whole page.
   */
  application: Maybe<ApplicationType>;
  /** Approval policy governing the quorum requirement. */
  approvalPolicyId: Maybe<Scalars['UUID']['output']>;
  /**
   * Fields that have been approved across all approve decisions.
   * Null when no approve decisions exist yet.
   */
  approvedFields: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the request was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Decisions recorded against this request, ordered by `decidedAt` ascending,
   * `id` ascending as a tiebreaker. Capped at 500 entries.
   */
  decisions: Array<AccessRequestDecision>;
  /**
   * Router-generated integrity token describing the denied fields. Format:
   * `v0.<base64url-no-pad(JSON)>.<sha256-hex>`. The JSON payload contains
   * `blocked_fields`, `app_id`, `service_id`, and request metadata. Pass the
   * `denial_context` value from the router's `CONSTELLATION_ACCESS_DENIED`
   * error extension verbatim.
   */
  denialContext: Scalars['String']['output'];
  /** Server-side reason for denial; null on non-denied requests. */
  denialReason: Maybe<Scalars['String']['output']>;
  /** IDs of policy exceptions evaluated while reviewing this request. */
  exceptionIds: Array<Scalars['UUID']['output']>;
  /** Optional expiry — after this timestamp the request is no longer actionable. */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  /** Stable identifier for the request. */
  id: Scalars['UUID']['output'];
  /** Optional client-supplied key used to deduplicate retries on create. */
  idempotencyKey: Maybe<Scalars['String']['output']>;
  /** The principal the request applies to. Null means the caller's own identity. */
  principal: Maybe<PolicyRulePrincipal>;
  /** Human-readable justification for the request. */
  reason: Scalars['String']['output'];
  /** Fields the caller is requesting access to. */
  requestedFields: Array<Scalars['String']['output']>;
  /** Number of approve decisions required to fully approve the request. */
  requiredApproverCount: Scalars['Int']['output'];
  /** IDs of policy rules evaluated while reviewing this request. */
  ruleIds: Array<Scalars['UUID']['output']>;
  /** Upstream service the access is being requested against. */
  serviceId: Scalars['UUID']['output'];
  /**
   * Base64url-encoded normalized GraphQL operation that triggered the access
   * check. Decode to display the original query to reviewers.
   */
  sourceOperation: Scalars['String']['output'];
  /** Lifecycle status of the request. */
  status: AccessRequestStatus;
  /** Timestamp when the request was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Upstream service the access is being requested against, as a resolved
   * record. Same lookup as `Account.upstreamService`, so clients can render
   * service names without joining against the service roster; `serviceId`
   * remains for consumers that only need the id. Null when the service has
   * since been deleted — access requests outlive it, and an error here
   * would null-cascade over the whole page.
   */
  upstreamService: Maybe<UpstreamService>;
};

/** A single decider's recorded outcome on an access request. */
export type AccessRequestDecision = {
  __typename: 'AccessRequestDecision';
  /**
   * Fields explicitly approved by this decider. Null on deny decisions.
   * A field NOT in this array is implicitly NOT approved by this decider.
   */
  approvedFields: Maybe<Array<Scalars['String']['output']>>;
  /** When the decision was recorded. */
  decidedAt: Scalars['DateTime']['output'];
  /**
   * The decider, as a full actor — id plus GraphOS actor kind. NEW,
   * additive alongside `deciderId` (see that field's own doc comment for
   * why this isn't a clean replace here the way `ApplicationApiKey`'s
   * `createdBy`/`revokedBy` were).
   */
  decider: Actor;
  /**
   * Bare id of the actor that recorded the decision — no `user:`/
   * `service:`/`identity:` prefix (that story is gone; see migration
   * 0037). Kept, unchanged in shape, alongside the new `decider` field
   * below rather than replaced outright: unlike `ApplicationApiKey`'s
   * `createdBy`/`revokedBy`, a plausible-but-unverified external consumer
   * parsing this field's prefix could exist (design §7's pre-flight
   * check), so additive is the safer default here specifically.
   */
  deciderId: Scalars['String']['output'];
  /** Approve or deny. */
  decision: AccessRequestDecisionKind;
  /** Stable identifier for the decision row. */
  id: Scalars['UUID']['output'];
  /** Optional caller-facing note (e.g. denial rationale). */
  note: Maybe<Scalars['String']['output']>;
  /** The access request this decision belongs to. */
  requestId: Scalars['UUID']['output'];
};

/**
 * The outcome a decider records for an access request.
 *
 * Mirrors `crate::models::ApprovalDecision`; kept distinct so the
 * GraphQL surface owns its naming (`AccessRequestDecisionKind`) without
 * leaking the DB-layer enum.
 */
export enum AccessRequestDecisionKind {
  /** Decider approves access, optionally for a subset of fields. */
  APPROVE = 'APPROVE',
  /** Decider denies access. */
  DENY = 'DENY'
}

/**
 * Filter options for `Service.accessRequests`. All fields are optional and
 * compose (logical AND).
 */
export type AccessRequestFilterInput = {
  /** Match only requests targeting this application. */
  appId?: InputMaybe<Scalars['UUID']['input']>;
  /** Match only requests targeting this upstream service. */
  serviceId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Match only requests whose status is one of the supplied values.
   * An empty array is treated the same as null (no status filter).
   */
  status?: InputMaybe<Array<AccessRequestStatus>>;
};

/** Paginated page of `AccessRequest`s. */
export type AccessRequestPage = {
  __typename: 'AccessRequestPage';
  /** Opaque cursor for the next page, or null when there are no more results. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Access requests in this page, in stable order (newest first). */
  items: Array<AccessRequest>;
};

/** Lifecycle status of an access request. */
export enum AccessRequestStatus {
  /** Request has been fully approved. */
  APPROVED = 'APPROVED',
  /** Request has received some approvals but requires additional approvers. */
  AWAITING_MORE_APPROVERS = 'AWAITING_MORE_APPROVERS',
  /** Request has been denied. */
  DENIED = 'DENIED',
  /** Request has been approved for a subset of the requested fields. */
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  /** Request has been submitted and is awaiting review. */
  PENDING = 'PENDING'
}

/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type Account = {
  __typename: 'Account';
  /** Fetches a specific API key by its ID */
  apiKey: Maybe<GraphOsKey>;
  /** Returns a list of all active Operator, Subgraph, and SCIM API keys for the account. Org Admins can view all keys; Graph Admins can view only keys for graphs they administer. */
  apiKeys: GraphOsKeyConnection;
  /** Look up a single application in this organization by id. */
  application: ApplicationType;
  /**
   * All active applications for this organization, paginated, with optional
   * filtering.
   */
  applications: ApplicationPage;
  auditLogExports: Maybe<Array<AuditLogExport>>;
  /** These are the roles that the account is able to use */
  availableRoles: Array<UserPermission>;
  /**
   * Get an URL to which an avatar image can be uploaded. Client uploads by sending a PUT request
   * with the image data to MediaUploadInfo.url. Client SHOULD set the "Content-Type" header to the
   * browser-inferred MIME type, and SHOULD set the "x-apollo-content-filename" header to the
   * filename, if such information is available. Client MUST set the "x-apollo-csrf-token" header to
   * MediaUploadInfo.csrfToken.
   */
  avatarUpload: Maybe<AvatarUploadResult>;
  /**
   * Get an image URL for the account's avatar. Note that CORS is not enabled for these URLs. The size
   * argument is used for bandwidth reduction, and should be the size of the image as displayed in the
   * application. Apollo's media server will downscale larger images to at least the requested size,
   * but this will not happen for third-party media servers.
   */
  avatarUrl: Maybe<Scalars['String']['output']>;
  billingContactEmail: Maybe<Scalars['String']['output']>;
  billingInfo: Maybe<BillingInfo>;
  billingInsights: BillingInsights;
  /** Used by Studio to show the Change Plan button */
  canChangePlan: Scalars['Boolean']['output'];
  capabilities: Maybe<AccountCapabilities>;
  /** Fetch a CloudOnboarding associated with this account */
  cloudOnboarding: Maybe<CloudOnboarding>;
  companyUrl: Maybe<Scalars['String']['output']>;
  /** The time at which the account was created */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  currentBillingMonth: Maybe<BillingMonth>;
  currentPlan: BillingPlan;
  currentSubscription: Maybe<BillingSubscription>;
  eligibleForUsageBasedPlan: Scalars['Boolean']['output'];
  /** The organization's currently-enabled S3 integration configuration, or null if none is configured. */
  enabledS3Integration: Maybe<S3IntegrationConfig>;
  /**
   * Evaluate a GraphQL operation against this organization's policy bundle.
   *
   * Returns a per-field audit trace showing which fields would be DENIED,
   * MASKED, or ALLOWED given the specified principal context.
   *
   * The `principalId` and `groups` must represent the **originator** of the
   * operation (e.g., the application calling the Router), NOT the Studio user
   * making this evaluation request.
   */
  evaluateOperation: PolicyEvaluationResult;
  expiredTrialDismissedAt: Maybe<Scalars['Timestamp']['output']>;
  expiredTrialSubscription: Maybe<BillingSubscription>;
  graphIDAvailable: Scalars['Boolean']['output'];
  /**
   * Constellation ("GraphOS for Agents") metadata for this organization.
   *
   * A namespace wrapper so Constellation-specific fields don't crowd the
   * federated `Account`. Always resolvable; the fields inside carry their
   * own auth and nullability.
   */
  graphOsForAgents: GraphOsForAgentsAccount;
  /** Graphs belonging to this organization. */
  graphs: Array<Service>;
  /** Graphs belonging to this organization. */
  graphsConnection: Maybe<AccountGraphConnection>;
  hasBeenOnTrial: Scalars['Boolean']['output'];
  hasBillingInfo: Maybe<Scalars['Boolean']['output']>;
  /** Globally unique identifier, which isn't guaranteed stable (can be changed by administrators). */
  id: Scalars['ID']['output'];
  /**
   * Internal immutable identifier for the account. Only visible to Apollo admins (because it really
   * shouldn't be used in normal client apps).
   */
  internalID: Scalars['ID']['output'];
  invitations: Maybe<Array<AccountInvitation>>;
  invoices: Array<Invoice>;
  isLocked: Maybe<Scalars['Boolean']['output']>;
  isOnExpiredTrial: Scalars['Boolean']['output'];
  isOnTrial: Scalars['Boolean']['output'];
  isSelfServiceDeletable: Maybe<Scalars['Boolean']['output']>;
  limits: Maybe<AccountLimits>;
  lockDetails: Maybe<AccountLockDetails>;
  lockType: Maybe<AccountLockType>;
  /** The user memberships belonging to an Organization */
  memberships: Maybe<Array<AccountMembership>>;
  /** Name of the organization, which can change over time and isn't unique. */
  name: Scalars['String']['output'];
  /** Fetches one of the organization's `client_credentials` OAuth clients by its `client_id`. Returns null if the organization has no such client, if the client is not a `client_credentials` client, or if the caller may not see it. We will revisit this restriction when we expand beyond `client_credentials`. */
  oauthClient: Maybe<OAuthClient>;
  /**
   * Fetches an offline license for the account.
   * (If you need this then please contact your Apollo account manager to discuss your requirements.)
   */
  offlineLicense: Maybe<RouterEntitlement>;
  planUpgradeOptions: Maybe<Array<OnboardingPlanOption>>;
  /** List the private subgraphs associated with your Apollo account */
  privateSubgraphs: Array<PrivateSubgraph>;
  /** Members of this account for a specific product. */
  productMembers: Array<ProductMember>;
  /** Returns a different registry related stats pertaining to this account. */
  registryStatsWindow: Maybe<RegistryStatsWindow>;
  requests: Maybe<Scalars['Long']['output']>;
  requestsInCurrentBillingPeriod: Maybe<Scalars['Long']['output']>;
  roles: Maybe<AccountRoles>;
  routerEntitlement: Maybe<RouterEntitlement>;
  /** All of the organization's S3 integration configurations, both enabled and disabled. */
  s3Integrations: Array<S3IntegrationConfig>;
  /** How many seats would be included in your next bill, as best estimated today */
  seatCountForNextBill: Maybe<Scalars['Int']['output']>;
  seats: Maybe<Seats>;
  secondaryIDs: Array<Scalars['ID']['output']>;
  /** Fetches a specific service account by its ID */
  serviceAccount: Maybe<ServiceAccount>;
  /**
   * Graphs belonging to this organization.
   * @deprecated Use graphs field instead
   */
  services: Array<Service>;
  /** The session length in seconds for a user in this org */
  sessionDurationInSeconds: Maybe<Scalars['Int']['output']>;
  /**
   * If non-null, this organization tracks its members through an upstream IdP;
   * invitations are not possible on SSO-synchronized account.
   */
  sso: Maybe<OrganizationSSO>;
  ssoV2: Maybe<SsoConfig>;
  /** A list of reusable invitations for the organization. */
  staticInvitations: Maybe<Array<OrganizationInviteLink>>;
  /** @deprecated use Account.statsWindow instead */
  stats: AccountStatsWindow;
  statsWindow: Maybe<AccountStatsWindow>;
  /** Apollo admin only: the stripe customer id associated with the billing account */
  stripeCustomerId: Maybe<Scalars['String']['output']>;
  subscriptions: Array<BillingSubscription>;
  /** Gets a ticket for this org, by id */
  supportTicket: Maybe<SupportTicket>;
  /** List of support tickets submitted for this org */
  supportTickets: Maybe<Array<SupportTicket>>;
  survey: Maybe<Survey>;
  /**
   * Look up a single upstream service in this organization by id.
   *
   * Exposed as `upstreamService` in the SDL — see `upstream_services` for
   * the rationale.
   */
  upstreamService: UpstreamService;
  /**
   * All active upstream services for this organization, paginated.
   *
   * Exposed as `upstreamServices` in the SDL to avoid colliding with
   * Studio's existing (deprecated) `Account.services` field, which has a
   * different return type.
   */
  upstreamServices: UpstreamServicePage;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountapiKeyArgs = {
  keyId: Scalars['ID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountapiKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ApiKeyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountapplicationArgs = {
  id: Scalars['UUID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountapplicationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountauditLogExportsArgs = {
  onlyUserInitiated: Scalars['Boolean']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountavatarUrlArgs = {
  size: Scalars['Int']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountbillingInsightsArgs = {
  from: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  windowSize?: InputMaybe<BillingUsageStatsWindowSize>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountcloudOnboardingArgs = {
  graphRef: Scalars['String']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountevaluateOperationArgs = {
  input: EvaluateOperationInput;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountgraphIDAvailableArgs = {
  id: Scalars['ID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountgraphsArgs = {
  filterBy?: InputMaybe<GraphFilter>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountgraphsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<GraphFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountinvitationsArgs = {
  includeAccepted: Scalars['Boolean']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountoauthClientArgs = {
  clientId: Scalars['ID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountprivateSubgraphsArgs = {
  cloudProvider: CloudProvider;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountproductMembersArgs = {
  product: Scalars['String']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountregistryStatsWindowArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountrequestsArgs = {
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountserviceAccountArgs = {
  id: Scalars['ID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountservicesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountstatsArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountstatsWindowArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountsupportTicketArgs = {
  id: Scalars['ID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountsurveyArgs = {
  id: Scalars['String']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountupstreamServiceArgs = {
  id: Scalars['UUID']['input'];
};


/** An organization in Apollo Studio. Can have multiple members and graphs. */
export type AccountupstreamServicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Columns of AccountBillingUsageStats. */
export enum AccountBillingUsageStatsColumn {
  AGENT_ID = 'AGENT_ID',
  AGENT_VERSION = 'AGENT_VERSION',
  GRAPH_DEPLOYMENT_TYPE = 'GRAPH_DEPLOYMENT_TYPE',
  OPERATION_COUNT = 'OPERATION_COUNT',
  OPERATION_COUNT_PROVIDED_EXPLICITLY = 'OPERATION_COUNT_PROVIDED_EXPLICITLY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  ROUTER_FEATURES_ENABLED = 'ROUTER_FEATURES_ENABLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountBillingUsageStatsDimensions = {
  __typename: 'AccountBillingUsageStatsDimensions';
  agentId: Maybe<Scalars['String']['output']>;
  agentVersion: Maybe<Scalars['String']['output']>;
  graphDeploymentType: Maybe<Scalars['String']['output']>;
  operationCountProvidedExplicitly: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  routerFeaturesEnabled: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountBillingUsageStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountBillingUsageStatsFilter = {
  /** Selects rows whose agentId dimension equals the given value if not null. To query for the null value, use {in: {agentId: [null]}} instead. */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<AccountBillingUsageStatsFilter>>;
  /** Selects rows whose graphDeploymentType dimension equals the given value if not null. To query for the null value, use {in: {graphDeploymentType: [null]}} instead. */
  graphDeploymentType?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountBillingUsageStatsFilterIn>;
  not?: InputMaybe<AccountBillingUsageStatsFilter>;
  /** Selects rows whose operationCountProvidedExplicitly dimension equals the given value if not null. To query for the null value, use {in: {operationCountProvidedExplicitly: [null]}} instead. */
  operationCountProvidedExplicitly?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountBillingUsageStatsFilter>>;
  /** Selects rows whose routerFeaturesEnabled dimension equals the given value if not null. To query for the null value, use {in: {routerFeaturesEnabled: [null]}} instead. */
  routerFeaturesEnabled?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountBillingUsageStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountBillingUsageStatsFilterIn = {
  /** Selects rows whose agentId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose graphDeploymentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  graphDeploymentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationCountProvidedExplicitly dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationCountProvidedExplicitly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerFeaturesEnabled dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerFeaturesEnabled?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountBillingUsageStatsMetrics = {
  __typename: 'AccountBillingUsageStatsMetrics';
  operationCount: Scalars['Long']['output'];
};

export type AccountBillingUsageStatsOrderBySpec = {
  column: AccountBillingUsageStatsColumn;
  direction: Ordering;
};

export type AccountBillingUsageStatsRecord = {
  __typename: 'AccountBillingUsageStatsRecord';
  /** Dimensions of AccountBillingUsageStats that can be grouped by. */
  groupBy: AccountBillingUsageStatsDimensions;
  /** Metrics of AccountBillingUsageStats that can be aggregated over. */
  metrics: AccountBillingUsageStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type AccountCapabilities = {
  __typename: 'AccountCapabilities';
  asList: Array<AccountCapability>;
  clientVersions: Scalars['Boolean']['output'];
  clients: Scalars['Boolean']['output'];
  cloudGraphs: Scalars['Boolean']['output'];
  connectorsInRouter: Scalars['Boolean']['output'];
  contracts: Scalars['Boolean']['output'];
  customSessionLengths: Scalars['Boolean']['output'];
  datadog: Scalars['Boolean']['output'];
  federation: Scalars['Boolean']['output'];
  launches: Scalars['Boolean']['output'];
  linting: Scalars['Boolean']['output'];
  metrics: Scalars['Boolean']['output'];
  notifications: Scalars['Boolean']['output'];
  operationRegistry: Scalars['Boolean']['output'];
  /** Whether a plan can use the Operator */
  operator: Scalars['Boolean']['output'];
  persistedQueries: Scalars['Boolean']['output'];
  proposals: Scalars['Boolean']['output'];
  schemaValidation: Scalars['Boolean']['output'];
  sso: Scalars['Boolean']['output'];
  traces: Scalars['Boolean']['output'];
  userRoles: Scalars['Boolean']['output'];
  webhooks: Scalars['Boolean']['output'];
};

export type AccountCapability = {
  __typename: 'AccountCapability';
  description: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

/** Columns of AccountCardinalityStats. */
export enum AccountCardinalityStatsColumn {
  CLIENT_NAME_CARDINALITY = 'CLIENT_NAME_CARDINALITY',
  CLIENT_VERSION_CARDINALITY = 'CLIENT_VERSION_CARDINALITY',
  OPERATION_SHAPE_CARDINALITY = 'OPERATION_SHAPE_CARDINALITY',
  SCHEMA_COORDINATE_CARDINALITY = 'SCHEMA_COORDINATE_CARDINALITY',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountCardinalityStatsDimensions = {
  __typename: 'AccountCardinalityStatsDimensions';
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountCardinalityStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountCardinalityStatsFilter = {
  and?: InputMaybe<Array<AccountCardinalityStatsFilter>>;
  in?: InputMaybe<AccountCardinalityStatsFilterIn>;
  not?: InputMaybe<AccountCardinalityStatsFilter>;
  or?: InputMaybe<Array<AccountCardinalityStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountCardinalityStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountCardinalityStatsFilterIn = {
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountCardinalityStatsMetrics = {
  __typename: 'AccountCardinalityStatsMetrics';
  clientNameCardinality: Scalars['Float']['output'];
  clientVersionCardinality: Scalars['Float']['output'];
  operationShapeCardinality: Scalars['Float']['output'];
  schemaCoordinateCardinality: Scalars['Float']['output'];
};

export type AccountCardinalityStatsOrderBySpec = {
  column: AccountCardinalityStatsColumn;
  direction: Ordering;
};

export type AccountCardinalityStatsRecord = {
  __typename: 'AccountCardinalityStatsRecord';
  /** Dimensions of AccountCardinalityStats that can be grouped by. */
  groupBy: AccountCardinalityStatsDimensions;
  /** Metrics of AccountCardinalityStats that can be aggregated over. */
  metrics: AccountCardinalityStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type AccountChecksStatsMetrics = {
  __typename: 'AccountChecksStatsMetrics';
  totalFailedChecks: Scalars['Long']['output'];
  totalSuccessfulChecks: Scalars['Long']['output'];
};

export type AccountChecksStatsRecord = {
  __typename: 'AccountChecksStatsRecord';
  id: Scalars['ID']['output'];
  metrics: AccountChecksStatsMetrics;
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountCoordinateUsage. */
export enum AccountCoordinateUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  KIND = 'KIND',
  NAMED_ATTRIBUTE = 'NAMED_ATTRIBUTE',
  NAMED_TYPE = 'NAMED_TYPE',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUEST_COUNT_NULL = 'REQUEST_COUNT_NULL',
  REQUEST_COUNT_UNDEFINED = 'REQUEST_COUNT_UNDEFINED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountCoordinateUsageDimensions = {
  __typename: 'AccountCoordinateUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  namedAttribute: Maybe<Scalars['String']['output']>;
  namedType: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['String']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountCoordinateUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountCoordinateUsageFilter = {
  and?: InputMaybe<Array<AccountCoordinateUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountCoordinateUsageFilterIn>;
  /** Selects rows whose kind dimension equals the given value if not null. To query for the null value, use {in: {kind: [null]}} instead. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedAttribute dimension equals the given value if not null. To query for the null value, use {in: {namedAttribute: [null]}} instead. */
  namedAttribute?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedType dimension equals the given value if not null. To query for the null value, use {in: {namedType: [null]}} instead. */
  namedType?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<AccountCoordinateUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountCoordinateUsageFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountCoordinateUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountCoordinateUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose kind dimension is in the given list. A null value in the list means a row with null for that dimension. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedAttribute dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedAttribute?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountCoordinateUsageMetrics = {
  __typename: 'AccountCoordinateUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestCountNull: Scalars['Long']['output'];
  requestCountUndefined: Scalars['Long']['output'];
};

export type AccountCoordinateUsageOrderBySpec = {
  column: AccountCoordinateUsageColumn;
  direction: Ordering;
};

export type AccountCoordinateUsageRecord = {
  __typename: 'AccountCoordinateUsageRecord';
  /** Dimensions of AccountCoordinateUsage that can be grouped by. */
  groupBy: AccountCoordinateUsageDimensions;
  /** Metrics of AccountCoordinateUsage that can be aggregated over. */
  metrics: AccountCoordinateUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountEdgeServerInfos. */
export enum AccountEdgeServerInfosColumn {
  BOOT_ID = 'BOOT_ID',
  EXECUTABLE_SCHEMA_ID = 'EXECUTABLE_SCHEMA_ID',
  LIBRARY_VERSION = 'LIBRARY_VERSION',
  PLATFORM = 'PLATFORM',
  RUNTIME_VERSION = 'RUNTIME_VERSION',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVER_ID = 'SERVER_ID',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  USER_VERSION = 'USER_VERSION'
}

export type AccountEdgeServerInfosDimensions = {
  __typename: 'AccountEdgeServerInfosDimensions';
  bootId: Maybe<Scalars['ID']['output']>;
  executableSchemaId: Maybe<Scalars['ID']['output']>;
  libraryVersion: Maybe<Scalars['String']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  runtimeVersion: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serverId: Maybe<Scalars['ID']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  userVersion: Maybe<Scalars['String']['output']>;
};

/** Filter for data in AccountEdgeServerInfos. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountEdgeServerInfosFilter = {
  and?: InputMaybe<Array<AccountEdgeServerInfosFilter>>;
  /** Selects rows whose bootId dimension equals the given value if not null. To query for the null value, use {in: {bootId: [null]}} instead. */
  bootId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose executableSchemaId dimension equals the given value if not null. To query for the null value, use {in: {executableSchemaId: [null]}} instead. */
  executableSchemaId?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<AccountEdgeServerInfosFilterIn>;
  /** Selects rows whose libraryVersion dimension equals the given value if not null. To query for the null value, use {in: {libraryVersion: [null]}} instead. */
  libraryVersion?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<AccountEdgeServerInfosFilter>;
  or?: InputMaybe<Array<AccountEdgeServerInfosFilter>>;
  /** Selects rows whose platform dimension equals the given value if not null. To query for the null value, use {in: {platform: [null]}} instead. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose runtimeVersion dimension equals the given value if not null. To query for the null value, use {in: {runtimeVersion: [null]}} instead. */
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serverId dimension equals the given value if not null. To query for the null value, use {in: {serverId: [null]}} instead. */
  serverId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose userVersion dimension equals the given value if not null. To query for the null value, use {in: {userVersion: [null]}} instead. */
  userVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in AccountEdgeServerInfos. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountEdgeServerInfosFilterIn = {
  /** Selects rows whose bootId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  bootId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose executableSchemaId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  executableSchemaId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose libraryVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  libraryVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose platform dimension is in the given list. A null value in the list means a row with null for that dimension. */
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose runtimeVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  runtimeVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serverId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serverId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose userVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  userVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountEdgeServerInfosOrderBySpec = {
  column: AccountEdgeServerInfosColumn;
  direction: Ordering;
};

export type AccountEdgeServerInfosRecord = {
  __typename: 'AccountEdgeServerInfosRecord';
  /** Dimensions of AccountEdgeServerInfos that can be grouped by. */
  groupBy: AccountEdgeServerInfosDimensions;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountErrorStats. */
export enum AccountErrorStatsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERRORS_COUNT = 'ERRORS_COUNT',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountErrorStatsDimensions = {
  __typename: 'AccountErrorStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountErrorStatsFilter = {
  and?: InputMaybe<Array<AccountErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountErrorStatsFilterIn>;
  not?: InputMaybe<AccountErrorStatsFilter>;
  or?: InputMaybe<Array<AccountErrorStatsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountErrorStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountErrorStatsMetrics = {
  __typename: 'AccountErrorStatsMetrics';
  errorsCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type AccountErrorStatsOrderBySpec = {
  column: AccountErrorStatsColumn;
  direction: Ordering;
};

export type AccountErrorStatsRecord = {
  __typename: 'AccountErrorStatsRecord';
  /** Dimensions of AccountErrorStats that can be grouped by. */
  groupBy: AccountErrorStatsDimensions;
  /** Metrics of AccountErrorStats that can be aggregated over. */
  metrics: AccountErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountFederatedErrorStats. */
export enum AccountFederatedErrorStatsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_COUNT = 'ERROR_COUNT',
  ERROR_PATH = 'ERROR_PATH',
  ERROR_SERVICE = 'ERROR_SERVICE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  SEVERITY = 'SEVERITY',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountFederatedErrorStatsDimensions = {
  __typename: 'AccountFederatedErrorStatsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorPath: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  severity: Maybe<Scalars['String']['output']>;
};

/** Filter for data in AccountFederatedErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountFederatedErrorStatsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<AccountFederatedErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorPath dimension equals the given value if not null. To query for the null value, use {in: {errorPath: [null]}} instead. */
  errorPath?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountFederatedErrorStatsFilterIn>;
  not?: InputMaybe<AccountFederatedErrorStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountFederatedErrorStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose severity dimension equals the given value if not null. To query for the null value, use {in: {severity: [null]}} instead. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in AccountFederatedErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountFederatedErrorStatsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorPath dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose severity dimension is in the given list. A null value in the list means a row with null for that dimension. */
  severity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountFederatedErrorStatsMetrics = {
  __typename: 'AccountFederatedErrorStatsMetrics';
  errorCount: Scalars['Long']['output'];
};

export type AccountFederatedErrorStatsOrderBySpec = {
  column: AccountFederatedErrorStatsColumn;
  direction: Ordering;
};

export type AccountFederatedErrorStatsRecord = {
  __typename: 'AccountFederatedErrorStatsRecord';
  /** Dimensions of AccountFederatedErrorStats that can be grouped by. */
  groupBy: AccountFederatedErrorStatsDimensions;
  /** Metrics of AccountFederatedErrorStats that can be aggregated over. */
  metrics: AccountFederatedErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountFieldExecutions. */
export enum AccountFieldExecutionsColumn {
  ERRORS_COUNT = 'ERRORS_COUNT',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  FIELD_HISTOGRAM = 'FIELD_HISTOGRAM',
  FIELD_NAME = 'FIELD_NAME',
  OBSERVED_EXECUTION_COUNT = 'OBSERVED_EXECUTION_COUNT',
  PARENT_TYPE = 'PARENT_TYPE',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountFieldExecutionsDimensions = {
  __typename: 'AccountFieldExecutionsDimensions';
  field: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountFieldExecutions. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountFieldExecutionsFilter = {
  and?: InputMaybe<Array<AccountFieldExecutionsFilter>>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountFieldExecutionsFilterIn>;
  not?: InputMaybe<AccountFieldExecutionsFilter>;
  or?: InputMaybe<Array<AccountFieldExecutionsFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountFieldExecutions. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountFieldExecutionsFilterIn = {
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountFieldExecutionsMetrics = {
  __typename: 'AccountFieldExecutionsMetrics';
  errorsCount: Scalars['Long']['output'];
  estimatedExecutionCount: Scalars['Long']['output'];
  fieldHistogram: DurationHistogram;
  observedExecutionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type AccountFieldExecutionsOrderBySpec = {
  column: AccountFieldExecutionsColumn;
  direction: Ordering;
};

export type AccountFieldExecutionsRecord = {
  __typename: 'AccountFieldExecutionsRecord';
  /** Dimensions of AccountFieldExecutions that can be grouped by. */
  groupBy: AccountFieldExecutionsDimensions;
  /** Metrics of AccountFieldExecutions that can be aggregated over. */
  metrics: AccountFieldExecutionsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountFieldUsage. */
export enum AccountFieldUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  FIELD_NAME = 'FIELD_NAME',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PARENT_TYPE = 'PARENT_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountFieldUsageDimensions = {
  __typename: 'AccountFieldUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountFieldUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountFieldUsageFilter = {
  and?: InputMaybe<Array<AccountFieldUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountFieldUsageFilterIn>;
  not?: InputMaybe<AccountFieldUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountFieldUsageFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountFieldUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountFieldUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountFieldUsageMetrics = {
  __typename: 'AccountFieldUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
};

export type AccountFieldUsageOrderBySpec = {
  column: AccountFieldUsageColumn;
  direction: Ordering;
};

export type AccountFieldUsageRecord = {
  __typename: 'AccountFieldUsageRecord';
  /** Dimensions of AccountFieldUsage that can be grouped by. */
  groupBy: AccountFieldUsageDimensions;
  /** Metrics of AccountFieldUsage that can be aggregated over. */
  metrics: AccountFieldUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A list of graphs that belong to an account. */
export type AccountGraphConnection = {
  __typename: 'AccountGraphConnection';
  /** A list of edges from the account to its graphs. */
  edges: Maybe<Array<AccountGraphEdge>>;
  /** A list of graphs attached to the account. */
  nodes: Maybe<Array<Service>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge between an account and a graph. */
export type AccountGraphEdge = {
  __typename: 'AccountGraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A graph attached to the account. */
  node: Maybe<Service>;
};

/** Columns of AccountGraphosCloudMetrics. */
export enum AccountGraphosCloudMetricsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLOUD_PROVIDER = 'CLOUD_PROVIDER',
  RESPONSE_SIZE = 'RESPONSE_SIZE',
  RESPONSE_SIZE_THROTTLED = 'RESPONSE_SIZE_THROTTLED',
  ROUTER_ID = 'ROUTER_ID',
  ROUTER_OPERATIONS = 'ROUTER_OPERATIONS',
  ROUTER_OPERATIONS_THROTTLED = 'ROUTER_OPERATIONS_THROTTLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  SUBGRAPH_FETCHES = 'SUBGRAPH_FETCHES',
  SUBGRAPH_FETCHES_THROTTLED = 'SUBGRAPH_FETCHES_THROTTLED',
  TIER = 'TIER',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountGraphosCloudMetricsDimensions = {
  __typename: 'AccountGraphosCloudMetricsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  cloudProvider: Maybe<Scalars['String']['output']>;
  routerId: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  tier: Maybe<Scalars['String']['output']>;
};

/** Filter for data in AccountGraphosCloudMetrics. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountGraphosCloudMetricsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<AccountGraphosCloudMetricsFilter>>;
  /** Selects rows whose cloudProvider dimension equals the given value if not null. To query for the null value, use {in: {cloudProvider: [null]}} instead. */
  cloudProvider?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountGraphosCloudMetricsFilterIn>;
  not?: InputMaybe<AccountGraphosCloudMetricsFilter>;
  or?: InputMaybe<Array<AccountGraphosCloudMetricsFilter>>;
  /** Selects rows whose routerId dimension equals the given value if not null. To query for the null value, use {in: {routerId: [null]}} instead. */
  routerId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose tier dimension equals the given value if not null. To query for the null value, use {in: {tier: [null]}} instead. */
  tier?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in AccountGraphosCloudMetrics. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountGraphosCloudMetricsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose cloudProvider dimension is in the given list. A null value in the list means a row with null for that dimension. */
  cloudProvider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose tier dimension is in the given list. A null value in the list means a row with null for that dimension. */
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountGraphosCloudMetricsMetrics = {
  __typename: 'AccountGraphosCloudMetricsMetrics';
  responseSize: Scalars['Long']['output'];
  responseSizeThrottled: Scalars['Long']['output'];
  routerOperations: Scalars['Long']['output'];
  routerOperationsThrottled: Scalars['Long']['output'];
  subgraphFetches: Scalars['Long']['output'];
  subgraphFetchesThrottled: Scalars['Long']['output'];
};

export type AccountGraphosCloudMetricsOrderBySpec = {
  column: AccountGraphosCloudMetricsColumn;
  direction: Ordering;
};

export type AccountGraphosCloudMetricsRecord = {
  __typename: 'AccountGraphosCloudMetricsRecord';
  /** Dimensions of AccountGraphosCloudMetrics that can be grouped by. */
  groupBy: AccountGraphosCloudMetricsDimensions;
  /** Metrics of AccountGraphosCloudMetrics that can be aggregated over. */
  metrics: AccountGraphosCloudMetricsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** An invitation for a user to join an organization. */
export type AccountInvitation = {
  __typename: 'AccountInvitation';
  /** An accepted invitation cannot be used anymore */
  acceptedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Who accepted the invitation */
  acceptedBy: Maybe<User>;
  /** Time the invitation was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Who created the invitation */
  createdBy: Maybe<User>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Last time we sent an email for the invitation */
  lastSentAt: Maybe<Scalars['Timestamp']['output']>;
  /** Access role for the invitee */
  role: UserPermission;
};

export type AccountLimit = {
  __typename: 'AccountLimit';
  description: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Maybe<Scalars['Long']['output']>;
};

export type AccountLimits = {
  __typename: 'AccountLimits';
  asList: Array<AccountLimit>;
  maxAuditInDays: Scalars['Int']['output'];
  maxGraphOSSeats: Maybe<Scalars['Long']['output']>;
  maxRangeInDays: Scalars['Int']['output'];
  maxRangeInDaysForChecks: Scalars['Int']['output'];
  maxRequestsPerMonth: Maybe<Scalars['Long']['output']>;
};

export type AccountLockDetails = {
  __typename: 'AccountLockDetails';
  actor: Maybe<Scalars['String']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['Timestamp']['output']>;
  type: Maybe<AccountLockType>;
};

export enum AccountLockType {
  AUTOMATED_TRIAL_END = 'AUTOMATED_TRIAL_END',
  MANUAL = 'MANUAL',
  MANUAL_BY_APOLLO_ADMIN = 'MANUAL_BY_APOLLO_ADMIN',
  MANUAL_BY_ORG_ADMIN = 'MANUAL_BY_ORG_ADMIN',
  PLAN_EOL_MIGRATION_REQUIRED = 'PLAN_EOL_MIGRATION_REQUIRED'
}

/** The membership association between a user and an organization. */
export type AccountMembership = {
  __typename: 'AccountMembership';
  account: Account;
  /** The timestamp when the user was added to the organization. */
  createdAt: Scalars['Timestamp']['output'];
  /** If this membership is a free seat (based on role) */
  free: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use role instead. */
  permission: UserPermission;
  /** The user's role within the organization'. */
  role: UserPermission;
  /** The user that belongs to the organization. */
  user: User;
};

export type AccountMutation = {
  __typename: 'AccountMutation';
  addOidcConfigurationToBaseConnection: Maybe<OidcConnection>;
  addSamlMetadataToBaseConnection: Maybe<SamlConnection>;
  /** @deprecated Use saml { addVerificationCert } instead */
  addSamlVerificationCert: Maybe<Scalars['Void']['output']>;
  /** Admin rotation of an OAuth client's secret: creates a new secret and expires every currently active secret for the client after `gracePeriod` days (immediately by default) */
  adminRotateClientSecret: OAuthClientCredentials;
  auditExport: Maybe<AuditLogExportMutation>;
  /**
   * Cancel account subscriptions, subscriptions will remain active until the end of the paid period.
   * Currently only works for Recurly subscriptions on team plans.
   */
  cancelSubscriptions: Maybe<Account>;
  /** Create a new AI Agent and mint a v2 API key tied to it. The returned GraphOsKey includes the plaintext secret, shown exactly once. */
  createAgenticAppApiKey: GraphOsKey;
  /** Apollo admins only: create a Stripe customer and link it to an existing billing account */
  createAndLinkStripeCustomer: Maybe<Account>;
  /**
   * Creates a new application for this account.
   * AGENTIC_APP starts in PENDING status; INTERACTIVE is auto-approved.
   */
  createApplication: ApplicationType;
  /**
   * Issues a new API key for one of this account's applications, scoped to
   * a subset of the org's registered upstream services. Returns the
   * plaintext key exactly once, in this response: only a SHA-256 digest
   * of it is stored, so a lost key can be replaced but never recovered.
   * Only keys belonging to approved applications are published in the runtime
   * artifact (`publishedApiKeys` / `runtimeSources`).
   */
  createApplicationApiKey: CreateApplicationApiKeyPayload;
  createBaseSsoConnection: Maybe<BaseConnection>;
  /** Create a CloudOnboarding for this account */
  createCloudOnboarding: CreateOnboardingResult;
  createGraph: GraphCreationResult;
  /** Create an ApiKey */
  createKey: GraphOsKey;
  createOidcConfigurationUrl: Maybe<Scalars['String']['output']>;
  /** Create the S3 integration configuration for this organization. Generates (or accepts) a per-customer external ID. */
  createS3Integration: CreateS3IntegrationResult;
  createStaticInvitation: Maybe<OrganizationInviteLink>;
  /** Creates a new upstream service for this account. */
  createUpstreamService: UpstreamService;
  currentSubscription: Maybe<BillingSubscriptionMutation>;
  /**
   * Soft-deletes an application by id within this account.
   * Returns true if the application was deleted.
   */
  deleteApplication: Scalars['Boolean']['output'];
  /** Delete the account's avatar. Requires Account.canUpdateAvatar to be true. */
  deleteAvatar: Maybe<AvatarDeleteError>;
  /** Delete an ApiKey */
  deleteKey: Scalars['ID']['output'];
  /** Deletes a `client_credentials` OAuth client: a soft delete that also removes its secrets, service account, and principal */
  deleteOAuthClient: Maybe<Scalars['Void']['output']>;
  /**
   * Disconnects an upstream service by id within this account, returning
   * true if there was a connected service to disconnect. The service leaves
   * this account's view immediately; its subgraph is removed from the graph
   * in the background, so a `true` here means the disconnect was accepted,
   * not that composition has finished.
   */
  deleteUpstreamService: Scalars['Boolean']['output'];
  ensureRecurlyAccountExists: Maybe<RecurlyAccountDetails>;
  /** If the org is on an enterprise trial, extend the trial by the given number of days, or the default number of days for that plan if numDays is not set. */
  extendTrial: Maybe<Account>;
  finalizeSsoReconfiguration: Maybe<Scalars['Void']['output']>;
  finalizeSsoV2Migration: Maybe<Scalars['Void']['output']>;
  /** Hard delete an account and all associated services */
  hardDelete: Maybe<Scalars['Void']['output']>;
  /** Get reference to the account ID */
  internalID: Maybe<Scalars['String']['output']>;
  /** Send an invitation to join the organization by E-mail */
  invite: Maybe<AccountInvitation>;
  /** Send an invitation to join the organization for a specific product by E-mail */
  inviteToProduct: AccountProductInvitation;
  /** Lock an account, which limits the functionality available with regard to its graphs. */
  lock: Maybe<Account>;
  /** See Account type. Field is needed by extending subgraph. */
  name: Maybe<Scalars['String']['output']>;
  /** Mutations for interacting with an Apollo account's private subgraphs on GraphOS */
  privateSubgraph: PrivateSubgraphMutation;
  reAddSsoUser: Maybe<Scalars['Void']['output']>;
  /**
   * Reactivate a canceled current subscription.
   * Currently only works for Recurly subscriptions on team plans.
   */
  reactivateCurrentSubscription: Maybe<Account>;
  /** Register an OAuth client that authenticates as itself with the `client_credentials` grant. The returned secret is shown only once. */
  registerOAuthClientCredentials: OAuthClientCredentials;
  /** Delete an invitation */
  removeInvitation: Maybe<Scalars['Void']['output']>;
  /** Remove a member of the account */
  removeMember: Maybe<Account>;
  /** Remove a user's membership from this account for a specific product. */
  removeProductMember: Maybe<Account>;
  /** Updates the name of an ApiKey */
  renameKey: GraphOsKey;
  replaceSsoConnectionDomains: Maybe<SsoConnection>;
  /** Trigger a request for an audit export */
  requestAuditExport: Maybe<Account>;
  /** Send a new E-mail for an existing invitation */
  resendInvitation: Maybe<AccountInvitation>;
  /**
   * Revokes a previously issued application API key, and asks GraphOS to
   * withdraw the credential it minted.
   *
   * Idempotent: revoking an already-revoked key succeeds and returns it
   * unchanged, preserving the original `revokedAt` / `revokedBy`. Revocation
   * is a safety operation, so a retry must never report failure about a key
   * that is in fact revoked — that reading invites a caller to treat a dead
   * credential as live.
   */
  revokeApplicationApiKey: ApplicationApiKey;
  /** Revoke an API Key */
  revokeKey: Scalars['ID']['output'];
  revokeStaticInvitation: Maybe<OrganizationInviteLink>;
  /** Revoke all of a user's refresh tokens for an OAuth client. The outstanding access token will naturally expire after a TTL. This operation does not prevent the user from re-authenticating. */
  revokeUserOAuthTokens: Maybe<Scalars['Void']['output']>;
  /** Revokes a user's sessions within the organization */
  revokeUserSessions: Maybe<Scalars['Void']['output']>;
  /** Rotate an ApiKey by creating a new key and expiring the old one. Returns the new key */
  rotateKey: GraphOsKey;
  /** Mutations scoped to an existing S3 integration configuration for this organization */
  s3Integration: S3IntegrationMutation;
  saml: Maybe<SamlConnectionMutation>;
  /** See Account type. Field is needed by extending subgraph. */
  seats: Maybe<Seats>;
  /** Create or update a custom session length for an org */
  setCustomSessionLength: Scalars['Int']['output'];
  /** Updates the expiration of an ApiKey */
  setKeyExpiration: GraphOsKey;
  /** Apollo admins only: set the billing plan to an arbitrary plan effective immediately terminating any current paid plan. */
  setPlan: Maybe<Scalars['Void']['output']>;
  /**
   * Sets (upserts) the field tags for one schema coordinate on a service.
   * Full-replace: `tags` becomes the entire tag set for `coordinate`; an
   * empty list clears it. Recompiles the org's policy bundle so the
   * change is reflected immediately — does not touch SDL or trigger a
   * republish.
   */
  setServiceFieldTags: ServiceFieldTag;
  /**
   * Sets (upserts) the field tags for many schema coordinates on one
   * service in a single call — the batch form of `setServiceFieldTags`,
   * for applying a screenful of staged tag edits at once. Each entry is a
   * full replace of that coordinate's tag set; an empty `tags` list clears
   * it.
   *
   * **Partial success is the normal outcome, not an error.** A coordinate
   * that no longer exists in the service's schema — say the upstream field
   * was removed after the edit was staged — is reported in `failed` while
   * every other coordinate still applies. The whole call only fails for
   * problems that are not attributable to a single coordinate: an
   * unauthorized caller, an unknown service, or a write that could not be
   * committed.
   *
   * The coordinates that do apply are written in one transaction, so the
   * batch either lands whole or not at all, and the org's policy bundle is
   * recompiled once for the batch rather than once per coordinate. As with
   * the single-coordinate form, this does not touch SDL or trigger a
   * republish.
   */
  setServiceFieldTagsBatch: SetServiceFieldTagsBatchPayload;
  /** This is called by the form shown to users after they cancel their team subscription. */
  submitTeamCancellationFeedback: Maybe<Scalars['Void']['output']>;
  /** Apollo admins only: Terminate the ongoing subscription in the account as soon as possible, without refunds. */
  terminateSubscription: Maybe<Account>;
  /**
   * Apollo admins only: terminate any ongoing subscriptions in the account, without refunds
   * Currently only works for Recurly subscriptions.
   */
  terminateSubscriptions: Maybe<Account>;
  trackTermsAccepted: Maybe<Scalars['Void']['output']>;
  /** Unlock a locked account. */
  unlock: Maybe<Account>;
  /** Updates an existing application by id within this account. */
  updateApplication: ApplicationType;
  /** Update the billing address for a Recurly token */
  updateBillingAddress: Maybe<Account>;
  /** Update the billing information from a Recurly token */
  updateBillingInfo: Maybe<Scalars['Void']['output']>;
  updateCompanyUrl: Maybe<Account>;
  /** Set the E-mail address of the account, used notably for billing */
  updateEmail: Maybe<Scalars['Void']['output']>;
  /** Update the account ID */
  updateID: Maybe<Account>;
  /** Update the company name */
  updateName: Maybe<Scalars['Void']['output']>;
  /** Updates the OIDC metadata for an existing SSO connection. Connection must be disabled prior to the update. */
  updateOidcConnectionMetadata: Maybe<OidcConnection>;
  /** Updates the role assigned to new SSO users. */
  updateSSODefaultRole: Maybe<OrganizationSSO>;
  /** Updates the SAML metadata for an existing SSO connection. Connection must be disabled prior to the update. */
  updateSamlConnectionMetadata: Maybe<SamlConnection>;
  /** Updates an existing upstream service by id within this account. */
  updateUpstreamService: UpstreamService;
  /**
   * Update a user's role within an organization
   * @deprecated Use updateUserRole instead.
   */
  updateUserPermission: Maybe<User>;
  /** Update a user's role within an organization */
  updateUserRole: Maybe<User>;
};


export type AccountMutationaddOidcConfigurationToBaseConnectionArgs = {
  config: OidcConfigurationInput;
  connectionId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMutationaddSamlMetadataToBaseConnectionArgs = {
  connectionId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  metadata: SamlConfigurationInput;
};


export type AccountMutationaddSamlVerificationCertArgs = {
  pem: Scalars['String']['input'];
};


export type AccountMutationadminRotateClientSecretArgs = {
  clientId: Scalars['String']['input'];
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountMutationauditExportArgs = {
  id: Scalars['String']['input'];
};


export type AccountMutationcreateAgenticAppApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type AccountMutationcreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type AccountMutationcreateApplicationApiKeyArgs = {
  input: CreateApplicationApiKeyInput;
};


export type AccountMutationcreateBaseSsoConnectionArgs = {
  domains: Array<Scalars['String']['input']>;
  idpId?: InputMaybe<Scalars['String']['input']>;
  useLegacyIdpId?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMutationcreateCloudOnboardingArgs = {
  input: CloudOnboardingInput;
};


export type AccountMutationcreateGraphArgs = {
  graphType: GraphType;
  hiddenFromUninvitedNonAdmin: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  variantCreationConfig?: InputMaybe<VariantCreationConfig>;
};


export type AccountMutationcreateKeyArgs = {
  name: Scalars['String']['input'];
  resources?: InputMaybe<ApiKeyResourceInput>;
  type: GraphOsKeyType;
};


export type AccountMutationcreateOidcConfigurationUrlArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationcreateS3IntegrationArgs = {
  bucket: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  kmsKeyArn?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  roleArn: Scalars['String']['input'];
};


export type AccountMutationcreateStaticInvitationArgs = {
  role: UserPermission;
};


export type AccountMutationcreateUpstreamServiceArgs = {
  input: CreateUpstreamServiceInput;
};


export type AccountMutationdeleteApplicationArgs = {
  id: Scalars['UUID']['input'];
};


export type AccountMutationdeleteKeyArgs = {
  keyId: Scalars['ID']['input'];
};


export type AccountMutationdeleteOAuthClientArgs = {
  clientId: Scalars['String']['input'];
};


export type AccountMutationdeleteUpstreamServiceArgs = {
  id: Scalars['UUID']['input'];
};


export type AccountMutationextendTrialArgs = {
  numDays?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountMutationfinalizeSsoReconfigurationArgs = {
  deleteExistingWebApiKeys?: InputMaybe<Scalars['Boolean']['input']>;
  newConnectionId: Scalars['ID']['input'];
  verifySsoSessionExists?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMutationfinalizeSsoV2MigrationArgs = {
  deleteExistingWebApiKeys?: InputMaybe<Scalars['Boolean']['input']>;
  deleteNonSsoMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  verifySsoSessionExists?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMutationinviteArgs = {
  email: Scalars['String']['input'];
  role?: InputMaybe<UserPermission>;
};


export type AccountMutationinviteToProductArgs = {
  email: Scalars['String']['input'];
  product: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type AccountMutationlockArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountLockType>;
};


export type AccountMutationreAddSsoUserArgs = {
  role: UserPermission;
  userId: Scalars['ID']['input'];
};


export type AccountMutationregisterOAuthClientCredentialsArgs = {
  clientName: Scalars['String']['input'];
  resources: OAuthClientResourceInput;
  scopes: Array<Scalars['String']['input']>;
  secretLifetimeDays?: InputMaybe<Scalars['Int']['input']>;
};


export type AccountMutationremoveInvitationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountMutationremoveMemberArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationremoveProductMemberArgs = {
  product: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type AccountMutationrenameKeyArgs = {
  keyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type AccountMutationreplaceSsoConnectionDomainsArgs = {
  domains: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type AccountMutationrequestAuditExportArgs = {
  actors?: InputMaybe<Array<ActorInput>>;
  from: Scalars['Timestamp']['input'];
  graphIds?: InputMaybe<Array<Scalars['String']['input']>>;
  to: Scalars['Timestamp']['input'];
};


export type AccountMutationresendInvitationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountMutationrevokeApplicationApiKeyArgs = {
  keyId: Scalars['UUID']['input'];
};


export type AccountMutationrevokeKeyArgs = {
  keyId: Scalars['ID']['input'];
};


export type AccountMutationrevokeStaticInvitationArgs = {
  token: Scalars['String']['input'];
};


export type AccountMutationrevokeUserOAuthTokensArgs = {
  clientId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type AccountMutationrevokeUserSessionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountMutationrotateKeyArgs = {
  expireOldKeyAt?: InputMaybe<Scalars['Timestamp']['input']>;
  keyId: Scalars['ID']['input'];
  newKeyName?: InputMaybe<Scalars['String']['input']>;
};


export type AccountMutations3IntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationsetCustomSessionLengthArgs = {
  sessionDurationInSeconds: Scalars['Int']['input'];
};


export type AccountMutationsetKeyExpirationArgs = {
  expiration: Scalars['Timestamp']['input'];
  keyId: Scalars['ID']['input'];
};


export type AccountMutationsetPlanArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationsetServiceFieldTagsArgs = {
  coordinate: Scalars['String']['input'];
  serviceId: Scalars['UUID']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type AccountMutationsetServiceFieldTagsBatchArgs = {
  changes: Array<ServiceFieldTagInput>;
  serviceId: Scalars['UUID']['input'];
};


export type AccountMutationsubmitTeamCancellationFeedbackArgs = {
  feedback: Scalars['String']['input'];
};


export type AccountMutationterminateSubscriptionArgs = {
  providerId: Scalars['ID']['input'];
};


export type AccountMutationtrackTermsAcceptedArgs = {
  at: Scalars['Timestamp']['input'];
};


export type AccountMutationupdateApplicationArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateApplicationInput;
};


export type AccountMutationupdateBillingAddressArgs = {
  billingAddress: BillingAddressInput;
};


export type AccountMutationupdateBillingInfoArgs = {
  token: Scalars['String']['input'];
};


export type AccountMutationupdateCompanyUrlArgs = {
  companyUrl?: InputMaybe<Scalars['String']['input']>;
};


export type AccountMutationupdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type AccountMutationupdateIDArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationupdateNameArgs = {
  name: Scalars['String']['input'];
};


export type AccountMutationupdateOidcConnectionMetadataArgs = {
  connectionId: Scalars['ID']['input'];
  metadata: OidcConfigurationUpdateInput;
};


export type AccountMutationupdateSSODefaultRoleArgs = {
  role: UserPermission;
};


export type AccountMutationupdateSamlConnectionMetadataArgs = {
  connectionId: Scalars['ID']['input'];
  metadata: SamlConfigurationInput;
};


export type AccountMutationupdateUpstreamServiceArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateUpstreamServiceInput;
};


export type AccountMutationupdateUserPermissionArgs = {
  permission: UserPermission;
  userID: Scalars['ID']['input'];
};


export type AccountMutationupdateUserRoleArgs = {
  role: UserPermission;
  userID: Scalars['ID']['input'];
};

/** Columns of AccountOperationCheckStats. */
export enum AccountOperationCheckStatsColumn {
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type AccountOperationCheckStatsDimensions = {
  __typename: 'AccountOperationCheckStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountOperationCheckStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountOperationCheckStatsFilter = {
  and?: InputMaybe<Array<AccountOperationCheckStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountOperationCheckStatsFilterIn>;
  not?: InputMaybe<AccountOperationCheckStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountOperationCheckStatsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountOperationCheckStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountOperationCheckStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountOperationCheckStatsMetrics = {
  __typename: 'AccountOperationCheckStatsMetrics';
  cachedRequestsCount: Scalars['Long']['output'];
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type AccountOperationCheckStatsOrderBySpec = {
  column: AccountOperationCheckStatsColumn;
  direction: Ordering;
};

export type AccountOperationCheckStatsRecord = {
  __typename: 'AccountOperationCheckStatsRecord';
  /** Dimensions of AccountOperationCheckStats that can be grouped by. */
  groupBy: AccountOperationCheckStatsDimensions;
  /** Metrics of AccountOperationCheckStats that can be aggregated over. */
  metrics: AccountOperationCheckStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountOperationFetchStats. */
export enum AccountOperationFetchStatsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CONNECTOR_SOURCE = 'CONNECTOR_SOURCE',
  FETCHES_WITH_ERRORS_COUNT = 'FETCHES_WITH_ERRORS_COUNT',
  FETCH_COUNT = 'FETCH_COUNT',
  FETCH_LATENCY_HISTOGRAM = 'FETCH_LATENCY_HISTOGRAM',
  FETCH_SERVICE_ID = 'FETCH_SERVICE_ID',
  FETCH_SERVICE_NAME = 'FETCH_SERVICE_NAME',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type AccountOperationFetchStatsDimensions = {
  __typename: 'AccountOperationFetchStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  connectorSource: Maybe<Scalars['String']['output']>;
  fetchServiceId: Maybe<Scalars['ID']['output']>;
  fetchServiceName: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountOperationFetchStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountOperationFetchStatsFilter = {
  and?: InputMaybe<Array<AccountOperationFetchStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose connectorSource dimension equals the given value if not null. To query for the null value, use {in: {connectorSource: [null]}} instead. */
  connectorSource?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fetchServiceId dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceId: [null]}} instead. */
  fetchServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose fetchServiceName dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceName: [null]}} instead. */
  fetchServiceName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountOperationFetchStatsFilterIn>;
  not?: InputMaybe<AccountOperationFetchStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountOperationFetchStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountOperationFetchStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountOperationFetchStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose connectorSource dimension is in the given list. A null value in the list means a row with null for that dimension. */
  connectorSource?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fetchServiceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose fetchServiceName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountOperationFetchStatsMetrics = {
  __typename: 'AccountOperationFetchStatsMetrics';
  fetchCount: Scalars['Long']['output'];
  fetchLatencyHistogram: DurationHistogram;
  fetchesWithErrorsCount: Scalars['Long']['output'];
};

export type AccountOperationFetchStatsOrderBySpec = {
  column: AccountOperationFetchStatsColumn;
  direction: Ordering;
};

export type AccountOperationFetchStatsRecord = {
  __typename: 'AccountOperationFetchStatsRecord';
  /** Dimensions of AccountOperationFetchStats that can be grouped by. */
  groupBy: AccountOperationFetchStatsDimensions;
  /** Metrics of AccountOperationFetchStats that can be aggregated over. */
  metrics: AccountOperationFetchStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** An invitation for a user to join an organization for a specific product. */
export type AccountProductInvitation = {
  __typename: 'AccountProductInvitation';
  /** When the invitation was accepted */
  acceptedAt: Maybe<Scalars['Timestamp']['output']>;
  /** When the invitation was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Email address the invitation was sent to */
  email: Scalars['String']['output'];
  /** When the invitation expires */
  expiresAt: Scalars['Timestamp']['output'];
  /** Unique identifier for the invitation */
  id: Scalars['ID']['output'];
  /** Last time an invitation email was sent */
  lastSentAt: Maybe<Scalars['Timestamp']['output']>;
  /** The product this invitation is for */
  product: Scalars['String']['output'];
  /** Access role for the invitee */
  role: Scalars['String']['output'];
  /** Current status of the invitation */
  status: Scalars['String']['output'];
};

export type AccountPublishesStatsMetrics = {
  __typename: 'AccountPublishesStatsMetrics';
  totalPublishes: Scalars['Long']['output'];
};

export type AccountPublishesStatsRecord = {
  __typename: 'AccountPublishesStatsRecord';
  id: Scalars['ID']['output'];
  metrics: AccountPublishesStatsMetrics;
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountQueryStats. */
export enum AccountQueryStatsColumn {
  CACHED_HISTOGRAM = 'CACHED_HISTOGRAM',
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CACHE_TTL_HISTOGRAM = 'CACHE_TTL_HISTOGRAM',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  FORBIDDEN_OPERATION_COUNT = 'FORBIDDEN_OPERATION_COUNT',
  FROM_ENGINEPROXY = 'FROM_ENGINEPROXY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PERSISTED_QUERY_ID = 'PERSISTED_QUERY_ID',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REGISTERED_OPERATION_COUNT = 'REGISTERED_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_HISTOGRAM = 'UNCACHED_HISTOGRAM',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type AccountQueryStatsDimensions = {
  __typename: 'AccountQueryStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fromEngineproxy: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  persistedQueryId: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  querySignatureLength: Maybe<Scalars['Int']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountQueryStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountQueryStatsFilter = {
  and?: InputMaybe<Array<AccountQueryStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fromEngineproxy dimension equals the given value if not null. To query for the null value, use {in: {fromEngineproxy: [null]}} instead. */
  fromEngineproxy?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountQueryStatsFilterIn>;
  not?: InputMaybe<AccountQueryStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountQueryStatsFilter>>;
  /** Selects rows whose persistedQueryId dimension equals the given value if not null. To query for the null value, use {in: {persistedQueryId: [null]}} instead. */
  persistedQueryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountQueryStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountQueryStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fromEngineproxy dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fromEngineproxy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose persistedQueryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  persistedQueryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountQueryStatsMetrics = {
  __typename: 'AccountQueryStatsMetrics';
  cacheTtlHistogram: DurationHistogram;
  cachedHistogram: DurationHistogram;
  cachedRequestsCount: Scalars['Long']['output'];
  forbiddenOperationCount: Scalars['Long']['output'];
  registeredOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
  totalLatencyHistogram: DurationHistogram;
  totalRequestCount: Scalars['Long']['output'];
  uncachedHistogram: DurationHistogram;
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type AccountQueryStatsOrderBySpec = {
  column: AccountQueryStatsColumn;
  direction: Ordering;
};

export type AccountQueryStatsRecord = {
  __typename: 'AccountQueryStatsRecord';
  /** Dimensions of AccountQueryStats that can be grouped by. */
  groupBy: AccountQueryStatsDimensions;
  /** Metrics of AccountQueryStats that can be aggregated over. */
  metrics: AccountQueryStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type AccountRoles = {
  __typename: 'AccountRoles';
  /** Whether the requesting credential may approve or deny agent-app access requests in this organization. */
  canApproveAccessRequests: Scalars['Boolean']['output'];
  canAudit: Scalars['Boolean']['output'];
  canCreateService: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  /** Whether the requesting credential may create or revoke agent-app API keys in this organization. */
  canManageAgentAppApiKeys: Scalars['Boolean']['output'];
  /** Whether the requesting credential may update or delete agent apps in this organization. Registering new agent apps is governed by canRegisterAgentApp. */
  canManageAgentApps: Scalars['Boolean']['output'];
  canManageMembers: Scalars['Boolean']['output'];
  canManageSessions: Scalars['Boolean']['output'];
  /** Whether the requesting credential may create, update, or delete upstream services and their field tags in this organization. */
  canManageUpstreamServices: Scalars['Boolean']['output'];
  canProvisionSSO: Scalars['Boolean']['output'];
  canQuery: Scalars['Boolean']['output'];
  canQueryAudit: Scalars['Boolean']['output'];
  canQueryBillingInfo: Scalars['Boolean']['output'];
  canQueryMembers: Scalars['Boolean']['output'];
  canQueryStats: Scalars['Boolean']['output'];
  /** Whether the requesting credential may read Constellation control-plane state for this organization. */
  canReadFromControlPlane: Scalars['Boolean']['output'];
  canReadTickets: Scalars['Boolean']['output'];
  /** Whether the requesting credential may register agent apps in this organization. Reflects the permissions granted to the API key making this request. */
  canRegisterAgentApp: Scalars['Boolean']['output'];
  canRemoveMembers: Scalars['Boolean']['output'];
  canSetConstrainedPlan: Scalars['Boolean']['output'];
  canUpdateBillingInfo: Scalars['Boolean']['output'];
  canUpdateMetadata: Scalars['Boolean']['output'];
  canViewApiKeyManagementPage: Scalars['Boolean']['output'];
};

/** A time window with a specified granularity over a given account. */
export type AccountStatsWindow = {
  __typename: 'AccountStatsWindow';
  billingUsageStats: Array<AccountBillingUsageStatsRecord>;
  cardinalityStats: Array<AccountCardinalityStatsRecord>;
  coordinateUsage: Array<AccountCoordinateUsageRecord>;
  edgeServerInfos: Array<AccountEdgeServerInfosRecord>;
  errorStats: Array<AccountErrorStatsRecord>;
  federatedErrorStats: Array<AccountFederatedErrorStatsRecord>;
  fieldExecutions: Array<AccountFieldExecutionsRecord>;
  fieldUsage: Array<AccountFieldUsageRecord>;
  graphosCloudMetrics: Array<AccountGraphosCloudMetricsRecord>;
  operationCheckStats: Array<AccountOperationCheckStatsRecord>;
  operationFetchStats: Array<AccountOperationFetchStatsRecord>;
  queryStats: Array<AccountQueryStatsRecord>;
  /** From field rounded down to the nearest resolution. */
  roundedDownFrom: Scalars['Timestamp']['output'];
  /** To field rounded up to the nearest resolution. */
  roundedUpTo: Scalars['Timestamp']['output'];
  tracePathErrorsRefs: Array<AccountTracePathErrorsRefsRecord>;
  traceRefs: Array<AccountTraceRefsRecord>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowbillingUsageStatsArgs = {
  filter?: InputMaybe<AccountBillingUsageStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountBillingUsageStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowcardinalityStatsArgs = {
  filter?: InputMaybe<AccountCardinalityStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCardinalityStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowcoordinateUsageArgs = {
  filter?: InputMaybe<AccountCoordinateUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCoordinateUsageOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowedgeServerInfosArgs = {
  filter?: InputMaybe<AccountEdgeServerInfosFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountEdgeServerInfosOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowerrorStatsArgs = {
  filter?: InputMaybe<AccountErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowfederatedErrorStatsArgs = {
  filter?: InputMaybe<AccountFederatedErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFederatedErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowfieldExecutionsArgs = {
  filter?: InputMaybe<AccountFieldExecutionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFieldExecutionsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowfieldUsageArgs = {
  filter?: InputMaybe<AccountFieldUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFieldUsageOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowgraphosCloudMetricsArgs = {
  filter?: InputMaybe<AccountGraphosCloudMetricsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountGraphosCloudMetricsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowoperationCheckStatsArgs = {
  filter?: InputMaybe<AccountOperationCheckStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOperationCheckStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowoperationFetchStatsArgs = {
  filter?: InputMaybe<AccountOperationFetchStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountOperationFetchStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowqueryStatsArgs = {
  filter?: InputMaybe<AccountQueryStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountQueryStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowtracePathErrorsRefsArgs = {
  filter?: InputMaybe<AccountTracePathErrorsRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTracePathErrorsRefsOrderBySpec>>;
};


/** A time window with a specified granularity over a given account. */
export type AccountStatsWindowtraceRefsArgs = {
  filter?: InputMaybe<AccountTraceRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTraceRefsOrderBySpec>>;
};

/** Columns of AccountTracePathErrorsRefs. */
export enum AccountTracePathErrorsRefsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  ERRORS_COUNT_IN_PATH = 'ERRORS_COUNT_IN_PATH',
  ERRORS_COUNT_IN_TRACE = 'ERRORS_COUNT_IN_TRACE',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  ERROR_SERVICE = 'ERROR_SERVICE',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_HTTP_STATUS_CODE = 'TRACE_HTTP_STATUS_CODE',
  TRACE_ID = 'TRACE_ID',
  TRACE_SIZE_BYTES = 'TRACE_SIZE_BYTES',
  TRACE_STARTS_AT = 'TRACE_STARTS_AT'
}

export type AccountTracePathErrorsRefsDimensions = {
  __typename: 'AccountTracePathErrorsRefsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  traceHttpStatusCode: Maybe<Scalars['Int']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
  traceStartsAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Filter for data in AccountTracePathErrorsRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountTracePathErrorsRefsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<AccountTracePathErrorsRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorMessage dimension equals the given value if not null. To query for the null value, use {in: {errorMessage: [null]}} instead. */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<AccountTracePathErrorsRefsFilterIn>;
  not?: InputMaybe<AccountTracePathErrorsRefsFilter>;
  or?: InputMaybe<Array<AccountTracePathErrorsRefsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose traceHttpStatusCode dimension equals the given value if not null. To query for the null value, use {in: {traceHttpStatusCode: [null]}} instead. */
  traceHttpStatusCode?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountTracePathErrorsRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountTracePathErrorsRefsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorMessage dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose traceHttpStatusCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceHttpStatusCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountTracePathErrorsRefsMetrics = {
  __typename: 'AccountTracePathErrorsRefsMetrics';
  errorsCountInPath: Scalars['Long']['output'];
  errorsCountInTrace: Scalars['Long']['output'];
  traceSizeBytes: Scalars['Long']['output'];
};

export type AccountTracePathErrorsRefsOrderBySpec = {
  column: AccountTracePathErrorsRefsColumn;
  direction: Ordering;
};

export type AccountTracePathErrorsRefsRecord = {
  __typename: 'AccountTracePathErrorsRefsRecord';
  /** Dimensions of AccountTracePathErrorsRefs that can be grouped by. */
  groupBy: AccountTracePathErrorsRefsDimensions;
  /** Metrics of AccountTracePathErrorsRefs that can be aggregated over. */
  metrics: AccountTracePathErrorsRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of AccountTraceRefs. */
export enum AccountTraceRefsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_COUNT = 'TRACE_COUNT',
  TRACE_ID = 'TRACE_ID'
}

export type AccountTraceRefsDimensions = {
  __typename: 'AccountTraceRefsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  generatedTraceId: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in AccountTraceRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type AccountTraceRefsFilter = {
  and?: InputMaybe<Array<AccountTraceRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<AccountTraceRefsFilterIn>;
  not?: InputMaybe<AccountTraceRefsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<AccountTraceRefsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in AccountTraceRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type AccountTraceRefsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AccountTraceRefsMetrics = {
  __typename: 'AccountTraceRefsMetrics';
  traceCount: Scalars['Long']['output'];
};

export type AccountTraceRefsOrderBySpec = {
  column: AccountTraceRefsColumn;
  direction: Ordering;
};

export type AccountTraceRefsRecord = {
  __typename: 'AccountTraceRefsRecord';
  /** Dimensions of AccountTraceRefs that can be grouped by. */
  groupBy: AccountTraceRefsDimensions;
  /** Metrics of AccountTraceRefs that can be aggregated over. */
  metrics: AccountTraceRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Client details to match against `activityLogs` entries. */
export type ActivityLogsClientFilterInInput = {
  /** The agent app's id, as `GatewayLogRecord.clientName`. */
  clientName?: InputMaybe<Scalars['String']['input']>;
};

/** A dimension `activityLogs` can be filtered by, and so also faceted. */
export enum ActivityLogsDimension {
  /** The agent app that made the request, as `ActivityLogsFilterInInput.clients`. */
  CLIENT = 'CLIENT',
  /** The effect a policy took on a field, as `ActivityLogsFilterInInput.effect`. */
  EFFECT = 'EFFECT',
  /** The service that handled the request, as `ActivityLogsFilterInInput.routingDomain`. */
  ROUTING_DOMAIN = 'ROUTING_DOMAIN',
  /** The tool's name after any `tools: rename_to`, as `ActivityLogsFilterInInput.toolEffectiveName`. */
  TOOL_EFFECTIVE_NAME = 'TOOL_EFFECTIVE_NAME',
  /** The MCP tool the request invoked, as `ActivityLogsFilterInInput.toolName`. */
  TOOL_NAME = 'TOOL_NAME'
}

/** Describes the values observed for a filter dimension on `activityLogs` in a window, for populating a filter menu. */
export type ActivityLogsFacet = {
  __typename: 'ActivityLogsFacet';
  /** The dimension these values came from, echoed back so concurrent facet queries can be told apart. */
  dimension: ActivityLogsDimension;
  /** The dimension's values, most-matched first. Empty when nothing in the window matched. */
  values: Array<ActivityLogsFacetValue>;
};

/** One value a filter dimension takes, with how much traffic it accounts for. */
export type ActivityLogsFacetValue = {
  __typename: 'ActivityLogsFacetValue';
  /** How many requests in the window matched this value. Exact, not sampled or estimated. */
  count: Scalars['Long']['output'];
  /** The value as the dimension's `ActivityLogsFilterInInput` field expects it, ready to send back as a filter. */
  value: Scalars['String']['output'];
};

/** Lists of dimensions to include or exclude in the activity log. Within one field, values are OR'd together (any match); across fields, results are AND'd together (e.g. `clients` and `routingDomain` both set means a match must satisfy both). */
export type ActivityLogsFilterInInput = {
  /** Matches any activity log entries from any of these clients. */
  clients?: InputMaybe<Array<InputMaybe<ActivityLogsClientFilterInInput>>>;
  /** Matches any activity log entries where a policy took effect on a field with any of these effects: `allow`, `mask`, `deny_requestable`, `deny_visible`, `deny_hidden`. */
  effect?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any activity log entries handled by any of these services, by routing domain -- the service id, as `RouterLogRecord.routingDomain`. */
  routingDomain?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any activity log entries whose request invoked any of these MCP tools, by effective name -- the name after any `tools: rename_to` config is applied. */
  toolEffectiveName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any activity log entries whose request invoked any of these MCP tools, by canonical name. */
  toolName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Filters applied to `activityLogs`. */
export type ActivityLogsFilterInput = {
  /** Exclude activity log entries that match a specified set of dimensions. */
  exclude?: InputMaybe<ActivityLogsFilterInInput>;
  /** Include activity log entries that match a specified set of dimensions. */
  include?: InputMaybe<ActivityLogsFilterInInput>;
  /** Matches activity log entries whose client name, tool name (canonical or effective), operation name, routing domain, or applied policy schema coordinate contains this text, or whose request id starts with it -- a request id is matched by prefix, so a partial id can be pasted but its interior never matches. Case-insensitive. A single word only; whitespace is not treated specially. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** One request's activity log entry, joining its gateway and router log records. */
export type ActivityLogsItem = {
  __typename: 'ActivityLogsItem';
  /** The record written by the MCP gateway for this request. */
  gatewayLog: GatewayLogRecord;
  /** The request ID shared by this entry's gateway and router log records. */
  requestId: Scalars['ID']['output'];
  /** The record written by the sub-router that handled this request, if it has arrived. */
  routerLog: Maybe<RouterLogRecord>;
  /** When this request was first observed. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Information about pagination in a connection. */
export type ActivityLogsPageInfo = {
  __typename: 'ActivityLogsPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** Represents an actor that performs actions in Apollo Studio. Most actors are either a `USER` or a `GRAPH` (based on a request's provided API key), and they have the corresponding `ActorType`. */
export type Actor = {
  __typename: 'Actor';
  /**
   * The bare GraphOS actor id — no `user:`/`service:`/`identity:` prefix
   * (that story is gone; see migration 0037). Named `actorId`, matching
   * the shared supergraph type's field name exactly (not `id`).
   */
  actorId: Scalars['ID']['output'];
  /**
   * The kind of actor `actor_id` names. `r#type` renders as `type` on the
   * wire — async-graphql strips the raw-identifier escape — matching this
   * repo's existing convention (see e.g. `PolicyRuleScope.r#type`).
   */
  type: ActorType;
};

/** Input type to provide when specifying an `Actor` in operation arguments. See also the `Actor` object type. */
export type ActorInput = {
  actorId: Scalars['ID']['input'];
  type: ActorType;
};

/**
 * The GraphQL-facing counterpart of migration 0037's `actor_type` Postgres
 * enum (`crate::models::actor::StoredActorType`) — see
 * `docs/developer/2026-08-19-A-actor-identity-refactor/design.md` §7.
 *
 * This deliberately redeclares the supergraph-wide shared `ActorType`
 * enum — seven other subgraphs (constellation-registry included makes
 * eight: custom-checks, identity, kotlin, operationcollections, proposals,
 * registry, technical-support) already define a type of this exact name,
 * and `ActorType` is also used as an *input* type elsewhere in the
 * supergraph (`ActorInput.type`). Composition's `ENUM_VALUE_MISMATCH` rule
 * requires every subgraph defining an enum used as an input to match its
 * value set byte-for-byte. An earlier draft of this design added a tenth,
 * locally-invented `UNKNOWN` member (for the domain enum's `Unknown(String)`
 * forward-compat arm — see `crate::auth::actor::ActorType`) and Studio
 * composition rejected it outright: `ENUM_VALUE_MISMATCH` because the other
 * seven subgraphs don't define `UNKNOWN`, and (on `Actor` itself)
 * `INVALID_FIELD_SHARING` because this subgraph marked `Actor.type`
 * non-shareable while the other seven mark it shareable. So there is no
 * `UNKNOWN` here: exactly the 9 values the shared enum has, no more. An
 * actor type this build doesn't recognize is refused at the attribution
 * write path instead of being rendered — see
 * `crate::models::actor::UnrecognizedActorType` and the `TryFrom` call
 * sites in `graphql::types::account_mutation` /
 * `graphql::types::service_mutation`.
 */
export enum ActorType {
  ANONYMOUS_USER = 'ANONYMOUS_USER',
  BACKFILL = 'BACKFILL',
  CRON = 'CRON',
  GRAPH = 'GRAPH',
  INTERNAL_IDENTITY = 'INTERNAL_IDENTITY',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
  SYNCHRONIZATION = 'SYNCHRONIZATION',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

/** parentCommentId is only present for replies. schemaCoordinate & subgraph are only present for initial change comments. If all are absent, this is a general parent comment on the proposal. */
export type AddCommentInput = {
  message: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['String']['input']>;
  revisionId: Scalars['String']['input'];
  schemaCoordinate?: InputMaybe<Scalars['String']['input']>;
  schemaScope?: InputMaybe<Scalars['String']['input']>;
  usersToNotify?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddCommentResult = NotFoundError | ParentChangeProposalComment | ParentGeneralProposalComment | ReplyChangeProposalComment | ReplyGeneralProposalComment | ValidationError;

export type AddOperationCollectionEntriesResult = AddOperationCollectionEntriesSuccess | PermissionError | ValidationError;

export type AddOperationCollectionEntriesSuccess = {
  __typename: 'AddOperationCollectionEntriesSuccess';
  operationCollectionEntries: Array<OperationCollectionEntry>;
};

export type AddOperationCollectionEntryResult = OperationCollectionEntry | PermissionError | ValidationError;

export type AddOperationCollectionToVariantResult = GraphVariant | InvalidTarget | PermissionError | ValidationError;

export type AddOperationInput = {
  /** The operation's fields. */
  document: OperationCollectionEntryStateInput;
  /** The operation's name. */
  name: Scalars['String']['input'];
};

export type AffectedClient = {
  __typename: 'AffectedClient';
  /**
   * ID, often the name, of the client set by the user and reported alongside metrics
   * @deprecated Unsupported.
   */
  clientReferenceId: Maybe<Scalars['ID']['output']>;
  /**
   * version of the client set by the user and reported alongside metrics
   * @deprecated Unsupported.
   */
  clientVersion: Maybe<Scalars['String']['output']>;
};

export enum AffectedEnv {
  NON_PRODUCTION = 'NON_PRODUCTION',
  PRODUCTION = 'PRODUCTION'
}

/** Filter options available when searching affected queries for a check. */
export type AffectedQueriesFilterInput = {
  /** Filter by a keyword to match against the query's operation name or ID. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter affected queries by one or more statuses.
   *
   * For example, use `[BROKEN]` to return only queries that are broken,
   * or `[BROKEN, POTENTIALLY_AFFECTED]` to include queries that are broken OR possibly affected.
   */
  status?: InputMaybe<Array<AffectedQueryStatus>>;
};

export type AffectedQuery = {
  __typename: 'AffectedQuery';
  /** If the operation would be approved if the check ran again. Returns null if queried from SchemaDiff.changes.affectedQueries.alreadyApproved */
  alreadyApproved: Maybe<Scalars['Boolean']['output']>;
  /** If the operation would be ignored if the check ran again */
  alreadyIgnored: Maybe<Scalars['Boolean']['output']>;
  /** List of changes affecting this query. Returns null if queried from SchemaDiff.changes.affectedQueries.changes */
  changes: Maybe<Array<ChangeOnOperation>>;
  /** Name to display to the user for the operation */
  displayName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Determines if this query validates against the proposed schema */
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** Whether this operation was ignored and its severity was downgraded for that reason */
  markedAsIgnored: Maybe<Scalars['Boolean']['output']>;
  /** Whether the changes were marked as safe and its severity was downgraded for that reason */
  markedAsSafe: Maybe<Scalars['Boolean']['output']>;
  /** Name provided for the operation, which can be empty string if it is an anonymous operation */
  name: Maybe<Scalars['String']['output']>;
  /** First 128 characters of query signature for display */
  signature: Maybe<Scalars['String']['output']>;
};

export enum AffectedQueryStatus {
  /** This query will break as a result of the changes in this check. */
  BROKEN = 'BROKEN',
  /** This query is affected by the changes, but was ignored in a previous check */
  IGNORED = 'IGNORED',
  /** This query is valid but may be affected by the changes in this check. */
  POTENTIALLY_AFFECTED = 'POTENTIALLY_AFFECTED',
  /** This query is affected by the changes, but was marked as safe in a previous check. */
  SAFE = 'SAFE'
}

/** An actor that has used an Agent App. Identified by kind plus value. */
export type AgentAppPrincipal = {
  __typename: 'AgentAppPrincipal';
  /** When this principal was first recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** Email address, if the identity provider supplied one. */
  email: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this principal. */
  id: Scalars['UUID']['output'];
  /** How this principal is identified. */
  kind: AgentAppPrincipalKind;
  /** When this principal was last observed using the Agent App. */
  lastSeenAt: Scalars['DateTime']['output'];
  /** Display name, if the identity provider supplied one. */
  name: Maybe<Scalars['String']['output']>;
  /** Subject identifier at the primary identity provider, if present. */
  primaryIdpSub: Maybe<Scalars['String']['output']>;
  /** When this principal's stored attributes were last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Identifier value for this kind. For an OIDC subject, the Keycloak `sub`. */
  value: Scalars['String']['output'];
};

/** How an Agent App Principal is identified. */
export enum AgentAppPrincipalKind {
  /** A machine credential identified by its API key id. */
  API_KEY = 'API_KEY',
  /** A person identified by their OIDC subject (Keycloak `sub`). */
  OIDC_SUBJECT = 'OIDC_SUBJECT'
}

/** A page of Agent App principals with an optional cursor for the next page. */
export type AgentAppPrincipalPage = {
  __typename: 'AgentAppPrincipalPage';
  /** Cursor for the next page of data, or null on the last page. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Principals in this page, most recently seen first. */
  items: Array<AgentAppPrincipal>;
  /** Total number of principals recorded for this Agent App. */
  totalCount: Scalars['Int']['output'];
};

/** An agent gateway represents a gateway entity that serves MCP requests. */
export type AgentGateway = {
  __typename: 'AgentGateway';
  /** The unique identifier for this agent gateway. */
  id: Scalars['ID']['output'];
  /** MCP insights timeseries report for this agent gateway. */
  mcpInsightsTimeseriesReport: McpInsightsTimeseriesReportResult;
  /** The human-readable name of this agent gateway. */
  name: Maybe<Scalars['String']['output']>;
};


/** An agent gateway represents a gateway entity that serves MCP requests. */
export type AgentGatewaymcpInsightsTimeseriesReportArgs = {
  dimensions: Array<McpInsightsTimeseriesReportDimension>;
  filter?: InputMaybe<McpInsightsTimeseriesReportFilterInput>;
  from: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
  metrics: Array<McpInsightsTimeseriesReportMetric>;
  resolution: TimeseriesReportResolution;
  to: Scalars['Timestamp']['input'];
};

/** Returned from createS3Integration when the organization already has an enabled S3 integration configuration. Use s3Integration(id).update to modify the existing configuration. */
export type AlreadyConfiguredError = {
  __typename: 'AlreadyConfiguredError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/**
 * Represents an API key that's used to authenticate a
 * particular Apollo user or graph.
 */
export type ApiKey = {
  /** The API key's ID. */
  id: Scalars['ID']['output'];
  /** The API key's name, for distinguishing it from other keys. */
  keyName: Maybe<Scalars['String']['output']>;
  /** The timestamp when the API key was last used for authentication, if available. */
  lastUsed: Maybe<Scalars['Timestamp']['output']>;
  /** The value of the API key. **This is a secret credential!** */
  token: Scalars['String']['output'];
};

/** Filtering options for API key queries */
export type ApiKeyFilterInput = {
  /** Filter by key status. If not specified, defaults to ACTIVE. */
  apiKeyStatus?: InputMaybe<ApiKeyStatusFilter>;
  /** Filter by key type. If not specified, all key types are returned. */
  apiKeyType?: InputMaybe<ApiKeyTypeFilter>;
};

export type ApiKeyProvision = {
  __typename: 'ApiKeyProvision';
  apiKey: ApiKey;
  created: Scalars['Boolean']['output'];
};

/** Represents a resource that an API key has access to, including its type and identifier. */
export type ApiKeyResource = {
  __typename: 'ApiKeyResource';
  /** The identifier of the resource that the key has access to. */
  resourceId: Scalars['String']['output'];
  /** The type of resource that the key has access to. */
  resourceType: Scalars['String']['output'];
};

/** The target resource(s) that a key has access to */
export type ApiKeyResourceInput = {
  /** One or more gateways that a key has access to */
  gateways?: InputMaybe<Array<GatewayIdentifierInput>>;
  /** One or more subgraphs that a key has access to */
  subgraphs?: InputMaybe<Array<SubgraphIdentifierInput>>;
  /** One or more variants that a key has access to */
  variants?: InputMaybe<Array<GraphVariantIdentifierInput>>;
};

/** Filter API keys by their status */
export enum ApiKeyStatusFilter {
  /** Only return active keys that are active, not revoked, expired, or deleted */
  ACTIVE = 'ACTIVE',
  /** Filter for all non-deleted keys */
  ALL = 'ALL',
  /** Only return expired keys that are not deleted */
  EXPIRED = 'EXPIRED',
  /** Only return revoked keys that are not deleted */
  REVOKED = 'REVOKED'
}

/** Filter API keys by their type */
export enum ApiKeyTypeFilter {
  /** Filter for Gateway keys */
  GATEWAY = 'GATEWAY',
  /** Filter for Operator keys */
  OPERATOR = 'OPERATOR',
  /** Filter for SCIM keys */
  SCIM = 'SCIM',
  /** Filter for Subgraph keys */
  SUBGRAPH = 'SUBGRAPH',
  /** Filter for Variant keys */
  VARIANT = 'VARIANT'
}

/** A generic event for the `trackApolloKotlinUsage` mutation */
export type ApolloKotlinUsageEventInput = {
  /** When the event occurred */
  date: Scalars['Timestamp']['input'];
  /** Optional parameters attached to the event */
  payload?: InputMaybe<Scalars['Object']['input']>;
  /** Type of event */
  type: Scalars['ID']['input'];
};

/** A generic property for the `trackApolloKotlinUsage` mutation */
export type ApolloKotlinUsagePropertyInput = {
  /** Optional parameters attached to the property */
  payload?: InputMaybe<Scalars['Object']['input']>;
  /** Type of property */
  type: Scalars['ID']['input'];
};

/**
 * A previously issued application API key. Never carries the plaintext key
 * or its digest — `keyHint` is the only key-material-derived field exposed
 * here, and it is not reversible to either.
 */
export type ApplicationApiKey = {
  __typename: 'ApplicationApiKey';
  /**
   * The upstream services this API key is allowed to access, as resolved
   * records. A service that has since been deleted drops out of this list
   * — the grant row survives the service, but there is nothing left to
   * render for it.
   */
  allowedServices: Array<UpstreamService>;
  /** When this API key was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The actor who created this API key. Was a bare `String` (the JWT
   * `sub`, effectively); replaced by an `Actor` so both the id and the
   * GraphOS actor kind are visible — see
   * `docs/developer/2026-08-19-A-actor-identity-refactor/design.md` §7.
   * No known external consumer, so this is a clean replace rather than an
   * additive field.
   */
  createdBy: Actor;
  /** Unique identifier for this API key. */
  id: Scalars['UUID']['output'];
  /**
   * A short, non-reversible fragment of the key, useful for telling keys
   * apart without exposing the key itself.
   */
  keyHint: Scalars['String']['output'];
  /** A human-readable name for this API key, chosen at creation time. */
  label: Scalars['String']['output'];
  /** When this API key was revoked, or null if it is still active. */
  revokedAt: Maybe<Scalars['DateTime']['output']>;
  /**
   * The actor who revoked this API key, or null if it is still active.
   * Same `String` -> `Actor` replacement as `createdBy`.
   */
  revokedBy: Maybe<Actor>;
};

/**
 * Filter options for `Account.applications`. All fields are optional and
 * compose (logical AND).
 */
export type ApplicationFilterInput = {
  /**
   * Match only applications of one of the supplied kinds.
   * An empty array is treated the same as null (no kind filter).
   */
  kind?: InputMaybe<Array<ApplicationKind>>;
  /** Case-insensitive substring match on the application name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Match only applications whose status is one of the supplied values.
   * An empty array is treated the same as null (no status filter).
   */
  status?: InputMaybe<Array<ApplicationStatus>>;
  /**
   * Tri-state filter on "unowned" interactive clients: applications of
   * kind INTERACTIVE with status APPROVED and no recorded principals —
   * i.e. DCR registrations no user has ever authenticated through.
   * `true` matches only unowned clients; `false` excludes them; null
   * applies no filter.
   */
  unowned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Whether the application is agentic (requires review) or interactive (auto-approved). */
export enum ApplicationKind {
  /** An agentic application — starts in PENDING status and requires human review. */
  AGENTIC_APP = 'AGENTIC_APP',
  /** An interactive application — automatically approved at creation. */
  INTERACTIVE = 'INTERACTIVE'
}

/** A page of applications with an optional cursor for the next page. */
export type ApplicationPage = {
  __typename: 'ApplicationPage';
  /** Cursor for the next page of data, or null on the last page. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Applications in this page. */
  items: Array<ApplicationType>;
  /**
   * Total number of applications matching the query's filter, independent
   * of `limit`/`cursor`.
   */
  totalCount: Scalars['Int']['output'];
};

/** Lifecycle status of an application registered in the constellation registry. */
export enum ApplicationStatus {
  /** Application has been reviewed and approved for service access. */
  APPROVED = 'APPROVED',
  /** Application has been reviewed and denied service access. */
  DENIED = 'DENIED',
  /** Application has been disabled and can no longer access services. */
  DISABLED = 'DISABLED',
  /** Application has been submitted and is awaiting review. */
  PENDING = 'PENDING'
}

/** An application that consumes services in the constellation registry. */
export type ApplicationType = {
  __typename: 'ApplicationType';
  /**
   * API keys issued for this application. Any member of the owning
   * organization may read this field, including keys that have since
   * been revoked — key material itself is never included; see
   * `ApplicationApiKey.keyHint`.
   */
  apiKeys: Array<ApplicationApiKey>;
  /** Timestamp when the application was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The actor who registered this application. Null for a row from
   * before attribution was recorded, and for a gateway-path registration
   * (DCR, First Use) whose actor type this build cannot store.
   */
  createdBy: Maybe<Actor>;
  /** Timestamp when the application was soft-deleted, or null if active. */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional description of the application's purpose. */
  description: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this application. */
  id: Scalars['UUID']['output'];
  /** Whether this is an agentic or interactive application. */
  kind: ApplicationKind;
  /** Human-readable name of the application. */
  name: Scalars['String']['output'];
  /**
   * OAuth client identifier, if this app was registered dynamically.
   * Null for apps that authenticate with an API key.
   */
  oauthClientId: Maybe<Scalars['String']['output']>;
  /**
   * Principals recorded as having used this Agent App, most recently seen
   * first.
   */
  principals: AgentAppPrincipalPage;
  /** Current lifecycle status of the application. */
  status: ApplicationStatus;
  /** Timestamp when the application was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** An application that consumes services in the constellation registry. */
export type ApplicationTypeprincipalsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A field-level policy that took effect on this request. One entry per field a policy acted on, carrying the rule that won for that field — rules that matched but lost are resolved away before the record is written. */
export type AppliedPolicy = {
  __typename: 'AppliedPolicy';
  /** The data classification that brought the field into scope (for example `pii`). */
  classification: Maybe<Scalars['String']['output']>;
  /** The winning effect: one of `allow`, `mask`, `deny_requestable`, `deny_visible`, `deny_hidden`. */
  effect: Maybe<Scalars['String']['output']>;
  /** Where the field sat in this operation's response. Normalized — list indices are collapsed, so one entry covers a field however many list items it was reached through. */
  fieldPath: Maybe<Scalars['String']['output']>;
  /** The policy rule that won for this field, federated from constellation-registry. */
  policyRule: Maybe<PolicyRule>;
  /** An optional explanation for why the rule matched. */
  reason: Maybe<Scalars['String']['output']>;
  /** The winning rule's id: the single rule whose effect was enforced on this field. */
  ruleId: Maybe<Scalars['String']['output']>;
  /** Where the field lives in the schema, as `Type.field`. */
  schemaCoordinate: Maybe<Scalars['String']['output']>;
};

/** Input for assigning a survey to one or more courses */
export type AssignSurveyToCoursesInput = {
  /** The courses to assign this survey to; existing assignments are replaced */
  courseIds: Array<Scalars['ID']['input']>;
  /** The survey to assign */
  surveyId: Scalars['ID']['input'];
};

/** Return payload for the assignSurveyToCourses mutation */
export type AssignSurveyToCoursesPayload = {
  __typename: 'AssignSurveyToCoursesPayload';
  /** The course IDs that were assigned (deduplicated) */
  assignedCourseIds: Array<Scalars['ID']['output']>;
  /** The survey that was assigned, or null if validation failed */
  survey: Maybe<FeedbackSurvey>;
  /** Any validation errors that occurred */
  userErrors: Array<UserError>;
};

/** The payload from adding a tag to a graph artifact. */
export type AssignTagToGraphArtifactPayload = {
  __typename: 'AssignTagToGraphArtifactPayload';
  /** Any errors encountered while adding the tag. */
  errors: Array<Error>;
  /** The graph artifact where the tag was added. */
  graphArtifact: Maybe<GraphArtifact>;
  /** The tag that was added. */
  tag: Maybe<GraphArtifactTag>;
};

/** The possible result of adding a tag to a graph artifact. */
export type AssignTagToGraphArtifactResult = AssignTagToGraphArtifactPayload | BadInputError | GraphArtifactDigestInvalidError | GraphArtifactNotFoundError | GraphArtifactTagInvalidError | GraphArtifactTagVariantAssignError | GraphArtifactTaggingLimitError | GraphArtifactTotalTagsLimitError | GraphNotFoundError | OperationInProgressError;

export type AuditLogExport = {
  __typename: 'AuditLogExport';
  /** The list of actors to filter the audit export */
  actors: Maybe<Array<Identity>>;
  bigqueryTriggeredAt: Maybe<Scalars['Timestamp']['output']>;
  /** The time when the audit export was completed */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The time when the audit export was reqeusted */
  createdAt: Scalars['Timestamp']['output'];
  /** List of URLs to download the audits for the requested range */
  downloadUrls: Maybe<Array<Scalars['String']['output']>>;
  exportedFiles: Maybe<Array<Scalars['String']['output']>>;
  /** The starting point of audits to include in export */
  from: Scalars['Timestamp']['output'];
  /** The list of graphs to filter the audit export */
  graphs: Maybe<Array<Service>>;
  /** The id for the audit export */
  id: Scalars['ID']['output'];
  /**
   * The user that initiated the audit export
   * @deprecated Use requesterActor instead, which is also populated for non-user (e.g. scheduled / system) exports.
   */
  requester: Maybe<User>;
  /** The actor that initiated the audit export. Unlike `requester`, this is populated for non-user actors such as scheduled / system exports. */
  requesterActor: Actor;
  /** The status of the audit export */
  status: AuditStatus;
  /**
   * The outcome of delivering this export to the customer's configured S3 bucket. Null for exports
   * that are not synced to S3 (no integration), or whose delivery has not yet been attempted. A
   * `TRANSIENT_FAILURE` while `status` is still `SYNCING` indicates delivery will be retried
   * automatically; any other non-null outcome is terminal.
   */
  syncOutcome: Maybe<AuditSyncOutcome>;
  /** The end point of audits to include in export */
  to: Scalars['Timestamp']['output'];
};

export type AuditLogExportMutation = {
  __typename: 'AuditLogExportMutation';
  cancel: Maybe<Account>;
  delete: Maybe<Account>;
};

export enum AuditStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  QUEUED = 'QUEUED',
  /** The audit export is being delivered to the configured S3 destination */
  SYNCING = 'SYNCING'
}

/** The outcome of delivering an audit-log export to the customer's configured S3 destination. See individual values for whether each outcome is retried automatically (transient) or terminal. */
export enum AuditSyncOutcome {
  /** Terminal: Apollo was denied access to the destination bucket (check the bucket policy and role trust). */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /** Terminal: delivery kept failing until the retry window elapsed and was abandoned. */
  DELIVERY_TIMED_OUT = 'DELIVERY_TIMED_OUT',
  /** Terminal: delivery was skipped because the S3 integration is disabled. */
  INTEGRATION_DISABLED = 'INTEGRATION_DISABLED',
  /** Terminal: delivery was skipped because the S3 integration was removed. */
  INTEGRATION_REMOVED = 'INTEGRATION_REMOVED',
  /** Terminal: an internal error — the export was marked for sync but had no associated S3 integration. */
  MISSING_INTEGRATION_ID = 'MISSING_INTEGRATION_ID',
  /** Terminal: the configured destination bucket does not exist. */
  NO_SUCH_BUCKET = 'NO_SUCH_BUCKET',
  /** The export was delivered successfully to the configured S3 destination. */
  SUCCESS = 'SUCCESS',
  /** Transient: a retryable error occurred; delivery is retried automatically while `status` remains `SYNCING`. */
  TRANSIENT_FAILURE = 'TRANSIENT_FAILURE'
}

export type AvatarDeleteError = {
  __typename: 'AvatarDeleteError';
  clientMessage: Scalars['String']['output'];
  code: AvatarDeleteErrorCode;
  serverMessage: Scalars['String']['output'];
};

export enum AvatarDeleteErrorCode {
  SSO_USERS_CANNOT_DELETE_SELF_AVATAR = 'SSO_USERS_CANNOT_DELETE_SELF_AVATAR'
}

export type AvatarUploadError = {
  __typename: 'AvatarUploadError';
  clientMessage: Scalars['String']['output'];
  code: AvatarUploadErrorCode;
  serverMessage: Scalars['String']['output'];
};

export enum AvatarUploadErrorCode {
  SSO_USERS_CANNOT_UPLOAD_SELF_AVATAR = 'SSO_USERS_CANNOT_UPLOAD_SELF_AVATAR'
}

export type AvatarUploadResult = AvatarUploadError | MediaUploadInfo;

/** AWS Load Balancer information */
export type AwsLoadBalancer = {
  __typename: 'AwsLoadBalancer';
  /** ARN for the load balancer */
  arn: Scalars['String']['output'];
  /** DNS endpoint for the load balancer */
  endpoint: Scalars['String']['output'];
  /** ARN for the HTTPS listener for the load balancer */
  listenerArn: Scalars['String']['output'];
};

/** Input for AWS Load Balancer */
export type AwsLoadBalancerInput = {
  arn: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  listenerArn: Scalars['String']['input'];
};

/** AWS-specific information for a Shard */
export type AwsShard = {
  __typename: 'AwsShard';
  /** AWS Account ID where the Shard is hosted */
  accountId: Scalars['String']['output'];
  /** ARNs of the target groups for sleeping Cloud Routers */
  coldStartTargetGroupArns: Maybe<Array<Scalars['String']['output']>>;
  /** ARN of the ECS Cluster */
  ecsClusterArn: Scalars['String']['output'];
  /** ARN of the IAM role to perform provisioning operations on this shard */
  iamRoleArn: Scalars['String']['output'];
  /** ID of the security group for the load balancer */
  loadbalancerSecurityGroupId: Scalars['String']['output'];
  /** Load balancers for this Cloud Router */
  loadbalancers: Array<AwsLoadBalancer>;
  /** ARN of the IAM permissions boundaries for IAM roles provisioned in this shard */
  permissionsBoundaryArn: Scalars['String']['output'];
  /** IDs of the subnets */
  subnetIds: Array<Scalars['String']['output']>;
  /** ID of the VPC */
  vpcId: Scalars['String']['output'];
};

/** The error returned when the required inputs are not passed */
export type BadInputError = Error & {
  __typename: 'BadInputError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type BaseConnection = SsoConnection & {
  __typename: 'BaseConnection';
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpId: Scalars['ID']['output'];
  scim: Maybe<SsoScimProvisioningDetails>;
  /** @deprecated Use stateV2 instead */
  state: SsoConnectionState;
  stateV2: SsoConnectionStateV2;
  updatedAt: Scalars['Timestamp']['output'];
};

export type BillingAddress = {
  __typename: 'BillingAddress';
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

/** Billing address input */
export type BillingAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type BillingAdminQuery = {
  __typename: 'BillingAdminQuery';
  /** Look up the current plan of an account by calling the grpc service */
  currentPlanFromGrpc: Maybe<GQLBillingPlanFromGrpc>;
};


export type BillingAdminQuerycurrentPlanFromGrpcArgs = {
  internalAccountId: Scalars['ID']['input'];
};

export type BillingCapability = {
  __typename: 'BillingCapability';
  defaultValue: Scalars['Boolean']['output'];
  intendedUse: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum BillingCycleAnchor {
  CUSTOM = 'CUSTOM',
  START_OF_MONTH = 'START_OF_MONTH'
}

export type BillingInfo = {
  __typename: 'BillingInfo';
  address: BillingAddress;
  cardType: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastFour: Maybe<Scalars['Int']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  month: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  vatNumber: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type BillingInsights = {
  __typename: 'BillingInsights';
  totalOperations: Array<BillingInsightsUsage>;
  totalSampledOperations: Array<BillingInsightsUsage>;
};

export type BillingInsightsUsage = {
  __typename: 'BillingInsightsUsage';
  timestamp: Scalars['Timestamp']['output'];
  totalOperationCount: Scalars['Long']['output'];
};

export type BillingLimit = {
  __typename: 'BillingLimit';
  defaultValue: Maybe<Scalars['Long']['output']>;
  intendedUse: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum BillingModel {
  REQUEST_BASED = 'REQUEST_BASED',
  SEAT_BASED = 'SEAT_BASED'
}

export type BillingMonth = {
  __typename: 'BillingMonth';
  end: Scalars['Timestamp']['output'];
  requests: Scalars['Long']['output'];
  start: Scalars['Timestamp']['output'];
};

export type BillingMutation = {
  __typename: 'BillingMutation';
  /** Temporary utility mutation to convert annual team plan orgs to monthly team plans */
  convertAnnualTeamOrgToMonthly: Maybe<Scalars['Void']['output']>;
  createSetupIntent: Maybe<SetupIntentResult>;
  /** Admin mutation for creating new log entry for failed usage export log. */
  createUsageExportLogFromFailed: Maybe<Scalars['Void']['output']>;
  /**
   * Admin mutation for manually creating usage exports for usage-based pricing of Scale plans.
   * Note that for subscriptions that were activated and/or canceled within the given interval,
   * we truncate the interval to that for which the subscription was active.
   */
  createUsageExportLogs: Maybe<Scalars['Void']['output']>;
  /** Admin mutation for creating new log entry for failed validation intervals. */
  createUsageExportLogsForFailedValidationIntervals: Maybe<Scalars['Void']['output']>;
  /** Admin mutation for reactivating a soft-canceled subscription */
  reactivateSoftCanceledSubscription: Maybe<Scalars['Void']['output']>;
  reloadPlans: Array<BillingPlan>;
  /** Admin mutation for manually syncing usage data for usage-based data of Scale plans. */
  syncOldestPendingUsage: Maybe<Scalars['Void']['output']>;
  /** Admin mutation for manually syncing usage data for usage-based data of Scale plans. */
  syncRecentScaleUsage: Maybe<Scalars['Void']['output']>;
  /** Mutation to sync an Apollo Plan with a Stripe product */
  syncStripePlan: Maybe<Scalars['Void']['output']>;
  /**
   * Admin mutation for syncing subscription with Stripe.
   * Currently only updates the current period start and end dates, and the state if the Stripe subscription is canceled.
   * We can expand this in the future if we want to!
   */
  syncStripeSubscription: Maybe<BillingSubscription>;
  /** Admin only:terminate never activated subscriptions */
  terminateNeverActivatedSubscriptions: Maybe<Scalars['Void']['output']>;
  /** Admin mutation for cancelling subscription in Stripe. */
  terminateStripeSubscriptionFromSoftCanceledState: Maybe<Scalars['Void']['output']>;
  updatePaymentMethod: Maybe<UpdatePaymentMethodResult>;
  /** Admin mutation for validating usage data exports. */
  validateUsageSync: Maybe<BillingPeriodUsageSyncValidationResult>;
};


export type BillingMutationconvertAnnualTeamOrgToMonthlyArgs = {
  internalAccountId: Scalars['ID']['input'];
};


export type BillingMutationcreateSetupIntentArgs = {
  internalAccountId: Scalars['ID']['input'];
};


export type BillingMutationcreateUsageExportLogFromFailedArgs = {
  usageExportLogId: Scalars['ID']['input'];
};


export type BillingMutationcreateUsageExportLogsArgs = {
  endAt: Scalars['Timestamp']['input'];
  internalAccountIds: Array<Scalars['ID']['input']>;
  startAt: Scalars['Timestamp']['input'];
};


export type BillingMutationcreateUsageExportLogsForFailedValidationIntervalsArgs = {
  billingPeriodsAgo?: InputMaybe<Scalars['Int']['input']>;
  subscriptionIds: Array<Scalars['ID']['input']>;
};


export type BillingMutationreactivateSoftCanceledSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type BillingMutationsyncRecentScaleUsageArgs = {
  hoursAgo: Scalars['Int']['input'];
};


export type BillingMutationsyncStripePlanArgs = {
  planKind: BillingPlanKind;
  planReadableId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId: Scalars['ID']['input'];
};


export type BillingMutationsyncStripeSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type BillingMutationterminateNeverActivatedSubscriptionsArgs = {
  internalAccountIds: Array<Scalars['String']['input']>;
};


export type BillingMutationterminateStripeSubscriptionFromSoftCanceledStateArgs = {
  skipUsageSyncValidation?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId: Scalars['ID']['input'];
};


export type BillingMutationupdatePaymentMethodArgs = {
  internalAccountId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type BillingMutationvalidateUsageSyncArgs = {
  billingPeriodsAgo?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export enum BillingPeriod {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  YEARLY = 'YEARLY'
}

export type BillingPeriodUsageSyncValidation = {
  __typename: 'BillingPeriodUsageSyncValidation';
  billingPeriodEndAt: Scalars['Timestamp']['output'];
  billingPeriodStartAt: Scalars['Timestamp']['output'];
  lastValidatedDruidIntervalEndAt: Scalars['Timestamp']['output'];
  lastValidatedDruidQueryExecutedAt: Maybe<Scalars['Timestamp']['output']>;
  lastValidationAt: Scalars['Timestamp']['output'];
  lastValidationSuccessful: Scalars['Boolean']['output'];
  lastValidationUsageReport: Array<JointUsageData>;
};

/** Result of validating usage data sync for a billing period */
export type BillingPeriodUsageSyncValidationResult = UsageSyncValidationFailed | UsageSyncValidationSkipped | UsageSyncValidationSucceeded;

export type BillingPlan = {
  __typename: 'BillingPlan';
  addons: Array<BillingPlanAddon>;
  /** Retrieve all capabilities for the plan */
  allCapabilities: Array<BillingPlanCapability>;
  /** Retrieve a list of all effective capability limits for this plan */
  allLimits: Array<BillingPlanLimit>;
  billingModel: BillingModel;
  billingPeriod: Maybe<BillingPeriod>;
  description: Maybe<Scalars['String']['output']>;
  /** Retrieve the limit applied to this plan for a capability */
  effectiveLimit: Maybe<Scalars['Long']['output']>;
  /** Check whether a capability is enabled for the plan */
  hasCapability: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isTrial: Scalars['Boolean']['output'];
  kind: BillingPlanKind;
  name: Scalars['String']['output'];
  /** The price of every seat */
  pricePerSeatInUsdCents: Maybe<Scalars['Int']['output']>;
  /** The price of subscribing to this plan with a quantity of 1 (currently always the case) */
  pricePerUnitInUsdCents: Scalars['Int']['output'];
  provider: Maybe<BillingProvider>;
  /** Whether the plan is accessible by all users in QueryRoot.allPlans, QueryRoot.plan, or AccountMutation.setPlan */
  public: Scalars['Boolean']['output'];
  /** @deprecated derive the range options client-side from AccountLimits.maxRangeInDays */
  ranges: Array<Scalars['String']['output']>;
  readableId: Scalars['ID']['output'];
  tier: BillingPlanTier;
};


export type BillingPlaneffectiveLimitArgs = {
  label: Scalars['String']['input'];
};


export type BillingPlanhasCapabilityArgs = {
  label: Scalars['String']['input'];
};

export type BillingPlanAddon = {
  __typename: 'BillingPlanAddon';
  id: Scalars['ID']['output'];
  pricePerUnitInUsdCents: Scalars['Int']['output'];
};

export type BillingPlanCapability = {
  __typename: 'BillingPlanCapability';
  label: Scalars['String']['output'];
  plan: BillingPlan;
  value: Scalars['Boolean']['output'];
};

/**
 * Overall class that a billing plan falls into. This is slightly more granular than BillingPlanTier
 * because it differentiates between trials, pilots, internal-only plans, etc.
 */
export enum BillingPlanKind {
  /** Original version of the default free plan that we still support but is no longer offered */
  COMMUNITY = 'COMMUNITY',
  /** Custom plan for serverless customers that is configured and billed manually in Stripe */
  DEDICATED = 'DEDICATED',
  /** 2025 entry-level paid plan, known as 'scale' internally */
  DEVELOPER = 'DEVELOPER',
  ENTERPRISE_INTERNAL = 'ENTERPRISE_INTERNAL',
  ENTERPRISE_PAID = 'ENTERPRISE_PAID',
  ENTERPRISE_PILOT = 'ENTERPRISE_PILOT',
  ENTERPRISE_TRIAL = 'ENTERPRISE_TRIAL',
  /** 2025 version of the default free plan */
  FREE = 'FREE',
  /** Placeholder for no billing plan */
  NONE = 'NONE',
  PLACEHOLDER_FREE = 'PLACEHOLDER_FREE',
  PLACEHOLDER_PAID = 'PLACEHOLDER_PAID',
  /** Sales assisted Scale plan currently configured in Recurly. */
  SCALE = 'SCALE',
  SCALE_ADVANCED = 'SCALE_ADVANCED',
  /** New Scale plans configured in Stripe. */
  SCALE_BASIC = 'SCALE_BASIC',
  SCALE_PLATFORM = 'SCALE_PLATFORM',
  /** @deprecated Part of initial 2022 serverless implementation; was never used in production */
  SERVERLESS = 'SERVERLESS',
  /** 2022 version of the 'serverless' free plan that we still support but is no longer offered */
  SERVERLESS_FREE = 'SERVERLESS_FREE',
  /** 2022 version of the 'serverless' paid plan that we still support but is no longer offered */
  SERVERLESS_PAID = 'SERVERLESS_PAID',
  /** 2025 mid-tier paid plan, known as 'scale' internally */
  STANDARD_SALES_ASSISTED = 'STANDARD_SALES_ASSISTED',
  /** 2025 mid-tier paid plan, known as 'scale' internally */
  STANDARD_SELF_SERVICE = 'STANDARD_SELF_SERVICE',
  /** Original version of the non-enterprise paid plan (configured in Recurly) that we still support but is no longer offered */
  TEAM_PAID = 'TEAM_PAID',
  /** Original version of the non-enterprise trial plan (configured in Recurly) that we still support but is no longer offered */
  TEAM_TRIAL = 'TEAM_TRIAL',
  UNKNOWN = 'UNKNOWN'
}

export type BillingPlanLimit = {
  __typename: 'BillingPlanLimit';
  label: Scalars['String']['output'];
  plan: BillingPlan;
  value: Maybe<Scalars['Long']['output']>;
};

export type BillingPlanMutation = {
  __typename: 'BillingPlanMutation';
  /** Archive this billing plan */
  archive: Maybe<Scalars['Void']['output']>;
  id: Scalars['ID']['output'];
  /** Reset the specified capability on this plan to the global default value for the capability */
  resetCapability: Maybe<BillingPlanCapability>;
  /** Reset the specified limit on this plan to the global default value for the limit */
  resetLimit: Maybe<BillingPlanLimit>;
  /** Sets the specified capability on this plan to the provided value */
  setCapability: Maybe<BillingPlanCapability>;
  /** Sets the specified limit on this plan to the provided value */
  setLimit: Maybe<BillingPlanLimit>;
  /**
   * The legacy billing plan columns for capabilities and limits are still used for some internal integrations,
   * but we do not always set them automatically, so this mutation syncs the newer values with the legacy columns.
   */
  syncEntitlementsToLegacyColumns: Maybe<Scalars['Void']['output']>;
  updateDescriptors: Maybe<BillingPlan>;
  /** Add Stripe pricing rates for this plan, and optionally remove the existing ones */
  upsertStripeRates: Maybe<Scalars['Void']['output']>;
};


export type BillingPlanMutationresetCapabilityArgs = {
  label: Scalars['String']['input'];
};


export type BillingPlanMutationresetLimitArgs = {
  label: Scalars['String']['input'];
};


export type BillingPlanMutationsetCapabilityArgs = {
  label: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type BillingPlanMutationsetLimitArgs = {
  label: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Long']['input']>;
};


export type BillingPlanMutationupdateDescriptorsArgs = {
  input?: InputMaybe<UpdateBillingPlanDescriptorsInput>;
};


export type BillingPlanMutationupsertStripeRatesArgs = {
  priceIds: Array<Scalars['String']['input']>;
  removeExisting?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BillingPlanTier {
  /** Original version of the default free plan that we still support but is no longer offered */
  COMMUNITY = 'COMMUNITY',
  DEVELOPER = 'DEVELOPER',
  ENTERPRISE = 'ENTERPRISE',
  /** 2025 version of the 'serverless' free plan */
  FREE = 'FREE',
  NONE = 'NONE',
  /** 2025 version of the 'serverless' paid plan */
  SCALE = 'SCALE',
  STANDARD = 'STANDARD',
  /** Original version of the non-enterprise paid plan (configured in Recurly) that we still support but is no longer offered */
  TEAM = 'TEAM',
  UNKNOWN = 'UNKNOWN',
  /** 2022 version of the 'serverless' free plan that we still support but is no longer offered */
  USAGE_BASED = 'USAGE_BASED'
}

export enum BillingProvider {
  APOLLO_NO_INVOICING = 'APOLLO_NO_INVOICING',
  METRONOME = 'METRONOME',
  NONE = 'NONE',
  RECURLY = 'RECURLY',
  STRIPE = 'STRIPE'
}

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  activatedAt: Scalars['Timestamp']['output'];
  addons: Array<BillingSubscriptionAddon>;
  /** Retrieve all capabilities for this subscription */
  allCapabilities: Array<SubscriptionCapability>;
  /** Retrieve a list of all effective capability limits for this subscription */
  allLimits: Array<SubscriptionLimit>;
  autoRenew: Scalars['Boolean']['output'];
  canceledAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Draft invoice for this subscription
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  currentDraftInvoice: Maybe<DraftInvoice>;
  currentPeriodEndsAt: Scalars['Timestamp']['output'];
  currentPeriodStartedAt: Scalars['Timestamp']['output'];
  /** Retrieve the limit applied to this subscription for a capability */
  effectiveLimit: Maybe<Scalars['Long']['output']>;
  expiresAt: Maybe<Scalars['Timestamp']['output']>;
  /** Renewal grace time for updating seat count */
  graceTimeForNextRenewal: Maybe<Scalars['Timestamp']['output']>;
  /** Check whether a capability is enabled for the subscription */
  hasCapability: Maybe<Scalars['Boolean']['output']>;
  meteredBillingSummary: Maybe<MeteredBillingSummary>;
  plan: BillingPlan;
  /** The price of every seat */
  pricePerSeatInUsdCents: Maybe<Scalars['Int']['output']>;
  /** The price of every unit in the subscription (hence multiplied by quantity to get to the basePriceInUsdCents) */
  pricePerUnitInUsdCents: Scalars['Int']['output'];
  /** Returns all active promotional credit grants for this subscription */
  promoCreditSummaries: Array<CreditGrant>;
  /** Returns promo credit for developer plan */
  promoCredits: Maybe<CreditGrant>;
  quantity: Scalars['Int']['output'];
  /** Total price of the subscription when it next renews, including add-ons (such as seats) */
  renewalTotalPriceInUsdCents: Scalars['Long']['output'];
  state: SubscriptionState;
  /**
   * When this subscription's trial period expires (if it is a trial). Not the same as the
   * subscription's Recurly expiration).
   */
  trialExpiresAt: Maybe<Scalars['Timestamp']['output']>;
  usageSyncValidations: Maybe<Array<BillingPeriodUsageSyncValidation>>;
  uuid: Scalars['ID']['output'];
};


export type BillingSubscriptioneffectiveLimitArgs = {
  label: Scalars['String']['input'];
};


export type BillingSubscriptionhasCapabilityArgs = {
  label: Scalars['String']['input'];
};

export type BillingSubscriptionAddon = {
  __typename: 'BillingSubscriptionAddon';
  id: Scalars['ID']['output'];
  pricePerUnitInUsdCents: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type BillingSubscriptionMutation = {
  __typename: 'BillingSubscriptionMutation';
  /** Remove the specified capability override for this subscription */
  clearCapability: Maybe<Scalars['Void']['output']>;
  /** Remove the specified limit override for this subscription */
  clearLimit: Maybe<Scalars['Void']['output']>;
  /** Sets the capability override on this subscription to the provided value */
  setCapability: Maybe<SubscriptionCapability>;
  /** Sets the limit override on this subscription to the provided value */
  setLimit: Maybe<SubscriptionLimit>;
  uuid: Scalars['ID']['output'];
};


export type BillingSubscriptionMutationclearCapabilityArgs = {
  label: Scalars['String']['input'];
};


export type BillingSubscriptionMutationclearLimitArgs = {
  label: Scalars['String']['input'];
};


export type BillingSubscriptionMutationsetCapabilityArgs = {
  label: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type BillingSubscriptionMutationsetLimitArgs = {
  label: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Long']['input']>;
};

export type BillingTier = {
  __typename: 'BillingTier';
  searchAccounts: Array<Account>;
  tier: BillingPlanTier;
};


export type BillingTiersearchAccountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Columns of BillingUsageStats. */
export enum BillingUsageStatsColumn {
  ACCOUNT_ID = 'ACCOUNT_ID',
  AGENT_ID = 'AGENT_ID',
  AGENT_VERSION = 'AGENT_VERSION',
  GRAPH_DEPLOYMENT_TYPE = 'GRAPH_DEPLOYMENT_TYPE',
  OPERATION_COUNT = 'OPERATION_COUNT',
  OPERATION_COUNT_PROVIDED_EXPLICITLY = 'OPERATION_COUNT_PROVIDED_EXPLICITLY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  ROUTER_FEATURES_ENABLED = 'ROUTER_FEATURES_ENABLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type BillingUsageStatsDimensions = {
  __typename: 'BillingUsageStatsDimensions';
  accountId: Maybe<Scalars['ID']['output']>;
  agentId: Maybe<Scalars['String']['output']>;
  agentVersion: Maybe<Scalars['String']['output']>;
  graphDeploymentType: Maybe<Scalars['String']['output']>;
  operationCountProvidedExplicitly: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  routerFeaturesEnabled: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in BillingUsageStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type BillingUsageStatsFilter = {
  /** Selects rows whose accountId dimension equals the given value if not null. To query for the null value, use {in: {accountId: [null]}} instead. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose agentId dimension equals the given value if not null. To query for the null value, use {in: {agentId: [null]}} instead. */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<BillingUsageStatsFilter>>;
  /** Selects rows whose graphDeploymentType dimension equals the given value if not null. To query for the null value, use {in: {graphDeploymentType: [null]}} instead. */
  graphDeploymentType?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<BillingUsageStatsFilterIn>;
  not?: InputMaybe<BillingUsageStatsFilter>;
  /** Selects rows whose operationCountProvidedExplicitly dimension equals the given value if not null. To query for the null value, use {in: {operationCountProvidedExplicitly: [null]}} instead. */
  operationCountProvidedExplicitly?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<BillingUsageStatsFilter>>;
  /** Selects rows whose routerFeaturesEnabled dimension equals the given value if not null. To query for the null value, use {in: {routerFeaturesEnabled: [null]}} instead. */
  routerFeaturesEnabled?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in BillingUsageStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type BillingUsageStatsFilterIn = {
  /** Selects rows whose accountId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  accountId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose agentId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose graphDeploymentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  graphDeploymentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationCountProvidedExplicitly dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationCountProvidedExplicitly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerFeaturesEnabled dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerFeaturesEnabled?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BillingUsageStatsMetrics = {
  __typename: 'BillingUsageStatsMetrics';
  operationCount: Scalars['Long']['output'];
};

export type BillingUsageStatsOrderBySpec = {
  column: BillingUsageStatsColumn;
  direction: Ordering;
};

export type BillingUsageStatsRecord = {
  __typename: 'BillingUsageStatsRecord';
  /** Dimensions of BillingUsageStats that can be grouped by. */
  groupBy: BillingUsageStatsDimensions;
  /** Metrics of BillingUsageStats that can be aggregated over. */
  metrics: BillingUsageStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export enum BillingUsageStatsWindowSize {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  NONE = 'NONE'
}

/** The building of a Studio variant (including supergraph composition and any contract filtering) as part of a launch. */
export type Build = {
  __typename: 'Build';
  /** The unique identifier for this build. */
  id: Scalars['ID']['output'];
  /** The inputs provided to the build, including subgraph and contract details. */
  input: BuildInput;
  /** The result of the build. This value is null until the build completes. */
  result: Maybe<BuildResult>;
};

export type BuildCheckFailed = {
  /** The input to the build task. */
  buildInputs: BuildInputs;
  /**
   * The build pipeline track of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  buildPipelineTrack: BuildPipelineTrack;
  /** A list of errors generated by this build. */
  errors: Array<BuildError>;
  /**
   * The Federation version of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  /** Whether the build task passed or failed. */
  passed: Scalars['Boolean']['output'];
  /** The workflow build task that generated this result. */
  workflowTask: BuildCheckTask;
};

export type BuildCheckPassed = {
  /** The input to the build task. */
  buildInputs: BuildInputs;
  /**
   * The build pipeline track of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  buildPipelineTrack: BuildPipelineTrack;
  /**
   * The Federation version of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  /** Whether the build task passed or failed. */
  passed: Scalars['Boolean']['output'];
  /** The SHA-256 of the supergraph schema document generated by this build. */
  supergraphSchemaHash: Scalars['SHA256']['output'];
  /** The workflow build task that generated this result. */
  workflowTask: BuildCheckTask;
};

export type BuildCheckResult = {
  /** The input to the build task. */
  buildInputs: BuildInputs;
  /**
   * The build pipeline track of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  buildPipelineTrack: BuildPipelineTrack;
  /**
   * The Federation version of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  /** Whether the build task passed or failed. */
  passed: Scalars['Boolean']['output'];
  /** The workflow build task that generated this result. */
  workflowTask: BuildCheckTask;
};

export type BuildCheckTask = {
  /** The result of the build check. This will be null when the task is initializing or running. */
  buildResult: Maybe<BuildCheckResult>;
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /**
   * The build input change proposed for this check workflow. Note that for triggered downstream
   *  workflows, this is not the upstream variant's proposed change, but the changes for the downstream
   * variant that are derived from the upstream workflow's results (e.g. the input supergraph schema).
   */
  proposedBuildInputChanges: ProposedBuildInputChanges;
  /**
   * The status of this task. All tasks start with the PENDING status while initializing. If any
   *  prerequisite task fails, then the task status becomes BLOCKED. Otherwise, if all prerequisite
   *  tasks pass, then this task runs (still having the PENDING status). Once the task completes, the
   *  task status will become either PASSED or FAILED.
   */
  status: CheckWorkflowTaskStatus;
  /** A studio UI url to view the details of this check workflow task */
  targetURL: Maybe<Scalars['String']['output']>;
  /** The workflow that this task belongs to. */
  workflow: CheckWorkflow;
};

/** The configuration for building a composition graph variant */
export type BuildConfig = {
  __typename: 'BuildConfig';
  buildPipelineTrack: BuildPipelineTrack;
  federationVersion: Scalars['FederationVersion']['output'];
  /** Show all uses of @tag directives to consumers in Schema Reference and Explorer */
  tagInApiSchema: Scalars['Boolean']['output'];
};

/**
 * Exactly one of the inputs must be set in a build configuration.
 * Which build configuration type is set will determine the type
 * of variant that is created. Existing variants of a given type
 * cannot be updated in-place to be of a different type.
 */
export type BuildConfigInput = {
  /** This list will contain any directives that should get passed through to the api schema from the core schema. Anything included in this list will appear in the consumer facing schema */
  apiDirectivePassThrough: Array<Scalars['String']['input']>;
  /** if buildPipelineTrack is null use the graph default */
  buildPipelineTrack?: InputMaybe<BuildPipelineTrack>;
  composition?: InputMaybe<CompositionConfigInput>;
  contract?: InputMaybe<ContractConfigInput>;
  /** if federationVersion is null use the graph default */
  federationVersion?: InputMaybe<Scalars['FederationVersion']['input']>;
};

/** A single error that occurred during the failed execution of a build. */
export type BuildError = {
  __typename: 'BuildError';
  code: Maybe<Scalars['String']['output']>;
  failedStep: Maybe<Scalars['String']['output']>;
  locations: Array<SourceLocation>;
  message: Scalars['String']['output'];
};

/** Contains the details of an executed build that failed. */
export type BuildFailure = {
  __typename: 'BuildFailure';
  errorCount: Scalars['Int']['output'];
  /** A list of all errors that occurred during the failed build. */
  errorMessages: Array<BuildError>;
};

export type BuildInput = CompositionBuildInput | FilterBuildInput;

export type BuildInputs = CompositionBuildInputs | FilterBuildInputs;

export enum BuildPipelineTrack {
  FED_1_0 = 'FED_1_0',
  FED_1_1 = 'FED_1_1',
  FED_2_0 = 'FED_2_0',
  FED_2_1 = 'FED_2_1',
  FED_2_3 = 'FED_2_3',
  FED_2_4 = 'FED_2_4',
  FED_2_5 = 'FED_2_5',
  FED_2_6 = 'FED_2_6',
  FED_2_7 = 'FED_2_7',
  FED_2_8 = 'FED_2_8',
  FED_2_9 = 'FED_2_9',
  FED_2_10 = 'FED_2_10',
  FED_2_11 = 'FED_2_11',
  /** Federation 2.12 */
  FED_2_12 = 'FED_2_12',
  /** Federation 2.13 */
  FED_2_13 = 'FED_2_13',
  /** Federation 2.14 */
  FED_2_14 = 'FED_2_14',
  /** Federation 2.15 */
  FED_2_15 = 'FED_2_15',
  FED_NEXT = 'FED_NEXT'
}

export enum BuildPipelineTrackBadge {
  DEPRECATED = 'DEPRECATED',
  EXPERIMENTAL = 'EXPERIMENTAL',
  LATEST = 'LATEST',
  LONG_TERM_SUPPORT = 'LONG_TERM_SUPPORT',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type BuildPipelineTrackDetails = {
  __typename: 'BuildPipelineTrackDetails';
  badge: Maybe<BuildPipelineTrackBadge>;
  buildPipelineTrack: BuildPipelineTrack;
  /** currently running version of composition for this track, includes patch updates */
  compositionVersion: Scalars['String']['output'];
  deprecatedAt: Maybe<Scalars['Timestamp']['output']>;
  displayName: Scalars['String']['output'];
  federationVersion: Scalars['FederationVersion']['output'];
  minimumGatewayVersion: Maybe<Scalars['String']['output']>;
  /** Minimum supported router and gateway versions. Min router   version can be null since fed 1 doesn't have router support. */
  minimumRouterVersion: Maybe<Scalars['String']['output']>;
  notSupportedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type BuildResult = BuildFailure | BuildSuccess;

export type BuildRouterVersionInput = {
  cloudRouterBranch?: InputMaybe<Scalars['String']['input']>;
  routerBranch?: InputMaybe<Scalars['String']['input']>;
  routerRepository?: InputMaybe<Scalars['String']['input']>;
};

export type BuildRouterVersionResult = BuildRouterVersionSuccess | CloudRouterTestingInvalidInputErrors;

export type BuildRouterVersionSuccess = {
  __typename: 'BuildRouterVersionSuccess';
  jobId: Scalars['ID']['output'];
};

/** Contains the details of an executed build that succeeded. */
export type BuildSuccess = {
  __typename: 'BuildSuccess';
  /** Contains the supergraph and API schemas created by composition. */
  coreSchema: CoreSchema;
};

/** The result of a failed call to PersistedQueryListMutation.startBulkDeletion when a bulk deletion job with different filter criteria is already running for this list. */
export type BulkDeletionAlreadyInProgressError = Error & {
  __typename: 'BulkDeletionAlreadyInProgressError';
  /** The ID of the already-running job. Poll PersistedQueryList.bulkDeletionStatus with this ID. */
  jobId: Scalars['ID']['output'];
  /** A human-readable description of why the bulk deletion could not be started. */
  message: Scalars['String']['output'];
};

/** A bulk deletion job that failed. */
export type BulkDeletionFailure = {
  __typename: 'BulkDeletionFailure';
  /** A human-readable description of why the job failed. */
  error: Scalars['String']['output'];
};

/** Whether an in-flight bulk deletion job is queued or actively running. */
export enum BulkDeletionJobStatus {
  /** The job is queued and has not yet started running. */
  PENDING = 'PENDING',
  /** The job is actively running. */
  RUNNING = 'RUNNING'
}

/** A bulk deletion job that has not yet finished. */
export type BulkDeletionPending = {
  __typename: 'BulkDeletionPending';
  /** The number of operations deleted so far by this job. */
  operationsDeletedSoFar: Scalars['Int']['output'];
  /** Whether the job is queued (PENDING) or running (RUNNING). */
  status: BulkDeletionJobStatus;
};

/** The status of an asynchronous bulk deletion job, as returned by PersistedQueryList.bulkDeletionStatus. */
export type BulkDeletionStatus = BulkDeletionFailure | BulkDeletionPending | BulkDeletionSuccess;

/** A bulk deletion job that finished successfully. */
export type BulkDeletionSuccess = {
  __typename: 'BulkDeletionSuccess';
  /** The build produced by this deletion job's final chunk. */
  build: Maybe<PersistedQueryListBuild>;
};

/** Cache control scope either public or private */
export enum CacheControlScope {
  /** Public scope to indicate that data is private */
  PRIVATE = 'PRIVATE',
  /** Public scope to indicate that data is public */
  PUBLIC = 'PUBLIC'
}

export enum CacheScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  UNKNOWN = 'UNKNOWN',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** The result of a failed call to PersistedQueryListMutation.delete due to linked variant(s). */
export type CannotDeleteLinkedPersistedQueryListError = Error & {
  __typename: 'CannotDeleteLinkedPersistedQueryListError';
  message: Scalars['String']['output'];
};

export type CannotModifyOperationBodyError = Error & {
  __typename: 'CannotModifyOperationBodyError';
  message: Scalars['String']['output'];
};

/** Columns of CardinalityStats. */
export enum CardinalityStatsColumn {
  CLIENT_NAME_CARDINALITY = 'CLIENT_NAME_CARDINALITY',
  CLIENT_VERSION_CARDINALITY = 'CLIENT_VERSION_CARDINALITY',
  OPERATION_SHAPE_CARDINALITY = 'OPERATION_SHAPE_CARDINALITY',
  SCHEMA_COORDINATE_CARDINALITY = 'SCHEMA_COORDINATE_CARDINALITY',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type CardinalityStatsDimensions = {
  __typename: 'CardinalityStatsDimensions';
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in CardinalityStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type CardinalityStatsFilter = {
  and?: InputMaybe<Array<CardinalityStatsFilter>>;
  in?: InputMaybe<CardinalityStatsFilterIn>;
  not?: InputMaybe<CardinalityStatsFilter>;
  or?: InputMaybe<Array<CardinalityStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in CardinalityStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type CardinalityStatsFilterIn = {
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CardinalityStatsMetrics = {
  __typename: 'CardinalityStatsMetrics';
  clientNameCardinality: Scalars['Float']['output'];
  clientVersionCardinality: Scalars['Float']['output'];
  operationShapeCardinality: Scalars['Float']['output'];
  schemaCoordinateCardinality: Scalars['Float']['output'];
};

export type CardinalityStatsOrderBySpec = {
  column: CardinalityStatsColumn;
  direction: Ordering;
};

export type CardinalityStatsRecord = {
  __typename: 'CardinalityStatsRecord';
  /** Dimensions of CardinalityStats that can be grouped by. */
  groupBy: CardinalityStatsDimensions;
  /** Metrics of CardinalityStats that can be aggregated over. */
  metrics: CardinalityStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A single change that was made to a definition in a schema. */
export type Change = {
  __typename: 'Change';
  affectedQueries: Maybe<Array<AffectedQuery>>;
  /** Target arg of change made. */
  argNode: Maybe<NamedIntrospectionArg>;
  /** Indication of the category of the change (e.g. addition, removal, edit). */
  category: ChangeCategory;
  /**
   * Node related to the top level node that was changed, such as a field in an object,
   * a value in an enum or the object of an interface.
   */
  childNode: Maybe<NamedIntrospectionValue>;
  /** Indicates the type of change that was made, and to what (e.g., 'TYPE_REMOVED'). */
  code: Scalars['String']['output'];
  /** A human-readable description of the change. */
  description: Scalars['String']['output'];
  /** Top level node affected by the change. */
  parentNode: Maybe<NamedIntrospectionType>;
  /** The severity of the change (e.g., `FAILURE` or `NOTICE`) */
  severity: ChangeSeverity;
  /** Short description of the change */
  shortDescription: Maybe<Scalars['String']['output']>;
  /**
   * Indication of the success of the overall change, either failure, warning, or notice.
   * @deprecated use severity instead
   */
  type: ChangeType;
};

/**
 * Defines a set of categories that a schema change
 * can be grouped by.
 */
export enum ChangeCategory {
  ADDITION = 'ADDITION',
  DEPRECATION = 'DEPRECATION',
  EDIT = 'EDIT',
  REMOVAL = 'REMOVAL'
}

/**
 * These schema change codes represent all of the possible changes that can
 * occur during the schema diff algorithm.
 */
export enum ChangeCode {
  /** Type of the argument was changed. */
  ARG_CHANGED_TYPE = 'ARG_CHANGED_TYPE',
  /** Argument was changed from nullable to non-nullable. */
  ARG_CHANGED_TYPE_OPTIONAL_TO_REQUIRED = 'ARG_CHANGED_TYPE_OPTIONAL_TO_REQUIRED',
  /** Default value added or changed for the argument. */
  ARG_DEFAULT_VALUE_CHANGE = 'ARG_DEFAULT_VALUE_CHANGE',
  /** Description was added, removed, or updated for argument. */
  ARG_DESCRIPTION_CHANGE = 'ARG_DESCRIPTION_CHANGE',
  /** Argument to a field was removed. */
  ARG_REMOVED = 'ARG_REMOVED',
  /** Argument to the directive was removed. */
  DIRECTIVE_ARG_REMOVED = 'DIRECTIVE_ARG_REMOVED',
  /** Location of the directive was removed. */
  DIRECTIVE_LOCATION_REMOVED = 'DIRECTIVE_LOCATION_REMOVED',
  /** Directive was removed. */
  DIRECTIVE_REMOVED = 'DIRECTIVE_REMOVED',
  /** Repeatable flag was removed for directive. */
  DIRECTIVE_REPEATABLE_REMOVED = 'DIRECTIVE_REPEATABLE_REMOVED',
  /** Enum was deprecated. */
  ENUM_DEPRECATED = 'ENUM_DEPRECATED',
  /** Reason for enum deprecation changed. */
  ENUM_DEPRECATED_REASON_CHANGE = 'ENUM_DEPRECATED_REASON_CHANGE',
  /** Enum deprecation was removed. */
  ENUM_DEPRECATION_REMOVED = 'ENUM_DEPRECATION_REMOVED',
  /** Description was added, removed, or updated for enum value. */
  ENUM_VALUE_DESCRIPTION_CHANGE = 'ENUM_VALUE_DESCRIPTION_CHANGE',
  /** Field was added to the type. */
  FIELD_ADDED = 'FIELD_ADDED',
  /** Return type for the field was changed. */
  FIELD_CHANGED_TYPE = 'FIELD_CHANGED_TYPE',
  /** Field was deprecated. */
  FIELD_DEPRECATED = 'FIELD_DEPRECATED',
  /** Reason for field deprecation changed. */
  FIELD_DEPRECATED_REASON_CHANGE = 'FIELD_DEPRECATED_REASON_CHANGE',
  /** Field deprecation removed. */
  FIELD_DEPRECATION_REMOVED = 'FIELD_DEPRECATION_REMOVED',
  /** Description was added, removed, or updated for field. */
  FIELD_DESCRIPTION_CHANGE = 'FIELD_DESCRIPTION_CHANGE',
  /** Type of the field in the input object was changed. */
  FIELD_ON_INPUT_OBJECT_CHANGED_TYPE = 'FIELD_ON_INPUT_OBJECT_CHANGED_TYPE',
  /** Field was removed from the type. */
  FIELD_REMOVED = 'FIELD_REMOVED',
  /** Field was removed from the input object. */
  FIELD_REMOVED_FROM_INPUT_OBJECT = 'FIELD_REMOVED_FROM_INPUT_OBJECT',
  /** A default value was added to an input object field. */
  INPUT_OBJECT_FIELD_DEFAULT_VALUE_ADDED = 'INPUT_OBJECT_FIELD_DEFAULT_VALUE_ADDED',
  /** The default value of an input object field was changed. */
  INPUT_OBJECT_FIELD_DEFAULT_VALUE_CHANGE = 'INPUT_OBJECT_FIELD_DEFAULT_VALUE_CHANGE',
  /** The default value of an input object field was removed. */
  INPUT_OBJECT_FIELD_DEFAULT_VALUE_REMOVED = 'INPUT_OBJECT_FIELD_DEFAULT_VALUE_REMOVED',
  /** Non-nullable field was added to the input object. (Deprecated.) */
  NON_NULLABLE_FIELD_ADDED_TO_INPUT_OBJECT = 'NON_NULLABLE_FIELD_ADDED_TO_INPUT_OBJECT',
  /** Nullable field was added to the input type. (Deprecated.) */
  NULLABLE_FIELD_ADDED_TO_INPUT_OBJECT = 'NULLABLE_FIELD_ADDED_TO_INPUT_OBJECT',
  /** Nullable argument was added to the field. */
  OPTIONAL_ARG_ADDED = 'OPTIONAL_ARG_ADDED',
  /** Optional field was added to the input type. */
  OPTIONAL_FIELD_ADDED_TO_INPUT_OBJECT = 'OPTIONAL_FIELD_ADDED_TO_INPUT_OBJECT',
  /** Non-nullable argument was added to the field. */
  REQUIRED_ARG_ADDED = 'REQUIRED_ARG_ADDED',
  /** Non-nullable argument added to directive. */
  REQUIRED_DIRECTIVE_ARG_ADDED = 'REQUIRED_DIRECTIVE_ARG_ADDED',
  /** Required field was added to the input object. */
  REQUIRED_FIELD_ADDED_TO_INPUT_OBJECT = 'REQUIRED_FIELD_ADDED_TO_INPUT_OBJECT',
  /** Type was added to the schema. */
  TYPE_ADDED = 'TYPE_ADDED',
  /** Type now implements the interface. */
  TYPE_ADDED_TO_INTERFACE = 'TYPE_ADDED_TO_INTERFACE',
  /** A new value was added to the enum. */
  TYPE_ADDED_TO_UNION = 'TYPE_ADDED_TO_UNION',
  /**
   * Type was changed from one kind to another.
   * Ex: scalar to object or enum to union.
   */
  TYPE_CHANGED_KIND = 'TYPE_CHANGED_KIND',
  /** Description was added, removed, or updated for type. */
  TYPE_DESCRIPTION_CHANGE = 'TYPE_DESCRIPTION_CHANGE',
  /** Type (object or scalar) was removed from the schema. */
  TYPE_REMOVED = 'TYPE_REMOVED',
  /** Type no longer implements the interface. */
  TYPE_REMOVED_FROM_INTERFACE = 'TYPE_REMOVED_FROM_INTERFACE',
  /** Type is no longer included in the union. */
  TYPE_REMOVED_FROM_UNION = 'TYPE_REMOVED_FROM_UNION',
  /** A new value was added to the enum. */
  VALUE_ADDED_TO_ENUM = 'VALUE_ADDED_TO_ENUM',
  /** Value was removed from the enum. */
  VALUE_REMOVED_FROM_ENUM = 'VALUE_REMOVED_FROM_ENUM'
}

/**
 * Represents the tuple of static information
 * about a particular kind of schema change.
 */
export type ChangeDefinition = {
  __typename: 'ChangeDefinition';
  category: ChangeCategory;
  code: ChangeCode;
  defaultSeverity: ChangeSeverity;
};

/** Info about a change in the context of an operation it affects */
export type ChangeOnOperation = {
  __typename: 'ChangeOnOperation';
  /**
   * Human-readable explanation of the impact of this change on the operation
   * @deprecated No longer maintained
   */
  impact: Maybe<Scalars['String']['output']>;
  /** The semantic info about this change, i.e. info about the change that doesn't depend on the operation */
  semanticChange: SemanticChange;
};

export type ChangeProposalComment = {
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** true if the schemaCoordinate this comment is on doesn't exist in the diff between the most recent revision & the base sdl */
  outdated: Scalars['Boolean']['output'];
  schemaCoordinate: Scalars['String']['output'];
  /** '#@!api!@#' for api schema, '#@!supergraph!@#' for supergraph schema, subgraph otherwise */
  schemaScope: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export enum ChangeSeverity {
  FAILURE = 'FAILURE',
  NOTICE = 'NOTICE'
}

/**
 * Summary of the changes for a schema diff, computed by placing the changes into categories and then
 * counting the size of each category. This categorization can be done in different ways, and
 * accordingly there are multiple fields here for each type of categorization.
 *
 * Note that if an object or interface field is added/removed, there won't be any addition/removal
 * changes generated for its arguments or @deprecated usages. If an enum type is added/removed, there
 * will be addition/removal changes generated for its values, but not for those values' @deprecated
 * usages. Description changes won't be generated for a schema element if that element (or an
 * ancestor) was added/removed.
 */
export type ChangeSummary = {
  __typename: 'ChangeSummary';
  /** Counts for changes to fields of objects, input objects, and interfaces. */
  field: FieldChangeSummaryCounts;
  /** Counts for all changes. */
  total: TotalChangeSummaryCounts;
  /**
   * Counts for changes to non-field aspects of objects, input objects, and interfaces,
   * and all aspects of enums, unions, and scalars.
   */
  type: TypeChangeSummaryCounts;
};

export enum ChangeType {
  FAILURE = 'FAILURE',
  NOTICE = 'NOTICE'
}

/** An addition made to a Studio variant's changelog after a launch. */
export type ChangelogLaunchResult = {
  __typename: 'ChangelogLaunchResult';
  createdAt: Scalars['Timestamp']['output'];
  schemaTagID: Scalars['ID']['output'];
};

/** Destination for notifications */
export type Channel = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subscriptions: Array<ChannelSubscription>;
};

export type ChannelSubscription = {
  channels: Array<Channel>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

/** Graph-level configuration of checks. */
export type CheckConfiguration = {
  __typename: 'CheckConfiguration';
  /** Time when check configuration was created */
  createdAt: Scalars['Timestamp']['output'];
  /**
   * During operation checks, if this option is enabled, the check will not fail or
   * mark any operations as broken/changed if the default value has changed, only
   * if the default value is removed completely.
   */
  downgradeDefaultValueChange: Scalars['Boolean']['output'];
  /**
   * During operation checks, if this option is enabled, it evaluates a check
   * run against zero operations as a pass instead of a failure.
   */
  downgradeStaticChecks: Scalars['Boolean']['output'];
  enableCustomChecks: Scalars['Boolean']['output'];
  /** Whether to run Linting during schema checks. */
  enableLintChecks: Scalars['Boolean']['output'];
  /** Clients to ignore during validation */
  excludedClients: Array<ClientFilter>;
  /** Operation names to ignore during validation */
  excludedOperationNames: Maybe<Array<Maybe<OperationNameFilter>>>;
  /** Operations to ignore during validation */
  excludedOperations: Array<ExcludedOperation>;
  /** Graph that this check configuration belongs to */
  graphID: Scalars['ID']['output'];
  /** ID of the check configuration */
  id: Scalars['ID']['output'];
  /** Default configuration to include operations on the base variant. */
  includeBaseVariant: Scalars['Boolean']['output'];
  /** Variant overrides for validation */
  includedVariants: Array<Scalars['String']['output']>;
  /** Minimum number of requests within the window for an operation to be considered. */
  operationCountThreshold: Scalars['Int']['output'];
  /**
   * Number of requests within the window for an operation to be considered, relative to
   * total request count. Expected values are between 0 and 0.05 (minimum 5% of
   * total request volume)
   */
  operationCountThresholdPercentage: Scalars['Float']['output'];
  /** How submitted build input diffs are handled when they match (or don't) a Proposal */
  proposalChangeMismatchSeverity: ProposalChangeMismatchSeverity;
  /**
   * Only check operations from the last <timeRangeSeconds> seconds.
   * The default is 7 days (604,800 seconds).
   */
  timeRangeSeconds: Scalars['Long']['output'];
  /** Time when check configuration was last updated */
  updatedAt: Scalars['Timestamp']['output'];
  /** Identity of the last user to update the check configuration */
  updatedBy: Maybe<Identity>;
};

/** Filter options available when listing checks. */
export type CheckFilterInput = {
  /** A list of git commiters. For cli triggered checks, this is the author. */
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  branches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of actors triggering this check. For non cli triggered checks, this is the Studio User / author. */
  createdBy?: InputMaybe<Array<ActorInput>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeProposalChecks?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CheckFilterInputStatusOption>;
  subgraphs?: InputMaybe<Array<Scalars['String']['input']>>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Options for filtering CheckWorkflows by status
 * This should always match CheckWorkflowStatus
 */
export enum CheckFilterInputStatusOption {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  PENDING = 'PENDING'
}

/** The result of performing a subgraph check, including all steps. */
export type CheckPartialSchemaResult = {
  __typename: 'CheckPartialSchemaResult';
  /** Overall result of the check. This will be null if composition validation was unsuccessful. */
  checkSchemaResult: Maybe<CheckSchemaResult>;
  /** Result of compostion run as part of the overall subgraph check. */
  compositionValidationResult: CompositionValidationResult;
  /** Whether any modifications were detected in the composed core schema. */
  coreSchemaModified: Scalars['Boolean']['output'];
  /** Check workflow associated with the overall subgraph check. */
  workflow: Maybe<CheckWorkflow>;
};

/** The possible results of a request to initiate schema checks (either a success object or one of multiple `Error` objects). */
export type CheckRequestResult = CheckRequestSuccess | InvalidInputError | PermissionError | PlanError | RateLimitExceededError;

/** Represents a successfully initiated execution of schema checks. This does not indicate the _result_ of the checks, only that they were initiated. */
export type CheckRequestSuccess = {
  __typename: 'CheckRequestSuccess';
  /** The URL of the Apollo Studio page for this check. */
  targetURL: Scalars['String']['output'];
  /** The unique ID for this execution of schema checks. */
  workflowID: Scalars['ID']['output'];
};

/** Input type to provide when running schema checks asynchronously for a non-federated graph. */
export type CheckSchemaAsyncInput = {
  /** Configuration options for the check execution. */
  config: HistoricQueryParametersInput;
  /** The GitHub context to associate with the check. */
  gitContext: GitContextInput;
  /** @deprecated This field is not required to be sent anymore */
  graphRef?: InputMaybe<Scalars['ID']['input']>;
  /** The URL of the GraphQL endpoint that Apollo Sandbox introspected to obtain the proposed schema. Required if `isSandbox` is `true`. */
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** If `true`, the check was initiated automatically by a Proposal update. */
  isProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the check was initiated by Apollo Sandbox. */
  isSandbox: Scalars['Boolean']['input'];
  proposedSchemaDocument?: InputMaybe<Scalars['String']['input']>;
};

/** The result of running schema checks on a graph variant. */
export type CheckSchemaResult = {
  __typename: 'CheckSchemaResult';
  /** The schema diff and affected operations generated by the schema check. */
  diffToPrevious: SchemaDiff;
  /** The unique ID of this execution of checks. */
  operationsCheckID: Scalars['ID']['output'];
  /** The URL to view the schema diff in Studio. */
  targetUrl: Maybe<Scalars['String']['output']>;
  /** Workflow associated with this check result */
  workflow: Maybe<CheckWorkflow>;
};

export type CheckStepCompleted = {
  __typename: 'CheckStepCompleted';
  id: Scalars['ID']['output'];
  status: CheckStepStatus;
};

export type CheckStepFailed = {
  __typename: 'CheckStepFailed';
  message: Scalars['String']['output'];
};

export type CheckStepInput = {
  graphID: Scalars['String']['input'];
  graphVariant: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
  workflowID: Scalars['ID']['input'];
};

export type CheckStepResult = CheckStepCompleted | CheckStepFailed | PermissionError | ValidationError;

export enum CheckStepStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

/** An individual diagnostic violation of a custom check task. */
export type CheckViolation = {
  __typename: 'CheckViolation';
  /**
   * The schema coordinate of this rule violation as defined by RFC:
   * 		https://github.com/graphql/graphql-wg/blob/main/rfcs/SchemaCoordinates.md
   * 		Optional for violations that aren't specific to a single schema element
   */
  coordinate: Maybe<Scalars['String']['output']>;
  /** The violation level for the rule. */
  level: ViolationLevel;
  /** A human-readable message describing the rule violation, rendered as markdown in Apollo Studio. Maximum length: 512 characters. */
  message: Scalars['String']['output'];
  /** The rule being violated. This is used to group multiple violations together in Studio. Max character length is 128. */
  rule: Scalars['String']['output'];
  /** The start and end position in the file of the rule violation. Used to display rule violations in the context of your schema diff. */
  sourceLocations: Maybe<Array<FileLocation>>;
};

/** An individual diagnostic violation of a custom check task. */
export type CheckViolationInput = {
  /**
   * The schema coordinate of this rule violation as defined by RFC:
   * 		https://github.com/graphql/graphql-wg/blob/main/rfcs/SchemaCoordinates.md
   * 		Optional for violations that aren't specific to a single schema element
   */
  coordinate?: InputMaybe<Scalars['String']['input']>;
  /** The violation level for the rule. */
  level: ViolationLevel;
  /** A human-readable message describing the rule violation, rendered as markdown in Apollo Studio. Maximum length: 512 characters. */
  message: Scalars['String']['input'];
  /** The rule being violated. This is used to group multiple violations together in Studio. Max character length is 128. */
  rule: Scalars['String']['input'];
  /** The start and end position in the file of the rule violation. Used to display rule violations in the context of your schema diff. */
  sourceLocations?: InputMaybe<Array<FileLocationInput>>;
};

export type CheckWorkflow = {
  __typename: 'CheckWorkflow';
  /** The supergraph schema provided as the base to check against. */
  baseSchemaHash: Maybe<Scalars['String']['output']>;
  /** The base subgraphs provided as the base to check against. */
  baseSubgraphs: Maybe<Array<Subgraph>>;
  /**
   * The variant provided as a base to check against. Only the differences from the
   * base schema will be tested in operations checks.
   */
  baseVariant: Maybe<GraphVariant>;
  /** The build task associated with this workflow, or null if no such task was scheduled. */
  buildTask: Maybe<BuildCheckTask>;
  /** The timestamp when the check workflow completed. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  /** The downstream task associated with this workflow, or null if no such task kind was scheduled. */
  downstreamTask: Maybe<DownstreamCheckTask>;
  /** Contextual parameters supplied by the runtime environment where the check was run. */
  gitContext: Maybe<GitContext>;
  /** The graph this check workflow belongs to. */
  graph: Service;
  id: Scalars['ID']['output'];
  /** The name of the implementing service that was responsible for triggering the validation. */
  implementingServiceName: Maybe<Scalars['String']['output']>;
  /** If this check is triggered for an sdl fetched using introspection, this is the endpoint where that schema was being served. */
  introspectionEndpoint: Maybe<Scalars['String']['output']>;
  /** Only true if the check was triggered from a proposal update. */
  isProposalCheck: Scalars['Boolean']['output'];
  /** Only true if the check was triggered from Sandbox Checks page. */
  isSandboxCheck: Scalars['Boolean']['output'];
  /** The operations task associated with this workflow, or null if no such task was scheduled. */
  operationsTask: Maybe<OperationsCheckTask>;
  /** If this check came from a proposal, this is the revision that triggered the check. */
  proposalRevision: Maybe<ProposalRevision>;
  /** The proposed supergraph schema being checked by this check workflow. */
  proposedSchemaHash: Maybe<Scalars['String']['output']>;
  /** The proposed subgraphs for this check workflow. */
  proposedSubgraphs: Maybe<Array<Subgraph>>;
  /** If this check was created by rerunning, the original check workflow that was rerun. */
  rerunOf: Maybe<CheckWorkflow>;
  /** Checks created by re-running this check, most recent first. */
  reruns: Maybe<Array<CheckWorkflow>>;
  /** The timestamp when the check workflow started. */
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Overall status of the workflow, based on the underlying task statuses. */
  status: CheckWorkflowStatus;
  /** The names of the subgraphs with changes that triggered the validation. */
  subgraphNames: Array<Scalars['String']['output']>;
  /** The set of check tasks associated with this workflow, e.g. composition, operations, etc. */
  tasks: Array<CheckWorkflowTask>;
  /** Identity of the user who ran this check */
  triggeredBy: Maybe<Identity>;
  /** The upstream workflow that triggered this workflow, or null if such an upstream workflow does not exist. */
  upstreamWorkflow: Maybe<CheckWorkflow>;
  /** Configuration of validation at the time the check was run. */
  validationConfig: Maybe<SchemaDiffValidationConfig>;
};


export type CheckWorkflowrerunsArgs = {
  limit: Scalars['Int']['input'];
};

export type CheckWorkflowMutation = {
  __typename: 'CheckWorkflowMutation';
  /** The graph this check workflow belongs to. */
  graph: Service;
  id: Scalars['ID']['output'];
  /**
   * Re-run a check workflow using the current check configuration. The result is either a workflow ID that
   * can be used to check the status or an error message that explains what went wrong.
   */
  rerunAsync: CheckRequestResult;
};


export type CheckWorkflowMutationrerunAsyncArgs = {
  input?: InputMaybe<RerunAsyncInput>;
};

export enum CheckWorkflowStatus {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  PENDING = 'PENDING'
}

export type CheckWorkflowTask = {
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /**
   * The status of this task. All tasks start with the PENDING status while initializing. If any
   *  prerequisite task fails, then the task status becomes BLOCKED. Otherwise, if all prerequisite
   *  tasks pass, then this task runs (still having the PENDING status). Once the task completes, the
   *  task status will become either PASSED or FAILED.
   */
  status: CheckWorkflowTaskStatus;
  /** A studio UI url to view the details of this check workflow task */
  targetURL: Maybe<Scalars['String']['output']>;
  /** The workflow that this task belongs to. */
  workflow: CheckWorkflow;
};

export enum CheckWorkflowTaskStatus {
  BLOCKED = 'BLOCKED',
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  PENDING = 'PENDING'
}

/** A client to be filtered. */
export type ClientFilter = {
  __typename: 'ClientFilter';
  /** Name of the client is required. */
  name: Scalars['String']['output'];
  /** Version string of the client. */
  version: Maybe<Scalars['String']['output']>;
};

/**
 * Options to filter by client reference ID, client name, and client version.
 * If passing client version, make sure to either provide a client reference ID or client name.
 */
export type ClientFilterInput = {
  /** name of the client set by the user and reported alongside metrics */
  name: Scalars['String']['input'];
  /** version of the client set by the user and reported alongside metrics */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Filter options to exclude by client reference ID, client name, and client version. */
export type ClientInfoFilter = {
  name: Scalars['String']['input'];
  /** Ignored */
  referenceID?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Filter options to exclude clients. Used as an output type for SchemaDiffValidationConfig. */
export type ClientInfoFilterOutput = {
  __typename: 'ClientInfoFilterOutput';
  name: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

/** Cloud queries */
export type Cloud = {
  __typename: 'Cloud';
  /** Return a given RouterConfigVersion */
  configVersion: Maybe<RouterConfigVersion>;
  /** Return all RouterConfigVersions */
  configVersions: Array<RouterConfigVersion>;
  /** Cloud Router constants */
  constants: CloudConstants;
  order: Maybe<Order>;
  /** The regions where a cloud router can be deployed */
  regions: Array<RegionDescription>;
  /** Return the Cloud Router associated with the provided graphRef */
  router: Maybe<Router>;
  /** Retrieve a Cloud Router by its internal ID */
  routerByInternalId: Maybe<Router>;
  /** Retrieve all routers */
  routers: Array<Router>;
  /** Return the Shard associated with the provided id */
  shard: Maybe<Shard>;
  /** Return all Shards */
  shards: Array<Shard>;
  /** Information about a specific Cloud Router version */
  version: RouterVersionResult;
  /** A list of Cloud Router versions */
  versions: RouterVersionsResult;
};


/** Cloud queries */
export type CloudconfigVersionArgs = {
  name: Scalars['String']['input'];
};


/** Cloud queries */
export type CloudconfigVersionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Cloud queries */
export type CloudorderArgs = {
  orderId: Scalars['String']['input'];
};


/** Cloud queries */
export type CloudregionsArgs = {
  provider: CloudProvider;
  tier?: InputMaybe<CloudTier>;
};


/** Cloud queries */
export type CloudrouterArgs = {
  id: Scalars['ID']['input'];
};


/** Cloud queries */
export type CloudrouterByInternalIdArgs = {
  internalId: Scalars['ID']['input'];
};


/** Cloud queries */
export type CloudroutersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<RouterStatus>>;
};


/** Cloud queries */
export type CloudshardArgs = {
  id: Scalars['ID']['input'];
};


/** Cloud queries */
export type CloudshardsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<CloudProvider>;
  tier?: InputMaybe<CloudTier>;
};


/** Cloud queries */
export type CloudversionArgs = {
  version: Scalars['String']['input'];
};


/** Cloud queries */
export type CloudversionsArgs = {
  input: RouterVersionsInput;
};

/** Constants for Cloud Routers */
export type CloudConstants = {
  __typename: 'CloudConstants';
  /** Minimum duration between last request and auto-deleting a Serverless Cloud Router */
  durationBeforeDeleteSecs: Scalars['Int']['output'];
  /**
   * Minimum duration between last request and the auto-delete warning for a Serverless
   * Cloud Router
   */
  durationBeforeDeleteWarningSecs: Scalars['Int']['output'];
  /** Minimum duration between last request and auto-pausing a Serverless Cloud Router */
  durationBeforeSleepSecs: Scalars['Int']['output'];
  /**
   * Minimum duration between last request and the auto-pause warning for a Serverless
   * Cloud Router
   */
  durationBeforeSleepWarningSecs: Scalars['Int']['output'];
};

/** Invalid input error */
export type CloudInvalidInputError = {
  __typename: 'CloudInvalidInputError';
  /** Argument related to the error */
  argument: Scalars['String']['output'];
  /** Location of the error */
  location: Maybe<Scalars['String']['output']>;
  /** Reason for the error */
  reason: Scalars['String']['output'];
};

/** Cloud mutations */
export type CloudMutation = {
  __typename: 'CloudMutation';
  /** Create a new RouterConfigVersion */
  createConfigVersion: RouterVersionConfigResult;
  /** Create a new Cloud Router */
  createRouter: CreateRouterResult;
  /** Create a new Shard */
  createShard: ShardResult;
  /** Create a new router version */
  createVersion: CreateRouterVersionResult;
  /** Destroy an existing Cloud Router */
  destroyRouter: DestroyRouterResult;
  order: Maybe<OrderMutation>;
  /** Fetch a Cloud Router for mutations */
  router: Maybe<RouterMutation>;
  /** Update a RouterConfigVersion */
  updateConfigVersion: RouterVersionConfigResult;
  /** Update an existing Cloud Router */
  updateRouter: UpdateRouterResult;
  /** Update an existing Shard */
  updateShard: ShardResult;
  /** Update an existing router version */
  updateVersion: UpdateRouterVersionResult;
};


/** Cloud mutations */
export type CloudMutationcreateConfigVersionArgs = {
  input: RouterConfigVersionInput;
};


/** Cloud mutations */
export type CloudMutationcreateRouterArgs = {
  id: Scalars['ID']['input'];
  input: CreateRouterInput;
};


/** Cloud mutations */
export type CloudMutationcreateShardArgs = {
  input: CreateShardInput;
};


/** Cloud mutations */
export type CloudMutationcreateVersionArgs = {
  version: RouterVersionCreateInput;
};


/** Cloud mutations */
export type CloudMutationdestroyRouterArgs = {
  id: Scalars['ID']['input'];
};


/** Cloud mutations */
export type CloudMutationorderArgs = {
  orderId: Scalars['String']['input'];
};


/** Cloud mutations */
export type CloudMutationrouterArgs = {
  id: Scalars['ID']['input'];
};


/** Cloud mutations */
export type CloudMutationupdateConfigVersionArgs = {
  input: RouterConfigVersionInput;
};


/** Cloud mutations */
export type CloudMutationupdateRouterArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouterInput;
};


/** Cloud mutations */
export type CloudMutationupdateShardArgs = {
  input: UpdateShardInput;
};


/** Cloud mutations */
export type CloudMutationupdateVersionArgs = {
  version: RouterVersionUpdateInput;
};

/** Cloud onboarding information */
export type CloudOnboarding = {
  __typename: 'CloudOnboarding';
  /** Graph variant reference for Cloud Onboarding */
  graphRef: Scalars['String']['output'];
  /** Cloud provider for Cloud Onboarding */
  provider: CloudProvider;
  /** Region for Cloud Onboarding */
  region: RegionDescription;
  /** Tier for Cloud Onboarding */
  tier: CloudTier;
};

/** Input to create a new Cloud Onboarding */
export type CloudOnboardingInput = {
  /** graph variant name for the onboarding */
  graphRef: Scalars['String']['input'];
  /** The cloud provider */
  provider: CloudProvider;
  /** Region for the Cloud Onboarding */
  region: Scalars['String']['input'];
  /** Tier for the Cloud Onboarding */
  tier: CloudTier;
};

/** List of supported cloud providers */
export enum CloudProvider {
  /** Amazon Web Services */
  AWS = 'AWS',
  /** Fly.io */
  FLY = 'FLY'
}

/** Generic input error */
export type CloudRouterTestingInvalidInputErrors = {
  __typename: 'CloudRouterTestingInvalidInputErrors';
  errors: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CloudRouterTestingToolPaginationInput = {
  cursor?: InputMaybe<Scalars['Cursor']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CloudTesting = {
  __typename: 'CloudTesting';
  routerVersionBuild: Maybe<RouterVersionBuildResult>;
  routerVersionBuilds: RouterVersionBuildPageResults;
  testRouter: Maybe<TestRouter>;
};


export type CloudTestingrouterVersionBuildArgs = {
  id: Scalars['ID']['input'];
};


export type CloudTestingrouterVersionBuildsArgs = {
  input: RouterVersionBuildsInput;
};


export type CloudTestingtestRouterArgs = {
  id: Scalars['ID']['input'];
};

export type CloudTestingMutation = {
  __typename: 'CloudTestingMutation';
  buildRouterVersion: BuildRouterVersionResult;
  cancelAllRouterVersionBuilds: Scalars['Boolean']['output'];
  cancelRouterVersionBuild: Scalars['Boolean']['output'];
  deleteAllRouterLaunches: Scalars['Boolean']['output'];
  deleteAllRouterVersionBuilds: Scalars['Boolean']['output'];
  deleteTestRouter: DeleteTestRouterResult;
  launchTestRouter: LaunchTestRouterResult;
};


export type CloudTestingMutationbuildRouterVersionArgs = {
  input: BuildRouterVersionInput;
};


export type CloudTestingMutationcancelRouterVersionBuildArgs = {
  id: Scalars['ID']['input'];
};


export type CloudTestingMutationdeleteTestRouterArgs = {
  id: Scalars['ID']['input'];
};


export type CloudTestingMutationlaunchTestRouterArgs = {
  input: LaunchTestRouterInput;
};

/** Cloud Router tiers */
export enum CloudTier {
  /** Dedicated tier */
  DEDICATED = 'DEDICATED',
  /** Enterprise Cloud tier */
  ENTERPRISE = 'ENTERPRISE',
  /** Serverless tier */
  SERVERLESS = 'SERVERLESS'
}

/** Validation result */
export type CloudValidationResult = CloudValidationSuccess | InternalServerError | InvalidInputErrors;

/** Config validation success */
export type CloudValidationSuccess = {
  __typename: 'CloudValidationSuccess';
  message: Scalars['String']['output'];
};

export type CommentFilter = {
  schemaScope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CommentStatus>>;
  type: Array<CommentType>;
};

export enum CommentStatus {
  DELETED = 'DELETED',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED'
}

export enum CommentType {
  CHANGE = 'CHANGE',
  GENERAL = 'GENERAL',
  REVIEW = 'REVIEW'
}

export enum ComparisonOperator {
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  NOT_EQUALS = 'NOT_EQUALS',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** The result of starting an async composeAndFilterPreview build. Use the buildID to poll composeAndFilterPreviewStatus for the outcome. */
export type ComposeAndFilterPreviewAsyncBuild = {
  __typename: 'ComposeAndFilterPreviewAsyncBuild';
  /** The ID of the started preview build. Poll composeAndFilterPreviewStatus with this ID for results. */
  buildID: Scalars['ID']['output'];
};

export type ComposeAndFilterPreviewBuildResults = {
  __typename: 'ComposeAndFilterPreviewBuildResults';
  /** The API schema document/SDL generated from composition/filtering. */
  apiSchemaDocument: Scalars['String']['output'];
  /** The supergraph core schema document/SDL generated from composition/filtering. */
  supergraphSchemaDocument: Scalars['String']['output'];
};

export type ComposeAndFilterPreviewComposeError = {
  __typename: 'ComposeAndFilterPreviewComposeError';
  /** A machine-readable error code. See https://www.apollographql.com/docs/federation/errors/for more info. */
  code: Maybe<Scalars['String']['output']>;
  /** The step at which composition failed. */
  failedStep: Maybe<Scalars['String']['output']>;
  /** Source locations related to the error. */
  locations: Maybe<Array<SourceLocation>>;
  /** A human-readable message describing the error. */
  message: Scalars['String']['output'];
};

export type ComposeAndFilterPreviewComposeFailure = {
  __typename: 'ComposeAndFilterPreviewComposeFailure';
  /** The list of errors from failed composition. */
  composeErrors: Array<ComposeAndFilterPreviewComposeError>;
};

export type ComposeAndFilterPreviewFilterError = {
  __typename: 'ComposeAndFilterPreviewFilterError';
  /** The step at which filtering failed. See https://www.apollographql.com/docs/studio/contracts/#contract-errors for more info. */
  failedStep: Maybe<Scalars['String']['output']>;
  /** A human-readable message describing the error. */
  message: Scalars['String']['output'];
};

export type ComposeAndFilterPreviewFilterFailure = {
  __typename: 'ComposeAndFilterPreviewFilterFailure';
  /** The results from successful composition. */
  composeResults: ComposeAndFilterPreviewBuildResults;
  /** The list of errors from failed filtering. */
  filterErrors: Array<ComposeAndFilterPreviewFilterError>;
};

/** Returned by composeAndFilterPreviewStatus while the async preview build is still in progress. */
export type ComposeAndFilterPreviewPending = {
  __typename: 'ComposeAndFilterPreviewPending';
  /** The ID of the in-flight preview build. */
  buildID: Scalars['ID']['output'];
  /** Whether the build is queued (PENDING) or executing (RUNNING). */
  status: ComposeAndFilterPreviewPendingStatus;
};

/** Whether an in-flight async composeAndFilterPreview build is queued or actively executing. */
export enum ComposeAndFilterPreviewPendingStatus {
  /** The build is queued and has not yet started executing. */
  PENDING = 'PENDING',
  /** The build is actively executing. */
  RUNNING = 'RUNNING'
}

export type ComposeAndFilterPreviewResult = ComposeAndFilterPreviewComposeFailure | ComposeAndFilterPreviewFilterFailure | ComposeAndFilterPreviewSuccess;

/** The result of polling an async composeAndFilterPreview build: still pending/running, or the terminal compose/filter outcome. */
export type ComposeAndFilterPreviewStatus = ComposeAndFilterPreviewComposeFailure | ComposeAndFilterPreviewFilterFailure | ComposeAndFilterPreviewPending | ComposeAndFilterPreviewSuccess;

export type ComposeAndFilterPreviewSubgraphChange = {
  /**
   * The info being changed in the named subgraph. If null, indicates that the named
   *  subgraph should be removed prior to composition.
   */
  info?: InputMaybe<ComposeAndFilterPreviewSubgraphChangeInfo>;
  /** The name of the subgraph being changed. */
  name: Scalars['String']['input'];
};

export type ComposeAndFilterPreviewSubgraphChangeInfo = {
  /**
   * The routing URL of the subgraph. If a subgraph with the same name exists, then this
   * field can be null to indicate the existing subgraph's info should be used; using
   * null otherwise results in an error.
   */
  routingUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The schema document/SDL of the subgraph. If a subgraph with the same name exists,
   * then this field can be null to indicate the existing subgraph's info should be
   * used; using null otherwise results in an error.
   */
  schemaDocument?: InputMaybe<Scalars['String']['input']>;
};

export type ComposeAndFilterPreviewSuccess = {
  __typename: 'ComposeAndFilterPreviewSuccess';
  /** The results from successful composition. */
  composeResults: ComposeAndFilterPreviewBuildResults;
  /** The results from successful filtering, or null if filtering was skipped. */
  filterResults: Maybe<ComposeAndFilterPreviewBuildResults>;
};

/** The result of supergraph composition that Studio performed in response to an attempted deletion of a subgraph. */
export type CompositionAndRemoveResult = {
  __typename: 'CompositionAndRemoveResult';
  /** The produced composition config. Will be null if there are any errors */
  compositionConfig: Maybe<CompositionConfig>;
  createdAt: Scalars['Timestamp']['output'];
  /** Whether the removed implementing service existed. */
  didExist: Scalars['Boolean']['output'];
  /** A list of errors that occurred during composition. Errors mean that Apollo was unable to compose the graph variant's subgraphs into a supergraph schema. If any errors are present, gateways / routers are not updated. */
  errors: Array<Maybe<SchemaCompositionError>>;
  /** ID that points to the results of composition. */
  graphCompositionID: Scalars['String']['output'];
  /** List of subgraphs that are included in this composition. */
  subgraphConfigs: Array<SubgraphConfig>;
  /** Whether this composition result resulted in a new supergraph schema passed to Uplink (`true`), or the build failed for any reason (`false`). For dry runs, this value is `true` if Uplink _would have_ been updated with the result. */
  updatedGateway: Scalars['Boolean']['output'];
};

/** The result of supergraph composition that Studio performed in response to an attempted publish of a subgraph. */
export type CompositionAndUpsertResult = {
  __typename: 'CompositionAndUpsertResult';
  /** The generated composition config, or null if any errors occurred. */
  compositionConfig: Maybe<CompositionConfig>;
  createdAt: Scalars['Timestamp']['output'];
  /** A list of errors that occurred during composition. Errors mean that Apollo was unable to compose the graph variant's subgraphs into a supergraph schema. If any errors are present, gateways / routers are not updated. */
  errors: Array<Maybe<SchemaCompositionError>>;
  /** ID that points to the results of composition. */
  graphCompositionID: Scalars['String']['output'];
  /** The Launch result part of this subgraph publish. */
  launch: Maybe<Launch>;
  /** Human-readable text describing the launch result of the subgraph publish. */
  launchCliCopy: Maybe<Scalars['String']['output']>;
  /** The URL of the Studio page for this update's associated launch, if available. */
  launchUrl: Maybe<Scalars['String']['output']>;
  /** List of subgraphs that are included in this composition. */
  subgraphConfigs: Array<SubgraphConfig>;
  /** All subgraphs that were created from this mutation */
  subgraphsCreated: Array<Scalars['String']['output']>;
  /** All subgraphs that were updated from this mutation */
  subgraphsUpdated: Array<Scalars['String']['output']>;
  /** Whether this composition result resulted in a new supergraph schema passed to Uplink (`true`), or the build failed for any reason (`false`). For dry runs, this value is `true` if Uplink _would have_ been updated with the result. */
  updatedGateway: Scalars['Boolean']['output'];
  /** Whether a new subgraph was created as part of this publish. */
  wasCreated: Scalars['Boolean']['output'];
  /** Whether an implementingService was updated as part of this mutation */
  wasUpdated: Scalars['Boolean']['output'];
};

export type CompositionBuildCheckFailed = BuildCheckFailed & BuildCheckResult & CompositionBuildCheckResult & {
  __typename: 'CompositionBuildCheckFailed';
  buildInputs: CompositionBuildInputs;
  buildPipelineTrack: BuildPipelineTrack;
  compositionPackageVersion: Maybe<Scalars['String']['output']>;
  errors: Array<BuildError>;
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  workflowTask: CompositionCheckTask;
};

export type CompositionBuildCheckPassed = BuildCheckPassed & BuildCheckResult & CompositionBuildCheckResult & {
  __typename: 'CompositionBuildCheckPassed';
  buildInputs: CompositionBuildInputs;
  buildPipelineTrack: BuildPipelineTrack;
  compositionPackageVersion: Maybe<Scalars['String']['output']>;
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  supergraphSchemaHash: Scalars['SHA256']['output'];
  workflowTask: CompositionCheckTask;
};

export type CompositionBuildCheckResult = {
  buildInputs: CompositionBuildInputs;
  /**
   * The build pipeline track of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  buildPipelineTrack: BuildPipelineTrack;
  /** The version of the OSS apollo composition package used during build */
  compositionPackageVersion: Maybe<Scalars['String']['output']>;
  /**
   * The Federation version of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  /** Whether the build task passed or failed. */
  passed: Scalars['Boolean']['output'];
  workflowTask: CompositionCheckTask;
};

export type CompositionBuildInput = {
  __typename: 'CompositionBuildInput';
  subgraphs: Array<Subgraph>;
  version: Maybe<Scalars['String']['output']>;
};

export type CompositionBuildInputSubgraph = {
  __typename: 'CompositionBuildInputSubgraph';
  /** The name of the subgraph. */
  name: Scalars['String']['output'];
  /** The routing URL of the subgraph. */
  routingUrl: Scalars['String']['output'];
  /** The SHA-256 of the schema document of the subgraph. */
  schemaHash: Scalars['SHA256']['output'];
};

export type CompositionBuildInputs = {
  __typename: 'CompositionBuildInputs';
  /**
   * The build pipeline track used for composition. Note this is also the build pipeline track used
   *  for any triggered downstream check workflows as well.
   */
  buildPipelineTrack: BuildPipelineTrack;
  /**
   * The Federation version used for composition. Note this is also the Federation version used
   *  for any triggered downstream check workflows as well.
   */
  federationVersion: Scalars['FederationVersion']['output'];
  /** The subgraphs used for composition. */
  subgraphs: Array<CompositionBuildInputSubgraph>;
};

export type CompositionCheckTask = BuildCheckTask & CheckWorkflowTask & {
  __typename: 'CompositionCheckTask';
  /** The result of the composition build check. This will be null when the task is initializing or running. */
  buildResult: Maybe<CompositionBuildCheckResult>;
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Whether the build's output supergraph core schema differs from that of the active publish for
   * the workflow's variant at the time this field executed (NOT at the time the check workflow
   * started).
   */
  coreSchemaModified: Scalars['Boolean']['output'];
  createdAt: Scalars['Timestamp']['output'];
  graphID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  proposedBuildInputChanges: ProposedCompositionBuildInputChanges;
  /**
   * An old version of buildResult that returns a very old GraphQL type that generally should be
   * avoided. This field will soon be deprecated.
   */
  result: Maybe<CompositionResult>;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** Composition configuration exposed to the gateway. */
export type CompositionConfig = {
  __typename: 'CompositionConfig';
  /**
   * List of GCS links for implementing services that comprise a composed graph. Is empty if tag/inaccessible is enabled.
   * @deprecated Soon we will stop writing to GCS locations
   */
  implementingServiceLocations: Array<ImplementingServiceLocation>;
  /** The resulting API schema's SHA256 hash, represented as a hexadecimal string. */
  schemaHash: Scalars['String']['output'];
};

export type CompositionConfigInput = {
  subgraphs: Array<SubgraphInput>;
};

/** The result of supergraph composition that Studio performed. */
export type CompositionPublishResult = CompositionResult & {
  __typename: 'CompositionPublishResult';
  /** The generated composition config, or null if any errors occurred. */
  compositionConfig: Maybe<CompositionConfig>;
  createdAt: Scalars['Timestamp']['output'];
  /** A list of errors that occurred during composition. Errors mean that Apollo was unable to compose the graph variant's subgraphs into a supergraph schema. If any errors are present, gateways / routers are not updated. */
  errors: Array<SchemaCompositionError>;
  /** The unique ID for this instance of composition. */
  graphCompositionID: Scalars['ID']['output'];
  graphID: Scalars['ID']['output'];
  /** Null if CompositionPublishResult was not on a Proposal Variant */
  proposalRevision: Maybe<ProposalRevision>;
  /**
   * Cloud router configuration associated with this build event.
   * It will be non-null for any cloud-router variant, and null for any not cloudy variant/graph
   */
  routerConfig: Maybe<Scalars['String']['output']>;
  /** List of subgraphs that are included in this composition. */
  subgraphConfigs: Array<SubgraphConfig>;
  /** The supergraph SDL generated by composition. */
  supergraphSdl: Maybe<Scalars['GraphQLDocument']['output']>;
  /** Whether this composition result updated gateway/router instances via Uplink (`true`), or it was a dry run (`false`). */
  updatedGateway: Scalars['Boolean']['output'];
};

/** The result of supergraph composition performed by Apollo Studio, often as the result of a subgraph check or subgraph publish. See individual implementations for more details. */
export type CompositionResult = {
  createdAt: Scalars['Timestamp']['output'];
  /** A list of errors that occurred during composition. Errors mean that Apollo was unable to compose the graph variant's subgraphs into a supergraph schema. If any errors are present, gateways / routers are not updated. */
  errors: Array<SchemaCompositionError>;
  /** The unique ID for this instance of composition. */
  graphCompositionID: Scalars['ID']['output'];
  /**
   * Cloud router configuration associated with this build event.
   * It will be non-null for any cloud-router variant, and null for any not cloudy variant/graph
   */
  routerConfig: Maybe<Scalars['String']['output']>;
  /** List of subgraphs included in this composition. */
  subgraphConfigs: Array<SubgraphConfig>;
  /** Supergraph SDL generated by composition. */
  supergraphSdl: Maybe<Scalars['GraphQLDocument']['output']>;
};

export type CompositionStatusSubscription = ChannelSubscription & {
  __typename: 'CompositionStatusSubscription';
  channels: Array<Channel>;
  createdAt: Scalars['Timestamp']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

/** The composition config exposed to the gateway */
export type CompositionValidationDetails = {
  __typename: 'CompositionValidationDetails';
  /** Hash of the composed schema */
  schemaHash: Maybe<Scalars['String']['output']>;
};

/** The result of composition validation run by Apollo Studio during a subgraph check. */
export type CompositionValidationResult = CompositionResult & {
  __typename: 'CompositionValidationResult';
  /** Describes whether composition succeeded. */
  compositionSuccess: Scalars['Boolean']['output'];
  /**
   * Akin to a composition config, represents the subgraph schemas and corresponding subgraphs that were used
   * in running composition. Will be null if any errors are encountered. Also may contain a schema hash if
   * one could be computed, which can be used for schema validation.
   */
  compositionValidationDetails: Maybe<CompositionValidationDetails>;
  createdAt: Scalars['Timestamp']['output'];
  /** A list of errors that occurred during composition. Errors mean that Apollo was unable to compose the graph variant's subgraphs into a supergraph schema. If any errors are present, gateways / routers are not updated. */
  errors: Array<SchemaCompositionError>;
  /** The unique ID for this instance of composition. */
  graphCompositionID: Scalars['ID']['output'];
  /**
   * The implementing service that was responsible for triggering the validation
   * @deprecated The proposed subgraph is now exposed under proposedSubgraphs, a list. If a single subgraph check was run the list will be one subgraph long.
   */
  proposedImplementingService: FederatedImplementingServicePartialSchema;
  /** DO NOT USE, NOT YET IMPLEMENTED. The subgraphs with changes that were responsible for triggering the validation */
  proposedSubgraphs: Array<FederatedImplementingServicePartialSchema>;
  /**
   * Cloud router configuration associated with this build event.
   * It will be non-null for any cloud-router variant, and null for any not cloudy variant/graph
   */
  routerConfig: Maybe<Scalars['String']['output']>;
  /** List of subgraphs that are included in this composition. */
  subgraphConfigs: Array<SubgraphConfig>;
  /** The supergraph schema document generated by composition. */
  supergraphSdl: Maybe<Scalars['GraphQLDocument']['output']>;
  /** If created as part of a check workflow, the associated workflow task. */
  workflowTask: Maybe<CompositionCheckTask>;
};

/** A fetch to a REST connector. */
export type ConnectorSubgraphFetchDetails = SubgraphFetchDetails & {
  __typename: 'ConnectorSubgraphFetchDetails';
  /** The name of the connector source this fetch used. */
  connectorSourceName: Maybe<Scalars['String']['output']>;
  /** The HTTP method used for this fetch. */
  httpMethod: Maybe<Scalars['String']['output']>;
  /** The subgraph's name. */
  name: Scalars['String']['output'];
  /** The URL template this fetch was made against. */
  urlTemplate: Maybe<Scalars['String']['output']>;
};

/** A subgraph in a federated Studio supergraph. */
export type ConnectorTools = {
  __typename: 'ConnectorTools';
  /** A prompt for generating supergraphs using Apollo Connectors */
  architect: Scalars['String']['output'];
  /** A specification for Apollo Connectors */
  spec: Scalars['String']['output'];
};

/** Represents a section of documentation content */
export type ContentSlice = {
  __typename: 'ContentSlice';
  /** The content of the section */
  content: Scalars['String']['output'];
  /** The index of the section */
  index: Scalars['Int']['output'];
  /** Total number of sections available */
  totalCount: Scalars['Int']['output'];
};

export type ContractConfigInput = {
  baseGraphRef: Scalars['String']['input'];
  filterConfigInput: FilterConfigInput;
};

/** The result of starting an async contractPreviewAsync build. Use the buildID to poll contractPreviewStatus for the outcome. */
export type ContractPreviewAsyncBuild = {
  __typename: 'ContractPreviewAsyncBuild';
  /** The ID of the started preview build. Poll contractPreviewStatus with this ID for results. */
  buildID: Scalars['ID']['output'];
};

/** Returned by contractPreviewStatus while the async preview build is still in progress. */
export type ContractPreviewAsyncPending = {
  __typename: 'ContractPreviewAsyncPending';
  /** The ID of the in-flight preview build. */
  buildID: Scalars['ID']['output'];
  /** Whether the build is queued (PENDING) or executing (RUNNING). */
  status: ContractPreviewAsyncPendingStatus;
};

/** Whether an in-flight async contractPreviewAsync build is queued or actively executing. */
export enum ContractPreviewAsyncPendingStatus {
  /** The build is queued and has not yet started executing. */
  PENDING = 'PENDING',
  /** The build is actively executing. */
  RUNNING = 'RUNNING'
}

/** The result of polling an async contractPreviewAsync build: still pending/running, or the terminal filter outcome. */
export type ContractPreviewAsyncStatus = ContractPreviewAsyncPending | ContractPreviewErrors | ContractPreviewSuccess;

export type ContractPreviewErrors = {
  __typename: 'ContractPreviewErrors';
  errors: Array<Scalars['String']['output']>;
  failedAt: ContractVariantFailedStep;
  /** The launch against which this preview was created. */
  upstreamLaunch: Launch;
};

export type ContractPreviewSuccess = {
  __typename: 'ContractPreviewSuccess';
  apiDocument: Scalars['String']['output'];
  coreDocument: Scalars['String']['output'];
  fieldCount: Scalars['Int']['output'];
  typeCount: Scalars['Int']['output'];
  /** The launch against which this preview was created. */
  upstreamLaunch: Launch;
};

export enum ContractVariantFailedStep {
  ADD_DIRECTIVE_DEFINITIONS_IF_NOT_PRESENT = 'ADD_DIRECTIVE_DEFINITIONS_IF_NOT_PRESENT',
  ADD_INACCESSIBLE_SPEC_PURPOSE = 'ADD_INACCESSIBLE_SPEC_PURPOSE',
  DIRECTIVE_DEFINITION_LOCATION_AUGMENTING = 'DIRECTIVE_DEFINITION_LOCATION_AUGMENTING',
  EMPTY_ENUM_MASKING = 'EMPTY_ENUM_MASKING',
  EMPTY_INPUT_OBJECT_MASKING = 'EMPTY_INPUT_OBJECT_MASKING',
  EMPTY_OBJECT_AND_INTERFACE_FIELD_MASKING = 'EMPTY_OBJECT_AND_INTERFACE_FIELD_MASKING',
  EMPTY_OBJECT_AND_INTERFACE_MASKING = 'EMPTY_OBJECT_AND_INTERFACE_MASKING',
  EMPTY_UNION_MASKING = 'EMPTY_UNION_MASKING',
  INPUT_VALIDATION = 'INPUT_VALIDATION',
  PARSING = 'PARSING',
  PARSING_TAG_DIRECTIVES = 'PARSING_TAG_DIRECTIVES',
  PARTIAL_INTERFACE_MASKING = 'PARTIAL_INTERFACE_MASKING',
  SCHEMA_RETRIEVAL = 'SCHEMA_RETRIEVAL',
  TAG_INHERITING = 'TAG_INHERITING',
  TAG_MATCHING = 'TAG_MATCHING',
  TO_API_SCHEMA = 'TO_API_SCHEMA',
  TO_FILTER_SCHEMA = 'TO_FILTER_SCHEMA',
  UNKNOWN = 'UNKNOWN',
  UNREACHABLE_TYPE_MASKING = 'UNREACHABLE_TYPE_MASKING',
  VERSION_CHECK = 'VERSION_CHECK'
}

export type ContractVariantUpsertErrors = {
  __typename: 'ContractVariantUpsertErrors';
  /** A list of all errors that occurred when attempting to create or update a contract variant. */
  errorMessages: Array<Scalars['String']['output']>;
};

export type ContractVariantUpsertResult = ContractVariantUpsertErrors | ContractVariantUpsertSuccess;

export type ContractVariantUpsertSuccess = {
  __typename: 'ContractVariantUpsertSuccess';
  /** The updated contract variant */
  contractVariant: GraphVariant;
  /** Human-readable text describing the launch result of the contract update. */
  launchCliCopy: Maybe<Scalars['String']['output']>;
  /** The URL of the Studio page for this update's associated launch, if available. */
  launchUrl: Maybe<Scalars['String']['output']>;
};

export type Coordinate = {
  __typename: 'Coordinate';
  byteOffset: Scalars['Int']['output'];
  column: Scalars['Int']['output'];
  line: Scalars['Int']['output'];
};

/** Metadata about when a coordinate was first and last seen in operation traces */
export type CoordinateInsights = {
  __typename: 'CoordinateInsights';
  /** If the first or last seen timestamps are earlier than this timestamp, we can't tell the exact date that we saw this coordinate since our data is bound by the retention period. */
  earliestRetentionTime: Maybe<Scalars['Timestamp']['output']>;
  /** The earliest time we saw references or executions for this coordinate. Null if the coordinate has never been seen or it is not in the schema. */
  firstSeen: Maybe<Scalars['Timestamp']['output']>;
  /** The most recent time we saw references or executions for this coordinate. Null if the coordinate has never been seen or it is not in the schema. */
  lastSeen: Maybe<Scalars['Timestamp']['output']>;
};

export type CoordinateInsightsListFilterInInput = {
  /** Filters results to coordinates whose usage was reported with any of the given client names. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to coordinates whose usage was reported with any of the given client versions. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CoordinateInsightsListFilterInput = {
  /** Filters results to coordinates whose usage was reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to coordinates whose usage was reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Restricts results to coordinates of the given kind (e.g. object field, input field, enum value). */
  coordinateKind?: InputMaybe<CoordinateKind>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<CoordinateInsightsListFilterInInput>;
  /** If set, restricts results to coordinates whose `@deprecated` status matches this value in the active schema. */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, restricts results to coordinates whose observed usage in the selected time range matches this value. */
  isUnused?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<CoordinateInsightsListFilterInput>>;
  /** Filters on partial string matches of Named Type and Named Attribute */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CoordinateInsightsListItem = {
  __typename: 'CoordinateInsightsListItem';
  /** The estimated number of field executions for this field, based on the field execution sample rate. This can be null depending on the sort order. */
  estimatedExecutionCount: Maybe<Scalars['Long']['output']>;
  /** The number of field executions recorded for this field. This can be null depending on the sort order. */
  executionCount: Maybe<Scalars['Long']['output']>;
  /** Whether the coordinate is marked `@deprecated` in the active schema for the variant. */
  isDeprecated: Scalars['Boolean']['output'];
  /** Whether the coordinate has had no observed usage in the selected time range. */
  isUnused: Scalars['Boolean']['output'];
  /** The named attribute portion of the schema coordinate (e.g. `email` for `User.email`, or `VALUE` for `MyEnum.VALUE`). */
  namedAttribute: Scalars['String']['output'];
  /** The named type portion of the schema coordinate (e.g. `User` for `User.email`, or `MyEnum` for `MyEnum.VALUE`). */
  namedType: Scalars['String']['output'];
  /** The count of operations that reference the coordinate. This can be null depending on the sort order. */
  referencingOperationCount: Maybe<Scalars['Long']['output']>;
  /** The count of operations that reference the coordinate per minute. This can be null depending on the sort order. */
  referencingOperationCountPerMin: Maybe<Scalars['Float']['output']>;
};

export enum CoordinateInsightsListOrderByColumn {
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REFERENCING_OPERATION_COUNT_PER_MIN = 'REFERENCING_OPERATION_COUNT_PER_MIN',
  SCHEMA_COORDINATE = 'SCHEMA_COORDINATE'
}

export type CoordinateInsightsListOrderByInput = {
  /** The column to order results by. */
  column: CoordinateInsightsListOrderByColumn;
  /** The order direction, ascending or descending. */
  direction: Ordering;
};

/** Information about pagination in a connection. */
export type CoordinateInsightsListPageInfo = {
  __typename: 'CoordinateInsightsListPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum CoordinateKind {
  ENUM_VALUE = 'ENUM_VALUE',
  INPUT_OBJECT_FIELD = 'INPUT_OBJECT_FIELD',
  OBJECT_FIELD = 'OBJECT_FIELD'
}

/** Columns of CoordinateUsage. */
export enum CoordinateUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  KIND = 'KIND',
  NAMED_ATTRIBUTE = 'NAMED_ATTRIBUTE',
  NAMED_TYPE = 'NAMED_TYPE',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUEST_COUNT_NULL = 'REQUEST_COUNT_NULL',
  REQUEST_COUNT_UNDEFINED = 'REQUEST_COUNT_UNDEFINED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type CoordinateUsageDimensions = {
  __typename: 'CoordinateUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  namedAttribute: Maybe<Scalars['String']['output']>;
  namedType: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['String']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in CoordinateUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type CoordinateUsageFilter = {
  and?: InputMaybe<Array<CoordinateUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<CoordinateUsageFilterIn>;
  /** Selects rows whose kind dimension equals the given value if not null. To query for the null value, use {in: {kind: [null]}} instead. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedAttribute dimension equals the given value if not null. To query for the null value, use {in: {namedAttribute: [null]}} instead. */
  namedAttribute?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedType dimension equals the given value if not null. To query for the null value, use {in: {namedType: [null]}} instead. */
  namedType?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<CoordinateUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<CoordinateUsageFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in CoordinateUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type CoordinateUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose kind dimension is in the given list. A null value in the list means a row with null for that dimension. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedAttribute dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedAttribute?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CoordinateUsageMetrics = {
  __typename: 'CoordinateUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestCountNull: Scalars['Long']['output'];
  requestCountUndefined: Scalars['Long']['output'];
};

export type CoordinateUsageOrderBySpec = {
  column: CoordinateUsageColumn;
  direction: Ordering;
};

export type CoordinateUsageRecord = {
  __typename: 'CoordinateUsageRecord';
  /** Dimensions of CoordinateUsage that can be grouped by. */
  groupBy: CoordinateUsageDimensions;
  /** Metrics of CoordinateUsage that can be aggregated over. */
  metrics: CoordinateUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Contains the supergraph and API schemas generated by composition. */
export type CoreSchema = {
  __typename: 'CoreSchema';
  /** The composed API schema document. */
  apiDocument: Scalars['GraphQLDocument']['output'];
  /** The API schema document's SHA256 hash, represented as a hexadecimal string. */
  apiHash: Scalars['String']['output'];
  /** The composed supergraph schema document. */
  coreDocument: Scalars['GraphQLDocument']['output'];
  /** The supergraph schema document's SHA256 hash, represented as a hexadecimal string. */
  coreHash: Scalars['String']['output'];
  /** @deprecated Use metadata instead */
  fieldCount: Scalars['Int']['output'];
  /** Metadata associated with the schema. */
  metadata: Maybe<SchemaMetadata>;
  tags: Array<Scalars['String']['output']>;
  /** @deprecated Use metadata instead */
  typeCount: Scalars['Int']['output'];
};

/** A learner's feedback submission for a course */
export type CourseFeedback = {
  __typename: 'CourseFeedback';
  /** The course this feedback was submitted for */
  courseId: Scalars['ID']['output'];
  /** Unique identifier for this feedback record */
  id: Scalars['ID']['output'];
  /** All question-answer pairs in this submission */
  responses: Array<QuestionResponse>;
  /** When this feedback was submitted */
  submittedAt: Scalars['Timestamp']['output'];
};

/** Input for submitting feedback for a course */
export type CourseFeedbackInput = {
  /** The course this feedback is for */
  courseId: Scalars['ID']['input'];
  /** All question-answer pairs in this submission */
  responses: Array<QuestionResponseInput>;
};

/** Input for `createAccessRequestByServiceName`. */
export type CreateAccessRequestByServiceNameInput = {
  /** Application the access is being requested for. */
  appId: Scalars['UUID']['input'];
  /** Approval policy governing the quorum requirement. Server-side default applies when omitted. */
  approvalPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Router-generated integrity token describing the denied fields. Format:
   * `v0.<base64url-no-pad(JSON)>.<sha256-hex>`. The JSON payload contains
   * `blocked_fields`, `app_id`, `service_id`, and request metadata. Pass the
   * `denial_context` value from the router's `CONSTELLATION_ACCESS_DENIED`
   * error extension verbatim.
   */
  denialContext: Scalars['String']['input'];
  /** Optional expiry — after this timestamp the request is no longer actionable. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Deprecated and ignored (AIR-476). Deduplication is now server-side by
   * natural key (org, app, service, principal, requested field set); any
   * value supplied here has no effect.
   * @deprecated Ignored — dedup is server-side by natural key (AIR-476).
   */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Principal the request applies to. Null means the caller's own identity. */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** Human-readable justification for the request. */
  reason: Scalars['String']['input'];
  /** Fields the caller is requesting access to. */
  requestedFields: Array<Scalars['String']['input']>;
  /** Required approver count override. Server-side default applies when omitted. */
  requiredApproverCount?: InputMaybe<Scalars['Int']['input']>;
  /** Upstream service name the access is being requested against. */
  serviceName: Scalars['String']['input'];
  /**
   * Base64url-encoded normalized GraphQL operation that triggered the access
   * check. Pass the `source_operation` value from the router's
   * `CONSTELLATION_ACCESS_DENIED` error extension verbatim. Reviewers can
   * base64-decode this to display the original query.
   */
  sourceOperation: Scalars['String']['input'];
};

/** Input for `createAccessRequest`. */
export type CreateAccessRequestInput = {
  /** Application the access is being requested for. */
  appId: Scalars['UUID']['input'];
  /** Approval policy governing the quorum requirement. Server-side default applies when omitted. */
  approvalPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Router-generated integrity token describing the denied fields. Format:
   * `v0.<base64url-no-pad(JSON)>.<sha256-hex>`. The JSON payload contains
   * `blocked_fields`, `app_id`, `service_id`, and request metadata. Pass the
   * `denial_context` value from the router's `CONSTELLATION_ACCESS_DENIED`
   * error extension verbatim.
   */
  denialContext: Scalars['String']['input'];
  /** Optional expiry — after this timestamp the request is no longer actionable. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Deprecated and ignored (AIR-476). Deduplication is now server-side by
   * natural key (org, app, service, principal, requested field set); any
   * value supplied here has no effect.
   * @deprecated Ignored — dedup is server-side by natural key (AIR-476).
   */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Principal the request applies to. Null means the caller's own identity. */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** Human-readable justification for the request. */
  reason: Scalars['String']['input'];
  /** Fields the caller is requesting access to. */
  requestedFields: Array<Scalars['String']['input']>;
  /** Required approver count override. Server-side default applies when omitted. */
  requiredApproverCount?: InputMaybe<Scalars['Int']['input']>;
  /** Upstream service the access is being requested against. */
  serviceId: Scalars['UUID']['input'];
  /**
   * Base64url-encoded normalized GraphQL operation that triggered the access
   * check. Pass the `source_operation` value from the router's
   * `CONSTELLATION_ACCESS_DENIED` error extension verbatim. Reviewers can
   * base64-decode this to display the original query.
   */
  sourceOperation: Scalars['String']['input'];
};

/**
 * Input for issuing a new application API key, scoped to a subset of the
 * application's org's registered upstream services.
 */
export type CreateApplicationApiKeyInput = {
  /**
   * Catalog names of the upstream services this key may be used against
   * (e.g. `"ashby"`). Every name must already be registered in the
   * caller's org; the whole request is rejected, naming every offender, if
   * any is unrecognized. Must not be empty, and duplicates are collapsed.
   */
  allowedServices: Array<Scalars['String']['input']>;
  /** The application the key is issued for. */
  applicationId: Scalars['UUID']['input'];
  /** Human-readable label for the key (e.g. "dashboard-prod"). */
  label: Scalars['String']['input'];
};

/**
 * The response to `createApplicationApiKey`. `plaintext` is the one place
 * the plaintext key appears in the whole schema — it is never returned by
 * any other field or query, and is not persisted anywhere but the caller's
 * own copy of this response.
 */
export type CreateApplicationApiKeyPayload = {
  __typename: 'CreateApplicationApiKeyPayload';
  /** The newly created API key. */
  key: ApplicationApiKey;
  /**
   * The plaintext value of the newly created key. Shown only once — it
   * cannot be retrieved again after this response.
   */
  plaintext: Scalars['String']['output'];
};

/** Input for creating a new application. */
export type CreateApplicationInput = {
  /** Optional description of the application's purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether this is an agentic or interactive application.
   * Determines initial status: AGENTIC_APP starts PENDING; INTERACTIVE starts APPROVED.
   */
  kind: ApplicationKind;
  /** Human-readable name for the new application. */
  name: Scalars['String']['input'];
};

/** Input to create a new AWS shard */
export type CreateAwsShardInput = {
  accountId: Scalars['String']['input'];
  coldStartTargetGroupArns?: InputMaybe<Array<Scalars['String']['input']>>;
  ecsClusterArn: Scalars['String']['input'];
  iamRoleArn: Scalars['String']['input'];
  loadbalancerSecurityGroupId: Scalars['String']['input'];
  loadbalancers: Array<AwsLoadBalancerInput>;
  permissionsBoundaryArn: Scalars['String']['input'];
  region: Scalars['String']['input'];
  subnetIds: Array<Scalars['String']['input']>;
  vpcId: Scalars['String']['input'];
};

/** Input for creating a new feedback survey */
export type CreateFeedbackSurveyInput = {
  /** Human-readable name for the survey */
  name: Scalars['String']['input'];
  /** The ordered list of questions for this survey */
  questions: Array<FeedbackQuestionInput>;
};

/** Return payload for the createSurvey mutation */
export type CreateFeedbackSurveyPayload = {
  __typename: 'CreateFeedbackSurveyPayload';
  /** The survey that was created, or null if validation failed */
  survey: Maybe<FeedbackSurvey>;
  /** Any validation errors that occurred */
  userErrors: Array<UserError>;
};

/** Result from the createCloudOnboarding mutation */
export type CreateOnboardingResult = CreateOnboardingSuccess | InternalServerError | InvalidInputErrors;

/** Success creating a CloudOnboarding */
export type CreateOnboardingSuccess = {
  __typename: 'CreateOnboardingSuccess';
  onboarding: CloudOnboarding;
};

export type CreateOperationCollectionResult = NotFoundError | OperationCollection | PermissionError | ValidationError;

/** The result of a successful call to GraphMutation.createPersistedQueryList. */
export type CreatePersistedQueryListResult = {
  __typename: 'CreatePersistedQueryListResult';
  persistedQueryList: PersistedQueryList;
};

/** The result/error union returned by GraphMutation.createPersistedQueryList. */
export type CreatePersistedQueryListResultOrError = CreatePersistedQueryListResult | PermissionError;

/** Input for creating a new policy exception. */
export type CreatePolicyExceptionInput = {
  /** Identifier of the user/system approving the exception. */
  approvedBy: Scalars['String']['input'];
  /** Classification label being granted. */
  classification: Scalars['String']['input'];
  /** Optional expiry timestamp. Null means the exception does not auto-expire. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optionally pair this exception, at creation, with an existing rule
   * (its id). The two become a matched set: deleting either soft-deletes
   * the other. The target must be a live, same-org rule that is not
   * already paired and was not created by an access request.
   */
  pairedId?: InputMaybe<Scalars['UUID']['input']>;
  /** Principal to grant. Null means "all principals in scope". */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** Human-readable justification for the grant. */
  reason: Scalars['String']['input'];
  /** Application the exception applies to. */
  scopeAppId: Scalars['UUID']['input'];
  /** Upstream service the exception covers. */
  serviceId: Scalars['UUID']['input'];
  /** Initial lifecycle status. Defaults to `ACTIVE` when omitted. */
  status?: InputMaybe<PolicyExceptionStatus>;
};

/** Input for creating a new policy rule. */
export type CreatePolicyRuleInput = {
  /** Operational configuration overrides; server-side defaults apply when omitted. */
  config?: InputMaybe<PolicyRuleConfigInput>;
  /** Optional human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Effect taken when the rule matches. */
  effect: PolicyEffect;
  /**
   * Effect-specific configuration. Required for `DENY`, optional for `ALLOW`
   * (absent allows every field), must be absent or all-null for `MASK`.
   */
  effectConfig?: InputMaybe<PolicyEffectConfigInput>;
  /** Optional short label for the rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optionally pair this rule, at creation, with an existing exception
   * (its id). The two become a matched set: deleting either soft-deletes
   * the other. The target must be a live, same-org exception that is not
   * already paired and was not created by an access request.
   */
  pairedId?: InputMaybe<Scalars['UUID']['input']>;
  /** Principal binding. Null means "all principals in scope". */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** Scope at which the rule applies. */
  scope: PolicyRuleScopeInput;
  /** Target — classification or service. */
  target: PolicyRuleTargetInput;
};

/** An error that occurs when creating a proposal fails. */
export type CreateProposalError = Error & {
  __typename: 'CreateProposalError';
  /** The error's details. */
  message: Scalars['String']['output'];
};

export type CreateProposalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  sourceVariantName: Scalars['String']['input'];
};

export type CreateProposalLifecycleSubscriptionInput = {
  /** The ID of the channel to subscribe. Accepts any channel type; use instead of webhookChannelID. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  events: Array<ProposalLifecycleEvent>;
  webhookChannelID: Scalars['ID']['input'];
};

export type CreateProposalLifecycleSubscriptionResult = PermissionError | ProposalLifecycleSubscription | ValidationError;

export type CreateProposalResult = CreateProposalError | GraphVariant | PermissionError | ValidationError;

/** Input to create a new Cloud Router */
export type CreateRouterInput = {
  /**
   * Number of GCUs allocated for the Cloud Router
   *
   * This is ignored for serverless Cloud Routers
   */
  gcus?: InputMaybe<Scalars['Int']['input']>;
  /** Graph composition ID, also known as launch ID */
  graphCompositionId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for ordering orders */
  orderingId: Scalars['String']['input'];
  /** Configuration for the Cloud Router */
  routerConfig?: InputMaybe<Scalars['String']['input']>;
  /** Router version for the Cloud Router */
  routerVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the possible outcomes of a createRouter mutation */
export type CreateRouterResult = CreateRouterSuccess | InternalServerError | InvalidInputErrors;

/**
 * Success branch of a createRouter mutation
 *
 * id of the order can be polled
 * via Query.cloud().order(id: ID!) to check-in on the progress
 * of the underlying operation
 */
export type CreateRouterSuccess = {
  __typename: 'CreateRouterSuccess';
  order: Order;
};

/** Result of a createVersion mutation */
export type CreateRouterVersionResult = InternalServerError | InvalidInputErrors | RouterVersion;

export type CreateRuleEnforcementInput = {
  graphVariant?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Array<StringToStringInput>>;
  policy: EnforcementPolicy;
};

/** Result of createS3Integration: the created configuration, or an error explaining why it could not be created. */
export type CreateS3IntegrationResult = AlreadyConfiguredError | InvalidInputError | PermissionError | S3IntegrationConfig;

/** Input for creating a new service catalog entry. */
export type CreateServiceCatalogInput = {
  /** Suggested auth configuration to prefill when creating a service from this entry. */
  defaultAuth?: InputMaybe<Scalars['JSON']['input']>;
  /** Suggested base URL to prefill when creating a service from this entry. */
  defaultBaseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Description of what this connector does. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name for this catalog entry (e.g. "Slack"). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** GraphQL schema template for this version of the service connector. */
  schemaTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the service connector this catalog entry describes. */
  serviceId: Scalars['String']['input'];
  /** Version timestamp for this catalog entry; defaults to the current time if omitted. */
  version?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input to create a new Shard */
export type CreateShardInput = {
  aws?: InputMaybe<CreateAwsShardInput>;
  gcuCapacity?: InputMaybe<Scalars['Int']['input']>;
  gcuUsage?: InputMaybe<Scalars['Int']['input']>;
  provider: CloudProvider;
  reason?: InputMaybe<Scalars['String']['input']>;
  routerCapacity?: InputMaybe<Scalars['Int']['input']>;
  routerUsage?: InputMaybe<Scalars['Int']['input']>;
  shardId: Scalars['String']['input'];
  status?: InputMaybe<ShardStatus>;
  tier: CloudTier;
};

/** Input for creating a new service. */
export type CreateUpstreamServiceInput = {
  /**
   * Authentication configuration as a JSON object. If the service template
   * references `{{TOKEN_VAR}}`, include `env_var` (string) here naming the
   * environment variable that holds the secret.
   */
  auth?: InputMaybe<Scalars['JSON']['input']>;
  /** Base URL for the service's API endpoint. */
  baseUrl: Scalars['String']['input'];
  /** Optional description of the service's purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name for the new service. */
  name: Scalars['String']['input'];
  /** Tags to categorize this service. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reference to a service catalog entry to use as the template. */
  templateId: Scalars['UUID']['input'];
};

export type CreditGrant = {
  __typename: 'CreditGrant';
  expiresAt: Maybe<Scalars['Timestamp']['output']>;
  remainingCreditsInUsdCents: Scalars['Int']['output'];
  totalCreditsInUsdCents: Scalars['Int']['output'];
};

export type CronExecution = {
  __typename: 'CronExecution';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  failure: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job: CronJob;
  resolvedAt: Maybe<Scalars['Timestamp']['output']>;
  resolvedBy: Maybe<Actor>;
  schedule: Scalars['String']['output'];
  startedAt: Scalars['Timestamp']['output'];
};

export type CronJob = {
  __typename: 'CronJob';
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  recentExecutions: Array<CronExecution>;
};


export type CronJobrecentExecutionsArgs = {
  n?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomCheckCallbackInput = {
  /** Sets the status of your check task. Setting this status to FAILURE will cause the entire check workflow to fail. */
  status: CheckStepStatus;
  /** The ID of the custom check task, provided in the webhook payload. */
  taskId: Scalars['ID']['input'];
  /** The violations found by your check task. Max length is 1000 */
  violations?: InputMaybe<Array<CheckViolationInput>>;
  /** The ID of the workflow that the custom check task is a member of, provided in the webhook payload. */
  workflowId: Scalars['ID']['input'];
};

/** Result of a custom check task callback mutation. */
export type CustomCheckCallbackResult = CustomCheckResult | PermissionError | TaskError | ValidationError;

/** Custom check configuration detailing webhook integration. */
export type CustomCheckConfiguration = {
  __typename: 'CustomCheckConfiguration';
  channel: CustomCheckWebhookChannel;
  id: Scalars['ID']['output'];
};

/** Result of a custom check configuration update mutation. */
export type CustomCheckConfigurationResult = CustomCheckConfiguration | PermissionError | ValidationError;

export type CustomCheckResult = {
  __typename: 'CustomCheckResult';
  violations: Array<CheckViolation>;
};

export type CustomCheckTask = CheckWorkflowTask & {
  __typename: 'CustomCheckTask';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  graphID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  result: Maybe<CustomCheckResult>;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** Configuration of a webhook integration for a custom check. */
export type CustomCheckWebhookChannel = {
  __typename: 'CustomCheckWebhookChannel';
  /** The time when this CustomCheckWebhookChannel was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The Identity that created this CustomCheckWebhookChannel. null if the Identity has been deleted. */
  createdBy: Maybe<Identity>;
  /** The ID for this webhook channel */
  id: Scalars['ID']['output'];
  /** The last time this subscription was updated, if never updated will be the createdAt time. */
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** The Identity that last updated this CustomCheckWebhookChannel, or the creator if no one has updated. null if the Identity has been deleted. */
  lastUpdatedBy: Maybe<Identity>;
  /** Whether or not a secret token has been set on this channel. */
  secretTokenIsSet: Scalars['Boolean']['output'];
  /** The URL to send the webhook to. */
  url: Scalars['String']['output'];
  /** The variant name if this channel is only configured for a specific variant. If null, this configuration applies to all variants. */
  variant: Maybe<Scalars['String']['output']>;
};

export enum DatadogApiRegion {
  EU = 'EU',
  EU1 = 'EU1',
  US = 'US',
  US1 = 'US1',
  US1FED = 'US1FED',
  US3 = 'US3',
  US5 = 'US5'
}

export type DatadogMetricsConfig = {
  __typename: 'DatadogMetricsConfig';
  apiKey: Scalars['String']['output'];
  apiRegion: DatadogApiRegion;
  enabled: Scalars['Boolean']['output'];
  legacyMetricNames: Scalars['Boolean']['output'];
};

export type DeleteCommentInput = {
  id: Scalars['String']['input'];
};

export type DeleteCommentResult = DeleteCommentSuccess | NotFoundError | PermissionError | ValidationError;

export type DeleteCommentSuccess = {
  __typename: 'DeleteCommentSuccess';
  comment: Maybe<DeleteCommentSuccessResult>;
};

export type DeleteCommentSuccessResult = ParentChangeProposalComment | ParentGeneralProposalComment;

/** The payload from deleting a tag from a graph artifact. */
export type DeleteGraphArtifactTagPayload = {
  __typename: 'DeleteGraphArtifactTagPayload';
  /** The name of the tag that was deleted. */
  tag: Scalars['String']['output'];
};

/** The possible result of deleting a tag from a graph artifact. */
export type DeleteGraphArtifactTagResult = BadInputError | DeleteGraphArtifactTagPayload | GraphArtifactNotFoundError | GraphNotFoundError | OperationInProgressError;

export type DeleteOperationCollectionResult = DeleteOperationCollectionSuccess | PermissionError;

export type DeleteOperationCollectionSuccess = {
  __typename: 'DeleteOperationCollectionSuccess';
  sandboxOwner: Maybe<User>;
  variants: Array<GraphVariant>;
};

/** The result of a successful call to PersistedQueryListMutation.deleteOperationsByFilter. */
export type DeleteOperationsByFilterResult = {
  __typename: 'DeleteOperationsByFilterResult';
  /** The build created by this delete operation. */
  build: Maybe<PersistedQueryListBuild>;
  /** Returns `true` if no changes were made by this operation (and no new revision was created). Otherwise, returns `false`. */
  unchanged: Scalars['Boolean']['output'];
};

/** The result/error union returned by PersistedQueryListMutation.deleteOperationsByFilter. */
export type DeleteOperationsByFilterResultOrError = DeleteOperationsByFilterResult | PermissionError;

/** The result of a successful call to PersistedQueryListMutation.delete. */
export type DeletePersistedQueryListResult = {
  __typename: 'DeletePersistedQueryListResult';
  graph: Service;
};

/** The result/error union returned by PersistedQueryListMutation.delete. */
export type DeletePersistedQueryListResultOrError = CannotDeleteLinkedPersistedQueryListError | DeletePersistedQueryListResult | PermissionError;

export type DeleteProposalLifecycleSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type DeleteProposalLifecycleSubscriptionResult = DeleteProposalLifecycleSubscriptionSuccess | NotFoundError | PermissionError | ValidationError;

export type DeleteProposalLifecycleSubscriptionSuccess = {
  __typename: 'DeleteProposalLifecycleSubscriptionSuccess';
  /** The id of the ProposalLifecycleSubscription that was deleted */
  id: Scalars['ID']['output'];
};

export type DeleteProposalSubgraphInput = {
  previousLaunchId?: InputMaybe<Scalars['ID']['input']>;
  subgraphName: Scalars['String']['input'];
  summary: Scalars['String']['input'];
};

export type DeleteProposalSubgraphResult = PermissionError | Proposal | ValidationError;

/** Result of delete: the owning account, or an error explaining why it could not be deleted. */
export type DeleteS3IntegrationResult = Account | InvalidInputError | NotFoundError | PermissionError;

/** The result of attempting to delete a graph variant. */
export type DeleteSchemaTagResult = {
  __typename: 'DeleteSchemaTagResult';
  /** Whether the variant was deleted or not. */
  deleted: Scalars['Boolean']['output'];
};

export type DeleteTestRouterResult = CloudRouterTestingInvalidInputErrors | DeleteTestRouterSuccess;

export type DeleteTestRouterSuccess = {
  __typename: 'DeleteTestRouterSuccess';
  jobId: Scalars['String']['output'];
};

export enum DeletionTargetType {
  ACCOUNT = 'ACCOUNT',
  USER = 'USER'
}

/** Represents the possible outcomes of a destroyRouter mutation */
export type DestroyRouterResult = DestroyRouterSuccess | InternalServerError | InvalidInputErrors;

/** Success branch of a destroyRouter mutation */
export type DestroyRouterSuccess = {
  __typename: 'DestroyRouterSuccess';
  /**
   * Order for the destroyRouter mutation
   *
   * This could be empty if the router is already destroyed or doesn't exist, but should still
   * be treated as a success.
   */
  order: Maybe<Order>;
};

/** Support for a single directive on a graph variant */
export type DirectiveSupportStatus = {
  __typename: 'DirectiveSupportStatus';
  /** whether the directive is supported on the current graph variant */
  enabled: Scalars['Boolean']['output'];
  /** name of the directive */
  name: Scalars['String']['output'];
};

/** Documentation access and search functionality */
export type Documentation = {
  __typename: 'Documentation';
  /** Retrieve a specific documentation page by its slug */
  page: Maybe<DocumentationPage>;
  /** Search for documentation pages matching the query */
  search: Array<DocumentationPage>;
};


/** Documentation access and search functionality */
export type DocumentationpageArgs = {
  slug: Scalars['String']['input'];
};


/** Documentation access and search functionality */
export type DocumentationsearchArgs = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

/** Input parameters for slicing documentation content */
export type DocumentationContentSliceInput = {
  /** Maximum number of characters to return */
  maxCharacters?: InputMaybe<Scalars['Int']['input']>;
  /** The section index to start from */
  sectionIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a single documentation page */
export type DocumentationPage = {
  __typename: 'DocumentationPage';
  /** The content of the page, optionally sliced based on input parameters */
  contentSlice: ContentSlice;
  /** Unique slug identifier for the page */
  slug: Scalars['String']['output'];
  /** The full URL of the documentation page */
  url: Scalars['String']['output'];
};


/** Represents a single documentation page */
export type DocumentationPagecontentSliceArgs = {
  slice?: InputMaybe<DocumentationContentSliceInput>;
};

/** The result of a schema checks workflow that was run on a downstream variant as part of checks for the corresponding source variant. Most commonly, these downstream checks are [contract checks](https://www.apollographql.com/docs/studio/contracts#contract-checks). */
export type DownstreamCheckResult = {
  __typename: 'DownstreamCheckResult';
  /** Whether the downstream check workflow blocks the upstream check workflow from completing. */
  blocking: Scalars['Boolean']['output'];
  /** The ID of the graph that the downstream variant belongs to. */
  downstreamGraphID: Scalars['String']['output'];
  /** The name of the downstream variant. */
  downstreamVariantName: Scalars['String']['output'];
  /**
   * The downstream checks workflow that this result corresponds to. This value is null
   * if the workflow hasn't been initialized yet, or if the downstream variant was deleted.
   */
  downstreamWorkflow: Maybe<CheckWorkflow>;
  /**
   * Whether the downstream check workflow is causing the upstream check workflow to fail. This occurs
   * when the downstream check workflow is both blocking and failing. This may be null while the
   * downstream check workflow is pending.
   */
  failsUpstreamWorkflow: Maybe<Scalars['Boolean']['output']>;
  /** The downstream checks task that this result corresponds to. */
  workflowTask: DownstreamCheckTask;
};

export type DownstreamCheckTask = CheckWorkflowTask & {
  __typename: 'DownstreamCheckTask';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /**
   * A list of results for all downstream checks triggered as part of the source variant's checks workflow.
   * This value is null if the task hasn't been initialized yet, or if the build task fails (the build task is a
   * prerequisite to this task). This value is _not_ null _while_ the task is running. The returned list is empty
   * if the source variant has no downstream variants.
   */
  results: Maybe<Array<DownstreamCheckResult>>;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

export enum DownstreamLaunchInitiation {
  /**
   * Initiate the creation of downstream launches associated with this subgraph publication asynchronously.
   * The resulting API response may not provide specific details about triggered downstream launches.
   */
  ASYNC = 'ASYNC',
  /**
   * Initiate the creation of downstream Launches associated with this subgraph publication synchronously.
   * Use this option to ensure that any downstream launches will be started before the publish mutation returns.
   * Note that this does not require launches to complete, but it does ensure that the downstream launch IDs are
   * available to be queried from a `CompositionAndUpsertResult`.
   */
  SYNC = 'SYNC'
}

export type DraftInvoice = {
  __typename: 'DraftInvoice';
  /** @deprecated This data came from Metronome and we no longer use Metronome */
  billingPeriodEndsAt: Scalars['Timestamp']['output'];
  /** @deprecated This data came from Metronome and we no longer use Metronome */
  billingPeriodStartsAt: Scalars['Timestamp']['output'];
  /**
   * The approximate date in the future we expect the customer to be billed if they fully complete the billing cycle
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  expectedInvoiceAt: Scalars['Timestamp']['output'];
  /**
   * When this invoice was sent to the customer, if it's been sent
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  invoicedAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Breakdown of this invoice's charges. May be empty if we don't have a breakdown
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  lineItems: Maybe<Array<InvoiceLineItem>>;
  /** @deprecated This data came from Metronome and we no longer use Metronome */
  subtotalInCents: Scalars['Int']['output'];
  /** @deprecated This data came from Metronome and we no longer use Metronome */
  totalInCents: Scalars['Int']['output'];
};

export type DuplicateOperationCollectionResult = OperationCollection | PermissionError | ValidationError;

export type DurationHistogram = {
  __typename: 'DurationHistogram';
  averageDurationMs: Maybe<Scalars['Float']['output']>;
  buckets: Array<DurationHistogramBucket>;
  durationMs: Maybe<Scalars['Float']['output']>;
  /** Counts per durationBucket, where sequences of zeroes are replaced with the negative of their size */
  sparseBuckets: Array<Scalars['Long']['output']>;
  totalCount: Scalars['Long']['output'];
  totalDurationMs: Scalars['Float']['output'];
};


export type DurationHistogramdurationMsArgs = {
  percentile: Scalars['Float']['input'];
};

export type DurationHistogramBucket = {
  __typename: 'DurationHistogramBucket';
  count: Scalars['Long']['output'];
  index: Scalars['Int']['output'];
  rangeBeginMs: Scalars['Float']['output'];
  rangeEndMs: Scalars['Float']['output'];
};

export type EdgeServerInfo = {
  /** A randomly generated UUID, immutable for the lifetime of the edge server runtime. */
  bootId: Scalars['String']['input'];
  /** A unique identifier for the executable GraphQL served by the edge server. length must be <= 64 characters. */
  executableSchemaId: Scalars['String']['input'];
  /** The graph variant, defaults to 'current' */
  graphVariant: Scalars['String']['input'];
  /** The version of the edge server reporting agent, e.g. apollo-server-2.8, graphql-java-3.1, etc. length must be <= 256 characters. */
  libraryVersion?: InputMaybe<Scalars['String']['input']>;
  /** The infra environment in which this edge server is running, e.g. localhost, Kubernetes, AWS Lambda, Google CloudRun, AWS ECS, etc. length must be <= 256 characters. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** The runtime in which the edge server is running, e.g. node 12.03, zulu8.46.0.19-ca-jdk8.0.252-macosx_x64, etc. length must be <= 256 characters. */
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  /** If available, an identifier for the edge server instance, such that when restarting this instance it will have the same serverId, with a different bootId. For example, in Kubernetes this might be the pod name. Length must be <= 256 characters. */
  serverId?: InputMaybe<Scalars['String']['input']>;
  /** An identifier used to distinguish the version (from the user's perspective) of the edge server's code itself. For instance, the git sha of the server's repository or the docker sha of the associated image this server runs with. Length must be <= 256 characters. */
  userVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Columns of EdgeServerInfos. */
export enum EdgeServerInfosColumn {
  BOOT_ID = 'BOOT_ID',
  EXECUTABLE_SCHEMA_ID = 'EXECUTABLE_SCHEMA_ID',
  LIBRARY_VERSION = 'LIBRARY_VERSION',
  PLATFORM = 'PLATFORM',
  RUNTIME_VERSION = 'RUNTIME_VERSION',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVER_ID = 'SERVER_ID',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  USER_VERSION = 'USER_VERSION'
}

export type EdgeServerInfosDimensions = {
  __typename: 'EdgeServerInfosDimensions';
  bootId: Maybe<Scalars['ID']['output']>;
  executableSchemaId: Maybe<Scalars['ID']['output']>;
  libraryVersion: Maybe<Scalars['String']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  runtimeVersion: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serverId: Maybe<Scalars['ID']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  userVersion: Maybe<Scalars['String']['output']>;
};

/** Filter for data in EdgeServerInfos. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type EdgeServerInfosFilter = {
  and?: InputMaybe<Array<EdgeServerInfosFilter>>;
  /** Selects rows whose bootId dimension equals the given value if not null. To query for the null value, use {in: {bootId: [null]}} instead. */
  bootId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose executableSchemaId dimension equals the given value if not null. To query for the null value, use {in: {executableSchemaId: [null]}} instead. */
  executableSchemaId?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<EdgeServerInfosFilterIn>;
  /** Selects rows whose libraryVersion dimension equals the given value if not null. To query for the null value, use {in: {libraryVersion: [null]}} instead. */
  libraryVersion?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<EdgeServerInfosFilter>;
  or?: InputMaybe<Array<EdgeServerInfosFilter>>;
  /** Selects rows whose platform dimension equals the given value if not null. To query for the null value, use {in: {platform: [null]}} instead. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose runtimeVersion dimension equals the given value if not null. To query for the null value, use {in: {runtimeVersion: [null]}} instead. */
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serverId dimension equals the given value if not null. To query for the null value, use {in: {serverId: [null]}} instead. */
  serverId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose userVersion dimension equals the given value if not null. To query for the null value, use {in: {userVersion: [null]}} instead. */
  userVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in EdgeServerInfos. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type EdgeServerInfosFilterIn = {
  /** Selects rows whose bootId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  bootId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose executableSchemaId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  executableSchemaId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose libraryVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  libraryVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose platform dimension is in the given list. A null value in the list means a row with null for that dimension. */
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose runtimeVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  runtimeVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serverId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serverId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose userVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  userVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EdgeServerInfosOrderBySpec = {
  column: EdgeServerInfosColumn;
  direction: Ordering;
};

export type EdgeServerInfosRecord = {
  __typename: 'EdgeServerInfosRecord';
  /** Dimensions of EdgeServerInfos that can be grouped by. */
  groupBy: EdgeServerInfosDimensions;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type EditCommentInput = {
  id: Scalars['String']['input'];
  message: Scalars['String']['input'];
  usersToNotify?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EditCommentResult = NotFoundError | ParentChangeProposalComment | ParentGeneralProposalComment | PermissionError | ReplyChangeProposalComment | ReplyGeneralProposalComment | ValidationError;

/** Education-specific data and functionality for a user */
export type Education = {
  __typename: 'Education';
  /** Recent pages visited by the user */
  recentPages: Array<RecentPage>;
};


/** Education-specific data and functionality for a user */
export type EducationrecentPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmailCategory {
  EDUCATIONAL = 'EDUCATIONAL'
}

export type EmailPreferences = {
  __typename: 'EmailPreferences';
  email: Scalars['String']['output'];
  subscriptions: Array<EmailCategory>;
  unsubscribedFromAll: Scalars['Boolean']['output'];
};

export enum EnforcementPolicy {
  CLIENT_NAME_CARDINALITY = 'CLIENT_NAME_CARDINALITY',
  CLIENT_VERSION_CARDINALITY = 'CLIENT_VERSION_CARDINALITY',
  OPERATION_ID_CARDINALITY = 'OPERATION_ID_CARDINALITY'
}

/** Usage stats describing extended-reference reporting for enhanced operation checks. */
export type EnhancedModeStats = {
  __typename: 'EnhancedModeStats';
  /** Timestamp of the latest usage report without extended references. */
  latestTimeWithoutEnhancedMode: Maybe<Scalars['Timestamp']['output']>;
  /** Number of executions reporting extended references. */
  queriesWithEnhancedMode: Scalars['Int']['output'];
  /** Number of executions not reporting extended references. */
  queriesWithoutEnhancedMode: Scalars['Int']['output'];
};

export type EntitiesError = {
  __typename: 'EntitiesError';
  message: Scalars['String']['output'];
};

export type EntitiesErrorResponse = {
  __typename: 'EntitiesErrorResponse';
  errors: Array<EntitiesError>;
};

export type EntitiesResponse = {
  __typename: 'EntitiesResponse';
  entities: Array<Entity>;
};

export type EntitiesResponseOrError = EntitiesErrorResponse | EntitiesResponse;

export type Entity = {
  __typename: 'Entity';
  subgraphKeys: Maybe<Array<SubgraphKeyMap>>;
  typename: Scalars['String']['output'];
};

/** GraphQL Error */
export type Error = {
  /** The error message */
  message: Scalars['String']['output'];
};

export type ErrorInsightsListFilterInInput = {
  /** Filters results to errors reported by any of the given agents (e.g. `apollo-router`). */
  agent?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to errors whose requests were reported with any of the given client names. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to errors whose requests were reported with any of the given client versions. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to errors that were reported with any of the given error codes. */
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to errors attributed to any of the given downstream subgraph or connector services. */
  service?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results by service when grouping by service, otherwise by reporting agent. */
  serviceOrAgent?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ErrorInsightsListFilterInput = {
  /** Filters results to errors reported by this agent (e.g. `apollo-router`). */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to errors whose requests were reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to errors whose requests were reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to errors that were reported with this exact error code. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<ErrorInsightsListFilterInInput>;
  /** Filters results to errors observed for this operation id. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<ErrorInsightsListFilterInput>>;
  /** Filters results to errors that occurred at this response path. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to errors attributed to this downstream subgraph or connector service. */
  service?: InputMaybe<Scalars['String']['input']>;
  /** Filters results by service when grouping by service, otherwise by reporting agent. */
  serviceOrAgent?: InputMaybe<Scalars['String']['input']>;
};

export enum ErrorInsightsListGroupByColumn {
  AGENT = 'AGENT',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CODE = 'CODE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  PATH = 'PATH',
  SERVICE = 'SERVICE',
  SERVICE_OR_AGENT = 'SERVICE_OR_AGENT',
  SEVERITY = 'SEVERITY'
}

export type ErrorInsightsListItem = {
  __typename: 'ErrorInsightsListItem';
  /** The reporting agent (e.g. `apollo-router`) attributed to these errors (if grouped by agent). */
  agent: Maybe<Scalars['String']['output']>;
  /** The client name that issued the requests resulting in these errors (if grouped by client). */
  clientName: Maybe<Scalars['String']['output']>;
  /** The client version that issued the requests resulting in these errors (if grouped by client). */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** The error code reported with these errors (if grouped by error code). */
  code: Maybe<Scalars['String']['output']>;
  /**
   * The number of errors observed in the selected time range, matching the grouping. Deprecated alias for errorCount.
   * @deprecated Use errorCount instead
   */
  count: Scalars['Long']['output'];
  /** The number of errors observed in the selected time range, matching the grouping. */
  errorCount: Scalars['Long']['output'];
  /** The number of operations that produced errors in the selected time range, if available for the grouping. */
  operationCount: Maybe<Scalars['Long']['output']>;
  /** The unique id of the operation associated with the errors (if grouped by operation). */
  operationId: Maybe<Scalars['String']['output']>;
  /** The name of the operation associated with the errors (if grouped by operation). */
  operationName: Maybe<Scalars['String']['output']>;
  /** The response path at which the errors occurred (if grouped by path). */
  path: Maybe<Scalars['String']['output']>;
  /** The downstream subgraph or connector service that produced the errors (if grouped by service). */
  service: Maybe<Scalars['String']['output']>;
  /** The service name when grouping by service, otherwise the reporting agent name. */
  serviceOrAgent: Maybe<Scalars['String']['output']>;
  /** The severity classification reported with the errors. */
  severity: Maybe<ErrorInsightsSeverity>;
  /** A sample of traces that contain the errors represented by this row, up to the given limit. */
  traceRefs: Maybe<ErrorTraceRefsResult>;
};


export type ErrorInsightsListItemtraceRefsArgs = {
  limit: Scalars['Int']['input'];
};

export enum ErrorInsightsListOrderByColumn {
  AGENT = 'AGENT',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CODE = 'CODE',
  COUNT = 'COUNT',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  PATH = 'PATH',
  SERVICE_OR_AGENT = 'SERVICE_OR_AGENT',
  SEVERITY = 'SEVERITY',
  TIMESTAMP = 'TIMESTAMP'
}

export type ErrorInsightsListOrderByInput = {
  /** The column to order results by. */
  column: ErrorInsightsListOrderByColumn;
  /** The order direction, ascending or descending. */
  direction: Ordering;
};

/** Information about pagination in a connection. */
export type ErrorInsightsListPageInfo = {
  __typename: 'ErrorInsightsListPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum ErrorInsightsSeverity {
  ERROR = 'ERROR',
  UNKNOWN = 'UNKNOWN',
  WARN = 'WARN'
}

export enum ErrorInsightsStrategy {
  ERROR_STATS = 'ERROR_STATS',
  FEDERATED_ERROR_STATS = 'FEDERATED_ERROR_STATS',
  MIXED = 'MIXED'
}

/** A single time-bucketed record in an error insights timeseries result. */
export type ErrorInsightsTimeseriesRecord = {
  __typename: 'ErrorInsightsTimeseriesRecord';
  /** The aggregated error insights data for this time bucket, matching the grouping. */
  data: ErrorInsightsListItem;
  /** The query strategy used to produce this record. */
  strategy: ErrorInsightsStrategy;
  /** The start of the time bucket for this record. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A timeseries of error counts bucketed by time over the requested range. */
export type ErrorInsightsTimeseriesResult = {
  __typename: 'ErrorInsightsTimeseriesResult';
  /** The list of time-bucketed records returned for the requested range and grouping. */
  records: Array<ErrorInsightsTimeseriesRecord>;
  /** The requested `from` timestamp, rounded down to the nearest bucket boundary. */
  roundedDownFrom: Scalars['Timestamp']['output'];
  /** The requested `to` timestamp, rounded up to the nearest bucket boundary. */
  roundedUpTo: Scalars['Timestamp']['output'];
  /** The total number of errors observed across all records in this result. */
  totalErrors: Scalars['Int']['output'];
};

/** Columns of ErrorStats. */
export enum ErrorStatsColumn {
  ACCOUNT_ID = 'ACCOUNT_ID',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERRORS_COUNT = 'ERRORS_COUNT',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type ErrorStatsDimensions = {
  __typename: 'ErrorStatsDimensions';
  accountId: Maybe<Scalars['ID']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in ErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ErrorStatsFilter = {
  /** Selects rows whose accountId dimension equals the given value if not null. To query for the null value, use {in: {accountId: [null]}} instead. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  and?: InputMaybe<Array<ErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ErrorStatsFilterIn>;
  not?: InputMaybe<ErrorStatsFilter>;
  or?: InputMaybe<Array<ErrorStatsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in ErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ErrorStatsFilterIn = {
  /** Selects rows whose accountId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  accountId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ErrorStatsMetrics = {
  __typename: 'ErrorStatsMetrics';
  errorsCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type ErrorStatsOrderBySpec = {
  column: ErrorStatsColumn;
  direction: Ordering;
};

export type ErrorStatsRecord = {
  __typename: 'ErrorStatsRecord';
  /** Dimensions of ErrorStats that can be grouped by. */
  groupBy: ErrorStatsDimensions;
  /** Metrics of ErrorStats that can be aggregated over. */
  metrics: ErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A reference to a recorded trace that contains an error matching the parent row's grouping. */
export type ErrorTraceRef = {
  __typename: 'ErrorTraceRef';
  /** The error message recorded in the trace, if available. */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The unique id of the operation associated with the trace. */
  operationId: Scalars['String']['output'];
  /** The timestamp at which the error was observed in the trace. */
  timestamp: Scalars['Timestamp']['output'];
  /** The unique id of the trace that contains the error. */
  traceId: Scalars['String']['output'];
};

/** A list of sample traces that contain errors matching the parent row's grouping. */
export type ErrorTraceRefsResult = {
  __typename: 'ErrorTraceRefsResult';
  /** A bounded sample of trace references matching the parent row's grouping. */
  items: Array<ErrorTraceRef>;
  /** The total number of matching traces available, even if only a subset is returned in `items`. */
  totalCount: Scalars['Int']['output'];
};

/** Input for the evaluateOperation query. */
export type EvaluateOperationInput = {
  /**
   * Optional: the Application record the operation originated from.
   * When provided, its UUID string is passed as `app_id` to OPA, activating
   * app-scoped policy rules.
   */
  applicationId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The groups the operation originator belongs to.
   * Defaults to `[]` when omitted.
   */
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The GraphQL operation text to evaluate (query or mutation). */
  operation: Scalars['String']['input'];
  /**
   * The principal_id of the operation originator (the caller whose access
   * is being simulated — NOT the Studio user making this request).
   * Defaults to `""` when omitted; only wildcard rules (no principal target) fire.
   */
  principalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: the Service record being queried.
   * When provided, its UUID string is passed as `service_id` to OPA, activating
   * service-targeted policy rules.
   */
  serviceId?: InputMaybe<Scalars['UUID']['input']>;
};

/**  Input parameters for run explorer operation event. */
export enum EventEnum {
  CLICK_CHECK_LIST = 'CLICK_CHECK_LIST',
  CLICK_GO_TO_GRAPH_SETTINGS = 'CLICK_GO_TO_GRAPH_SETTINGS',
  RUN_EXPLORER_OPERATION = 'RUN_EXPLORER_OPERATION'
}

/** Excluded operation for a graph. */
export type ExcludedOperation = {
  __typename: 'ExcludedOperation';
  /** Operation ID to exclude from schema check. */
  ID: Scalars['ID']['output'];
};

/** Option to filter by operation ID. */
export type ExcludedOperationInput = {
  /** Operation ID to exclude from schema check. */
  ID: Scalars['ID']['input'];
};

export type ExtendedRefsUsage = {
  __typename: 'ExtendedRefsUsage';
  /** The first time usage of this feature was reported for this variant to Apollo by the Router, or null if such usage has never been reported. */
  firstSeenAt: Maybe<Scalars['Timestamp']['output']>;
  /** The last time usage of this feature was reported for this variant to Apollo by the Router, or null if such usage has never been reported. */
  lastSeenAt: Maybe<Scalars['Timestamp']['output']>;
};

/** A recorded report that a specific diff item is a false positive. */
export type FalsePositiveFlag = {
  __typename: 'FalsePositiveFlag';
  /** When this false-positive report was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The type of diff change that was flagged as a false positive. Null for note-only reports. */
  diffItemType: Maybe<FlatDiffType>;
  /** Unique identifier for this false-positive report. */
  id: Scalars['ID']['output'];
  /** The schema coordinate that was flagged, e.g. "User.name" or "Query.users". Null for note-only reports. */
  schemaCoordinate: Maybe<Scalars['String']['output']>;
  /** '#@!api!@#' for api schema, '#@!supergraph!@#' for supergraph schema, subgraph otherwise */
  schemaScope: Scalars['String']['output'];
};

/** A single diff element being reported as a false positive. beforeText and afterText are SDL captured at report time. Newer Studio clients send a coordinate-level snippet (the changed member with its parent type header); older clients send the full type. */
export type FalsePositiveFlagElementInput = {
  /** SDL for the after state: a coordinate-level snippet or the full type, depending on the client. Empty string when there is no after state. */
  afterText: Scalars['String']['input'];
  /** SDL for the before state: a coordinate-level snippet or the full type, depending on the client. Empty string when there is no before state. */
  beforeText: Scalars['String']['input'];
  /** The type of diff change being flagged. */
  diffItemType: FlatDiffType;
  /** The schema coordinate being flagged, e.g. "User.name" or "Query.users". */
  schemaCoordinate: Scalars['String']['input'];
};

export type FeatureIntros = {
  __typename: 'FeatureIntros';
  /** @deprecated No longer supported */
  devGraph: Scalars['Boolean']['output'];
  federatedGraph: Scalars['Boolean']['output'];
  freeConsumerSeats: Scalars['Boolean']['output'];
};

/** Feature Intros Input Type */
export type FeatureIntrosInput = {
  /** @deprecated No longer supported */
  devGraph?: InputMaybe<Scalars['Boolean']['input']>;
  federatedGraph?: InputMaybe<Scalars['Boolean']['input']>;
  freeConsumerSeats?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Columns of FederatedErrorStats. */
export enum FederatedErrorStatsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_COUNT = 'ERROR_COUNT',
  ERROR_PATH = 'ERROR_PATH',
  ERROR_SERVICE = 'ERROR_SERVICE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  SEVERITY = 'SEVERITY',
  TIMESTAMP = 'TIMESTAMP'
}

export type FederatedErrorStatsDimensions = {
  __typename: 'FederatedErrorStatsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorPath: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  severity: Maybe<Scalars['String']['output']>;
};

/** Filter for data in FederatedErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type FederatedErrorStatsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<FederatedErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorPath dimension equals the given value if not null. To query for the null value, use {in: {errorPath: [null]}} instead. */
  errorPath?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<FederatedErrorStatsFilterIn>;
  not?: InputMaybe<FederatedErrorStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<FederatedErrorStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose severity dimension equals the given value if not null. To query for the null value, use {in: {severity: [null]}} instead. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in FederatedErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type FederatedErrorStatsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorPath dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose severity dimension is in the given list. A null value in the list means a row with null for that dimension. */
  severity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FederatedErrorStatsMetrics = {
  __typename: 'FederatedErrorStatsMetrics';
  errorCount: Scalars['Long']['output'];
};

export type FederatedErrorStatsOrderBySpec = {
  column: FederatedErrorStatsColumn;
  direction: Ordering;
};

export type FederatedErrorStatsRecord = {
  __typename: 'FederatedErrorStatsRecord';
  /** Dimensions of FederatedErrorStats that can be grouped by. */
  groupBy: FederatedErrorStatsDimensions;
  /** Metrics of FederatedErrorStats that can be aggregated over. */
  metrics: FederatedErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A single subgraph in a supergraph. Every supergraph managed by Apollo Studio includes at least one subgraph. See https://www.apollographql.com/docs/federation/managed-federation/overview/ for more information. */
export type FederatedImplementingService = {
  __typename: 'FederatedImplementingService';
  /** The subgraph's current active schema, used in supergraph composition for the the associated variant. */
  activePartialSchema: PartialSchema;
  /** The timestamp when the subgraph was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The timestamp when the subgraph was deleted. Null if it wasn't deleted. */
  deletedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The ID of the graph this subgraph belongs to. */
  graphID: Scalars['String']['output'];
  /** The name of the graph variant this subgraph belongs to. */
  graphVariant: Scalars['String']['output'];
  /** The subgraph's name. */
  name: Scalars['String']['output'];
  /** The current user-provided version/edition of the subgraph. Typically a Git SHA or docker image ID. */
  revision: Scalars['String']['output'];
  /** The timestamp when the subgraph was most recently updated. */
  updatedAt: Scalars['Timestamp']['output'];
  /** The URL of the subgraph's GraphQL endpoint. */
  url: Maybe<Scalars['String']['output']>;
};

/** A minimal representation of a federated implementing service, using only a name and partial schema SDL */
export type FederatedImplementingServicePartialSchema = {
  __typename: 'FederatedImplementingServicePartialSchema';
  /** The name of the implementing service */
  name: Scalars['String']['output'];
  /** The partial schema of the implementing service */
  sdl: Scalars['String']['output'];
};

/** Container for a list of subgraphs composing a supergraph. */
export type FederatedImplementingServices = {
  __typename: 'FederatedImplementingServices';
  /** The list of underlying subgraphs. */
  services: Array<FederatedImplementingService>;
};

/** A single question within a feedback survey */
export type FeedbackQuestion = {
  __typename: 'FeedbackQuestion';
  /** Additional instructions or context for the question, such as scale explanations (e.g. 1 = strongly disagree, 7 = strongly agree) */
  description: Maybe<Scalars['String']['output']>;
  /** Stable identifier for this question, used as questionId in responses */
  id: Scalars['ID']['output'];
  /** Predefined answer options, populated for MULTIPLE_CHOICE questions */
  options: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the learner must answer this question before submitting */
  required: Scalars['Boolean']['output'];
  /** The question text to display to the learner */
  text: Scalars['String']['output'];
  /** The input type the client should render */
  type: FeedbackQuestionKind;
};

/** Input for a single question within a feedback survey */
export type FeedbackQuestionInput = {
  /** Additional instructions or context for the question, such as scale explanations (e.g. 1 = strongly disagree, 7 = strongly agree) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Stable identifier for this question — reuse across versions to preserve response continuity */
  id: Scalars['ID']['input'];
  /** Predefined answer options, required for MULTIPLE_CHOICE questions */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the learner must answer this question before submitting */
  required: Scalars['Boolean']['input'];
  /** The question text to display to the learner */
  text: Scalars['String']['input'];
  /** The input type the client should render */
  type: FeedbackQuestionKind;
};

/** The display type of a feedback question, used by the client to render the correct input */
export enum FeedbackQuestionKind {
  /** A yes/no input */
  BOOLEAN = 'BOOLEAN',
  /** An open-ended text input */
  FREE_TEXT = 'FREE_TEXT',
  /** A single-select list of predefined options */
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  /** A 0–10 Net Promoter Score input */
  NPS = 'NPS',
  /** A numeric rating input (e.g. 1–5 stars) */
  RATING = 'RATING'
}

/** A reusable, versioned feedback survey definition */
export type FeedbackSurvey = {
  __typename: 'FeedbackSurvey';
  /** Unique identifier for this survey */
  id: Scalars['ID']['output'];
  /** Human-readable name for this survey */
  name: Scalars['String']['output'];
  /** The ordered list of questions in this survey */
  questions: Array<FeedbackQuestion>;
  /** The current version of this survey, auto-incremented on each update */
  version: Scalars['String']['output'];
};

/** Counts of changes at the field level, including objects, interfaces, and input fields. */
export type FieldChangeSummaryCounts = {
  __typename: 'FieldChangeSummaryCounts';
  /** Number of changes that are additions of fields to object, interface, and input types. */
  additions: Scalars['Int']['output'];
  /**
   * Number of changes that are field edits. This includes fields changing type and any field
   * deprecation and description changes, but also includes any argument changes and any input object
   * field changes.
   */
  edits: Scalars['Int']['output'];
  /** Number of changes that are removals of fields from object, interface, and input types. */
  removals: Scalars['Int']['output'];
};

/** Full audit trace for a single field's policy decision. */
export type FieldDecision = {
  __typename: 'FieldDecision';
  /** Whether the rule decision is active (false = overridden by an exception). */
  active: Scalars['Boolean']['output'];
  /** The winning effect. One of: `"allow"`, `"deny"`, `"mask"`. */
  baseEffect: Scalars['String']['output'];
  /**
   * For deny rules: controls how the field appears in schema/UI.
   * One of: `"hidden"`, `"visible"`, `"requestable"`.
   */
  denyVisibility: Maybe<Scalars['String']['output']>;
  /** The IDs of policy rules that were matched. */
  matchedRuleIds: Array<Scalars['String']['output']>;
  /** ID of the exception that overrode this decision (when active=false). */
  overriddenBy: Maybe<Scalars['String']['output']>;
  /** `config_priority` of the winning rule — higher values take precedence. */
  priority: Maybe<Scalars['Int']['output']>;
  /** Human-readable reason for denial. */
  reason: Maybe<Scalars['String']['output']>;
  /** True if this is a shadow-mode evaluation (not enforced in production). */
  shadow: Scalars['Boolean']['output'];
};

/** Policy evaluation result for one field in the operation. */
export type FieldEvaluation = {
  __typename: 'FieldEvaluation';
  /** Classification tags on this field (e.g. ["sensitivity:PII"]). */
  classifications: Array<Scalars['String']['output']>;
  /**
   * The winning policy decision for this field. Null when no rule matched
   * (field is effectively ALLOWED with no policy consideration).
   */
  decision: Maybe<FieldDecision>;
  /** Qualified field path, e.g. "AshbyJob.salary". */
  fieldPath: Scalars['String']['output'];
};

/** Columns of FieldExecutions. */
export enum FieldExecutionsColumn {
  ERRORS_COUNT = 'ERRORS_COUNT',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  FIELD_HISTOGRAM = 'FIELD_HISTOGRAM',
  FIELD_NAME = 'FIELD_NAME',
  OBSERVED_EXECUTION_COUNT = 'OBSERVED_EXECUTION_COUNT',
  PARENT_TYPE = 'PARENT_TYPE',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type FieldExecutionsDimensions = {
  __typename: 'FieldExecutionsDimensions';
  field: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in FieldExecutions. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type FieldExecutionsFilter = {
  and?: InputMaybe<Array<FieldExecutionsFilter>>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<FieldExecutionsFilterIn>;
  not?: InputMaybe<FieldExecutionsFilter>;
  or?: InputMaybe<Array<FieldExecutionsFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in FieldExecutions. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type FieldExecutionsFilterIn = {
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type FieldExecutionsMetrics = {
  __typename: 'FieldExecutionsMetrics';
  errorsCount: Scalars['Long']['output'];
  estimatedExecutionCount: Scalars['Long']['output'];
  fieldHistogram: DurationHistogram;
  observedExecutionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type FieldExecutionsOrderBySpec = {
  column: FieldExecutionsColumn;
  direction: Ordering;
};

export type FieldExecutionsRecord = {
  __typename: 'FieldExecutionsRecord';
  /** Dimensions of FieldExecutions that can be grouped by. */
  groupBy: FieldExecutionsDimensions;
  /** Metrics of FieldExecutions that can be aggregated over. */
  metrics: FieldExecutionsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Metadata about when a field was first and last seen in operation traces */
export type FieldInsights = {
  __typename: 'FieldInsights';
  /** If the first or last seen timestamps are earlier than this timestamp, we can't tell the exact date that we saw this field since our data is bound by the retention period. */
  earliestRetentionTime: Maybe<Scalars['Timestamp']['output']>;
  /** The earliest time we saw references or executions for this field. Null if the field has never been seen or it is not in the schema. */
  firstSeen: Maybe<Scalars['Timestamp']['output']>;
  /** The most recent time we saw references or executions for this field. Null if the field has never been seen or it is not in the schema. */
  lastSeen: Maybe<Scalars['Timestamp']['output']>;
};

export type FieldInsightsListFilterInInput = {
  /** Filters results to fields whose usage was reported with any of the given client names. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to fields whose usage was reported with any of the given client versions. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FieldInsightsListFilterInput = {
  /** Filters results to fields whose usage was reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to fields whose usage was reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<FieldInsightsListFilterInInput>;
  /** If set, restricts results to fields whose `@deprecated` status matches this value in the active schema. */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, restricts results to fields whose observed usage in the selected time range matches this value. */
  isUnused?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<FieldInsightsListFilterInput>>;
  /** Filters on partial string matches of Parent Type and Field Name */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FieldInsightsListItem = {
  __typename: 'FieldInsightsListItem';
  /** The count of errors seen for this field. This can be null depending on the sort order. */
  errorCount: Maybe<Scalars['Long']['output']>;
  /** The count of errors seen for this field per minute. This can be null depending on the sort order. */
  errorCountPerMin: Maybe<Scalars['Float']['output']>;
  /** The percentage of errors vs successful resolutions for this field. This can be null depending on the sort order. */
  errorPercentage: Maybe<Scalars['Float']['output']>;
  /** The estimated number of field executions for this field, based on the field execution sample rate. This can be null depending on the sort order. */
  estimatedExecutionCount: Maybe<Scalars['Long']['output']>;
  /** The number of field executions recorded for this field. This can be null depending on the sort order. */
  executionCount: Maybe<Scalars['Long']['output']>;
  /** The name of the field (e.g. `email` for `User.email`). */
  fieldName: Scalars['String']['output'];
  /** Whether the field is marked `@deprecated` in the active schema for the variant. */
  isDeprecated: Scalars['Boolean']['output'];
  /** Whether the field has had no observed usage in the selected time range. */
  isUnused: Scalars['Boolean']['output'];
  /** The p50 of the latency of the resolution of this field. This can be null depending on the filter and sort order. */
  p50LatencyMs: Maybe<Scalars['Float']['output']>;
  /** The p90 of the latency of the resolution of this field. This can be null depending on the filter and sort order. */
  p90LatencyMs: Maybe<Scalars['Float']['output']>;
  /** The p95 of the latency of the resolution of this field. This can be null depending on the filter and sort order. */
  p95LatencyMs: Maybe<Scalars['Float']['output']>;
  /** The p99 of the latency of the resolution of this field. This can be null depending on the filter and sort order. */
  p99LatencyMs: Maybe<Scalars['Float']['output']>;
  /** The name of the type that declares the field (e.g. `User` for `User.email`). */
  parentType: Scalars['String']['output'];
  /** The count of operations that reference the field. This can be null depending on the sort order. */
  referencingOperationCount: Maybe<Scalars['Long']['output']>;
  /** The count of operations that reference the field per minute. This can be null depending on the sort order. */
  referencingOperationCountPerMin: Maybe<Scalars['Float']['output']>;
};

export enum FieldInsightsListOrderByColumn {
  ERROR_COUNT = 'ERROR_COUNT',
  ERROR_COUNT_PER_MIN = 'ERROR_COUNT_PER_MIN',
  ERROR_PERCENTAGE = 'ERROR_PERCENTAGE',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  PARENT_TYPE_AND_FIELD_NAME = 'PARENT_TYPE_AND_FIELD_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REFERENCING_OPERATION_COUNT_PER_MIN = 'REFERENCING_OPERATION_COUNT_PER_MIN',
  SERVICE_TIME_P50 = 'SERVICE_TIME_P50',
  SERVICE_TIME_P90 = 'SERVICE_TIME_P90',
  SERVICE_TIME_P95 = 'SERVICE_TIME_P95',
  SERVICE_TIME_P99 = 'SERVICE_TIME_P99'
}

export type FieldInsightsListOrderByInput = {
  /** The column to order results by. */
  column: FieldInsightsListOrderByColumn;
  /** The order direction, ascending or descending. */
  direction: Ordering;
};

/** Information about pagination in a connection. */
export type FieldInsightsListPageInfo = {
  __typename: 'FieldInsightsListPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** Columns of FieldUsage. */
export enum FieldUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  FIELD_NAME = 'FIELD_NAME',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PARENT_TYPE = 'PARENT_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type FieldUsageDimensions = {
  __typename: 'FieldUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in FieldUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type FieldUsageFilter = {
  and?: InputMaybe<Array<FieldUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<FieldUsageFilterIn>;
  not?: InputMaybe<FieldUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<FieldUsageFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in FieldUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type FieldUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type FieldUsageMetrics = {
  __typename: 'FieldUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
};

export type FieldUsageOrderBySpec = {
  column: FieldUsageColumn;
  direction: Ordering;
};

export type FieldUsageRecord = {
  __typename: 'FieldUsageRecord';
  /** Dimensions of FieldUsage that can be grouped by. */
  groupBy: FieldUsageDimensions;
  /** Metrics of FieldUsage that can be aggregated over. */
  metrics: FieldUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type FileCoordinate = {
  __typename: 'FileCoordinate';
  byteOffset: Scalars['Int']['output'];
  column: Scalars['Int']['output'];
  line: Scalars['Int']['output'];
};

export type FileCoordinateInput = {
  byteOffset: Scalars['Int']['input'];
  column: Scalars['Int']['input'];
  line: Scalars['Int']['input'];
};

export type FileLocation = {
  __typename: 'FileLocation';
  end: FileCoordinate;
  start: FileCoordinate;
  subgraphName: Maybe<Scalars['String']['output']>;
};

export type FileLocationInput = {
  end: FileCoordinateInput;
  start: FileCoordinateInput;
  subgraphName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterBuildCheckFailed = BuildCheckFailed & BuildCheckResult & FilterBuildCheckResult & {
  __typename: 'FilterBuildCheckFailed';
  buildInputs: FilterBuildInputs;
  buildPipelineTrack: BuildPipelineTrack;
  errors: Array<BuildError>;
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  workflowTask: FilterCheckTask;
};

export type FilterBuildCheckPassed = BuildCheckPassed & BuildCheckResult & FilterBuildCheckResult & {
  __typename: 'FilterBuildCheckPassed';
  buildInputs: FilterBuildInputs;
  buildPipelineTrack: BuildPipelineTrack;
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  supergraphSchemaHash: Scalars['SHA256']['output'];
  workflowTask: FilterCheckTask;
};

export type FilterBuildCheckResult = {
  buildInputs: FilterBuildInputs;
  /**
   * The build pipeline track of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  buildPipelineTrack: BuildPipelineTrack;
  /**
   * The Federation version of the build task, which indicates what gateway/router versions the
   *  build pipeline is intended to support (and accordingly controls the version of code).
   */
  federationVersion: Scalars['FederationVersion']['output'];
  id: Scalars['ID']['output'];
  /** Whether the build task passed or failed. */
  passed: Scalars['Boolean']['output'];
  workflowTask: FilterCheckTask;
};

/** Inputs provided to the build for a contract variant, which filters types and fields from a source variant's schema. */
export type FilterBuildInput = {
  __typename: 'FilterBuildInput';
  /** Schema filtering rules for the build, such as tags to include or exclude from the source variant schema. */
  filterConfig: FilterConfig;
  /** The source variant schema document's SHA256 hash, represented as a hexadecimal string. */
  schemaHash: Scalars['String']['output'];
};

export type FilterBuildInputs = {
  __typename: 'FilterBuildInputs';
  /**
   * The build pipeline track used for filtering. Note this is taken from upstream check workflow
   * or launch.
   */
  buildPipelineTrack: BuildPipelineTrack;
  /** The exclude filters used for filtering. */
  exclude: Array<Scalars['String']['output']>;
  /**
   * The Federation version used for filtering. Note this is taken from upstream check workflow
   * or launch.
   */
  federationVersion: Scalars['FederationVersion']['output'];
  /**
   * Whether to hide unreachable objects, interfaces, unions, inputs, enums and scalars from
   * the resulting contract schema.
   */
  hideUnreachableTypes: Scalars['Boolean']['output'];
  /** The include filters used for filtering. */
  include: Array<Scalars['String']['output']>;
  /** The SHA-256 of the supergraph schema document used for filtering. */
  supergraphSchemaHash: Scalars['SHA256']['output'];
};

export type FilterCheckAsyncInput = {
  config: HistoricQueryParametersInput;
  filterChanges: FilterCheckFilterChanges;
  gitContext: GitContextInput;
};

export type FilterCheckFilterChanges = {
  excludeAdditions?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
  hideUnreachableTypesChange?: InputMaybe<Scalars['Boolean']['input']>;
  includeAdditions?: InputMaybe<Array<Scalars['String']['input']>>;
  includeRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterCheckTask = BuildCheckTask & CheckWorkflowTask & {
  __typename: 'FilterCheckTask';
  /** The result of the filter build check. This will be null when the task is initializing or running. */
  buildResult: Maybe<FilterBuildCheckResult>;
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  proposedBuildInputChanges: ProposedFilterBuildInputChanges;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** The filter configuration used to build a contract schema. The configuration consists of lists of tags for schema elements to include or exclude in the resulting schema. */
export type FilterConfig = {
  __typename: 'FilterConfig';
  /** Tags of schema elements to exclude from the contract schema. */
  exclude: Array<Scalars['String']['output']>;
  /** Whether to hide unreachable objects, interfaces, unions, inputs, enums and scalars from the resulting contract schema. */
  hideUnreachableTypes: Scalars['Boolean']['output'];
  /** Tags of schema elements to include in the contract schema. */
  include: Array<Scalars['String']['output']>;
};

export type FilterConfigInput = {
  /** A list of tags for schema elements to exclude from the resulting contract schema. */
  exclude: Array<Scalars['String']['input']>;
  /**
   * Whether to hide unreachable objects, interfaces, unions, inputs, enums and scalars from
   * the resulting contract schema. Defaults to `false`.
   */
  hideUnreachableTypes: Scalars['Boolean']['input'];
  /** A list of tags for schema elements to include in the resulting contract schema. */
  include: Array<Scalars['String']['input']>;
};

/** Represents a diff between two versions of a schema as a flat list of changes */
export type FlatDiff = {
  __typename: 'FlatDiff';
  diff: Array<FlatDiffItem>;
  id: Scalars['ID']['output'];
  summary: FlatDiffSummary;
};

export type FlatDiffAddArgument = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddArgument';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddDirective = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddDirective';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddDirectiveUsage = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddDirectiveUsage';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddEnum = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddEnum';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddEnumValue = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddEnumValue';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddField = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddField';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddImplementation = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddImplementation';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddInput = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddInput';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddInterface = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddInterface';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddObject = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddObject';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddScalar = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddScalar';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddSchemaDefinition = FlatDiffItem & {
  __typename: 'FlatDiffAddSchemaDefinition';
  type: FlatDiffType;
};

export type FlatDiffAddSchemaDirectiveUsage = FlatDiffItem & FlatDiffItemValue & {
  __typename: 'FlatDiffAddSchemaDirectiveUsage';
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddSchemaRootOperation = FlatDiffItem & FlatDiffItemRootType & FlatDiffItemValue & {
  __typename: 'FlatDiffAddSchemaRootOperation';
  rootType: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddUnion = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffAddUnion';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffAddUnionMember = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddUnionMember';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffAddValidLocation = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffAddValidLocation';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffChangeArgumentDefault = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemNullableValue & {
  __typename: 'FlatDiffChangeArgumentDefault';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Maybe<Scalars['String']['output']>;
};

export type FlatDiffChangeDescription = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemNullableValue & {
  __typename: 'FlatDiffChangeDescription';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Maybe<Scalars['String']['output']>;
};

export type FlatDiffChangeDirectiveRepeatable = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffChangeDirectiveRepeatable';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['Boolean']['output'];
};

export type FlatDiffChangeInputFieldDefault = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemNullableValue & {
  __typename: 'FlatDiffChangeInputFieldDefault';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Maybe<Scalars['String']['output']>;
};

export type FlatDiffChangeSchemaDescription = FlatDiffItem & FlatDiffItemNullableValue & {
  __typename: 'FlatDiffChangeSchemaDescription';
  type: FlatDiffType;
  value: Maybe<Scalars['String']['output']>;
};

export type FlatDiffItem = {
  type: FlatDiffType;
};

export type FlatDiffItemCoordinate = {
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffItemNullableValue = {
  type: FlatDiffType;
  value: Maybe<Scalars['String']['output']>;
};

export type FlatDiffItemRootType = {
  rootType: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffItemValue = {
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveArgument = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveArgument';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveDirective = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveDirective';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveDirectiveUsage = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveDirectiveUsage';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveEnum = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveEnum';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveEnumValue = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveEnumValue';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveField = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveField';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveImplementation = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveImplementation';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveInput = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveInput';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveInterface = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveInterface';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveObject = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveObject';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveScalar = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveScalar';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveSchemaDefinition = FlatDiffItem & {
  __typename: 'FlatDiffRemoveSchemaDefinition';
  type: FlatDiffType;
};

export type FlatDiffRemoveSchemaDirectiveUsage = FlatDiffItem & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveSchemaDirectiveUsage';
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveSchemaRootOperation = FlatDiffItem & FlatDiffItemRootType & {
  __typename: 'FlatDiffRemoveSchemaRootOperation';
  rootType: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveUnion = FlatDiffItem & FlatDiffItemCoordinate & {
  __typename: 'FlatDiffRemoveUnion';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
};

export type FlatDiffRemoveUnionMember = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveUnionMember';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffRemoveValidLocation = FlatDiffItem & FlatDiffItemCoordinate & FlatDiffItemValue & {
  __typename: 'FlatDiffRemoveValidLocation';
  coordinate: Scalars['String']['output'];
  type: FlatDiffType;
  value: Scalars['String']['output'];
};

export type FlatDiffResult = FlatDiff | NotFoundError | SchemaValidationError;

/** Represents a summary of a diff between two versions of a schema. */
export type FlatDiffSummary = {
  __typename: 'FlatDiffSummary';
  directive: FlatDiffTypeSummary;
  enum: FlatDiffTypeSummary;
  input: FlatDiffTypeSummary;
  interface: FlatDiffTypeSummary;
  object: FlatDiffTypeSummary;
  scalar: FlatDiffTypeSummary;
  schema: FlatDiffTypeSummary;
  union: FlatDiffTypeSummary;
};

export enum FlatDiffType {
  ADD_ARGUMENT = 'ADD_ARGUMENT',
  ADD_DIRECTIVE = 'ADD_DIRECTIVE',
  ADD_DIRECTIVE_USAGE = 'ADD_DIRECTIVE_USAGE',
  ADD_ENUM = 'ADD_ENUM',
  ADD_ENUM_VALUE = 'ADD_ENUM_VALUE',
  ADD_FIELD = 'ADD_FIELD',
  ADD_IMPLEMENTATION = 'ADD_IMPLEMENTATION',
  ADD_INPUT = 'ADD_INPUT',
  ADD_INTERFACE = 'ADD_INTERFACE',
  ADD_OBJECT = 'ADD_OBJECT',
  ADD_SCALAR = 'ADD_SCALAR',
  ADD_SCHEMA_DEFINITION = 'ADD_SCHEMA_DEFINITION',
  ADD_SCHEMA_DIRECTIVE_USAGE = 'ADD_SCHEMA_DIRECTIVE_USAGE',
  ADD_SCHEMA_ROOT_OPERATION = 'ADD_SCHEMA_ROOT_OPERATION',
  ADD_UNION = 'ADD_UNION',
  ADD_UNION_MEMBER = 'ADD_UNION_MEMBER',
  ADD_VALID_LOCATION = 'ADD_VALID_LOCATION',
  CHANGE_ARGUMENT_DEFAULT = 'CHANGE_ARGUMENT_DEFAULT',
  CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
  CHANGE_INPUT_FIELD_DEFAULT = 'CHANGE_INPUT_FIELD_DEFAULT',
  CHANGE_REPEATABLE = 'CHANGE_REPEATABLE',
  CHANGE_SCHEMA_DESCRIPTION = 'CHANGE_SCHEMA_DESCRIPTION',
  REMOVE_ARGUMENT = 'REMOVE_ARGUMENT',
  REMOVE_DIRECTIVE = 'REMOVE_DIRECTIVE',
  REMOVE_DIRECTIVE_USAGE = 'REMOVE_DIRECTIVE_USAGE',
  REMOVE_ENUM = 'REMOVE_ENUM',
  REMOVE_ENUM_VALUE = 'REMOVE_ENUM_VALUE',
  REMOVE_FIELD = 'REMOVE_FIELD',
  REMOVE_IMPLEMENTATION = 'REMOVE_IMPLEMENTATION',
  REMOVE_INPUT = 'REMOVE_INPUT',
  REMOVE_INTERFACE = 'REMOVE_INTERFACE',
  REMOVE_OBJECT = 'REMOVE_OBJECT',
  REMOVE_SCALAR = 'REMOVE_SCALAR',
  REMOVE_SCHEMA_DEFINITION = 'REMOVE_SCHEMA_DEFINITION',
  REMOVE_SCHEMA_DIRECTIVE_USAGE = 'REMOVE_SCHEMA_DIRECTIVE_USAGE',
  REMOVE_SCHEMA_ROOT_OPERATION = 'REMOVE_SCHEMA_ROOT_OPERATION',
  REMOVE_UNION = 'REMOVE_UNION',
  REMOVE_UNION_MEMBER = 'REMOVE_UNION_MEMBER',
  REMOVE_VALID_LOCATION = 'REMOVE_VALID_LOCATION'
}

export type FlatDiffTypeSummary = {
  __typename: 'FlatDiffTypeSummary';
  add: Scalars['Int']['output'];
  change: Scalars['Int']['output'];
  remove: Scalars['Int']['output'];
  typeCount: Scalars['Int']['output'];
};

/** Fly-specific information for a Shard */
export type FlyShard = {
  __typename: 'FlyShard';
  /** DNS endpoint for the orchestrator */
  endpoint: Scalars['String']['output'];
  /** Endpoints of the Etcd cluster */
  etcdEndpoints: Array<Scalars['String']['output']>;
  /** Fly organization ID */
  organizationId: Scalars['String']['output'];
};

export type GQLBillingPlanFromGrpc = {
  __typename: 'GQLBillingPlanFromGrpc';
  dbPlan: Maybe<BillingPlan>;
  matchesDbPlan: Maybe<Scalars['Boolean']['output']>;
  rawProtoJson: Maybe<Scalars['String']['output']>;
};

/** Details to identify a gateway */
export type GatewayIdentifierInput = {
  /** The gateway id */
  gatewayId: Scalars['String']['input'];
  /** Optional graph id associated with this gateway key. When omitted, gatewayId is used. */
  graphId?: InputMaybe<Scalars['String']['input']>;
};

/** The MCP gateway's log record for one request. */
export type GatewayLogRecord = {
  __typename: 'GatewayLogRecord';
  /** The field-level policies that took effect on this request — one entry per field a policy acted on, carrying the rule that won for that field. Measures policy impact, not coverage: rules that matched but lost are resolved away before the record is written. */
  appliedPolicies: Array<AppliedPolicy>;
  /** The agent app that made this request, as its Agent App id -- the identity established when the caller authenticates, not a display name. Resolve it against the app roster to label it. Distinct from `apollo.gateway.client.name`, which the other client-reporting fields in this schema carry: that is self-reported by the caller, while this names who the caller authenticated as. */
  clientName: Maybe<Scalars['String']['output']>;
  /** The version of the client that made this request. */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** The deduplicated set of error codes from the response. */
  errorCodes: Array<Scalars['String']['output']>;
  /** The number of errors in the response. */
  errorCount: Scalars['Int']['output'];
  /** The OCI manifest digest of the immutable graph artifact the gateway was serving for this request. Distinct from the graph ref, which is mutable. */
  graphArtifactId: Maybe<Scalars['String']['output']>;
  /** The HTTP status code the gateway returned for this request, if known. */
  responseStatus: Maybe<Scalars['Int']['output']>;
  /** When the gateway wrote this record. */
  timestamp: Scalars['Timestamp']['output'];
  /** The name of the MCP tool the caller invoked after any `tools: rename_to` config is applied, if the request named one. */
  toolEffectiveName: Maybe<Scalars['String']['output']>;
  /** The canonical name of the MCP tool the caller invoked, if the request named one. */
  toolName: Maybe<Scalars['String']['output']>;
};

export type GeneralProposalComment = {
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type GitContext = {
  __typename: 'GitContext';
  branch: Maybe<Scalars['String']['output']>;
  commit: Maybe<Scalars['ID']['output']>;
  commitUrl: Maybe<Scalars['String']['output']>;
  committer: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  remoteHost: Maybe<GitRemoteHost>;
  remoteUrl: Maybe<Scalars['String']['output']>;
};

/** This is stored with a schema when it is uploaded */
export type GitContextInput = {
  /** The Git repository branch used in the check. */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Git commit used in the check. */
  commit?: InputMaybe<Scalars['ID']['input']>;
  /** The username of the user who created the Git commit used in the check. */
  committer?: InputMaybe<Scalars['String']['input']>;
  /** The commit message of the Git commit used in the check. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The Git repository's remote URL. */
  remoteUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum GitRemoteHost {
  BITBUCKET = 'BITBUCKET',
  GITHUB = 'GITHUB',
  GITLAB = 'GITLAB'
}

/**
 * Represents a graph API key, which has permissions scoped to a
 * user role for a single Apollo graph.
 */
export type GraphApiKey = ApiKey & {
  __typename: 'GraphApiKey';
  /** The timestamp when the API key was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** Details of the user or graph that created the API key. */
  createdBy: Maybe<Identity>;
  /** The API key's ID. */
  id: Scalars['ID']['output'];
  /** The API key's name, for distinguishing it from other keys. */
  keyName: Maybe<Scalars['String']['output']>;
  /** The timestamp when the API key was last used for authentication, if available. */
  lastUsed: Maybe<Scalars['Timestamp']['output']>;
  /** The permission level assigned to the API key upon creation. */
  role: UserPermission;
  /** The value of the API key. **This is a secret credential!** */
  token: Scalars['String']['output'];
};

/** Apollo Graph Artifact; contains references to OCI artifacts */
export type GraphArtifact = {
  __typename: 'GraphArtifact';
  /** The time the Graph Artifact was completed */
  completedAt: Maybe<Scalars['DateTime']['output']>;
  /** The artifacts deployed to the Graph Artifact */
  content: GraphArtifactContent;
  /** The time the Graph Artifact was created */
  createdAt: Scalars['DateTime']['output'];
  /** The unique, content-addressable identifier (SHA) of the artifact */
  digest: Maybe<Scalars['String']['output']>;
  /** Errors related to this graph artifact */
  errors: Array<GraphArtifactError>;
  /** The Graph Variant this Graph Artifact is associated with */
  graphVariant: GraphVariant;
  /** The ID of the Graph Artifact */
  id: Scalars['ID']['output'];
  /** The location where the graph artifact can be retrieved from the registry itself */
  location: Maybe<GraphArtifactLocation>;
  /** The status of the Graph Artifact */
  status: GraphArtifactStatus;
  /** The OCI tags applied to the Graph Artifact */
  tags: GraphArtifactTagConnection;
  /** The last time the Graph Artifact was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** Apollo Graph Artifact; contains references to OCI artifacts */
export type GraphArtifacttagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated connection for Graph Artifacts */
export type GraphArtifactConnection = {
  __typename: 'GraphArtifactConnection';
  /** The list of Graph Artifact edges containing nodes and cursors */
  edges: Array<GraphArtifactEdge>;
  /** Information about pagination state */
  pageInfo: PageInfo;
  /** The total number of Graph Artifacts in the connection */
  totalCount: Scalars['Int']['output'];
};

/** Artifacts associated to a Graph Artifact */
export type GraphArtifactContent = {
  __typename: 'GraphArtifactContent';
  /** The Build associated with the Graph Artifact */
  build: Maybe<Build>;
  /** The Launch associated with the Graph Artifact */
  launch: Launch;
};

/** The error returned when a graph artifact digest is invalid. */
export type GraphArtifactDigestInvalidError = Error & {
  __typename: 'GraphArtifactDigestInvalidError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** An edge containing a Graph Artifact node and cursor for pagination */
export type GraphArtifactEdge = {
  __typename: 'GraphArtifactEdge';
  /** The cursor describing the location of the edge within the pagination result */
  cursor: Scalars['String']['output'];
  /** The Graph Artifact that the edge represents */
  node: GraphArtifact;
};

/** Error related to a graph artifact */
export type GraphArtifactError = {
  __typename: 'GraphArtifactError';
  message: Scalars['String']['output'];
};

/**
 * The ways a graph artifact can be identified.
 * Only one of these options should be provided.
 */
export type GraphArtifactInput = {
  /** The specific graph artifact digest (SHA). */
  digest?: InputMaybe<Scalars['String']['input']>;
  /** The graph artifact ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** The location of the graph artifact within the registry itself */
export type GraphArtifactLocation = {
  __typename: 'GraphArtifactLocation';
  /** The identifier that points to a specific resource in the registry. In the case of a graph artifact, an immutable digest SHA. In the case of a tag, the human-readable tag name. */
  reference: Scalars['String']['output'];
  /** The service that handles the required registry requests */
  registry: Scalars['String']['output'];
  /** The repository name/scope of the graph artifact */
  repository: Scalars['String']['output'];
  /** The full URI that can be used to interact with the graph artifact within the registry itself */
  uri: Scalars['String']['output'];
};

/** The error returned when a graph artifact was not found */
export type GraphArtifactNotFoundError = Error & {
  __typename: 'GraphArtifactNotFoundError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** The status of a Graph Artifact */
export enum GraphArtifactStatus {
  /** The Graph Artifact was successfully created */
  GRAPH_ARTIFACT_COMPLETED = 'GRAPH_ARTIFACT_COMPLETED',
  /** The Graph Artifact failed to be successfully created */
  GRAPH_ARTIFACT_FAILED = 'GRAPH_ARTIFACT_FAILED',
  /** The Graph Artifact is in the process of being created */
  GRAPH_ARTIFACT_PENDING = 'GRAPH_ARTIFACT_PENDING'
}

/** A tag for a Graph Artifact */
export type GraphArtifactTag = {
  __typename: 'GraphArtifactTag';
  /** The Graph the tag is associated with */
  graph: Service;
  /** The Graph Artifact the tag is associated with */
  graphArtifact: GraphArtifact;
  /** The OCI tag history of the Graph Artifact */
  history: GraphArtifactTagHistoryConnection;
  /** The location where the graph artifact tag can be retrieved from the registry itself */
  location: Maybe<GraphArtifactLocation>;
  /** The name of the Graph Artifact tag */
  tag: Scalars['String']['output'];
};


/** A tag for a Graph Artifact */
export type GraphArtifactTaghistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated connection for Graph Artifact Tags */
export type GraphArtifactTagConnection = {
  __typename: 'GraphArtifactTagConnection';
  /** The list of Graph Artifact Tag edges containing nodes and cursors */
  edges: Array<GraphArtifactTagEdge>;
  /** Information about pagination state */
  pageInfo: PageInfo;
  /** The total number of Graph Artifact Tags in the connection */
  totalCount: Scalars['Int']['output'];
};

/** An edge containing a Graph Artifact Tag node and cursor for pagination */
export type GraphArtifactTagEdge = {
  __typename: 'GraphArtifactTagEdge';
  /** The cursor describing the location of the edge within the pagination result */
  cursor: Scalars['String']['output'];
  /** The Graph Artifact Tag that the edge represents */
  node: GraphArtifactTag;
};

/** A paginated connection for Graph Artifact Tags history */
export type GraphArtifactTagHistoryConnection = {
  __typename: 'GraphArtifactTagHistoryConnection';
  /** The list of Graph Artifact Tag history edges containing nodes and cursors */
  edges: Array<GraphArtifactTagHistoryEdge>;
  /** Information about pagination state */
  pageInfo: PageInfo;
  /** The total number of Graph Artifact Tag history entries in the connection */
  totalCount: Scalars['Int']['output'];
};

/** An edge containing a Graph Artifact Tag history node and cursor for pagination */
export type GraphArtifactTagHistoryEdge = {
  __typename: 'GraphArtifactTagHistoryEdge';
  /** The cursor describing the location of the edge within the pagination result */
  cursor: Scalars['String']['output'];
  /** The Graph Artifact Tag history entry that the edge represents */
  node: GraphArtifactTagHistoryEntry;
};

/** A single graph artifact tag history entry */
export type GraphArtifactTagHistoryEntry = {
  __typename: 'GraphArtifactTagHistoryEntry';
  /** When the change occurred */
  changedAt: Scalars['DateTime']['output'];
  /** The graph artifact to which the tag was assigned */
  graphArtifactAssigned: GraphArtifact;
  /** The graph artifact from which the tag was removed. This will be null if it is a new tag */
  graphArtifactUnassigned: Maybe<GraphArtifact>;
  /** The graph artifact tag that was effected as part of the history event */
  tag: GraphArtifactTag;
};

/** The error returned when a graph artifact tag name is invalid. */
export type GraphArtifactTagInvalidError = Error & {
  __typename: 'GraphArtifactTagInvalidError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** The repository and tag names for a Graph Variant */
export type GraphArtifactTagLocation = {
  __typename: 'GraphArtifactTagLocation';
  /** The repository the tag is associated with */
  repository: Scalars['String']['output'];
  /** The name of the tag */
  tag: Scalars['String']['output'];
};

/**
 * The error returned when a variant graph artifact tag is attempted to be re-assigned.
 * Variant graph artifact tags are automatically created and assigned and represent the "latest" for a variant's graph artifact.
 * They cannot be re-assigned.
 */
export type GraphArtifactTagVariantAssignError = Error & {
  __typename: 'GraphArtifactTagVariantAssignError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** The error returned when the number of tags assigned to a single graph artifact will exceed the limit. */
export type GraphArtifactTaggingLimitError = Error & {
  __typename: 'GraphArtifactTaggingLimitError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** The error returned when the total number of tags created for a graph will exceed the limit. */
export type GraphArtifactTotalTagsLimitError = Error & {
  __typename: 'GraphArtifactTotalTagsLimitError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type GraphCapabilities = {
  __typename: 'GraphCapabilities';
  /**  False if this graph is a cloud supergraph. */
  canPublishMonograph: Scalars['Boolean']['output'];
  /**  Currently, graph URL is not updatable for cloud supergraphs. */
  canUpdateURL: Scalars['Boolean']['output'];
  /**  Minimum Federation Version track required for all variants of this graph. */
  minimumBuildPipelineTrack: BuildPipelineTrack;
  /**  Minimum Federation Version track required for all variants of this graph. */
  minimumFederationVersion: Scalars['FederationVersion']['output'];
};

/** The timing details for the build step of a launch. */
export type GraphCreationError = {
  __typename: 'GraphCreationError';
  message: Scalars['String']['output'];
};

export type GraphCreationResult = GraphCreationError | Service;

/** Filtering options for graph connections. */
export type GraphFilter = {
  /** Only include graphs in a certain state. */
  state?: InputMaybe<GraphState>;
  /** Only include graphs of certain types. */
  type?: InputMaybe<Array<GraphType>>;
};

/** Details to identify a graph */
export type GraphIdentifierInput = {
  /** The graph id */
  graphId: Scalars['String']['input'];
};

/** A union of all containers that can comprise the components of a Studio graph */
export type GraphImplementors = FederatedImplementingServices | NonFederatedImplementingService;

/** The linter configuration for this graph. */
export type GraphLinterConfiguration = {
  __typename: 'GraphLinterConfiguration';
  /** The set of @tag names allowed in the schema. */
  allowedTagNames: Array<Scalars['String']['output']>;
  /** Whether to ignore @deprecated elements from linting violations. */
  ignoreDeprecated: Scalars['Boolean']['output'];
  /** Whether to ignore @inaccessible elements from linting violations. */
  ignoreInaccessible: Scalars['Boolean']['output'];
  /** The set of lint rules configured for this graph. */
  rules: Array<LinterRuleLevelConfiguration>;
};

/** The changes to the linter configuration for this graph. */
export type GraphLinterConfigurationChangesInput = {
  /** A set of allowed @tag names to be added to the linting configuration for this graph or null if no changes should be made. */
  allowedTagNameAdditions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A set of @tag names to be removed from the allowed @tag list for this graphs linting configuration or null if no changes should be made. */
  allowedTagNameRemovals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Change whether @deprecated elements should be linted or null if no changes should be made. */
  ignoreDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Change whether @inaccessible elements should be linted or null if no changes should be made. */
  ignoreInaccessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** A set of rule changes or null if no changes should be made. */
  rules?: InputMaybe<Array<LinterRuleLevelConfigurationChangesInput>>;
};

/** The error returned when a graph is not found. */
export type GraphNotFoundError = Error & {
  __typename: 'GraphNotFoundError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** Constellation ("GraphOS for Agents") metadata for an organization. */
export type GraphOsForAgentsAccount = {
  __typename: 'GraphOsForAgentsAccount';
  /**
   * Every classification tag in use across this org's connected services,
   * tag-ascending, with how many services and fields carry each. Backs tag
   * filters and pickers without paginating every service's `fieldTags`.
   *
   * Scoped to `connected`, non-deleted services — the same definition the
   * policy compiler uses for the org's known tags — so a filter built from
   * this can never offer a tag that classifies nothing.
   */
  availableFieldTags: Array<ServiceFieldTagSummary>;
  /**
   * The graph ref (`graph@variant`) this org's agentic subgraphs publish to.
   *
   * Returns the org's stored `graph_ref` when an `organizations` row exists.
   * For an org that has not been onboarded yet (no row), returns the per-org
   * computed default — the exact ref the first write would auto-vivify — so
   * callers never have to reconstruct the slug convention themselves.
   *
   * Null means the caller cannot read this organization's control plane.
   */
  defaultGraphRef: Maybe<Scalars['String']['output']>;
  /**
   * Resolves an OAuth provider's published metadata from a pasted issuer
   * or discovery URL, so a client can fill in the rest of an OAuth
   * configuration automatically.
   *
   * Gated on org membership, not on org admin: this is reachable by any
   * member, and the four error strings this can return are fixed at design
   * time precisely so an unprivileged member learns nothing about the
   * network from them.
   */
  oauthDiscovery: Maybe<OauthDiscoveryResult>;
  /**
   * Number of this organization's active services that have a newer catalog
   * version available. Backs the nav badge without paginating every service.
   */
  servicesWithUpdatesCount: Scalars['Int']['output'];
};


/** Constellation ("GraphOS for Agents") metadata for an organization. */
export type GraphOsForAgentsAccountoauthDiscoveryArgs = {
  issuerUrl: Scalars['String']['input'];
};

/** Shared credential configuration for a federation source. */
export type GraphOsForAgentsGlobalAuth = {
  __typename: 'GraphOsForAgentsGlobalAuth';
  /**
   * Environment variable name holding the shared API key credential. GAS
   * renders this as `credential: ${env.<name>}` in `sources.yaml`.
   */
  credentialEnvVar: Scalars['String']['output'];
};

/**
 * Graph-scoped GraphOS for Agents view. Runtime publication data for this
 * graph lives here, distinct from the org-scoped `GraphOsForAgentsAccount`
 * control-plane fields on `Account`.
 */
export type GraphOsForAgentsGraph = {
  __typename: 'GraphOsForAgentsGraph';
  /** The full graph ref (`graph_id@variant`) resolved for this graph slug. */
  graphRef: Scalars['String']['output'];
  /**
   * Live application API key digests the runtime should honor for this graph.
   * Requires `canReadConstellationArtifacts` for this graph.
   */
  publishedApiKeys: Array<GraphOsForAgentsPublishedApiKey>;
  /**
   * Upstream services publishable to the runtime sources contract.
   * Requires `canReadConstellationArtifacts` for this graph.
   */
  runtimeSources: Array<GraphOsForAgentsRuntimeSource>;
};

/** One key/value pair in a GraphOS-for-Agents dictionary-like bag. */
export type GraphOsForAgentsKeyValuePair = {
  __typename: 'GraphOsForAgentsKeyValuePair';
  /** Parameter name. */
  key: Scalars['String']['output'];
  /** Literal (unencoded) parameter value. */
  value: Scalars['String']['output'];
};

/** OAuth settings for a per-user federation source. */
export type GraphOsForAgentsOauthAuth = {
  __typename: 'GraphOsForAgentsOauthAuth';
  /** JSON path used to extract an access token from an upstream response. */
  accessTokenPath: Maybe<Scalars['String']['output']>;
  /** Explicit OAuth 2.0 authorization endpoint URL. */
  authorizationEndpoint: Maybe<Scalars['String']['output']>;
  /** Issuer URLs used for OpenID Connect discovery. */
  authorizationServers: Maybe<Array<Scalars['String']['output']>>;
  /** OAuth client identifier presented to the upstream. */
  clientId: Maybe<Scalars['String']['output']>;
  /**
   * Environment variable name holding the OAuth client secret. GAS renders
   * this as `client_secret: ${env.<name>}` in `sources.yaml`.
   */
  clientSecretEnvVar: Scalars['String']['output'];
  /**
   * Extra query parameters for the upstream authorization URL
   * (eg, `access_type` / `offline`). GAS renders these as the
   * `extra_authorize_params` YAML mapping in `sources.yaml` when set.
   * Values are literal; the runtime percent-encodes when building the URL.
   *
   * Validated on write: keys must be unreserved URL characters and must
   * not collide with the parameters the OAuth machinery owns
   * (`redirect_uri`, `client_id`, `response_type`, `state`, `nonce`,
   * `scope`, `code_challenge`, `code_challenge_method`, `request`,
   * `request_uri`); neither keys nor values may carry `&`, `=`, `?` or `#`.
   */
  extraAuthorizeParams: Maybe<Array<GraphOsForAgentsKeyValuePair>>;
  /** Expected JWT issuer (`iss` claim) for this source. */
  issuer: Maybe<Scalars['String']['output']>;
  /** JWKS endpoint URL for validating tokens from this source. */
  jwksUri: Maybe<Scalars['String']['output']>;
  /** Dynamic Client Registration endpoint URL for this source. */
  registrationEndpoint: Maybe<Scalars['String']['output']>;
  /** Query parameter name used for scopes on the upstream authorize URL. */
  scopeParam: Maybe<Scalars['String']['output']>;
  /** OAuth scopes requested for this source. */
  scopes: Maybe<Array<Scalars['String']['output']>>;
  /** Explicit OAuth 2.0 token endpoint URL. */
  tokenEndpoint: Maybe<Scalars['String']['output']>;
};

/** User-scoped auth for a federation source. */
export type GraphOsForAgentsPerUserAuth = {
  __typename: 'GraphOsForAgentsPerUserAuth';
  /** OAuth settings for per-user token brokering. */
  oauth: GraphOsForAgentsOauthAuth;
};

/** One live application API key digest published to the runtime for this graph. */
export type GraphOsForAgentsPublishedApiKey = {
  __typename: 'GraphOsForAgentsPublishedApiKey';
  /** Identifier of the approved application that owns this key. */
  applicationId: Scalars['UUID']['output'];
  /** SHA-256 digest of the API key material (lowercase hex, 64 characters). */
  digest: Scalars['String']['output'];
};

/**
 * One federation source's runtime auth configuration. The structured input
 * used to build one entry in `sources.yaml`, keyed by `federationSourceName`.
 */
export type GraphOsForAgentsRuntimeSource = {
  __typename: 'GraphOsForAgentsRuntimeSource';
  /**
   * The `@source` name from this service's pinned catalog template. This
   * is the key in `sources.yaml`, not the registry upstream service name.
   */
  federationSourceName: Scalars['String']['output'];
  /**
   * Per-source auth blocks for the gateway contract. Absent sub-fields mean
   * the block is not configured and must be omitted from `sources.yaml`.
   */
  sourcesAuth: GraphOsForAgentsSourcesAuth;
  /**
   * Registry identifier of the connected upstream service this source was
   * derived from.
   */
  upstreamServiceId: Scalars['UUID']['output'];
  /**
   * Catalog name of the upstream service (for example `slack`). Diagnostic
   * only; not the federation source name.
   */
  upstreamServiceName: Scalars['String']['output'];
};

/** Per-source auth blocks for the runtime gateway sources contract. */
export type GraphOsForAgentsSourcesAuth = {
  __typename: 'GraphOsForAgentsSourcesAuth';
  /**
   * SHA-256 digests (lowercase hex) of live application API keys authorized
   * for this source. An empty list means `allowed_key_digests` is omitted
   * from `sources.yaml`.
   */
  authorizedKeyDigests: Array<Scalars['String']['output']>;
  /**
   * Shared credential configuration for non-interactive requests. Null when
   * this source has no global auth configured.
   */
  global: Maybe<GraphOsForAgentsGlobalAuth>;
  /**
   * User-scoped OAuth configuration brokered by the token-exchange
   * coprocessor. Null when this source has no per-user auth configured.
   */
  perUser: Maybe<GraphOsForAgentsPerUserAuth>;
};

/** Represents an API key that's used to authenticate an Apollo principal. */
export type GraphOsKey = ApiKey & {
  __typename: 'GraphOsKey';
  /** The time when this API key was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The actor that created this API key. */
  createdBy: Actor;
  /** The time when this API key expires, if applicable. */
  expiresAt: Maybe<Scalars['Timestamp']['output']>;
  /** The API key's ID. */
  id: Scalars['ID']['output'];
  /** The API key's name, for distinguishing it from other keys. */
  keyName: Maybe<Scalars['String']['output']>;
  /** The type of API key (e.g., OPERATOR, SUBGRAPH, GATEWAY, SCIM). */
  keyType: Maybe<GraphOsKeyType>;
  /** The timestamp when the API key was last used for authentication, if available. */
  lastUsed: Maybe<Scalars['Timestamp']['output']>;
  /** Permissions associated with this API key, defining what actions it can perform. */
  resources: Array<ApiKeyResource>;
  /** The time when this API key was revoked. */
  revokedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The actor that revoked this API key. */
  revokedBy: Maybe<Actor>;
  /** The value of the API key. **This is a secret credential!** */
  token: Scalars['String']['output'];
};

/** Represent a connection of GraphOS API keys, used for pagination in GraphQL queries. */
export type GraphOsKeyConnection = {
  __typename: 'GraphOsKeyConnection';
  /** List of edges in the connection, each containing a node and a cursor. */
  edges: Array<GraphOsKeyEdge>;
  /** List of of API keys in the connection. */
  nodes: Array<GraphOsKey>;
  /** Information about the pagination state of the connection. */
  pageInfo: GraphOsKeyPageInfo;
  /** Total number of API keys in the connection, regardless of pagination. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection of GraphOS API keys, containing a node and a cursor. */
export type GraphOsKeyEdge = {
  __typename: 'GraphOsKeyEdge';
  /** A cursor for use in pagination, representing the position of this edge in the connection. */
  cursor: Scalars['String']['output'];
  /** The API key node in the edge. */
  node: GraphOsKey;
};

/** Information about the pagination state of a connection of GraphOS API keys. */
export type GraphOsKeyPageInfo = {
  __typename: 'GraphOsKeyPageInfo';
  /** The cursor to use for fetching the previous page of items. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** Indicates if there are more items after the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates if there are more items before the current page. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor to use for fetching the next page of items. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export enum GraphOsKeyType {
  /** A key used by a Gateway instance */
  GATEWAY = 'GATEWAY',
  OPERATOR = 'OPERATOR',
  ROUTER = 'ROUTER',
  SCIM = 'SCIM',
  /** A key with one or more subgraphs as its target resource(s) */
  SUBGRAPH = 'SUBGRAPH',
  /** A key with one or more variants as its target resource(s) */
  VARIANT = 'VARIANT'
}

export type GraphQLDoc = {
  __typename: 'GraphQLDoc';
  graph: Service;
  hash: Scalars['ID']['output'];
  source: Scalars['GraphQLDocument']['output'];
};

/** Various states a graph can be in. */
export enum GraphState {
  /** The graph has not been configured with any variants. */
  CONFIGURED = 'CONFIGURED',
  /** The graph has not been configured with any variants. */
  NOT_CONFIGURED = 'NOT_CONFIGURED'
}

export enum GraphType {
  CLASSIC = 'CLASSIC',
  CLOUD_SUPERGRAPH = 'CLOUD_SUPERGRAPH',
  SELF_HOSTED_SUPERGRAPH = 'SELF_HOSTED_SUPERGRAPH'
}

/** A graph variant */
export type GraphVariant = {
  __typename: 'GraphVariant';
  /** As new schema tags keep getting published, activeSchemaPublish refers to the latest. */
  activeSchemaPublish: Maybe<SchemaTag>;
  /** The activity log feed for this graph: one entry per request, newest first. */
  activityLogs: GraphVariantActivityLogsConnection;
  /** Describes the values observed for a filter dimension on `activityLogs` in a window, with a count each, for populating a filter menu without reading log rows. Every dimension `ActivityLogsFilterInInput` accepts can be faceted. `filter` narrows the counts exactly as it narrows `activityLogs`, except that the faceted dimension's own `include` and `exclude` values are ignored, so selecting one value leaves the rest of the menu reachable. Values come back most-matched first, bounded by `first`; `contains` reaches past that bound, matching a value case-insensitively on a substring. */
  activityLogsFacet: ActivityLogsFacet;
  /** The list of BuildPipelineTracks and their associated details that this variant is allowed to set in their build configuration. */
  allowedTracks: Array<Maybe<BuildPipelineTrackDetails>>;
  /**
   * If this variant doesn't conduct a build (monograph) then this field will be null
   * For contract variants the build config is set based on the upstream composition variant.
   */
  buildConfig: Maybe<BuildConfig>;
  /** The time the variant's federation version and/or the supported directives was last updated */
  buildConfigUpdatedAt: Maybe<Scalars['Timestamp']['output']>;
  checkConfiguration: VariantCheckConfiguration;
  /**
   * Compose and filter preview contract schema built from this source variant.
   * @deprecated Use the composeAndFilterPreviewAsync mutation and poll composeAndFilterPreviewStatus instead.
   */
  composeAndFilterPreview: Maybe<ComposeAndFilterPreviewResult>;
  /** Poll the status and result of an async composeAndFilterPreview build started on this variant. Null if no such build exists. */
  composeAndFilterPreviewStatus: Maybe<ComposeAndFilterPreviewStatus>;
  /**
   * Federation version this variant uses
   * @deprecated Use federationVersion instead.
   */
  compositionVersion: Maybe<Scalars['String']['output']>;
  /** The filter configuration used to build a contract schema. The configuration consists of lists of tags for schema elements to include or exclude in the resulting schema. */
  contractFilterConfig: Maybe<FilterConfig>;
  /**
   * A human-readable description of the filter configuration of this contract variant, or null if this isn't a contract
   * variant.
   */
  contractFilterConfigDescription: Maybe<Scalars['String']['output']>;
  /** Poll the status and result of an async contractPreviewAsync build started on this variant. Null if no such build exists. */
  contractPreviewStatus: Maybe<ContractPreviewAsyncStatus>;
  /**
   * Returns details about a coordinate in the schema. Unless an error occurs, we will currently always return a non-null
   * response here, with the timestamps set to null if there is no usage of the coordinate or if coordinate doesn't exist in the
   * schema. However, we are keeping the return type as nullable in case we want to update this later in a
   * backwards-compatible way (e.g. a null response meaning that the coordinate doesn't exist in the schema at all).
   */
  coordinateInsights: Maybe<CoordinateInsights>;
  /** Returns a paginated list of coordinate insights list items, including all coordinates from the active schema for this variant. */
  coordinateInsightsList: GraphVariantCoordinateInsightsListItemConnection;
  /** Time the variant was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Custom check configuration for this graph. */
  customCheckConfiguration: Maybe<CustomCheckConfiguration>;
  derivedVariantCount: Scalars['Int']['output'];
  /** Returns the list of variants derived from this variant. This currently includes contracts only. */
  derivedVariants: Maybe<Array<GraphVariant>>;
  /** A list of the entities across all subgraphs, exposed to consumers & up. This value is null for non-federated variants. */
  entities: Maybe<EntitiesResponseOrError>;
  /** Returns a paginated list of error insights list items, including service and code for which the error originated from. */
  errorInsightsList: GraphVariantErrorInsightsListItemConnection;
  /** Returns a time series list of error counts over time for this variant within a given time range. */
  errorInsightsTimeseries: ErrorInsightsTimeseriesResult;
  /** Details about 'enhanced reference' reporting for traces sent to Apollo by Router for this variant. */
  extendedRefsUsage: ExtendedRefsUsage;
  /** Federation version this variant uses */
  federationVersion: Maybe<Scalars['String']['output']>;
  /** The last instant that field execution information (resolver execution via field-level instrumentation) was reported for this variant */
  fieldExecutionsLastReportedAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Returns details about a field in the schema. Unless an error occurs, we will currently always return a non-null
   * response here, with the timestamps set to null if there is no usage of the field or if field doesn't exist in the
   * schema. However, we are keeping the return type as nullable in case we want to update this later in a
   * backwards-compatible way (e.g. a null response meaning that the field doesn't exist in the schema at all).
   */
  fieldInsights: Maybe<FieldInsights>;
  /** Returns a paginated list of field insights list items, including all fields from the active schema for this variant. */
  fieldInsightsList: GraphVariantFieldInsightsListItemConnection;
  /** The last instant that field usage information (usage of fields via referencing operations) was reported for this variant */
  fieldUsageLastReportedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The graph that this variant belongs to. */
  graph: Service;
  /**
   * Get a specific graph artifact tag assigned to a graph artifact of the associated variant.
   * If the tag is assigned to another variant of the same graph, this field will return 'null'.
   * For example, querying graph 'MyGraph', variant 'prod' for tag 'v1' would return null if tag `v1` is currently assigned to the `dev` variant.
   */
  graphArtifactTag: Maybe<GraphArtifactTag>;
  /** The graph artifact tags currently assigned to graph artifacts of this variant */
  graphArtifactTags: GraphArtifactTagConnection;
  /** The graph artifacts associated with a specific graph variant */
  graphArtifacts: GraphArtifactConnection;
  /** Graph ID of the variant. Prefer using graph { id } when feasible. */
  graphId: Scalars['String']['output'];
  /** If the variant has managed subgraphs. */
  hasManagedSubgraphs: Maybe<Scalars['Boolean']['output']>;
  /**
   * Represents whether this variant has a supergraph schema. Note that this can only be true for variants with build steps
   * (running e.g. federation composition or contracts filtering). This will be false for a variant with a build step if it
   * has never successfully published.
   */
  hasSupergraphSchema: Scalars['Boolean']['output'];
  /** The variant's global identifier in the form `graphID@variant`. */
  id: Scalars['ID']['output'];
  internalVariantUUID: Scalars['String']['output'];
  /** Represents whether this variant is a Contract. */
  isContract: Maybe<Scalars['Boolean']['output']>;
  /** Is this variant one of the current user's favorite variants? */
  isFavoriteOfCurrentUser: Scalars['Boolean']['output'];
  /**
   * If the variant has managed subgraphs.
   * @deprecated Replaced by hasManagedSubgraphs
   */
  isFederated: Maybe<Scalars['Boolean']['output']>;
  /** Represents whether this variant is a Proposal. */
  isProposal: Maybe<Scalars['Boolean']['output']>;
  /** If the variant is protected */
  isProtected: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  /** Represents whether this variant should be listed in the public variants directory. This can only be true if the variant is also public. */
  isPubliclyListed: Scalars['Boolean']['output'];
  /** Represents whether Apollo has verified the authenticity of this public variant. This can only be true if the variant is also public. */
  isVerified: Scalars['Boolean']['output'];
  /** The most recent agent that reported data to Apollo for this variant, or null if the agent is unknown. */
  lastReportedAgent: Maybe<ReportingAgent>;
  /** Latest approved launch for the variant, and what is served through Uplink. */
  latestApprovedLaunch: Maybe<Launch>;
  /** Latest launch for the variant, whether successful or not. */
  latestLaunch: Maybe<Launch>;
  /** The details of the variant's most recent publication. */
  latestPublication: Maybe<SchemaTag>;
  /** Retrieve a launch for this variant by ID. */
  launch: Maybe<Launch>;
  /** A list of launches ordered by date, asc or desc depending on orderBy. The maximum limit is 100. */
  launchHistory: Maybe<Array<Launch>>;
  /** Count of total launch history */
  launchHistoryLength: Maybe<Scalars['Long']['output']>;
  /** A list of launches metadata ordered by date, asc or desc depending on orderBy. The maximum limit is 100. */
  launchSummaries: Maybe<Array<LaunchSummary>>;
  links: Maybe<Array<LinkInfo>>;
  /** The default collection MCP servers will use if no explicit collection is provided. Auto-creates a collection if it does not exist. */
  mcpDefaultCollection: McpDefaultCollectionResult;
  /** The variant's name (e.g., `staging`). */
  name: Scalars['String']['output'];
  /**
   * A list of the saved [operation collections](https://www.apollographql.com/docs/studio/explorer/operation-collections/) associated with this variant.
   * This field accepts up to 400 requests per minute. This rate may be temporarily adjusted based on system conditions.
   */
  operationCollections: Array<OperationCollection>;
  /** A list of the saved [operation collections](https://www.apollographql.com/docs/studio/explorer/operation-collections/) associated with this variant, paged. */
  operationCollectionsConnection: Maybe<GraphVariantOperationCollectionConnection>;
  /** Returns a paginated list of operation insights list items. */
  operationInsightsList: GraphVariantOperationInsightsListItemConnection;
  /** The merged/computed/effective check configuration for the operations check task. */
  operationsCheckConfiguration: Maybe<OperationsCheckConfiguration>;
  /** Which permissions the current user has for interacting with this variant */
  permissions: GraphVariantPermissions;
  /** The Persisted Query List linked to this variant, if any. */
  persistedQueryList: Maybe<PersistedQueryList>;
  /** Generate a federated operation plan for a given operation */
  plan: Maybe<QueryPlan>;
  /** Returns how a field policy rule has been applied on this variant. A rule is org-scoped in the policy registry while the logs behind this field are per-variant, so this answers only for this variant -- query each variant to cover a whole graph. `lastAppliedAt` is null when the rule has never been applied here. */
  policyRuleInsights: PolicyRuleInsights;
  /** Explorer setting for postflight script to run before the actual GraphQL operations is run. */
  postflightScript: Maybe<Scalars['String']['output']>;
  /** Explorer setting for preflight script to run before the actual GraphQL operations is run. */
  preflightScript: Maybe<Scalars['String']['output']>;
  /** Returns the proposal-related fields for this graph variant if the variant is a proposal; otherwise, returns null. This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  proposal: Maybe<Proposal>;
  readme: Readme;
  /** Registry stats for this particular graph variant */
  registryStatsWindow: Maybe<RegistryStatsWindow>;
  /** The total number of requests for this variant in the last 24 hours */
  requestsInLastDay: Maybe<Scalars['Long']['output']>;
  /** Router associated with this graph variant */
  router: Maybe<Router>;
  routerConfig: Maybe<Scalars['String']['output']>;
  /** The first time the Router reported usage of this variant to Apollo. */
  routerFirstSeenAt: Maybe<Scalars['Timestamp']['output']>;
  /** The last time the Router reported usage of this variant to Apollo. */
  routerLastSeenAt: Maybe<Scalars['Timestamp']['output']>;
  /** The list of rule enforcements for this variant, if any. */
  ruleEnforcements: Array<RuleEnforcement>;
  /** Returns the current state of every schema coordinate (object field, input object field, and enum value) for this variant, describing whether each coordinate is used and whether it is deprecated. Unlike the timeseries reports, this returns a single snapshot row per coordinate rather than metrics bucketed over time. A coordinate is reported as 'used' if it was referenced or executed at any point since the 'since' timestamp. The report can be filtered by coordinate kind, used status, deprecation status, and client. Using the groupByClient input flag will cause the report to output one record per combination of schema coordinate, client, and version name instead of one record per schema coordinate. Note that insights on enum values and input object types are only supported if extended reference reporting is enabled (see https://www.apollographql.com/docs/graphos/routing/configuration/yaml#extended-reference-reporting). */
  schemaCoordinateInsightsUsageReport: SchemaCoordinateInsightsUsageReportResult;
  /** If the graphql endpoint is set up to accept cookies. */
  sendCookies: Maybe<Scalars['Boolean']['output']>;
  /** Explorer setting for shared headers for a graph */
  sharedHeaders: Maybe<Scalars['String']['output']>;
  /** The variant this variant is derived from. This property currently only exists on contract variants. */
  sourceVariant: Maybe<GraphVariant>;
  /** Returns the details of the subgraph with the provided `name`, or null if this variant doesn't include a subgraph with that name. */
  subgraph: Maybe<FederatedImplementingService>;
  /** The number of subgraphs included in this variant. This value is null for non-federated variants. Set `includeDeleted` to `true` to include deleted subgraphs. */
  subgraphCount: Maybe<Scalars['Int']['output']>;
  /** The most recent time subgraph insights metrics were reported, or null if none have been reported for this variant. */
  subgraphInsightsLastReportedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Returns a list of subgraph insights items. */
  subgraphInsightsList: GraphVariantSubgraphInsightsListItemConnection;
  /** Returns a time-indexed set of subgraph metrics for this variant within a given time range. */
  subgraphInsightsTimeseries: SubgraphInsightsTimeseriesResult;
  /** Which permissions the currently authenticated principal has for interacting with the given subgraph */
  subgraphPermissions: Array<SubgraphPermissions>;
  /** A list of the subgraphs included in this variant. This value is null for non-federated variants. Set `includeDeleted` to `true` to include deleted subgraphs. */
  subgraphs: Maybe<Array<FederatedImplementingService>>;
  /** The URL of the variant's GraphQL endpoint for subscription operations. */
  subscriptionUrl: Maybe<Scalars['String']['output']>;
  /** A list of supported directives */
  supportedDirectives: Maybe<Array<DirectiveSupportStatus>>;
  /** Returns the top N operations by a few different metrics */
  topNOperations: TopNOperationsResult;
  /**
   * Returns a list of the top operations reported for this variant within a given time range. This API is rate limited,
   * and will return an error if too many requests are made for a graph.
   */
  topOperationsReport: Array<TopOperationRecord>;
  /**
   * A list of the subgraphs that have been published to since the variant was created.
   * Does not include subgraphs that were created & deleted since the variant was created.
   *
   * TODO: @deprecated(reason: "use GraphVariant.updatedSubgraphsSinceCreation instead")
   */
  updatedSubgraphs: Maybe<Array<FederatedImplementingService>>;
  /** A list of the subgraphs that have been published to since the variant was created. Does not include subgraphs that were created & deleted since the variant was created since that is not a change compared to initial; however includes subgraphs that were only deleted because that is a change compared to the initial. */
  updatedSubgraphsSinceCreation: Maybe<Array<Subgraph>>;
  /** The URL of the variant's GraphQL endpoint for query and mutation operations. For subscription operations, use `subscriptionUrl`. */
  url: Maybe<Scalars['String']['output']>;
  /** The last instant that usage information (e.g. operation stat, client stats) was reported for this variant */
  usageLastReportedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Validate router configuration for this graph variant */
  validateRouter: CloudValidationResult;
};


/** A graph variant */
export type GraphVariantactivityLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivityLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantactivityLogsFacetArgs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  dimension: ActivityLogsDimension;
  filter?: InputMaybe<ActivityLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantcomposeAndFilterPreviewArgs = {
  filterConfig?: InputMaybe<FilterConfigInput>;
  subgraphChanges?: InputMaybe<Array<ComposeAndFilterPreviewSubgraphChange>>;
};


/** A graph variant */
export type GraphVariantcomposeAndFilterPreviewStatusArgs = {
  buildID: Scalars['ID']['input'];
};


/** A graph variant */
export type GraphVariantcontractPreviewStatusArgs = {
  buildID: Scalars['ID']['input'];
};


/** A graph variant */
export type GraphVariantcoordinateInsightsArgs = {
  coordinateKind: CoordinateKind;
  namedAttribute: Scalars['String']['input'];
  namedType: Scalars['String']['input'];
};


/** A graph variant */
export type GraphVariantcoordinateInsightsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CoordinateInsightsListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoordinateInsightsListOrderByInput>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVarianterrorInsightsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  groupBy?: InputMaybe<Array<ErrorInsightsListGroupByColumn>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ErrorInsightsListOrderByInput>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVarianterrorInsightsTimeseriesArgs = {
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  from: Scalars['Timestamp']['input'];
  groupBy: ErrorInsightsListGroupByColumn;
  resolution: Resolution;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantfieldInsightsArgs = {
  fieldName: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
};


/** A graph variant */
export type GraphVariantfieldInsightsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FieldInsightsListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FieldInsightsListOrderByInput>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantgraphArtifactTagArgs = {
  tag: Scalars['String']['input'];
};


/** A graph variant */
export type GraphVariantgraphArtifactTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A graph variant */
export type GraphVariantgraphArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A graph variant */
export type GraphVariantlaunchArgs = {
  id: Scalars['ID']['input'];
};


/** A graph variant */
export type GraphVariantlaunchHistoryArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: LaunchHistoryOrder;
};


/** A graph variant */
export type GraphVariantlaunchSummariesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: LaunchHistoryOrder;
};


/** A graph variant */
export type GraphVariantoperationCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A graph variant */
export type GraphVariantoperationInsightsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OperationInsightsListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OperationInsightsListOrderByInput>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantoperationsCheckConfigurationArgs = {
  overrides?: InputMaybe<OperationsCheckConfigurationOverridesInput>;
};


/** A graph variant */
export type GraphVariantplanArgs = {
  document: Scalars['GraphQLDocument']['input'];
  operationName?: InputMaybe<Scalars['String']['input']>;
};


/** A graph variant */
export type GraphVariantpolicyRuleInsightsArgs = {
  ruleId: Scalars['ID']['input'];
};


/** A graph variant */
export type GraphVariantregistryStatsWindowArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** A graph variant */
export type GraphVariantschemaCoordinateInsightsUsageReportArgs = {
  filters?: InputMaybe<SchemaCoordinateInsightsUsageReportFilterInput>;
  groupByClient: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<SchemaCoordinateInsightsUsageReportOrderByInput>;
  since: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantsubgraphArgs = {
  name: Scalars['ID']['input'];
};


/** A graph variant */
export type GraphVariantsubgraphCountArgs = {
  includeDeleted: Scalars['Boolean']['input'];
};


/** A graph variant */
export type GraphVariantsubgraphInsightsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubgraphInsightsListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  groupBy?: InputMaybe<Array<SubgraphInsightsListGroupByColumn>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SubgraphInsightsListOrderByInput>;
  requireLatencyMetrics: Scalars['Boolean']['input'];
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantsubgraphInsightsTimeseriesArgs = {
  filter?: InputMaybe<SubgraphInsightsListFilterInput>;
  from: Scalars['Timestamp']['input'];
  requireLatencyMetrics: Scalars['Boolean']['input'];
  resolution: Resolution;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantsubgraphPermissionsArgs = {
  subgraphNames: Array<Scalars['String']['input']>;
};


/** A graph variant */
export type GraphVariantsubgraphsArgs = {
  includeDeleted: Scalars['Boolean']['input'];
};


/** A graph variant */
export type GraphVarianttopNOperationsArgs = {
  filter?: InputMaybe<TopNOperationsFilterInput>;
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  topN?: InputMaybe<Scalars['Int']['input']>;
};


/** A graph variant */
export type GraphVarianttopOperationsReportArgs = {
  filter?: InputMaybe<TopOperationsReportVariantFilterInput>;
  from: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<TopOperationsReportOrderByInput>;
  to: Scalars['Timestamp']['input'];
};


/** A graph variant */
export type GraphVariantvalidateRouterArgs = {
  config: RouterConfigInput;
};

/** A page of `activityLogs` results. */
export type GraphVariantActivityLogsConnection = {
  __typename: 'GraphVariantActivityLogsConnection';
  /** A list of edges from the graph variant to its activity log entries. */
  edges: Maybe<Array<GraphVariantActivityLogsEdge>>;
  /** A list of activity log entries that belong to a graph variant. */
  nodes: Maybe<Array<ActivityLogsItem>>;
  /** Information to aid in pagination. */
  pageInfo: ActivityLogsPageInfo;
  /** The total number of activity log entries connected to the graph variant. */
  totalCount: Scalars['Long']['output'];
};

/** An edge between a graph variant and an activity log entry. */
export type GraphVariantActivityLogsEdge = {
  __typename: 'GraphVariantActivityLogsEdge';
  /** A cursor for use in pagination — opaque, encodes (Timestamp, RequestId) of the last request in phase 1. */
  cursor: Scalars['String']['output'];
  /** An activity log entry attached to the graph variant. */
  node: Maybe<ActivityLogsItem>;
};

/** A list of coordinate insights list items that belong to a graph variant. */
export type GraphVariantCoordinateInsightsListItemConnection = {
  __typename: 'GraphVariantCoordinateInsightsListItemConnection';
  /** A list of edges from the graph variant to its coordinate insights list items. */
  edges: Maybe<Array<GraphVariantCoordinateInsightsListItemEdge>>;
  /** A list of coordinate insights list items that belong to a graph variant. */
  nodes: Maybe<Array<CoordinateInsightsListItem>>;
  /** Information to aid in pagination. */
  pageInfo: CoordinateInsightsListPageInfo;
  /** The total number of coordinate insights list items connected to the graph variant */
  totalCount: Scalars['Int']['output'];
};

/** An edge between a graph variant and a coordinate insights list item. */
export type GraphVariantCoordinateInsightsListItemEdge = {
  __typename: 'GraphVariantCoordinateInsightsListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A coordinate insights list item attached to the graph variant. */
  node: Maybe<CoordinateInsightsListItem>;
};

/** A list of error insights list items that belong to a graph variant. */
export type GraphVariantErrorInsightsListItemConnection = {
  __typename: 'GraphVariantErrorInsightsListItemConnection';
  /** A list of edges from the graph variant to its error insights list items. */
  edges: Maybe<Array<GraphVariantErrorInsightsListItemEdge>>;
  /** A list of error insights list items that belong to a graph variant. */
  nodes: Maybe<Array<ErrorInsightsListItem>>;
  /** Information to aid in pagination. */
  pageInfo: ErrorInsightsListPageInfo;
  /** The total number of error insights list items connected to the graph variant. */
  totalCount: Scalars['Int']['output'];
};

/** An edge between a graph variant and an error insights list item. */
export type GraphVariantErrorInsightsListItemEdge = {
  __typename: 'GraphVariantErrorInsightsListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A error insights list items attached to the graph variant. */
  node: Maybe<ErrorInsightsListItem>;
};

/** A list of field insights list items that belong to a graph variant. */
export type GraphVariantFieldInsightsListItemConnection = {
  __typename: 'GraphVariantFieldInsightsListItemConnection';
  /** A list of edges from the graph variant to its field insights list items. */
  edges: Maybe<Array<GraphVariantFieldInsightsListItemEdge>>;
  /** A list of field insights list items that belong to a graph variant. */
  nodes: Maybe<Array<FieldInsightsListItem>>;
  /** Information to aid in pagination. */
  pageInfo: FieldInsightsListPageInfo;
  /** The total number of field insights list items connected to the graph variant */
  totalCount: Scalars['Int']['output'];
};

/** An edge between a graph variant and a field insights list item. */
export type GraphVariantFieldInsightsListItemEdge = {
  __typename: 'GraphVariantFieldInsightsListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A field insights list item attached to the graph variant. */
  node: Maybe<FieldInsightsListItem>;
};

/** Details to identify a graph variant */
export type GraphVariantIdentifierInput = {
  /** The graph id */
  graphId: Scalars['String']['input'];
  /** The variant name */
  variantName: Scalars['String']['input'];
};

/** Result of looking up a variant by ref */
export type GraphVariantLookup = GraphVariant | InvalidRefFormat;

/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutation = {
  __typename: 'GraphVariantMutation';
  addLinkToVariant: GraphVariant;
  buildConfig: Maybe<GraphVariant>;
  /** Start an asynchronous compose and filter preview build from this source variant. Returns a build ID; poll composeAndFilterPreviewStatus with it to retrieve the result. */
  composeAndFilterPreviewAsync: ComposeAndFilterPreviewAsyncBuild;
  /**
   * _Asynchronously_ previews a Contract schema built from this source variant.
   *
   * Enqueues a Temporal workflow and returns immediately with a `ContractPreviewAsyncBuild`
   * containing a build ID. Poll `contractPreviewStatus` with that ID for the result.
   */
  contractPreviewAsync: ContractPreviewAsyncBuild;
  createRouter: CreateRouterResult;
  /**
   * Callback mutation for submitting custom check results once your validation has run.
   * Results are returned with the SUCCESS or FAILURE of your validations, the task and workflow ids
   * to associate results, with and an optional list of violations to provide more details to users.
   * The Schema Check will wait for this response for 10 minutes and not complete until the results are returned.
   * After 10 minutes have passed without a callback request being received, the task will be marked as timed out.
   */
  customCheckCallback: CustomCheckCallbackResult;
  /** Delete the variant. */
  delete: DeleteSchemaTagResult;
  destroyRouter: DestroyRouterResult;
  /** Graph ID of the variant */
  graphId: Scalars['String']['output'];
  /** Global identifier for the graph variant, in the form `graph@variant`. */
  id: Scalars['ID']['output'];
  internalVariantUUID: Scalars['String']['output'];
  /** Links a specified PersistedQueryList to the variant of the parent GraphVariantMutation. */
  linkPersistedQueryList: LinkPersistedQueryListResultOrError;
  /** Name of the variant, like `variant`. */
  name: Scalars['String']['output'];
  /** Provides access to mutation fields for modifying a GraphOS Schema Proposal, if this GraphVariant is a proposal variant; else returns NotFoundError. Learn more at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
  proposal: ProposalMutationResult;
  /** Send a custom check request with a fake task id to your configured endpoint. */
  queueTestCustomChecksRequest: QueueTestCustomChecksRequestResult;
  relaunch: RelaunchResult;
  removeLinkFromVariant: GraphVariant;
  /** Gets the router attached to a graph variant */
  router: Maybe<RouterMutation>;
  runLintCheck: CheckStepResult;
  /** Mutation called by CheckCoordinator to find associated proposals to the schema diffs in a check workflow */
  runProposalsCheck: CheckStepResult;
  service: Service;
  setCustomCheckConfiguration: CustomCheckConfigurationResult;
  setIsFavoriteOfCurrentUser: GraphVariant;
  /**
   * _Asynchronously_ kicks off operation checks for a proposed non-federated
   * schema change against its associated graph.
   *
   * Returns a `CheckRequestSuccess` object with a workflow ID that you can use
   * to check status, or an error object if the checks workflow failed to start.
   *
   * Rate limited to 3000 per min. Schema checks cannot be performed on contract variants.
   */
  submitCheckSchemaAsync: CheckRequestResult;
  /** Submit a request for a Filter Schema Check and receive a result with a workflow ID that can be used to check status, or an error message that explains what went wrong. */
  submitFilterCheckAsync: CheckRequestResult;
  /**
   *  _Asynchronously_ kicks off composition and operation checks for all proposed subgraphs schema changes against its associated supergraph.
   *
   *  Returns a `CheckRequestSuccess` object with a workflow ID that you can use
   *  to check status, or an error object if the checks workflow failed to start.
   *
   * Rate limited to 3000 per min. Subgraph checks cannot be performed on contract variants.
   */
  submitMultiSubgraphCheckAsync: CheckRequestResult;
  /**
   * _Asynchronously_ kicks off composition and operation checks for a proposed subgraph schema change against its associated supergraph.
   *
   * Returns a `CheckRequestSuccess` object with a workflow ID that you can use
   * to check status, or an error object if the checks workflow failed to start.
   *
   * Rate limited to 3000 per min. Subgraph checks cannot be performed on contract variants.
   */
  submitSubgraphCheckAsync: CheckRequestResult;
  /** Triggers the Proposals implementation check for active proposals that are sourced from this variant for a given graph composition id */
  triggerProposalsImplementationHandler: Maybe<GraphVariant>;
  /** Unlinks a specified PersistedQueryList from the variant of the parent GraphVariantMutation. */
  unlinkPersistedQueryList: UnlinkPersistedQueryListResultOrError;
  updateCheckConfigurationCustomChecks: VariantCheckConfiguration;
  updateCheckConfigurationDowngradeChecks: VariantCheckConfiguration;
  updateCheckConfigurationDownstreamVariants: VariantCheckConfiguration;
  updateCheckConfigurationEnableOperationsCheck: Maybe<VariantCheckConfiguration>;
  updateCheckConfigurationExcludedClients: VariantCheckConfiguration;
  updateCheckConfigurationExcludedOperations: VariantCheckConfiguration;
  updateCheckConfigurationIncludedVariants: VariantCheckConfiguration;
  updateCheckConfigurationProposalChangeMismatchSeverity: VariantCheckConfiguration;
  updateCheckConfigurationTimeRange: VariantCheckConfiguration;
  updateIsProtected: Maybe<GraphVariant>;
  updatePostflightScript: Maybe<GraphVariant>;
  updatePreflightScript: Maybe<GraphVariant>;
  updateRouter: UpdateRouterResult;
  updateSendCookies: Maybe<GraphVariant>;
  updateSharedHeaders: Maybe<GraphVariant>;
  updateSubscriptionURL: Maybe<GraphVariant>;
  updateURL: Maybe<GraphVariant>;
  /** Updates the [federation version](https://www.apollographql.com/docs/graphos/reference/router/federation-version-support) of this variant */
  updateVariantFederationVersion: Maybe<GraphVariant>;
  updateVariantIsPublic: Maybe<GraphVariant>;
  updateVariantIsPubliclyListed: Maybe<GraphVariant>;
  updateVariantIsVerified: Maybe<GraphVariant>;
  /** Updates the [README](https://www.apollographql.com/docs/studio/org/graphs/#the-readme-page) of this variant. */
  updateVariantReadme: Maybe<GraphVariant>;
  upsertRouterConfig: Maybe<UpsertRouterResult>;
  variant: GraphVariant;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationaddLinkToVariantArgs = {
  title?: InputMaybe<Scalars['String']['input']>;
  type: LinkInfoType;
  url: Scalars['String']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationbuildConfigArgs = {
  federationVersion?: InputMaybe<Scalars['FederationVersion']['input']>;
  skipLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  tagInApiSchema: Scalars['Boolean']['input'];
  version?: InputMaybe<BuildPipelineTrack>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationcomposeAndFilterPreviewAsyncArgs = {
  filterConfig?: InputMaybe<FilterConfigInput>;
  subgraphChanges?: InputMaybe<Array<ComposeAndFilterPreviewSubgraphChange>>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationcontractPreviewAsyncArgs = {
  filters: FilterConfigInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationcreateRouterArgs = {
  input: CreateRouterInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationcustomCheckCallbackArgs = {
  input: CustomCheckCallbackInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationlinkPersistedQueryListArgs = {
  persistedQueryListId: Scalars['ID']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationremoveLinkFromVariantArgs = {
  linkInfoId: Scalars['ID']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationrunLintCheckArgs = {
  input: RunLintCheckInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationrunProposalsCheckArgs = {
  input: RunProposalsCheckInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsetCustomCheckConfigurationArgs = {
  input: SetCustomCheckConfigurationInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsetIsFavoriteOfCurrentUserArgs = {
  favorite: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsubmitCheckSchemaAsyncArgs = {
  input: CheckSchemaAsyncInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsubmitFilterCheckAsyncArgs = {
  input: FilterCheckAsyncInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsubmitMultiSubgraphCheckAsyncArgs = {
  input: MultiSubgraphCheckAsyncInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationsubmitSubgraphCheckAsyncArgs = {
  input: SubgraphCheckAsyncInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationtriggerProposalsImplementationHandlerArgs = {
  graphCompositionId: Scalars['ID']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationCustomChecksArgs = {
  enableCustomChecks?: InputMaybe<Scalars['Boolean']['input']>;
  useGraphSettings: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationDowngradeChecksArgs = {
  downgradeDefaultValueChange?: InputMaybe<Scalars['Boolean']['input']>;
  downgradeStaticChecks?: InputMaybe<Scalars['Boolean']['input']>;
  useGraphSettings: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationDownstreamVariantsArgs = {
  blockingDownstreamVariants?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationEnableOperationsCheckArgs = {
  enabled: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationExcludedClientsArgs = {
  appendGraphSettings: Scalars['Boolean']['input'];
  excludedClients?: InputMaybe<Array<ClientFilterInput>>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationExcludedOperationsArgs = {
  appendGraphSettings: Scalars['Boolean']['input'];
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput>>;
  excludedOperations?: InputMaybe<Array<OperationInfoFilterInput>>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationIncludedVariantsArgs = {
  includedVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  useGraphSettings: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationProposalChangeMismatchSeverityArgs = {
  proposalChangeMismatchSeverity?: InputMaybe<ProposalChangeMismatchSeverity>;
  useGraphSettings?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateCheckConfigurationTimeRangeArgs = {
  operationCountThreshold?: InputMaybe<Scalars['Int']['input']>;
  operationCountThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  timeRangeSeconds?: InputMaybe<Scalars['Long']['input']>;
  useGraphSettings: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateIsProtectedArgs = {
  isProtected: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdatePostflightScriptArgs = {
  postflightScript?: InputMaybe<Scalars['String']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdatePreflightScriptArgs = {
  preflightScript?: InputMaybe<Scalars['String']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateRouterArgs = {
  input: UpdateRouterInput;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateSendCookiesArgs = {
  sendCookies: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateSharedHeadersArgs = {
  sharedHeaders?: InputMaybe<Scalars['String']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateSubscriptionURLArgs = {
  subscriptionUrl?: InputMaybe<Scalars['String']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateURLArgs = {
  url?: InputMaybe<Scalars['String']['input']>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateVariantFederationVersionArgs = {
  federationVersion?: InputMaybe<Scalars['FederationVersion']['input']>;
  version?: InputMaybe<BuildPipelineTrack>;
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateVariantIsPublicArgs = {
  isPublic: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateVariantIsPubliclyListedArgs = {
  isPubliclyListed: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateVariantIsVerifiedArgs = {
  isVerified: Scalars['Boolean']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupdateVariantReadmeArgs = {
  readme: Scalars['String']['input'];
};


/** Modifies a variant of a graph, also called a schema tag in parts of our product. */
export type GraphVariantMutationupsertRouterConfigArgs = {
  configuration: Scalars['String']['input'];
};

export type GraphVariantOperationCollectionConnection = {
  __typename: 'GraphVariantOperationCollectionConnection';
  /** A list of edges from the graph variant to its operation collections. */
  edges: Maybe<Array<GraphVariantOperationCollectionEdge>>;
  /** A list of operation collections attached to a graph variant. */
  nodes: Maybe<Array<OperationCollection>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge between a graph variant and an operation collection. */
export type GraphVariantOperationCollectionEdge = {
  __typename: 'GraphVariantOperationCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** An operation collection attached to a graph variant. */
  node: Maybe<OperationCollection>;
};

/** A list of operation insights list items that belong to a graph variant. */
export type GraphVariantOperationInsightsListItemConnection = {
  __typename: 'GraphVariantOperationInsightsListItemConnection';
  /** A list of edges from the graph variant to its operation insights list items. */
  edges: Maybe<Array<GraphVariantOperationInsightsListItemEdge>>;
  /** A list of operation insights list items that belong to a graph variant. */
  nodes: Maybe<Array<OperationInsightsListItem>>;
  /** Information to aid in pagination. */
  pageInfo: OperationInsightsListPageInfo;
  /** The total number of operation insights list items connected to the graph variant. */
  totalCount: Scalars['Int']['output'];
};

/** An edge between a graph variant and an operation insights list item. */
export type GraphVariantOperationInsightsListItemEdge = {
  __typename: 'GraphVariantOperationInsightsListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A operation insights list items attached to the graph variant. */
  node: Maybe<OperationInsightsListItem>;
};

/** Individual permissions for the current user when interacting with a particular Studio graph variant. */
export type GraphVariantPermissions = {
  __typename: 'GraphVariantPermissions';
  canCreateCollectionInVariant: Scalars['Boolean']['output'];
  /** If this variant is a Proposal, will match the Proposal.canEditProposal field (can the current user can edit this Proposal either by authorship or role level). False if this GraphVariant is not a Proposal. */
  canEditProposal: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage/update this variant's build configuration (e.g., build pipeline version). */
  canManageBuildConfig: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage/update cloud routers */
  canManageCloudRouter: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to update variant-level settings for the Apollo Studio Explorer. */
  canManageExplorerSettings: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to publish schemas to this variant. */
  canPushSchemas: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user can read any information about this variant. */
  canQuery: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view this variant's build configuration details (e.g., build pipeline version). */
  canQueryBuildConfig: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view details regarding cloud routers */
  canQueryCloudRouter: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view cloud router logs */
  canQueryCloudRouterLogs: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view launch history */
  canQueryLaunches: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to download schemas associated to this variant. */
  canQuerySchemas: Scalars['Boolean']['output'];
  canShareCollectionInVariant: Scalars['Boolean']['output'];
  canUpdateVariantLinkInfo: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to update the README for this variant. */
  canUpdateVariantReadme: Scalars['Boolean']['output'];
  variantId: Scalars['ID']['output'];
};

export type GraphVariantSubgraphInsightsListItemConnection = {
  __typename: 'GraphVariantSubgraphInsightsListItemConnection';
  /** A list of edges from the graph variant to its subgraph insights list items. */
  edges: Maybe<Array<GraphVariantSubgraphInsightsListItemEdge>>;
  /** A list of subgraph insights list items that belong to a graph variant. */
  nodes: Maybe<Array<SubgraphInsightsListItem>>;
  /** Information to aid in pagination. */
  pageInfo: SubgraphInsightsListPageInfo;
  /** The total number of subgraph insights list items connected to the graph variant. */
  totalCount: Scalars['Int']['output'];
};

export type GraphVariantSubgraphInsightsListItemEdge = {
  __typename: 'GraphVariantSubgraphInsightsListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A error insights list items attached to the graph variant. */
  node: Maybe<SubgraphInsightsListItem>;
};

/** Columns of GraphosCloudMetrics. */
export enum GraphosCloudMetricsColumn {
  ACCOUNT_ID = 'ACCOUNT_ID',
  AGENT_VERSION = 'AGENT_VERSION',
  CLOUD_PROVIDER = 'CLOUD_PROVIDER',
  RESPONSE_SIZE = 'RESPONSE_SIZE',
  RESPONSE_SIZE_THROTTLED = 'RESPONSE_SIZE_THROTTLED',
  ROUTER_ID = 'ROUTER_ID',
  ROUTER_OPERATIONS = 'ROUTER_OPERATIONS',
  ROUTER_OPERATIONS_THROTTLED = 'ROUTER_OPERATIONS_THROTTLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  SUBGRAPH_FETCHES = 'SUBGRAPH_FETCHES',
  SUBGRAPH_FETCHES_THROTTLED = 'SUBGRAPH_FETCHES_THROTTLED',
  TIER = 'TIER',
  TIMESTAMP = 'TIMESTAMP'
}

export type GraphosCloudMetricsDimensions = {
  __typename: 'GraphosCloudMetricsDimensions';
  accountId: Maybe<Scalars['ID']['output']>;
  agentVersion: Maybe<Scalars['String']['output']>;
  cloudProvider: Maybe<Scalars['String']['output']>;
  routerId: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  tier: Maybe<Scalars['String']['output']>;
};

/** Filter for data in GraphosCloudMetrics. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type GraphosCloudMetricsFilter = {
  /** Selects rows whose accountId dimension equals the given value if not null. To query for the null value, use {in: {accountId: [null]}} instead. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<GraphosCloudMetricsFilter>>;
  /** Selects rows whose cloudProvider dimension equals the given value if not null. To query for the null value, use {in: {cloudProvider: [null]}} instead. */
  cloudProvider?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<GraphosCloudMetricsFilterIn>;
  not?: InputMaybe<GraphosCloudMetricsFilter>;
  or?: InputMaybe<Array<GraphosCloudMetricsFilter>>;
  /** Selects rows whose routerId dimension equals the given value if not null. To query for the null value, use {in: {routerId: [null]}} instead. */
  routerId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose tier dimension equals the given value if not null. To query for the null value, use {in: {tier: [null]}} instead. */
  tier?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in GraphosCloudMetrics. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type GraphosCloudMetricsFilterIn = {
  /** Selects rows whose accountId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  accountId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose cloudProvider dimension is in the given list. A null value in the list means a row with null for that dimension. */
  cloudProvider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose tier dimension is in the given list. A null value in the list means a row with null for that dimension. */
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GraphosCloudMetricsMetrics = {
  __typename: 'GraphosCloudMetricsMetrics';
  responseSize: Scalars['Long']['output'];
  responseSizeThrottled: Scalars['Long']['output'];
  routerOperations: Scalars['Long']['output'];
  routerOperationsThrottled: Scalars['Long']['output'];
  subgraphFetches: Scalars['Long']['output'];
  subgraphFetchesThrottled: Scalars['Long']['output'];
};

export type GraphosCloudMetricsOrderBySpec = {
  column: GraphosCloudMetricsColumn;
  direction: Ordering;
};

export type GraphosCloudMetricsRecord = {
  __typename: 'GraphosCloudMetricsRecord';
  /** Dimensions of GraphosCloudMetrics that can be grouped by. */
  groupBy: GraphosCloudMetricsDimensions;
  /** Metrics of GraphosCloudMetrics that can be aggregated over. */
  metrics: GraphosCloudMetricsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A fetch to a GraphQL subgraph. */
export type GraphqlSubgraphFetchDetails = SubgraphFetchDetails & {
  __typename: 'GraphqlSubgraphFetchDetails';
  /** The subgraph's name. */
  name: Scalars['String']['output'];
};

export enum HTTPMethod {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE',
  UNKNOWN = 'UNKNOWN',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Returned when the organization has cloudy graphs and the plan does not support them */
export type HasCloudyGraphs = PlanIneligibilityReason & {
  __typename: 'HasCloudyGraphs';
  /** The severity of the ineligibility reason */
  severity: PlanIneligibilityReasonSeverity;
};

export type HistoricQueryParameters = {
  /** A list of clients to filter out during validation. */
  excludedClients?: InputMaybe<Array<ClientInfoFilter>>;
  /** A list of operation names to filter out during validation. */
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput>>;
  from?: InputMaybe<Scalars['String']['input']>;
  /** A list of operation IDs to filter out during validation. */
  ignoredOperations?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * A list of variants to include in the validation. If no variants are provided
   * then this defaults to the "current" variant along with the base variant. The
   * base variant indicates the schema that generates diff and marks the metrics that
   * are checked for broken queries. We union this base variant with the untagged values('',
   * same as null inside of `in`, and 'current') in this metrics fetch. This strategy
   * supports users who have not tagged their metrics or schema.
   */
  includedVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Minimum number of requests within the window for a query to be considered. */
  queryCountThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of requests within the window for a query to be considered, relative to
   * total request count. Expected values are between 0 and 0.05 (minimum 5% of total
   * request volume)
   */
  queryCountThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Input type to provide when specifying configuration details for schema checks. */
export type HistoricQueryParametersInput = {
  /** Clients to be excluded from check. */
  excludedClients?: InputMaybe<Array<ClientInfoFilter>>;
  /** Operations to be ignored in this schema check, specified by operation name. */
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput>>;
  /** Start time for operations to be checked against. Specified as either a) an ISO formatted date/time string or b) a negative number of seconds relative to the time the check request was submitted. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Operations to be ignored in this schema check, specified by ID. */
  ignoredOperations?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Graph variants to be included in check. */
  includedVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum number of queries to be checked against the change. */
  queryCountThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Only fail check if this percentage of operations would be negatively impacted. */
  queryCountThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** End time for operations to be checked against. Specified as either a) an ISO formatted date/time string or b) a negative number of seconds relative to the time the check request was submitted. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** An identity (such as a `User` or `Graph`) in Apollo Studio. See implementing types for details. */
export type Identity = {
  /** Returns a representation of the identity as an `Actor` type. */
  asActor: Actor;
  /** The identity's identifier, which is unique among objects of its type. */
  id: Scalars['ID']['output'];
  /** The identity's human-readable name. */
  name: Scalars['String']['output'];
};

/** An actor's identity and info about the client they used to perform the action */
export type IdentityAndClientInfo = {
  __typename: 'IdentityAndClientInfo';
  /** Client name provided when the actor performed the action */
  clientName: Maybe<Scalars['String']['output']>;
  /** Client version provided when the actor performed the action */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** Identity info about the actor */
  identity: Maybe<Identity>;
};

export type IdentityMutation = ServiceMutation | UserMutation;

export type IgnoreOperationsInChecksResult = {
  __typename: 'IgnoreOperationsInChecksResult';
  /** The graph that was updated. */
  graph: Service;
  /** An error or success message. */
  message: Scalars['String']['output'];
  /** Whether or not the request succeeded. */
  success: Scalars['Boolean']['output'];
};

export type IgnoredRule = {
  __typename: 'IgnoredRule';
  ignoredRule: LintRule;
  schemaCoordinate: Scalars['String']['output'];
  subgraphName: Maybe<Scalars['String']['output']>;
};

export type IgnoredRuleInput = {
  ignoredRule: LintRule;
  schemaCoordinate: Scalars['String']['input'];
  subgraphName?: InputMaybe<Scalars['String']['input']>;
};

/** The location of the implementing service config file in storage */
export type ImplementingServiceLocation = {
  __typename: 'ImplementingServiceLocation';
  /** The name of the implementing service */
  name: Scalars['String']['output'];
  /** The path in storage to access the implementing service config file */
  path: Scalars['String']['output'];
};

export type InternalAdminUser = {
  __typename: 'InternalAdminUser';
  role: InternalMdgAdminRole;
  userID: Scalars['String']['output'];
};

export type InternalIdentity = Identity & {
  __typename: 'InternalIdentity';
  accounts: Array<Account>;
  asActor: Actor;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum InternalMdgAdminRole {
  INTERNAL_MDG_ADMIN = 'INTERNAL_MDG_ADMIN',
  INTERNAL_MDG_READ_ONLY = 'INTERNAL_MDG_READ_ONLY',
  INTERNAL_MDG_SALES = 'INTERNAL_MDG_SALES',
  INTERNAL_MDG_SUPER_ADMIN = 'INTERNAL_MDG_SUPER_ADMIN',
  INTERNAL_MDG_SUPPORT = 'INTERNAL_MDG_SUPPORT'
}

/** Generic server error. This should only ever return 'internal server error' as a message */
export type InternalServerError = Error & {
  __typename: 'InternalServerError';
  /** Message related to the internal error */
  message: Scalars['String']['output'];
};

export type IntrospectionDirective = {
  __typename: 'IntrospectionDirective';
  args: Array<IntrospectionInputValue>;
  description: Maybe<Scalars['String']['output']>;
  locations: Array<IntrospectionDirectiveLocation>;
  name: Scalars['String']['output'];
};

export type IntrospectionDirectiveInput = {
  args: Array<IntrospectionInputValueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
  locations: Array<IntrospectionDirectiveLocation>;
  name: Scalars['String']['input'];
};

/** __DirectiveLocation introspection type */
export enum IntrospectionDirectiveLocation {
  /** Location adjacent to an argument definition. */
  ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an enum definition. */
  ENUM = 'ENUM',
  /** Location adjacent to an enum value definition. */
  ENUM_VALUE = 'ENUM_VALUE',
  /** Location adjacent to a field. */
  FIELD = 'FIELD',
  /** Location adjacent to a field definition. */
  FIELD_DEFINITION = 'FIELD_DEFINITION',
  /** Location adjacent to a fragment definition. */
  FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  INLINE_FRAGMENT = 'INLINE_FRAGMENT',
  /** Location adjacent to an input object field definition. */
  INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION',
  /** Location adjacent to an input object type definition. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /** Location adjacent to an interface definition. */
  INTERFACE = 'INTERFACE',
  /** Location adjacent to a mutation operation. */
  MUTATION = 'MUTATION',
  /** Location adjacent to an object type definition. */
  OBJECT = 'OBJECT',
  /** Location adjacent to a query operation. */
  QUERY = 'QUERY',
  /** Location adjacent to a scalar definition. */
  SCALAR = 'SCALAR',
  /** Location adjacent to a schema definition. */
  SCHEMA = 'SCHEMA',
  /** Location adjacent to a subscription operation. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** Location adjacent to a union definition. */
  UNION = 'UNION',
  /** Location adjacent to a variable definition. */
  VARIABLE_DEFINITION = 'VARIABLE_DEFINITION'
}

/** Values associated with introspection result for an enum value */
export type IntrospectionEnumValue = {
  __typename: 'IntrospectionEnumValue';
  /** @deprecated Use deprecationReason instead */
  depreactionReason: Maybe<Scalars['String']['output']>;
  deprecationReason: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** __EnumValue introspection type */
export type IntrospectionEnumValueInput = {
  deprecationReason?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeprecated: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Values associated with introspection result for field */
export type IntrospectionField = {
  __typename: 'IntrospectionField';
  args: Array<IntrospectionInputValue>;
  deprecationReason: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: IntrospectionType;
};

/** __Field introspection type */
export type IntrospectionFieldInput = {
  args: Array<IntrospectionInputValueInput>;
  deprecationReason?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeprecated: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  type: IntrospectionTypeInput;
};

/** Values associated with introspection result for an input field */
export type IntrospectionInputValue = {
  __typename: 'IntrospectionInputValue';
  defaultValue: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: IntrospectionType;
};

/** __Value introspection type */
export type IntrospectionInputValueInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  deprecationReason?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: IntrospectionTypeInput;
};

export type IntrospectionSchema = {
  __typename: 'IntrospectionSchema';
  directives: Array<IntrospectionDirective>;
  mutationType: Maybe<IntrospectionType>;
  queryType: IntrospectionType;
  subscriptionType: Maybe<IntrospectionType>;
  types: Array<IntrospectionType>;
};


export type IntrospectionSchematypesArgs = {
  filter?: InputMaybe<TypeFilterConfig>;
};

/** __Schema introspection type */
export type IntrospectionSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  directives: Array<IntrospectionDirectiveInput>;
  mutationType?: InputMaybe<IntrospectionTypeRefInput>;
  queryType: IntrospectionTypeRefInput;
  subscriptionType?: InputMaybe<IntrospectionTypeRefInput>;
  types?: InputMaybe<Array<IntrospectionTypeInput>>;
};

/** Object containing all possible values for an introspectionType */
export type IntrospectionType = {
  __typename: 'IntrospectionType';
  /** the base kind of the type this references, ignoring lists and nullability */
  baseKind: Maybe<IntrospectionTypeKind>;
  description: Maybe<Scalars['String']['output']>;
  enumValues: Maybe<Array<IntrospectionEnumValue>>;
  fields: Maybe<Array<IntrospectionField>>;
  inputFields: Maybe<Array<IntrospectionInputValue>>;
  interfaces: Maybe<Array<IntrospectionType>>;
  kind: Maybe<IntrospectionTypeKind>;
  name: Maybe<Scalars['String']['output']>;
  ofType: Maybe<IntrospectionType>;
  possibleTypes: Maybe<Array<IntrospectionType>>;
  /** printed representation of type, including nested nullability and list ofTypes */
  printed: Scalars['String']['output'];
};


/** Object containing all possible values for an introspectionType */
export type IntrospectionTypeenumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** __Type introspection type */
export type IntrospectionTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enumValues?: InputMaybe<Array<IntrospectionEnumValueInput>>;
  fields?: InputMaybe<Array<IntrospectionFieldInput>>;
  inputFields?: InputMaybe<Array<IntrospectionInputValueInput>>;
  interfaces?: InputMaybe<Array<IntrospectionTypeInput>>;
  kind: IntrospectionTypeKind;
  name?: InputMaybe<Scalars['String']['input']>;
  ofType?: InputMaybe<IntrospectionTypeInput>;
  possibleTypes?: InputMaybe<Array<IntrospectionTypeInput>>;
  specifiedByUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum IntrospectionTypeKind {
  /** Indicates this type is an enum. 'enumValues' is a valid field. */
  ENUM = 'ENUM',
  /** Indicates this type is an input object. 'inputFields' is a valid field. */
  INPUT_OBJECT = 'INPUT_OBJECT',
  /**
   * Indicates this type is an interface. 'fields' and 'possibleTypes' are valid
   * fields
   */
  INTERFACE = 'INTERFACE',
  /** Indicates this type is a list. 'ofType' is a valid field. */
  LIST = 'LIST',
  /** Indicates this type is a non-null. 'ofType' is a valid field. */
  NON_NULL = 'NON_NULL',
  /** Indicates this type is an object. 'fields' and 'interfaces' are valid fields. */
  OBJECT = 'OBJECT',
  /** Indicates this type is a scalar. */
  SCALAR = 'SCALAR',
  /** Indicates this type is a union. 'possibleTypes' is a valid field. */
  UNION = 'UNION'
}

/** Shallow __Type introspection type */
export type IntrospectionTypeRefInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** An error caused by providing invalid input for a task, such as schema checks. */
export type InvalidInputError = {
  __typename: 'InvalidInputError';
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Generic input error */
export type InvalidInputErrors = Error & {
  __typename: 'InvalidInputErrors';
  errors: Array<CloudInvalidInputError>;
  message: Scalars['String']['output'];
};

export type InvalidOperation = {
  __typename: 'InvalidOperation';
  errors: Maybe<Array<OperationValidationError>>;
  signature: Scalars['ID']['output'];
};

/** This object is returned when a request to fetch a Studio graph variant provides an invalid graph ref. */
export type InvalidRefFormat = Error & {
  __typename: 'InvalidRefFormat';
  message: Scalars['String']['output'];
};

/** A coordinate whose requested tags were rejected, with the reasons. */
export type InvalidServiceFieldTag = {
  __typename: 'InvalidServiceFieldTag';
  /**
   * The coordinate exactly as it was submitted, so the caller can match it
   * back to the pending edit it staged.
   */
  coordinate: Scalars['String']['output'];
  /** Every reason this coordinate was rejected; never empty. */
  errors: Array<ServiceFieldTagError>;
};

export type InvalidTarget = Error & {
  __typename: 'InvalidTarget';
  message: Scalars['String']['output'];
};

export type Invoice = {
  __typename: 'Invoice';
  closedAt: Maybe<Scalars['Timestamp']['output']>;
  collectionMethod: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['Int']['output'];
  invoiceNumberV2: Scalars['String']['output'];
  state: InvoiceState;
  totalInCents: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type InvoiceLineItem = {
  __typename: 'InvoiceLineItem';
  /**
   * Line items may be grouped to help the customer better understand their charges
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  groupKey: Maybe<Scalars['String']['output']>;
  /**
   * Line items may be grouped to help the customer better understand their charges
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  groupValue: Maybe<Scalars['String']['output']>;
  /** @deprecated This data came from Metronome and we no longer use Metronome */
  name: Scalars['String']['output'];
  /**
   * The quantity of 'things' in this line item. (e.g. number of operations, seats, etc).
   * May be null for flat charges.
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  quantity: Maybe<Scalars['Int']['output']>;
  /**
   * The amount this line item costs.
   * @deprecated This data came from Metronome and we no longer use Metronome
   */
  totalInCents: Scalars['Int']['output'];
};

export enum InvoiceState {
  COLLECTED = 'COLLECTED',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  PAST_DUE = 'PAST_DUE',
  UNKNOWN = 'UNKNOWN',
  VOID = 'VOID'
}

export type JointUsageData = {
  __typename: 'JointUsageData';
  druidCount: Scalars['Long']['output'];
  meterEventName: Scalars['String']['output'];
  stripeCount: Scalars['Long']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

/** Represents the complete process of making a set of updates to a deployed graph variant. */
export type Launch = {
  __typename: 'Launch';
  /** The timestamp when the launch was approved. */
  approvedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The associated build for this launch (a build includes schema composition and contract filtering). This value is null until the build is initiated. */
  build: Maybe<Build>;
  /** The inputs provided to this launch's associated build, including subgraph schemas and contract filters. */
  buildInput: BuildInput;
  /** The timestamp when the launch completed. This value is null until the launch completes. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The timestamp when the launch was initiated. */
  createdAt: Scalars['Timestamp']['output'];
  /** Contract launches that were triggered by this launch. */
  downstreamLaunches: Array<Launch>;
  /** The launch's associated graph. */
  graph: Maybe<Service>;
  /** The Graph Artifact created from this launch. */
  graphArtifact: Maybe<GraphArtifact>;
  /** The ID of the launch's associated graph. */
  graphId: Scalars['String']['output'];
  /** The name of the launch's associated variant. */
  graphVariant: Scalars['String']['output'];
  /** The unique identifier for this launch. */
  id: Scalars['ID']['output'];
  /** Whether the launch completed. */
  isCompleted: Maybe<Scalars['Boolean']['output']>;
  /** Whether the result of the launch has been published to the associated graph and variant. This is always false for a failed launch. */
  isPublished: Maybe<Scalars['Boolean']['output']>;
  /** The most recent launch sequence step that has started but not necessarily completed. */
  latestSequenceStep: Maybe<LaunchSequenceStep>;
  /** Cloud Router order for this launch ID */
  order: OrderOrError;
  orders: Array<Order>;
  /** The launch immediately prior to this one. If successOnly is true, returns the most recent successful launch; if false, returns the most recent launch, regardless of success. If no such previous launch exists, returns null. */
  previousLaunch: Maybe<Launch>;
  /** Returns the proposal revision associated with this launch, if it exists. This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  proposalRevision: Maybe<ProposalRevision>;
  /** A specific publication of a graph variant pertaining to this launch. */
  publication: Maybe<SchemaTag>;
  /** A list of results from the completed launch. The items included in this list vary depending on whether the launch succeeded, failed, or was superseded. */
  results: Array<LaunchResult>;
  /** Cloud router configuration associated with this build event. It will be non-null for any cloud-router variant, and null for any not cloudy variant/graph. */
  routerConfig: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<SchemaTag>;
  /** A list of all serial steps in the launch sequence. This list can change as the launch progresses. For example, a `LaunchCompletedStep` is appended after a launch completes. */
  sequence: Array<LaunchSequenceStep>;
  /** A shortened version of `Launch.id` that includes only the first 8 characters. */
  shortenedID: Scalars['String']['output'];
  /** The launch's status. If a launch is superseded, its status remains `LAUNCH_INITIATED`. To check for a superseded launch, use `supersededAt`. */
  status: LaunchStatus;
  /** A list of subgraph changes that are included in this launch. */
  subgraphChanges: Maybe<Array<SubgraphChange>>;
  /** The timestamp when this launch was superseded by another launch. If an active launch is superseded, it terminates. */
  supersededAt: Maybe<Scalars['Timestamp']['output']>;
  /** The launch that superseded this launch, if any. If an active launch is superseded, it terminates. */
  supersededBy: Maybe<Launch>;
  /** The source variant launch that caused this launch to be initiated. This value is present only for contract variant launches. Otherwise, it's null. */
  upstreamLaunch: Maybe<Launch>;
};


/** Represents the complete process of making a set of updates to a deployed graph variant. */
export type LaunchpreviousLaunchArgs = {
  successOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LaunchHistoryOrder {
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC'
}

/** Types of results that can be associated with a `Launch` */
export type LaunchResult = ChangelogLaunchResult;

/** The timing details for the build step of a launch. */
export type LaunchSequenceBuildStep = {
  __typename: 'LaunchSequenceBuildStep';
  /** The timestamp when the step completed. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The timestamp when the step started. */
  startedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** The timing details for the completion step of a launch. */
export type LaunchSequenceCompletedStep = {
  __typename: 'LaunchSequenceCompletedStep';
  /** The timestamp when the step (and therefore the launch) completed. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** The timing details for the initiation step of a launch. */
export type LaunchSequenceInitiatedStep = {
  __typename: 'LaunchSequenceInitiatedStep';
  /** The timestamp when the step (and therefore the launch) started. */
  startedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** The timing details for the publish step of a launch. */
export type LaunchSequencePublishStep = {
  __typename: 'LaunchSequencePublishStep';
  /** The timestamp when the step completed. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The timestamp when the step started. */
  startedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Represents the various steps that occur in sequence during a single launch. */
export type LaunchSequenceStep = LaunchSequenceBuildStep | LaunchSequenceCompletedStep | LaunchSequenceInitiatedStep | LaunchSequencePublishStep | LaunchSequenceSupersededStep;

/** The timing details for the superseded step of a launch. This step occurs only if the launch is superseded by another launch. */
export type LaunchSequenceSupersededStep = {
  __typename: 'LaunchSequenceSupersededStep';
  /** The timestamp when the step completed, thereby ending the execution of this launch in favor of the superseding launch. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
};

export enum LaunchStatus {
  LAUNCH_COMPLETED = 'LAUNCH_COMPLETED',
  LAUNCH_FAILED = 'LAUNCH_FAILED',
  LAUNCH_INITIATED = 'LAUNCH_INITIATED'
}

/** The summarized information about the complete process of making a set of updates to a deployed graph variant. For full information about the update, refer to the `GraphVariant.launch` using the `LaunchSummary.id`. */
export type LaunchSummary = {
  __typename: 'LaunchSummary';
  /** The timestamp when the launch was approved. */
  approvedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Identifier of the associated build for this launch. This value is null until the build is initiated. */
  buildID: Maybe<Scalars['ID']['output']>;
  /** The inputs provided to this launch's associated build, including subgraph schemas and contract filters. */
  buildInput: BuildInput;
  /** The timestamp when the launch completed. This value is null until the launch completes. */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The timestamp when the launch was initiated. */
  createdAt: Scalars['Timestamp']['output'];
  /** The ID of the launch's associated graph. */
  graphId: Scalars['String']['output'];
  /** The name of the launch's associated variant. */
  graphVariant: Scalars['String']['output'];
  /** The unique identifier for this launch. */
  id: Scalars['ID']['output'];
  /** A list of results from the completed launch. The items included in this list vary depending on whether the launch succeeded, failed, or was superseded. */
  results: Array<LaunchResult>;
  /** The launch's status. If a launch is superseded, its status remains `LAUNCH_INITIATED`. To check for a superseded launch, use `supersededAt`. */
  status: LaunchStatus;
  /** A list of subgraph changes that are included in this launch. */
  subgraphChanges: Maybe<Array<SubgraphChange>>;
};

export type LaunchTestRouterInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  provider?: InputMaybe<CloudProvider>;
  routerVersion: Scalars['String']['input'];
  tier?: InputMaybe<CloudTier>;
};

export type LaunchTestRouterResult = CloudRouterTestingInvalidInputErrors | LaunchTestRouterSuccess;

export type LaunchTestRouterSuccess = {
  __typename: 'LaunchTestRouterSuccess';
  graphRef: Scalars['String']['output'];
  jobId: Scalars['ID']['output'];
};

export type LinkInfo = {
  __typename: 'LinkInfo';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: LinkInfoType;
  url: Scalars['String']['output'];
};

export enum LinkInfoType {
  DEVELOPER_PORTAL = 'DEVELOPER_PORTAL',
  OTHER = 'OTHER',
  REPOSITORY = 'REPOSITORY'
}

export type LinkPersistedQueryListResult = {
  __typename: 'LinkPersistedQueryListResult';
  graphVariant: GraphVariant;
  persistedQueryList: PersistedQueryList;
};

/** The result/error union returned by GraphVariantMutation.linkPersistedQueryList. */
export type LinkPersistedQueryListResultOrError = LinkPersistedQueryListResult | ListNotFoundError | PermissionError | VariantAlreadyLinkedError;

export type LintCheckTask = CheckWorkflowTask & {
  __typename: 'LintCheckTask';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  graphID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  result: Maybe<LintResult>;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** A single rule violation. */
export type LintDiagnostic = {
  __typename: 'LintDiagnostic';
  /** The category used for grouping similar rules. */
  category: LinterRuleCategory;
  /** The schema coordinate of this diagnostic. */
  coordinate: Scalars['String']['output'];
  /** The graph's configured level for the rule. */
  level: LintDiagnosticLevel;
  /** The message describing the rule violation. */
  message: Scalars['String']['output'];
  /** The lint rule being violated. */
  rule: LintRule;
  /** The human readable position in the file of the rule violation. */
  sourceLocations: Array<Location>;
};

/** The severity level of an lint result. */
export enum LintDiagnosticLevel {
  ERROR = 'ERROR',
  IGNORED = 'IGNORED',
  WARNING = 'WARNING'
}

/** The result of linting a schema. */
export type LintResult = {
  __typename: 'LintResult';
  /** The set of lint rule violations found in the schema. */
  diagnostics: Array<LintDiagnostic>;
  /** Stats generated from the resulting diagnostics. */
  stats: LintStats;
};

export enum LintRule {
  ALL_ELEMENTS_REQUIRE_DESCRIPTION = 'ALL_ELEMENTS_REQUIRE_DESCRIPTION',
  CONTACT_DIRECTIVE_MISSING = 'CONTACT_DIRECTIVE_MISSING',
  DEFINED_TYPES_ARE_UNUSED = 'DEFINED_TYPES_ARE_UNUSED',
  DEPRECATED_DIRECTIVE_MISSING_REASON = 'DEPRECATED_DIRECTIVE_MISSING_REASON',
  DIRECTIVE_COMPOSITION = 'DIRECTIVE_COMPOSITION',
  DIRECTIVE_NAMES_SHOULD_BE_CAMEL_CASE = 'DIRECTIVE_NAMES_SHOULD_BE_CAMEL_CASE',
  DOES_NOT_PARSE = 'DOES_NOT_PARSE',
  ENUM_PREFIX = 'ENUM_PREFIX',
  ENUM_SUFFIX = 'ENUM_SUFFIX',
  ENUM_USED_AS_INPUT_WITHOUT_SUFFIX = 'ENUM_USED_AS_INPUT_WITHOUT_SUFFIX',
  ENUM_USED_AS_OUTPUT_DESPITE_SUFFIX = 'ENUM_USED_AS_OUTPUT_DESPITE_SUFFIX',
  ENUM_VALUES_SHOULD_BE_SCREAMING_SNAKE_CASE = 'ENUM_VALUES_SHOULD_BE_SCREAMING_SNAKE_CASE',
  FIELD_NAMES_SHOULD_BE_CAMEL_CASE = 'FIELD_NAMES_SHOULD_BE_CAMEL_CASE',
  FROM_SUBGRAPH_DOES_NOT_EXIST = 'FROM_SUBGRAPH_DOES_NOT_EXIST',
  INCONSISTENT_ARGUMENT_PRESENCE = 'INCONSISTENT_ARGUMENT_PRESENCE',
  INCONSISTENT_BUT_COMPATIBLE_ARGUMENT_TYPE = 'INCONSISTENT_BUT_COMPATIBLE_ARGUMENT_TYPE',
  INCONSISTENT_BUT_COMPATIBLE_FIELD_TYPE = 'INCONSISTENT_BUT_COMPATIBLE_FIELD_TYPE',
  INCONSISTENT_DEFAULT_VALUE_PRESENCE = 'INCONSISTENT_DEFAULT_VALUE_PRESENCE',
  INCONSISTENT_DESCRIPTION = 'INCONSISTENT_DESCRIPTION',
  INCONSISTENT_ENTITY = 'INCONSISTENT_ENTITY',
  INCONSISTENT_ENUM_VALUE_FOR_INPUT_ENUM = 'INCONSISTENT_ENUM_VALUE_FOR_INPUT_ENUM',
  INCONSISTENT_ENUM_VALUE_FOR_OUTPUT_ENUM = 'INCONSISTENT_ENUM_VALUE_FOR_OUTPUT_ENUM',
  INCONSISTENT_EXECUTABLE_DIRECTIVE_LOCATIONS = 'INCONSISTENT_EXECUTABLE_DIRECTIVE_LOCATIONS',
  INCONSISTENT_EXECUTABLE_DIRECTIVE_PRESENCE = 'INCONSISTENT_EXECUTABLE_DIRECTIVE_PRESENCE',
  INCONSISTENT_EXECUTABLE_DIRECTIVE_REPEATABLE = 'INCONSISTENT_EXECUTABLE_DIRECTIVE_REPEATABLE',
  INCONSISTENT_INPUT_OBJECT_FIELD = 'INCONSISTENT_INPUT_OBJECT_FIELD',
  INCONSISTENT_INTERFACE_VALUE_TYPE_FIELD = 'INCONSISTENT_INTERFACE_VALUE_TYPE_FIELD',
  INCONSISTENT_NON_REPEATABLE_DIRECTIVE_ARGUMENTS = 'INCONSISTENT_NON_REPEATABLE_DIRECTIVE_ARGUMENTS',
  INCONSISTENT_OBJECT_VALUE_TYPE_FIELD = 'INCONSISTENT_OBJECT_VALUE_TYPE_FIELD',
  INCONSISTENT_RUNTIME_TYPES_FOR_SHAREABLE_RETURN = 'INCONSISTENT_RUNTIME_TYPES_FOR_SHAREABLE_RETURN',
  INCONSISTENT_TYPE_SYSTEM_DIRECTIVE_LOCATIONS = 'INCONSISTENT_TYPE_SYSTEM_DIRECTIVE_LOCATIONS',
  INCONSISTENT_TYPE_SYSTEM_DIRECTIVE_REPEATABLE = 'INCONSISTENT_TYPE_SYSTEM_DIRECTIVE_REPEATABLE',
  INCONSISTENT_UNION_MEMBER = 'INCONSISTENT_UNION_MEMBER',
  INPUT_ARGUMENT_NAMES_SHOULD_BE_CAMEL_CASE = 'INPUT_ARGUMENT_NAMES_SHOULD_BE_CAMEL_CASE',
  INPUT_TYPE_SUFFIX = 'INPUT_TYPE_SUFFIX',
  INTERFACE_PREFIX = 'INTERFACE_PREFIX',
  INTERFACE_SUFFIX = 'INTERFACE_SUFFIX',
  MERGED_NON_REPEATABLE_DIRECTIVE_ARGUMENTS = 'MERGED_NON_REPEATABLE_DIRECTIVE_ARGUMENTS',
  NO_EXECUTABLE_DIRECTIVE_INTERSECTION = 'NO_EXECUTABLE_DIRECTIVE_INTERSECTION',
  NULLABLE_PATH_VARIABLE = 'NULLABLE_PATH_VARIABLE',
  OBJECT_PREFIX = 'OBJECT_PREFIX',
  OBJECT_SUFFIX = 'OBJECT_SUFFIX',
  OVERRIDDEN_FIELD_CAN_BE_REMOVED = 'OVERRIDDEN_FIELD_CAN_BE_REMOVED',
  OVERRIDE_DIRECTIVE_CAN_BE_REMOVED = 'OVERRIDE_DIRECTIVE_CAN_BE_REMOVED',
  OVERRIDE_MIGRATION_IN_PROGRESS = 'OVERRIDE_MIGRATION_IN_PROGRESS',
  QUERY_DOCUMENT_DECLARATION = 'QUERY_DOCUMENT_DECLARATION',
  RESTY_FIELD_NAMES = 'RESTY_FIELD_NAMES',
  TAG_DIRECTIVE_USES_UNKNOWN_NAME = 'TAG_DIRECTIVE_USES_UNKNOWN_NAME',
  TYPE_NAMES_SHOULD_BE_PASCAL_CASE = 'TYPE_NAMES_SHOULD_BE_PASCAL_CASE',
  TYPE_PREFIX = 'TYPE_PREFIX',
  TYPE_SUFFIX = 'TYPE_SUFFIX',
  UNUSED_ENUM_TYPE = 'UNUSED_ENUM_TYPE'
}

/** Stats generated from linting a schema against the graph's linter configuration. */
export type LintStats = {
  __typename: 'LintStats';
  /** Total number of lint errors. */
  errorsCount: Scalars['Int']['output'];
  /** Total number of lint rules ignored. */
  ignoredCount: Scalars['Int']['output'];
  /** Total number of lint rules violated. */
  totalCount: Scalars['Int']['output'];
  /** Total number of lint warnings. */
  warningsCount: Scalars['Int']['output'];
};

export type LinterIgnoredRuleChangesInput = {
  ruleViolationsToEnable: Array<IgnoredRuleInput>;
  ruleViolationsToIgnore: Array<IgnoredRuleInput>;
};

/** The category used for grouping similar rules. */
export enum LinterRuleCategory {
  /** These rules are generated during composition. */
  COMPOSITION = 'COMPOSITION',
  /** These rules enforce naming conventions. */
  NAMING = 'NAMING',
  /** These rules define conventions for the entire schema and directive usage outside of composition. */
  OTHER = 'OTHER'
}

export type LinterRuleLevelConfiguration = {
  __typename: 'LinterRuleLevelConfiguration';
  /** Illustrative code showcasing the potential violation of this rule. */
  badExampleCode: Maybe<Scalars['String']['output']>;
  /** The category used for grouping similar rules. */
  category: LinterRuleCategory;
  /** A human readable description of the rule. */
  description: Scalars['String']['output'];
  /** Illustrative code showcasing the fix for the potential violation of this rule. */
  goodExampleCode: Maybe<Scalars['String']['output']>;
  /** The configured level for the rule. */
  level: LintDiagnosticLevel;
  /** The name for this lint rule. */
  rule: LintRule;
};

export type LinterRuleLevelConfigurationChangesInput = {
  level: LintDiagnosticLevel;
  rule: LintRule;
};

/** The result of a failed call to GraphVariantMutation.linkPersistedQueryList when the specified list can't be found. */
export type ListNotFoundError = Error & {
  __typename: 'ListNotFoundError';
  listId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type Location = {
  __typename: 'Location';
  end: Maybe<Coordinate>;
  start: Maybe<Coordinate>;
  subgraphName: Maybe<Scalars['String']['output']>;
};

/** Level of the log entry */
export enum LogLevel {
  /** Debug log entry */
  DEBUG = 'DEBUG',
  /** Error log entry */
  ERROR = 'ERROR',
  /** Informational log entry */
  INFO = 'INFO',
  /** Warning log entry */
  WARN = 'WARN'
}

/** Order log message */
export type LogMessage = {
  __typename: 'LogMessage';
  /** Log level */
  level: LogLevel;
  /** Log message contents */
  message: Scalars['String']['output'];
  /** Timestamp in UTC */
  timestamp: Scalars['DateTime']['output'];
};

export enum LoginFlowSource {
  INTERNAL_SSO = 'INTERNAL_SSO'
}

export type MarkChangesForOperationAsSafeResult = {
  __typename: 'MarkChangesForOperationAsSafeResult';
  /**
   * Nice to have for the frontend since the Apollo cache is already watching for AffectedQuery to update.
   * This might return null if no behavior changes were found for the affected operation ID.
   * This is a weird situation that should never happen.
   */
  affectedOperation: Maybe<AffectedQuery>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** The result of the markCheckOperationsAsSafe and unmarkCheckOperationsAsSafe operations. */
export type MarkCheckOperationsAsSafeResult = {
  __typename: 'MarkCheckOperationsAsSafeResult';
  /** A message indicating what was changed or what could not be changed successfully */
  message: Scalars['String']['output'];
  /** True if the operations were updated successfully, false otherwise */
  success: Scalars['Boolean']['output'];
};

export type McpDefaultCollectionResult = OperationCollection | PermissionError;

/** Dimensions that can be used for grouping / filtering MCP insights. */
export enum McpInsightsTimeseriesReportDimension {
  /** The ID of the agent gateway */
  GATEWAY_ID = 'GATEWAY_ID',
  /** The ID of the agent gateway instance */
  GATEWAY_INSTANCE_ID = 'GATEWAY_INSTANCE_ID',
  /** The name of the MCP method being requested, e.g. `tools/call` */
  MCP_METHOD_NAME = 'MCP_METHOD_NAME',
  /** The ID of the tool being used if available */
  TOOL_ID = 'TOOL_ID',
  /** The ID of the upstream service being called through the gateway */
  UPSTREAM_ID = 'UPSTREAM_ID'
}

/** The type and value for an MCP insights timeseries report dimension. */
export type McpInsightsTimeseriesReportDimensionValue = {
  __typename: 'McpInsightsTimeseriesReportDimensionValue';
  /** The type of dimension this represents. */
  type: McpInsightsTimeseriesReportDimension;
  /** The string value of this dimension. */
  value: Maybe<Scalars['String']['output']>;
};

/** Lists of dimensions to include or exclude in the MCP insights timeseries report. Each list can have a maximum of 1000 entries. */
export type McpInsightsTimeseriesReportFilterInInput = {
  /** Matches any MCP requests whose gateway instance ID is in this list. */
  gatewayInstanceId?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any MCP requests whose method name is in this list. */
  mcpMethodName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any MCP requests whose tool ID is in this list. */
  toolId?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any MCP requests whose upstream ID is in this list. */
  upstreamId?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The filters available when using the MCP timeseries report. */
export type McpInsightsTimeseriesReportFilterInput = {
  /** Exclude MCP requests that match a specified set of dimensions. If the same dimension exists in both 'include' and 'exclude', a REQUEST_INVALID error will be returned. */
  exclude?: InputMaybe<McpInsightsTimeseriesReportFilterInInput>;
  /** Include MCP requests that match a specified set of dimensions. */
  include?: InputMaybe<McpInsightsTimeseriesReportFilterInInput>;
};

/** Metrics that are available from MCP insights. */
export enum McpInsightsTimeseriesReportMetric {
  /** The number of operations requested */
  REQUEST_COUNT = 'REQUEST_COUNT',
  /** The number of operations that resulted in at least one error */
  REQUEST_WITH_ERROR_COUNT = 'REQUEST_WITH_ERROR_COUNT'
}

/** The type and value for an MCP insights timeseries report metric. */
export type McpInsightsTimeseriesReportMetricValue = {
  __typename: 'McpInsightsTimeseriesReportMetricValue';
  /** The type of metric this represents. */
  type: McpInsightsTimeseriesReportMetric;
  /** The floating point value of this metric. */
  value: Scalars['Float']['output'];
};

/** The data that is returned by the MCP insights timeseries report. */
export type McpInsightsTimeseriesReportResult = {
  __typename: 'McpInsightsTimeseriesReportResult';
  /** A CSV representation of the results. This includes a header and rows that have a column for start and end timestamp and all requested dimensions and metrics. */
  csv: Maybe<Scalars['String']['output']>;
  /** The result records, with each row having a start and end timestamp and a set of dimensions and metrics. */
  records: Array<McpInsightsTimeseriesReportRow>;
};

/** A single row of data that is returned by the MCP insights timeseries report. */
export type McpInsightsTimeseriesReportRow = {
  __typename: 'McpInsightsTimeseriesReportRow';
  /** The dimension values for this row, matching the requested dimensions. */
  dimensions: Array<McpInsightsTimeseriesReportDimensionValue>;
  /** The exclusive end of the time bucket for this row. */
  endExclusiveTimestamp: Scalars['Timestamp']['output'];
  /** The metric values for this row, matching the requested metrics. */
  metrics: Array<McpInsightsTimeseriesReportMetricValue>;
  /** The start of the time bucket for this row. */
  startTimestamp: Scalars['Timestamp']['output'];
};

export type MediaUploadInfo = {
  __typename: 'MediaUploadInfo';
  csrfToken: Scalars['String']['output'];
  maxContentLength: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** This type represents a conflict between two versions of a schema i.e. the current proposal and the updated source variant schema */
export type MergeConflict = {
  __typename: 'MergeConflict';
  /** The diffs that caused the conflict */
  diffItems: Array<FlatDiffItem>;
  /** location of conflicts in the partialMergeSdl */
  locationCoordinate: Maybe<ParsedSchemaCoordinate>;
  /** message explaining the conflict */
  message: Maybe<Scalars['String']['output']>;
};

export type MergedSdlWithConflictsData = {
  __typename: 'MergedSdlWithConflictsData';
  subgraphsWithConflicts: Array<SubgraphWithConflicts>;
};

export type MergedSdlWithConflictsResult = MergedSdlWithConflictsData | NotFoundError;

export enum MeterKind {
  PERFORMANCE_ADDON_OPERATIONS = 'PERFORMANCE_ADDON_OPERATIONS',
  STANDARD_OPERATIONS = 'STANDARD_OPERATIONS',
  SUBSCRIPTION_MESSAGES = 'SUBSCRIPTION_MESSAGES'
}

export type MeterSummaries = {
  __typename: 'MeterSummaries';
  aggregatedValues: Array<MeterValue>;
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export type MeterValue = {
  __typename: 'MeterValue';
  meterKind: MeterKind;
  value: Scalars['Long']['output'];
};

export type MeteredBillCreditGrantLineItem = {
  __typename: 'MeteredBillCreditGrantLineItem';
  amountInCents: Scalars['Int']['output'];
};

/** Represents an invoice-level discount applied to the upcoming bill */
export type MeteredBillDiscountLineItem = {
  __typename: 'MeteredBillDiscountLineItem';
  /** Amount in USD cents. */
  amountInCents: Scalars['Int']['output'];
};

export type MeteredBillFlatFeeLineItem = {
  __typename: 'MeteredBillFlatFeeLineItem';
  amountInCents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MeteredBillMeteredLineItem = {
  __typename: 'MeteredBillMeteredLineItem';
  amountInCents: Scalars['Int']['output'];
  meterKind: MeterKind;
};

export type MeteredBillingSummary = {
  __typename: 'MeteredBillingSummary';
  /**
   * Aggregated meter usage that has already been exported to our third-party billing provider (e.g. Stripe).
   * Currently only supports monthly granularity.
   */
  exportedMeterValues: Array<MeterSummaries>;
  upcomingBill: UpcomingMeteredBill;
};


export type MeteredBillingSummaryexportedMeterValuesArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start: Scalars['Date']['input'];
};

export type MoveOperationCollectionEntryResult = InvalidTarget | MoveOperationCollectionEntrySuccess | PermissionError;

export type MoveOperationCollectionEntrySuccess = {
  __typename: 'MoveOperationCollectionEntrySuccess';
  operation: OperationCollectionEntry;
  originCollection: OperationCollection;
  targetCollection: OperationCollection;
};

/** Input type to provide when running schema checks against multiple subgraph changes asynchronously for a federated supergraph. */
export type MultiSubgraphCheckAsyncInput = {
  /** Configuration options for the check execution. */
  config: HistoricQueryParametersInput;
  /** The GitHub context to associate with the check. */
  gitContext: GitContextInput;
  /** The graph ref of the Studio graph and variant to run checks against (such as `my-graph@current`). */
  graphRef?: InputMaybe<Scalars['ID']['input']>;
  /** The URL of the GraphQL endpoint that Apollo Sandbox introspected to obtain the proposed schema. Required if `isSandbox` is `true`. */
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** If `true`, the check was initiated automatically by a Proposal update. */
  isProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the check was initiated by Apollo Sandbox. */
  isSandbox: Scalars['Boolean']['input'];
  /** The source variant that this check should use the operations check configuration from */
  sourceVariant?: InputMaybe<Scalars['String']['input']>;
  /** The changed subgraph schemas to check. */
  subgraphsToCheck: Array<InputMaybe<SubgraphSdlCheckInput>>;
  /** The user that triggered this check. If null, defaults to authContext to determine user. */
  triggeredBy?: InputMaybe<ActorInput>;
};

/** GraphQL mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** @deprecated Use Mutation.organization instead. */
  account: Maybe<AccountMutation>;
  addOidcConfigurationToBaseConnection: Maybe<SsoConnection>;
  /**
   * Add a tag to a specific graph artifact.
   * - If the tag does not already exist, it will be created.
   * - If the tag already exists, it will be reassigned to the provided graph artifact.
   */
  assignGraphArtifactTag: AssignTagToGraphArtifactResult;
  billing: Maybe<BillingMutation>;
  /**
   * Allows the frontend to check if a SSO configuration key is valid.
   * This helps restrict access to the public SSO configuration page.
   */
  checkSsoConfigurationKey: Scalars['Boolean']['output'];
  /** Cloud mutations */
  cloud: CloudMutation;
  cloudTesting: CloudTestingMutation;
  /** Creates an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/) for a given variant, or creates a [sandbox collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/#sandbox-collections) without an associated variant. This field accepts up to 200 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  createOperationCollection: CreateOperationCollectionResult;
  /** Creates a new service catalog entry for a service connector schema template. */
  createServiceCatalogEntry: ServiceCatalogType;
  /** Delete a tag from a graph. The tag and its full history are removed. Tags managed by Apollo cannot be deleted, such as variant latest tags. */
  deleteGraphArtifactTag: DeleteGraphArtifactTagResult;
  /**
   * Soft-deletes every active version of a service, removing it from the
   * catalog entirely. Returns the number of versions deleted. Distinct
   * from `deleteServiceCatalogEntry`, which removes a single version by id.
   */
  deleteServiceCatalog: Scalars['Int']['output'];
  /** Soft-deletes a service catalog entry by ID. Returns true if the entry was deleted. */
  deleteServiceCatalogEntry: Scalars['Boolean']['output'];
  /**
   * Finalize a password reset with a token included in the E-mail link,
   * returns the corresponding login email when successful
   */
  finalizePasswordReset: Maybe<Scalars['String']['output']>;
  /**
   * Grants an org access to a restricted catalog entry. Idempotent — a
   * no-op if the org already has access. If `service_id` was previously
   * unrestricted, this is its first grant and it becomes restricted to
   * just the orgs with a grant from this point on.
   */
  grantServiceCatalogAccess: Scalars['Boolean']['output'];
  /** Provides access to mutation fields for modifying a Studio graph with the provided ID. */
  graph: Maybe<ServiceMutation>;
  /** Join an account with a token */
  joinAccount: Maybe<Account>;
  me: Maybe<IdentityMutation>;
  newAccount: Maybe<Account>;
  newService: Maybe<Service>;
  /** Access course feedback mutations */
  odysseyCourseFeedback: OdysseyCourseFeedbackMutations;
  operationCollection: Maybe<OperationCollectionMutation>;
  /** Provides access to mutation fields for modifying a an organization with the provided ID. */
  organization: Maybe<AccountMutation>;
  plan: Maybe<BillingPlanMutation>;
  /**
   * Provides access to mutation fields for modifying a GraphOS Schema Proposals with the provided ID. Learn more at https://www.apollographql.com/docs/graphos/delivery/schema-proposals
   * @deprecated Use GraphVariantMutation.proposal instead
   */
  proposal: ProposalMutationResult;
  /** @deprecated Use GraphVariantMutation.proposal instead */
  proposalByVariantRef: ProposalMutationResult;
  /** Publish an education event to the event system */
  publishEDUEvent: Scalars['Boolean']['output'];
  /** Push a lead to Marketo by program ID */
  pushMarketoLead: Scalars['Boolean']['output'];
  /**
   * Records that a principal used an Agent App. Creates the app if it is
   * not yet in the control plane. Repeating the same identity refreshes
   * display attributes and last-seen time.
   */
  recordAgentAppPrincipal: AgentAppPrincipal;
  /**
   * Registers an OAuth client as an interactive agent app in the control
   * plane. Repeating the same `oauthClientId` returns the existing app.
   * The organization is taken from the caller's credential.
   */
  registerAgentApp: ApplicationType;
  /** Report a running GraphQL server's schema. */
  reportSchema: Maybe<ReportSchemaResult>;
  /** Ask for a user's password to be reset by E-mail */
  resetPassword: Maybe<Scalars['Void']['output']>;
  resolveAllInternalCronExecutions: Maybe<Scalars['Void']['output']>;
  resolveInternalCronExecution: Maybe<CronExecution>;
  /**
   * Revokes an org's access to a restricted catalog entry. Returns
   * whether a grant was actually removed. Revoking every remaining grant
   * leaves the entry public again (no rows = public, per the spec).
   */
  revokeServiceCatalogAccess: Scalars['Boolean']['output'];
  service: Maybe<ServiceMutation>;
  setCurrentAccountId: Maybe<Scalars['ID']['output']>;
  /** Set the subscriptions for a given email */
  setSubscriptions: Maybe<EmailPreferences>;
  /** Set the studio settings for the current user */
  setUserSettings: Maybe<UserSettings>;
  signUp: Maybe<User>;
  ssoV2: SsoMutation;
  /** This is called by the form shown to users after they delete their user or organization account. */
  submitPostDeletionFeedback: Maybe<Scalars['Void']['output']>;
  /** Mutation for basic engagement tracking in studio */
  track: Maybe<Scalars['Void']['output']>;
  /** Apollo Kotlin usage tracking. */
  trackApolloKotlinUsage: Maybe<Scalars['Void']['output']>;
  /** Router usage tracking. Reserved to https://router.apollo.dev/telemetry (https://github.com/apollographql/orbiter). */
  trackRouterUsage: Maybe<Scalars['Void']['output']>;
  /** Rover session tracking. Reserved to https://rover.apollo.dev/telemetry (https://github.com/apollographql/orbiter). */
  trackRoverSession: Maybe<Scalars['Void']['output']>;
  /** Transfer Odyssey progress from one user to another */
  transferOdysseyProgress: Scalars['Boolean']['output'];
  /**
   * Soft-deletes the agent app registered for `oauthClientId` in the
   * caller's organization. Idempotent: returns `false` when no active row
   * matches.
   */
  unregisterAgentApp: Scalars['Boolean']['output'];
  /** Unsubscribe a given email from all emails */
  unsubscribeFromAll: Maybe<EmailPreferences>;
  /**
   * Updates an existing service catalog entry by ID. Each input field is
   * optional; fields left unset retain their current value.
   *
   * A new `schemaTemplate` also re-seeds the entry's `defaultFieldTags`
   * from the `@tag` directives in that SDL. This is how a catalog entry
   * changes its field tags without a new version: publish the same SDL with
   * different `@tag` directives, and the tags that were added or removed
   * follow. Services already created from this entry are unaffected — they
   * own their tags from creation (`UpstreamService.fieldTags`).
   */
  updateServiceCatalogEntry: ServiceCatalogType;
  updateSurvey: Survey;
  /**
   * Provides access to mutation fields for modifying an Apollo user with the
   * provided ID.
   */
  user: Maybe<UserMutation>;
};


/** GraphQL mutations */
export type MutationaccountArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationaddOidcConfigurationToBaseConnectionArgs = {
  config: OidcConfigurationInput;
  configurationKey: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationassignGraphArtifactTagArgs = {
  artifact: GraphArtifactInput;
  graphID: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationcheckSsoConfigurationKeyArgs = {
  key: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationcreateOperationCollectionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  isSandbox: Scalars['Boolean']['input'];
  isShared: Scalars['Boolean']['input'];
  minEditRole?: InputMaybe<UserPermission>;
  name: Scalars['String']['input'];
  variantRefs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** GraphQL mutations */
export type MutationcreateServiceCatalogEntryArgs = {
  input: CreateServiceCatalogInput;
};


/** GraphQL mutations */
export type MutationdeleteGraphArtifactTagArgs = {
  graphID: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationdeleteServiceCatalogArgs = {
  serviceId: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationdeleteServiceCatalogEntryArgs = {
  id: Scalars['UUID']['input'];
};


/** GraphQL mutations */
export type MutationfinalizePasswordResetArgs = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationgrantServiceCatalogAccessArgs = {
  orgId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationgraphArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationjoinAccountArgs = {
  accountId: Scalars['ID']['input'];
  joinToken: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationnewAccountArgs = {
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutations */
export type MutationnewServiceArgs = {
  accountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hiddenFromUninvitedNonAdminAccountMembers: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  isDev?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingArchitecture?: InputMaybe<OnboardingArchitecture>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutations */
export type MutationoperationCollectionArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationorganizationArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationplanArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationproposalArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationproposalByVariantRefArgs = {
  variantRef: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationpublishEDUEventArgs = {
  data: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationpushMarketoLeadArgs = {
  cookie?: InputMaybe<Scalars['String']['input']>;
  input: PushMarketoLeadInput;
  programId: Scalars['ID']['input'];
  programStatus?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutations */
export type MutationrecordAgentAppPrincipalArgs = {
  input: RecordAgentAppPrincipalInput;
};


/** GraphQL mutations */
export type MutationregisterAgentAppArgs = {
  agentAppId?: InputMaybe<Scalars['UUID']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  oauthClientId: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationreportSchemaArgs = {
  coreSchema?: InputMaybe<Scalars['String']['input']>;
  report: SchemaReport;
};


/** GraphQL mutations */
export type MutationresetPasswordArgs = {
  email: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationresolveAllInternalCronExecutionsArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutations */
export type MutationresolveInternalCronExecutionArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationrevokeServiceCatalogAccessArgs = {
  orgId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationserviceArgs = {
  id: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationsetCurrentAccountIdArgs = {
  currentAccountId?: InputMaybe<Scalars['ID']['input']>;
};


/** GraphQL mutations */
export type MutationsetSubscriptionsArgs = {
  email: Scalars['String']['input'];
  subscriptions: Array<EmailCategory>;
  token: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationsetUserSettingsArgs = {
  newSettings?: InputMaybe<UserSettingsInput>;
};


/** GraphQL mutations */
export type MutationsignUpArgs = {
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  referrer?: InputMaybe<Scalars['String']['input']>;
  trackingGoogleClientId?: InputMaybe<Scalars['String']['input']>;
  trackingMarketoClientId?: InputMaybe<Scalars['String']['input']>;
  trackingValues?: InputMaybe<UserTrackingInput>;
  userSegment?: InputMaybe<UserSegment>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL mutations */
export type MutationsubmitPostDeletionFeedbackArgs = {
  feedback: Scalars['String']['input'];
  targetIdentifier: Scalars['ID']['input'];
  targetType: DeletionTargetType;
};


/** GraphQL mutations */
export type MutationtrackArgs = {
  event: EventEnum;
  graphID: Scalars['String']['input'];
  graphVariant: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationtrackApolloKotlinUsageArgs = {
  events: Array<ApolloKotlinUsageEventInput>;
  instanceId: Scalars['ID']['input'];
  properties: Array<ApolloKotlinUsagePropertyInput>;
};


/** GraphQL mutations */
export type MutationtrackRouterUsageArgs = {
  ci?: InputMaybe<Scalars['String']['input']>;
  os: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
  usage: Array<RouterUsageInput>;
  version: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationtrackRoverSessionArgs = {
  anonymousId: Scalars['ID']['input'];
  arguments: Array<RoverArgumentInput>;
  ci?: InputMaybe<Scalars['String']['input']>;
  command: Scalars['String']['input'];
  cwdHash: Scalars['SHA256']['input'];
  os: Scalars['String']['input'];
  remoteUrlHash?: InputMaybe<Scalars['SHA256']['input']>;
  sessionId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationtransferOdysseyProgressArgs = {
  from: Scalars['ID']['input'];
  to: Scalars['ID']['input'];
};


/** GraphQL mutations */
export type MutationunregisterAgentAppArgs = {
  oauthClientId: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationunsubscribeFromAllArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** GraphQL mutations */
export type MutationupdateServiceCatalogEntryArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateServiceCatalogInput;
};


/** GraphQL mutations */
export type MutationupdateSurveyArgs = {
  internalAccountId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
  surveyIdVersion: Scalars['Int']['input'];
  surveyState: Array<SurveyQuestionInput>;
};


/** GraphQL mutations */
export type MutationuserArgs = {
  id: Scalars['ID']['input'];
};

export type NamedIntrospectionArg = {
  __typename: 'NamedIntrospectionArg';
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type NamedIntrospectionArgNoDescription = {
  __typename: 'NamedIntrospectionArgNoDescription';
  name: Maybe<Scalars['String']['output']>;
};

/**
 * The shared fields for a named introspection type. Currently this is returned for the
 * top level value affected by a change. In the future, we may update this
 * type to be an interface, which is extended by the more specific types:
 * scalar, object, input object, union, interface, and enum
 *
 * For an in-depth look at where these types come from, see:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/659eb50d3/types/graphql/utilities/introspectionQuery.d.ts#L31-L37
 */
export type NamedIntrospectionType = {
  __typename: 'NamedIntrospectionType';
  description: Maybe<Scalars['String']['output']>;
  kind: Maybe<IntrospectionTypeKind>;
  name: Maybe<Scalars['String']['output']>;
};

export type NamedIntrospectionTypeNoDescription = {
  __typename: 'NamedIntrospectionTypeNoDescription';
  name: Maybe<Scalars['String']['output']>;
};

/**
 * Introspection values that can be children of other types for changes, such
 * as input fields, objects in interfaces, enum values. In the future, this
 * value could become an interface to allow fields specific to the types
 * returned.
 */
export type NamedIntrospectionValue = {
  __typename: 'NamedIntrospectionValue';
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  printedType: Maybe<Scalars['String']['output']>;
};

export type NamedIntrospectionValueNoDescription = {
  __typename: 'NamedIntrospectionValueNoDescription';
  name: Maybe<Scalars['String']['output']>;
  printedType: Maybe<Scalars['String']['output']>;
};

/** A non-federated service for a monolithic graph. */
export type NonFederatedImplementingService = {
  __typename: 'NonFederatedImplementingService';
  /** Timestamp of when this implementing service was created. */
  createdAt: Scalars['Timestamp']['output'];
  /**
   * Identifies which graph this non-implementing service belongs to.
   * Formerly known as "service_id".
   */
  graphID: Scalars['String']['output'];
  /**
   * Specifies which variant of a graph this implementing service belongs to".
   * Formerly known as "tag".
   */
  graphVariant: Scalars['String']['output'];
};

/** An error that occurs when a requested object is not found. */
export type NotFoundError = Error & {
  __typename: 'NotFoundError';
  /** The error message. */
  message: Scalars['String']['output'];
};

export enum NotificationStatus {
  ALL = 'ALL',
  NONE = 'NONE'
}

/** An OAuth client registered to an organization. Read-only: a client's secret is never returned here, only when the client is registered or its secret is rotated. Only `client_credentials` clients are readable today. We will revisit this restriction when we expand beyond `client_credentials`. */
export type OAuthClient = {
  __typename: 'OAuthClient';
  /** The client's `client_id`, presented at the token endpoint. */
  clientId: Scalars['ID']['output'];
  /** When this client was registered. */
  createdAt: Scalars['Timestamp']['output'];
  /** The actor that registered this client. */
  createdBy: Actor;
  /** The grant types this client may use. A client may hold more than one. */
  grantTypes: Array<OAuthGrantKind>;
  /** The client's name, for distinguishing it from other clients. */
  name: Maybe<Scalars['String']['output']>;
  /** The resources this client is restricted to. */
  resources: Array<OAuthClientResource>;
  /** The scopes that tokens issued to this client may carry. */
  scopes: Array<Scalars['String']['output']>;
};

/** An OAuth client that authenticates as itself using the `client_credentials` grant, together with the secret it was issued. */
export type OAuthClientCredentials = {
  __typename: 'OAuthClientCredentials';
  /** The client's `client_id`, presented at the token endpoint. */
  clientId: Scalars['String']['output'];
  /** The client's name, for distinguishing it from other clients. */
  clientName: Scalars['String']['output'];
  /** The client's `client_secret`. **This is a secret credential!** It is returned only when the client is registered and cannot be retrieved afterwards, only replaced. */
  clientSecret: Scalars['String']['output'];
  /** The resources this client is restricted to. */
  resources: Array<OAuthClientResource>;
  /** The scopes that tokens issued to this client will carry. */
  scopes: Array<Scalars['String']['output']>;
  /** When the client secret expires. */
  secretExpiresAt: Scalars['Timestamp']['output'];
};

/** A resource an OAuth client is restricted to. */
export type OAuthClientResource = {
  __typename: 'OAuthClientResource';
  /** The identifier of the resource the client is restricted to. */
  resourceId: Scalars['String']['output'];
  /** The type of resource the client is restricted to, such as `GRAPH`. */
  resourceType: Scalars['String']['output'];
};

/** Resources to restrict an OAuth client to. */
export type OAuthClientResourceInput = {
  /** One or more graphs to restrict the client to. */
  graphs: Array<GraphIdentifierInput>;
};

/** An OAuth 2.1 grant type a client may use. */
export enum OAuthGrantKind {
  /** The authorization code grant, in which a user authorizes the client through a browser redirect. */
  AUTHORIZATION_CODE = 'AUTHORIZATION_CODE',
  /** The client credentials grant, in which the client authenticates as itself with no user present. */
  CLIENT_CREDENTIALS = 'CLIENT_CREDENTIALS',
  /** The device authorization grant, for clients on devices that cannot open a browser. */
  DEVICE_CODE = 'DEVICE_CODE',
  /** The refresh token grant, which exchanges a refresh token for a new access token. */
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  /** A grant type this service does not name, including the extension grant types RFC 7591 permits. */
  UNKNOWN = 'UNKNOWN'
}

/**
 * The metadata returned once an OAuth provider's discovery document has been
 * fetched successfully. Nullable field, not nullable-scalars-with-a-discriminator:
 * a present result always came from one successfully fetched document, and a
 * null field within it means the document itself omitted that value.
 */
export type OauthDiscoveryResult = {
  __typename: 'OauthDiscoveryResult';
  /** The OAuth authorization endpoint published in the provider's discovery document. */
  authorizationEndpoint: Maybe<Scalars['String']['output']>;
  /**
   * The issuer identifier published in the provider's discovery document. May
   * differ from the issuer URL that was originally queried.
   */
  issuer: Maybe<Scalars['String']['output']>;
  /** The URI of the provider's JSON Web Key Set, used to verify token signatures. */
  jwksUri: Maybe<Scalars['String']['output']>;
  /**
   * The dynamic client registration endpoint published in the provider's
   * discovery document, if it supports dynamic registration.
   */
  registrationEndpoint: Maybe<Scalars['String']['output']>;
  /** The OAuth scopes the provider's discovery document advertises support for. */
  scopesSupported: Maybe<Array<Scalars['String']['output']>>;
  /** The OAuth token endpoint published in the provider's discovery document. */
  tokenEndpoint: Maybe<Scalars['String']['output']>;
};

/** Represents an attempt at an Odyssey test or assessment */
export type OdysseyAttempt = {
  __typename: 'OdysseyAttempt';
  /** When the attempt was completed, if applicable */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for the attempt */
  id: Scalars['ID']['output'];
  /** Whether the attempt resulted in a pass */
  pass: Maybe<Scalars['Boolean']['output']>;
  /** All responses submitted during this attempt */
  responses: Array<OdysseyResponse>;
  /** When the attempt was started */
  startedAt: Scalars['Timestamp']['output'];
  /** The test ID that was attempted */
  testId: Scalars['String']['output'];
};

/** Represents an earned Odyssey certification */
export type OdysseyCertification = {
  __typename: 'OdysseyCertification';
  /** The certification ID that was earned */
  certificationId: Scalars['String']['output'];
  /** When the certification was earned */
  earnedAt: Scalars['Timestamp']['output'];
  /** Icon URL or identifier for the certification */
  icon: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this certification record */
  id: Scalars['ID']['output'];
  /** The owner of this certification */
  owner: Maybe<OdysseyCertificationOwner>;
  /** Source system or method where the certification was earned */
  source: Maybe<Scalars['String']['output']>;
};

/** Owner information for an Odyssey certification */
export type OdysseyCertificationOwner = {
  __typename: 'OdysseyCertificationOwner';
  /** Full name of the certification owner */
  fullName: Scalars['String']['output'];
  /** Unique identifier for the certification owner */
  id: Scalars['ID']['output'];
};

/** Represents an Odyssey course enrollment and progress */
export type OdysseyCourse = {
  __typename: 'OdysseyCourse';
  /** When the course was completed, if applicable */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** When the user enrolled in the course */
  enrolledAt: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for the course */
  id: Scalars['ID']['output'];
  /** The language the course is taken in */
  language: Maybe<Scalars['String']['output']>;
};

/** Namespace for course feedback mutations */
export type OdysseyCourseFeedbackMutations = {
  __typename: 'OdysseyCourseFeedbackMutations';
  /** Assign a survey to one or more courses, replacing any existing assignment. Admin-only. */
  assignSurveyToCourses: AssignSurveyToCoursesPayload;
  /** Create a new feedback survey. Admin-only. */
  createSurvey: CreateFeedbackSurveyPayload;
  /** Submit feedback for a completed course */
  submitFeedback: SubmitFeedbackPayload;
  /** Replace the questions on an existing feedback survey, bumping its version. Admin-only. */
  updateSurvey: UpdateFeedbackSurveyPayload;
};


/** Namespace for course feedback mutations */
export type OdysseyCourseFeedbackMutationsassignSurveyToCoursesArgs = {
  input: AssignSurveyToCoursesInput;
};


/** Namespace for course feedback mutations */
export type OdysseyCourseFeedbackMutationscreateSurveyArgs = {
  input: CreateFeedbackSurveyInput;
};


/** Namespace for course feedback mutations */
export type OdysseyCourseFeedbackMutationssubmitFeedbackArgs = {
  input: CourseFeedbackInput;
};


/** Namespace for course feedback mutations */
export type OdysseyCourseFeedbackMutationsupdateSurveyArgs = {
  input: UpdateFeedbackSurveyInput;
};

/** Namespace for course feedback queries */
export type OdysseyCourseFeedbackQueries = {
  __typename: 'OdysseyCourseFeedbackQueries';
  /** Get all feedback submissions for a specific course. Internal Apollo staff only. */
  submissions: Array<CourseFeedback>;
  /** Get the feedback survey assigned to a course */
  survey: Maybe<FeedbackSurvey>;
  /** Get a feedback survey by ID. Internal Apollo staff only. */
  surveyById: Maybe<FeedbackSurvey>;
  /** Get all feedback surveys. Internal Apollo staff only. */
  surveys: Array<FeedbackSurvey>;
};


/** Namespace for course feedback queries */
export type OdysseyCourseFeedbackQueriessubmissionsArgs = {
  courseId: Scalars['ID']['input'];
};


/** Namespace for course feedback queries */
export type OdysseyCourseFeedbackQueriessurveyArgs = {
  courseId: Scalars['ID']['input'];
};


/** Namespace for course feedback queries */
export type OdysseyCourseFeedbackQueriessurveyByIdArgs = {
  id: Scalars['ID']['input'];
};

/** Input for creating or updating an Odyssey course enrollment */
export type OdysseyCourseInput = {
  /** When the course was completed */
  completedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The course identifier */
  courseId: Scalars['String']['input'];
  /** Whether this is a beta version of the course */
  isBeta?: InputMaybe<Scalars['Boolean']['input']>;
  /** The language the course is taken in */
  language?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a response to a question in an Odyssey attempt */
export type OdysseyResponse = {
  __typename: 'OdysseyResponse';
  /** Whether this response was correct */
  correct: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** The question ID this response is for */
  questionId: Scalars['String']['output'];
  /** The values provided as answers */
  values: Array<OdysseyValue>;
};

/** Input for updating the correctness of an Odyssey response */
export type OdysseyResponseCorrectnessInput = {
  /** Whether the response is correct */
  correct: Scalars['Boolean']['input'];
  /** The response ID to update */
  id: Scalars['ID']['input'];
};

/** Input for creating a response to an Odyssey question */
export type OdysseyResponseInput = {
  /** The attempt ID this response belongs to */
  attemptId: Scalars['ID']['input'];
  /** Whether the response is correct */
  correct?: InputMaybe<Scalars['Boolean']['input']>;
  /** The question ID being answered */
  questionId: Scalars['String']['input'];
  /** The values provided as answers */
  values: Array<Scalars['String']['input']>;
};

/** Represents a task within an Odyssey course */
export type OdysseyTask = {
  __typename: 'OdysseyTask';
  /** When the task was completed, if applicable */
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for the task */
  id: Scalars['ID']['output'];
  /** The value or answer provided for the task */
  value: Maybe<Scalars['String']['output']>;
};

/** Input for creating or updating an Odyssey task */
export type OdysseyTaskInput = {
  /** When the task was completed */
  completedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The task identifier */
  taskId: Scalars['String']['input'];
  /** The value or answer for the task */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single value in an Odyssey response */
export type OdysseyValue = {
  __typename: 'OdysseyValue';
  /** Unique identifier for the value */
  id: Scalars['ID']['output'];
  /** The actual value content */
  value: Scalars['String']['output'];
};

export type OidcConfigurationInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  discoveryURI?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
};

export type OidcConfigurationUpdateInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  discoveryURI?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
};

export type OidcConnection = SsoConnection & {
  __typename: 'OidcConnection';
  clientId: Scalars['ID']['output'];
  discoveryUri: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpId: Scalars['ID']['output'];
  issuer: Scalars['String']['output'];
  scim: Maybe<SsoScimProvisioningDetails>;
  /** @deprecated Use stateV2 instead */
  state: SsoConnectionState;
  stateV2: SsoConnectionStateV2;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum OnboardingArchitecture {
  MONOLITH = 'MONOLITH',
  SUPERGRAPH = 'SUPERGRAPH'
}

export type OnboardingPlanOption = {
  __typename: 'OnboardingPlanOption';
  billingCycleAnchor: BillingCycleAnchor;
  canTransitionTo: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  excludedFeatures: Array<Scalars['String']['output']>;
  includedFeatures: Array<Scalars['String']['output']>;
  /** Reasons why this plan option is not available for this organization */
  ineligibleReasons: Array<PlanIneligibilityReason>;
  isSelfService: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  planReadableId: Maybe<Scalars['ID']['output']>;
  pricePerUnitDescription: Scalars['String']['output'];
  priceSimpleDescription: Scalars['String']['output'];
  promoCreditsInCents: Maybe<Scalars['Int']['output']>;
  totalDueOnSignupInCents: Maybe<Scalars['Int']['output']>;
};

export type Operation = {
  __typename: 'Operation';
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  signature: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
};

export type OperationAcceptedChange = {
  __typename: 'OperationAcceptedChange';
  acceptedAt: Scalars['Timestamp']['output'];
  acceptedBy: Maybe<Identity>;
  change: StoredApprovedChange;
  checkID: Scalars['ID']['output'];
  graphID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  operationID: Scalars['String']['output'];
};

/** Columns of OperationCheckStats. */
export enum OperationCheckStatsColumn {
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type OperationCheckStatsDimensions = {
  __typename: 'OperationCheckStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in OperationCheckStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type OperationCheckStatsFilter = {
  and?: InputMaybe<Array<OperationCheckStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<OperationCheckStatsFilterIn>;
  not?: InputMaybe<OperationCheckStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<OperationCheckStatsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in OperationCheckStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type OperationCheckStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type OperationCheckStatsMetrics = {
  __typename: 'OperationCheckStatsMetrics';
  cachedRequestsCount: Scalars['Long']['output'];
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type OperationCheckStatsOrderBySpec = {
  column: OperationCheckStatsColumn;
  direction: Ordering;
};

export type OperationCheckStatsRecord = {
  __typename: 'OperationCheckStatsRecord';
  /** Dimensions of OperationCheckStats that can be grouped by. */
  groupBy: OperationCheckStatsDimensions;
  /** Metrics of OperationCheckStats that can be aggregated over. */
  metrics: OperationCheckStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A list of saved GraphQL operations. */
export type OperationCollection = {
  __typename: 'OperationCollection';
  /** The timestamp when the collection was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The user or other entity that created the collection. */
  createdBy: Maybe<Identity>;
  /** The collection's description. A `null` description was never set, and empty string description was set to be empty string by a user, or other entity. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * If a user has any of these roles, they will be able to edit this
   * collection.
   * @deprecated deprecated in favour of minEditRole
   */
  editRoles: Maybe<Array<UserPermission>>;
  id: Scalars['ID']['output'];
  /** Whether the current user has marked the collection as a favorite. */
  isFavorite: Scalars['Boolean']['output'];
  /** Whether the collection is a [sandbox collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/#sandbox-collections). */
  isSandbox: Scalars['Boolean']['output'];
  /** Whether the collection is shared across its associated organization. */
  isShared: Scalars['Boolean']['output'];
  /** The timestamp when the collection was most recently updated. */
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** The user or other entity that most recently updated the collection. */
  lastUpdatedBy: Maybe<Identity>;
  /** The minimum role a user needs to edit this collection. Valid values: null, CONSUMER, OBSERVER, DOCUMENTER, CONTRIBUTOR, GRAPH_ADMIN. This value is always `null` if `isShared` is `false`. If `null` when `isShared` is `true`, the minimum role is `GRAPH_ADMIN`. */
  minEditRole: Maybe<UserPermission>;
  /** The collection's name. */
  name: Scalars['String']['output'];
  /** Returns the operation in the collection with the specified ID, if any. */
  operation: Maybe<OperationCollectionEntryResult>;
  /** A list of the GraphQL operations that belong to the collection. */
  operations: Array<OperationCollectionEntry>;
  /** The permissions that the current user has for the collection. */
  permissions: OperationCollectionPermissions;
  variants: Array<GraphVariant>;
};


/** A list of saved GraphQL operations. */
export type OperationCollectionoperationArgs = {
  id: Scalars['ID']['input'];
};

/** A saved operation entry within an Operation Collection. */
export type OperationCollectionEntry = {
  __typename: 'OperationCollectionEntry';
  collection: OperationCollection;
  /** The timestamp when the entry was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The user or other entity that created the entry. */
  createdBy: Maybe<Identity>;
  /** Details of the entry's associated operation, such as its `body` and `variables`. */
  currentOperationRevision: OperationCollectionEntryState;
  id: Scalars['ID']['output'];
  /** The timestamp when the entry was most recently updated. */
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** The user or other entity that most recently updated the entry. */
  lastUpdatedBy: Maybe<Identity>;
  /** The entry's name. */
  name: Scalars['String']['output'];
  /** The entry's lexicographical ordering index within its containing collection. */
  orderingIndex: Scalars['String']['output'];
};

/** Provides fields for modifying an operation in a collection. */
export type OperationCollectionEntryMutation = {
  __typename: 'OperationCollectionEntryMutation';
  moveToCollection: MoveOperationCollectionEntryResult;
  reorderEntry: Maybe<UpdateOperationCollectionResult>;
  /** Updates the name of an operation. */
  updateName: Maybe<UpdateOperationCollectionEntryResult>;
  /** Updates the body, headers, and/or variables of an operation. */
  updateValues: Maybe<UpdateOperationCollectionEntryResult>;
};


/** Provides fields for modifying an operation in a collection. */
export type OperationCollectionEntryMutationmoveToCollectionArgs = {
  collectionId: Scalars['ID']['input'];
  lowerOrderingBound?: InputMaybe<Scalars['String']['input']>;
  upperOrderingBound?: InputMaybe<Scalars['String']['input']>;
};


/** Provides fields for modifying an operation in a collection. */
export type OperationCollectionEntryMutationreorderEntryArgs = {
  lowerOrderingBound?: InputMaybe<Scalars['String']['input']>;
  upperOrderingBound?: InputMaybe<Scalars['String']['input']>;
};


/** Provides fields for modifying an operation in a collection. */
export type OperationCollectionEntryMutationupdateNameArgs = {
  name: Scalars['String']['input'];
};


/** Provides fields for modifying an operation in a collection. */
export type OperationCollectionEntryMutationupdateValuesArgs = {
  operationInput: OperationCollectionEntryStateInput;
};

export type OperationCollectionEntryMutationResult = NotFoundError | OperationCollectionEntryMutation | PermissionError;

/** Possible return values when querying for an entry in an operation collection (either the entry object or an `Error` object). */
export type OperationCollectionEntryResult = NotFoundError | OperationCollectionEntry;

/** The most recent body, variable and header values of a saved operation entry. */
export type OperationCollectionEntryState = {
  __typename: 'OperationCollectionEntryState';
  /** The raw body of the entry's GraphQL operation. */
  body: Scalars['String']['output'];
  /** The timestamp when the entry state was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The user or other entity that created this entry state. */
  createdBy: Maybe<Identity>;
  /** Headers for the entry's GraphQL operation. */
  headers: Maybe<Array<OperationHeader>>;
  /** The post operation workflow automation script for this entry's GraphQL operation */
  postflightOperationScript: Maybe<Scalars['String']['output']>;
  /** The pre operation workflow automation script for this entry's GraphQL operation */
  script: Maybe<Scalars['String']['output']>;
  /** Variables for the entry's GraphQL operation, as a JSON string. */
  variables: Maybe<Scalars['String']['output']>;
};

/** Fields for creating or modifying an operation collection entry. */
export type OperationCollectionEntryStateInput = {
  /** The operation's query body. */
  body: Scalars['String']['input'];
  /** The operation's headers. */
  headers?: InputMaybe<Array<OperationHeaderInput>>;
  /** The operation's postflight workflow script */
  postflightOperationScript?: InputMaybe<Scalars['String']['input']>;
  /** The operation's preflight workflow script */
  script?: InputMaybe<Scalars['String']['input']>;
  /** The operation's variables. */
  variables?: InputMaybe<Scalars['String']['input']>;
};

/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutation = {
  __typename: 'OperationCollectionMutation';
  /** Adds an operation to this collection. */
  addOperation: Maybe<AddOperationCollectionEntryResult>;
  /** Adds operations to this collection. */
  addOperations: Maybe<AddOperationCollectionEntriesResult>;
  /** @deprecated Will throw NotImplemented */
  addToVariant: AddOperationCollectionToVariantResult;
  /** Deletes this operation collection. This also deletes all of the collection's associated operations. */
  delete: Maybe<DeleteOperationCollectionResult>;
  /** Deletes an operation from this collection. */
  deleteOperation: Maybe<RemoveOperationCollectionEntryResult>;
  duplicateCollection: DuplicateOperationCollectionResult;
  operation: Maybe<OperationCollectionEntryMutationResult>;
  /** @deprecated Will throw NotImplemented */
  removeFromVariant: RemoveOperationCollectionFromVariantResult;
  /** Updates the minimum role a user needs to be able to modify this collection. */
  setMinEditRole: Maybe<UpdateOperationCollectionResult>;
  /** Updates this collection's description. */
  updateDescription: Maybe<UpdateOperationCollectionResult>;
  /** Updates whether the current user has marked this collection as a favorite. */
  updateIsFavorite: Maybe<UpdateOperationCollectionResult>;
  /** Updates whether this collection is shared across its associated organization. */
  updateIsShared: Maybe<UpdateOperationCollectionResult>;
  /** Updates this operation collection's name. */
  updateName: Maybe<UpdateOperationCollectionResult>;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationaddOperationArgs = {
  name: Scalars['String']['input'];
  operationInput: OperationCollectionEntryStateInput;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationaddOperationsArgs = {
  operations: Array<AddOperationInput>;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationaddToVariantArgs = {
  variantRef: Scalars['ID']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationdeleteOperationArgs = {
  id: Scalars['ID']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationduplicateCollectionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  isSandbox: Scalars['Boolean']['input'];
  isShared: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  variantRef?: InputMaybe<Scalars['ID']['input']>;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationoperationArgs = {
  id: Scalars['ID']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationremoveFromVariantArgs = {
  variantRef: Scalars['ID']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationsetMinEditRoleArgs = {
  editRole?: InputMaybe<UserPermission>;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationupdateDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationupdateIsFavoriteArgs = {
  isFavorite: Scalars['Boolean']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationupdateIsSharedArgs = {
  isShared: Scalars['Boolean']['input'];
};


/** Provides fields for modifying an [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/). This fields on this type accepts up to 200 requests per minute combined. This rate may be temporarily adjusted based on system conditions. */
export type OperationCollectionMutationupdateNameArgs = {
  name: Scalars['String']['input'];
};

/** Whether the current user can perform various actions on the associated collection. */
export type OperationCollectionPermissions = {
  __typename: 'OperationCollectionPermissions';
  /** Whether the current user can edit operations in the associated collection. */
  canEditOperations: Scalars['Boolean']['output'];
  /** Whether the current user can delete or update the associated collection's metadata, such as its name and description. */
  canManage: Scalars['Boolean']['output'];
  /** Whether the current user can read operations in the associated collection. */
  canReadOperations: Scalars['Boolean']['output'];
};

export type OperationCollectionResult = NotFoundError | OperationCollection | PermissionError | ValidationError;

export type OperationDetails = {
  __typename: 'OperationDetails';
  /** A hashed representation of the signature, commonly used as the operation ID. */
  id: Scalars['String']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** First 128 characters of query signature for display. */
  signature: Maybe<Scalars['String']['output']>;
};

export type OperationDocument = {
  __typename: 'OperationDocument';
  /** Operation document body */
  body: Scalars['String']['output'];
  /** Operation name */
  name: Maybe<Scalars['String']['output']>;
};

export type OperationDocumentInput = {
  /** Operation document body */
  body: Scalars['String']['input'];
  /** Operation name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Columns of OperationFetchStats. */
export enum OperationFetchStatsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CONNECTOR_SOURCE = 'CONNECTOR_SOURCE',
  FETCHES_WITH_ERRORS_COUNT = 'FETCHES_WITH_ERRORS_COUNT',
  FETCH_COUNT = 'FETCH_COUNT',
  FETCH_LATENCY_HISTOGRAM = 'FETCH_LATENCY_HISTOGRAM',
  FETCH_SERVICE_ID = 'FETCH_SERVICE_ID',
  FETCH_SERVICE_NAME = 'FETCH_SERVICE_NAME',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP'
}

export type OperationFetchStatsDimensions = {
  __typename: 'OperationFetchStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  connectorSource: Maybe<Scalars['String']['output']>;
  fetchServiceId: Maybe<Scalars['ID']['output']>;
  fetchServiceName: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in OperationFetchStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type OperationFetchStatsFilter = {
  and?: InputMaybe<Array<OperationFetchStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose connectorSource dimension equals the given value if not null. To query for the null value, use {in: {connectorSource: [null]}} instead. */
  connectorSource?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fetchServiceId dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceId: [null]}} instead. */
  fetchServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose fetchServiceName dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceName: [null]}} instead. */
  fetchServiceName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<OperationFetchStatsFilterIn>;
  not?: InputMaybe<OperationFetchStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<OperationFetchStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in OperationFetchStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type OperationFetchStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose connectorSource dimension is in the given list. A null value in the list means a row with null for that dimension. */
  connectorSource?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fetchServiceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose fetchServiceName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type OperationFetchStatsMetrics = {
  __typename: 'OperationFetchStatsMetrics';
  fetchCount: Scalars['Long']['output'];
  fetchLatencyHistogram: DurationHistogram;
  fetchesWithErrorsCount: Scalars['Long']['output'];
};

export type OperationFetchStatsOrderBySpec = {
  column: OperationFetchStatsColumn;
  direction: Ordering;
};

export type OperationFetchStatsRecord = {
  __typename: 'OperationFetchStatsRecord';
  /** Dimensions of OperationFetchStats that can be grouped by. */
  groupBy: OperationFetchStatsDimensions;
  /** Metrics of OperationFetchStats that can be aggregated over. */
  metrics: OperationFetchStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Saved headers on a saved operation. */
export type OperationHeader = {
  __typename: 'OperationHeader';
  /** The header's name. */
  name: Scalars['String']['output'];
  /** The header's value. */
  value: Scalars['String']['output'];
};

export type OperationHeaderInput = {
  /** The header's name. */
  name: Scalars['String']['input'];
  /** The header's value. */
  value: Scalars['String']['input'];
};

/** The error returned when another operation updating this tag is running. */
export type OperationInProgressError = Error & {
  __typename: 'OperationInProgressError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type OperationInfoFilter = {
  __typename: 'OperationInfoFilter';
  id: Scalars['String']['output'];
};

export type OperationInfoFilterInput = {
  id: Scalars['String']['input'];
};

export type OperationInsightsListFilterInInput = {
  /** Filters results to operations whose requests were reported with any of the given client names. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to operations whose requests were reported with any of the given client versions. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OperationInsightsListFilterInput = {
  /** Filters results to operations whose requests were reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to operations whose requests were reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<OperationInsightsListFilterInInput>;
  /** If set, restricts results to operations whose un-named status matches this value. */
  isUnnamed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, restricts results to operations whose registered status matches this value. */
  isUnregistered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restricts results to operations of the given GraphQL types (e.g. QUERY, MUTATION, SUBSCRIPTION). */
  operationTypes?: InputMaybe<Array<OperationType>>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<OperationInsightsListFilterInput>>;
  /** Filters on partial string matches against the operation name or signature. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OperationInsightsListItem = {
  __typename: 'OperationInsightsListItem';
  /** The fraction (0.0 to 1.0) of requests for this operation that were served from a cache. */
  cacheHitRate: Scalars['Float']['output'];
  /** The p50 of the latency across cached requests. This can be null depending on the filter and sort order. */
  cacheTtlP50Ms: Maybe<Scalars['Float']['output']>;
  /** A substring of the query signature for unnamed operations, otherwise the operation name. */
  displayName: Scalars['String']['output'];
  /** The number of requests for this operation that resulted in errors. */
  errorCount: Scalars['Long']['output'];
  /** The rate per minute of requests for this operation that resulted in errors. */
  errorCountPerMin: Scalars['Float']['output'];
  /** The percentage of requests for this operation that resulted in errors. */
  errorPercentage: Scalars['Float']['output'];
  /** The unique id for this operation. */
  id: Scalars['ID']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The total number of requests for this operation in the selected time range. */
  requestCount: Scalars['Long']['output'];
  /** The rate of requests per minute for this operation in the selected time range. */
  requestCountPerMin: Scalars['Float']['output'];
  /** The p50 of the latency across all requests. This can be null depending on the filter and sort order. */
  serviceTimeP50Ms: Maybe<Scalars['Float']['output']>;
  /** The p90 of the latency across all requests. This can be null depending on the filter and sort order. */
  serviceTimeP90Ms: Maybe<Scalars['Float']['output']>;
  /** The p95 of the latency across all requests. This can be null depending on the filter and sort order. */
  serviceTimeP95Ms: Maybe<Scalars['Float']['output']>;
  /** The p99 of the latency across all requests. This can be null depending on the filter and sort order. */
  serviceTimeP99Ms: Maybe<Scalars['Float']['output']>;
  /** The query signature size as a number of UTF8 bytes. This can be null if the sort order is not SIGNATURE_BYTES. */
  signatureBytes: Maybe<Scalars['Long']['output']>;
  /** The total duration across all requests. This can be null depending on the filter and sort order. */
  totalDurationMs: Maybe<Scalars['Float']['output']>;
  /** The GraphQL operation type, or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export enum OperationInsightsListOrderByColumn {
  CACHE_HIT_RATE = 'CACHE_HIT_RATE',
  CACHE_TTL_P50 = 'CACHE_TTL_P50',
  ERROR_COUNT = 'ERROR_COUNT',
  ERROR_COUNT_PER_MIN = 'ERROR_COUNT_PER_MIN',
  ERROR_PERCENTAGE = 'ERROR_PERCENTAGE',
  OPERATION_NAME = 'OPERATION_NAME',
  REQUEST_COUNT = 'REQUEST_COUNT',
  REQUEST_COUNT_PER_MIN = 'REQUEST_COUNT_PER_MIN',
  SERVICE_TIME_P50 = 'SERVICE_TIME_P50',
  SERVICE_TIME_P90 = 'SERVICE_TIME_P90',
  SERVICE_TIME_P95 = 'SERVICE_TIME_P95',
  SERVICE_TIME_P99 = 'SERVICE_TIME_P99',
  SIGNATURE_BYTES = 'SIGNATURE_BYTES',
  TOTAL_DURATION_MS = 'TOTAL_DURATION_MS'
}

export type OperationInsightsListOrderByInput = {
  /** The order column used for the operation results. Defaults to ordering by operation names. */
  column: OperationInsightsListOrderByColumn;
  /** The direction used to order operation results. Defaults to ascending order. */
  direction: Ordering;
};

/** Information about pagination in a connection. */
export type OperationInsightsListPageInfo = {
  __typename: 'OperationInsightsListPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** The named type and version of the clients to include or exclude in the operation timeseries report. */
export type OperationInsightsTimeseriesReportClientFilterInInput = {
  /** The client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** The client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum OperationInsightsTimeseriesReportDimension {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  GRAPH_VARIANT = 'GRAPH_VARIANT',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PERSISTED_QUERY_ID = 'PERSISTED_QUERY_ID'
}

/** The type and value for an operation insights timeseries report dimension. */
export type OperationInsightsTimeseriesReportDimensionValue = {
  __typename: 'OperationInsightsTimeseriesReportDimensionValue';
  /** The type of dimension this represents. */
  type: OperationInsightsTimeseriesReportDimension;
  /** The string value of this dimension. Null for operations without this dimension (e.g., unnamed operations). */
  value: Maybe<Scalars['String']['output']>;
};

/** Lists of dimensions to include or exclude in the operations timeseries report. Each list can have a maximum of 1000 entries. */
export type OperationInsightsTimeseriesReportFilterInInput = {
  /** Include or exclude certain clients */
  clients?: InputMaybe<Array<InputMaybe<OperationInsightsTimeseriesReportClientFilterInInput>>>;
  /** Matches any operations with IDs in this list. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any operations with names in this list. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any operations requested by any persisted query ID in this list. The persisted query ID is only available when using router v2.2.0 and onwards. */
  persistedQueryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any operations requested from any variant in this list. */
  variantName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The filters available when using the operation timeseries report. */
export type OperationInsightsTimeseriesReportFilterInput = {
  /** Exclude operations that match a specified set of dimensions. If the same dimension exists in both 'include' and 'exclude', a REQUEST_INVALID error will be returned. */
  exclude?: InputMaybe<OperationInsightsTimeseriesReportFilterInInput>;
  /** Include operations that match a specified set of dimensions. */
  include?: InputMaybe<OperationInsightsTimeseriesReportFilterInInput>;
  /** Set to true to only return named operations, false to return only unnamed operations, or null for both. */
  named?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include only certain types of operations (query, mutation, subscription). Operation types may not be recorded correctly for users not on Apollo router. */
  operationTypes?: InputMaybe<Array<OperationType>>;
  /** Set to true to only return operations that were requested by a PQ ID, false to return only operations that were requested by operation body, or null for both. The persisted query ID is only available when using router v2.2.0 and onwards. */
  requestedByPersistedQuery?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OperationInsightsTimeseriesReportMetric {
  REQUEST_COUNT = 'REQUEST_COUNT',
  REQUEST_LATENCY_P50_MS = 'REQUEST_LATENCY_P50_MS',
  REQUEST_LATENCY_P90_MS = 'REQUEST_LATENCY_P90_MS',
  REQUEST_LATENCY_P99_MS = 'REQUEST_LATENCY_P99_MS',
  REQUEST_WITH_ERROR_COUNT = 'REQUEST_WITH_ERROR_COUNT'
}

/** The type and value for an operation insights timeseries report metric. */
export type OperationInsightsTimeseriesReportMetricValue = {
  __typename: 'OperationInsightsTimeseriesReportMetricValue';
  /** The type of metric this represents. */
  type: OperationInsightsTimeseriesReportMetric;
  /** The floating point value of this metric. */
  value: Scalars['Float']['output'];
};

/** The metric and direction to use as the secondary sort order for the operation timeseries report. The primary sort order will always be time. */
export type OperationInsightsTimeseriesReportOrderByInput = {
  /** The ordering used for the metrics results. This metric must be included in the requested metrics. */
  column: OperationInsightsTimeseriesReportMetric;
  /** The direction used to order the results. */
  direction: Ordering;
};

/** The data that is returned by the operation insights timeseries report. */
export type OperationInsightsTimeseriesReportResult = {
  __typename: 'OperationInsightsTimeseriesReportResult';
  /** A CSV representation of the results. This includes a header and rows that have a column for start and end timestamp and all requested dimensions and metrics. */
  csv: Maybe<Scalars['String']['output']>;
  /** The result records, with each row having a start and end timestamp and a set of dimensions and metrics. */
  records: Array<OperationInsightsTimeseriesReportRow>;
};

/** A single row of data that is returned by the operation insights timeseries report. */
export type OperationInsightsTimeseriesReportRow = {
  __typename: 'OperationInsightsTimeseriesReportRow';
  /** The dimension values for this row, matching the requested dimensions. */
  dimensions: Array<OperationInsightsTimeseriesReportDimensionValue>;
  /** The exclusive end of the time bucket for this row. */
  endExclusiveTimestamp: Scalars['Timestamp']['output'];
  /** The metric values for this row, matching the requested metrics. */
  metrics: Array<OperationInsightsTimeseriesReportMetricValue>;
  /** The start of the time bucket for this row. */
  startTimestamp: Scalars['Timestamp']['output'];
};

/** Operation name filter configuration for a graph. */
export type OperationNameFilter = {
  __typename: 'OperationNameFilter';
  /** name of the operation by the user and reported alongside metrics */
  name: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

/** Options to filter by operation name. */
export type OperationNameFilterInput = {
  /** name of the operation set by the user and reported alongside metrics */
  name: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum OperationType {
  MUTATION = 'MUTATION',
  QUERY = 'QUERY',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export type OperationValidationError = {
  __typename: 'OperationValidationError';
  message: Scalars['String']['output'];
};

export type OperationsCheckConfiguration = {
  __typename: 'OperationsCheckConfiguration';
  /**
   * During operation checks, if this option is enabled, the check will not fail or
   *  mark any operations as broken/changed if the default value has changed, only
   *  if the default value is removed completely.
   */
  downgradeDefaultValueChange: Scalars['Boolean']['output'];
  /**
   * During operation checks, if this option is enabled, it evaluates a check
   * run against zero operations as a pass instead of a failure.
   */
  downgradeStaticChecks: Scalars['Boolean']['output'];
  /** During the operations check, ignore clients matching any of the <excludedClients> filters. */
  excludedClients: Array<ClientFilter>;
  /** During the operations check, ignore operations matching any of the <excludedOperationNames> filters. */
  excludedOperationNames: Array<OperationNameFilter>;
  /** During the operations check, ignore operations matching any of the <excludedOperations> filters. */
  excludedOperations: Array<OperationInfoFilter>;
  /**
   * The start of the time range for the operations check, expressed as an offset from the time the
   * check request was received (in seconds) or an ISO-8601 timestamp. This was either provided by the
   * user or computed from variant- or graph-level settings.
   * @deprecated Use fromNormalized instead
   */
  from: Scalars['String']['output'];
  /** The start of the time range for the operations check. */
  fromNormalized: Scalars['Timestamp']['output'];
  /**
   * During the operations check, fetch operations from the metrics data for <includedVariants>
   * variants.
   */
  includedVariants: Array<Scalars['String']['output']>;
  /**
   * During the operations check, ignore operations that executed less than <operationCountThreshold>
   * times in the time range.
   */
  operationCountThreshold: Scalars['Int']['output'];
  /**
   * Duration the operations check, ignore operations that constituted less than
   * <operationCountThresholdPercentage>% of the operations in the time range.
   */
  operationCountThresholdPercentage: Scalars['Float']['output'];
  /**
   * The end of the time range for the operations check, expressed as an offset from the time the
   * check request was received (in seconds) or an ISO-8601 timestamp. This was either provided by the
   * user or computed from variant- or graph-level settings.
   * @deprecated Use toNormalized instead
   */
  to: Scalars['String']['output'];
  /** The end of the time range for the operations check. */
  toNormalized: Scalars['Timestamp']['output'];
};

export type OperationsCheckConfigurationOverridesInput = {
  /**
   * During the operations check, ignore clients matching any of the <excludedClients> filters.
   * Providing null will use variant- or graph-level settings instead.
   */
  excludedClients?: InputMaybe<Array<ClientFilterInput>>;
  /**
   * During the operations check, ignore operations matching any of the <excludedOperationNames>
   * filters. Providing null will use variant- or graph-level settings instead.
   */
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput>>;
  /**
   * During the operations check, ignore operations matching any of the <excludedOperations> filters.
   * Providing null will use variant- or graph-level settings instead.
   */
  excludedOperations?: InputMaybe<Array<OperationInfoFilterInput>>;
  /**
   * The start of the time range for the operations check, expressed as an offset from the time the
   * check request is received (in seconds) or an ISO-8601 timestamp. Providing null here and
   * useMaxRetention as false will use variant- or graph-level settings instead. It is an error to
   * provide a non-null value here and useMaxRetention as true.
   */
  from?: InputMaybe<Scalars['String']['input']>;
  /**
   * During the operations check, fetch operations from the metrics data for <includedVariants>
   * variants. Providing null will use variant- or graph-level settings instead.
   */
  includedVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * During the operations check, ignore operations that executed less than <operationCountThreshold>
   * times in the time range. Providing null will use variant- or graph-level settings instead.
   */
  operationCountThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * During the operations check, ignore operations that executed less than <operationCountThreshold>
   * times in the time range. Expected values are between 0% and 5%. Providing null will use variant-
   * or graph-level settings instead.
   */
  operationCountThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The end of the time range for the operations check, expressed as an offset from the time the
   * check request is received (in seconds) or an ISO-8601 timestamp. Providing null here and
   * useMaxRetention as false will use variant- or graph-level settings instead. It is an error to
   * provide a non-null value here and useMaxRetention as true.
   */
  to?: InputMaybe<Scalars['String']['input']>;
  /**
   * During the operations check, use the maximum time range allowed by the graph's plan's retention.
   * Providing false here and from/to as null will use variant- or graph-level settings instead. It is
   * an error to provide true here and from/to as non-null.
   */
  useMaxRetention: Scalars['Boolean']['input'];
};

export type OperationsCheckResult = {
  __typename: 'OperationsCheckResult';
  /** Operations affected by all changes in diff */
  affectedQueries: Maybe<Array<AffectedQuery>>;
  /** Returns an affected operation and its changes for this check */
  affectedQuery: Maybe<AffectedQuery>;
  /** Indicates whether the changes for this operation check were truncated due to their large quantity. */
  areChangesTruncated: Scalars['Boolean']['output'];
  /** Summary/counts for all changes in diff */
  changeSummary: ChangeSummary;
  /** List of schema changes with associated affected clients and operations */
  changes: Array<Change>;
  /** Indication of the success of the change, either failure, warning, or notice. */
  checkSeverity: ChangeSeverity;
  /** The variant that was used as a base to check against */
  checkedVariant: GraphVariant;
  createdAt: Scalars['Timestamp']['output'];
  /** The threshold that was crossed; null if the threshold was not exceeded */
  crossedOperationThreshold: Maybe<Scalars['Int']['output']>;
  /** Whether enhanced operation checks were active for this check. Null for old checks or checks that never queried druid. */
  enhancedModeEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Usage stats behind enhanced mode; null when enhancedModeEnabled is null. */
  enhancedModeStats: Maybe<EnhancedModeStats>;
  /** Graph ID of the variant */
  graphID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Number of affected operations that are neither marked as SAFE or IGNORED. */
  numberOfAffectedOperations: Scalars['Int']['output'];
  /** Number of operations that were validated during schema diff */
  numberOfCheckedOperations: Scalars['Int']['output'];
  /** Total number of affected operations including ones marked SAFE or IGNORED. */
  totalNumberOfAffectedOperations: Scalars['Int']['output'];
  /** Total number of schema changes, excluding any truncation. */
  totalNumberOfChanges: Scalars['Int']['output'];
  /** Operations checked against but not affecting the diff. */
  unaffectedOperations: Maybe<Array<OperationDetails>>;
  workflowTask: OperationsCheckTask;
};


export type OperationsCheckResultaffectedQueriesArgs = {
  filter?: InputMaybe<AffectedQueriesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type OperationsCheckResultaffectedQueryArgs = {
  id: Scalars['ID']['input'];
};

export type OperationsCheckTask = CheckWorkflowTask & {
  __typename: 'OperationsCheckTask';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  graphID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /**
   * The result of the operations check. This will be null when the task is initializing or running,
   * or when the build task fails (which is a prerequisite task to this one).
   */
  result: Maybe<OperationsCheckResult>;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** Cloud Router order */
export type Order = {
  __typename: 'Order';
  /**
   * Completion percentage of the order (between 0 and 100)
   *
   * This will only return data for IN_PROGRESS, COMPLETED, or SUPERSEDED states
   */
  completionPercentage: Maybe<Scalars['Int']['output']>;
  /** When this Order was created */
  createdAt: Scalars['NaiveDateTime']['output'];
  /** Order identifier */
  id: Scalars['ID']['output'];
  /** Introspect why call to `ready` failed */
  introspectReady: Scalars['String']['output'];
  logs: Array<LogMessage>;
  /** Order type */
  orderType: OrderType;
  /** Checks if we can serve requests through the external endpoint */
  readyExternal: Scalars['Boolean']['output'];
  /** Reason for ERRORED or ROLLING_BACK orders */
  reason: Maybe<Scalars['String']['output']>;
  /** Router associated with this Order */
  router: Router;
  /** Checks if the service is updated */
  serviceReady: Scalars['Boolean']['output'];
  /** Shard associated with this Order */
  shard: Shard;
  /** Order status */
  status: OrderStatus;
  /** Last time this Order was updated */
  updatedAt: Maybe<Scalars['NaiveDateTime']['output']>;
};

/** The order does not exist */
export type OrderDoesNotExistError = {
  __typename: 'OrderDoesNotExistError';
  tryAgainSeconds: Scalars['Int']['output'];
};

/** Catch-all failure result of a failed order mutation. */
export type OrderError = {
  __typename: 'OrderError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type OrderMutation = {
  __typename: 'OrderMutation';
  /** Create an ALB rule */
  createAlbRule: OrderResult;
  /** Create CNAME record */
  createCname: OrderResult;
  /** Create an IAM Role */
  createIamRole: OrderResult;
  /** Create a security group */
  createSecurityGroup: OrderResult;
  /** Create an ECS service */
  createService: OrderResult;
  /** Create a target group */
  createTargetGroup: OrderResult;
  /** Create a task definition */
  createTaskDefinition: OrderResult;
  /** Delete an ALB rule */
  deleteAlbRule: OrderResult;
  /** Delete API key */
  deleteApiKey: OrderResult;
  /** Delete CNAME */
  deleteCname: OrderResult;
  /** Delete an IAM Role */
  deleteIamRole: OrderResult;
  /** Delete a security group */
  deleteSecurityGroup: OrderResult;
  /** Delete an ECS service */
  deleteService: OrderResult;
  /** Delete a target group */
  deleteTargetGroup: OrderResult;
  /** Delete a task definition */
  deleteTaskDefinition: OrderResult;
  /** Force rollback of the order */
  forceRollback: OrderResult;
  /** Rollback an ALB rule */
  rollbackAlbRule: OrderResult;
  /** Rollback CNAME record */
  rollbackCname: OrderResult;
  /** Rollback an IAM Role */
  rollbackIamRole: OrderResult;
  /** Rollback router information */
  rollbackInfo: OrderResult;
  /** Rollback router information */
  rollbackSecrets: OrderResult;
  /** Rollback a security group */
  rollbackSecurityGroup: OrderResult;
  /** Rollback an ECS service */
  rollbackService: OrderResult;
  /** Rollback a target group */
  rollbackTargetGroup: OrderResult;
  /** Rollback a task definition */
  rollbackTaskDefinition: OrderResult;
  /** Set default environment variables */
  setDefaultVars: OrderResult;
  /** Update an ALB rule */
  updateAlbRule: OrderResult;
  /** Update an IAM Role */
  updateIamRole: OrderResult;
  /** Update router information */
  updateInfo: OrderResult;
  /** Update secrets */
  updateSecrets: OrderResult;
  /** Update a Service */
  updateService: OrderResult;
  /** Update order status */
  updateStatus: OrderResult;
  /** Update order status with a reason and cause */
  updateStatusWithReason: OrderResult;
  /** Update a task definition */
  updateTaskDefinition: OrderResult;
};


export type OrderMutationupdateStatusArgs = {
  status: OrderStatus;
  updateRouter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderMutationupdateStatusWithReasonArgs = {
  cause: ReasonCause;
  reason: Scalars['String']['input'];
  status: OrderStatus;
  updateRouter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Return an Order or an error */
export type OrderOrError = Order | OrderDoesNotExistError;

/** Represents the possible outcomes of an order mutation */
export type OrderResult = InvalidInputErrors | Order | OrderError;

/** Represents the different status for an order */
export enum OrderStatus {
  /** Order was successfully completed */
  COMPLETED = 'COMPLETED',
  /** Order was unsuccessful */
  ERRORED = 'ERRORED',
  /** New Order in progress */
  PENDING = 'PENDING',
  /**
   * Order is currently rolling back
   *
   * All resources created as part of this Order are being deleted
   */
  ROLLING_BACK = 'ROLLING_BACK',
  /**
   * Order has been superseded by another, more recent order
   *
   * This can happen if two update orders arrive in close succession and we already
   * started to process the newer order first.
   */
  SUPERSEDED = 'SUPERSEDED'
}

/** Represents the different types of order */
export enum OrderType {
  /** Create a new Cloud Router */
  CREATE_ROUTER = 'CREATE_ROUTER',
  /** Destroy an existing Cloud Router */
  DESTROY_ROUTER = 'DESTROY_ROUTER',
  /** Update an existing Cloud Router */
  UPDATE_ROUTER = 'UPDATE_ROUTER'
}

/** The direction in which results are ordered. */
export enum Ordering {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export enum OrderingDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** A reusable invite link for an organization. */
export type OrganizationInviteLink = {
  __typename: 'OrganizationInviteLink';
  createdAt: Scalars['Timestamp']['output'];
  /** A joinToken that can be passed to Mutation.joinAccount to join the organization. */
  joinToken: Scalars['String']['output'];
  /** The role that the user will receive if they join the organization with this link. */
  role: UserPermission;
};

export type OrganizationSSO = {
  __typename: 'OrganizationSSO';
  defaultRole: UserPermission;
  idpid: Scalars['ID']['output'];
  provider: OrganizationSSOProvider;
};

export enum OrganizationSSOProvider {
  APOLLO = 'APOLLO'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** PagerDuty notification channel */
export type PagerDutyChannel = Channel & {
  __typename: 'PagerDutyChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  routingKey: Scalars['String']['output'];
  subscriptions: Array<ChannelSubscription>;
};

/** PagerDuty notification channel parameters */
export type PagerDutyChannelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  routingKey: Scalars['String']['input'];
};

export type ParentChangeProposalComment = ChangeProposalComment & ProposalComment & {
  __typename: 'ParentChangeProposalComment';
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** true if the schemaCoordinate this comment is on doesn't exist in the diff between the most recent revision & the base sdl */
  outdated: Scalars['Boolean']['output'];
  replies: Array<ReplyChangeProposalComment>;
  replyCount: Scalars['Int']['output'];
  schemaCoordinate: Scalars['String']['output'];
  /** '#@!api!@#' for api schema, '#@!supergraph!@#' for supergraph schema, subgraph otherwise */
  schemaScope: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type ParentGeneralProposalComment = GeneralProposalComment & ProposalComment & {
  __typename: 'ParentGeneralProposalComment';
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  replies: Array<ReplyGeneralProposalComment>;
  replyCount: Scalars['Int']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type ParentProposalComment = ParentChangeProposalComment | ParentGeneralProposalComment;

/** SAML certificate information parsed from an IdP's metadata XML */
export type ParsedSamlCertInfo = {
  __typename: 'ParsedSamlCertInfo';
  notAfter: Scalars['Timestamp']['output'];
  notBefore: Scalars['Timestamp']['output'];
  pem: Scalars['String']['output'];
  subjectDN: Scalars['String']['output'];
};

/** SAML metadata parsed from an IdP's metadata XML */
export type ParsedSamlIdpMetadata = {
  __typename: 'ParsedSamlIdpMetadata';
  encryptionCerts: Array<ParsedSamlCertInfo>;
  entityId: Scalars['String']['output'];
  ssoUrl: Scalars['String']['output'];
  verificationCerts: Array<ParsedSamlCertInfo>;
  wantsSignedRequests: Scalars['Boolean']['output'];
};

export type ParsedSchemaCoordinate = {
  __typename: 'ParsedSchemaCoordinate';
  argName: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  isDirective: Maybe<Scalars['Boolean']['output']>;
  typeName: Scalars['String']['output'];
};

/** The schema for a single published subgraph in Studio. */
export type PartialSchema = {
  __typename: 'PartialSchema';
  /** Timestamp for when the partial schema was created */
  createdAt: Scalars['Timestamp']['output'];
  /** If this sdl is currently actively composed in the gateway, this is true */
  isLive: Scalars['Boolean']['output'];
  /** The subgraph schema document as SDL. */
  sdl: Scalars['String']['output'];
};

/**
 * Input for registering a partial schema to an implementing service.
 * One of the fields must be specified (validated server-side).
 *
 * If a new partialSchemaSDL is passed in, this operation will store it before
 * creating the association.
 *
 * If both the sdl and hash are specified, an error will be thrown if the provided
 * hash doesn't match our hash of the sdl contents. If the sdl field is specified,
 * the hash does not need to be and will be computed server-side.
 */
export type PartialSchemaInput = {
  /**
   * Hash of the partial schema to associate; error is thrown if only the hash is
   * specified and the hash has not been seen before
   */
  hash?: InputMaybe<Scalars['String']['input']>;
  /**
   * Contents of the partial schema in SDL syntax, but may reference types
   * that aren't defined in this document
   */
  sdl?: InputMaybe<Scalars['String']['input']>;
};

/** An error that's returned when the current user doesn't have sufficient permissions to perform an action. */
export type PermissionError = Error & {
  __typename: 'PermissionError';
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Information about the act of publishing operations to the list */
export type PersistedQueriesPublish = {
  __typename: 'PersistedQueriesPublish';
  operationCounts: PersistedQueriesPublishOperationCounts;
  publishedAt: Scalars['Timestamp']['output'];
};

export type PersistedQueriesPublishOperationCounts = {
  __typename: 'PersistedQueriesPublishOperationCounts';
  /** The number of new operations added to the list by this publish. */
  added: Scalars['Int']['output'];
  /** The number of operations included in this publish whose metadata and body were unchanged from the previous list revision. */
  identical: Scalars['Int']['output'];
  /** The number of operations removed from the list by this publish. */
  removed: Scalars['Int']['output'];
  /** The number of operations in this list that were not mentioned by this publish. */
  unaffected: Scalars['Int']['output'];
  /** The number of operations whose metadata or body were changed by this publish. */
  updated: Scalars['Int']['output'];
};

export type PersistedQuery = {
  __typename: 'PersistedQuery';
  body: Scalars['GraphQLDocument']['output'];
  /** An optional client name associated with the operation. Two operations with the same ID but different client names are treated as distinct operations. An operation with the same ID and a null client name is treated as a distinct operation as well. */
  clientName: Maybe<Scalars['String']['output']>;
  firstPublishedAt: Scalars['Timestamp']['output'];
  /** An opaque identifier for this operation. For a given client name, this should map uniquely to an operation body; editing the body should generally result in a new ID. Apollo's tools generally use the lowercase hex SHA256 of the operation body. Note that for (eg) Apollo Client keyFields, you should use both `id` and `clientName`. */
  id: Scalars['ID']['output'];
  lastPublishedAt: Scalars['Timestamp']['output'];
  /** The GraphQL operation name for this operation. */
  name: Scalars['String']['output'];
  type: OperationType;
};

export type PersistedQueryConnection = {
  __typename: 'PersistedQueryConnection';
  edges: Array<PersistedQueryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersistedQueryEdge = {
  __typename: 'PersistedQueryEdge';
  cursor: Scalars['String']['output'];
  node: PersistedQuery;
};

/** Filter options for persisted query operations */
export type PersistedQueryFilterInput = {
  /** Only include operations whose client name is included in this list */
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Only include operations whose last published date is before or after the given date */
  lastPublishedAt?: InputMaybe<TimestampFilterInput>;
  /** Only include operations whose names contain this case-insensitive substring */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Full identifier for an operation in a Persisted Query List. */
export type PersistedQueryIdInput = {
  /** An optional client name to associate with the operation. Two operations with the same ID but different client names are treated as distinct operations. An operation with the same ID and a null client name is treated as a distinct operation as well. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** An opaque identifier for this operation. For a given client name, this should map uniquely to an operation body; editing the body should generally result in a new ID. Apollo's tools generally use the lowercase hex SHA256 of the operation body. */
  id: Scalars['ID']['input'];
};

/** Operations to be published to the Persisted Query List. */
export type PersistedQueryInput = {
  /** The GraphQL document for this operation, including all necessary fragment definitions. */
  body: Scalars['GraphQLDocument']['input'];
  /** An optional client name to associate with the operation. Two operations with the same ID but different client names are treated as distinct operations. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** An opaque identifier for this operation. This should map uniquely to an operation body; editing the body should generally result in a new ID. Apollo's tools generally use the lowercase hex SHA256 of the operation body. */
  id: Scalars['ID']['input'];
  /** A name for the operation. Typically this is the name of the actual GraphQL operation in the body. This does not need to be unique within a Persisted Query List; as a client project evolves and its operations change, multiple operations with the same name (but different body and id) can be published. */
  name: Scalars['String']['input'];
  /** The operation's type. */
  type: OperationType;
};

/** A Persisted Query List for a graph. */
export type PersistedQueryList = {
  __typename: 'PersistedQueryList';
  builds: PersistedQueryListBuildConnection;
  /** Polls the status of an asynchronous bulk deletion job started by PersistedQueryListMutation.startBulkDeletion. Returns null if no job with this ID exists, for example because the ID is unrecognized or the job's record has since expired. */
  bulkDeletionStatus: Maybe<BulkDeletionStatus>;
  /** Distinct client names associated with all operations in this Persisted Query List, if any. */
  clientNames: StringConnection;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Maybe<User>;
  /** The current build of this PQL. */
  currentBuild: PersistedQueryListBuild;
  description: Scalars['String']['output'];
  graph: Service;
  /** The immutable ID for this Persisted Query List. */
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** All variants linked to this Persisted Query List, if any. */
  linkedVariants: Array<GraphVariant>;
  /** The list's name; can be changed and does not need to be unique. */
  name: Scalars['String']['output'];
  operation: Maybe<PersistedQuery>;
  /** All operations in this Persisted Query List, if any. */
  operations: PersistedQueryConnection;
};


/** A Persisted Query List for a graph. */
export type PersistedQueryListbuildsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A Persisted Query List for a graph. */
export type PersistedQueryListbulkDeletionStatusArgs = {
  id: Scalars['ID']['input'];
};


/** A Persisted Query List for a graph. */
export type PersistedQueryListclientNamesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A Persisted Query List for a graph. */
export type PersistedQueryListoperationArgs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


/** A Persisted Query List for a graph. */
export type PersistedQueryListoperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PersistedQueryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PersistedQuerySortInput>;
};

/** Information about a particular revision of the list, as produced by a particular publish. */
export type PersistedQueryListBuild = {
  __typename: 'PersistedQueryListBuild';
  /** A unique ID for this build revision; primarily useful as a client cache ID. */
  id: Scalars['String']['output'];
  /** The persisted query list that this build built. */
  list: PersistedQueryList;
  /** The chunks that made up this build. We do not commit to keeping the full contents of older revisions indefinitely, so this may be null for suitably old revisions. */
  manifestChunks: Maybe<Array<PersistedQueryListManifestChunk>>;
  /** Information about the publish operation that created this build. */
  publish: PersistedQueriesPublish;
  /** The revision of this Persisted Query List. Revision 0 is the initial empty list; each publish increments the revision by 1. */
  revision: Scalars['Int']['output'];
  /** The total number of operations in the list after this build. Compare to PersistedQueriesPublish.operationCounts. */
  totalOperationsInList: Scalars['Int']['output'];
};

export type PersistedQueryListBuildConnection = {
  __typename: 'PersistedQueryListBuildConnection';
  edges: Array<PersistedQueryListBuildEdge>;
  pageInfo: PageInfo;
};

export type PersistedQueryListBuildEdge = {
  __typename: 'PersistedQueryListBuildEdge';
  cursor: Scalars['String']['output'];
  node: PersistedQueryListBuild;
};

export type PersistedQueryListManifestChunk = {
  __typename: 'PersistedQueryListManifestChunk';
  /** An immutable identifier for this particular chunk of a PQL. The contents referenced by this ID will never change. */
  id: Scalars['ID']['output'];
  json: Scalars['String']['output'];
  list: PersistedQueryList;
  /** The chunk can be downloaded from any of these URLs, which might be transient. */
  urls: Array<Scalars['String']['output']>;
};

export type PersistedQueryListMutation = {
  __typename: 'PersistedQueryListMutation';
  /** Deletes this Persisted Query List. */
  delete: DeletePersistedQueryListResultOrError;
  /** Deletes operations from this Persisted Query List based on filter criteria, with the ability to exclude specific operations. */
  deleteOperationsByFilter: DeleteOperationsByFilterResultOrError;
  id: Scalars['ID']['output'];
  /** Updates this Persisted Query List by publishing a set of operations and removing other operations. Operations not mentioned remain in the list unchanged. */
  publishOperations: PublishOperationsResultOrError;
  /** Starts an asynchronous job to delete all operations matching the given filter (minus any excluded operations) from this Persisted Query List. Returns a job ID to poll via PersistedQueryList.bulkDeletionStatus. Disabled behind a feature flag; once enabled for a graph, a bulk deletion already running for a list with the same filter and excluded operations will return that job's existing ID instead of starting a second one. A request with different filter criteria while one is already running is rejected, since it can't be attached to the running job and starting a second concurrent job for the list isn't supported. */
  startBulkDeletion: StartBulkDeletionResultOrError;
  /** Updates the name and/or description of the specified Persisted Query List. */
  updateMetadata: UpdatePersistedQueryListMetadataResultOrError;
};


export type PersistedQueryListMutationdeleteOperationsByFilterArgs = {
  exclude?: InputMaybe<Array<PersistedQueryIdInput>>;
  filter: PersistedQueryFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PersistedQueryListMutationpublishOperationsArgs = {
  allowOverwrittenOperations?: InputMaybe<Scalars['Boolean']['input']>;
  operations?: InputMaybe<Array<PersistedQueryInput>>;
  remove?: InputMaybe<Array<PersistedQueryIdInput>>;
  removeOperations?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PersistedQueryListMutationstartBulkDeletionArgs = {
  exclude?: InputMaybe<Array<PersistedQueryIdInput>>;
  filter: PersistedQueryFilterInput;
};


export type PersistedQueryListMutationupdateMetadataArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Columns available for sorting persisted query operations */
export enum PersistedQuerySortColumn {
  /** Sort by the first published date */
  FIRST_PUBLISHED_AT = 'FIRST_PUBLISHED_AT',
  /** Sort by the last published date */
  LAST_PUBLISHED_AT = 'LAST_PUBLISHED_AT',
  /** Sort by name */
  NAME = 'NAME'
}

/** Sort options for persisted query operations */
export type PersistedQuerySortInput = {
  /** The column to sort by */
  column: PersistedQuerySortColumn;
  /** The direction of sorting */
  direction: Ordering;
};

/** An error related to an organization's Apollo Studio plan. */
export type PlanError = {
  __typename: 'PlanError';
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Reason for a plan ineligibility */
export type PlanIneligibilityReason = {
  /** The severity of the ineligibility reason */
  severity: PlanIneligibilityReasonSeverity;
};

/** The severity of a reason for a plan ineligibility */
export enum PlanIneligibilityReasonSeverity {
  /** Error means the plan cannot be transitioned to */
  ERROR = 'ERROR',
  /** Warning means the plan can be transitioned to, but the user should be aware of a limitation */
  WARNING = 'WARNING'
}

/** Whether a rule is enforced or only shadow-evaluated. */
export enum PolicyConfigMode {
  /** Rule is enforced — decisions affect real traffic. */
  ENFORCE = 'ENFORCE',
  /** Rule is evaluated for observability only; outcomes are logged but not applied. */
  SHADOW = 'SHADOW'
}

/**
 * Lifecycle status of a rule. Note: the design doc lists a third value
 * `'deleted'`; we map that onto `deleted_at IS NOT NULL` and keep the SQL
 * enum to just `active` / `disabled`. Callers wanting to round-trip the
 * doc's enum should treat a `deleted_at`-present row as if status = deleted.
 */
export enum PolicyConfigStatus {
  /** Rule is live and participates in evaluation. */
  ACTIVE = 'ACTIVE',
  /** Rule is retained but skipped during evaluation. */
  DISABLED = 'DISABLED'
}

/** How a deny rule presents to clients that lack access. */
export enum PolicyDenyVisibility {
  /** Field/type does not appear in the client's view of the schema. */
  HIDDEN = 'HIDDEN',
  /** Field/type returns an "access requestable" hint. */
  REQUESTABLE = 'REQUESTABLE',
  /** Field/type is visible but returns an error on access. */
  VISIBLE = 'VISIBLE'
}

/** The action a rule takes when matched. */
export enum PolicyEffect {
  /**
   * Permit access to every field of the target. `effectConfig.allowFields`
   * or `effectConfig.redactFields` narrows it to a subset.
   */
  ALLOW = 'ALLOW',
  /** Refuse access. `effectConfig.denyVisibility` controls how the denial is surfaced. */
  DENY = 'DENY',
  /** Mask matching values in responses. Carries no `effectConfig`. */
  MASK = 'MASK'
}

/**
 * Effect-specific configuration. Flat container — see the design doc /
 * spec for the rationale. At most one effect's fields are populated on a
 * given rule; others are null. A MASK rule, and an ALLOW rule over every
 * field, carry no `effectConfig` at all.
 */
export type PolicyEffectConfig = {
  __typename: 'PolicyEffectConfig';
  /** (ALLOW) Fields to expose. Mutually exclusive with `redactFields`. */
  allowFields: Maybe<Array<Scalars['String']['output']>>;
  /** (DENY) Optional caller-facing reason. Free-form text. */
  denyReason: Maybe<Scalars['String']['output']>;
  /** (DENY) How the rule presents to clients without access. */
  denyVisibility: Maybe<PolicyDenyVisibility>;
  /** (ALLOW) Fields to redact from responses. Mutually exclusive with `allowFields`. */
  redactFields: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Effect-specific configuration on create/update. At most one effect's fields
 * may be supplied — see `PolicyEffect` for the per-effect contract.
 */
export type PolicyEffectConfigInput = {
  /**
   * (ALLOW) Fields to expose, narrowing the rule from every field to these.
   * Mutually exclusive with `redactFields`. Must name at least one field.
   */
  allowFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** (DENY) Optional caller-facing reason. Free-form text. */
  denyReason?: InputMaybe<Scalars['String']['input']>;
  /** (DENY) How the rule presents to clients without access. */
  denyVisibility?: InputMaybe<PolicyDenyVisibility>;
  /**
   * (ALLOW) Fields to redact from responses. Mutually exclusive with
   * `allowFields`. Null or empty redacts nothing, allowing every field.
   */
  redactFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The result of evaluating a GraphQL operation against the org's policies. */
export type PolicyEvaluationResult = {
  __typename: 'PolicyEvaluationResult';
  /**
   * One entry per `TypeName.fieldName` in the operation that carries at least
   * one classification tag. Fields with no tags are omitted (they are implicitly
   * ALLOWED with no policy consideration).
   */
  fields: Array<FieldEvaluation>;
};

/**
 * A grant that carves out an exception to the policy rules — an approved
 * allowance for a principal to access a classification on a specific service
 * within one application.
 */
export type PolicyException = {
  __typename: 'PolicyException';
  /** Optional reference to the access request that produced this exception. */
  accessRequestId: Maybe<Scalars['UUID']['output']>;
  /** Identifier of the user/system that approved the exception. */
  approvedBy: Scalars['String']['output'];
  /** Classification label being granted (e.g. `pii`). */
  classification: Scalars['String']['output'];
  /** Timestamp when the exception was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Soft-delete timestamp; null for live exceptions. */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** When the exception expires; null means it does not auto-expire. */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  /** Stable identifier for the exception. */
  id: Scalars['UUID']['output'];
  /**
   * The paired rule this exception was created alongside (its 1:1
   * companion), if any. Independent of `accessRequestId` — an
   * approval-created exception carries both.
   */
  pairedId: Maybe<Scalars['UUID']['output']>;
  /** The principal granted access. Null means "all principals in scope". */
  principal: Maybe<PolicyRulePrincipal>;
  /** Human-readable justification for the grant. */
  reason: Scalars['String']['output'];
  /** Application the exception applies to. Exceptions are always app-scoped. */
  scopeAppId: Scalars['UUID']['output'];
  /** The upstream service the exception covers. */
  serviceId: Scalars['UUID']['output'];
  /** Lifecycle status — active, expired, or revoked. */
  status: PolicyExceptionStatus;
  /** Timestamp when the exception was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginated page of `PolicyException`s. */
export type PolicyExceptionPage = {
  __typename: 'PolicyExceptionPage';
  /** Opaque cursor for the next page, or null when there are no more results. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Exceptions in this page, in stable order. */
  items: Array<PolicyException>;
};

/** Lifecycle status of a policy exception. */
export enum PolicyExceptionStatus {
  /** Exception is live — covered access is granted. */
  ACTIVE = 'ACTIVE',
  /** Exception passed its `expiresAt` and no longer grants access. */
  EXPIRED = 'EXPIRED',
  /** Exception was manually rescinded before expiry. */
  REVOKED = 'REVOKED'
}

/** What kind of principal a rule binds to. */
export enum PolicyPrincipalKind {
  /** Binds the rule/exception to a named group of principals. */
  GROUP = 'GROUP',
  /** Binds the rule/exception to a single principal identifier. */
  PRINCIPAL_ID = 'PRINCIPAL_ID'
}

/** A policy rule — one binding row in the Constellation Policy IR. */
export type PolicyRule = {
  __typename: 'PolicyRule';
  /** Optional reference to the access request that produced this rule. */
  accessRequestId: Maybe<Scalars['UUID']['output']>;
  /**
   * The owning org. Part of this type's federation key alongside `id`
   * (`@key(fields: "id account { internalID }")`), so a caller supplies
   * the org up front rather than this type authorizing after an unscoped
   * lookup.
   */
  account: Account;
  /** Operational configuration — mode, priority, status. */
  config: PolicyRuleConfig;
  /** Timestamp when the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Soft-delete timestamp; null for live rules. */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional human-readable description of the rule's intent. */
  description: Maybe<Scalars['String']['output']>;
  /** The action taken when the rule matches. */
  effect: PolicyEffect;
  /** Effect-specific configuration. Null when `effect = MASK`. */
  effectConfig: Maybe<PolicyEffectConfig>;
  /** Stable identifier for the rule. */
  id: Scalars['UUID']['output'];
  /** Optional short label for the rule. `description` carries the longer prose. */
  name: Maybe<Scalars['String']['output']>;
  /**
   * The paired exception this rule was created alongside (its 1:1
   * companion), if any. Independent of `accessRequestId` — an
   * approval-created rule carries both.
   */
  pairedId: Maybe<Scalars['UUID']['output']>;
  /** The principal bound by the rule. Null means "all principals in scope". */
  principal: Maybe<PolicyRulePrincipal>;
  /** The graph-wide or app-scoped slice the rule applies to. */
  scope: PolicyRuleScope;
  /** What the rule targets (a classification or a specific service). */
  target: PolicyRuleTarget;
  /** Timestamp when the rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Operational configuration for a rule — enforcement mode, priority, and status. */
export type PolicyRuleConfig = {
  __typename: 'PolicyRuleConfig';
  /** Whether the rule is enforced or only shadow-evaluated. */
  mode: PolicyConfigMode;
  /** Tie-breaker priority when multiple rules match. Higher wins. */
  priority: Scalars['Int']['output'];
  /** Whether the rule is active or disabled. */
  status: PolicyConfigStatus;
};

/**
 * Operational configuration on create/update. All fields default server-side
 * when omitted.
 */
export type PolicyRuleConfigInput = {
  /** Override the enforcement mode. Defaults to `ENFORCE`. */
  mode?: InputMaybe<PolicyConfigMode>;
  /** Override the priority. Defaults to 100. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Override the lifecycle status. Defaults to `ACTIVE`. */
  status?: InputMaybe<PolicyConfigStatus>;
};

/**
 * Filter options for `Service.policyRules`. All fields are optional and
 * compose (logical AND).
 */
export type PolicyRuleFilterInput = {
  /**
   * Match only rules whose `config.status` is one of the supplied values.
   * An empty array is treated the same as null.
   */
  configStatus?: InputMaybe<Array<PolicyConfigStatus>>;
  /**
   * Match only rules with one of the supplied effects.
   * An empty array is treated the same as null.
   */
  effect?: InputMaybe<Array<PolicyEffect>>;
  /**
   * When true, match only rules created by the access-request approval flow;
   * when false, only rules authored directly. Null does not filter.
   */
  hasAccessRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, match only rules paired with a policy exception (their 1:1
   * companion); when false, only standalone rules. Null does not filter.
   *
   * Independent of `hasAccessRequest` — a rule created by the approval flow
   * carries both linkages, so the two intersect rather than overlap.
   */
  hasPairedException?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When false, match only rules with no principal binding — rules that apply
   * to everyone in scope. When true, match only rules that bind some
   * principal. Null does not filter.
   */
  hasPrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include soft-deleted rules. Defaults to false, which excludes them. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Match only rules bound to one of the supplied principal kinds. Implies a
   * principal binding exists, so combining this with `hasPrincipal: false`
   * matches nothing. An empty array is treated the same as null.
   */
  principalType?: InputMaybe<Array<PolicyPrincipalKind>>;
  /** Match only rules scoped to this application. */
  scopeAppId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Match only rules at one of the supplied scopes (graph-wide or
   * app-scoped). An empty array is treated the same as null.
   */
  scopeType?: InputMaybe<Array<PolicyScopeKind>>;
  /**
   * Match only rules whose target is one of the supplied kinds.
   * An empty array is treated the same as null.
   */
  targetType?: InputMaybe<Array<PolicyTargetKind>>;
};

/** Metadata about how a field policy rule has been applied to requests on this variant. Only covers rules whose effect differs from the graph's default visibility: an effect matching the default is never logged, so such a rule always reads as unapplied here regardless of how often it actually matched. */
export type PolicyRuleInsights = {
  __typename: 'PolicyRuleInsights';
  /** The most recent time this rule's effect was enforced on a field. Null if the rule has never been applied, was last applied before the retention period, or has an effect matching the graph's default visibility. */
  lastAppliedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Paginated page of `PolicyRule`s. */
export type PolicyRulePage = {
  __typename: 'PolicyRulePage';
  /** Opaque cursor for the next page, or null when there are no more results. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Rules in this page, in stable order. */
  items: Array<PolicyRule>;
};

/**
 * The principal a rule binds to. A null `principal` on the parent means "all
 * principals in scope".
 */
export type PolicyRulePrincipal = {
  __typename: 'PolicyRulePrincipal';
  /** Whether `value` identifies a group or a single principal. */
  type: PolicyPrincipalKind;
  /** Group name or principal identifier — interpretation depends on `type`. */
  value: Scalars['String']['output'];
};

/** Input shape for a principal binding — mirrors `PolicyRulePrincipal`. */
export type PolicyRulePrincipalInput = {
  /** Whether `value` identifies a group or a single principal. */
  type: PolicyPrincipalKind;
  /** Group name or principal identifier. */
  value: Scalars['String']['input'];
};

/** The slice of the graph a rule applies to — graph-wide or a single application. */
export type PolicyRuleScope = {
  __typename: 'PolicyRuleScope';
  /** The application id when `type = APP`; null for `GRAPH` scope. */
  appId: Maybe<Scalars['UUID']['output']>;
  /**
   * The application when `type = APP`, as a resolved record; null for
   * `GRAPH` scope. Same lookup as `Account.application`, so clients can
   * render app names without joining against the application roster;
   * `appId` remains for consumers that only need the id.
   */
  application: Maybe<ApplicationType>;
  /** Whether the rule applies graph-wide (`GRAPH`) or to a single app (`APP`). */
  type: PolicyScopeKind;
};

/** Input shape for a rule's scope — mirrors `PolicyRuleScope`. */
export type PolicyRuleScopeInput = {
  /** The application id; required when `type = APP`, must be null for `GRAPH`. */
  appId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the rule should apply graph-wide or to a single app. */
  type: PolicyScopeKind;
};

/** What a rule targets — a data classification label or a specific service. */
export type PolicyRuleTarget = {
  __typename: 'PolicyRuleTarget';
  /** Classification label (e.g. `pii`) when `type = CLASSIFICATION`; null otherwise. */
  classification: Maybe<Scalars['String']['output']>;
  /** Service id when `type = SERVICE`; null otherwise. */
  serviceId: Maybe<Scalars['UUID']['output']>;
  /** Whether the target is a classification label or a specific service. */
  type: PolicyTargetKind;
  /**
   * The upstream service when `type = SERVICE`, as a resolved record;
   * null for `CLASSIFICATION` targets. Same lookup as
   * `Account.upstreamService`, so clients can render service names
   * without joining against the service roster; `serviceId` remains for
   * consumers that only need the id.
   */
  upstreamService: Maybe<UpstreamService>;
};

/** Input shape for a rule's target — mirrors `PolicyRuleTarget`. */
export type PolicyRuleTargetInput = {
  /** Classification label; required when `type = CLASSIFICATION`. */
  classification?: InputMaybe<Scalars['String']['input']>;
  /** Service id; required when `type = SERVICE`. */
  serviceId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the target is a classification label or a specific service. */
  type: PolicyTargetKind;
};

/** Whether a rule applies organization-wide or to a single application. */
export enum PolicyScopeKind {
  /** Application-scoped — applies only to the application identified by `appId`. */
  APP = 'APP',
  /** Graph-wide — applies to every application in the graph. */
  GRAPH = 'GRAPH'
}

/** What a rule targets — a classification (e.g. `pii`) or a specific service. */
export enum PolicyTargetKind {
  /** Targets a data classification label such as `pii` or `secret`. */
  CLASSIFICATION = 'CLASSIFICATION',
  /** Targets a specific upstream service identified by `serviceId`. */
  SERVICE = 'SERVICE'
}

/** GraphQL representation of an AWS private subgraph */
export type PrivateSubgraph = {
  __typename: 'PrivateSubgraph';
  /** The cloud provider where the subgraph is hosted */
  cloudProvider: CloudProvider;
  /** The domain URL of the private subgraph */
  domainUrl: Maybe<Scalars['String']['output']>;
  /** The name of the subgraph, if set */
  name: Maybe<Scalars['String']['output']>;
  /** The private subgraph's region */
  region: RegionDescription;
  /** The status of the resource share */
  status: PrivateSubgraphShareStatus;
};

export type PrivateSubgraphMutation = {
  __typename: 'PrivateSubgraphMutation';
  /** Synchronize private subgraphs to your Apollo account */
  sync: Array<PrivateSubgraph>;
};


export type PrivateSubgraphMutationsyncArgs = {
  input: SyncPrivateSubgraphsInput;
};

/** The status of an association between a private subgraph and your Apollo account */
export enum PrivateSubgraphShareStatus {
  /** The private subgraph is connected to the Apollo service network */
  CONNECTED = 'CONNECTED',
  /** The private subgraph is disconnected to the Apollo service network */
  DISCONNECTED = 'DISCONNECTED',
  /** The private subgraph's connection to the Apollo service network has errored */
  ERRORED = 'ERRORED',
  /** The private subgraph's connection is pending */
  PENDING = 'PENDING',
  /** The private subgraph's disconnection is pending */
  PENDING_DISCONNECTION = 'PENDING_DISCONNECTION',
  /** The current state of the association is unknown */
  UNKNOWN = 'UNKNOWN'
}

/** The JSM product associated with a support ticket. */
export enum Product {
  /** Issues related to Apollo Client */
  APOLLO_CLIENT = 'APOLLO_CLIENT',
  /** Issues related to Apollo Connectors */
  APOLLO_CONNECTORS = 'APOLLO_CONNECTORS',
  /** Issues related to Apollo Explorer/Sandbox */
  APOLLO_EXPLORER_SANDBOX = 'APOLLO_EXPLORER_SANDBOX',
  /** Issues related to Apollo Operator */
  APOLLO_OPERATOR = 'APOLLO_OPERATOR',
  /** Issues related to Apollo Router */
  APOLLO_ROUTER = 'APOLLO_ROUTER',
  /** Issues related to Apollo Rover CLI */
  APOLLO_ROVER_CLI = 'APOLLO_ROVER_CLI',
  /** Issues related to Apollo Server */
  APOLLO_SERVER = 'APOLLO_SERVER',
  /** Issues related to Apollo Studio */
  APOLLO_STUDIO = 'APOLLO_STUDIO',
  /** Billing issues */
  BILLING = 'BILLING',
  /** Issues related to MCP Server */
  MCP_SERVER = 'MCP_SERVER',
  /** Onboarding issues */
  ONBOARDING = 'ONBOARDING',
  /** Other issues */
  OTHER = 'OTHER',
  /** Issues related to Schema Proposals */
  SCHEMA_PROPOSALS = 'SCHEMA_PROPOSALS',
  /** Security issues */
  SECURITY = 'SECURITY',
  /** Issues related to Studio Insights */
  STUDIO_INSIGHTS = 'STUDIO_INSIGHTS',
  /** User, account, and permissions issues */
  USERS_ACCOUNTS_PERMISSIONS = 'USERS_ACCOUNTS_PERMISSIONS'
}

/** A user's membership in an account for a specific product. */
export type ProductMember = {
  __typename: 'ProductMember';
  /** The date the user became a member of this account for this product. */
  memberSince: Scalars['Timestamp']['output'];
  /** The product associated with this membership. */
  product: Scalars['String']['output'];
  /** The user associated with this membership. */
  user: User;
};

export type PromoteSchemaError = {
  __typename: 'PromoteSchemaError';
  code: PromoteSchemaErrorCode;
  message: Scalars['String']['output'];
};

export enum PromoteSchemaErrorCode {
  CANNOT_PROMOTE_SCHEMA_FOR_FEDERATED_GRAPH = 'CANNOT_PROMOTE_SCHEMA_FOR_FEDERATED_GRAPH'
}

export type PromoteSchemaResponse = {
  __typename: 'PromoteSchemaResponse';
  code: PromoteSchemaResponseCode;
  tag: SchemaTag;
};

export enum PromoteSchemaResponseCode {
  NO_CHANGES_DETECTED = 'NO_CHANGES_DETECTED',
  PROMOTION_SUCCESS = 'PROMOTION_SUCCESS'
}

export type PromoteSchemaResponseOrError = PromoteSchemaError | PromoteSchemaResponse;

export type Proposal = {
  __typename: 'Proposal';
  /**
   * A list of the activities for this proposal.
   * If first and last are not specified, defaults to 25. If one is specified there is a max allowed value of 50.
   */
  activities: ProposalActivityConnection;
  /** The variant this Proposal is under the hood. */
  backingVariant: GraphVariant;
  /** Can the current user can edit THIS proposal, either by authorship or role level */
  canEditProposal: Scalars['Boolean']['output'];
  changes: Array<ProposalChange>;
  comment: Maybe<ProposalCommentResult>;
  createdAt: Scalars['Timestamp']['output'];
  /**
   * null if user is deleted, or if user removed from org
   * and others in the org no longer have access to this user's info
   */
  createdBy: Maybe<Identity>;
  /** The description of this Proposal. */
  description: Scalars['String']['output'];
  descriptionUpdatedAt: Maybe<Scalars['Timestamp']['output']>;
  descriptionUpdatedBy: Maybe<Identity>;
  displayName: Scalars['String']['output'];
  /** A flag indicating if changes have been detected on the source variant. Will be false if proposal was created prior to the pull upstream feature release on Nov 15, 2024. */
  hasUpstreamChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  implementedChanges: Array<ProposalImplementedChange>;
  /** True if only some of the changes in this proposal are currently published to the implementation variant */
  isPartiallyImplemented: Scalars['Boolean']['output'];
  latestRevision: ProposalRevision;
  mergeBaseCompositionId: Maybe<Scalars['ID']['output']>;
  /**
   * Use mergedSdlWithConflicts instead.
   * @deprecated Use mergedSdlWithConflicts instead
   */
  mergedSdl: Array<SubgraphWithConflicts>;
  /** Returns a partially merged sdl string and list of conflicts in the sdl by merging the proposals's current sdl and the source variant's current sdl against the source variant's sdl at the time of the last merge or proposal creation. */
  mergedSdlWithConflicts: Maybe<MergedSdlWithConflictsResult>;
  parentComments: Array<ParentProposalComment>;
  rebaseConflicts: Maybe<RebaseConflictResult>;
  /**  null if user deleted or removed from org */
  requestedReviewers: Array<Maybe<ProposalRequestedReviewer>>;
  reviews: Array<ProposalReview>;
  revision: Maybe<ProposalRevisionResult>;
  revisionHistory: ProposalRevisionHistoryResult;
  /** The variant this Proposal was cloned/sourced from. */
  sourceVariant: GraphVariant;
  status: ProposalStatus;
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: Maybe<Identity>;
};


export type ProposalactivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProposalcommentArgs = {
  id: Scalars['ID']['input'];
};


export type ProposalparentCommentsArgs = {
  filter?: InputMaybe<CommentFilter>;
};


export type ProposalrevisionArgs = {
  id: Scalars['ID']['input'];
};


export type ProposalrevisionHistoryArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<ProposalRevisionHistoryOrder>;
};

export type ProposalActivity = {
  __typename: 'ProposalActivity';
  activity: Maybe<ProposalActivityAction>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  target: Maybe<ProposalActivityTarget>;
};

export enum ProposalActivityAction {
  /** When the system changes a Proposal's status back to OPEN from APPROVED when approvals drop below min approvals. */
  APPROVAL_WITHDRAWN = 'APPROVAL_WITHDRAWN',
  /** When the system changes a Proposal's status back to OPEN from APPROVED when a change is made after a proposal or review is approved. */
  APPROVAL_WITHDRAWN_ON_PUBLISH = 'APPROVAL_WITHDRAWN_ON_PUBLISH',
  /** When a user manually sets a Proposal to Close */
  CLOSE_PROPOSAL = 'CLOSE_PROPOSAL',
  /** When a Comment is added to a Proposal. */
  COMMENT_ADDED = 'COMMENT_ADDED',
  /** When a subgraph in a Proposal is deleted. */
  DELETE_SUBGRAPH = 'DELETE_SUBGRAPH',
  /** When a diff in a Proposal publish is found to already be in the Implementation target variant that fully implements the Proposal. Status of the Proposal will change to IMPLEMENTED. */
  FULLY_IMPLEMENTED_PROPOSAL_ORIGIN = 'FULLY_IMPLEMENTED_PROPOSAL_ORIGIN',
  /**  When a diff in an Implementation variant publish is found in a Proposal that fully implements the Proposal. Status of the Proposal will change to IMPLEMENTED. */
  FULLY_IMPLEMENTED_VARIANT_ORIGIN = 'FULLY_IMPLEMENTED_VARIANT_ORIGIN',
  /** When the system changes a Proposal's status to APPROVED when the min approvals have been met. */
  MET_MIN_APPROVALS_PROPOSAL = 'MET_MIN_APPROVALS_PROPOSAL',
  /** When a user manually sets a Proposal to Open */
  OPEN_PROPOSAL = 'OPEN_PROPOSAL',
  /** When a diff in a Proposal publish is found to already be in the Implementation target variant that partially implements the Proposal. Does not change the status of the Proposal, but isPartiallyImplemented will return true. */
  PARTIALLY_IMPLEMENTED_PROPOSAL_ORIGIN = 'PARTIALLY_IMPLEMENTED_PROPOSAL_ORIGIN',
  /** When a diff in an Implementation variant publish is found in a Proposal that partially implements the Proposal. Does not change the status of the Proposal, but isPartiallyImplemented will return true. */
  PARTIALLY_IMPLEMENTED_VARIANT_ORIGIN = 'PARTIALLY_IMPLEMENTED_VARIANT_ORIGIN',
  /** When a new revision is published to subgraphs in a Proposal. */
  PUBLISH_SUBGRAPHS = 'PUBLISH_SUBGRAPHS',
  /** When a Proposal is moved to DRAFT from another status not on creation. */
  RETURN_TO_DRAFT_PROPOSAL = 'RETURN_TO_DRAFT_PROPOSAL',
  /** When a Review is added to a Proposal. */
  REVIEW_ADDED = 'REVIEW_ADDED'
}

export type ProposalActivityConnection = {
  __typename: 'ProposalActivityConnection';
  edges: Maybe<Array<ProposalActivityEdge>>;
  nodes: Array<ProposalActivity>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProposalActivityEdge = {
  __typename: 'ProposalActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: Maybe<ProposalActivity>;
};

export type ProposalActivityTarget = ParentChangeProposalComment | ParentGeneralProposalComment | Proposal | ProposalFullImplementationProposalOrigin | ProposalFullImplementationVariantOrigin | ProposalPartialImplementationProposalOrigin | ProposalPartialImplementationVariantOrigin | ProposalReview | ProposalRevision;

export type ProposalChange = {
  __typename: 'ProposalChange';
  diffItem: FlatDiffItem;
  implemented: Scalars['Boolean']['output'];
  /** Whether the change is still proposed, or was absorbed into the merge base by a Pull Changes. */
  state: ProposalChangeState;
};

export enum ProposalChangeMismatchSeverity {
  ERROR = 'ERROR',
  OFF = 'OFF',
  WARN = 'WARN'
}

/** Whether a change is still part of what the proposal proposes, or has left that delta because a Pull Changes carried it into the merge base. The proposal keeps an absorbed change as its record of shipped work. */
export enum ProposalChangeState {
  /** A Pull Changes carried the change into the merge base, so it is no longer part of the current delta. It is kept, with its implemented markers, as the record that the proposed change shipped. */
  ABSORBED = 'ABSORBED',
  /** The change is part of the proposal's current delta. */
  ACTIVE = 'ACTIVE'
}

export type ProposalComment = {
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type ProposalCommentResult = NotFoundError | ParentChangeProposalComment | ParentGeneralProposalComment | ReplyChangeProposalComment | ReplyGeneralProposalComment | ReviewProposalComment;

export enum ProposalCoverage {
  FULL = 'FULL',
  NONE = 'NONE',
  OVERRIDDEN = 'OVERRIDDEN',
  PARTIAL = 'PARTIAL',
  PENDING = 'PENDING'
}

export type ProposalFullImplementationProposalOrigin = ProposalImplementation & {
  __typename: 'ProposalFullImplementationProposalOrigin';
  /** the time this Proposal became implemented in the implementation target variant. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** the diff that was matched between the Proposal and the implementation target variant. TODO to deserialize this back into a DiffItem NEBULA-2726 */
  jsonDiff: Array<Scalars['String']['output']>;
  /** Revision containing a diff that fully implements this Proposal in the implementation target variant. */
  revision: ProposalRevision;
  /** the target variant this Proposal became implemented in. */
  variant: GraphVariant;
};

export type ProposalFullImplementationVariantOrigin = ProposalImplementation & {
  __typename: 'ProposalFullImplementationVariantOrigin';
  /** the time this Proposal became implemented in the implementation target variant. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** the diff that was matched between the Proposal and the implementation target variant. TODO to deserialize this back into a DiffItem NEBULA-2726 */
  jsonDiff: Array<Scalars['String']['output']>;
  /** launch containing a diff that fully implements this Proposal in the implementation target variant. null if user does not have access to launches */
  launch: Maybe<Launch>;
  /** the target variant this Proposal became implemented in. */
  variant: GraphVariant;
};

export type ProposalImplementation = {
  /** the time this Proposal became implemented in the implementation target variant. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** the diff that was matched between the Proposal and the implementation target variant */
  jsonDiff: Array<Scalars['String']['output']>;
  /** the target variant this Proposal became implemented in. */
  variant: GraphVariant;
};

export type ProposalImplementedChange = {
  __typename: 'ProposalImplementedChange';
  diffItem: FlatDiffItem;
  launchId: Scalars['ID']['output'];
  subgraph: Scalars['String']['output'];
};

export enum ProposalLifecycleEvent {
  /** When a user is mentioned in a comment on a Proposal. */
  COMMENT_MENTION = 'COMMENT_MENTION',
  /** When a new Proposal is created. */
  PROPOSAL_CREATED = 'PROPOSAL_CREATED',
  /** When a Review is submitted on a Proposal. */
  REVIEW_SUBMITTED = 'REVIEW_SUBMITTED',
  /** When a new revision is published to subgraphs in a Proposal. */
  REVISION_SAVED = 'REVISION_SAVED',
  /** When a Proposal's status changes (e.g. OPEN, APPROVED, IMPLEMENTED, CLOSED). */
  STATUS_CHANGE = 'STATUS_CHANGE'
}

export type ProposalLifecycleSubscription = ChannelSubscription & {
  __typename: 'ProposalLifecycleSubscription';
  /** The channels that will be notified on this subscription. */
  channels: Array<Channel>;
  /** The time when this ProposalLifecycleSubscription was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** The Identity that created this ProposalLifecycleSubscription. null if the Identity has been deleted. */
  createdBy: Maybe<Identity>;
  /** True if this ProposalLifecycleSubscription is actively sending notifications. */
  enabled: Scalars['Boolean']['output'];
  /** The ProposalLifecycleEvents that will trigger notifications on this subscription. */
  events: Array<ProposalLifecycleEvent>;
  id: Scalars['ID']['output'];
  /** The last time this subscription was updated, if never updated will be the createdAt time. */
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** The Identity that last updated this ProposalLifecycleSubscription, or the creator if no one has updated. null if the Identity has been deleted. */
  lastUpdatedBy: Maybe<Identity>;
  /** Always null for ProposalLifecycleSubscription. */
  variant: Maybe<Scalars['String']['output']>;
};

/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutation = {
  __typename: 'ProposalMutation';
  /** Add a comment to this proposal. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  addComment: AddCommentResult;
  /** Delete a comment on this proposal. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  deleteComment: DeleteCommentResult;
  /** Delete a subgraph from this proposal. This will write the summary to proposals, record the most up to date diff, and call registry's removeImplementingServiceAndTriggerComposition. If composition is successful, this will update running routers. */
  deleteSubgraph: DeleteProposalSubgraphResult;
  /** Edit a comment on this proposal. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  editComment: EditCommentResult;
  /** The GraphOS Schema Proposal being modified by this mutation. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
  proposal: Maybe<Proposal>;
  /** This mutation creates a new revision of a proposal by publishing multiple subgraphs, saving the summary and recording a diff. If composition is successful, this will update running routers. See the documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals/creation/#save-revisions This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  publishSubgraphs: PublishProposalSubgraphResult;
  /** Re-runs schema checks for the specified proposal revision and associates the resulting check workflow with that revision. If the revision has no existing check workflow, a new one is created. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  reRunCheckForRevision: ReRunCheckForRevisionResult;
  /** Removes all requested reviewers and their reviews that are not part of the new set of default reviewers. Adds any new default reviewers to the list of requested reviewers for this proposal. */
  replaceReviewersWithDefaultReviewers: ReplaceReviewersWithDefaultReviewersResult;
  /** Report one or more diff items as suspected false positives on a proposal revision. */
  reportFalsePositiveDiffItems: ReportFalsePositiveDiffItemsResult;
  /** Set the mergeBaseCompositionId of this Proposal, if it is null. Must be internal MDG user with sudo. */
  setMergeBaseCompositionId: SetMergeBaseCompositionIdResult;
  /** Sync proposal revisions to the latest launch. */
  syncToLaunches: ProposalSyncToLaunchesResult;
  /** Triggers implementation handler on the proposal for the given proposalGraphCompositionId and implementationVariantGraphCompositionId. */
  triggerProposalsImplementationHandlerProposalPublish: Proposal;
  /** Updates the description of this Proposal variant. Returns ValidationError if description exceeds max length of 10k characters. */
  updateDescription: UpdateProposalResult;
  /** Update the title of this proposal. This field accepts up to 200 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  updateDisplayName: UpdateProposalResult;
  /** Update the list of requested reviewers for this proposal. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  updateRequestedReviewers: UpdateRequestedReviewersResult;
  /** Update the status of this proposal. This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  updateStatus: UpdateProposalResult;
  updateUpdatedByInfo: UpdateProposalResult;
  /** Create or update a review for this proposal. Only users who are requested reviewers can call this mutation.  This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  upsertReview: UpsertReviewResult;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationaddCommentArgs = {
  input: AddCommentInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationdeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationdeleteSubgraphArgs = {
  input: DeleteProposalSubgraphInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationeditCommentArgs = {
  input: EditCommentInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationpublishSubgraphsArgs = {
  input: PublishProposalSubgraphsInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationreRunCheckForRevisionArgs = {
  input: ReRunCheckForRevisionInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationreportFalsePositiveDiffItemsArgs = {
  input: ReportFalsePositiveDiffItemsInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationsetMergeBaseCompositionIdArgs = {
  input: SetMergeBaseCompositionIdInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationtriggerProposalsImplementationHandlerProposalPublishArgs = {
  implementationVariantGraphCompositionId?: InputMaybe<Scalars['ID']['input']>;
  proposalGraphCompositionId: Scalars['ID']['input'];
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupdateDescriptionArgs = {
  input: UpdateDescriptionInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupdateDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupdateRequestedReviewersArgs = {
  input: UpdateRequestedReviewersInput;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupdateStatusArgs = {
  status: ProposalStatus;
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupdateUpdatedByInfoArgs = {
  timestamp: Scalars['Timestamp']['input'];
};


/** Mutations for editing GraphOS Schema Proposals. See documentation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals */
export type ProposalMutationupsertReviewArgs = {
  input: UpsertReviewInput;
};

export type ProposalMutationResult = NotFoundError | PermissionError | ProposalMutation | ValidationError;

export type ProposalPartialImplementationProposalOrigin = ProposalImplementation & {
  __typename: 'ProposalPartialImplementationProposalOrigin';
  /** the time this Proposal became partially implemented in the implementation target variant. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** the diff that was matched between the Proposal and the implementation target variant. TODO to deserialize this back into a DiffItem NEBULA-2726 */
  jsonDiff: Array<Scalars['String']['output']>;
  /** Revision containing a diff that partially implements this Proposal in the implementation target variant. */
  revision: ProposalRevision;
  /** the target variant this Proposal became partially implemented in. */
  variant: GraphVariant;
};

export type ProposalPartialImplementationVariantOrigin = ProposalImplementation & {
  __typename: 'ProposalPartialImplementationVariantOrigin';
  /** the time this Proposal became partially implemented in the implementation target variant. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** the diff that was matched between the Proposal and the implementation target variant. TODO to deserialize this back into a DiffItem NEBULA-2726 */
  jsonDiff: Array<Scalars['String']['output']>;
  /** launch containing a diff that partially implements this Proposal in the implementation target variant. null if user does not have access to launches */
  launch: Maybe<Launch>;
  /** the target variant this Proposal became partially implemented in. */
  variant: GraphVariant;
};

export type ProposalRequestedReviewer = {
  __typename: 'ProposalRequestedReviewer';
  currentReview: Maybe<ProposalReview>;
  user: Maybe<Identity>;
};

export type ProposalReview = {
  __typename: 'ProposalReview';
  comment: Maybe<ReviewProposalComment>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Maybe<Identity>;
  decision: ReviewDecision;
  id: Scalars['ID']['output'];
  isDismissed: Scalars['Boolean']['output'];
  /** The revision this review was submitted against. */
  revision: Maybe<ProposalRevision>;
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
  updatedBy: Maybe<Identity>;
};

export type ProposalRevision = {
  __typename: 'ProposalRevision';
  /** On publish, checks are triggered on a proposal automatically. However, if an error occurred triggering a check on publish, we skip attempting the check to avoid blocking the publish from succeeding. This is the only case this field would be null. */
  checkWorkflow: Maybe<CheckWorkflow>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Maybe<Identity>;
  /** Look up a single false-positive flag by its ID on this revision. Returns null if the flag does not exist, belongs to a different revision, or the caller cannot view the proposal. */
  falsePositiveFlag: Maybe<FalsePositiveFlag>;
  id: Scalars['ID']['output'];
  isMerge: Scalars['Boolean']['output'];
  launch: Maybe<Launch>;
  /** ID of the launch that this revision is associated with. For internal use only, correct schema usage would be to access through the Launch, but CONSUMER role has no access to launch, yet they need access to the schema publish. */
  launchId: Scalars['ID']['output'];
  /** Latest composition ID of the proposal's source variant at the time this revision was created. */
  mergeBaseCompositionId: Maybe<Scalars['ID']['output']>;
  /** Latest launch of the proposal's source variant at the time this revision was created. */
  mergeBaseLaunch: Maybe<Launch>;
  /** The schema publish of the proposal's source variant at the time this revision was created. Null if the launch is PENDING. */
  mergeBaseSchemaPublish: Maybe<SchemaTag>;
  /** null if this is the first revision */
  previousRevision: Maybe<ProposalRevision>;
  /** The schema publish for this revision. Null while the launch is PENDING. */
  schemaPublish: Maybe<SchemaTag>;
  summary: Scalars['String']['output'];
};


export type ProposalRevisionfalsePositiveFlagArgs = {
  id: Scalars['ID']['input'];
};

export enum ProposalRevisionHistoryOrder {
  /** List revisions from oldest to newest. */
  CREATED_ASC = 'CREATED_ASC',
  /** List revisions from newest to oldest, default. */
  CREATED_DESC = 'CREATED_DESC'
}

export type ProposalRevisionHistoryResult = {
  __typename: 'ProposalRevisionHistoryResult';
  revisions: Array<ProposalRevision>;
  /** This is the total number of revisions for the proposal, regardless of the size of the returned list. */
  totalCount: Scalars['Int']['output'];
};

export type ProposalRevisionResult = NotFoundError | ProposalRevision;

export type ProposalRoles = {
  __typename: 'ProposalRoles';
  create: UserPermission;
  edit: UserPermission;
};

export enum ProposalStatus {
  APPROVED = 'APPROVED',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  IMPLEMENTED = 'IMPLEMENTED',
  OPEN = 'OPEN'
}

export type ProposalSyncToLaunchesResult = PermissionError | ProposalSyncToLaunchesSuccess;

export type ProposalSyncToLaunchesSuccess = {
  __typename: 'ProposalSyncToLaunchesSuccess';
  proposal: Proposal;
  /** True if the proposal was updated due to the sync, false if the proposal was already up-to-date and nothing was done. */
  updated: Scalars['Boolean']['output'];
};

export type ProposalVariantCreationErrors = {
  __typename: 'ProposalVariantCreationErrors';
  /** A list of all errors that occurred when attempting to create a proposal variant. */
  errorMessages: Array<Scalars['String']['output']>;
};

export type ProposalVariantCreationResult = GraphVariant | ProposalVariantCreationErrors;

export type ProposalsCheckTask = CheckWorkflowTask & {
  __typename: 'ProposalsCheckTask';
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  /** The results of this proposal check were overridden */
  didOverrideProposalsCheckTask: Scalars['Boolean']['output'];
  /** Diff items in this Check task. Will be empty list if hasExceededMaxDiffs is true. */
  diffs: Array<ProposalsCheckTaskDiff>;
  graphID: Scalars['ID']['output'];
  /** Indicates if the number of diffs in this check has exceeded the maximum allowed. null if this check was run before this field was added. */
  hasExceededMaxDiffs: Maybe<Scalars['Boolean']['output']>;
  /** True if this Proposal check passed with warnings, otherwise false. */
  hasWarnings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Indicates the level of coverage a check's changeset is in approved Proposals. PENDING while Check is still running. */
  proposalCoverage: ProposalCoverage;
  /** Proposals with their state at the time the check was run associated to this check task. */
  relatedProposalResults: Array<RelatedProposalResult>;
  /** @deprecated use relatedProposalResults instead */
  relatedProposals: Array<Proposal>;
  /** The configured severity at the time the check was run. If the check failed, this is the severity that should be shown. While this Check is PENDING defaults to Service's severityLevel. */
  severityLevel: ProposalChangeMismatchSeverity;
  status: CheckWorkflowTaskStatus;
  targetURL: Maybe<Scalars['String']['output']>;
  workflow: CheckWorkflow;
};

/** A diff item in this Check Task and their related Proposals. */
export type ProposalsCheckTaskDiff = {
  __typename: 'ProposalsCheckTaskDiff';
  /** A diff item in this Check Task. */
  diffItem: FlatDiffItem;
  /** If this diff item is associated with an approved Proposal. */
  hasApprovedProposal: Scalars['Boolean']['output'];
  /** Proposals associated with this diff. */
  relatedProposalResults: Array<RelatedProposalResult>;
  /** The subgraph this diff belongs to. */
  subgraph: Scalars['String']['output'];
};

/** Filtering options for list of proposals. */
export type ProposalsFilterInput = {
  /** Only include proposals that were created with these variants as a base. */
  sourceVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only include proposals of a certain status. */
  status?: InputMaybe<Array<ProposalStatus>>;
  /** Only include proposals that have updated these subgraph names */
  subgraphs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProposalsMustBeApprovedByADefaultReviewerResult = PermissionError | Service | ValidationError;

/** Proposals, limited & offset based on Service.proposals & the total count */
export type ProposalsResult = {
  __typename: 'ProposalsResult';
  /** The proposals on this graph. */
  proposals: Array<Proposal>;
  /** The total number of proposals on this graph */
  totalCount: Scalars['Int']['output'];
};

export type ProposedBuildInputChanges = ProposedCompositionBuildInputChanges | ProposedFilterBuildInputChanges;

export type ProposedCompositionBuildInputChanges = {
  __typename: 'ProposedCompositionBuildInputChanges';
  /** The proposed new build pipeline track, or null if no such change was proposed. */
  buildPipelineTrackChange: Maybe<BuildPipelineTrack>;
  /** The proposed new Federation version, or null if no such change was proposed. */
  proposedFederationVersion: Maybe<Scalars['FederationVersion']['output']>;
  /** Any proposed upserts to subgraphs, or the empty list if no such changes were proposed. */
  subgraphUpserts: Array<ProposedCompositionBuildInputSubgraphUpsert>;
};

export type ProposedCompositionBuildInputSubgraphUpsert = {
  __typename: 'ProposedCompositionBuildInputSubgraphUpsert';
  /** The name of the subgraph changed in this subgraph upsert. */
  name: Scalars['String']['output'];
  /** The SHA-256 of the schema document in this subgraph upsert. */
  schemaHash: Maybe<Scalars['SHA256']['output']>;
};

export type ProposedFilterBuildInputChanges = {
  __typename: 'ProposedFilterBuildInputChanges';
  /** The proposed new build pipeline track, or null if no such change was proposed. */
  buildPipelineTrackChange: Maybe<BuildPipelineTrack>;
  /** Any proposed additions to exclude filters, or the empty list if no such changes were proposed. */
  excludeAdditions: Array<Scalars['String']['output']>;
  /** Any proposed removals to exclude filters, or the empty list if no such changes were proposed. */
  excludeRemovals: Array<Scalars['String']['output']>;
  /** The proposed value for whether to hide unreachable schema elements, or null if no such change was proposed. */
  hideUnreachableTypesChange: Maybe<Scalars['Boolean']['output']>;
  /** Any proposed additions to include filters, or the empty list if no such changes were proposed. */
  includeAdditions: Array<Scalars['String']['output']>;
  /** Any proposed removals to include filters, or the empty list if no such changes were proposed. */
  includeRemovals: Array<Scalars['String']['output']>;
  /** The proposed new Federation version, or null if no such change was proposed. */
  proposedFederationVersion: Maybe<Scalars['FederationVersion']['output']>;
  /** The proposed new build pipeline track, or null if no such change was proposed. */
  supergraphSchemaHashChange: Maybe<Scalars['SHA256']['output']>;
};

export type Protobuf = {
  __typename: 'Protobuf';
  json: Scalars['String']['output'];
  object: Scalars['Object']['output'];
  raw: Scalars['Blob']['output'];
  text: Scalars['String']['output'];
};

/** The result of a successful call to PersistedQueryListMutation.publishOperations. */
export type PublishOperationsResult = {
  __typename: 'PublishOperationsResult';
  /** The build created by this publish operation. */
  build: PersistedQueryListBuild;
  /** Returns `true` if no changes were made by this publish (and no new revision was created). Otherwise, returns `false`. */
  unchanged: Scalars['Boolean']['output'];
};

/** The result/error union returned by PersistedQueryListMutation.publishOperations. */
export type PublishOperationsResultOrError = CannotModifyOperationBodyError | PermissionError | PublishOperationsResult;

export type PublishProposalSubgraphResult = NotFoundError | PermissionError | Proposal | SchemaValidationError | ValidationError;

export type PublishProposalSubgraphsInput = {
  gitContext?: InputMaybe<GitContextInput>;
  /** Non null if this publish is a merge revision. The composition id of the source variant updated to. This is necessary to keep track of the last composition id this proposal is updated with. */
  mergeUpdateCompositionId?: InputMaybe<Scalars['ID']['input']>;
  previousLaunchId: Scalars['ID']['input'];
  revision: Scalars['String']['input'];
  subgraphInputs: Array<PublishSubgraphsSubgraphInput>;
  summary: Scalars['String']['input'];
};

/** The result attempting to publish subgraphs with async build. */
export type PublishSubgraphsAsyncBuildResult = {
  __typename: 'PublishSubgraphsAsyncBuildResult';
  /** The Launch result part of this subgraph publish. */
  launch: Maybe<Launch>;
  /** Human-readable text describing the launch result of the subgraph publish. */
  launchCliCopy: Maybe<Scalars['String']['output']>;
  /** The URL of the Studio page for this update's associated launch, if available. */
  launchUrl: Maybe<Scalars['String']['output']>;
};

export type PublishSubgraphsSubgraphInput = {
  activePartialSchema: PartialSchemaInput;
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PushMarketoLeadInput = {
  /** Clearbit enriched LinkedIn URL */
  Clearbit_LinkedIn_URL__c?: InputMaybe<Scalars['String']['input']>;
  /** Company domain */
  Company_Domain__c?: InputMaybe<Scalars['String']['input']>;
  /** GDPR Explicit Opt in */
  Explicit_Opt_in__c?: InputMaybe<Scalars['Boolean']['input']>;
  /** Google Click ID */
  Google_Click_ID__c?: InputMaybe<Scalars['String']['input']>;
  /** GA Client ID */
  Google_User_ID__c?: InputMaybe<Scalars['String']['input']>;
  /** GraphQL Production Stage */
  GraphQL_Production_Stage__c?: InputMaybe<Scalars['String']['input']>;
  /** Job Function */
  Job_Function__c?: InputMaybe<Scalars['String']['input']>;
  /** Lead Message */
  Lead_Message__c?: InputMaybe<Scalars['String']['input']>;
  /** Lead Source Detail */
  Lead_Source_Detail__c?: InputMaybe<Scalars['String']['input']>;
  /** Lead Source Most Recent Detail */
  Lead_Source_Most_Recent_Detail__c?: InputMaybe<Scalars['String']['input']>;
  /** Lead Source Most Recent */
  Lead_Source_Most_Recent__c?: InputMaybe<Scalars['String']['input']>;
  /** Referrer */
  Referrer__c?: InputMaybe<Scalars['String']['input']>;
  /** Studio Organization ID */
  Studio_Organization_ID__c?: InputMaybe<Scalars['String']['input']>;
  /** Studio User Id */
  Studio_User_Id__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Campaign First Touch */
  UTM_Campaign_First_Touch__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Campaign */
  UTM_Campaign__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM ICID */
  UTM_ICID__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Medium First Touch */
  UTM_Medium_First_Touch__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Medium */
  UTM_Medium__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Source First Touch */
  UTM_Source_First_Touch__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Source */
  UTM_Source__c?: InputMaybe<Scalars['String']['input']>;
  /** UTM Term */
  UTM_Term__c?: InputMaybe<Scalars['String']['input']>;
  /** Company name */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Is Graph Champion */
  isGraphChampion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notes Import */
  notesImport?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** UTM Campaign Capture Mkto Only */
  uTMCampaignCaptureMktoOnly?: InputMaybe<Scalars['String']['input']>;
  /** UTM ICID Capture Mkto Only */
  uTMICIDCaptureMktoOnly?: InputMaybe<Scalars['String']['input']>;
  /** UTM Medium Capture Mkto Only */
  uTMMediumCaptureMktoOnly?: InputMaybe<Scalars['String']['input']>;
  /** UTM Source Capture Mkto Only */
  uTMSourceCaptureMktoOnly?: InputMaybe<Scalars['String']['input']>;
  /** UTM Term Capture Mkto Only */
  uTMTermCaptureMktoOnly?: InputMaybe<Scalars['String']['input']>;
};

/** Queries defined by this subgraph */
export type Query = {
  __typename: 'Query';
  /** Account by ID */
  account: Maybe<Account>;
  /** Retrieve account by billing provider identifier */
  accountByBillingCode: Maybe<Account>;
  /** Retrieve account by internal id */
  accountByInternalID: Maybe<Account>;
  /** Whether an account ID is available for mutation{newAccount(id:)} */
  accountIDAvailable: Scalars['Boolean']['output'];
  /** Returns details of the agent gateway with the provided ID.  Currently requires the associated account ID for this gateway, which may be removed as a requirement in the future. */
  agentGateway: Maybe<AgentGateway>;
  /** All accounts */
  allAccounts: Maybe<Array<Account>>;
  /** Returns all active rule enforcements across all accounts. Restricted to internal Apollo admins. */
  allActiveRuleEnforcements: Array<RuleEnforcement>;
  /** All accounts on team billable plans with active subscriptions */
  allActiveTeamBillingAccounts: Maybe<Array<Account>>;
  /** All available billing plan capabilities */
  allBillingCapabilities: Array<BillingCapability>;
  /** All available billing plan limits */
  allBillingLimits: Array<BillingLimit>;
  /** All available plans */
  allBillingPlans: Array<BillingPlan>;
  allPublicVariants: Maybe<Array<GraphVariant>>;
  /** All auto-renewing team accounts on active annual plans */
  allRenewingNonEnterpriseAnnualAccounts: Maybe<Array<Account>>;
  /** All router entitlements for self-hosted commercial runtime accounts. */
  allSelfHostedCommercialRuntimeEntitlements: RouterEntitlementConnection;
  /** All services */
  allServices: Maybe<Array<Service>>;
  /** All timezones with their offsets from UTC */
  allTimezoneOffsets: Array<TimezoneOffset>;
  /** All users */
  allUsers: Maybe<Array<User>>;
  billingAdmin: Maybe<BillingAdminQuery>;
  /** Retrieves all past and current subscriptions for an account, even if the account has been deleted */
  billingSubscriptionHistory: Array<Maybe<BillingSubscription>>;
  billingTier: Maybe<BillingTier>;
  /** If this is true, the user is an Apollo administrator who can ignore restrictions based purely on billing plan. */
  canBypassPlanRestrictions: Scalars['Boolean']['output'];
  /** Cloud queries */
  cloud: Cloud;
  cloudTesting: CloudTesting;
  /** Escaped JSON string of the public key used for verifying entitlement JWTs */
  commercialRuntimePublicKey: Scalars['String']['output'];
  /** Fields that back Connector-related MCP tools */
  connectorTools: ConnectorTools;
  currentAccountId: Maybe<Scalars['ID']['output']>;
  diffSchemas: Array<Change>;
  /** Access documentation pages and search functionality */
  documentation: Documentation;
  /** Get the unsubscribe settings for a given email. */
  emailPreferences: Maybe<EmailPreferences>;
  /** Past and current enterprise trial accounts */
  enterpriseTrialAccounts: Maybe<Array<Account>>;
  /** Returns the root URL of the Apollo Studio frontend. */
  frontendUrlRoot: Scalars['String']['output'];
  /** Returns details of the graph with the provided ID. */
  graph: Maybe<Service>;
  /** Get the graph artifact associated with a given digest (SHA) */
  graphArtifactByDigest: Maybe<GraphArtifact>;
  /** Get Graph Artifact by Graph Artifact ID */
  graphArtifactById: Maybe<GraphArtifact>;
  /** Get the Graph Artifact associated with the provided tag */
  graphArtifactByTag: Maybe<GraphArtifact>;
  /** Get a specific graph artifact tag */
  graphArtifactTag: Maybe<GraphArtifactTag>;
  /** Get the repository and tag name for the given variant */
  graphArtifactTagLocation: Maybe<GraphArtifactTagLocation>;
  /** Get the list of graph artifact tags associated with a given graph */
  graphArtifactTags: GraphArtifactTagConnection;
  /** All the graph artifacts associated with a given graphId */
  graphArtifacts: GraphArtifactConnection;
  internalActiveCronJobs: Array<CronJob>;
  internalAdminUsers: Maybe<Array<InternalAdminUser>>;
  internalUnresolvedCronExecutionFailures: Array<CronExecution>;
  isLoggedIn: Maybe<Scalars['Boolean']['output']>;
  /** Returns details of the authenticated `User` or `Graph` executing this query. If this is an unauthenticated query (i.e., no API key is provided), this field returns null. */
  me: Maybe<Identity>;
  /** Retrieve a specific Odyssey certification by its ID */
  odysseyCertification: Maybe<OdysseyCertification>;
  /** Access course feedback queries */
  odysseyCourseFeedback: OdysseyCourseFeedbackQueries;
  /** Returns the [operation collection](https://www.apollographql.com/docs/studio/explorer/operation-collections/) for the provided ID. This field accepts up to 400 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  operationCollection: OperationCollectionResult;
  /** This field accepts up to 400 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  operationCollectionEntries: Array<OperationCollectionEntry>;
  /** Returns details of the Studio organization with the provided ID. */
  organization: Maybe<Account>;
  /**
   * Unowned interactive DCR agent apps registered before `createdBefore`.
   * The organization is taken from the caller's credential.
   */
  orphanedAgentApps: ApplicationPage;
  /** Look up a plan by ID */
  plan: Maybe<BillingPlan>;
  /** Returns a proposal by its ID. This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  proposal: Maybe<Proposal>;
  /** A list of public variants that have been selected to be shown on our Graph Directory. */
  publiclyListedVariants: Maybe<Array<GraphVariant>>;
  /** Accounts with enterprise subscriptions that have expired in the past 45 days */
  recentlyExpiredEnterpriseAccounts: Maybe<Array<Account>>;
  recommendedPlanOnSignup: Maybe<OnboardingPlanOption>;
  /** Search all accounts */
  searchAccounts: Array<Account>;
  /** Service by ID */
  service: Maybe<Service>;
  /** Returns all service connectors in the catalog. */
  serviceCatalog: ServiceCatalogPage;
  /**
   * Latest version per service, ignoring org-visibility — every entry,
   * including org-restricted ones. For the admin catalog UI's list view,
   * which must see restricted entries to manage their access grants.
   */
  serviceCatalogAdmin: ServiceCatalogPage;
  /** Returns all active catalog entries for a given service connector. */
  serviceCatalogEntries: Array<ServiceCatalogType>;
  /** Returns a single service catalog entry by its ID. */
  serviceCatalogEntry: ServiceCatalogType;
  /**
   * All active (non-deleted) versions for a service, newest first. No
   * org-visibility filtering — for the admin catalog UI's version-history
   * view, which must see restricted entries' history too.
   */
  serviceCatalogVersions: Array<ServiceCatalogType>;
  /** Accounts with enterprise subscriptions that will expire within the next 30 days */
  soonToExpireEnterpriseAccounts: Maybe<Array<Account>>;
  sso: SsoQuery;
  /** Returns the SSO login url for an account with SSO configured. */
  ssoLoginUrl: Maybe<Scalars['String']['output']>;
  /** Query statistics across all services. For admins only; normal users must go through AccountsStatsWindow or ServiceStatsWindow. */
  stats: StatsWindow;
  /** Get the studio settings for the current user */
  studioSettings: Maybe<UserSettings>;
  /** Schema transformation for the Apollo platform API. Renames types. Internal to Apollo. */
  transformSchemaForPlatformApi: Maybe<Scalars['GraphQLDocument']['output']>;
  /** Returns details of the Apollo user with the provided ID. */
  user: Maybe<User>;
  /** Returns details of the Apollo users with the provided IDs. */
  users: Maybe<Array<User>>;
  /** Returns details of a Studio graph variant with the provided graph ref. A graph ref has the format `graphID@variantName` (or just `graphID` for the default variant `current`). Returns null if the graph or variant doesn't exist, or if the graph isn't accessible by the current actor. */
  variant: Maybe<GraphVariantLookup>;
};


/** Queries defined by this subgraph */
export type QueryaccountArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryaccountByBillingCodeArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryaccountByInternalIDArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryaccountIDAvailableArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryagentGatewayArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryallAccountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<BillingPlanTier>;
};


/** Queries defined by this subgraph */
export type QueryallSelfHostedCommercialRuntimeEntitlementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries defined by this subgraph */
export type QueryallServicesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Queries defined by this subgraph */
export type QueryallUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Queries defined by this subgraph */
export type QuerybillingSubscriptionHistoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries defined by this subgraph */
export type QuerybillingTierArgs = {
  tier: BillingPlanTier;
};


/** Queries defined by this subgraph */
export type QuerydiffSchemasArgs = {
  baseSchema: Scalars['String']['input'];
  nextSchema: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QueryemailPreferencesArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactByDigestArgs = {
  digest: Scalars['String']['input'];
  graphID: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactByIdArgs = {
  graphID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactByTagArgs = {
  graphID: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactTagArgs = {
  graphID: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactTagLocationArgs = {
  graphID: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  graphID: Scalars['ID']['input'];
  variantName?: InputMaybe<Scalars['String']['input']>;
};


/** Queries defined by this subgraph */
export type QuerygraphArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  graphID: Scalars['ID']['input'];
  variantName?: InputMaybe<Scalars['String']['input']>;
};


/** Queries defined by this subgraph */
export type QueryodysseyCertificationArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryoperationCollectionArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryoperationCollectionEntriesArgs = {
  collectionEntryIds: Array<Scalars['ID']['input']>;
};


/** Queries defined by this subgraph */
export type QueryorganizationArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryorphanedAgentAppsArgs = {
  createdBefore: Scalars['DateTime']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries defined by this subgraph */
export type QueryplanArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries defined by this subgraph */
export type QueryproposalArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QuerysearchAccountsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Queries defined by this subgraph */
export type QueryserviceArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryserviceCatalogArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries defined by this subgraph */
export type QueryserviceCatalogAdminArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Queries defined by this subgraph */
export type QueryserviceCatalogEntriesArgs = {
  serviceId: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QueryserviceCatalogEntryArgs = {
  id: Scalars['UUID']['input'];
};


/** Queries defined by this subgraph */
export type QueryserviceCatalogVersionsArgs = {
  serviceId: Scalars['String']['input'];
};


/** Queries defined by this subgraph */
export type QueryssoLoginUrlArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};


/** Queries defined by this subgraph */
export type QuerystatsArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** Queries defined by this subgraph */
export type QuerytransformSchemaForPlatformApiArgs = {
  baseSchema: Scalars['GraphQLDocument']['input'];
};


/** Queries defined by this subgraph */
export type QueryuserArgs = {
  id: Scalars['ID']['input'];
};


/** Queries defined by this subgraph */
export type QueryusersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Queries defined by this subgraph */
export type QueryvariantArgs = {
  ref: Scalars['ID']['input'];
};

/** query documents to validate against */
export type QueryDocumentInput = {
  document?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlan = {
  __typename: 'QueryPlan';
  json: Scalars['String']['output'];
  object: Scalars['Object']['output'];
  text: Scalars['String']['output'];
};

/** Columns of QueryStats. */
export enum QueryStatsColumn {
  ACCOUNT_ID = 'ACCOUNT_ID',
  CACHED_HISTOGRAM = 'CACHED_HISTOGRAM',
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CACHE_TTL_HISTOGRAM = 'CACHE_TTL_HISTOGRAM',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  FORBIDDEN_OPERATION_COUNT = 'FORBIDDEN_OPERATION_COUNT',
  FROM_ENGINEPROXY = 'FROM_ENGINEPROXY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PERSISTED_QUERY_ID = 'PERSISTED_QUERY_ID',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REGISTERED_OPERATION_COUNT = 'REGISTERED_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_HISTOGRAM = 'UNCACHED_HISTOGRAM',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type QueryStatsDimensions = {
  __typename: 'QueryStatsDimensions';
  accountId: Maybe<Scalars['ID']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fromEngineproxy: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  persistedQueryId: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  querySignatureLength: Maybe<Scalars['Int']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in QueryStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type QueryStatsFilter = {
  /** Selects rows whose accountId dimension equals the given value if not null. To query for the null value, use {in: {accountId: [null]}} instead. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  and?: InputMaybe<Array<QueryStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fromEngineproxy dimension equals the given value if not null. To query for the null value, use {in: {fromEngineproxy: [null]}} instead. */
  fromEngineproxy?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<QueryStatsFilterIn>;
  not?: InputMaybe<QueryStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<QueryStatsFilter>>;
  /** Selects rows whose persistedQueryId dimension equals the given value if not null. To query for the null value, use {in: {persistedQueryId: [null]}} instead. */
  persistedQueryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in QueryStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type QueryStatsFilterIn = {
  /** Selects rows whose accountId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  accountId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fromEngineproxy dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fromEngineproxy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose persistedQueryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  persistedQueryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryStatsMetrics = {
  __typename: 'QueryStatsMetrics';
  cacheTtlHistogram: DurationHistogram;
  cachedHistogram: DurationHistogram;
  cachedRequestsCount: Scalars['Long']['output'];
  forbiddenOperationCount: Scalars['Long']['output'];
  registeredOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
  totalLatencyHistogram: DurationHistogram;
  totalRequestCount: Scalars['Long']['output'];
  uncachedHistogram: DurationHistogram;
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type QueryStatsOrderBySpec = {
  column: QueryStatsColumn;
  direction: Ordering;
};

export type QueryStatsRecord = {
  __typename: 'QueryStatsRecord';
  /** Dimensions of QueryStats that can be grouped by. */
  groupBy: QueryStatsDimensions;
  /** Metrics of QueryStats that can be aggregated over. */
  metrics: QueryStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Query Trigger */
export type QueryTrigger = ChannelSubscription & {
  __typename: 'QueryTrigger';
  channels: Array<Channel>;
  comparisonOperator: ComparisonOperator;
  enabled: Scalars['Boolean']['output'];
  excludedOperationNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metric: QueryTriggerMetric;
  operationNames: Array<Scalars['String']['output']>;
  percentile: Maybe<Scalars['Float']['output']>;
  scope: QueryTriggerScope;
  serviceId: Scalars['String']['output'];
  state: QueryTriggerState;
  threshold: Scalars['Float']['output'];
  variant: Maybe<Scalars['String']['output']>;
  window: QueryTriggerWindow;
};

/** Query trigger */
export type QueryTriggerInput = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  comparisonOperator: ComparisonOperator;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  excludedOperationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  metric: QueryTriggerMetric;
  operationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  percentile?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<QueryTriggerScope>;
  threshold: Scalars['Float']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
  window: QueryTriggerWindow;
};

export enum QueryTriggerMetric {
  /** Number of requests within the window that resulted in an error. Ignores `percentile`. */
  ERROR_COUNT = 'ERROR_COUNT',
  /** Number of error requests divided by total number of requests. Ignores `percentile`. */
  ERROR_PERCENTAGE = 'ERROR_PERCENTAGE',
  /** Number of requests within the window. Ignores `percentile`. */
  REQUEST_COUNT = 'REQUEST_COUNT',
  /** Request latency in ms. Requires `percentile`. */
  REQUEST_SERVICE_TIME = 'REQUEST_SERVICE_TIME'
}

export enum QueryTriggerScope {
  ALL = 'ALL',
  ANY = 'ANY',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Query trigger state */
export type QueryTriggerState = {
  __typename: 'QueryTriggerState';
  evaluatedAt: Scalars['Timestamp']['output'];
  lastTriggeredAt: Maybe<Scalars['Timestamp']['output']>;
  operations: Array<QueryTriggerStateOperation>;
  triggered: Scalars['Boolean']['output'];
};

export type QueryTriggerStateOperation = {
  __typename: 'QueryTriggerStateOperation';
  count: Scalars['Long']['output'];
  operation: Scalars['String']['output'];
  triggered: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export enum QueryTriggerWindow {
  FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
  FIVE_MINUTES = 'FIVE_MINUTES',
  ONE_MINUTE = 'ONE_MINUTE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** A single question-answer pair within a feedback submission */
export type QuestionResponse = {
  __typename: 'QuestionResponse';
  /** The answer provided by the learner */
  answer: Scalars['String']['output'];
  /** The question text at the time of submission */
  question: Scalars['String']['output'];
  /** The stable identifier for the question */
  questionId: Scalars['ID']['output'];
};

/** A single question-answer pair within a feedback submission */
export type QuestionResponseInput = {
  /** The answer provided by the learner */
  answer: Scalars['String']['input'];
  /** The stable identifier for the question being answered */
  questionId: Scalars['ID']['input'];
};

/** Result of calling a test request to a custom check endpoint. */
export type QueueTestCustomChecksRequestResult = GraphVariant | PermissionError | ValidationError;

export type QueueTestProposalLifecycleNotificationError = {
  __typename: 'QueueTestProposalLifecycleNotificationError';
  message: Scalars['String']['output'];
};

export type QueueTestProposalLifecycleNotificationInput = {
  channelId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type QueueTestProposalLifecycleNotificationResult = NotFoundError | PermissionError | QueueTestProposalLifecycleNotificationError | QueueTestProposalLifecycleNotificationSuccess | ValidationError;

export type QueueTestProposalLifecycleNotificationSuccess = {
  __typename: 'QueueTestProposalLifecycleNotificationSuccess';
  queued: Maybe<Scalars['Boolean']['output']>;
};

export type RateLimit = {
  __typename: 'RateLimit';
  count: Scalars['Long']['output'];
  durationMs: Scalars['Long']['output'];
};

/** An error that occurs when the rate limit on this operation has been exceeded. */
export type RateLimitExceededError = {
  __typename: 'RateLimitExceededError';
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Input for re-running schema checks on a proposal revision. */
export type ReRunCheckForRevisionInput = {
  /** The ID of the proposal revision whose schema checks should be re-run. */
  revisionId: Scalars['ID']['input'];
};

/** The result of re-running schema checks for a proposal revision. */
export type ReRunCheckForRevisionResult = NotFoundError | PermissionError | Proposal | ValidationError;

/** The README documentation for a graph variant, which is displayed in Studio. */
export type Readme = {
  __typename: 'Readme';
  /** The contents of the README in plaintext. */
  content: Scalars['String']['output'];
  /** The README's unique ID. `a15177c0-b003-4837-952a-dbfe76062eb1` for the default README */
  id: Scalars['ID']['output'];
  /**
   * The timestamp when the README was most recently updated. `1970-01-01T00:00:00Z` for the default README
   * @deprecated Deprecated in favour of lastUpdatedTime
   */
  lastUpdatedAt: Scalars['Timestamp']['output'];
  /** The actor that most recently updated the README (usually a `User`). `null` for the default README, or if the `User` was deleted. */
  lastUpdatedBy: Maybe<Identity>;
  /** The timestamp when the README was most recently updated. `null` for the default README */
  lastUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
};

/** Responsibility for an errored order */
export enum ReasonCause {
  /**
   * Could not complete an order due to internal reason
   *
   * This could be due to intermittent issues, bug in our code, etc.
   */
  INTERNAL = 'INTERNAL',
  /**
   * Could not complete an order due to invalid User input
   *
   * For example, the user provided an invalid router configuration or supergraph schema.
   */
  USER = 'USER'
}

export type RebaseConflict = {
  __typename: 'RebaseConflict';
  location: Maybe<ParsedSchemaCoordinate>;
  message: Maybe<Scalars['String']['output']>;
};

export type RebaseConflictData = {
  __typename: 'RebaseConflictData';
  conflicts: Array<RebaseConflict>;
  count: Scalars['Int']['output'];
};

export type RebaseConflictResult = NotFoundError | RebaseConflictData | SchemaValidationError;

/** Represents a recently visited page with its URL and access time */
export type RecentPage = {
  __typename: 'RecentPage';
  /** When the page was last accessed */
  timestamp: Scalars['Timestamp']['output'];
  /** The URL of the recently visited page */
  url: Scalars['String']['output'];
};

/** Input for `recordAccessRequestDecision`. */
export type RecordAccessRequestDecisionInput = {
  /**
   * Fields explicitly approved by the caller. Required on `APPROVE`, must
   * be null on `DENY` (enforced by the DB layer).
   */
  approvedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Approve or deny. */
  decision: AccessRequestDecisionKind;
  /** Optional caller-facing note (e.g. denial rationale). */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The access request to record a decision against. */
  requestId: Scalars['UUID']['input'];
};

/** Input for `recordAgentAppPrincipal`. */
export type RecordAgentAppPrincipalInput = {
  /** Identifier of the Agent App this principal used. */
  agentAppId: Scalars['UUID']['input'];
  /** Human-readable name of the OAuth client, if the client supplied one. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Email address, if the identity provider supplied one. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Group names from the JWT. Recorded into an org-scoped vocabulary for
   * future policy-authoring autocomplete — never stored on the principal
   * itself, since stale group membership must not look authoritative.
   */
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The token's own Keycloak subject (realm-local id), distinct from
   * `value` when a primary IdP subject is present.
   */
  keycloakSub?: InputMaybe<Scalars['String']['input']>;
  /** How this principal is identified. */
  kind: AgentAppPrincipalKind;
  /** Display name, if the identity provider supplied one. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** OAuth client identifier bound to the Agent App. */
  oauthClientId: Scalars['String']['input'];
  /**
   * Subject identifier at the primary identity provider, if present.
   * Retained for older callers that still send it separately; `value`
   * already folds it in via `primary_idp_sub || sub`.
   */
  primaryIdpSub?: InputMaybe<Scalars['String']['input']>;
  /**
   * Identifier value for this kind. For an OIDC subject, this is the
   * canonical policy principal: `primary_idp_sub || sub` (the primary
   * identity provider's subject if the token carried one, otherwise the
   * Keycloak `sub`). Principal-scoped policies key on this field.
   */
  value: Scalars['String']['input'];
};

/** Details of account data stored in Recurly */
export type RecurlyAccountDetails = {
  __typename: 'RecurlyAccountDetails';
  accountCode: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
};

/** Description for a Cloud Router region */
export type RegionDescription = {
  __typename: 'RegionDescription';
  /** Region identifier */
  code: Scalars['String']['output'];
  /** Country of the region, in ISO 3166-1 alpha-2 code */
  country: Scalars['String']['output'];
  /** Full name of the region */
  name: Scalars['String']['output'];
  /** Cloud Provider related to this region */
  provider: CloudProvider;
  /** State of the Region */
  state: RegionState;
};

/** Possible state of a region */
export enum RegionState {
  /**
   * Active region
   *
   * Can be used for Cloud Routers
   */
  ACTIVE = 'ACTIVE',
  /** Does not appear in the API */
  HIDDEN = 'HIDDEN',
  /**
   * Inactive region
   *
   * Cannot yet be used for Cloud Routers
   */
  INACTIVE = 'INACTIVE'
}

export type RegisterOperationsMutationResponse = {
  __typename: 'RegisterOperationsMutationResponse';
  invalidOperations: Maybe<Array<InvalidOperation>>;
  newOperations: Maybe<Array<RegisteredOperation>>;
  registrationSuccess: Scalars['Boolean']['output'];
};

export type RegisteredClientIdentityInput = {
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredOperation = {
  __typename: 'RegisteredOperation';
  signature: Scalars['ID']['output'];
};

export type RegisteredOperationInput = {
  document?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<RegisteredOperationMetadataInput>;
  signature: Scalars['ID']['input'];
};

export type RegisteredOperationMetadataInput = {
  /** This will be used to link existing records in Engine to a new ID. */
  engineSignature?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryStatsWindow = {
  __typename: 'RegistryStatsWindow';
  schemaCheckStats: Array<AccountChecksStatsRecord>;
  schemaPublishStats: Array<AccountPublishesStatsRecord>;
};

export type RegistrySubscription = ChannelSubscription & {
  __typename: 'RegistrySubscription';
  channel: Maybe<Channel>;
  /** @deprecated Use channels list instead */
  channels: Array<Channel>;
  createdAt: Scalars['Timestamp']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  options: SubscriptionOptions;
  variant: Maybe<Scalars['String']['output']>;
};

/** A Proposal related to a Proposal Check Task. */
export type RelatedProposalResult = {
  __typename: 'RelatedProposalResult';
  /** The latest revision at the time the check was run, defaults to current revision if nothing found for time of the check. */
  latestRevisionAtCheck: ProposalRevision;
  /** The Proposal related to the check. State may have changed since the Check was run. */
  proposal: Proposal;
  /** The status of the Proposal at the time the check was run, defaults to current state if nothing found for time of the check. */
  statusAtCheck: ProposalStatus;
};

export type RelaunchComplete = {
  __typename: 'RelaunchComplete';
  latestLaunch: Launch;
  updated: Scalars['Boolean']['output'];
};

export type RelaunchError = {
  __typename: 'RelaunchError';
  message: Scalars['String']['output'];
};

export type RelaunchResult = RelaunchComplete | RelaunchError;

export type RemoveOperationCollectionEntryResult = OperationCollection | PermissionError;

export type RemoveOperationCollectionFromVariantResult = GraphVariant | NotFoundError | PermissionError | ValidationError;

export type ReplaceReviewersWithDefaultReviewersResult = PermissionError | Proposal | ValidationError;

export type ReplyChangeProposalComment = ChangeProposalComment & ProposalComment & {
  __typename: 'ReplyChangeProposalComment';
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** true if the schemaCoordinate this comment is on doesn't exist in the diff between the most recent revision & the base sdl */
  outdated: Scalars['Boolean']['output'];
  schemaCoordinate: Scalars['String']['output'];
  /** '#@!api!@#' for api schema, '#@!supergraph!@#' for supergraph schema, subgraph otherwise */
  schemaScope: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type ReplyGeneralProposalComment = GeneralProposalComment & ProposalComment & {
  __typename: 'ReplyGeneralProposalComment';
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Input for reporting one or more diff items as false positives on a proposal revision. */
export type ReportFalsePositiveDiffItemsInput = {
  /** The individual diff elements being flagged. May be empty when submitting a note-only report. */
  elements: Array<FalsePositiveFlagElementInput>;
  /** Optional free-text note that applies to all elements in this batch. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The revision whose diff contains the suspected false positives. */
  revisionId: Scalars['ID']['input'];
  /** '#@!api!@#' for api schema, '#@!supergraph!@#' for supergraph schema, subgraph otherwise */
  schemaScope: Scalars['String']['input'];
};

/** The result of reporting one or more diff items as false positives on a proposal revision. */
export type ReportFalsePositiveDiffItemsResult = NotFoundError | PermissionError | ReportFalsePositiveDiffItemsSuccess | ValidationError;

/** Returned when false positive flags were recorded successfully. */
export type ReportFalsePositiveDiffItemsSuccess = {
  __typename: 'ReportFalsePositiveDiffItemsSuccess';
  /** IDs of the flag rows that were newly inserted (empty list means all were duplicates). */
  flagIds: Array<Scalars['ID']['output']>;
};

export type ReportSchemaError = ReportSchemaResult & {
  __typename: 'ReportSchemaError';
  code: ReportSchemaErrorCode;
  inSeconds: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  withCoreSchema: Scalars['Boolean']['output'];
};

export enum ReportSchemaErrorCode {
  BOOT_ID_IS_NOT_VALID_UUID = 'BOOT_ID_IS_NOT_VALID_UUID',
  BOOT_ID_IS_REQUIRED = 'BOOT_ID_IS_REQUIRED',
  CORE_SCHEMA_HASH_IS_NOT_SCHEMA_SHA256 = 'CORE_SCHEMA_HASH_IS_NOT_SCHEMA_SHA256',
  CORE_SCHEMA_HASH_IS_REQUIRED = 'CORE_SCHEMA_HASH_IS_REQUIRED',
  CORE_SCHEMA_HASH_IS_TOO_LONG = 'CORE_SCHEMA_HASH_IS_TOO_LONG',
  EXECUTABLE_SCHEMA_ID_IS_NOT_SCHEMA_SHA256 = 'EXECUTABLE_SCHEMA_ID_IS_NOT_SCHEMA_SHA256',
  EXECUTABLE_SCHEMA_ID_IS_REQUIRED = 'EXECUTABLE_SCHEMA_ID_IS_REQUIRED',
  EXECUTABLE_SCHEMA_ID_IS_TOO_LONG = 'EXECUTABLE_SCHEMA_ID_IS_TOO_LONG',
  GRAPH_REF_INVALID_FORMAT = 'GRAPH_REF_INVALID_FORMAT',
  GRAPH_REF_IS_REQUIRED = 'GRAPH_REF_IS_REQUIRED',
  GRAPH_VARIANT_DOES_NOT_MATCH_REGEX = 'GRAPH_VARIANT_DOES_NOT_MATCH_REGEX',
  GRAPH_VARIANT_IS_REQUIRED = 'GRAPH_VARIANT_IS_REQUIRED',
  LIBRARY_VERSION_IS_TOO_LONG = 'LIBRARY_VERSION_IS_TOO_LONG',
  PLATFORM_IS_TOO_LONG = 'PLATFORM_IS_TOO_LONG',
  RUNTIME_VERSION_IS_TOO_LONG = 'RUNTIME_VERSION_IS_TOO_LONG',
  SCHEMA_IS_NOT_PARSABLE = 'SCHEMA_IS_NOT_PARSABLE',
  SCHEMA_IS_NOT_VALID = 'SCHEMA_IS_NOT_VALID',
  SERVER_ID_IS_TOO_LONG = 'SERVER_ID_IS_TOO_LONG',
  USER_VERSION_IS_TOO_LONG = 'USER_VERSION_IS_TOO_LONG'
}

export type ReportSchemaResponse = ReportSchemaResult & {
  __typename: 'ReportSchemaResponse';
  inSeconds: Scalars['Int']['output'];
  withCoreSchema: Scalars['Boolean']['output'];
};

export type ReportSchemaResult = {
  inSeconds: Scalars['Int']['output'];
  withCoreSchema: Scalars['Boolean']['output'];
};

export type ReportServerInfoError = ReportServerInfoResult & {
  __typename: 'ReportServerInfoError';
  code: ReportSchemaErrorCode;
  inSeconds: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  withExecutableSchema: Scalars['Boolean']['output'];
};

export type ReportServerInfoResponse = ReportServerInfoResult & {
  __typename: 'ReportServerInfoResponse';
  inSeconds: Scalars['Int']['output'];
  withExecutableSchema: Scalars['Boolean']['output'];
};

export type ReportServerInfoResult = {
  inSeconds: Scalars['Int']['output'];
  withExecutableSchema: Scalars['Boolean']['output'];
};

/** Represents an agent that has reported data to Apollo. */
export type ReportingAgent = {
  __typename: 'ReportingAgent';
  /** The identifier of the reporting agent (e.g., `apollo-router`, `apollo-server-core`). */
  agent: Scalars['String']['output'];
  /** Indicates whether this reporting agent is an Apollo Router. */
  isRouter: Scalars['Boolean']['output'];
  /** The timestamp when this agent was reported to Apollo. */
  reportedAt: Scalars['Timestamp']['output'];
  /** The version of the reporting agent, if provided (e.g., `2.22.1`, `1.0.0-beta`). */
  version: Maybe<Scalars['String']['output']>;
};

export type RequestCountsPerGraphVariant = {
  __typename: 'RequestCountsPerGraphVariant';
  cachedRequestsCount: Scalars['Long']['output'];
  graphID: Scalars['String']['output'];
  uncachedRequestsCount: Scalars['Long']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

export type RerunAsyncInput = {
  sourceVariant?: InputMaybe<Scalars['String']['input']>;
};

export enum Resolution {
  R1D = 'R1D',
  R1H = 'R1H',
  R1M = 'R1M',
  R5M = 'R5M',
  R6H = 'R6H',
  R15M = 'R15M'
}

export enum ResponseHints {
  NONE = 'NONE',
  SAMPLE_RESPONSES = 'SAMPLE_RESPONSES',
  SUBGRAPHS = 'SUBGRAPHS',
  TIMINGS = 'TIMINGS',
  TRACE_TIMINGS = 'TRACE_TIMINGS'
}

export enum ReviewDecision {
  APPROVED = 'APPROVED',
  NOT_APPROVED = 'NOT_APPROVED'
}

export type ReviewProposalComment = ProposalComment & {
  __typename: 'ReviewProposalComment';
  createdAt: Scalars['Timestamp']['output'];
  /** null if the user is deleted */
  createdBy: Maybe<Identity>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  status: CommentStatus;
  /** null if never updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type RoleOverride = {
  __typename: 'RoleOverride';
  /** @deprecated RoleOverride can only be queried via a Graph, so any fields here should instead be selected via the parent object. */
  graph: Service;
  lastUpdatedAt: Scalars['Timestamp']['output'];
  role: UserPermission;
  user: User;
};

export type Router = {
  __typename: 'Router';
  /** Capabilities for this Cloud Router */
  capabilities: Maybe<RouterCapabilities>;
  /** Constants for Cloud Routers */
  constants: CloudConstants;
  /** Date when the Cloud Router was created */
  createdAt: Scalars['NaiveDateTime']['output'];
  /** Order currently modifying this Cloud Router */
  currentOrder: Maybe<Order>;
  /**
   * Custom URLs that can be used to reach the Cloud Router
   *
   * This will be null if the Cloud Router is in a deleted status or does not support custom
   * domains.
   * @deprecated use Router.endpoints instead
   */
  customDomains: Maybe<Array<Scalars['String']['output']>>;
  /** Set of endpoints that can be used to reach a Cloud Router */
  endpoints: RouterEndpoints;
  /**
   * Number of Graph Compute Units (GCUs) associated with this Cloud Router
   *
   * This value is not present for Cloud Routers on the `SERVERLESS` tier.
   */
  gcus: Maybe<Scalars['Int']['output']>;
  /** Return the GraphVariant associated with this Router */
  graphVariant: Maybe<GraphVariant>;
  /** graphRef representing the Cloud Router */
  id: Scalars['ID']['output'];
  /** Internal identifier for a Cloud Router */
  internalId: Maybe<Scalars['ID']['output']>;
  /**
   * Cloud Router version applied for the next launch
   *
   * If this value is not null, any subsequent launch will use this version instead of the
   * current one. This can happen when a new STABLE version is available, but we could not
   * automatically update this Cloud Router, for example due to configuration issues.
   */
  nextRouterVersion: Maybe<RouterVersion>;
  /**
   * The next scheduled router status, useful for telling when a router will be transitioning in
   * the near future to another staus. If no change in status is scheduled, this field will be
   * null
   */
  nextStatus: Maybe<RouterStatus>;
  /** Retrieves a specific Order related to this Cloud Router */
  order: Maybe<Order>;
  /** Retrieves all Orders related to this Cloud Router */
  orders: Array<Order>;
  /**
   * URL where the Cloud Router can be found
   *
   * This will be null if the Cloud Router is in a deleted status
   * @deprecated use Router.endpoints instead
   */
  routerUrl: Maybe<Scalars['String']['output']>;
  /**
   * Current version of the Cloud Router
   *
   * This will be null if the Cloud Router is in a deleted status.
   */
  routerVersion: Maybe<RouterVersion>;
  /** Return the list of secrets for this Cloud Router with their hash values */
  secrets: Array<Secret>;
  /** Shard associated with this Cloud Router */
  shard: Maybe<Shard>;
  /** Current status of the Cloud Router */
  status: RouterStatus;
  /**
   * Last time when the Cloud Router was updated
   *
   * If the Cloud Router was never updated, this value will be null
   */
  updatedAt: Maybe<Scalars['NaiveDateTime']['output']>;
};


export type RouterorderArgs = {
  orderId: Scalars['ID']['input'];
};


export type RouterordersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RouterAdminMutation = {
  __typename: 'RouterAdminMutation';
  /** Pre-create a custom domain for this Cloud Router, but don't enable routing yet */
  preCreateCustomDomain: RouterPreCreateDomainResult;
  /** Override the lastTraffic for Serverless Cloud Routers */
  setLastTraffic: RouterSetLastTrafficResult;
  /** Update the Cloud Router state so it will display a `nextStatus` value */
  setNextStatus: RouterSetNextStatusResult;
  /** Sleep this Cloud Router */
  sleep: RouterSleepResult;
  /** Wake up this Cloud Router */
  wakeUp: RouterWakeUpResult;
};


export type RouterAdminMutationpreCreateCustomDomainArgs = {
  customDomain: Scalars['String']['input'];
};


export type RouterAdminMutationsetLastTrafficArgs = {
  lastTraffic: Scalars['NaiveDateTime']['input'];
};


export type RouterAdminMutationsetNextStatusArgs = {
  nextStatus: RouterStatus;
};

/** Capabilities for this Cloud Router */
export type RouterCapabilities = {
  __typename: 'RouterCapabilities';
  /** This Cloud Router can router traffic from custom domains */
  customDomains: Scalars['Boolean']['output'];
  /** This Cloud Router supports using a custom path */
  customPath: Scalars['Boolean']['output'];
  /** This Cloud Router supports getting and settings GCUs */
  gcus: Scalars['Boolean']['output'];
  /** This Cloud Router can use private subgraphs */
  privateSubgraphs: Scalars['Boolean']['output'];
};

/** Router configuration input */
export type RouterConfigInput = {
  /**
   * Number of GCUs allocated for the Cloud Router
   *
   * This is ignored for serverless Cloud Routers
   */
  gcus?: InputMaybe<Scalars['Int']['input']>;
  /** Graph composition ID, also known as launch ID */
  graphCompositionId?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for the Cloud Router */
  routerConfig?: InputMaybe<Scalars['String']['input']>;
  /** Router version for the Cloud Router */
  routerVersion?: InputMaybe<Scalars['String']['input']>;
};

export type RouterConfigVersion = {
  __typename: 'RouterConfigVersion';
  /** JSON schema for validating the router configuration */
  configSchema: Maybe<Scalars['String']['output']>;
  /** Name of the RouterConfigVersion */
  name: Scalars['String']['output'];
};

/** Input to create a RouterConfigVersion */
export type RouterConfigVersionInput = {
  /** Configuration schema mapping for the RouterConfigVersion */
  configSchema: Scalars['String']['input'];
  /** Name of the RouterConfigVersion */
  configVersion: Scalars['String']['input'];
};

/**
 * List of endpoints for Cloud Router
 *
 * ## Endpoint states
 *
 * If a Router is in the `DELETED` state, all the fields on this object will return `null`.
 *
 * For all other states, this table list all the possible valid states, and the mutations that can
 * be performed on them.
 *
 * | Default Enabled? | Primary Endpoint | Custom Endpoints | Allowed endpoint mutations                                           |
 * | Yes              | Default          | null             | N/A (this Router does not support custom endpoints)                  |
 * | Yes              | Default          | []               | addCustomDomain, enableDefaultEndpoint, resetPrimaryEndpoint         |
 * | Yes              | Default          | ["1", "2", "3"]  | addCustomDomain, enableDefaultEndpoint, removeCustomDomain("1", "2", or "3"), resetPrimaryEndpoint, setPrimaryEndpoint ("1", "2", or "3") |
 * | Yes              | Custom 1         | ["1", "2", "3"]  | addCustomDomain, disableDefaultEndpoint, enableDefaultEndpoint, removeCustomDomain("2" or "3"), resetPrimaryEndpoint, setPrimaryEndpoint ("1", "2", or "3") |
 * | No               | Custom 1         | ["1", "2", "3"]  | addCustomDomain, disableDefaultEndpoint, enableDefaultEndpoint, removeCustomDomain("2" or "3"), setPrimaryEndpoint ("1", "2", or "3") |
 */
export type RouterEndpoints = {
  __typename: 'RouterEndpoints';
  /**
   * Set of custom Cloud Router endpoints
   *
   * This is null if the cloud router is in a deleted state, or if it does not support
   * custom endpoints.
   */
  custom: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Default Cloud Router endpoint
   *
   * This is null if the cloud router is in a deleted state.
   */
  default: Maybe<Scalars['String']['output']>;
  /**
   * Whether the default Cloud Router endpoint is enabled
   *
   * If the default endpoint is not enabled (`false`), this Cloud Router cannot receive traffic
   * on the default endpoint.
   *
   * This is null if the cloud router is in a deleted state.
   */
  defaultEnabled: Maybe<Scalars['Boolean']['output']>;
  /**
   * Primary Cloud Router endpoint
   *
   * This is null if the cloud router is in a deleted state.
   */
  primary: Maybe<Scalars['String']['output']>;
};

/** Represents the possible outcomes of an endpoint mutation */
export type RouterEndpointsResult = InternalServerError | InvalidInputErrors | RouterEndpointsSuccess;

/** Successe branch of  an addEndpoint or removeEndpoint mutation */
export type RouterEndpointsSuccess = {
  __typename: 'RouterEndpointsSuccess';
  endpoints: RouterEndpoints;
};

export type RouterEntitlement = {
  __typename: 'RouterEntitlement';
  /** The id of the account this license was generated for. */
  accountId: Scalars['String']['output'];
  /** Which audiences this license applies to. */
  audience: Array<RouterEntitlementAudience>;
  /** Router will stop serving requests after this time if commercial features are in use. */
  haltAt: Maybe<Scalars['Timestamp']['output']>;
  /** RFC 8037 Ed25519 JWT signed representation of sibling fields. Restricted to internal services only. */
  jwt: Scalars['String']['output'];
  /** Organization this license applies to. */
  subject: Scalars['String']['output'];
  throughputLimit: Maybe<RateLimit>;
  /** Router will warn users after this time if commercial features are in use. */
  warnAt: Maybe<Scalars['Timestamp']['output']>;
};

export enum RouterEntitlementAudience {
  /** Routers in Apollo hosted cloud. */
  CLOUD = 'CLOUD',
  /** Routers in offline environments with license files supplied from a URL or locally. */
  OFFLINE = 'OFFLINE',
  /** Routers in self-hosted environments fetching their license from uplink. */
  SELF_HOSTED = 'SELF_HOSTED'
}

/** A paginated list of router entitlements. */
export type RouterEntitlementConnection = {
  __typename: 'RouterEntitlementConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RouterEntitlementEdge>>>;
  /** A list of router entitlements. */
  nodes: Maybe<Array<Maybe<RouterEntitlement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of router entitlements. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a router entitlement connection. */
export type RouterEntitlementEdge = {
  __typename: 'RouterEntitlementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** A router entitlement. */
  node: Maybe<RouterEntitlement>;
};

/** Represents the possible outcomes of a setGcus mutation */
export type RouterGcusResult = InternalServerError | InvalidInputErrors | RouterGcusSuccess;

/** Success branch of a setGcus mutation */
export type RouterGcusSuccess = {
  __typename: 'RouterGcusSuccess';
  order: Order;
};

/** The sub-router's log record for one request. */
export type RouterLogRecord = {
  __typename: 'RouterLogRecord';
  /** The deduplicated set of error codes from the response. */
  errorCodes: Array<Scalars['String']['output']>;
  /** The number of errors in the response. */
  errorCount: Scalars['Int']['output'];
  /** The OCI manifest digest of the immutable graph artifact the sub-router was serving for this operation. Distinct from the graph ref, which is mutable. */
  graphArtifactId: Maybe<Scalars['String']['output']>;
  /** The operation's id, if known. */
  operationId: Maybe<Scalars['String']['output']>;
  /** The operation's name, or null if the operation is unnamed. */
  operationName: Maybe<Scalars['String']['output']>;
  /** The normalized GraphQL signature of the operation, looked up from the signature store by operationId. Null if the operation id is unknown, or the signature can't be found (not yet ingested, or the request predates signature retention). */
  operationSignature: Maybe<Scalars['String']['output']>;
  /** The GraphQL operation type, or null if it could not be determined. */
  operationType: Maybe<OperationType>;
  /** The HTTP status code the sub-router returned for this operation, if known. */
  responseStatus: Maybe<Scalars['Int']['output']>;
  /** The service that handled this operation, as its routing domain -- the service id a policy rule binds to, each backed by its own sub-router. A slug such as `checkout`; neither a subgraph name nor an `UpstreamService` display name. */
  routingDomain: Maybe<Scalars['String']['output']>;
  /** The subgraphs and connectors this operation fetched from. */
  subgraphFetches: Array<SubgraphFetchDetails>;
  /** When the sub-router wrote this record. */
  timestamp: Scalars['Timestamp']['output'];
};

export type RouterMutation = {
  __typename: 'RouterMutation';
  /** Add a custom domain for this Cloud Router */
  addCustomDomain: RouterEndpointsResult;
  /** Admin mutations for this Router */
  admin: RouterAdminMutation;
  /**
   * Disable the default endpoint
   *
   * This mutation will only work if the Router is not in a DELETED state and the default
   * endpoint is not the primary endpoint.
   */
  disableDefaultEndpoint: RouterEndpointsResult;
  /**
   * Enable the default endpoint
   *
   * This mutation will only work if the Router is not in a DELETED state
   */
  enableDefaultEndpoint: RouterEndpointsResult;
  /** Remove a custom domain for this Cloud Router */
  removeCustomDomain: RouterEndpointsResult;
  /**
   * Reset the primary endpoint to the default endpoint
   *
   * This mutation will only work if the Router is not in a DELETED state, and the default
   * endpoint is enabled.
   */
  resetPrimaryEndpoint: RouterEndpointsResult;
  /** Set a custom path for this Router */
  setCustomPath: RouterPathResult;
  /** Set the number of GCUs associated with this Router */
  setGcus: RouterGcusResult;
  /** Set the version used for the next update for this Cloud Router */
  setNextVersion: SetNextVersionResult;
  /**
   * Set the primary endpoint to a custom endpoint
   *
   * This mutation will only work if the Router is not in a DELETED state, and the primary
   * endpoint correspond to the full endpoint name (e.g. `https://api.mycompany.com/graphql`) of
   * an existing custom endpoint.
   */
  setPrimaryEndpoint: RouterEndpointsResult;
  /** Set secrets for this Cloud Router */
  setSecrets: RouterSecretsResult;
  /**
   * Sleep this Cloud Router
   * @deprecated use Router.admin.sleep instead
   */
  sleep: RouterSleepResult;
};


export type RouterMutationaddCustomDomainArgs = {
  customDomain: Scalars['String']['input'];
};


export type RouterMutationremoveCustomDomainArgs = {
  customDomain: Scalars['String']['input'];
};


export type RouterMutationsetCustomPathArgs = {
  path: Scalars['String']['input'];
};


export type RouterMutationsetGcusArgs = {
  gcus: Scalars['Int']['input'];
};


export type RouterMutationsetNextVersionArgs = {
  version: Scalars['String']['input'];
};


export type RouterMutationsetPrimaryEndpointArgs = {
  endpoint: Scalars['String']['input'];
};


export type RouterMutationsetSecretsArgs = {
  input: RouterSecretsInput;
};

/** Represents the possible outcomes of a setCustomPath mutation */
export type RouterPathResult = InternalServerError | InvalidInputErrors | RouterPathSuccess;

/** Success branch of a setCustomPath mutation */
export type RouterPathSuccess = {
  __typename: 'RouterPathSuccess';
  endpoints: RouterEndpoints;
  order: Order;
};

/** "Represents the possible outcomes of a ", RouterPreCreateDomain, " mutation" */
export type RouterPreCreateDomainResult = InternalServerError | InvalidInputErrors | RouterPreCreateDomainSuccess;

/** Success branch of a preCreateCustomDomain mutation */
export type RouterPreCreateDomainSuccess = {
  __typename: 'RouterPreCreateDomainSuccess';
  success: Scalars['Boolean']['output'];
};

/** User input for a RouterSecrets mutation */
export type RouterSecretsInput = {
  /** Secrets to create or update */
  secrets?: InputMaybe<Array<SecretInput>>;
  /** Secrets to remove */
  unsetSecrets?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents the possible outcomes of a RouterSecrets mutation */
export type RouterSecretsResult = InternalServerError | InvalidInputErrors | RouterSecretsSuccess;

/** Success branch of a RouterSecrets mutation. */
export type RouterSecretsSuccess = {
  __typename: 'RouterSecretsSuccess';
  order: Order;
  secrets: Array<Secret>;
};

/** "Represents the possible outcomes of a ", RouterSetLastTraffic, " mutation" */
export type RouterSetLastTrafficResult = InternalServerError | InvalidInputErrors | RouterSetLastTrafficSuccess;

/** Success branch of a setLastTraffic mutation */
export type RouterSetLastTrafficSuccess = {
  __typename: 'RouterSetLastTrafficSuccess';
  success: Scalars['Boolean']['output'];
};

/** "Represents the possible outcomes of a ", RouterSetNextStatus, " mutation" */
export type RouterSetNextStatusResult = InternalServerError | InvalidInputErrors | RouterSetNextStatusSuccess;

/** Success branch of a setNextStatus mutation */
export type RouterSetNextStatusSuccess = {
  __typename: 'RouterSetNextStatusSuccess';
  success: Scalars['Boolean']['output'];
};

/** "Represents the possible outcomes of a ", RouterSleep, " mutation" */
export type RouterSleepResult = InternalServerError | InvalidInputErrors | RouterSleepSuccess;

/** Success branch of a sleep mutation */
export type RouterSleepSuccess = {
  __typename: 'RouterSleepSuccess';
  success: Scalars['Boolean']['output'];
};

/** Current status of Cloud Routers */
export enum RouterStatus {
  /** Cloud Router is not yet provisioned */
  CREATING = 'CREATING',
  /** Router has been deleted */
  DELETED = 'DELETED',
  /**
   * Cloud Router is running, but currently being deleted
   *
   * This is the only mutation state that doesn't support rollback. If we fail to
   * delete a Router, the workflows are configured to stop and keep the router into
   * the Deleting status.
   */
  DELETING = 'DELETING',
  /**
   * Current order is rolling back to the last known good state
   *
   * After a RollingBack state, a Router can move either into Running state (from a
   * Update order) or Deleted (from a Create order).
   *
   * If we fail to roll back, the workflows are configured to stop and keep the router
   * into the RollingBack status.
   */
  ROLLING_BACK = 'ROLLING_BACK',
  /** Current router is running and able to server requests */
  RUNNING = 'RUNNING',
  /** Router has been put to sleep. This state should only be possible for Serverless routers */
  SLEEPING = 'SLEEPING',
  /** Cloud Router is running, but currently being updated */
  UPDATING = 'UPDATING'
}

export type RouterUpsertFailure = {
  __typename: 'RouterUpsertFailure';
  message: Scalars['String']['output'];
};

/** A generic key→count type so that router usage metrics can be added to without modifying the `trackRouterUsage` mutation */
export type RouterUsageInput = {
  count: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};

/** Router Version */
export type RouterVersion = {
  __typename: 'RouterVersion';
  /** Build number */
  build: Scalars['String']['output'];
  /** JSON schema for validating the router configuration for this router version */
  configSchema: Scalars['String']['output'];
  /** Config version for this router version */
  configVersion: Scalars['String']['output'];
  /** Core version identifier */
  core: Scalars['String']['output'];
  /** Latest supported BuildPipelineTrack for this version */
  latestSupportedPipelineTrack: Maybe<Scalars['String']['output']>;
  /** Status of a router version */
  status: Status;
  /** Version identifier */
  version: Scalars['String']['output'];
};

export type RouterVersionBuild = {
  __typename: 'RouterVersionBuild';
  jobId: Scalars['String']['output'];
  routerVersion: Maybe<Scalars['String']['output']>;
  status: RouterVersionBuildStatus;
};

export type RouterVersionBuildError = {
  __typename: 'RouterVersionBuildError';
  jobId: Scalars['String']['output'];
  routerVersion: Maybe<Scalars['String']['output']>;
};

export type RouterVersionBuildPageResults = {
  __typename: 'RouterVersionBuildPageResults';
  count: Scalars['Int']['output'];
  cursor: Maybe<Scalars['Cursor']['output']>;
  results: Array<RouterVersionBuildResult>;
};

export type RouterVersionBuildResult = RouterVersionBuild | RouterVersionBuildError;

export enum RouterVersionBuildStatus {
  BUILDING = 'BUILDING',
  CANCELLED = 'CANCELLED',
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING'
}

export enum RouterVersionBuildsField {
  CREATED_AT = 'CREATED_AT'
}

export type RouterVersionBuildsInput = {
  orderBy?: InputMaybe<RouterVersionBuildsOrderByInput>;
  pagination?: InputMaybe<CloudRouterTestingToolPaginationInput>;
};

export type RouterVersionBuildsOrderByInput = {
  direction: OrderingDirection;
  field: RouterVersionBuildsField;
};

/** Result of a RouterConfigVersion mutation */
export type RouterVersionConfigResult = CloudInvalidInputError | InternalServerError | RouterConfigVersion;

/** Input to create a new router version */
export type RouterVersionCreateInput = {
  /** Version of the configuration */
  configVersion: Scalars['String']['input'];
  /** Latest supported BuildPipelineTrack for this version */
  latestSupportedPipelineTrack: Scalars['String']['input'];
  /** Version status */
  status: Status;
  /** Version identifier */
  version: Scalars['String']['input'];
};

/** Result of a router version query */
export type RouterVersionResult = InternalServerError | InvalidInputErrors | RouterVersion;

/** Input for updating a router version */
export type RouterVersionUpdateInput = {
  /** Version of the configuration */
  configVersion?: InputMaybe<Scalars['String']['input']>;
  /** Latest supported BuildPipelineTrack for this version */
  latestSupportedPipelineTrack?: InputMaybe<Scalars['String']['input']>;
  /** Version status */
  status?: InputMaybe<Status>;
  /** Version identifier */
  version: Scalars['String']['input'];
};

/** List of router versions */
export type RouterVersions = {
  __typename: 'RouterVersions';
  versions: Array<RouterVersion>;
};

/** Input for filtering router versions */
export type RouterVersionsInput = {
  /** Name of the branch */
  branch?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of versions to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Status of the version */
  status?: InputMaybe<Status>;
};

/** Result of a router versions query */
export type RouterVersionsResult = InternalServerError | InvalidInputErrors | RouterVersions;

/** "Represents the possible outcomes of a ", RouterWakeUp, " mutation" */
export type RouterWakeUpResult = InternalServerError | InvalidInputErrors | RouterWakeUpSuccess;

/** Success branch of a wakeUp mutation */
export type RouterWakeUpSuccess = {
  __typename: 'RouterWakeUpSuccess';
  success: Scalars['Boolean']['output'];
};

export type RoverArgumentInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type RuleEnforcement = {
  __typename: 'RuleEnforcement';
  /** The instant this enforcement was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** Identifying info for the creator of this enforcement. */
  createdBy: Scalars['String']['output'];
  /** The instant this enforcement was deleted. */
  deletedAt: Maybe<Scalars['Timestamp']['output']>;
  /** The identifier for the graph this this enforcement applies to. */
  graphId: Scalars['String']['output'];
  /** The name of the variant that this enforcement applies to. */
  graphVariant: Maybe<Scalars['String']['output']>;
  /** The ID of this enforcement. */
  id: Scalars['ID']['output'];
  /** A list of key/value pairs representing any parameters necessary for the policy's enforcement. */
  params: Maybe<Array<StringToString>>;
  /** The policy that this enforcement belongs to. */
  policy: EnforcementPolicy;
  /** The instant this enforcement was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type RuleEnforcementError = {
  __typename: 'RuleEnforcementError';
  message: Scalars['String']['output'];
};

export type RuleEnforcementResult = RuleEnforcement | RuleEnforcementError;

export type RunLintCheckInput = {
  baseSchema: SchemaHashInput;
  checkStep: CheckStepInput;
  proposedSchema: SchemaHashInput;
};

/** Inputs needed to find all relevant proposals to a check workflow */
export type RunProposalsCheckInput = {
  /** List of subgraph names and hashes from the state of this variant when the check was run. */
  baseSubgraphs: Array<SubgraphCheckInput>;
  /** Supergraph hash that was most recently published when the check was run */
  baseSupergraphHash: Scalars['String']['input'];
  /** List of subgraph names and hashes that are being proposed in the check task */
  proposedSubgraphs: Array<SubgraphCheckInput>;
  /** Supergraph hash that is the output of the check's composition task */
  proposedSupergraphHash: Scalars['String']['input'];
  /** If this check was created by rerunning, the original check workflow task that was rerun */
  rerunOfTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** The severity to assign the check results if matching proposals are not found */
  severityLevel: ProposalChangeMismatchSeverity;
  /** The check workflow task id. Used by Task entities to resolve the results */
  workflowTaskId: Scalars['String']['input'];
};

/** Per-organization S3 integration configuration. */
export type S3IntegrationConfig = {
  __typename: 'S3IntegrationConfig';
  /** The organization that owns this S3 integration configuration. */
  account: Account;
  /** The AWS region of the customer's S3 bucket. */
  awsRegion: Scalars['String']['output'];
  /** The time at which this configuration was created. */
  createdAt: Scalars['Timestamp']['output'];
  /** ARN of the customer's AWS IAM role that Apollo assumes to write to the bucket. */
  customerRoleArn: Scalars['String']['output'];
  /** Whether this S3 integration is currently enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The per-customer external ID for the AWS IAM role trust policy. The create mutation result returns the full plaintext (the only place it's surfaced). Subsequent reads return a redacted preview with only the last few characters visible. */
  externalId: Scalars['String']['output'];
  /** Unique identifier for this S3 integration configuration. */
  id: Scalars['ID']['output'];
  /** Optional customer KMS key ARN. When set, audit files written to the bucket are encrypted with this key (SSE-KMS). */
  kmsKeyArn: Maybe<Scalars['String']['output']>;
  /** End of the most recent time window successfully exported to the bucket, if any. */
  lastSuccessfulWindowEnd: Maybe<Scalars['Timestamp']['output']>;
  /** Name of the customer's destination S3 bucket. */
  s3Bucket: Scalars['String']['output'];
  /** Optional key prefix prepended to objects written to the bucket. */
  s3KeyPrefix: Maybe<Scalars['String']['output']>;
  /** The time at which this configuration was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

/** Mutations for an existing S3 integration configuration. */
export type S3IntegrationMutation = {
  __typename: 'S3IntegrationMutation';
  /** Permanently delete this S3 integration configuration. Use s3Integration(id).update to enable or disable a configuration without removing it. */
  delete: DeleteS3IntegrationResult;
  /** Update this S3 integration configuration. Every field is optional: only the fields supplied are changed, the rest are left as-is. */
  update: UpdateS3IntegrationResult;
};


/** Mutations for an existing S3 integration configuration. */
export type S3IntegrationMutationupdateArgs = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  kmsKeyArn?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  roleArn?: InputMaybe<Scalars['String']['input']>;
};

export type SafAssessment = {
  __typename: 'SafAssessment';
  /** The date and time the assessment was completed. */
  completedAt: Maybe<Scalars['Date']['output']>;
  /** The time that the assessment was deleted. */
  deletedAt: Maybe<Scalars['Date']['output']>;
  /** The graph that this assessment belongs to. */
  graph: Service;
  id: Scalars['ID']['output'];
  /** The plan items for this assessment. */
  planItems: Array<SafPlanItem>;
  /** The responses for this assessment. */
  responses: Array<SafResponse>;
  /** The date and time the assessment was started. */
  startedAt: Scalars['Date']['output'];
};

export type SafAssessmentMutation = {
  __typename: 'SafAssessmentMutation';
  /** Delete the assessment. */
  delete: SafAssessment;
  id: Scalars['String']['output'];
  /** Mutations for a specific plan item. */
  planItem: Maybe<SafPlanItemMutation>;
  /** Reorder the plan items for a given assessment. */
  reorderPlanItems: Array<SafPlanItem>;
  /** Save a response for a question. */
  saveResponse: SafResponse;
  /** Submit the assessment. */
  submit: SafAssessment;
};


export type SafAssessmentMutationplanItemArgs = {
  id: Scalars['ID']['input'];
};


export type SafAssessmentMutationreorderPlanItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SafAssessmentMutationsaveResponseArgs = {
  input: SafResponseInput;
};


export type SafAssessmentMutationsubmitArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  planItemIds: Array<Scalars['String']['input']>;
};

export type SafPlanItem = {
  __typename: 'SafPlanItem';
  bestPracticeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeprioritized: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type SafPlanItemInput = {
  isDeprioritized: Scalars['Boolean']['input'];
  notes: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type SafPlanItemMutation = {
  __typename: 'SafPlanItemMutation';
  /** Update a plan item. */
  update: SafPlanItem;
};


export type SafPlanItemMutationupdateArgs = {
  input: SafPlanItemInput;
};

export type SafResponse = {
  __typename: 'SafResponse';
  /** The assessment that this response belongs to. */
  assessment: Maybe<SafAssessment>;
  /** Additional context or feedback about the question. */
  comment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The ID of the question that this response is for. */
  questionId: Scalars['String']['output'];
  /** A list of responses for this question. */
  response: Array<Scalars['String']['output']>;
};

export type SafResponseInput = {
  comment: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  response: Array<Scalars['String']['input']>;
};

export type SamlCertInfo = {
  __typename: 'SamlCertInfo';
  id: Scalars['ID']['output'];
  notAfter: Scalars['Timestamp']['output'];
  notBefore: Scalars['Timestamp']['output'];
  pem: Scalars['String']['output'];
  subjectDN: Scalars['String']['output'];
};

export type SamlConfigurationInput = {
  encryptionCerts?: InputMaybe<Array<Scalars['String']['input']>>;
  entityId: Scalars['String']['input'];
  ssoUrl: Scalars['String']['input'];
  verificationCerts: Array<Scalars['String']['input']>;
  wantsSignedRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SamlConnection = SsoConnection & {
  __typename: 'SamlConnection';
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpId: Scalars['ID']['output'];
  metadata: SamlIdpMetadata;
  scim: Maybe<SsoScimProvisioningDetails>;
  /** @deprecated Use stateV2 instead */
  state: SsoConnectionState;
  stateV2: SsoConnectionStateV2;
  updatedAt: Scalars['Timestamp']['output'];
};

export type SamlConnectionMutation = {
  __typename: 'SamlConnectionMutation';
  addEncryptionCert: Maybe<SamlConnection>;
  addVerificationCert: Maybe<SamlConnection>;
  removeVerificationCert: Maybe<SamlConnection>;
  updateIdpId: Maybe<SamlConnection>;
};


export type SamlConnectionMutationaddEncryptionCertArgs = {
  pem: Scalars['String']['input'];
};


export type SamlConnectionMutationaddVerificationCertArgs = {
  pem: Scalars['String']['input'];
};


export type SamlConnectionMutationremoveVerificationCertArgs = {
  certId: Scalars['ID']['input'];
};


export type SamlConnectionMutationupdateIdpIdArgs = {
  idpId: Scalars['String']['input'];
};

export type SamlIdpMetadata = {
  __typename: 'SamlIdpMetadata';
  encryptionCerts: Array<SamlCertInfo>;
  entityId: Scalars['String']['output'];
  ssoUrl: Scalars['String']['output'];
  verificationCerts: Array<SamlCertInfo>;
  wantsSignedRequests: Scalars['Boolean']['output'];
};

export type ScheduledSummary = ChannelSubscription & {
  __typename: 'ScheduledSummary';
  /** @deprecated Use channels list instead */
  channel: Maybe<Channel>;
  channels: Array<Channel>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

/** A GraphQL schema document and associated metadata. */
export type Schema = {
  __typename: 'Schema';
  createTemporaryURL: Maybe<TemporaryURL>;
  /** The timestamp of initial ingestion of a schema to a graph. */
  createdAt: Scalars['Timestamp']['output'];
  /** The GraphQL schema document. */
  document: Scalars['GraphQLDocument']['output'];
  /**
   * The number of fields; this includes user defined fields only, excluding built-in types and fields
   * @deprecated Use metadata instead
   */
  fieldCount: Scalars['Int']['output'];
  gitContext: Maybe<GitContext>;
  /** The GraphQL schema document's SHA256 hash, represented as a hexadecimal string. */
  hash: Scalars['ID']['output'];
  introspection: IntrospectionSchema;
  /** Metadata associated with the schema. */
  metadata: Maybe<SchemaMetadata>;
  /**
   * The list of schema coordinates ('TypeName.fieldName') in the schema
   * that can be measured by usage reporting.
   * Currently only supports object types and interface types.
   */
  observableCoordinates: Maybe<Array<SchemaCoordinate>>;
  /**
   * The number of types; this includes user defined types only, excluding built-in types
   * @deprecated Use metadata instead
   */
  typeCount: Scalars['Int']['output'];
};


/** A GraphQL schema document and associated metadata. */
export type SchemacreateTemporaryURLArgs = {
  expiresInSeconds: Scalars['Int']['input'];
};

/** An error that occurred while running schema composition on a set of subgraph schemas. */
export type SchemaCompositionError = {
  __typename: 'SchemaCompositionError';
  /** A machine-readable error code. */
  code: Maybe<Scalars['String']['output']>;
  /** Source locations related to the error. */
  locations: Array<Maybe<SourceLocation>>;
  /** A human-readable message describing the error. */
  message: Scalars['String']['output'];
};

export type SchemaCoordinate = {
  __typename: 'SchemaCoordinate';
  /** The printed coordinate value, e.g. 'ParentType.fieldName' */
  coordinate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the coordinate being referred to is marked as deprecated */
  isDeprecated: Scalars['Boolean']['output'];
};

export type SchemaCoordinateFilterInput = {
  /**
   * If true, only include deprecated coordinates.
   * If false, filter out deprecated coordinates.
   */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The schema coordinates to include or exclude in the report. */
export type SchemaCoordinateInsightsTimeseriesReportCoordinateFilterInInput = {
  /** The schema coordinate's kind. */
  kind: CoordinateKind;
  /** The named attribute. This is the field name for object and input object fields, or the enum value for enums. If this is null, the filter will apply to all named attributes with the same named type. */
  namedAttribute?: InputMaybe<Scalars['String']['input']>;
  /** The named type. This is the parent type for object and input object fields, or the enum name for enums. If this is null, the filter will apply to all named types with the same named attribute. */
  namedType?: InputMaybe<Scalars['String']['input']>;
};

export enum SchemaCoordinateInsightsTimeseriesReportDimension {
  COORDINATE_KIND = 'COORDINATE_KIND',
  NAMED_ATTRIBUTE = 'NAMED_ATTRIBUTE',
  NAMED_TYPE = 'NAMED_TYPE',
  VARIANT_NAME = 'VARIANT_NAME'
}

/** The type and value for an schema coordinate insights timeseries report dimension. */
export type SchemaCoordinateInsightsTimeseriesReportDimensionValue = {
  __typename: 'SchemaCoordinateInsightsTimeseriesReportDimensionValue';
  /** The type of dimension this represents. */
  type: SchemaCoordinateInsightsTimeseriesReportDimension;
  /** The string value of this dimension. Null for operations without this dimension (e.g., unnamed operations). */
  value: Maybe<Scalars['String']['output']>;
};

/** Lists of dimensions to include or exclude in the schema coordinate timeseries report. Each list can have a maximum of 1000 entries. */
export type SchemaCoordinateInsightsTimeseriesReportFilterInInput = {
  /** The named type and attributes to include or exclude. */
  coordinates?: InputMaybe<Array<SchemaCoordinateInsightsTimeseriesReportCoordinateFilterInInput>>;
  /** The name of the variant where the the operation that referenced or executed the schema coordinate was run. */
  variantName?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The filters available when using the schema coordinate timeseries report. */
export type SchemaCoordinateInsightsTimeseriesReportFilterInput = {
  /** Include only certain kinds of schema coordinates (object fields, input object fields, enum values). */
  coordinateKinds?: InputMaybe<Array<CoordinateKind>>;
  /** Exclude schema coordinates that match a specified set of dimensions. If the same dimension exists in both 'include' and 'exclude', a REQUEST_INVALID error will be returned. */
  exclude?: InputMaybe<SchemaCoordinateInsightsTimeseriesReportFilterInInput>;
  /** Include schema coordinates that match a specified set of dimensions. */
  include?: InputMaybe<SchemaCoordinateInsightsTimeseriesReportFilterInInput>;
};

export enum SchemaCoordinateInsightsTimeseriesReportMetric {
  ERROR_COUNT = 'ERROR_COUNT',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  OBSERVED_EXECUTION_COUNT = 'OBSERVED_EXECUTION_COUNT',
  REQUEST_COUNT = 'REQUEST_COUNT'
}

/** The type and value for an schema coordinate insights timeseries report metric. */
export type SchemaCoordinateInsightsTimeseriesReportMetricValue = {
  __typename: 'SchemaCoordinateInsightsTimeseriesReportMetricValue';
  /** The type of metric this represents. */
  type: SchemaCoordinateInsightsTimeseriesReportMetric;
  /** The floating point value of this metric. */
  value: Scalars['Float']['output'];
};

/** The metric and direction to use as the secondary sort order for the schema coordinate timeseries report. The primary sort order will always be time. */
export type SchemaCoordinateInsightsTimeseriesReportOrderByInput = {
  /** The order column used for the metrics results. */
  column: SchemaCoordinateInsightsTimeseriesReportMetric;
  /** The direction used to order operation results. */
  direction: Ordering;
};

/** The data that is returned by the schema coordinate insights timeseries report. */
export type SchemaCoordinateInsightsTimeseriesReportResult = {
  __typename: 'SchemaCoordinateInsightsTimeseriesReportResult';
  /** A CSV representation of the results. This includes a header and rows that have a column for start and end timestamp and all requested dimensions and metrics. */
  csv: Maybe<Scalars['String']['output']>;
  /** The result records, with each row having a start and end timestamp and a set of dimensions and metrics. */
  records: Array<SchemaCoordinateInsightsTimeseriesReportRow>;
};

/** A single row of data that is returned by the schema coordinate insights timeseries report. */
export type SchemaCoordinateInsightsTimeseriesReportRow = {
  __typename: 'SchemaCoordinateInsightsTimeseriesReportRow';
  /** The dimension values for this row, matching the requested dimensions. */
  dimensions: Array<SchemaCoordinateInsightsTimeseriesReportDimensionValue>;
  /** The exclusive end of the time bucket for this row. */
  endExclusiveTimestamp: Scalars['Timestamp']['output'];
  /** The metric values for this row, matching the requested metrics. */
  metrics: Array<SchemaCoordinateInsightsTimeseriesReportMetricValue>;
  /** The start of the time bucket for this row. */
  startTimestamp: Scalars['Timestamp']['output'];
};

/** A client filter entry. At least one of clientName or clientVersion must be provided. Omitting clientVersion matches all versions of the given client; omitting clientName matches all clients with the given version. */
export type SchemaCoordinateInsightsUsageReportClientInput = {
  /** The client name. If omitted, matches any client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** The client version. If omitted, matches any client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
};

/** A sortable column of the schema coordinate usage report. */
export enum SchemaCoordinateInsightsUsageReportColumn {
  /** The estimated total number of times that the coordinate was executed taking into account sampling. This will always be zero for input object fields and enum values. */
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  /** The timestamp that the coordinate was last executed or referenced. */
  LAST_SEEN_AT = 'LAST_SEEN_AT',
  /** The number of times that the coordinate was reported as executed. This will always be zero for input object fields and enum values. */
  OBSERVED_EXECUTION_COUNT = 'OBSERVED_EXECUTION_COUNT',
  /** The number of operation executions that contained a reference to the coordinate. */
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT'
}

/** The filters available when using the schema coordinate usage report. */
export type SchemaCoordinateInsightsUsageReportFilterInput = {
  /** If set, include only schema coordinates used by at least one of the specified client name and version pairs. Cannot contain more than 100 pairs. */
  clients?: InputMaybe<Array<SchemaCoordinateInsightsUsageReportClientInput>>;
  /** Include only certain kinds of schema coordinates (object fields, input object fields, enum values). */
  coordinateKinds?: InputMaybe<Array<CoordinateKind>>;
  /** If set, include only schema coordinates whose `@deprecated` status in the active schema matches this value. */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, include only schema coordinates whose used status matches this value. A coordinate is 'used' if it was referenced or executed at any point since the requested 'since' timestamp. */
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The column and direction to use when ordering the schema coordinate usage report. */
export type SchemaCoordinateInsightsUsageReportOrderByInput = {
  /** The column used to order the results. */
  column: SchemaCoordinateInsightsUsageReportColumn;
  /** The direction used to order the results. */
  direction: Ordering;
};

/** The data that is returned by the schema coordinate insights usage report. */
export type SchemaCoordinateInsightsUsageReportResult = {
  __typename: 'SchemaCoordinateInsightsUsageReportResult';
  /** A CSV representation of the results. This includes a header and a row per schema coordinate with all of its columns. */
  csv: Scalars['String']['output'];
  /** The result records, one per schema coordinate, describing its current usage and deprecation status. */
  records: Array<SchemaCoordinateInsightsUsageReportRow>;
};

/** A single schema coordinate (object field, input object field, or enum value) and its current usage and deprecation status. */
export type SchemaCoordinateInsightsUsageReportRow = {
  __typename: 'SchemaCoordinateInsightsUsageReportRow';
  /** The name of the client that used this coordinate. Populated only when 'groupByClient' is true. */
  clientName: Maybe<Scalars['String']['output']>;
  /** The version of the client that used this coordinate. Populated only when 'groupByClient' is true. */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** The schema coordinate's kind. */
  coordinateKind: CoordinateKind;
  /** Whether this schema coordinate is marked `@deprecated` in the active schema for the variant. */
  deprecated: Scalars['Boolean']['output'];
  /** The estimated total number of executions for this schema coordinate since the requested 'since' timestamp, based on the field execution sample rate. */
  estimatedExecutionCount: Scalars['Long']['output'];
  /** The most recent timestamp at which this schema coordinate was seen (referenced or executed). Null if it has not been seen since the requested 'since' timestamp. */
  lastSeenAt: Maybe<Scalars['Timestamp']['output']>;
  /** The named attribute. This is the field name for object and input object fields, or the enum value for enums. */
  namedAttribute: Scalars['String']['output'];
  /** The named type. This is the parent type for object and input object fields, or the enum name for enums. */
  namedType: Scalars['String']['output'];
  /** The total number of observed executions recorded for this schema coordinate since the requested 'since' timestamp. */
  observedExecutionCount: Scalars['Long']['output'];
  /** The total number of operations that referenced this schema coordinate since the requested 'since' timestamp. */
  referencingOperationCount: Scalars['Long']['output'];
  /** Whether this schema coordinate has been referenced or executed at any point since the requested 'since' timestamp. */
  used: Scalars['Boolean']['output'];
};

/** The result of computing the difference between two schemas, usually as part of schema checks. */
export type SchemaDiff = {
  __typename: 'SchemaDiff';
  /**
   * Clients affected by all changes in the diff.
   * @deprecated Unsupported.
   */
  affectedClients: Maybe<Array<AffectedClient>>;
  /** Operations affected by all changes in the diff. */
  affectedQueries: Maybe<Array<AffectedQuery>>;
  /** Numeric summaries for each type of change in the diff. */
  changeSummary: ChangeSummary;
  /** A list of all schema changes in the diff, including their severity. */
  changes: Array<Change>;
  /** The number of GraphQL operations affected by the diff's changes that are neither marked as safe nor ignored. */
  numberOfAffectedOperations: Scalars['Int']['output'];
  /** The number of GraphQL operations that were validated during the check. */
  numberOfCheckedOperations: Maybe<Scalars['Int']['output']>;
  /** Indicates the overall safety of the changes included in the diff, based on operation history (e.g., `FAILURE` or `NOTICE`). */
  severity: ChangeSeverity;
  /** The tag against which this diff was created */
  tag: Maybe<Scalars['String']['output']>;
  /** @deprecated use severity instead */
  type: ChangeType;
  /** Configuration of validation */
  validationConfig: Maybe<SchemaDiffValidationConfig>;
};

export type SchemaDiffValidationConfig = {
  __typename: 'SchemaDiffValidationConfig';
  /** Clients to ignore during validation. */
  excludedClients: Maybe<Array<ClientInfoFilterOutput>>;
  /** Operation names to ignore during validation. */
  excludedOperationNames: Maybe<Array<Maybe<OperationNameFilter>>>;
  /**
   * delta in seconds from current time that determines the start of the window
   * for reported metrics included in a schema diff. A day window from the present
   * day would have a `from` value of -86400. In rare cases, this could be an ISO
   * timestamp if the user passed one in on diff creation
   */
  from: Maybe<Scalars['Timestamp']['output']>;
  /** Operation IDs to ignore during validation. */
  ignoredOperations: Maybe<Array<Scalars['ID']['output']>>;
  /** Variants to include during validation. */
  includedVariants: Maybe<Array<Scalars['String']['output']>>;
  /** Minimum number of requests within the window for a query to be considered. */
  queryCountThreshold: Maybe<Scalars['Int']['output']>;
  /**
   * Number of requests within the window for a query to be considered, relative to
   * total request count. Expected values are between 0 and 0.05 (minimum 5% of
   * total request volume)
   */
  queryCountThresholdPercentage: Maybe<Scalars['Float']['output']>;
  /**
   * delta in seconds from current time that determines the end of the
   * window for reported metrics included in a schema diff. A day window
   * from the present day would have a `to` value of -0. In rare
   * cases, this could be an ISO timestamp if the user passed one in on diff
   * creation
   */
  to: Maybe<Scalars['Timestamp']['output']>;
};

export type SchemaHashInput = {
  /** If provided fetches build messages that are added to linter results. */
  buildID?: InputMaybe<Scalars['ID']['input']>;
  /** SHA256 of the schema sdl. */
  hash: Scalars['String']['input'];
  subgraphs?: InputMaybe<Array<SubgraphHashInput>>;
};

/** Metadata associated with a GraphQL schema */
export type SchemaMetadata = {
  __typename: 'SchemaMetadata';
  /** Number of directives. */
  directiveCount: Scalars['Int']['output'];
  /** Number of Federation entities. Null if the schema is not a Supergraph. */
  entityCount: Maybe<Scalars['Int']['output']>;
  /** Number of enum types. */
  enumCount: Scalars['Int']['output'];
  /** Number of input types. */
  inputCount: Scalars['Int']['output'];
  /** Number of fields defined on input types. */
  inputFieldCount: Scalars['Int']['output'];
  /** Number of interface types. */
  interfaceCount: Scalars['Int']['output'];
  /** Number of fields defined on interface types. */
  interfaceFieldCount: Scalars['Int']['output'];
  /** Number of fields defined on the Mutation type. */
  mutationFieldCount: Scalars['Int']['output'];
  /** Number of object types. */
  objectCount: Scalars['Int']['output'];
  /** Number of fields across all non-root object types */
  otherFieldCount: Scalars['Int']['output'];
  /** Number of fields defined on the Query type. */
  queryFieldCount: Scalars['Int']['output'];
  /** Number of scalar types. */
  scalarCount: Scalars['Int']['output'];
  /** Number of fields defined on the Subscription type. */
  subscriptionFieldCount: Scalars['Int']['output'];
  /** Number of union types. */
  unionCount: Scalars['Int']['output'];
};

export type SchemaPublishSubscription = ChannelSubscription & {
  __typename: 'SchemaPublishSubscription';
  channels: Array<Channel>;
  createdAt: Scalars['Timestamp']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['Timestamp']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

export type SchemaReport = {
  /** A randomly generated UUID, immutable for the lifetime of the edge server runtime. */
  bootId: Scalars['String']['input'];
  /** The hex SHA256 hash of the schema being reported. Note that for a GraphQL server with a core schema, this should be the core schema, not the API schema. */
  coreSchemaHash: Scalars['String']['input'];
  /** The graph ref (eg, 'id@variant') */
  graphRef: Scalars['String']['input'];
  /** The version of the edge server reporting agent, e.g. apollo-server-2.8, graphql-java-3.1, etc. length must be <= 256 characters. */
  libraryVersion?: InputMaybe<Scalars['String']['input']>;
  /** The infra environment in which this edge server is running, e.g. localhost, Kubernetes, AWS Lambda, Google CloudRun, AWS ECS, etc. length must be <= 256 characters. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** The runtime in which the edge server is running, e.g. node 12.03, zulu8.46.0.19-ca-jdk8.0.252-macosx_x64, etc. length must be <= 256 characters. */
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  /** If available, an identifier for the edge server instance, such that when restarting this instance it will have the same serverId, with a different bootId. For example, in Kubernetes this might be the pod name. Length must be <= 256 characters. */
  serverId?: InputMaybe<Scalars['String']['input']>;
  /** An identifier used to distinguish the version (from the user's perspective) of the edge server's code itself. For instance, the git sha of the server's repository or the docker sha of the associated image this server runs with. Length must be <= 256 characters. */
  userVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details for an individual publication of an individual graph variant. */
export type SchemaTag = {
  __typename: 'SchemaTag';
  /** The result of federated composition executed for this publication. This result includes either a supergraph schema or error details, depending on whether composition succeeded. This value is null when the publication is for a non-federated graph. */
  compositionResult: Maybe<CompositionResult>;
  createdAt: Scalars['Timestamp']['output'];
  /** A schema diff comparing against the schema from the most recent previous successful publication. */
  diffToPrevious: Maybe<SchemaDiff>;
  gitContext: Maybe<GitContext>;
  /**
   * List of previously uploaded SchemaTags under the same tag name, starting with
   * the selected published schema record. Sorted in reverse chronological order
   * by creation date (newest publish first).
   *
   * Note: This does not include the history of checked schemas
   */
  history: Array<SchemaTag>;
  /**
   * Number of tagged schemas created under the same tag name.
   * Also represents the maximum size of the history's limit argument.
   */
  historyLength: Scalars['Int']['output'];
  /**
   * Number of schemas tagged prior to this one under the same tag name, its position
   * in the tag history.
   */
  historyOrder: Scalars['Int']['output'];
  /** The identifier for this specific publication. */
  id: Scalars['ID']['output'];
  /**
   * The launch for this publication. This value is non-null for contract variants, and sometimes null
   * for composition variants (specifically for older publications). This value is null for other
   * variants.
   */
  launch: Maybe<Launch>;
  /** The timestamp when the variant was published to. */
  publishedAt: Scalars['Timestamp']['output'];
  /**
   * The Identity that published this schema and their client info, or null if this isn't
   * a publish. Sub-fields may be null if they weren't recorded.
   */
  publishedBy: Maybe<IdentityAndClientInfo>;
  /** The schema that was published to the variant. */
  schema: Schema;
  slackNotificationBody: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use variant { name } instead */
  tag: Scalars['String']['output'];
  /** The variant that was published to." */
  variant: GraphVariant;
  webhookNotificationBody: Scalars['String']['output'];
};


/** Contains details for an individual publication of an individual graph variant. */
export type SchemaTaghistoryArgs = {
  includeUnchanged: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SchemaTagHistoryOrder>;
};


/** Contains details for an individual publication of an individual graph variant. */
export type SchemaTaghistoryLengthArgs = {
  includeUnchanged: Scalars['Boolean']['input'];
};


/** Contains details for an individual publication of an individual graph variant. */
export type SchemaTagslackNotificationBodyArgs = {
  graphDisplayName: Scalars['String']['input'];
};

export enum SchemaTagHistoryOrder {
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC'
}

/** An error that occurs when an invalid schema is passed in as user input */
export type SchemaValidationError = Error & {
  __typename: 'SchemaValidationError';
  issues: Array<SchemaValidationIssue>;
  /** The error's details. */
  message: Scalars['String']['output'];
};

/** An error that occurs when an invalid schema is passed in as user input */
export type SchemaValidationIssue = {
  __typename: 'SchemaValidationIssue';
  message: Scalars['String']['output'];
};

/** How many seats of the given types does an organization have (regardless of plan type)? */
export type Seats = {
  __typename: 'Seats';
  /** How many members that are free in this organization. */
  free: Scalars['Int']['output'];
  /** How many members that are not free in this organization. */
  fullPrice: Scalars['Int']['output'];
};

/** Cloud Router secret */
export type Secret = {
  __typename: 'Secret';
  /** When the secret was created */
  createdAt: Scalars['DateTime']['output'];
  /** Hash of the secret */
  hash: Scalars['String']['output'];
  /** Name of the secret */
  name: Scalars['String']['output'];
};

/** Input for creating or updating secrets */
export type SecretInput = {
  /** Name of the secret */
  name: Scalars['String']['input'];
  /**
   * Value for that secret
   *
   * This can only be used for input, as it is not possible to retrieve the value of secrets.
   */
  value: Scalars['String']['input'];
};

export type SemanticChange = {
  __typename: 'SemanticChange';
  /** Target arg of change made. */
  argNode: Maybe<NamedIntrospectionArg>;
  /**
   * Node related to the top level node that was changed, such as a field in an object,
   * a value in an enum or the object of an interface
   */
  childNode: Maybe<NamedIntrospectionValue>;
  /** Semantic metadata about the type of change */
  definition: ChangeDefinition;
  /** Top level node affected by the change */
  parentNode: Maybe<NamedIntrospectionType>;
  /** Short description of the change */
  shortDescription: Maybe<Scalars['String']['output']>;
};

/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type Service = Identity & {
  __typename: 'Service';
  /** Look up a single access request by id. */
  accessRequest: AccessRequest;
  /** All access requests for this graph, paginated, with optional filtering. */
  accessRequests: AccessRequestPage;
  /** The organization that this graph belongs to. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['ID']['output']>;
  /** The `GraphVariant` types of all proposal variants. This is a potentially expensive field to query. */
  allProposalVariants: Array<GraphVariant>;
  /** A list of the graph API keys that are active for this graph. */
  apiKeys: Maybe<Array<GraphApiKey>>;
  /** Provides a view of the graph as an `Actor` type. */
  asActor: Actor;
  /**
   * Get an URL to which an avatar image can be uploaded. Client uploads by sending a PUT request
   * with the image data to MediaUploadInfo.url. Client SHOULD set the "Content-Type" header to the
   * browser-inferred MIME type, and SHOULD set the "x-apollo-content-filename" header to the
   * filename, if such information is available. Client MUST set the "x-apollo-csrf-token" header to
   * MediaUploadInfo.csrfToken.
   */
  avatarUpload: Maybe<AvatarUploadResult>;
  /**
   * Get an image URL for the service's avatar. Note that CORS is not enabled for these URLs. The size
   * argument is used for bandwidth reduction, and should be the size of the image as displayed in the
   * application. Apollo's media server will downscale larger images to at least the requested size,
   * but this will not happen for third-party media servers.
   */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Get available notification endpoints */
  channels: Maybe<Array<Channel>>;
  /** Get check configuration for this graph. */
  checkConfiguration: Maybe<CheckConfiguration>;
  /** Get a check workflow for this graph by its ID */
  checkWorkflow: Maybe<CheckWorkflow>;
  /** Get a check workflow task for this graph by its ID */
  checkWorkflowTask: Maybe<CheckWorkflowTask>;
  /** Get check workflows for this graph ordered by creation time, most recent first. */
  checkWorkflows: Array<CheckWorkflow>;
  /**
   * List of options available for filtering checks for this graph by git committer.
   * If a filter is passed, constrains results to match the filter.
   * For cli triggered checks, this is the author.
   * @deprecated Use checksCommitterOptions instead
   */
  checksAuthorOptions: Array<Scalars['String']['output']>;
  /**
   * List of options available for filtering checks for this graph by branch.
   * If a filter is passed, constrains results to match the filter.
   */
  checksBranchOptions: Array<Scalars['String']['output']>;
  /**
   * List of options available for filtering checks for this graph by git committer.
   * If a filter is passed, constrains results to match the filter.
   * For cli triggered checks, this is the author.
   */
  checksCommitterOptions: Array<Scalars['String']['output']>;
  /**
   * List of options available for filtering checks for this graph by created by field.
   * If a filter is passed, constrains results to match the filter.
   * For non cli triggered checks, this is the Studio User / author.
   */
  checksCreatedByOptions: Array<Identity>;
  /**
   * List of options available for filtering checks for this graph by subgraph name.
   * If a filter is passed, constrains results to match the filter.
   */
  checksSubgraphOptions: Array<Scalars['String']['output']>;
  /** Get a composition build check result for this graph by its ID */
  compositionBuildCheckResult: Maybe<CompositionBuildCheckResult>;
  /** Given a graphCompositionID, return the results of composition. This can represent either a validation or a publish. */
  compositionResultById: Maybe<CompositionResult>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Maybe<Identity>;
  /** Custom check configuration for this graph. */
  customCheckConfiguration: Maybe<CustomCheckConfiguration>;
  datadogMetricsConfig: Maybe<DatadogMetricsConfig>;
  defaultBuildPipelineTrack: Maybe<Scalars['String']['output']>;
  /** The time the default build pipeline track version was updated. */
  defaultBuildPipelineTrackUpdatedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Returns the default reviewers for this graph. This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  defaultProposalReviewers: Array<Maybe<Identity>>;
  deletedAt: Maybe<Scalars['Timestamp']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  devGraphOwner: Maybe<User>;
  /** Get a GraphQL document by hash */
  doc: Maybe<GraphQLDoc>;
  /** Get GraphQL documents by hash, max up to 100 can be requested per query. This field accepts up to 120 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  docs: Maybe<Array<Maybe<GraphQLDoc>>>;
  /**
   * Get a GraphQL document by hash
   * @deprecated Use doc instead
   */
  document: Maybe<Scalars['GraphQLDocument']['output']>;
  /** Diffs the sdls at the oldSdlHash and newSdlHash, returning a FlatDiffResult. This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  flatDiff: FlatDiffResult;
  /** Get a specific graph artifact tag */
  graphArtifactTag: Maybe<GraphArtifactTag>;
  /** The list of graph artifact tags belonging to this graph. Optionally, provide a variant name to filter by variant */
  graphArtifactTags: GraphArtifactTagConnection;
  /** The list of graph artifact tags belonging to this graph. Optionally, provide a variant name to filter by variant */
  graphArtifacts: GraphArtifactConnection;
  /** The capabilities that are supported for this graph */
  graphCapabilities: GraphCapabilities;
  /**
   * GraphOS for Agents configuration for this graph. Individual fields
   * enforce their own authorization; resolving this wrapper alone does not.
   */
  graphOsForAgents: GraphOsForAgentsGraph;
  graphType: GraphType;
  /**
   * When this is true, this graph will be hidden from non-admin members of the org who haven't been explicitly assigned a
   * role on this graph.
   */
  hiddenFromUninvitedNonAdminAccountMembers: Scalars['Boolean']['output'];
  /** The graph's globally unique identifier. */
  id: Scalars['ID']['output'];
  /** List of ignored rule violations for the linter */
  ignoredLinterViolations: Array<IgnoredRule>;
  /**
   * List of subgraphs that comprise a graph. A non-federated graph should have a single implementing service.
   * Set includeDeleted to see deleted subgraphs.
   */
  implementingServices: Maybe<GraphImplementors>;
  lastReportedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Linter configuration for this graph. */
  linterConfiguration: GraphLinterConfiguration;
  /** Current identity, null if not authenticated. */
  me: Maybe<Identity>;
  /** Indicates whether the graph has been migrated from Cloud to Self-Hosted graph type. */
  migratedCloudyGraph: Scalars['Boolean']['output'];
  minProposalApprovers: Scalars['Int']['output'];
  minProposalRoles: ProposalRoles;
  /** The composition result that was most recently published to a graph variant. */
  mostRecentCompositionPublish: Maybe<CompositionPublishResult>;
  /** Permissions of the current user in this graph. */
  myRole: Maybe<UserPermission>;
  name: Scalars['String']['output'];
  onboardingArchitecture: Maybe<OnboardingArchitecture>;
  operation: Maybe<Operation>;
  /** Get request counts by variant for operation checks */
  operationCheckRequestsByVariant: Array<RequestCountsPerGraphVariant>;
  /**
   *  Returns a timeseries of operation metrics across a specified time range for this graph. This will return specified metrics (request count,
   *  avg latency, etc) grouped by time and the specified dimensions (query ID, query name, client name, etc). This API is rate limited and only
   *  allows a small number of requests per minute, and will return a RATE_LIMIT_EXCEEDED error if too many requests are made for a graph. If a
   * request to this field times out, we recommend that you try a shorter time range or fewer dimensions.
   */
  operationInsightsTimeseriesReport: OperationInsightsTimeseriesReportResult;
  /** Gets the operations and their approved changes for this graph, checkID, and operationID. */
  operationsAcceptedChanges: Array<OperationAcceptedChange>;
  /** Get an operations check result for a specific check ID */
  operationsCheck: Maybe<OperationsCheckResult>;
  /** The Persisted Query List associated with this graph with the given ID. */
  persistedQueryList: Maybe<PersistedQueryList>;
  persistedQueryLists: Maybe<Array<PersistedQueryList>>;
  /** Look up a single policy exception in this graph by id. */
  policyException: PolicyException;
  /** All active policy exceptions for this graph, paginated. */
  policyExceptions: PolicyExceptionPage;
  /** Look up a single policy rule in this graph by id. */
  policyRule: PolicyRule;
  /**
   * All active policy rules for this graph, paginated, with optional
   * filtering.
   */
  policyRules: PolicyRulePage;
  /** A template that is the base description for new schema proposals */
  proposalDescriptionTemplate: Maybe<Scalars['String']['output']>;
  /** The current active user's Proposal notification status on this graph. */
  proposalNotificationStatus: NotificationStatus;
  /**
   * A list of the proposals for this graph sorted by created at date.
   * limit defaults to 25 and has an allowed max of 50, offset defaults to 0.
   * This field accepts up to 1000 requests per minute. This rate may be temporarily adjusted based on system conditions.
   */
  proposals: ProposalsResult;
  /** If the graph setting for the proposals implementation variant has been set, this will be non null. */
  proposalsImplementationVariant: Maybe<GraphVariant>;
  /** Must one of the default reviewers approve proposals */
  proposalsMustBeApprovedByADefaultReviewer: Scalars['Boolean']['output'];
  /** True if each approving reviewer's review will get dismissed & the proposal status will change from approved to open on new revisions. */
  proposalsMustBeReApprovedOnChange: Scalars['Boolean']['output'];
  /** Get query triggers for a given variant. If variant is null all the triggers for this service will be gotten. */
  queryTriggers: Maybe<Array<QueryTrigger>>;
  readme: Maybe<Readme>;
  /** Registry specific stats for this graph. */
  registryStatsWindow: Maybe<RegistryStatsWindow>;
  /**
   * Whether registry subscriptions (with any options) are enabled. If variant is not passed, returns true if configuration is present for any variant
   * @deprecated This field will be removed
   */
  registrySubscriptionsEnabled: Scalars['Boolean']['output'];
  reportingEnabled: Scalars['Boolean']['output'];
  /** The list of members that can access this graph, accounting for graph role overrides */
  roleOverrides: Maybe<Array<RoleOverride>>;
  /** Describes the permissions that the active user has for this graph. */
  roles: Maybe<ServiceRoles>;
  ruleEnforcement: Maybe<RuleEnforcement>;
  /** Get a specific assessment for this graph by its ID. */
  safAssessment: Maybe<SafAssessment>;
  /** All assessments for this graph. */
  safAssessments: Array<SafAssessment>;
  scheduledSummaries: Array<ScheduledSummary>;
  /** Get a schema by hash or current tag */
  schema: Maybe<Schema>;
  /**
   *  Returns a timeseries of object field, input object field, and enum value metrics across a specified time range for this graph. This will return specified
   *  metrics (request count, error count, etc) grouped by time and the specified dimensions (parent type, field name, client name, etc). This API is rate
   *  limited and only allows a small number of requests per minute, and will return a RATE_LIMIT_EXCEEDED error if too many requests are made for a graph. If a
   * request to this field times out, we recommend that you try a shorter time range or fewer dimensions.
   */
  schemaCoordinateInsightsTimeseriesReport: SchemaCoordinateInsightsTimeseriesReportResult;
  /** The current publish associated to a given variant (with 'tag' as the variant name). */
  schemaTag: Maybe<SchemaTag>;
  schemaTagById: Maybe<SchemaTag>;
  /**
   * Get schema tags, with optional filtering to a set of tags. Always sorted by creation
   * date in reverse chronological order.
   */
  schemaTags: Maybe<Array<SchemaTag>>;
  /** @deprecated use Service.statsWindow instead */
  stats: ServiceStatsWindow;
  statsWindow: Maybe<ServiceStatsWindow>;
  /**
   *  Returns a timeseries of subgraph and connector fetch metrics across a specified time range for this graph. Each
   * request from the router to a subgraph or connector service is counted as a fetch. A single GraphQL operation can
   * result in multiple fetches, depending on the operation shape and query plan. This will return specified metrics (fetch
   * count, avg latency, etc.) grouped by time and the specified dimensions (fetch service ID, fetch service name, client
   * name, etc.). This API is rate limited and only allows a small number of requests per minute, and will return a
   * RATE_LIMIT_EXCEEDED error if too many requests are made for a graph. If a request to this field times out, we
   * recommend that you try a shorter time range or fewer dimensions.
   */
  subgraphInsightsTimeseriesReport: SubgraphInsightsTimeseriesReportResult;
  /** Generate a test schema publish notification body */
  testSchemaPublishBody: Scalars['String']['output'];
  /** The graph's name. */
  title: Scalars['String']['output'];
  /** Count checkWorkflows for the given filter. Used for paginating with checkWorkflows. */
  totalCheckWorkflowCount: Scalars['Int']['output'];
  trace: Maybe<Trace>;
  traceStorageEnabled: Scalars['Boolean']['output'];
  /**
   * Provides details of the graph variant with the provided `name`, if a variant
   * with that name exists for this graph. Otherwise, returns null.
   *
   *  For a list of _all_ variants associated with a graph, use `Graph.variants` instead.
   */
  variant: Maybe<GraphVariant>;
  /** A list of the variants for this graph. */
  variants: Array<GraphVariant>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceaccessRequestArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceaccessRequestsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccessRequestFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceavatarUrlArgs = {
  size: Scalars['Int']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechannelsArgs = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicecheckWorkflowArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicecheckWorkflowTaskArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicecheckWorkflowsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechecksAuthorOptionsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechecksBranchOptionsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechecksCommitterOptionsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechecksCreatedByOptionsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicechecksSubgraphOptionsArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicecompositionBuildCheckResultArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicecompositionResultByIdArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicedocArgs = {
  hash?: InputMaybe<Scalars['SHA256']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicedocsArgs = {
  hashes: Array<Scalars['SHA256']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicedocumentArgs = {
  hash?: InputMaybe<Scalars['SHA256']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceflatDiffArgs = {
  newSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
  oldSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicegraphArtifactTagArgs = {
  tag: Scalars['String']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicegraphArtifactTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicegraphArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceimplementingServicesArgs = {
  graphVariant: Scalars['String']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicelastReportedAtArgs = {
  graphVariant?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicemostRecentCompositionPublishArgs = {
  graphVariant: Scalars['String']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceoperationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceoperationCheckRequestsByVariantArgs = {
  from: Scalars['Timestamp']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceoperationInsightsTimeseriesReportArgs = {
  dimensions: Array<OperationInsightsTimeseriesReportDimension>;
  filters?: InputMaybe<OperationInsightsTimeseriesReportFilterInput>;
  from: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
  metrics: Array<OperationInsightsTimeseriesReportMetric>;
  orderBy?: InputMaybe<OperationInsightsTimeseriesReportOrderByInput>;
  resolution: TimeseriesReportResolution;
  to: Scalars['Timestamp']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceoperationsAcceptedChangesArgs = {
  checkID: Scalars['ID']['input'];
  operationID: Scalars['String']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceoperationsCheckArgs = {
  checkID: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicepersistedQueryListArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicepolicyExceptionArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicepolicyExceptionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicepolicyRuleArgs = {
  id: Scalars['UUID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicepolicyRulesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PolicyRuleFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceproposalsArgs = {
  filterBy?: InputMaybe<ProposalsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicequeryTriggersArgs = {
  graphVariant?: InputMaybe<Scalars['String']['input']>;
  operationNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceregistryStatsWindowArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceregistrySubscriptionsEnabledArgs = {
  graphVariant?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceruleEnforcementArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicesafAssessmentArgs = {
  id: Scalars['ID']['input'];
  includeDeleted: Scalars['Boolean']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicesafAssessmentsArgs = {
  includeDeleted: Scalars['Boolean']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceschemaArgs = {
  hash?: InputMaybe<Scalars['ID']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceschemaCoordinateInsightsTimeseriesReportArgs = {
  dimensions?: InputMaybe<Array<SchemaCoordinateInsightsTimeseriesReportDimension>>;
  filters?: InputMaybe<SchemaCoordinateInsightsTimeseriesReportFilterInput>;
  from: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
  metrics?: InputMaybe<Array<SchemaCoordinateInsightsTimeseriesReportMetric>>;
  orderBy?: InputMaybe<SchemaCoordinateInsightsTimeseriesReportOrderByInput>;
  resolution?: InputMaybe<TimeseriesReportResolution>;
  to: Scalars['Timestamp']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceschemaTagArgs = {
  tag: Scalars['String']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceschemaTagByIdArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServiceschemaTagsArgs = {
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicestatsArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicestatsWindowArgs = {
  from: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicesubgraphInsightsTimeseriesReportArgs = {
  dimensions: Array<SubgraphInsightsTimeseriesReportDimension>;
  filters?: InputMaybe<SubgraphInsightsTimeseriesReportFilterInput>;
  from: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
  metrics: Array<SubgraphInsightsTimeseriesReportMetric>;
  orderBy?: InputMaybe<SubgraphInsightsTimeseriesReportOrderByInput>;
  resolution: TimeseriesReportResolution;
  to: Scalars['Timestamp']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicetestSchemaPublishBodyArgs = {
  variant: Scalars['String']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicetotalCheckWorkflowCountArgs = {
  filter?: InputMaybe<CheckFilterInput>;
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicetraceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * A graph in Apollo Studio represents a graph in your organization.
 * Each graph has one or more variants, which correspond to the different environments where that graph runs (such as staging and production).
 * Each variant has its own GraphQL schema, which means schemas can differ between environments.
 */
export type ServicevariantArgs = {
  name: Scalars['String']['input'];
};

/** Represents a machine identity associated with an organization. Used as a principal for API keys. */
export type ServiceAccount = Identity & {
  __typename: 'ServiceAccount';
  /** Returns a representation of this service account as an `Actor` type. Useful when determining which actor performed a particular action in Studio. */
  asActor: Actor;
  /** The service account's unique id. */
  id: Scalars['ID']['output'];
  /** The name assigned to this service account. */
  name: Scalars['String']['output'];
  /** The organization this service account belongs to. */
  organization: Maybe<Account>;
  /** Internal, immutable ID of the organization this service account belongs to. */
  organizationInternalID: Scalars['ID']['output'];
  /** The type of service account, indicating its intended use case. */
  type: ServiceAccountKind;
};

/** The type of service account, indicating its intended use case. */
export enum ServiceAccountKind {
  /** A gateway service account used for gateway operations */
  GATEWAY = 'GATEWAY',
  /** The identity of an OAuth client using the `client_credentials` grant */
  OAUTH_CLIENT_CREDENTIALS = 'OAUTH_CLIENT_CREDENTIALS',
  /** An operator service account used for administrative operations */
  OPERATOR = 'OPERATOR',
  /** A pipeline service account used for data processing operations */
  PIPELINE = 'PIPELINE',
  /** A router service account used for Apollo Router operations */
  ROUTER = 'ROUTER',
  /** A SCIM service account used for user provisioning and management */
  SCIM = 'SCIM',
  /** An unknown or unspecified service account type */
  UNKNOWN = 'UNKNOWN',
  /** A variant service account used for variant operations */
  VARIANT = 'VARIANT'
}

/** Columns of ServiceBillingUsageStats. */
export enum ServiceBillingUsageStatsColumn {
  AGENT_ID = 'AGENT_ID',
  AGENT_VERSION = 'AGENT_VERSION',
  GRAPH_DEPLOYMENT_TYPE = 'GRAPH_DEPLOYMENT_TYPE',
  OPERATION_COUNT = 'OPERATION_COUNT',
  OPERATION_COUNT_PROVIDED_EXPLICITLY = 'OPERATION_COUNT_PROVIDED_EXPLICITLY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  ROUTER_FEATURES_ENABLED = 'ROUTER_FEATURES_ENABLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceBillingUsageStatsDimensions = {
  __typename: 'ServiceBillingUsageStatsDimensions';
  agentId: Maybe<Scalars['String']['output']>;
  agentVersion: Maybe<Scalars['String']['output']>;
  graphDeploymentType: Maybe<Scalars['String']['output']>;
  operationCountProvidedExplicitly: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  routerFeaturesEnabled: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceBillingUsageStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceBillingUsageStatsFilter = {
  /** Selects rows whose agentId dimension equals the given value if not null. To query for the null value, use {in: {agentId: [null]}} instead. */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<ServiceBillingUsageStatsFilter>>;
  /** Selects rows whose graphDeploymentType dimension equals the given value if not null. To query for the null value, use {in: {graphDeploymentType: [null]}} instead. */
  graphDeploymentType?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceBillingUsageStatsFilterIn>;
  not?: InputMaybe<ServiceBillingUsageStatsFilter>;
  /** Selects rows whose operationCountProvidedExplicitly dimension equals the given value if not null. To query for the null value, use {in: {operationCountProvidedExplicitly: [null]}} instead. */
  operationCountProvidedExplicitly?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceBillingUsageStatsFilter>>;
  /** Selects rows whose routerFeaturesEnabled dimension equals the given value if not null. To query for the null value, use {in: {routerFeaturesEnabled: [null]}} instead. */
  routerFeaturesEnabled?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceBillingUsageStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceBillingUsageStatsFilterIn = {
  /** Selects rows whose agentId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose graphDeploymentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  graphDeploymentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationCountProvidedExplicitly dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationCountProvidedExplicitly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerFeaturesEnabled dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerFeaturesEnabled?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceBillingUsageStatsMetrics = {
  __typename: 'ServiceBillingUsageStatsMetrics';
  operationCount: Scalars['Long']['output'];
};

export type ServiceBillingUsageStatsOrderBySpec = {
  column: ServiceBillingUsageStatsColumn;
  direction: Ordering;
};

export type ServiceBillingUsageStatsRecord = {
  __typename: 'ServiceBillingUsageStatsRecord';
  /** Dimensions of ServiceBillingUsageStats that can be grouped by. */
  groupBy: ServiceBillingUsageStatsDimensions;
  /** Metrics of ServiceBillingUsageStats that can be aggregated over. */
  metrics: ServiceBillingUsageStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceCardinalityStats. */
export enum ServiceCardinalityStatsColumn {
  CLIENT_NAME_CARDINALITY = 'CLIENT_NAME_CARDINALITY',
  CLIENT_VERSION_CARDINALITY = 'CLIENT_VERSION_CARDINALITY',
  OPERATION_SHAPE_CARDINALITY = 'OPERATION_SHAPE_CARDINALITY',
  SCHEMA_COORDINATE_CARDINALITY = 'SCHEMA_COORDINATE_CARDINALITY',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceCardinalityStatsDimensions = {
  __typename: 'ServiceCardinalityStatsDimensions';
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceCardinalityStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceCardinalityStatsFilter = {
  and?: InputMaybe<Array<ServiceCardinalityStatsFilter>>;
  in?: InputMaybe<ServiceCardinalityStatsFilterIn>;
  not?: InputMaybe<ServiceCardinalityStatsFilter>;
  or?: InputMaybe<Array<ServiceCardinalityStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceCardinalityStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceCardinalityStatsFilterIn = {
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceCardinalityStatsMetrics = {
  __typename: 'ServiceCardinalityStatsMetrics';
  clientNameCardinality: Scalars['Float']['output'];
  clientVersionCardinality: Scalars['Float']['output'];
  operationShapeCardinality: Scalars['Float']['output'];
  schemaCoordinateCardinality: Scalars['Float']['output'];
};

export type ServiceCardinalityStatsOrderBySpec = {
  column: ServiceCardinalityStatsColumn;
  direction: Ordering;
};

export type ServiceCardinalityStatsRecord = {
  __typename: 'ServiceCardinalityStatsRecord';
  /** Dimensions of ServiceCardinalityStats that can be grouped by. */
  groupBy: ServiceCardinalityStatsDimensions;
  /** Metrics of ServiceCardinalityStats that can be aggregated over. */
  metrics: ServiceCardinalityStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export type ServiceCatalogPage = {
  __typename: 'ServiceCatalogPage';
  /** Cursor for the next page of data */
  cursor: Maybe<Scalars['String']['output']>;
  /** A list of catalog service entries */
  items: Array<ServiceCatalogType>;
};

/** A versioned catalog entry containing a service's GraphQL schema template. */
export type ServiceCatalogType = {
  __typename: 'ServiceCatalogType';
  /**
   * Orgs explicitly granted access to this catalog entry. Empty means
   * the entry is public — visible to every org.
   */
  allowedOrgIds: Array<Scalars['String']['output']>;
  /** Timestamp when the catalog entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Suggested auth configuration to prefill when creating a service from
   * this entry. Same shape as `UpstreamService.auth`.
   */
  defaultAuth: Maybe<Scalars['JSON']['output']>;
  /** Suggested base URL to prefill when creating a service from this entry. */
  defaultBaseUrl: Maybe<Scalars['String']['output']>;
  /**
   * Field-level classification tags this catalog entry seeds a new service
   * with, keyed by schema coordinate. Extracted from the `@tag` directives
   * in `schemaTemplate`, and re-extracted whenever `schemaTemplate` is
   * written — by `createServiceCatalogEntry` for a new version, or by
   * `updateServiceCatalogEntry` for this one. There is no way to set them
   * apart from the SDL they come from.
   *
   * The defaults only: once a service exists, its own tags are
   * independently owned and are read and edited through
   * `UpstreamService.fieldTags` / `setServiceFieldTags`.
   */
  defaultFieldTags: Array<ServiceFieldTag>;
  /** Timestamp when the catalog entry was soft-deleted, or null if active. */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Description of what this connector does. */
  description: Maybe<Scalars['String']['output']>;
  /** Human-readable name for this catalog entry (e.g. "Slack"). */
  displayName: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this catalog entry. */
  id: Scalars['UUID']['output'];
  /** GraphQL schema template for this version of the service connector. */
  schemaTemplate: Maybe<Scalars['String']['output']>;
  /** Identifier of the service connector this catalog entry describes. */
  serviceId: Scalars['String']['output'];
  /** Timestamp when the catalog entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Version timestamp for this catalog entry. */
  version: Scalars['DateTime']['output'];
};

/** Columns of ServiceCoordinateUsage. */
export enum ServiceCoordinateUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  KIND = 'KIND',
  NAMED_ATTRIBUTE = 'NAMED_ATTRIBUTE',
  NAMED_TYPE = 'NAMED_TYPE',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUEST_COUNT_NULL = 'REQUEST_COUNT_NULL',
  REQUEST_COUNT_UNDEFINED = 'REQUEST_COUNT_UNDEFINED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceCoordinateUsageDimensions = {
  __typename: 'ServiceCoordinateUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  namedAttribute: Maybe<Scalars['String']['output']>;
  namedType: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['String']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceCoordinateUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceCoordinateUsageFilter = {
  and?: InputMaybe<Array<ServiceCoordinateUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceCoordinateUsageFilterIn>;
  /** Selects rows whose kind dimension equals the given value if not null. To query for the null value, use {in: {kind: [null]}} instead. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedAttribute dimension equals the given value if not null. To query for the null value, use {in: {namedAttribute: [null]}} instead. */
  namedAttribute?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose namedType dimension equals the given value if not null. To query for the null value, use {in: {namedType: [null]}} instead. */
  namedType?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<ServiceCoordinateUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceCoordinateUsageFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceCoordinateUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceCoordinateUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose kind dimension is in the given list. A null value in the list means a row with null for that dimension. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedAttribute dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedAttribute?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose namedType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  namedType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceCoordinateUsageMetrics = {
  __typename: 'ServiceCoordinateUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestCountNull: Scalars['Long']['output'];
  requestCountUndefined: Scalars['Long']['output'];
};

export type ServiceCoordinateUsageOrderBySpec = {
  column: ServiceCoordinateUsageColumn;
  direction: Ordering;
};

export type ServiceCoordinateUsageRecord = {
  __typename: 'ServiceCoordinateUsageRecord';
  /** Dimensions of ServiceCoordinateUsage that can be grouped by. */
  groupBy: ServiceCoordinateUsageDimensions;
  /** Metrics of ServiceCoordinateUsage that can be aggregated over. */
  metrics: ServiceCoordinateUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceEdgeServerInfos. */
export enum ServiceEdgeServerInfosColumn {
  BOOT_ID = 'BOOT_ID',
  EXECUTABLE_SCHEMA_ID = 'EXECUTABLE_SCHEMA_ID',
  LIBRARY_VERSION = 'LIBRARY_VERSION',
  PLATFORM = 'PLATFORM',
  RUNTIME_VERSION = 'RUNTIME_VERSION',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVER_ID = 'SERVER_ID',
  TIMESTAMP = 'TIMESTAMP',
  USER_VERSION = 'USER_VERSION'
}

export type ServiceEdgeServerInfosDimensions = {
  __typename: 'ServiceEdgeServerInfosDimensions';
  bootId: Maybe<Scalars['ID']['output']>;
  executableSchemaId: Maybe<Scalars['ID']['output']>;
  libraryVersion: Maybe<Scalars['String']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  runtimeVersion: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serverId: Maybe<Scalars['ID']['output']>;
  userVersion: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceEdgeServerInfos. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceEdgeServerInfosFilter = {
  and?: InputMaybe<Array<ServiceEdgeServerInfosFilter>>;
  /** Selects rows whose bootId dimension equals the given value if not null. To query for the null value, use {in: {bootId: [null]}} instead. */
  bootId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose executableSchemaId dimension equals the given value if not null. To query for the null value, use {in: {executableSchemaId: [null]}} instead. */
  executableSchemaId?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<ServiceEdgeServerInfosFilterIn>;
  /** Selects rows whose libraryVersion dimension equals the given value if not null. To query for the null value, use {in: {libraryVersion: [null]}} instead. */
  libraryVersion?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<ServiceEdgeServerInfosFilter>;
  or?: InputMaybe<Array<ServiceEdgeServerInfosFilter>>;
  /** Selects rows whose platform dimension equals the given value if not null. To query for the null value, use {in: {platform: [null]}} instead. */
  platform?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose runtimeVersion dimension equals the given value if not null. To query for the null value, use {in: {runtimeVersion: [null]}} instead. */
  runtimeVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serverId dimension equals the given value if not null. To query for the null value, use {in: {serverId: [null]}} instead. */
  serverId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose userVersion dimension equals the given value if not null. To query for the null value, use {in: {userVersion: [null]}} instead. */
  userVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceEdgeServerInfos. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceEdgeServerInfosFilterIn = {
  /** Selects rows whose bootId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  bootId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose executableSchemaId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  executableSchemaId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose libraryVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  libraryVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose platform dimension is in the given list. A null value in the list means a row with null for that dimension. */
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose runtimeVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  runtimeVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serverId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serverId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose userVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  userVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceEdgeServerInfosOrderBySpec = {
  column: ServiceEdgeServerInfosColumn;
  direction: Ordering;
};

export type ServiceEdgeServerInfosRecord = {
  __typename: 'ServiceEdgeServerInfosRecord';
  /** Dimensions of ServiceEdgeServerInfos that can be grouped by. */
  groupBy: ServiceEdgeServerInfosDimensions;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceErrorStats. */
export enum ServiceErrorStatsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERRORS_COUNT = 'ERRORS_COUNT',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceErrorStatsDimensions = {
  __typename: 'ServiceErrorStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceErrorStatsFilter = {
  and?: InputMaybe<Array<ServiceErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceErrorStatsFilterIn>;
  not?: InputMaybe<ServiceErrorStatsFilter>;
  or?: InputMaybe<Array<ServiceErrorStatsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceErrorStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceErrorStatsMetrics = {
  __typename: 'ServiceErrorStatsMetrics';
  errorsCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type ServiceErrorStatsOrderBySpec = {
  column: ServiceErrorStatsColumn;
  direction: Ordering;
};

export type ServiceErrorStatsRecord = {
  __typename: 'ServiceErrorStatsRecord';
  /** Dimensions of ServiceErrorStats that can be grouped by. */
  groupBy: ServiceErrorStatsDimensions;
  /** Metrics of ServiceErrorStats that can be aggregated over. */
  metrics: ServiceErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceFederatedErrorStats. */
export enum ServiceFederatedErrorStatsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_COUNT = 'ERROR_COUNT',
  ERROR_PATH = 'ERROR_PATH',
  ERROR_SERVICE = 'ERROR_SERVICE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SEVERITY = 'SEVERITY',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceFederatedErrorStatsDimensions = {
  __typename: 'ServiceFederatedErrorStatsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorPath: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceFederatedErrorStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceFederatedErrorStatsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<ServiceFederatedErrorStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorPath dimension equals the given value if not null. To query for the null value, use {in: {errorPath: [null]}} instead. */
  errorPath?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceFederatedErrorStatsFilterIn>;
  not?: InputMaybe<ServiceFederatedErrorStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceFederatedErrorStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose severity dimension equals the given value if not null. To query for the null value, use {in: {severity: [null]}} instead. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceFederatedErrorStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceFederatedErrorStatsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorPath dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose severity dimension is in the given list. A null value in the list means a row with null for that dimension. */
  severity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceFederatedErrorStatsMetrics = {
  __typename: 'ServiceFederatedErrorStatsMetrics';
  errorCount: Scalars['Long']['output'];
};

export type ServiceFederatedErrorStatsOrderBySpec = {
  column: ServiceFederatedErrorStatsColumn;
  direction: Ordering;
};

export type ServiceFederatedErrorStatsRecord = {
  __typename: 'ServiceFederatedErrorStatsRecord';
  /** Dimensions of ServiceFederatedErrorStats that can be grouped by. */
  groupBy: ServiceFederatedErrorStatsDimensions;
  /** Metrics of ServiceFederatedErrorStats that can be aggregated over. */
  metrics: ServiceFederatedErrorStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceFieldExecutions. */
export enum ServiceFieldExecutionsColumn {
  ERRORS_COUNT = 'ERRORS_COUNT',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  FIELD_HISTOGRAM = 'FIELD_HISTOGRAM',
  FIELD_NAME = 'FIELD_NAME',
  OBSERVED_EXECUTION_COUNT = 'OBSERVED_EXECUTION_COUNT',
  PARENT_TYPE = 'PARENT_TYPE',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceFieldExecutionsDimensions = {
  __typename: 'ServiceFieldExecutionsDimensions';
  field: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceFieldExecutions. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceFieldExecutionsFilter = {
  and?: InputMaybe<Array<ServiceFieldExecutionsFilter>>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceFieldExecutionsFilterIn>;
  not?: InputMaybe<ServiceFieldExecutionsFilter>;
  or?: InputMaybe<Array<ServiceFieldExecutionsFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceFieldExecutions. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceFieldExecutionsFilterIn = {
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceFieldExecutionsMetrics = {
  __typename: 'ServiceFieldExecutionsMetrics';
  errorsCount: Scalars['Long']['output'];
  estimatedExecutionCount: Scalars['Long']['output'];
  fieldHistogram: DurationHistogram;
  observedExecutionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
};

export type ServiceFieldExecutionsOrderBySpec = {
  column: ServiceFieldExecutionsColumn;
  direction: Ordering;
};

export type ServiceFieldExecutionsRecord = {
  __typename: 'ServiceFieldExecutionsRecord';
  /** Dimensions of ServiceFieldExecutions that can be grouped by. */
  groupBy: ServiceFieldExecutionsDimensions;
  /** Metrics of ServiceFieldExecutions that can be aggregated over. */
  metrics: ServiceFieldExecutionsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A field-level classification tag on one connected service instance. */
export type ServiceFieldTag = {
  __typename: 'ServiceFieldTag';
  /** The schema coordinate, e.g. "Ashby_Mutation.ashby_createCandidate". */
  coordinate: Scalars['String']['output'];
  /** The full tag set for this coordinate (empty = no tags). */
  tags: Array<Scalars['String']['output']>;
};

/** Why one coordinate in a batch could not be applied. */
export type ServiceFieldTagError = {
  __typename: 'ServiceFieldTagError';
  /**
   * Human-readable explanation, suitable for showing inline against the
   * offending coordinate.
   */
  message: Scalars['String']['output'];
};

/**
 * One coordinate's replacement tag set within a `setServiceFieldTagsBatch`
 * call.
 */
export type ServiceFieldTagInput = {
  /** The schema coordinate to set tags on, e.g. "Ashby_Job.salary". */
  coordinate: Scalars['String']['input'];
  /**
   * The full tag set for this coordinate — replaces whatever is there now;
   * an empty list clears it.
   */
  tags: Array<Scalars['String']['input']>;
};

/**
 * One classification tag in use across an organization's connected
 * services, with how far it reaches. Backs tag filters and pickers, which
 * need the org's vocabulary without paginating every service's `fieldTags`.
 */
export type ServiceFieldTagSummary = {
  __typename: 'ServiceFieldTagSummary';
  /**
   * How many tagged fields carry it, counted per (service, coordinate)
   * pair — the same coordinate on two services counts twice, because those
   * are two distinct fields.
   */
  coordinateCount: Scalars['Int']['output'];
  /** How many connected services have at least one field carrying this tag. */
  serviceCount: Scalars['Int']['output'];
  /** The tag value, e.g. "sensitivity:PII". */
  tag: Scalars['String']['output'];
};

/** Columns of ServiceFieldUsage. */
export enum ServiceFieldUsageColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  ESTIMATED_EXECUTION_COUNT = 'ESTIMATED_EXECUTION_COUNT',
  EXECUTION_COUNT = 'EXECUTION_COUNT',
  FIELD_NAME = 'FIELD_NAME',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PARENT_TYPE = 'PARENT_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REFERENCING_OPERATION_COUNT = 'REFERENCING_OPERATION_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceFieldUsageDimensions = {
  __typename: 'ServiceFieldUsageDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  parentType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceFieldUsage. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceFieldUsageFilter = {
  and?: InputMaybe<Array<ServiceFieldUsageFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fieldName dimension equals the given value if not null. To query for the null value, use {in: {fieldName: [null]}} instead. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceFieldUsageFilterIn>;
  not?: InputMaybe<ServiceFieldUsageFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceFieldUsageFilter>>;
  /** Selects rows whose parentType dimension equals the given value if not null. To query for the null value, use {in: {parentType: [null]}} instead. */
  parentType?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceFieldUsage. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceFieldUsageFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fieldName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fieldName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose parentType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  parentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceFieldUsageMetrics = {
  __typename: 'ServiceFieldUsageMetrics';
  estimatedExecutionCount: Scalars['Long']['output'];
  executionCount: Scalars['Long']['output'];
  referencingOperationCount: Scalars['Long']['output'];
};

export type ServiceFieldUsageOrderBySpec = {
  column: ServiceFieldUsageColumn;
  direction: Ordering;
};

export type ServiceFieldUsageRecord = {
  __typename: 'ServiceFieldUsageRecord';
  /** Dimensions of ServiceFieldUsage that can be grouped by. */
  groupBy: ServiceFieldUsageDimensions;
  /** Metrics of ServiceFieldUsage that can be aggregated over. */
  metrics: ServiceFieldUsageMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceGraphosCloudMetrics. */
export enum ServiceGraphosCloudMetricsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLOUD_PROVIDER = 'CLOUD_PROVIDER',
  RESPONSE_SIZE = 'RESPONSE_SIZE',
  RESPONSE_SIZE_THROTTLED = 'RESPONSE_SIZE_THROTTLED',
  ROUTER_ID = 'ROUTER_ID',
  ROUTER_OPERATIONS = 'ROUTER_OPERATIONS',
  ROUTER_OPERATIONS_THROTTLED = 'ROUTER_OPERATIONS_THROTTLED',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SUBGRAPH_FETCHES = 'SUBGRAPH_FETCHES',
  SUBGRAPH_FETCHES_THROTTLED = 'SUBGRAPH_FETCHES_THROTTLED',
  TIER = 'TIER',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceGraphosCloudMetricsDimensions = {
  __typename: 'ServiceGraphosCloudMetricsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  cloudProvider: Maybe<Scalars['String']['output']>;
  routerId: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  tier: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceGraphosCloudMetrics. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceGraphosCloudMetricsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<ServiceGraphosCloudMetricsFilter>>;
  /** Selects rows whose cloudProvider dimension equals the given value if not null. To query for the null value, use {in: {cloudProvider: [null]}} instead. */
  cloudProvider?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceGraphosCloudMetricsFilterIn>;
  not?: InputMaybe<ServiceGraphosCloudMetricsFilter>;
  or?: InputMaybe<Array<ServiceGraphosCloudMetricsFilter>>;
  /** Selects rows whose routerId dimension equals the given value if not null. To query for the null value, use {in: {routerId: [null]}} instead. */
  routerId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose tier dimension equals the given value if not null. To query for the null value, use {in: {tier: [null]}} instead. */
  tier?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceGraphosCloudMetrics. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceGraphosCloudMetricsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose cloudProvider dimension is in the given list. A null value in the list means a row with null for that dimension. */
  cloudProvider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose routerId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  routerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose tier dimension is in the given list. A null value in the list means a row with null for that dimension. */
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceGraphosCloudMetricsMetrics = {
  __typename: 'ServiceGraphosCloudMetricsMetrics';
  responseSize: Scalars['Long']['output'];
  responseSizeThrottled: Scalars['Long']['output'];
  routerOperations: Scalars['Long']['output'];
  routerOperationsThrottled: Scalars['Long']['output'];
  subgraphFetches: Scalars['Long']['output'];
  subgraphFetchesThrottled: Scalars['Long']['output'];
};

export type ServiceGraphosCloudMetricsOrderBySpec = {
  column: ServiceGraphosCloudMetricsColumn;
  direction: Ordering;
};

export type ServiceGraphosCloudMetricsRecord = {
  __typename: 'ServiceGraphosCloudMetricsRecord';
  /** Dimensions of ServiceGraphosCloudMetrics that can be grouped by. */
  groupBy: ServiceGraphosCloudMetricsDimensions;
  /** Metrics of ServiceGraphosCloudMetrics that can be aggregated over. */
  metrics: ServiceGraphosCloudMetricsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutation = {
  __typename: 'ServiceMutation';
  /**
   * Checks a proposed subgraph schema change against a published subgraph.
   * If the proposal composes successfully, perform a usage check for the resulting supergraph schema.
   * @deprecated Use GraphVariant.submitSubgraphCheckAsync instead.
   * This mutation polls to wait for the check to finish,
   * while subgraphSubgraphCheckAsync triggers returns
   * without waiting for the check to finish.
   */
  checkPartialSchema: CheckPartialSchemaResult;
  /**
   * Checks a proposed schema against the schema that has been published to
   * a particular variant, using metrics corresponding to `historicParameters`.
   * Callers can set `historicParameters` directly or rely on defaults set in the
   * graph's check configuration (7 days by default).
   * If they do not set `historicParameters` but set `useMaximumRetention`,
   * validation will use the maximum retention the graph has access to.
   */
  checkSchema: CheckSchemaResult;
  /** Make changes to a check workflow. */
  checkWorkflow: Maybe<CheckWorkflowMutation>;
  /**
   * Creates a new access request for this graph.
   *
   * Does NOT recompile the policy bundle — access requests are reviewed
   * out of band and do not affect policy evaluation until an approve
   * decision is folded into a `PolicyException`.
   */
  createAccessRequest: AccessRequest;
  /**
   * Creates a new access request for this graph using a service name
   *
   * Does NOT recompile the policy bundle — access requests are reviewed
   * out of band and do not affect policy evaluation until an approve
   * decision is folded into a `PolicyException`.
   */
  createAccessRequestByServiceName: AccessRequest;
  createCompositionStatusSubscription: SchemaPublishSubscription;
  /** Create a new Persisted Query List. */
  createPersistedQueryList: CreatePersistedQueryListResultOrError;
  /** Creates a new policy exception for this graph. */
  createPolicyException: PolicyException;
  /** Creates a new policy rule for this graph. */
  createPolicyRule: PolicyRule;
  /** Creates a proposal variant from a source variant and a name, description. See the documentation for proposal creation at https://www.apollographql.com/docs/graphos/delivery/schema-proposals/creation This field accepts up to 500 requests per minute. This rate may be temporarily adjusted based on system conditions. */
  createProposal: CreateProposalResult;
  /** Subscribes a webhook channel to Proposal lifecycle events on this graph. */
  createProposalLifecycleSubscription: CreateProposalLifecycleSubscriptionResult;
  /** Creates a proposal variant from a source variant and a name, description. Do not call this from any clients, this resolver is exclusively for inter-service proposal -> kotlin registry communication. */
  createProposalVariant: ProposalVariantCreationResult;
  createRuleEnforcement: RuleEnforcementResult;
  /** Create a new assessment for this graph. */
  createSafAssessment: SafAssessment;
  createSchemaPublishSubscription: SchemaPublishSubscription;
  /** Update the default build pipeline track for this graph. */
  defaultBuildPipelineTrack: Maybe<BuildPipelineTrack>;
  /** Update the default Federation version for this graph. */
  defaultFederationVersion: Maybe<Scalars['FederationVersion']['output']>;
  /** Soft delete a graph. Data associated with the graph is not permanently deleted; Apollo support can undo. */
  delete: Maybe<Scalars['Void']['output']>;
  /** Delete the service's avatar. Requires Service.roles.canUpdateAvatar to be true. */
  deleteAvatar: Maybe<AvatarDeleteError>;
  /** Delete an existing channel */
  deleteChannel: Scalars['Boolean']['output'];
  /** Soft-deletes a policy exception by id. */
  deletePolicyException: Scalars['Boolean']['output'];
  /** Soft-deletes a policy rule by id. Returns true on first delete, false on miss / already deleted. */
  deletePolicyRule: Scalars['Boolean']['output'];
  /** Deletes this service's current subscriptions specific by ID. */
  deleteProposalLifecycleSubscription: DeleteProposalLifecycleSubscriptionResult;
  /** Delete an existing query trigger */
  deleteQueryTrigger: Scalars['Boolean']['output'];
  /** Deletes this service's current subscriptions specific to the ID, returns true if it existed */
  deleteRegistrySubscription: Scalars['Boolean']['output'];
  /**
   * Deletes this service's current registry subscription(s) specific to its graph variant,
   * returns a list of subscription IDs that were deleted.
   */
  deleteRegistrySubscriptions: Array<Scalars['ID']['output']>;
  deleteRuleEnforcement: Scalars['Boolean']['output'];
  deleteScheduledSummary: Scalars['Boolean']['output'];
  /** Delete a variant by name. */
  deleteSchemaTag: DeleteSchemaTagResult;
  /** Given a UTC timestamp, delete all traces associated with this Service, on that corresponding day. If a timestamp to is provided, deletes all days inclusive. */
  deleteTraces: Maybe<Scalars['Void']['output']>;
  disableDatadogForwardingLegacyMetricNames: Maybe<Service>;
  /** Hard delete a graph and all data associated with it. Its ID cannot be reused. */
  hardDelete: Maybe<Scalars['Void']['output']>;
  /** @deprecated Use service.id */
  id: Scalars['ID']['output'];
  /**
   * Ignore all operations in future checks and changes affecting it will be tracked,
   * but won't affect the outcome of the check.
   */
  ignoreAllOperationsInChecks: Maybe<IgnoreOperationsInChecksResult>;
  /**
   * Ignore an operation in future checks;
   * changes affecting it will be tracked,
   * but won't affect the outcome of the check.
   * Returns true if the operation is newly ignored,
   * false if it already was.
   */
  ignoreOperationsInChecks: Maybe<IgnoreOperationsInChecksResult>;
  /** Lint a single schema using the graph's linter configuration. */
  lintSchema: LintResult;
  /** Transitions graph to a 'SELF_HOSTED_SUPERGRAPH' type and removes related cloud configuration. */
  makeSelfHostedIfCloudy: Maybe<Scalars['Void']['output']>;
  /** Mark any changes within the specified check for all operations as safe. Future checks will not fail for those operation and change combinations. */
  markAllCheckOperationsAsSafe: MarkCheckOperationsAsSafeResult;
  /**
   * Mark the changeset that affects all operations in a given check instance as safe.
   * Note that only operations marked as behavior changes are allowed to be marked as safe.
   */
  markChangesForAllOperationsAsSafe: MarkChangesForOperationAsSafeResult;
  /**
   * Mark the changeset that affects multiple operations in a given check instance as safe.
   * Note that only operations marked as behavior changes are allowed to be marked as safe.
   * This is very similar to markCheckOperationsAsSafe but that takes a check workflow ID instead of an operation check ID.
   */
  markChangesForMultipleOperationsAsSafe: MarkChangesForOperationAsSafeResult;
  /**
   * Mark the changeset that affects an operation in a given check instance as safe.
   * Note that only operations marked as behavior changes are allowed to be marked as safe.
   */
  markChangesForOperationAsSafe: MarkChangesForOperationAsSafeResult;
  /** Mark any changes within the specified check for the specified operations as safe. Future checks will not fail for those operation and change combinations. */
  markCheckOperationsAsSafe: MarkCheckOperationsAsSafeResult;
  /** Generates a new graph API key for this graph with the specified permission level. */
  newKey: GraphApiKey;
  /** Mutation to set whether a proposals check task's results should be overridden or not */
  overrideProposalsCheckTask: Maybe<Scalars['Boolean']['output']>;
  /** Adds an override to the given users permission for this graph */
  overrideUserPermission: Maybe<Service>;
  /** Provides access to mutation fields for modifying a Persisted Query List with the provided ID. */
  persistedQueryList: PersistedQueryListMutation;
  /** Promote the schema with the given SHA-256 hash to active for the given variant/tag. */
  promoteSchema: PromoteSchemaResponseOrError;
  proposalsMustBeApprovedByADefaultReviewer: Maybe<ProposalsMustBeApprovedByADefaultReviewerResult>;
  /** Publish to a subgraph. If composition is successful, this will update running routers. */
  publishSubgraph: Maybe<CompositionAndUpsertResult>;
  /**
   * Publishes multiple subgraphs. If composition is successful, this will update running routers.
   * This field accepts up to 120 requests per minute. This rate may be temporarily adjusted based on system conditions.
   */
  publishSubgraphs: Maybe<CompositionAndUpsertResult>;
  /** Publishes multiple subgraphs, running the build async. */
  publishSubgraphsAsyncBuild: Maybe<PublishSubgraphsAsyncBuildResult>;
  /** Test a subscription by queueing a test notification for the one subscribed event. */
  queueTestProposalLifecycleNotification: QueueTestProposalLifecycleNotificationResult;
  /**
   * Records a decider's decision against an access request.
   *
   * On approval, synchronously creates a `PolicyException` and `PolicyRule`,
   * updates the request status to `Approved`, and recompiles the policy
   * bundle — all within a single transaction. On denial, updates the request
   * status to `Denied`. All resulting domain events (`PolicyExceptionCreated`,
   * `PolicyRuleCreated`, `AccessRequestDecisionRecorded`) are enqueued on the
   * outbox and dispatched to GCP Pub/Sub for downstream consumers.
   */
  recordAccessRequestDecision: AccessRequest;
  registerOperationsWithResponse: Maybe<RegisterOperationsMutationResponse>;
  /** Removes a subgraph. If composition is successful, this will update running routers. */
  removeImplementingServiceAndTriggerComposition: CompositionAndRemoveResult;
  /** Deletes the existing graph API key with the provided ID, if any. */
  removeKey: Maybe<Scalars['Void']['output']>;
  /** Sets a new name for the graph API key with the provided ID, if any. This does not invalidate the key or change its value. */
  renameKey: Maybe<GraphApiKey>;
  /** @deprecated use Mutation.reportSchema instead */
  reportServerInfo: Maybe<ReportServerInfoResult>;
  /** Mutations for a specific assessment. */
  safAssessment: Maybe<SafAssessmentMutation>;
  /**
   * Federation key field. The parent `Service` entity, used as the nested
   * key `@key(fields: "service { id }")`. Declared `@external` because it
   * is owned and resolved by the kotlin subgraph.
   */
  service: Service;
  setCustomCheckConfiguration: CustomCheckConfigurationResult;
  setDefaultBuildPipelineTrack: Maybe<Scalars['String']['output']>;
  setMinProposalApprovers: SetMinApproversResult;
  /** The minimum role for create & edit is graph admin */
  setMinProposalRoles: SetProposalRolesResult;
  setProposalDefaultReviewers: SetProposalDefaultReviewersResult;
  /** Updates the template for schema proposal descriptions. Deletes the template if the input string is null or empty */
  setProposalDescriptionTemplate: Maybe<SetProposalDescriptionTemplateResult>;
  /** Set the variant for this graph that all proposals depend on for 'IMPLEMENTED' status. TODO maya switch this to canManageProposalSettings. If variantName is passed as null, implementation variant is deleted. */
  setProposalImplementationVariant: SetProposalImplementationVariantResult;
  /** Sets the current active user's Proposals notification status on this graph. */
  setProposalNotificationStatus: SetProposalNotificationStatusResult;
  setProposalsMustBeReApprovedOnChange: Maybe<SetProposalsMustBeReApprovedOnChangeResult>;
  /**
   * Store a given schema document. This schema will be attached to the graph but
   * not be associated with any variant. On success, returns the schema hash.
   */
  storeSchemaDocument: StoreSchemaResponseOrError;
  /** Test Slack notification channel */
  testSlackChannel: Maybe<Scalars['Void']['output']>;
  testSubscriptionForChannel: Scalars['String']['output'];
  transfer: Maybe<Service>;
  /** Undelete a soft deleted graph. */
  undelete: Maybe<Service>;
  /**
   * Revert the effects of ignoreOperation.
   * Returns true if the operation is no longer ignored,
   * false if it wasn't.
   */
  unignoreOperationsInChecks: Maybe<UnignoreOperationsInChecksResult>;
  /** Unmark any changes within the specified check for all operations as safe. Future checks will fail for those operation and change combinations. */
  unmarkAllCheckOperationsAsSafe: MarkCheckOperationsAsSafeResult;
  /** Unmark changes for an operation as safe. */
  unmarkChangesForOperationAsSafe: MarkChangesForOperationAsSafeResult;
  /** Unmark any changes within the specified check for the specified operations as safe. Future checks will fail for those operation and change combinations. */
  unmarkCheckOperationsAsSafe: MarkCheckOperationsAsSafeResult;
  /** Update schema check configuration for a graph. */
  updateCheckConfiguration: CheckConfiguration;
  updateDatadogMetricsConfig: Maybe<DatadogMetricsConfig>;
  updateDescription: Maybe<Service>;
  /** Update hiddenFromUninvitedNonAdminAccountMembers */
  updateHiddenFromUninvitedNonAdminAccountMembers: Maybe<Service>;
  /** Update rule violations to ignore for this graph. */
  updateIgnoredRuleViolations: Array<IgnoredRule>;
  /** Update the linter configuration for this graph. */
  updateLinterConfiguration: GraphLinterConfiguration;
  /** Updates an existing policy exception by id within this graph. */
  updatePolicyException: PolicyException;
  /** Updates an existing policy rule by id within this graph. */
  updatePolicyRule: PolicyRule;
  /** Updates the specified proposal lifecycle subscription's subscribed events. */
  updateProposalLifecycleSubscription: UpdateProposalLifecycleSubscriptionResult;
  updateReadme: Maybe<Service>;
  updateRuleEnforcement: RuleEnforcementResult;
  updateTitle: Maybe<Service>;
  /** Publish a schema to this variant, either via a document or an introspection query result. */
  uploadSchema: Maybe<UploadSchemaMutationResponse>;
  upsertChannel: Maybe<Channel>;
  /** Creates a contract schema from a source variant and a set of filter configurations */
  upsertContractVariant: ContractVariantUpsertResult;
  /** Publish to a subgraph. If composition is successful, this will update running routers. */
  upsertImplementingServiceAndTriggerComposition: Maybe<CompositionAndUpsertResult>;
  /** Create/update PagerDuty notification channel */
  upsertPagerDutyChannel: Maybe<PagerDutyChannel>;
  upsertQueryTrigger: Maybe<QueryTrigger>;
  /** Create or update a subscription for a service. */
  upsertRegistrySubscription: RegistrySubscription;
  upsertScheduledSummary: Maybe<ScheduledSummary>;
  /** Create/update Slack notification channel */
  upsertSlackChannel: Maybe<SlackChannel>;
  upsertWebhookChannel: Maybe<WebhookChannel>;
  validateOperations: ValidateOperationsResult;
  /**
   * This mutation will not result in any changes to the implementing service
   * Run composition with the Implementing Service's partial schema replaced with the one provided
   * in the mutation's input. Store the composed schema, return the hash of the composed schema,
   * and any warnings and errors pertaining to composition.
   * This mutation will not run validation against operations.
   * @deprecated Use GraphVariant.submitSubgraphCheckAsync instead
   */
  validatePartialSchemaOfImplementingServiceAgainstGraph: CompositionValidationResult;
  /** Make changes to a graph variant. */
  variant: Maybe<GraphVariantMutation>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcheckPartialSchemaArgs = {
  frontend?: InputMaybe<Scalars['String']['input']>;
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  historicParameters?: InputMaybe<HistoricQueryParameters>;
  implementingServiceName: Scalars['String']['input'];
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
  isProposalCheck: Scalars['Boolean']['input'];
  isSandboxCheck: Scalars['Boolean']['input'];
  partialSchema: PartialSchemaInput;
  triggeredBy?: InputMaybe<ActorInput>;
  useMaximumRetention?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcheckSchemaArgs = {
  baseSchemaTag?: InputMaybe<Scalars['String']['input']>;
  frontend?: InputMaybe<Scalars['String']['input']>;
  gitContext?: InputMaybe<GitContextInput>;
  historicParameters?: InputMaybe<HistoricQueryParameters>;
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
  isProposalCheck: Scalars['Boolean']['input'];
  isSandboxCheck: Scalars['Boolean']['input'];
  proposedSchema?: InputMaybe<IntrospectionSchemaInput>;
  proposedSchemaDocument?: InputMaybe<Scalars['String']['input']>;
  proposedSchemaHash?: InputMaybe<Scalars['String']['input']>;
  useMaximumRetention?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcheckWorkflowArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateAccessRequestArgs = {
  input: CreateAccessRequestInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateAccessRequestByServiceNameArgs = {
  input: CreateAccessRequestByServiceNameInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateCompositionStatusSubscriptionArgs = {
  channelID: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreatePersistedQueryListArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreatePolicyExceptionArgs = {
  input: CreatePolicyExceptionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreatePolicyRuleArgs = {
  input: CreatePolicyRuleInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateProposalArgs = {
  input: CreateProposalInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateProposalLifecycleSubscriptionArgs = {
  input: CreateProposalLifecycleSubscriptionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateProposalVariantArgs = {
  sourceVariantName: Scalars['ID']['input'];
  triggeredBy?: InputMaybe<ActorInput>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateRuleEnforcementArgs = {
  input: CreateRuleEnforcementInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationcreateSchemaPublishSubscriptionArgs = {
  channelID: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdefaultBuildPipelineTrackArgs = {
  buildPipelineTrack: BuildPipelineTrack;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdefaultFederationVersionArgs = {
  federationVersion: Scalars['FederationVersion']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeletePolicyExceptionArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeletePolicyRuleArgs = {
  id: Scalars['UUID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteProposalLifecycleSubscriptionArgs = {
  input: DeleteProposalLifecycleSubscriptionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteQueryTriggerArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteRegistrySubscriptionArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteRegistrySubscriptionsArgs = {
  variant: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteRuleEnforcementArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteScheduledSummaryArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteSchemaTagArgs = {
  tag: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationdeleteTracesArgs = {
  from: Scalars['Timestamp']['input'];
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationignoreAllOperationsInChecksArgs = {
  operationsCheckId: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationignoreOperationsInChecksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationlintSchemaArgs = {
  baseSdl?: InputMaybe<Scalars['String']['input']>;
  sdl: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationmarkAllCheckOperationsAsSafeArgs = {
  checkWorkflowID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationmarkChangesForAllOperationsAsSafeArgs = {
  operationsCheckId: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationmarkChangesForMultipleOperationsAsSafeArgs = {
  checkID: Scalars['ID']['input'];
  operationIDs: Array<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationmarkChangesForOperationAsSafeArgs = {
  checkID: Scalars['ID']['input'];
  operationID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationmarkCheckOperationsAsSafeArgs = {
  checkWorkflowID: Scalars['ID']['input'];
  operationIDs: Array<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationnewKeyArgs = {
  keyName?: InputMaybe<Scalars['String']['input']>;
  role: UserPermission;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationoverrideProposalsCheckTaskArgs = {
  shouldOverride: Scalars['Boolean']['input'];
  taskId: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationoverrideUserPermissionArgs = {
  permission?: InputMaybe<UserPermission>;
  userID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationpersistedQueryListArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationpromoteSchemaArgs = {
  graphVariant: Scalars['String']['input'];
  historicParameters?: InputMaybe<HistoricQueryParameters>;
  overrideComposedSchema: Scalars['Boolean']['input'];
  sha256: Scalars['SHA256']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationproposalsMustBeApprovedByADefaultReviewerArgs = {
  mustBeApproved: Scalars['Boolean']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationpublishSubgraphArgs = {
  activePartialSchema: PartialSchemaInput;
  downstreamLaunchInitiation?: InputMaybe<DownstreamLaunchInitiation>;
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationpublishSubgraphsArgs = {
  downstreamLaunchInitiation?: InputMaybe<DownstreamLaunchInitiation>;
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  subgraphInputs: Array<PublishSubgraphsSubgraphInput>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationpublishSubgraphsAsyncBuildArgs = {
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  subgraphInputs: Array<PublishSubgraphsSubgraphInput>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationqueueTestProposalLifecycleNotificationArgs = {
  input: QueueTestProposalLifecycleNotificationInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationrecordAccessRequestDecisionArgs = {
  input: RecordAccessRequestDecisionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationregisterOperationsWithResponseArgs = {
  clientIdentity?: InputMaybe<RegisteredClientIdentityInput>;
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  manifestVersion?: InputMaybe<Scalars['Int']['input']>;
  operations: Array<RegisteredOperationInput>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationremoveImplementingServiceAndTriggerCompositionArgs = {
  dryRun: Scalars['Boolean']['input'];
  graphVariant: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationremoveKeyArgs = {
  id: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationrenameKeyArgs = {
  id: Scalars['ID']['input'];
  newKeyName?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationreportServerInfoArgs = {
  executableSchema?: InputMaybe<Scalars['String']['input']>;
  info: EdgeServerInfo;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsafAssessmentArgs = {
  id: Scalars['ID']['input'];
  includeDeleted: Scalars['Boolean']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetCustomCheckConfigurationArgs = {
  input: SetCustomCheckConfigurationInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetDefaultBuildPipelineTrackArgs = {
  version: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetMinProposalApproversArgs = {
  input: SetMinProposalApproversInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetMinProposalRolesArgs = {
  input: SetProposalRolesInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetProposalDefaultReviewersArgs = {
  input: SetProposalDefaultReviewersInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetProposalDescriptionTemplateArgs = {
  input: SetProposalDescriptionTemplateInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetProposalImplementationVariantArgs = {
  variantName?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetProposalNotificationStatusArgs = {
  input: SetProposalNotificationStatusInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationsetProposalsMustBeReApprovedOnChangeArgs = {
  approvalRequiredOnChange: Scalars['Boolean']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationstoreSchemaDocumentArgs = {
  schemaDocument: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationtestSlackChannelArgs = {
  id: Scalars['ID']['input'];
  notification: SlackNotificationInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationtestSubscriptionForChannelArgs = {
  channelID: Scalars['ID']['input'];
  subscriptionID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationtransferArgs = {
  to: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationunignoreOperationsInChecksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationunmarkAllCheckOperationsAsSafeArgs = {
  checkWorkflowID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationunmarkChangesForOperationAsSafeArgs = {
  checkID: Scalars['ID']['input'];
  operationID: Scalars['ID']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationunmarkCheckOperationsAsSafeArgs = {
  checkWorkflowID: Scalars['ID']['input'];
  operationIDs: Array<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateCheckConfigurationArgs = {
  downgradeDefaultValueChange?: InputMaybe<Scalars['Boolean']['input']>;
  downgradeStaticChecks?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomChecks?: InputMaybe<Scalars['Boolean']['input']>;
  enableLintChecks?: InputMaybe<Scalars['Boolean']['input']>;
  excludedClients?: InputMaybe<Array<ClientFilterInput>>;
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput>>;
  excludedOperations?: InputMaybe<Array<ExcludedOperationInput>>;
  includeBaseVariant?: InputMaybe<Scalars['Boolean']['input']>;
  includedVariants?: InputMaybe<Array<Scalars['String']['input']>>;
  operationCountThreshold?: InputMaybe<Scalars['Int']['input']>;
  operationCountThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  proposalChangeMismatchSeverity?: InputMaybe<ProposalChangeMismatchSeverity>;
  timeRangeSeconds?: InputMaybe<Scalars['Long']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateDatadogMetricsConfigArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiRegion?: InputMaybe<DatadogApiRegion>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateDescriptionArgs = {
  description: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateHiddenFromUninvitedNonAdminAccountMembersArgs = {
  hiddenFromUninvitedNonAdminAccountMembers: Scalars['Boolean']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateIgnoredRuleViolationsArgs = {
  changes: LinterIgnoredRuleChangesInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateLinterConfigurationArgs = {
  changes: GraphLinterConfigurationChangesInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdatePolicyExceptionArgs = {
  id: Scalars['UUID']['input'];
  input: UpdatePolicyExceptionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdatePolicyRuleArgs = {
  id: Scalars['UUID']['input'];
  input: UpdatePolicyRuleInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateProposalLifecycleSubscriptionArgs = {
  input: UpdateProposalLifecycleSubscriptionInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateReadmeArgs = {
  readme: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateRuleEnforcementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRuleEnforcementInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupdateTitleArgs = {
  title: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationuploadSchemaArgs = {
  errorOnBadRequest: Scalars['Boolean']['input'];
  gitContext?: InputMaybe<GitContextInput>;
  historicParameters?: InputMaybe<HistoricQueryParameters>;
  overrideComposedSchema: Scalars['Boolean']['input'];
  schema?: InputMaybe<IntrospectionSchemaInput>;
  schemaDocument?: InputMaybe<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pagerDutyChannel?: InputMaybe<PagerDutyChannelInput>;
  slackChannel?: InputMaybe<SlackChannelInput>;
  webhookChannel?: InputMaybe<WebhookChannelInput>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertContractVariantArgs = {
  contractVariantName: Scalars['String']['input'];
  filterConfig: FilterConfigInput;
  initiateLaunch: Scalars['Boolean']['input'];
  sourceVariant?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertImplementingServiceAndTriggerCompositionArgs = {
  activePartialSchema: PartialSchemaInput;
  gitContext?: InputMaybe<GitContextInput>;
  graphVariant: Scalars['String']['input'];
  name: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertPagerDutyChannelArgs = {
  channel: PagerDutyChannelInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertQueryTriggerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  trigger: QueryTriggerInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertRegistrySubscriptionArgs = {
  channelID?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<SubscriptionOptionsInput>;
  variant?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertScheduledSummaryArgs = {
  channelID?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertSlackChannelArgs = {
  channel: SlackChannelInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationupsertWebhookChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secretToken?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationvalidateOperationsArgs = {
  gitContext?: InputMaybe<GitContextInput>;
  operations: Array<OperationDocumentInput>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationvalidatePartialSchemaOfImplementingServiceAgainstGraphArgs = {
  graphVariant: Scalars['String']['input'];
  implementingServiceName: Scalars['String']['input'];
  partialSchema: PartialSchemaInput;
};


/** Provides access to mutation fields for managing Studio graphs and subgraphs. */
export type ServiceMutationvariantArgs = {
  name: Scalars['String']['input'];
};

/** Columns of ServiceOperationCheckStats. */
export enum ServiceOperationCheckStatsColumn {
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type ServiceOperationCheckStatsDimensions = {
  __typename: 'ServiceOperationCheckStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceOperationCheckStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceOperationCheckStatsFilter = {
  and?: InputMaybe<Array<ServiceOperationCheckStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceOperationCheckStatsFilterIn>;
  not?: InputMaybe<ServiceOperationCheckStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceOperationCheckStatsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceOperationCheckStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceOperationCheckStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceOperationCheckStatsMetrics = {
  __typename: 'ServiceOperationCheckStatsMetrics';
  cachedRequestsCount: Scalars['Long']['output'];
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type ServiceOperationCheckStatsOrderBySpec = {
  column: ServiceOperationCheckStatsColumn;
  direction: Ordering;
};

export type ServiceOperationCheckStatsRecord = {
  __typename: 'ServiceOperationCheckStatsRecord';
  /** Dimensions of ServiceOperationCheckStats that can be grouped by. */
  groupBy: ServiceOperationCheckStatsDimensions;
  /** Metrics of ServiceOperationCheckStats that can be aggregated over. */
  metrics: ServiceOperationCheckStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceOperationFetchStats. */
export enum ServiceOperationFetchStatsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CONNECTOR_SOURCE = 'CONNECTOR_SOURCE',
  FETCHES_WITH_ERRORS_COUNT = 'FETCHES_WITH_ERRORS_COUNT',
  FETCH_COUNT = 'FETCH_COUNT',
  FETCH_LATENCY_HISTOGRAM = 'FETCH_LATENCY_HISTOGRAM',
  FETCH_SERVICE_ID = 'FETCH_SERVICE_ID',
  FETCH_SERVICE_NAME = 'FETCH_SERVICE_NAME',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  OPERATION_TYPE = 'OPERATION_TYPE',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP'
}

export type ServiceOperationFetchStatsDimensions = {
  __typename: 'ServiceOperationFetchStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  connectorSource: Maybe<Scalars['String']['output']>;
  fetchServiceId: Maybe<Scalars['ID']['output']>;
  fetchServiceName: Maybe<Scalars['String']['output']>;
  operationId: Maybe<Scalars['String']['output']>;
  operationName: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceOperationFetchStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceOperationFetchStatsFilter = {
  and?: InputMaybe<Array<ServiceOperationFetchStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose connectorSource dimension equals the given value if not null. To query for the null value, use {in: {connectorSource: [null]}} instead. */
  connectorSource?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fetchServiceId dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceId: [null]}} instead. */
  fetchServiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose fetchServiceName dimension equals the given value if not null. To query for the null value, use {in: {fetchServiceName: [null]}} instead. */
  fetchServiceName?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceOperationFetchStatsFilterIn>;
  not?: InputMaybe<ServiceOperationFetchStatsFilter>;
  /** Selects rows whose operationId dimension equals the given value if not null. To query for the null value, use {in: {operationId: [null]}} instead. */
  operationId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationName dimension equals the given value if not null. To query for the null value, use {in: {operationName: [null]}} instead. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceOperationFetchStatsFilter>>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceOperationFetchStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceOperationFetchStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose connectorSource dimension is in the given list. A null value in the list means a row with null for that dimension. */
  connectorSource?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fetchServiceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose fetchServiceName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fetchServiceName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceOperationFetchStatsMetrics = {
  __typename: 'ServiceOperationFetchStatsMetrics';
  fetchCount: Scalars['Long']['output'];
  fetchLatencyHistogram: DurationHistogram;
  fetchesWithErrorsCount: Scalars['Long']['output'];
};

export type ServiceOperationFetchStatsOrderBySpec = {
  column: ServiceOperationFetchStatsColumn;
  direction: Ordering;
};

export type ServiceOperationFetchStatsRecord = {
  __typename: 'ServiceOperationFetchStatsRecord';
  /** Dimensions of ServiceOperationFetchStats that can be grouped by. */
  groupBy: ServiceOperationFetchStatsDimensions;
  /** Metrics of ServiceOperationFetchStats that can be aggregated over. */
  metrics: ServiceOperationFetchStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceQueryStats. */
export enum ServiceQueryStatsColumn {
  CACHED_HISTOGRAM = 'CACHED_HISTOGRAM',
  CACHED_REQUESTS_COUNT = 'CACHED_REQUESTS_COUNT',
  CACHE_TTL_HISTOGRAM = 'CACHE_TTL_HISTOGRAM',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  FORBIDDEN_OPERATION_COUNT = 'FORBIDDEN_OPERATION_COUNT',
  FROM_ENGINEPROXY = 'FROM_ENGINEPROXY',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  PERSISTED_QUERY_ID = 'PERSISTED_QUERY_ID',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  REGISTERED_OPERATION_COUNT = 'REGISTERED_OPERATION_COUNT',
  REQUESTS_WITH_ERRORS_COUNT = 'REQUESTS_WITH_ERRORS_COUNT',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP',
  UNCACHED_HISTOGRAM = 'UNCACHED_HISTOGRAM',
  UNCACHED_REQUESTS_COUNT = 'UNCACHED_REQUESTS_COUNT'
}

export type ServiceQueryStatsDimensions = {
  __typename: 'ServiceQueryStatsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  fromEngineproxy: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  persistedQueryId: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  querySignatureLength: Maybe<Scalars['Int']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
};

/** Filter for data in ServiceQueryStats. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceQueryStatsFilter = {
  and?: InputMaybe<Array<ServiceQueryStatsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose fromEngineproxy dimension equals the given value if not null. To query for the null value, use {in: {fromEngineproxy: [null]}} instead. */
  fromEngineproxy?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceQueryStatsFilterIn>;
  not?: InputMaybe<ServiceQueryStatsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceQueryStatsFilter>>;
  /** Selects rows whose persistedQueryId dimension equals the given value if not null. To query for the null value, use {in: {persistedQueryId: [null]}} instead. */
  persistedQueryId?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for data in ServiceQueryStats. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceQueryStatsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose fromEngineproxy dimension is in the given list. A null value in the list means a row with null for that dimension. */
  fromEngineproxy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose persistedQueryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  persistedQueryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceQueryStatsMetrics = {
  __typename: 'ServiceQueryStatsMetrics';
  cacheTtlHistogram: DurationHistogram;
  cachedHistogram: DurationHistogram;
  cachedRequestsCount: Scalars['Long']['output'];
  forbiddenOperationCount: Scalars['Long']['output'];
  registeredOperationCount: Scalars['Long']['output'];
  requestsWithErrorsCount: Scalars['Long']['output'];
  totalLatencyHistogram: DurationHistogram;
  totalRequestCount: Scalars['Long']['output'];
  uncachedHistogram: DurationHistogram;
  uncachedRequestsCount: Scalars['Long']['output'];
};

export type ServiceQueryStatsOrderBySpec = {
  column: ServiceQueryStatsColumn;
  direction: Ordering;
};

export type ServiceQueryStatsRecord = {
  __typename: 'ServiceQueryStatsRecord';
  /** Dimensions of ServiceQueryStats that can be grouped by. */
  groupBy: ServiceQueryStatsDimensions;
  /** Metrics of ServiceQueryStats that can be aggregated over. */
  metrics: ServiceQueryStatsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Individual permissions for the current user when interacting with a particular Studio graph. */
export type ServiceRoles = {
  __typename: 'ServiceRoles';
  /** Whether the currently authenticated user is permitted to perform schema checks (i.e., run `rover (sub)graph check`). */
  canCheckSchemas: Scalars['Boolean']['output'];
  canCreateProposal: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to create new graph variants. */
  canCreateVariants: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to delete the graph in question */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to delete proposal variants. */
  canDeleteProposalVariants: Scalars['Boolean']['output'];
  /** Given the graph's setting regarding proposal permission levels, can the current user edit Proposals authored by other users */
  canEditProposal: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage user access to the graph in question. */
  canManageAccess: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage the build configuration (e.g., build pipeline version). */
  canManageBuildConfig: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage third-party integrations (e.g., Datadog forwarding). */
  canManageIntegrations: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage graph-level API keys. */
  canManageKeys: Scalars['Boolean']['output'];
  canManagePersistedQueryLists: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage proposal permission settings for this graph. */
  canManageProposalPermissions: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to manage proposal settings, like setting the implementation variant, on this graph. */
  canManageProposalSettings: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to perform basic administration of variants (e.g., make a variant public). */
  canManageVariants: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view details about the build configuration (e.g. build pipeline version). */
  canQueryBuildConfig: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view details of the check configuration for this graph. */
  canQueryCheckConfiguration: Scalars['Boolean']['output'];
  canQueryDeletedImplementingServices: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to view which subgraphs the graph is composed of. */
  canQueryImplementingServices: Scalars['Boolean']['output'];
  canQueryIntegrations: Scalars['Boolean']['output'];
  canQueryPersistedQueryLists: Scalars['Boolean']['output'];
  canQueryPrivateInfo: Scalars['Boolean']['output'];
  canQueryProposals: Scalars['Boolean']['output'];
  canQueryPublicInfo: Scalars['Boolean']['output'];
  canQueryReadmeAuthor: Scalars['Boolean']['output'];
  canQueryRoleOverrides: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to download schemas owned by this graph. */
  canQuerySchemas: Scalars['Boolean']['output'];
  canQueryStats: Scalars['Boolean']['output'];
  canQueryTokens: Scalars['Boolean']['output'];
  canQueryTraces: Scalars['Boolean']['output'];
  /** Whether the requesting credential may fetch Constellation runtime artifacts (policy bundles, source definitions) for this graph. Granted only to Apollo-internal services. */
  canReadConstellationArtifacts: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to register operations (i.e. `apollo client:push`) for this graph. */
  canRegisterOperations: Scalars['Boolean']['output'];
  canStoreSchemasWithoutVariant: Scalars['Boolean']['output'];
  canUndelete: Scalars['Boolean']['output'];
  canUpdateAvatar: Scalars['Boolean']['output'];
  canUpdateDescription: Scalars['Boolean']['output'];
  canUpdateTitle: Scalars['Boolean']['output'];
  /** Whether the currently authenticated user is permitted to make updates to the check configuration for this graph. */
  canWriteCheckConfiguration: Scalars['Boolean']['output'];
  service: Service;
};

/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindow = {
  __typename: 'ServiceStatsWindow';
  billingUsageStats: Array<ServiceBillingUsageStatsRecord>;
  cardinalityStats: Array<ServiceCardinalityStatsRecord>;
  coordinateUsage: Array<ServiceCoordinateUsageRecord>;
  edgeServerInfos: Array<ServiceEdgeServerInfosRecord>;
  errorStats: Array<ServiceErrorStatsRecord>;
  federatedErrorStats: Array<ServiceFederatedErrorStatsRecord>;
  fieldExecutions: Array<ServiceFieldExecutionsRecord>;
  fieldLatencies: Array<ServiceFieldExecutionsRecord>;
  fieldStats: Array<ServiceFieldExecutionsRecord>;
  fieldUsage: Array<ServiceFieldUsageRecord>;
  graphosCloudMetrics: Array<ServiceGraphosCloudMetricsRecord>;
  operationCheckStats: Array<ServiceOperationCheckStatsRecord>;
  operationFetchStats: Array<ServiceOperationFetchStatsRecord>;
  queryStats: Array<ServiceQueryStatsRecord>;
  /** From field rounded down to the nearest resolution. */
  roundedDownFrom: Scalars['Timestamp']['output'];
  /** To field rounded up to the nearest resolution. */
  roundedUpTo: Scalars['Timestamp']['output'];
  tracePathErrorsRefs: Array<ServiceTracePathErrorsRefsRecord>;
  traceRefs: Array<ServiceTraceRefsRecord>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowbillingUsageStatsArgs = {
  filter?: InputMaybe<ServiceBillingUsageStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceBillingUsageStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowcardinalityStatsArgs = {
  filter?: InputMaybe<ServiceCardinalityStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceCardinalityStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowcoordinateUsageArgs = {
  filter?: InputMaybe<ServiceCoordinateUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceCoordinateUsageOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowedgeServerInfosArgs = {
  filter?: InputMaybe<ServiceEdgeServerInfosFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceEdgeServerInfosOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowerrorStatsArgs = {
  filter?: InputMaybe<ServiceErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowfederatedErrorStatsArgs = {
  filter?: InputMaybe<ServiceFederatedErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceFederatedErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowfieldExecutionsArgs = {
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceFieldExecutionsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowfieldLatenciesArgs = {
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceFieldExecutionsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowfieldStatsArgs = {
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceFieldExecutionsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowfieldUsageArgs = {
  filter?: InputMaybe<ServiceFieldUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceFieldUsageOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowgraphosCloudMetricsArgs = {
  filter?: InputMaybe<ServiceGraphosCloudMetricsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceGraphosCloudMetricsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowoperationCheckStatsArgs = {
  filter?: InputMaybe<ServiceOperationCheckStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceOperationCheckStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowoperationFetchStatsArgs = {
  filter?: InputMaybe<ServiceOperationFetchStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceOperationFetchStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowqueryStatsArgs = {
  filter?: InputMaybe<ServiceQueryStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceQueryStatsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowtracePathErrorsRefsArgs = {
  filter?: InputMaybe<ServiceTracePathErrorsRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceTracePathErrorsRefsOrderBySpec>>;
};


/** A time window with a specified granularity over a given service. */
export type ServiceStatsWindowtraceRefsArgs = {
  filter?: InputMaybe<ServiceTraceRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceTraceRefsOrderBySpec>>;
};

/** Columns of ServiceTracePathErrorsRefs. */
export enum ServiceTracePathErrorsRefsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  ERRORS_COUNT_IN_PATH = 'ERRORS_COUNT_IN_PATH',
  ERRORS_COUNT_IN_TRACE = 'ERRORS_COUNT_IN_TRACE',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  ERROR_SERVICE = 'ERROR_SERVICE',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_HTTP_STATUS_CODE = 'TRACE_HTTP_STATUS_CODE',
  TRACE_ID = 'TRACE_ID',
  TRACE_SIZE_BYTES = 'TRACE_SIZE_BYTES',
  TRACE_STARTS_AT = 'TRACE_STARTS_AT'
}

export type ServiceTracePathErrorsRefsDimensions = {
  __typename: 'ServiceTracePathErrorsRefsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  traceHttpStatusCode: Maybe<Scalars['Int']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
  traceStartsAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Filter for data in ServiceTracePathErrorsRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceTracePathErrorsRefsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<ServiceTracePathErrorsRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorMessage dimension equals the given value if not null. To query for the null value, use {in: {errorMessage: [null]}} instead. */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ServiceTracePathErrorsRefsFilterIn>;
  not?: InputMaybe<ServiceTracePathErrorsRefsFilter>;
  or?: InputMaybe<Array<ServiceTracePathErrorsRefsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose traceHttpStatusCode dimension equals the given value if not null. To query for the null value, use {in: {traceHttpStatusCode: [null]}} instead. */
  traceHttpStatusCode?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in ServiceTracePathErrorsRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceTracePathErrorsRefsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorMessage dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose traceHttpStatusCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceHttpStatusCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ServiceTracePathErrorsRefsMetrics = {
  __typename: 'ServiceTracePathErrorsRefsMetrics';
  errorsCountInPath: Scalars['Long']['output'];
  errorsCountInTrace: Scalars['Long']['output'];
  traceSizeBytes: Scalars['Long']['output'];
};

export type ServiceTracePathErrorsRefsOrderBySpec = {
  column: ServiceTracePathErrorsRefsColumn;
  direction: Ordering;
};

export type ServiceTracePathErrorsRefsRecord = {
  __typename: 'ServiceTracePathErrorsRefsRecord';
  /** Dimensions of ServiceTracePathErrorsRefs that can be grouped by. */
  groupBy: ServiceTracePathErrorsRefsDimensions;
  /** Metrics of ServiceTracePathErrorsRefs that can be aggregated over. */
  metrics: ServiceTracePathErrorsRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of ServiceTraceRefs. */
export enum ServiceTraceRefsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_COUNT = 'TRACE_COUNT',
  TRACE_ID = 'TRACE_ID'
}

export type ServiceTraceRefsDimensions = {
  __typename: 'ServiceTraceRefsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  generatedTraceId: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in ServiceTraceRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type ServiceTraceRefsFilter = {
  and?: InputMaybe<Array<ServiceTraceRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<ServiceTraceRefsFilterIn>;
  not?: InputMaybe<ServiceTraceRefsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<ServiceTraceRefsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in ServiceTraceRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type ServiceTraceRefsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ServiceTraceRefsMetrics = {
  __typename: 'ServiceTraceRefsMetrics';
  traceCount: Scalars['Long']['output'];
};

export type ServiceTraceRefsOrderBySpec = {
  column: ServiceTraceRefsColumn;
  direction: Ordering;
};

export type ServiceTraceRefsRecord = {
  __typename: 'ServiceTraceRefsRecord';
  /** Dimensions of ServiceTraceRefs that can be grouped by. */
  groupBy: ServiceTraceRefsDimensions;
  /** Metrics of ServiceTraceRefs that can be aggregated over. */
  metrics: ServiceTraceRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

export enum ServiceType {
  CONNECTOR = 'CONNECTOR',
  SUBGRAPH = 'SUBGRAPH',
  UNKNOWN = 'UNKNOWN'
}

export type SetCustomCheckConfigurationInput = {
  secretToken?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** Input to update a proposal description */
export type SetMergeBaseCompositionIdInput = {
  /** The composition id of the source variant this proposal is based on. */
  mergeBaseCompositionId: Scalars['ID']['input'];
};

export type SetMergeBaseCompositionIdResult = PermissionError | Proposal | ValidationError;

export type SetMinApproversResult = PermissionError | Service | ValidationError;

export type SetMinProposalApproversInput = {
  minApprovers?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the possible outcomes of a setNextVersion mutation */
export type SetNextVersionResult = InternalServerError | InvalidInputErrors | RouterVersion;

export type SetProposalDefaultReviewersInput = {
  reviewerUserIds: Array<Scalars['ID']['input']>;
};

export type SetProposalDefaultReviewersResult = PermissionError | Service | ValidationError;

export type SetProposalDescriptionTemplateInput = {
  descriptionTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type SetProposalDescriptionTemplateResult = PermissionError | Service | ValidationError;

export type SetProposalImplementationVariantResult = PermissionError | Service | ValidationError;

export type SetProposalNotificationStatusInput = {
  /** NotificationStatus to set for the current active user.  */
  status: NotificationStatus;
};

export type SetProposalNotificationStatusResult = PermissionError | Service | ValidationError;

export type SetProposalRolesInput = {
  create?: InputMaybe<UserPermission>;
  edit?: InputMaybe<UserPermission>;
};

export type SetProposalRolesResult = PermissionError | Service | ValidationError;

export type SetProposalsMustBeReApprovedOnChangeResult = PermissionError | Service | ValidationError;

/**
 * Outcome of a batch field-tag edit. Partial success is the normal case, not
 * an error: a coordinate that has gone stale (the upstream field was removed
 * since the edit was staged) lands in `failed` while every other coordinate
 * still applies. Callers reconcile per coordinate — clear the ones in
 * `updated`, keep the ones in `failed` with their message shown inline.
 *
 * Every coordinate submitted appears in exactly one of the two lists, each in
 * submission order.
 */
export type SetServiceFieldTagsBatchPayload = {
  __typename: 'SetServiceFieldTagsBatchPayload';
  /** Coordinates that were rejected; none of these were written. */
  failed: Array<InvalidServiceFieldTag>;
  /** Coordinates whose tags were written, with their resulting tag sets. */
  updated: Array<ServiceFieldTag>;
};

export type SetupIntentResult = NotFoundError | PermissionError | SetupIntentSuccess;

export type SetupIntentSuccess = {
  __typename: 'SetupIntentSuccess';
  clientSecret: Scalars['String']['output'];
};

/**
 * Shard for Cloud Routers
 *
 * This represents a specific shard where a Cloud Router can run
 */
export type Shard = {
  __typename: 'Shard';
  gcuCapacity: Maybe<Scalars['Int']['output']>;
  gcuUsage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  provider: CloudProvider;
  /** Details of this shard for a specific provider */
  providerDetails: ShardProvider;
  reason: Maybe<Scalars['String']['output']>;
  region: RegionDescription;
  routerCapacity: Maybe<Scalars['Int']['output']>;
  routerUsage: Scalars['Int']['output'];
  routers: Array<Router>;
  status: ShardStatus;
  tier: CloudTier;
};


/**
 * Shard for Cloud Routers
 *
 * This represents a specific shard where a Cloud Router can run
 */
export type ShardroutersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Provider-specific information for a Shard */
export type ShardProvider = AwsShard | FlyShard;

/** Represents the possible outcomes of a shard mutation */
export type ShardResult = InternalServerError | InvalidInputErrors | ShardSuccess;

/** Current status of Cloud Shards */
export enum ShardStatus {
  /** The Shard is active and ready to accept new Cloud Routers */
  ACTIVE = 'ACTIVE',
  /** The Shard no long exists */
  DELETED = 'DELETED',
  /** The Shard is working as expected, but should not be used to provision new Cloud Routers */
  DEPRECATED = 'DEPRECATED',
  /**
   * The Shard is suffering from a temporary degradation that might impact provisioning new
   * Cloud Routers
   */
  IMPAIRED = 'IMPAIRED',
  /**
   * The Shard is currently being updated and should temporarily not be used to provision new
   * Cloud Routers
   */
  UPDATING = 'UPDATING'
}

/** Success branch of an shard mutation */
export type ShardSuccess = {
  __typename: 'ShardSuccess';
  shard: Shard;
};

/** Slack notification channel */
export type SlackChannel = Channel & {
  __typename: 'SlackChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** List of the Schema Proposal Lifecycle Subscriptions this Channel is subscribed to. */
  proposalLifecycleSubscriptions: Array<ProposalLifecycleSubscription>;
  subscriptions: Array<ChannelSubscription>;
  url: Scalars['String']['output'];
};

/** Slack notification channel parameters */
export type SlackChannelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type SlackNotificationField = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Slack notification message */
export type SlackNotificationInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  fallback: Scalars['String']['input'];
  fields?: InputMaybe<Array<SlackNotificationField>>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleLink?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A location in a source code file. */
export type SourceLocation = {
  __typename: 'SourceLocation';
  /** Column number. */
  column: Scalars['Int']['output'];
  /** Line number. */
  line: Scalars['Int']['output'];
};

export type SsoConfig = {
  __typename: 'SsoConfig';
  /** Returns all SSO connections for the account, including those disabled or incomplete */
  allConnections: Array<SsoConnection>;
  /** Returns the current enabled SSO connection for the account */
  currentConnection: Maybe<SsoConnection>;
  defaultRole: UserPermission;
};

export type SsoConnection = {
  domains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idpId: Scalars['ID']['output'];
  scim: Maybe<SsoScimProvisioningDetails>;
  /** @deprecated Use stateV2 instead */
  state: SsoConnectionState;
  stateV2: SsoConnectionStateV2;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum SsoConnectionState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export enum SsoConnectionStateV2 {
  /** The connection has been archived and is no longer in use */
  ARCHIVED = 'ARCHIVED',
  /** The connection has been disabled by an admin */
  DISABLED = 'DISABLED',
  /** The connection has been finalized. a connection can only go from VALIDATED->ENABLED */
  ENABLED = 'ENABLED',
  /** The initial state for base connections - setup still in progress */
  INITIALIZED = 'INITIALIZED',
  /** The connection has been configured as either SAML/OIDC and can be used to login */
  STAGED = 'STAGED',
  /** The connection has had at least one successful login - connections automatically transition from STAGED->VALIDATED on first login */
  VALIDATED = 'VALIDATED'
}

/** Returned when the organization has SSO enabled and the plan does not support SSO */
export type SsoEnabled = PlanIneligibilityReason & {
  __typename: 'SsoEnabled';
  /** The severity of the ineligibility reason */
  severity: PlanIneligibilityReasonSeverity;
};

export type SsoMutation = {
  __typename: 'SsoMutation';
  deleteSsoConnection: Maybe<SsoConnection>;
  disableSsoConnection: Maybe<SsoConnection>;
  enableScimProvisioning: Maybe<SsoScimProvisioningDetails>;
  enableSsoConnection: Maybe<SsoConnection>;
};


export type SsoMutationdeleteSsoConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type SsoMutationdisableSsoConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type SsoMutationenableScimProvisioningArgs = {
  connectionId: Scalars['ID']['input'];
};


export type SsoMutationenableSsoConnectionArgs = {
  id: Scalars['ID']['input'];
};

export type SsoQuery = {
  __typename: 'SsoQuery';
  /** Parses a SAML IDP metadata XML string and returns the parsed metadata */
  parseSamlIdpMetadata: Maybe<ParsedSamlIdpMetadata>;
};


export type SsoQueryparseSamlIdpMetadataArgs = {
  metadata: Scalars['String']['input'];
};

export type SsoScimProvisioningDetails = {
  __typename: 'SsoScimProvisioningDetails';
  scimEnabled: Scalars['Boolean']['output'];
  scimEndpoint: Maybe<Scalars['String']['output']>;
};

/** The result of a successful call to PersistedQueryListMutation.startBulkDeletion. */
export type StartBulkDeletionResult = {
  __typename: 'StartBulkDeletionResult';
  /** The ID of the started (or already-active) bulk deletion job. Poll PersistedQueryList.bulkDeletionStatus with this ID. */
  jobId: Scalars['ID']['output'];
};

/** The result/error union returned by PersistedQueryListMutation.startBulkDeletion. */
export type StartBulkDeletionResultOrError = BulkDeletionAlreadyInProgressError | PermissionError | StartBulkDeletionResult;

/** A time window with a specified granularity. */
export type StatsWindow = {
  __typename: 'StatsWindow';
  billingUsageStats: Array<BillingUsageStatsRecord>;
  cardinalityStats: Array<CardinalityStatsRecord>;
  coordinateUsage: Array<CoordinateUsageRecord>;
  edgeServerInfos: Array<EdgeServerInfosRecord>;
  errorStats: Array<ErrorStatsRecord>;
  federatedErrorStats: Array<FederatedErrorStatsRecord>;
  fieldExecutions: Array<FieldExecutionsRecord>;
  fieldUsage: Array<FieldUsageRecord>;
  graphosCloudMetrics: Array<GraphosCloudMetricsRecord>;
  operationCheckStats: Array<OperationCheckStatsRecord>;
  operationFetchStats: Array<OperationFetchStatsRecord>;
  queryStats: Array<QueryStatsRecord>;
  /** From field rounded down to the nearest resolution. */
  roundedDownFrom: Scalars['Timestamp']['output'];
  /** To field rounded up to the nearest resolution. */
  roundedUpTo: Scalars['Timestamp']['output'];
  tracePathErrorsRefs: Array<TracePathErrorsRefsRecord>;
  traceRefs: Array<TraceRefsRecord>;
};


/** A time window with a specified granularity. */
export type StatsWindowbillingUsageStatsArgs = {
  filter?: InputMaybe<BillingUsageStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillingUsageStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowcardinalityStatsArgs = {
  filter?: InputMaybe<CardinalityStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardinalityStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowcoordinateUsageArgs = {
  filter?: InputMaybe<CoordinateUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoordinateUsageOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowedgeServerInfosArgs = {
  filter?: InputMaybe<EdgeServerInfosFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EdgeServerInfosOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowerrorStatsArgs = {
  filter?: InputMaybe<ErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowfederatedErrorStatsArgs = {
  filter?: InputMaybe<FederatedErrorStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FederatedErrorStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowfieldExecutionsArgs = {
  filter?: InputMaybe<FieldExecutionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FieldExecutionsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowfieldUsageArgs = {
  filter?: InputMaybe<FieldUsageFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FieldUsageOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowgraphosCloudMetricsArgs = {
  filter?: InputMaybe<GraphosCloudMetricsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GraphosCloudMetricsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowoperationCheckStatsArgs = {
  filter?: InputMaybe<OperationCheckStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperationCheckStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowoperationFetchStatsArgs = {
  filter?: InputMaybe<OperationFetchStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperationFetchStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowqueryStatsArgs = {
  filter?: InputMaybe<QueryStatsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryStatsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowtracePathErrorsRefsArgs = {
  filter?: InputMaybe<TracePathErrorsRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TracePathErrorsRefsOrderBySpec>>;
};


/** A time window with a specified granularity. */
export type StatsWindowtraceRefsArgs = {
  filter?: InputMaybe<TraceRefsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TraceRefsOrderBySpec>>;
};

/** Possible status of a Cloud Router version */
export enum Status {
  /**
   * Deprecated version of a Cloud Router
   *
   * New Cloud Routers should not use this version, and this will not be
   * supported at some point in the future.
   */
  DEPRECATED = 'DEPRECATED',
  /**
   * Upcoming or experimental version of a Cloud Router
   *
   * This should only be used internally, or to preview new features to
   * customers.
   */
  NEXT = 'NEXT',
  /** Cloud Router Version is ready to be used by end users */
  STABLE = 'STABLE'
}

export type StoreSchemaError = {
  __typename: 'StoreSchemaError';
  code: StoreSchemaErrorCode;
  message: Scalars['String']['output'];
};

export enum StoreSchemaErrorCode {
  SCHEMA_IS_NOT_PARSABLE = 'SCHEMA_IS_NOT_PARSABLE',
  SCHEMA_IS_NOT_VALID = 'SCHEMA_IS_NOT_VALID'
}

export type StoreSchemaResponse = {
  __typename: 'StoreSchemaResponse';
  sha256: Scalars['SHA256']['output'];
};

export type StoreSchemaResponseOrError = StoreSchemaError | StoreSchemaResponse;

export type StoredApprovedChange = {
  __typename: 'StoredApprovedChange';
  argNode: Maybe<NamedIntrospectionArgNoDescription>;
  childNode: Maybe<NamedIntrospectionValueNoDescription>;
  code: ChangeCode;
  parentNode: Maybe<NamedIntrospectionTypeNoDescription>;
};

/** A paginated connection of strings. */
export type StringConnection = {
  __typename: 'StringConnection';
  /** A list of edges containing a cursor and a string node for pagination. */
  edges: Array<StringEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection, containing a string node and its cursor. */
export type StringEdge = {
  __typename: 'StringEdge';
  /** A cursor for use in pagination, unique identifier for this edge's position. */
  cursor: Scalars['String']['output'];
  /** The string value at this position in the connection. */
  node: Scalars['String']['output'];
};

export type StringToString = {
  __typename: 'StringToString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StringToStringInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** A subgraph in a federated Studio supergraph. */
export type Subgraph = {
  __typename: 'Subgraph';
  /** The subgraph schema document's SHA256 hash, represented as a hexadecimal string. */
  hash: Scalars['String']['output'];
  /** The subgraph's registered name. */
  name: Scalars['String']['output'];
  /** The number of fields in this subgraph */
  numberOfFields: Maybe<Scalars['Int']['output']>;
  /** The number of types in this subgraph */
  numberOfTypes: Maybe<Scalars['Int']['output']>;
  /** The revision string of this publish if provided */
  revision: Maybe<Scalars['String']['output']>;
  /** The subgraph's routing URL, provided to gateways that use managed federation. */
  routingURL: Scalars['String']['output'];
  /** The subgraph schema document. */
  sdl: Scalars['String']['output'];
  /** Timestamp of when the subgraph was published. */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};


/** A subgraph in a federated Studio supergraph. */
export type SubgraphsdlArgs = {
  graphId: Scalars['ID']['input'];
};

/** A change made to a subgraph as part of a launch. */
export type SubgraphChange = {
  __typename: 'SubgraphChange';
  /** The subgraph's name. */
  name: Scalars['ID']['output'];
  /** The type of change that was made. */
  type: SubgraphChangeType;
};

export enum SubgraphChangeType {
  ADDITION = 'ADDITION',
  DELETION = 'DELETION',
  MODIFICATION = 'MODIFICATION'
}

/** Input type to provide when running schema checks asynchronously for a federated supergraph. */
export type SubgraphCheckAsyncInput = {
  /** Configuration options for the check execution. */
  config: HistoricQueryParametersInput;
  /** The GitHub context to associate with the check. */
  gitContext: GitContextInput;
  /** The graph ref of the Studio graph and variant to run checks against (such as `my-graph@current`). */
  graphRef?: InputMaybe<Scalars['ID']['input']>;
  /** The URL of the GraphQL endpoint that Apollo Sandbox introspected to obtain the proposed schema. Required if `isSandbox` is `true`. */
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
  /** If `true`, the check was initiated automatically by a Proposal update. */
  isProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If `true`, the check was initiated by Apollo Sandbox. */
  isSandbox: Scalars['Boolean']['input'];
  /** The proposed subgraph schema to perform checks with. */
  proposedSchema: Scalars['GraphQLDocument']['input'];
  /** The source variant that this check should use the operations check configuration from */
  sourceVariant?: InputMaybe<Scalars['String']['input']>;
  /** The name of the subgraph to check schema changes for. */
  subgraphName: Scalars['String']['input'];
  /** The user that triggered this check. If null, defaults to authContext to determine user. */
  triggeredBy?: InputMaybe<ActorInput>;
};

/** A subgraph in a federated Studio supergraph. */
export type SubgraphCheckInput = {
  /** The subgraph schema document's SHA256 hash, represented as a hexadecimal string. */
  hash: Scalars['String']['input'];
  /** The subgraph's registered name. */
  name: Scalars['String']['input'];
};

export type SubgraphConfig = {
  __typename: 'SubgraphConfig';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schemaHash: Scalars['String']['output'];
  sdl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** One subgraph or connector a request's operation fetched from. */
export type SubgraphFetchDetails = {
  /** The subgraph's name. */
  name: Scalars['String']['output'];
};

export type SubgraphHashInput = {
  /** SHA256 of the subgraph schema sdl. */
  hash: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Details to identify a subgraph */
export type SubgraphIdentifierInput = {
  /** The graph id */
  graphId: Scalars['String']['input'];
  /** The subgraph name */
  subgraphName: Scalars['String']['input'];
  /** The variant name */
  variantName: Scalars['String']['input'];
};

export type SubgraphInput = {
  /** We are either going to pass in a document or a schema reference */
  document?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  routingURL: Scalars['String']['input'];
  /**
   * Reference to a schema in studio.
   * If this is a mutable ref i.e. graphRef then it will link (tbd)
   * If it is a stable ref i.e. hash then it
   */
  schemaRef?: InputMaybe<Scalars['String']['input']>;
};

export type SubgraphInsightsListFilterInInput = {
  /** Filters results to fetches whose requests were reported with any of the given client names. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to fetches whose requests were reported with any of the given client versions. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to any of the given downstream subgraph or connector service ids. */
  subgraphId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to any of the given downstream subgraph or connector service names. */
  subgraphName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubgraphInsightsListFilterInput = {
  /** Filters results to fetches whose requests were reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to fetches whose requests were reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<SubgraphInsightsListFilterInInput>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<SubgraphInsightsListFilterInput>>;
  /** Filters on partial string matches against the subgraph or connector name/id. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restricts results to fetches of the given service types (e.g. subgraph vs connector). */
  serviceTypes?: InputMaybe<Array<ServiceType>>;
  /** Filters results to this exact downstream subgraph or connector service id. */
  subgraphId?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to this exact downstream subgraph or connector service name. */
  subgraphName?: InputMaybe<Scalars['String']['input']>;
};

export enum SubgraphInsightsListGroupByColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  CONNECTOR_SOURCE = 'CONNECTOR_SOURCE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  SERVICE_TYPE = 'SERVICE_TYPE',
  SUBGRAPH_ID = 'SUBGRAPH_ID',
  SUBGRAPH_NAME = 'SUBGRAPH_NAME'
}

export type SubgraphInsightsListItem = {
  __typename: 'SubgraphInsightsListItem';
  /** The client name (if being grouped). */
  clientName: Maybe<Scalars['String']['output']>;
  /** The client version (if being grouped). */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** The connector source (if being grouped). */
  connectorSource: Maybe<Scalars['String']['output']>;
  /** Count of fetches to this subgraph. */
  fetchCount: Scalars['Long']['output'];
  /** Rate per minute of fetches to this subgraph. */
  fetchCountPerMin: Scalars['Float']['output'];
  /** Percentage of fetches to this subgraph with errors. */
  fetchErrorPercentage: Scalars['Float']['output'];
  /** The histogram of fetch latencies. This can be null depending on whether latency calculations are needed. */
  fetchLatencyHistogram: Maybe<DurationHistogram>;
  /** Count of fetches to this subgraph with errors. */
  fetchesWithErrorsCount: Scalars['Long']['output'];
  /** Rate per minute of fetches to this subgraph with errors. */
  fetchesWithErrorsCountPerMin: Scalars['Float']['output'];
  /** The unique id for the operation (if being grouped). */
  operationId: Maybe<Scalars['ID']['output']>;
  /** The name of the operation (if being grouped). */
  operationName: Maybe<Scalars['String']['output']>;
  /** The operation type, e.g. query, mutation, subscription (if being grouped). */
  operationType: Maybe<OperationType>;
  /** The p50 of the latency across all fetches. This can be null depending on whether latency calculations are needed. */
  serviceTimeP50Ms: Maybe<Scalars['Float']['output']>;
  /** The p90 of the latency across all fetches. This can be null depending on whether latency calculations are needed. */
  serviceTimeP90Ms: Maybe<Scalars['Float']['output']>;
  /** The p95 of the latency across all fetches. This can be null depending on whether latency calculations are needed. */
  serviceTimeP95Ms: Maybe<Scalars['Float']['output']>;
  /** The p99 of the latency across all fetches. This can be null depending on whether latency calculations are needed. */
  serviceTimeP99Ms: Maybe<Scalars['Float']['output']>;
  /** The service type (if being grouped). */
  serviceType: Maybe<ServiceType>;
  /** The unique id for this subgraph. */
  subgraphId: Maybe<Scalars['ID']['output']>;
  /** The subgraph name. */
  subgraphName: Scalars['String']['output'];
  /** The total duration across all fetches. This can be null depending on whether latency calculations are needed. */
  totalDurationMs: Maybe<Scalars['Float']['output']>;
};

export enum SubgraphInsightsListOrderByColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  FETCHES_WITH_ERRORS_COUNT = 'FETCHES_WITH_ERRORS_COUNT',
  FETCHES_WITH_ERRORS_COUNT_PER_MIN = 'FETCHES_WITH_ERRORS_COUNT_PER_MIN',
  FETCH_COUNT = 'FETCH_COUNT',
  FETCH_COUNT_PER_MIN = 'FETCH_COUNT_PER_MIN',
  FETCH_ERROR_PERCENTAGE = 'FETCH_ERROR_PERCENTAGE',
  OPERATION_ID = 'OPERATION_ID',
  OPERATION_NAME = 'OPERATION_NAME',
  SERVICE_TIME_P50 = 'SERVICE_TIME_P50',
  SERVICE_TIME_P90 = 'SERVICE_TIME_P90',
  SERVICE_TIME_P95 = 'SERVICE_TIME_P95',
  SERVICE_TIME_P99 = 'SERVICE_TIME_P99',
  SUBGRAPH_ID = 'SUBGRAPH_ID',
  SUBGRAPH_NAME = 'SUBGRAPH_NAME',
  TIMESTAMP = 'TIMESTAMP',
  TOTAL_DURATION_MS = 'TOTAL_DURATION_MS'
}

export type SubgraphInsightsListOrderByInput = {
  /** The column to order results by. */
  column: SubgraphInsightsListOrderByColumn;
  /** The order direction, ascending or descending. */
  direction: Ordering;
};

/** Information about pagination in a connection. */
export type SubgraphInsightsListPageInfo = {
  __typename: 'SubgraphInsightsListPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** A single data point in the subgraph insights time series. */
export type SubgraphInsightsTimeseriesRecord = {
  __typename: 'SubgraphInsightsTimeseriesRecord';
  /** The metrics or values for this time series entry. */
  data: SubgraphInsightsListItem;
  /** The timestamp marking the start of this time segment. */
  timestamp: Scalars['Timestamp']['output'];
};

/** The named type and version of the clients to include or exclude in the subgraph and connector timeseries report. */
export type SubgraphInsightsTimeseriesReportClientFilterInInput = {
  /** The client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** The client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Dimensions by which the subgraph and connector timeseries data can be grouped or filtered. */
export enum SubgraphInsightsTimeseriesReportDimension {
  /** The client name that issued the request to the graph. */
  CLIENT_NAME = 'CLIENT_NAME',
  /** The version string of the client that issued the request to the graph. */
  CLIENT_VERSION = 'CLIENT_VERSION',
  /** The identifier of the downstream subgraph or connector service that the router made a request to as part of its query plan execution. */
  FETCH_SERVICE_ID = 'FETCH_SERVICE_ID',
  /** The name of the downstream subgraph or connector service that the router made a request to as part of its query plan execution. */
  FETCH_SERVICE_NAME = 'FETCH_SERVICE_NAME',
  /** The variant or version of the graph serving the request. */
  GRAPH_VARIANT = 'GRAPH_VARIANT',
  /** The unique identifier of the top-level operation executed. */
  OPERATION_ID = 'OPERATION_ID',
  /** The name of the top-level operation executed, if provided. */
  OPERATION_NAME = 'OPERATION_NAME',
  /** The GraphQl operation type, e.g. QUERY, MUTATION, SUBSCRIPTION */
  OPERATION_TYPE = 'OPERATION_TYPE'
}

/** The type and value for a subgraph and connector insights timeseries report dimension. */
export type SubgraphInsightsTimeseriesReportDimensionValue = {
  __typename: 'SubgraphInsightsTimeseriesReportDimensionValue';
  /** The type of dimension this represents. */
  type: SubgraphInsightsTimeseriesReportDimension;
  /** The string value of this dimension. Null for subgraphs without this dimension (e.g., unnamed operations). */
  value: Maybe<Scalars['String']['output']>;
};

/** Lists of dimensions to include or exclude in the subgraph and connector timeseries report. Each list can have a maximum of 1000 entries. */
export type SubgraphInsightsTimeseriesReportFilterInInput = {
  /** Include or exclude certain clients */
  clients?: InputMaybe<Array<InputMaybe<SubgraphInsightsTimeseriesReportClientFilterInInput>>>;
  /** Matches any subgraph or connector fetches targeting a subgraph or connector with an ID in this list. */
  fetchServiceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any subgraph or connector fetches targeting a subgraph or connector with a name in this list. */
  fetchServiceName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any subgraph or connector fetches whose operation ID is in this list. */
  operationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any subgraph or connector fetches whose operation name is in this list. */
  operationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Matches any subgraph or connector fetches requested from any variant in this list. */
  variantName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The filters available when using the subgraph and connector timeseries report. */
export type SubgraphInsightsTimeseriesReportFilterInput = {
  /** Exclude subgraph or connector fetches that match a specified set of dimensions. If the same dimension exists in both 'include' and 'exclude', a REQUEST_INVALID error will be returned. */
  exclude?: InputMaybe<SubgraphInsightsTimeseriesReportFilterInInput>;
  /** Include subgraph or connector fetches that match a specified set of dimensions. */
  include?: InputMaybe<SubgraphInsightsTimeseriesReportFilterInInput>;
};

/**
 * Metrics available for subgraph and connector timeseries fetches, representing aggregated data
 * collected over the given time window for the selected dimensions. Each request from the router to a downstream subgraph
 * or connector service is counted as a fetch.
 */
export enum SubgraphInsightsTimeseriesReportMetric {
  /** The total number of fetch requests sent from the router to the downstream subgraph or connector service as part of its query plan execution. */
  FETCH_COUNT = 'FETCH_COUNT',
  /** The 50th percentile (median) latency of fetches (in milliseconds). */
  FETCH_LATENCY_P50_MS = 'FETCH_LATENCY_P50_MS',
  /** The 90th percentile latency of fetch requests (in milliseconds). */
  FETCH_LATENCY_P90_MS = 'FETCH_LATENCY_P90_MS',
  /** The 99th percentile latency of fetch requests (in milliseconds). */
  FETCH_LATENCY_P99_MS = 'FETCH_LATENCY_P99_MS',
  /** The number of fetch requests that resulted in error responses from the downstream service. */
  FETCH_WITH_ERRORS_COUNT = 'FETCH_WITH_ERRORS_COUNT'
}

/** The type and value for subgraph and connector insights timeseries report metric. */
export type SubgraphInsightsTimeseriesReportMetricValue = {
  __typename: 'SubgraphInsightsTimeseriesReportMetricValue';
  /** The type of metric this represents. */
  type: SubgraphInsightsTimeseriesReportMetric;
  /** The floating point value of this metric. */
  value: Scalars['Float']['output'];
};

/** The metric and direction to use as the secondary sort order for the subgraph and connector insights timeseries report. The primary sort order will always be time. */
export type SubgraphInsightsTimeseriesReportOrderByInput = {
  /** The ordering used for the metrics results. This metric must be included in the requested metrics. */
  column: SubgraphInsightsTimeseriesReportMetric;
  /** The direction used to order the results. */
  direction: Ordering;
};

/** The data that is returned by the subgraph and connector insights timeseries report. */
export type SubgraphInsightsTimeseriesReportResult = {
  __typename: 'SubgraphInsightsTimeseriesReportResult';
  /** A CSV representation of the results. This includes a header and rows that have a column for start and end timestamp and all requested dimensions and metrics. */
  csv: Maybe<Scalars['String']['output']>;
  /** The result records, with each row having a start and end timestamp and a set of dimensions and metrics. */
  records: Array<SubgraphInsightsTimeseriesReportRow>;
};

/** A single row of data that is returned by the subgraph and connector insights timeseries report. */
export type SubgraphInsightsTimeseriesReportRow = {
  __typename: 'SubgraphInsightsTimeseriesReportRow';
  /** The dimension values for this row, matching the requested dimensions. */
  dimensions: Array<SubgraphInsightsTimeseriesReportDimensionValue>;
  /** The exclusive end of the time bucket for this row. */
  endExclusiveTimestamp: Scalars['Timestamp']['output'];
  /** The metric values for this row, matching the requested metrics. */
  metrics: Array<SubgraphInsightsTimeseriesReportMetricValue>;
  /** The start of the time bucket for this row. */
  startTimestamp: Scalars['Timestamp']['output'];
};

/** Result of a subgraph insights time series query. */
export type SubgraphInsightsTimeseriesResult = {
  __typename: 'SubgraphInsightsTimeseriesResult';
  /** The list of time series records containing the metrics or data points for the query. */
  records: Array<SubgraphInsightsTimeseriesRecord>;
  /** The start of the time bucket, rounded down to the nearest interval. */
  roundedDownFrom: Scalars['Timestamp']['output'];
  /** The end of the time bucket, rounded up to the nearest interval. */
  roundedUpTo: Scalars['Timestamp']['output'];
};

export type SubgraphKeyMap = {
  __typename: 'SubgraphKeyMap';
  keys: Array<Scalars['String']['output']>;
  subgraphName: Scalars['String']['output'];
};

/** Individual permissions for the currently authenticated principal when interacting with a particular Studio subgraph. */
export type SubgraphPermissions = {
  __typename: 'SubgraphPermissions';
  /** Whether the currently authenticated principal can publish schema for this subgraph. */
  canPublishSubgraph: Scalars['Boolean']['output'];
  /** Identifier for the subgraph this permissions object is associated with. */
  subgraphName: Scalars['String']['output'];
  /** Identifier for the variant this subgraph belongs to. */
  variantId: Scalars['ID']['output'];
};

export type SubgraphSdlCheckInput = {
  name: Scalars['String']['input'];
  sdl?: InputMaybe<Scalars['GraphQLDocument']['input']>;
};

export type SubgraphWithConflicts = {
  __typename: 'SubgraphWithConflicts';
  conflicts: Array<MergeConflict>;
  partialMergeSdl: Scalars['String']['output'];
  subgraphName: Scalars['String']['output'];
};

/** The result of submitting course feedback */
export type SubmitFeedbackPayload = {
  __typename: 'SubmitFeedbackPayload';
  /** The feedback record that was created, or null if submission failed */
  feedback: Maybe<CourseFeedback>;
  /** Any validation errors that occurred during submission */
  userErrors: Array<UserError>;
};

export type SubscriptionCapability = {
  __typename: 'SubscriptionCapability';
  label: Scalars['String']['output'];
  subscription: BillingSubscription;
  value: Scalars['Boolean']['output'];
};

export type SubscriptionLimit = {
  __typename: 'SubscriptionLimit';
  label: Scalars['String']['output'];
  subscription: BillingSubscription;
  value: Maybe<Scalars['Long']['output']>;
};

export type SubscriptionOptions = {
  __typename: 'SubscriptionOptions';
  /** Enables notifications for schema updates */
  schemaUpdates: Scalars['Boolean']['output'];
};

export type SubscriptionOptionsInput = {
  /** Enables notifications for schema updates */
  schemaUpdates: Scalars['Boolean']['input'];
};

export enum SubscriptionState {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CANCELED_NEVER_ACTIVATED = 'CANCELED_NEVER_ACTIVATED',
  EXPIRED = 'EXPIRED',
  FUTURE = 'FUTURE',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  SOFT_CANCELED = 'SOFT_CANCELED',
  UNKNOWN = 'UNKNOWN'
}

export type SupportTicket = {
  __typename: 'SupportTicket';
  /** The environment affected by the issue */
  affectedEnv: Maybe<AffectedEnv>;
  /** The org id this issue belongs to */
  apolloOrgId: Maybe<Scalars['String']['output']>;
  /** The date the issue was created */
  created: Scalars['Timestamp']['output'];
  /** The description of the issue */
  description: Scalars['String']['output'];
  /** The graph this issue is related to */
  graph: Maybe<Service>;
  /** The id of the issue */
  id: Scalars['Int']['output'];
  /** The key of the issue, ie TH-### */
  key: Scalars['String']['output'];
  /** The priority of the issue. Returns P3 if null in Jira */
  priority: TicketPriority;
  /** The JSM product associated with this ticket (replaces the old Component field) */
  product: Maybe<Product>;
  /** The version of product that is in use, i.e. Router v2.1, this is an optional field, if the value is null then the JSM field will be blank */
  productVersion: Maybe<Scalars['String']['output']>;
  /** The JSM status category of the issue */
  statusCategory: TicketStatusCategory;
  /** The display label of the issue status as returned by JSM */
  statusLabel: Scalars['String']['output'];
  /** The summary of the issue */
  summary: Scalars['String']['output'];
  /** The apollo user who created this issue */
  user: Maybe<User>;
};

export type SupportTicketInput = {
  affectedEnv?: InputMaybe<AffectedEnv>;
  apolloOrgId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  graphId?: InputMaybe<Scalars['String']['input']>;
  graphType?: InputMaybe<GraphType>;
  priority: TicketPriority;
  /** The JSM product associated with this ticket (replaces the old Component field) */
  product?: InputMaybe<Product>;
  /** The version of product that is in use, i.e. Router v2.1, this is an optional field, if the value is null then the JSM field will be blank */
  productVersion?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

export type Survey = {
  __typename: 'Survey';
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  questionAnswers: Array<SurveyQuestionAnswer>;
  shouldShow: Scalars['Boolean']['output'];
};

export type SurveyQuestionAnswer = {
  __typename: 'SurveyQuestionAnswer';
  answerDetails: Maybe<Scalars['String']['output']>;
  answerValue: Maybe<Scalars['String']['output']>;
  questionKey: Scalars['String']['output'];
};

export type SurveyQuestionInput = {
  answerDetails?: InputMaybe<Scalars['String']['input']>;
  answerKey: Scalars['String']['input'];
  answerKeyVersion?: InputMaybe<Scalars['Int']['input']>;
  answerValue?: InputMaybe<Scalars['String']['input']>;
  questionKey: Scalars['String']['input'];
  questionKeyVersion?: InputMaybe<Scalars['Int']['input']>;
  wasSkipped: Scalars['Boolean']['input'];
};

/** User input for a resource share mutation */
export type SyncPrivateSubgraphsInput = {
  /** A unique identifier for the private subgraph */
  identifier: Scalars['String']['input'];
  /** The cloud provider where the private subgraph is hosted */
  provider: CloudProvider;
};

export type TaskError = {
  __typename: 'TaskError';
  message: Scalars['String']['output'];
};

export type TemporaryURL = {
  __typename: 'TemporaryURL';
  url: Scalars['String']['output'];
};

export type TestRouter = {
  __typename: 'TestRouter';
  id: Scalars['ID']['output'];
  router: Maybe<Router>;
  status: TestRouterStatus;
};

/** The current state of a [`TestRouter`] */
export enum TestRouterStatus {
  /** The router has been destroyed */
  DELETED = 'DELETED',
  /** The router is spinning down */
  DELETING = 'DELETING',
  /** The router has entered an errored state as a result of the above */
  ERRORED = 'ERRORED',
  /** The router is spinning up */
  LAUNCHING = 'LAUNCHING',
  /** The router is running */
  RUNNING = 'RUNNING'
}

export enum ThemeName {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

/** Throttle error */
export type ThrottleError = Error & {
  __typename: 'ThrottleError';
  message: Scalars['String']['output'];
  retryAfter: Maybe<Scalars['Int']['output']>;
};

export enum TicketPriority {
  /** Note that JSM does not have P0 */
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  /** Note that Zendesk does not have P4 */
  P4 = 'P4'
}

/** The status category of a JSM support ticket */
export enum TicketStatusCategory {
  /** Ticket has reached a terminal state */
  DONE = 'DONE',
  /** Ticket is actively being worked on */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Ticket is open and not yet in progress */
  TODO = 'TODO'
}

/** The size of each time bucket in a timeseries report. */
export enum TimeseriesReportResolution {
  /** One-day buckets. */
  DAY = 'DAY',
  /** Single bucket containing the entire time range. */
  ENTIRE_RANGE = 'ENTIRE_RANGE',
  /** One-hour buckets. */
  HOUR = 'HOUR',
  /** One-minute buckets. */
  MINUTE = 'MINUTE',
  /** One-month buckets. */
  MONTH = 'MONTH'
}

/** Filter options to represent a timestamp range */
export type TimestampFilterInput = {
  /** The start of the range */
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  /** The end of the range */
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type TimezoneOffset = {
  __typename: 'TimezoneOffset';
  minutesOffsetFromUTC: Scalars['Int']['output'];
  zoneID: Scalars['String']['output'];
};

/** Returned when the organization has too many users to transition to the plan */
export type TooManyUsers = PlanIneligibilityReason & {
  __typename: 'TooManyUsers';
  /** The current number of users on the organization that makes the plan transition ineligible */
  currentUsers: Scalars['Int']['output'];
  /** The maximum number of users allowed by the plan */
  maxUsers: Scalars['Int']['output'];
  /** The severity of the ineligibility reason */
  severity: PlanIneligibilityReasonSeverity;
};

export type TopNOperationsByErrorPercentageRecord = TopNOperationsRecord & {
  __typename: 'TopNOperationsByErrorPercentageRecord';
  /** A substring of the query signature for unnamed operations, otherwise the operation name. */
  displayName: Scalars['String']['output'];
  /** The percentage of requests for this operation that resulted in errors. */
  errorPercentage: Scalars['Float']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique id for this operation. */
  queryID: Scalars['String']['output'];
  /** The GraphQL operation type, or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export type TopNOperationsByP95Record = TopNOperationsRecord & {
  __typename: 'TopNOperationsByP95Record';
  /** A substring of the query signature for unnamed operations, otherwise the operation name. */
  displayName: Scalars['String']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique id for this operation. */
  queryID: Scalars['String']['output'];
  /** The p95 of the latency across all requests for this operation in the selected time range, in milliseconds. */
  serviceTimeP95Ms: Scalars['Float']['output'];
  /** The GraphQL operation type, or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export type TopNOperationsByRequestRateRecord = TopNOperationsRecord & {
  __typename: 'TopNOperationsByRequestRateRecord';
  /** A substring of the query signature for unnamed operations, otherwise the operation name. */
  displayName: Scalars['String']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique id for this operation. */
  queryID: Scalars['String']['output'];
  /** The rate of requests per minute for this operation in the selected time range. */
  requestCountPerMin: Scalars['Float']['output'];
  /** The GraphQL operation type, or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export type TopNOperationsFilterInput = {
  /** Filters results to operations whose requests were reported with this exact client name. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Filters results to operations whose requests were reported with this exact client version. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Filters that match if the value is one of the given values. Multiple conditions inside `in` are ANDed together. */
  in?: InputMaybe<TopNOperationsFilterInput>;
  /** A list of alternative filter conditions; results match if any of them match. */
  or?: InputMaybe<Array<TopNOperationsFilterInput>>;
};

export type TopNOperationsRecord = {
  /** A substring of the query signature for unnamed operations, otherwise the operation name. */
  displayName: Scalars['String']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique id for this operation. */
  queryID: Scalars['String']['output'];
  /** The GraphQL operation type, or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export type TopNOperationsResult = {
  __typename: 'TopNOperationsResult';
  /** Top N operations by error percentage (descending). */
  byErrorPercentage: Array<TopNOperationsByErrorPercentageRecord>;
  /** Top N operations by p95 latency (descending). */
  byP95: Array<TopNOperationsByP95Record>;
  /** Top N operations by request rate (descending). */
  byRequestRate: Array<TopNOperationsByRequestRateRecord>;
};

export type TopOperationRecord = {
  __typename: 'TopOperationRecord';
  /** The graph this operation was reported from. */
  graphId: Scalars['String']['output'];
  /** The graph variant this operation was reported from. */
  graphVariant: Scalars['String']['output'];
  /** The operation name or null if the operation is unnamed. */
  name: Maybe<Scalars['String']['output']>;
  /** The unique id for this operation. */
  operationId: Scalars['String']['output'];
  /** The total number of requests for this operation for the specified time range. */
  requestCount: Scalars['Long']['output'];
  /** The operation's signature body or null if the signature is unavailable due to parse errors. */
  signature: Maybe<Scalars['String']['output']>;
  /** The operation type or null if the operation type could not be determined from the signature. */
  type: Maybe<OperationType>;
};

export enum TopOperationsReportOrderByColumn {
  REQUEST_COUNT = 'REQUEST_COUNT'
}

export type TopOperationsReportOrderByInput = {
  /** The order column used for the operation results. Defaults to ordering by total request count. */
  column: TopOperationsReportOrderByColumn;
  /** The direction used to order operation results. Defaults to descending order. */
  direction: Ordering;
};

export type TopOperationsReportVariantFilterInInput = {
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TopOperationsReportVariantFilterInput = {
  in: TopOperationsReportVariantFilterInInput;
};

/** Counts of changes. */
export type TotalChangeSummaryCounts = {
  __typename: 'TotalChangeSummaryCounts';
  /**
   * Number of changes that are additions. This includes adding types, adding fields to object, input
   * object, and interface types, adding values to enums, adding members to interfaces and unions, and
   * adding arguments.
   */
  additions: Scalars['Int']['output'];
  /** Number of changes that are new usages of the @deprecated directive. */
  deprecations: Scalars['Int']['output'];
  /**
   * Number of changes that are edits. This includes types changing kind, fields and arguments
   * changing type, arguments changing default value, and any description changes. This also includes
   * edits to @deprecated reason strings.
   */
  edits: Scalars['Int']['output'];
  /**
   * Number of changes that are removals. This includes removing types, removing fields from object,
   * input object, and interface types, removing values from enums, removing members from interfaces
   * and unions, and removing arguments. This also includes removing @deprecated usages.
   */
  removals: Scalars['Int']['output'];
};

/** A single recorded trace of an operation handled by the Apollo Router or gateway. */
export type Trace = {
  __typename: 'Trace';
  /** The version of the agent (e.g. Apollo Router) that reported this trace, if available. */
  agentVersion: Maybe<Scalars['String']['output']>;
  /** The maximum cache TTL for this operation in milliseconds, or null if not cacheable. */
  cacheMaxAgeMs: Maybe<Scalars['Float']['output']>;
  /** The cache scope for this operation, or null if not cacheable. */
  cacheScope: Maybe<CacheScope>;
  /** The client name reported with the operation, if available. */
  clientName: Maybe<Scalars['String']['output']>;
  /** The client version reported with the operation, if available. */
  clientVersion: Maybe<Scalars['String']['output']>;
  /** The total duration of the operation in milliseconds. */
  durationMs: Scalars['Float']['output'];
  /** The time the operation finished executing, in the gateway/router's clock. */
  endTime: Scalars['Timestamp']['output'];
  /** The HTTP request/response context for the operation, if available. */
  http: Maybe<TraceHTTP>;
  /** The unique id of this trace. */
  id: Scalars['ID']['output'];
  /**
   * True if the report containing the trace was submitted as potentially incomplete, which can happen if the Router's
   * trace buffer fills up while constructing the trace. If this is true, the trace might be missing some nodes.
   */
  isIncomplete: Scalars['Boolean']['output'];
  /** The name of the executed operation, or null if the operation was unnamed. */
  operationName: Maybe<Scalars['String']['output']>;
  /** The full raw trace as a base64-encoded protobuf message. */
  protobuf: Protobuf;
  /** The root node of the trace tree. */
  root: TraceNode;
  /** The normalized GraphQL signature of the operation, used as the operation's stable identifier across runs. */
  signature: Scalars['String']['output'];
  /** The time the operation started executing, in the gateway/router's clock. */
  startTime: Scalars['Timestamp']['output'];
  /** The body of the operation that was sent but did not execute (e.g. for parse/validation errors). */
  unexecutedOperationBody: Maybe<Scalars['String']['output']>;
  /** The name of the operation that was sent but did not execute (e.g. for parse/validation errors). */
  unexecutedOperationName: Maybe<Scalars['String']['output']>;
  /** The variables sent with the operation, with sensitive values redacted. */
  variablesJSON: Array<StringToString>;
};

/** A single error reported at a node in the trace tree. */
export type TraceError = {
  __typename: 'TraceError';
  /** The error code from the error's `extensions.code` field, if present. */
  errorCode: Maybe<Scalars['String']['output']>;
  /** The downstream subgraph or connector service the error originated from, if attributable. */
  errorService: Maybe<Scalars['String']['output']>;
  /** The full GraphQL error as a JSON-encoded string, including any extensions. */
  json: Scalars['String']['output'];
  /** The source locations in the operation document associated with the error. */
  locations: Array<TraceSourceLocation>;
  /** The human-readable error message. */
  message: Scalars['String']['output'];
  /** The timestamp at which the error was observed, if available. */
  timestamp: Maybe<Scalars['Timestamp']['output']>;
};

/** HTTP request and response context for the operation captured in a trace. */
export type TraceHTTP = {
  __typename: 'TraceHTTP';
  /** The HTTP method of the request that produced this trace. */
  method: HTTPMethod;
  /** Request headers reported with the operation, with sensitive values redacted. Repeated header names appear once per value. */
  requestHeaders: Array<StringToString>;
  /** Response headers returned to the client, with sensitive values redacted. Repeated header names appear once per value. */
  responseHeaders: Array<StringToString>;
  /** The HTTP status code returned to the client. */
  statusCode: Scalars['Int']['output'];
};

/** A single node in a trace tree, representing either a field resolver execution or a query plan fetch. */
export type TraceNode = {
  __typename: 'TraceNode';
  /** Additional metadata for the node, presented in key-value pairs. */
  attributes: Array<StringToString>;
  /** The maximum cache TTL for this node's field in milliseconds, or null if not cacheable. */
  cacheMaxAgeMs: Maybe<Scalars['Float']['output']>;
  /** The cache scope for this node's field, or null if not cacheable. */
  cacheScope: Maybe<CacheScope>;
  /** The total number of children, including the ones that were truncated. */
  childCount: Scalars['Int']['output'];
  /** Whether the children of this node have been truncated because the number of children is over the max. */
  childrenAreTruncated: Scalars['Boolean']['output'];
  /**
   * All children, and the children of those children, and so on. Children that have been truncated
   * are not included.
   */
  descendants: Array<TraceNode>;
  /**
   * The end time of the node. If this is a fetch node (meaning isFetch is true), this will be the
   * time that the gateway/router received the response from the subgraph server in the
   * gateway/routers clock time.
   */
  endTime: Scalars['Timestamp']['output'];
  /** Errors that occurred at this node, if any. */
  errors: Array<TraceError>;
  /** The unique id of this node within the trace. */
  id: Scalars['ID']['output'];
  /**
   * Whether the fetch node in question is a descendent of a Deferred node in the trace's query plan. The nodes
   * in query plans can be complicated and nested, so this is a fairly simple representation of the structure.
   */
  isDeferredFetch: Scalars['Boolean']['output'];
  /**
   * Whether the node in question represents a fetch node within a query plan. If so, this will contain
   * children with timestamps that are calculated by the router/gateway rather than subgraph and the
   * fields subgraphStartTime and subgraphEndTime will be non-null.
   */
  isFetch: Scalars['Boolean']['output'];
  /** For list elements, the index in the parent list; for object fields, the response key under the parent. */
  key: Maybe<Scalars['StringOrInt']['output']>;
  /** A classification which helps to differentiate between types of nodes (intended for display / filtering purposes). */
  kind: TraceNodeKind;
  /** If the node represents an aliased field resolver, the underlying field name; otherwise null. */
  originalFieldName: Maybe<Scalars['String']['output']>;
  /** The id of this node's parent, or null if this is the root node. */
  parentId: Maybe<Scalars['ID']['output']>;
  /**
   * If the node is a field resolver, the field's parent type; e.g. "User" for User.email
   * otherwise null.
   */
  parentType: Maybe<Scalars['String']['output']>;
  /**
   * The start time of the node. If this is a fetch node (meaning isFetch is true), this will be the
   * time that the gateway/router sent the request to the subgraph server in the gateway/router's clock
   * time.
   */
  startTime: Scalars['Timestamp']['output'];
  /**
   * Only present when the node in question is a fetch node, this will indicate the timestamp at which
   * the subgraph server returned a response to the gateway/router. This timestamp is based on the
   * subgraph server's clock, so if there is a clock skew between the subgraph and the gateway/router,
   * this and endTime will not be in sync. If this is a fetch node but we don't receive subgraph traces
   * (e.g. if the subgraph doesn't support federated traces), this value will be null.
   */
  subgraphEndTime: Maybe<Scalars['Timestamp']['output']>;
  /** If present, indicates the subgraph context a node is associated with. */
  subgraphName: Maybe<Scalars['String']['output']>;
  /**
   * Only present when the node in question is a fetch node, this will indicate the timestamp at which
   * the fetch was received by the subgraph server. This timestamp is based on the subgraph server's
   * clock, so if there is a clock skew between the subgraph and the gateway/router, this and startTime
   * will not be in sync. If this is a fetch node but we don't receive subgraph traces (e.g. if the
   * subgraph doesn't support federated traces), this value will be null.
   */
  subgraphStartTime: Maybe<Scalars['Timestamp']['output']>;
  /**
   * If the node is a field resolver, the field's return type; e.g. "String!" for User.email:String!
   * otherwise an empty string.
   */
  type: Maybe<Scalars['String']['output']>;
};

export enum TraceNodeKind {
  ARRAY_INDEX_RESOLVER = 'ARRAY_INDEX_RESOLVER',
  FIELD_RESOLVER = 'FIELD_RESOLVER',
  REQUEST = 'REQUEST',
  ROUTER_INTERNAL = 'ROUTER_INTERNAL',
  SUBGRAPH_REQUEST = 'SUBGRAPH_REQUEST',
  USER_PLUGIN = 'USER_PLUGIN'
}

/** Columns of TracePathErrorsRefs. */
export enum TracePathErrorsRefsColumn {
  AGENT_VERSION = 'AGENT_VERSION',
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  ERRORS_COUNT_IN_PATH = 'ERRORS_COUNT_IN_PATH',
  ERRORS_COUNT_IN_TRACE = 'ERRORS_COUNT_IN_TRACE',
  ERROR_CODE = 'ERROR_CODE',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  ERROR_SERVICE = 'ERROR_SERVICE',
  PATH = 'PATH',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_HTTP_STATUS_CODE = 'TRACE_HTTP_STATUS_CODE',
  TRACE_ID = 'TRACE_ID',
  TRACE_SIZE_BYTES = 'TRACE_SIZE_BYTES',
  TRACE_STARTS_AT = 'TRACE_STARTS_AT'
}

export type TracePathErrorsRefsDimensions = {
  __typename: 'TracePathErrorsRefsDimensions';
  agentVersion: Maybe<Scalars['String']['output']>;
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  errorService: Maybe<Scalars['String']['output']>;
  /** If metrics were collected from a federated service, this field will be prefixed with `service:<SERVICE_NAME>.` */
  path: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  traceHttpStatusCode: Maybe<Scalars['Int']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
  traceStartsAt: Maybe<Scalars['Timestamp']['output']>;
};

/** Filter for data in TracePathErrorsRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type TracePathErrorsRefsFilter = {
  /** Selects rows whose agentVersion dimension equals the given value if not null. To query for the null value, use {in: {agentVersion: [null]}} instead. */
  agentVersion?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<TracePathErrorsRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose errorCode dimension equals the given value if not null. To query for the null value, use {in: {errorCode: [null]}} instead. */
  errorCode?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorMessage dimension equals the given value if not null. To query for the null value, use {in: {errorMessage: [null]}} instead. */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose errorService dimension equals the given value if not null. To query for the null value, use {in: {errorService: [null]}} instead. */
  errorService?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<TracePathErrorsRefsFilterIn>;
  not?: InputMaybe<TracePathErrorsRefsFilter>;
  or?: InputMaybe<Array<TracePathErrorsRefsFilter>>;
  /** Selects rows whose path dimension equals the given value if not null. To query for the null value, use {in: {path: [null]}} instead. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose traceHttpStatusCode dimension equals the given value if not null. To query for the null value, use {in: {traceHttpStatusCode: [null]}} instead. */
  traceHttpStatusCode?: InputMaybe<Scalars['Int']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in TracePathErrorsRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type TracePathErrorsRefsFilterIn = {
  /** Selects rows whose agentVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  agentVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose errorCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorMessage dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose errorService dimension is in the given list. A null value in the list means a row with null for that dimension. */
  errorService?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose path dimension is in the given list. A null value in the list means a row with null for that dimension. */
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose traceHttpStatusCode dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceHttpStatusCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TracePathErrorsRefsMetrics = {
  __typename: 'TracePathErrorsRefsMetrics';
  errorsCountInPath: Scalars['Long']['output'];
  errorsCountInTrace: Scalars['Long']['output'];
  traceSizeBytes: Scalars['Long']['output'];
};

export type TracePathErrorsRefsOrderBySpec = {
  column: TracePathErrorsRefsColumn;
  direction: Ordering;
};

export type TracePathErrorsRefsRecord = {
  __typename: 'TracePathErrorsRefsRecord';
  /** Dimensions of TracePathErrorsRefs that can be grouped by. */
  groupBy: TracePathErrorsRefsDimensions;
  /** Metrics of TracePathErrorsRefs that can be aggregated over. */
  metrics: TracePathErrorsRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** Columns of TraceRefs. */
export enum TraceRefsColumn {
  CLIENT_NAME = 'CLIENT_NAME',
  CLIENT_VERSION = 'CLIENT_VERSION',
  DURATION_BUCKET = 'DURATION_BUCKET',
  OPERATION_SUBTYPE = 'OPERATION_SUBTYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  QUERY_ID = 'QUERY_ID',
  QUERY_NAME = 'QUERY_NAME',
  SCHEMA_HASH = 'SCHEMA_HASH',
  SCHEMA_TAG = 'SCHEMA_TAG',
  SERVICE_ID = 'SERVICE_ID',
  TIMESTAMP = 'TIMESTAMP',
  TRACE_COUNT = 'TRACE_COUNT',
  TRACE_ID = 'TRACE_ID'
}

export type TraceRefsDimensions = {
  __typename: 'TraceRefsDimensions';
  clientName: Maybe<Scalars['String']['output']>;
  clientVersion: Maybe<Scalars['String']['output']>;
  durationBucket: Maybe<Scalars['Int']['output']>;
  generatedTraceId: Maybe<Scalars['String']['output']>;
  operationSubtype: Maybe<Scalars['String']['output']>;
  operationType: Maybe<Scalars['String']['output']>;
  queryId: Maybe<Scalars['ID']['output']>;
  queryName: Maybe<Scalars['String']['output']>;
  querySignature: Maybe<Scalars['String']['output']>;
  schemaHash: Maybe<Scalars['String']['output']>;
  schemaTag: Maybe<Scalars['String']['output']>;
  serviceId: Maybe<Scalars['ID']['output']>;
  traceId: Maybe<Scalars['ID']['output']>;
};

/** Filter for data in TraceRefs. Fields with dimension names represent equality checks. All fields are implicitly ANDed together. */
export type TraceRefsFilter = {
  and?: InputMaybe<Array<TraceRefsFilter>>;
  /** Selects rows whose clientName dimension equals the given value if not null. To query for the null value, use {in: {clientName: [null]}} instead. */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose clientVersion dimension equals the given value if not null. To query for the null value, use {in: {clientVersion: [null]}} instead. */
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose durationBucket dimension equals the given value if not null. To query for the null value, use {in: {durationBucket: [null]}} instead. */
  durationBucket?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<TraceRefsFilterIn>;
  not?: InputMaybe<TraceRefsFilter>;
  /** Selects rows whose operationSubtype dimension equals the given value if not null. To query for the null value, use {in: {operationSubtype: [null]}} instead. */
  operationSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose operationType dimension equals the given value if not null. To query for the null value, use {in: {operationType: [null]}} instead. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<TraceRefsFilter>>;
  /** Selects rows whose queryId dimension equals the given value if not null. To query for the null value, use {in: {queryId: [null]}} instead. */
  queryId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose queryName dimension equals the given value if not null. To query for the null value, use {in: {queryName: [null]}} instead. */
  queryName?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaHash dimension equals the given value if not null. To query for the null value, use {in: {schemaHash: [null]}} instead. */
  schemaHash?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose schemaTag dimension equals the given value if not null. To query for the null value, use {in: {schemaTag: [null]}} instead. */
  schemaTag?: InputMaybe<Scalars['String']['input']>;
  /** Selects rows whose serviceId dimension equals the given value if not null. To query for the null value, use {in: {serviceId: [null]}} instead. */
  serviceId?: InputMaybe<Scalars['ID']['input']>;
  /** Selects rows whose traceId dimension equals the given value if not null. To query for the null value, use {in: {traceId: [null]}} instead. */
  traceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for data in TraceRefs. Fields match if the corresponding dimension's value is in the given list. All fields are implicitly ANDed together. */
export type TraceRefsFilterIn = {
  /** Selects rows whose clientName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose clientVersion dimension is in the given list. A null value in the list means a row with null for that dimension. */
  clientVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose durationBucket dimension is in the given list. A null value in the list means a row with null for that dimension. */
  durationBucket?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Selects rows whose operationSubtype dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationSubtype?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose operationType dimension is in the given list. A null value in the list means a row with null for that dimension. */
  operationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose queryId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose queryName dimension is in the given list. A null value in the list means a row with null for that dimension. */
  queryName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaHash dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaHash?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose schemaTag dimension is in the given list. A null value in the list means a row with null for that dimension. */
  schemaTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Selects rows whose serviceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  serviceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Selects rows whose traceId dimension is in the given list. A null value in the list means a row with null for that dimension. */
  traceId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TraceRefsMetrics = {
  __typename: 'TraceRefsMetrics';
  traceCount: Scalars['Long']['output'];
};

export type TraceRefsOrderBySpec = {
  column: TraceRefsColumn;
  direction: Ordering;
};

export type TraceRefsRecord = {
  __typename: 'TraceRefsRecord';
  /** Dimensions of TraceRefs that can be grouped by. */
  groupBy: TraceRefsDimensions;
  /** Metrics of TraceRefs that can be aggregated over. */
  metrics: TraceRefsMetrics;
  /** Starting segment timestamp. */
  timestamp: Scalars['Timestamp']['output'];
};

/** A position in the operation document, identifying where an error was reported. */
export type TraceSourceLocation = {
  __typename: 'TraceSourceLocation';
  /** The 1-based column number in the operation document. */
  column: Scalars['Int']['output'];
  /** The 1-based line number in the operation document. */
  line: Scalars['Int']['output'];
};

/** Counts of changes at the type level, including interfaces, unions, enums, scalars, input objects, etc. */
export type TypeChangeSummaryCounts = {
  __typename: 'TypeChangeSummaryCounts';
  /** Number of changes that are additions of types. */
  additions: Scalars['Int']['output'];
  /**
   * Number of changes that are edits. This includes types changing kind and any type description
   * changes, but also includes adding/removing values from enums, adding/removing members from
   * interfaces and unions, and any enum value deprecation and description changes.
   */
  edits: Scalars['Int']['output'];
  /** Number of changes that are removals of types. */
  removals: Scalars['Int']['output'];
};

/**
 * the TypeFilterConfig is used to isolate
 * types, and subsequent fields, through
 * various configuration settings.
 *
 * It defaults to filter towards user defined
 * types only
 */
export type TypeFilterConfig = {
  /** include abstract types (interfaces and unions) */
  includeAbstractTypes?: InputMaybe<Scalars['Boolean']['input']>;
  /** include built in scalars (i.e. Boolean, Int, etc) */
  includeBuiltInTypes?: InputMaybe<Scalars['Boolean']['input']>;
  /** include reserved introspection types (i.e. __Type) */
  includeIntrospectionTypes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type URI = {
  __typename: 'URI';
  /** A GCS URI */
  gcs: Scalars['String']['output'];
};

export type UnignoreOperationsInChecksResult = {
  __typename: 'UnignoreOperationsInChecksResult';
  /** The graph that was updated. */
  graph: Service;
  /** An error or success message. */
  message: Scalars['String']['output'];
  /** Whether or not the request succeeded. */
  success: Scalars['Boolean']['output'];
};

export type UnlinkPersistedQueryListResult = {
  __typename: 'UnlinkPersistedQueryListResult';
  graphVariant: GraphVariant;
  unlinkedPersistedQueryList: PersistedQueryList;
};

/** The result/error union returned by GraphVariantMutation.unlinkPersistedQueryList. */
export type UnlinkPersistedQueryListResultOrError = PermissionError | UnlinkPersistedQueryListResult | VariantAlreadyUnlinkedError;

export type UpcomingMeteredBill = {
  __typename: 'UpcomingMeteredBill';
  creditGrantLineItems: Array<Maybe<MeteredBillCreditGrantLineItem>>;
  /** Invoice-level discounts applied to this invoice. */
  discountLineItems: Array<Maybe<MeteredBillDiscountLineItem>>;
  flatFeeLineItems: Array<MeteredBillFlatFeeLineItem>;
  lastUsageSyncedAt: Maybe<Scalars['Timestamp']['output']>;
  meteredLineItems: Array<MeteredBillMeteredLineItem>;
  totalInCents: Scalars['Int']['output'];
};

/** Input for updating an existing application. */
export type UpdateApplicationInput = {
  /** Updated description of the application's purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated name for the application. */
  name: Scalars['String']['input'];
  /** Updated lifecycle status for the application. */
  status?: InputMaybe<ApplicationStatus>;
};

/** Input to update an AWS shard */
export type UpdateAwsShardInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  coldStartTargetGroupArns?: InputMaybe<Array<Scalars['String']['input']>>;
  ecsClusterArn?: InputMaybe<Scalars['String']['input']>;
  iamRoleArn?: InputMaybe<Scalars['String']['input']>;
  loadbalancerSecurityGroupId?: InputMaybe<Scalars['String']['input']>;
  loadbalancers?: InputMaybe<Array<AwsLoadBalancerInput>>;
  permissionsBoundaryArn?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subnetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  vpcId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingPlanDescriptorsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  readableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input to update a proposal description */
export type UpdateDescriptionInput = {
  /** A proposal description */
  description: Scalars['String']['input'];
};

/** Input for replacing the questions on an existing feedback survey */
export type UpdateFeedbackSurveyInput = {
  /** The new ordered list of questions; replaces the existing set and bumps the version */
  questions: Array<FeedbackQuestionInput>;
  /** The survey to update */
  surveyId: Scalars['ID']['input'];
};

/** Return payload for the updateSurvey mutation */
export type UpdateFeedbackSurveyPayload = {
  __typename: 'UpdateFeedbackSurveyPayload';
  /** The updated survey, or null if validation failed */
  survey: Maybe<FeedbackSurvey>;
  /** Any validation errors that occurred */
  userErrors: Array<UserError>;
};

export type UpdateOperationCollectionEntryResult = OperationCollectionEntry | PermissionError | ValidationError;

export type UpdateOperationCollectionResult = OperationCollection | PermissionError | ValidationError;

export type UpdatePaymentMethodResult = Account | NotFoundError | PermissionError | UpdatePaymentMethodSuccess;

export type UpdatePaymentMethodSuccess = {
  __typename: 'UpdatePaymentMethodSuccess';
  paymentMethodId: Scalars['String']['output'];
};

/** The result of a successful call to PersistedQueryListMutation.updateMetadata. */
export type UpdatePersistedQueryListMetadataResult = {
  __typename: 'UpdatePersistedQueryListMetadataResult';
  persistedQueryList: PersistedQueryList;
};

/** The result/error union returned by PersistedQueryListMutation.updateMetadata. */
export type UpdatePersistedQueryListMetadataResultOrError = PermissionError | UpdatePersistedQueryListMetadataResult;

/** Input for updating an existing policy exception. Any field left null is unchanged. */
export type UpdatePolicyExceptionInput = {
  /** New expiry timestamp, or null to leave unchanged. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** New principal binding, or null to leave unchanged. */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** New justification, or null to leave unchanged. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** New lifecycle status (e.g. revoke an active exception), or null to leave unchanged. */
  status?: InputMaybe<PolicyExceptionStatus>;
};

/**
 * Input for updating an existing policy rule. Any field left null is unchanged.
 * `effect` and `effectConfig` must be supplied together.
 */
export type UpdatePolicyRuleInput = {
  /** Operational configuration overrides — only the supplied fields change. */
  config?: InputMaybe<PolicyRuleConfigInput>;
  /** New description, or null to leave unchanged. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New effect — must be paired with `effectConfig`. */
  effect?: InputMaybe<PolicyEffect>;
  /** New effect-specific configuration — must be paired with `effect`. */
  effectConfig?: InputMaybe<PolicyEffectConfigInput>;
  /** New name, or null to leave unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New principal binding, or null to leave unchanged. */
  principal?: InputMaybe<PolicyRulePrincipalInput>;
  /** New scope, or null to leave unchanged. */
  scope?: InputMaybe<PolicyRuleScopeInput>;
  /** New target, or null to leave unchanged. */
  target?: InputMaybe<PolicyRuleTargetInput>;
};

export type UpdateProposalLifecycleSubscriptionInput = {
  events: Array<ProposalLifecycleEvent>;
  id: Scalars['ID']['input'];
};

export type UpdateProposalLifecycleSubscriptionResult = NotFoundError | PermissionError | ProposalLifecycleSubscription | ValidationError;

export type UpdateProposalResult = PermissionError | Proposal | ValidationError;

export type UpdateRequestedReviewersInput = {
  reviewerUserIdsToAdd?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewerUserIdsToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateRequestedReviewersResult = PermissionError | Proposal | ValidationError;

/** Input for updating a  Cloud Router */
export type UpdateRouterInput = {
  /**
   * Number of GCUs allocated for the Cloud Router
   *
   * This is ignored for serverless Cloud Routers
   */
  gcus?: InputMaybe<Scalars['Int']['input']>;
  /** Graph composition ID, also known as launch ID */
  graphCompositionId?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for ordering orders */
  orderingId: Scalars['String']['input'];
  /** Configuration for the Cloud Router */
  routerConfig?: InputMaybe<Scalars['String']['input']>;
  /** Router version for the Cloud Router */
  routerVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the possible outcomes of an updateRouter mutation */
export type UpdateRouterResult = InternalServerError | InvalidInputErrors | UpdateRouterSuccess;

/**
 * Success branch of an updateRouter mutation.
 * id of the order can be polled via Query.cloud().order(id: ID!) to check-in
 * on the progress of the underlying operation
 */
export type UpdateRouterSuccess = {
  __typename: 'UpdateRouterSuccess';
  order: Order;
};

/** Result of an updateVersion mutation */
export type UpdateRouterVersionResult = InternalServerError | InvalidInputErrors | RouterVersion;

export type UpdateRuleEnforcementInput = {
  /** A json string representing any parameters necessary for the policy's enforcement. Explicit null setting is allowed. */
  params?: InputMaybe<Array<StringToStringInput>>;
};

/** Result of update: the updated configuration, or an error explaining why it could not be updated. */
export type UpdateS3IntegrationResult = AlreadyConfiguredError | InvalidInputError | NotFoundError | PermissionError | S3IntegrationConfig;

/** Input for updating an existing service catalog entry. */
export type UpdateServiceCatalogInput = {
  /** Updated suggested auth configuration. */
  defaultAuth?: InputMaybe<Scalars['JSON']['input']>;
  /** Updated suggested base URL. */
  defaultBaseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated description of what this connector does. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated human-readable name for this catalog entry. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Updated GraphQL schema template for this catalog entry. */
  schemaTemplate?: InputMaybe<Scalars['String']['input']>;
};

/** Input to update an existing Shard */
export type UpdateShardInput = {
  aws?: InputMaybe<UpdateAwsShardInput>;
  gcuCapacity?: InputMaybe<Scalars['Int']['input']>;
  gcuUsage?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  routerCapacity?: InputMaybe<Scalars['Int']['input']>;
  routerUsage?: InputMaybe<Scalars['Int']['input']>;
  shardId: Scalars['String']['input'];
  status?: InputMaybe<ShardStatus>;
};

/** Input for updating an existing service. */
export type UpdateUpstreamServiceInput = {
  /**
   * Updated authentication configuration as a JSON object. If the service
   * template references `{{TOKEN_VAR}}`, include `env_var` (string) here
   * naming the environment variable that holds the secret.
   */
  auth?: InputMaybe<Scalars['JSON']['input']>;
  /** Updated base URL for the service's API endpoint. */
  baseUrl: Scalars['String']['input'];
  /** Updated description of the service's purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated name for the service. */
  name: Scalars['String']['input'];
  /** Updated tags for this service. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Updated reference to a service catalog entry template. */
  templateId: Scalars['UUID']['input'];
};

/** Describes the result of publishing a schema to a graph variant. */
export type UploadSchemaMutationResponse = {
  __typename: 'UploadSchemaMutationResponse';
  /** A machine-readable response code that indicates the type of result (e.g., `UPLOAD_SUCCESS` or `NO_CHANGES`) */
  code: Scalars['String']['output'];
  /** A Human-readable message describing the type of result. */
  message: Scalars['String']['output'];
  /** If the publish operation succeeded, this contains its details. Otherwise, this is null. */
  publication: Maybe<SchemaTag>;
  /** Whether the schema publish operation succeeded (`true`) or encountered errors (`false`). */
  success: Scalars['Boolean']['output'];
  /** If successful, the corresponding publication. */
  tag: Maybe<SchemaTag>;
};

export type UpsertReviewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  decision: ReviewDecision;
  revisionId: Scalars['ID']['input'];
};

export type UpsertReviewResult = PermissionError | Proposal | ValidationError;

export type UpsertRouterResult = GraphVariant | RouterUpsertFailure;

/** A registered service in the constellation registry. */
export type UpstreamService = {
  __typename: 'UpstreamService';
  /** Authentication configuration for the service, stored as a JSON object. */
  auth: Maybe<Scalars['JSON']['output']>;
  /** Base URL for the service's API endpoint. */
  baseUrl: Maybe<Scalars['String']['output']>;
  /** Timestamp when the service was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The catalog entry this service is currently configured with — the object
   * form of `templateId`. Unlike `latestTemplate` this is not filtered by org
   * visibility: it reports what the service is already running, not an
   * upgrade the org would be allowed to take.
   */
  currentTemplate: Maybe<ServiceCatalogType>;
  /** Version timestamp of the catalog entry this service is currently pinned to. */
  currentTemplateVersion: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the service was soft-deleted, or null if active. */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional description of the service's purpose. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Field-level classification tags on this service, keyed by schema
   * coordinate. Auto-seeded from the catalog entry's defaults on
   * creation; customizable per-org via `setServiceFieldTags`.
   */
  fieldTags: Array<ServiceFieldTag>;
  /** Unique identifier for this service. */
  id: Scalars['UUID']['output'];
  /**
   * The newest catalog version for this connector that is visible to this
   * org. Always the latest — it equals the pinned version when the service is
   * up to date. Null only when no version is visible. Use `updateAvailable`,
   * not this field's presence, to test for drift.
   */
  latestTemplate: Maybe<ServiceCatalogType>;
  /** Human-readable name of the service. */
  name: Scalars['String']['output'];
  /** Error message from the most recent publish, only populated when status is FAILED. */
  publishError: Maybe<Scalars['String']['output']>;
  /** Lifecycle status of the publish to GraphOS. */
  status: UpstreamServiceStatus;
  /** Tags used to categorize and filter this service. */
  tags: Array<Scalars['String']['output']>;
  /** Reference to the service catalog entry this service was instantiated from. */
  templateId: Maybe<Scalars['UUID']['output']>;
  /**
   * True when a newer catalog version exists for this service's connector and
   * is visible to this organization. False when the service is already on the
   * newest version, has no template pinned, the connector is no longer
   * available to this org, or the service is `DISCONNECTING`.
   */
  updateAvailable: Scalars['Boolean']['output'];
  /** Timestamp when the service was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A page of upstream services with an optional cursor for the next page. */
export type UpstreamServicePage = {
  __typename: 'UpstreamServicePage';
  /** Cursor for the next page of data, or null on the last page. */
  cursor: Maybe<Scalars['String']['output']>;
  /** Upstream services in this page. */
  items: Array<UpstreamService>;
};

/** Lifecycle status of an upstream service's publish to GraphOS. */
export enum UpstreamServiceStatus {
  /** Most recent publish completed and its launch reached LAUNCH_COMPLETED. */
  CONNECTED = 'CONNECTED',
  /**
   * Disconnect accepted; the subgraph is still being removed from the graph
   * in the background. A service in this state is read-only — mutations that
   * target it report it as missing — and it leaves `upstreamServices` on its
   * own once the removal completes, or comes back as `FAILED` with
   * `publishError` set if the graph refuses the removal.
   *
   * Removal waits on composition, so expect this to last minutes.
   */
  DISCONNECTING = 'DISCONNECTING',
  /** Most recent publish or launch terminated in a non-recoverable error. */
  FAILED = 'FAILED',
  /** Background worker has not yet driven publish/launch to completion. */
  PENDING = 'PENDING'
}

/** Result when usage data sync validation failed */
export type UsageSyncValidationFailed = {
  __typename: 'UsageSyncValidationFailed';
  /** The validation details */
  validation: BillingPeriodUsageSyncValidation;
};

/** Result when usage data sync validation was skipped */
export type UsageSyncValidationSkipped = {
  __typename: 'UsageSyncValidationSkipped';
  /** Reason why the validation was skipped */
  reason: Scalars['String']['output'];
};

/** Result when usage data sync validation succeeded */
export type UsageSyncValidationSucceeded = {
  __typename: 'UsageSyncValidationSucceeded';
  /** The validation details */
  validation: BillingPeriodUsageSyncValidation;
};

/** A registered Apollo Studio user. */
export type User = Identity & {
  __typename: 'User';
  acceptedPrivacyPolicyAt: Maybe<Scalars['Timestamp']['output']>;
  /** Returns a list of all active user API keys for the user. */
  apiKeys: Array<UserApiKey>;
  /** Returns a representation of this user as an `Actor` type. Useful when determining which actor (usually a `User` or `Graph`) performed a particular action in Studio. */
  asActor: Actor;
  /**
   * Get an URL to which an avatar image can be uploaded. Client uploads by sending a PUT request
   * with the image data to MediaUploadInfo.url. Client SHOULD set the "Content-Type" header to the
   * browser-inferred MIME type, and SHOULD set the "x-apollo-content-filename" header to the
   * filename, if such information is available. Client MUST set the "x-apollo-csrf-token" header to
   * MediaUploadInfo.csrfToken.
   */
  avatarUpload: Maybe<AvatarUploadResult>;
  /**
   * Get an image URL for the user's avatar. Note that CORS is not enabled for these URLs. The size
   * argument is used for bandwidth reduction, and should be the size of the image as displayed in the
   * application. Apollo's media server will downscale larger images to at least the requested size,
   * but this will not happen for third-party media servers.
   */
  avatarUrl: Maybe<Scalars['String']['output']>;
  betaFeaturesOn: Scalars['Boolean']['output'];
  canUpdateAvatar: Scalars['Boolean']['output'];
  canUpdateEmail: Scalars['Boolean']['output'];
  canUpdateFullName: Scalars['Boolean']['output'];
  createdAt: Scalars['Timestamp']['output'];
  /** Education-specific data for the user */
  education: Maybe<Education>;
  email: Maybe<Scalars['String']['output']>;
  emailModifiedAt: Maybe<Scalars['Timestamp']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  featureIntros: Maybe<FeatureIntros>;
  fullName: Scalars['String']['output'];
  /** The user's GitHub username, if they log in via GitHub. May be null even for GitHub users in some edge cases. */
  githubUsername: Maybe<Scalars['String']['output']>;
  /** The user's unique ID. */
  id: Scalars['ID']['output'];
  /**
   * This role is reserved exclusively for internal Apollo employees, and it controls what access they may have to other
   * organizations. Only admins are allowed to see this field.
   */
  internalAdminRole: Maybe<InternalMdgAdminRole>;
  /** Whether or not this user is and internal Apollo employee */
  isInternalUser: Scalars['Boolean']['output'];
  isSsoV2: Scalars['Boolean']['output'];
  /** Last time any API token from this user was used against AGM services */
  lastAuthenticatedAt: Maybe<Scalars['Timestamp']['output']>;
  loginFlowSource: Maybe<LoginFlowSource>;
  logoutAfterIdleMs: Maybe<Scalars['Int']['output']>;
  /** A list of the user's memberships in Apollo Studio organizations. */
  memberships: Array<UserMembership>;
  /** The user's first and last name. */
  name: Scalars['String']['output'];
  /** Retrieve a specific attempt by its ID */
  odysseyAttempt: Maybe<OdysseyAttempt>;
  /** All test attempts made by the user */
  odysseyAttempts: Maybe<Array<OdysseyAttempt>>;
  /** Retrieve a specific certification by its ID */
  odysseyCertification: Maybe<OdysseyCertification>;
  /** All certifications earned by the user */
  odysseyCertifications: Array<OdysseyCertification>;
  /** Retrieve a specific Odyssey course by its ID */
  odysseyCourse: Maybe<OdysseyCourse>;
  /** All Odyssey courses the user is enrolled in */
  odysseyCourses: Maybe<Array<OdysseyCourse>>;
  /**
   * Whether the user has early access to Odyssey features
   * @deprecated Unused. Remove from application usage
   */
  odysseyHasEarlyAccess: Scalars['Boolean']['output'];
  /**
   * Whether the user has requested early access to Odyssey
   * @deprecated Unused. Remove from application usage
   */
  odysseyHasRequestedEarlyAccess: Scalars['Boolean']['output'];
  /** Retrieve specific Odyssey tasks by their IDs */
  odysseyTasks: Maybe<Array<OdysseyTask>>;
  sandboxOperationCollections: Array<OperationCollection>;
  /** List of support tickets this user has submitted or raised via any channel */
  supportTickets: Maybe<Array<SupportTicket>>;
  synchronized: Scalars['Boolean']['output'];
  type: UserType;
};


/** A registered Apollo Studio user. */
export type UserapiKeysArgs = {
  includeCookies?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A registered Apollo Studio user. */
export type UseravatarUrlArgs = {
  size: Scalars['Int']['input'];
};


/** A registered Apollo Studio user. */
export type UserodysseyAttemptArgs = {
  id: Scalars['ID']['input'];
};


/** A registered Apollo Studio user. */
export type UserodysseyCertificationArgs = {
  certificationId: Scalars['ID']['input'];
};


/** A registered Apollo Studio user. */
export type UserodysseyCourseArgs = {
  courseId: Scalars['ID']['input'];
};


/** A registered Apollo Studio user. */
export type UserodysseyTasksArgs = {
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Represents a user API key, which has permissions identical to
 * its associated Apollo user.
 */
export type UserApiKey = ApiKey & {
  __typename: 'UserApiKey';
  /** The API key's ID. */
  id: Scalars['ID']['output'];
  /** The API key's name, for distinguishing it from other keys. */
  keyName: Maybe<Scalars['String']['output']>;
  /** The timestamp when the API key was last used for authentication, if available. */
  lastUsed: Maybe<Scalars['Timestamp']['output']>;
  /** The value of the API key. **This is a secret credential!** */
  token: Scalars['String']['output'];
};

/** A field-level validation error returned from a mutation */
export type UserError = {
  __typename: 'UserError';
  /** The field path the error is associated with */
  field: Array<Scalars['String']['output']>;
  /** A human-readable description of the error */
  message: Scalars['String']['output'];
};

/** A single user's membership in a single Apollo Studio organization. */
export type UserMembership = {
  __typename: 'UserMembership';
  /** The organization that the user belongs to. */
  account: Account;
  /** The timestamp when the user was added to the organization. */
  createdAt: Scalars['Timestamp']['output'];
  /**
   * The user's permission level within the organization.
   * @deprecated Use role instead.
   */
  permission: UserPermission;
  /** The user's role within the organization'. */
  role: UserPermission;
  /** The user that belongs to the organization. */
  user: User;
};

export type UserMutation = {
  __typename: 'UserMutation';
  acceptPrivacyPolicy: Maybe<Scalars['Void']['output']>;
  /** Change the user's password */
  changePassword: Maybe<Scalars['Void']['output']>;
  /** Complete an Odyssey attempt with final scoring */
  completeOdysseyAttempt: Maybe<OdysseyAttempt>;
  /** Create a new Odyssey test attempt */
  createOdysseyAttempt: Maybe<OdysseyAttempt>;
  /** Create a new Odyssey certification for the user */
  createOdysseyCertification: Maybe<OdysseyCertification>;
  /** Create multiple Odyssey course enrollments */
  createOdysseyCourses: Maybe<Array<OdysseyCourse>>;
  /** Create multiple Odyssey tasks in parallel for the user */
  createOdysseyTasks: Maybe<Array<OdysseyTask>>;
  /** Delete the user's avatar. Requires User.canUpdateAvatar to be true. */
  deleteAvatar: Maybe<AvatarDeleteError>;
  /** Delete an Odyssey test attempt */
  deleteOdysseyAttempt: Maybe<OdysseyAttempt>;
  /** Delete an Odyssey certification */
  deleteOdysseyCertification: Maybe<OdysseyCertification>;
  /** Delete an Odyssey course enrollment */
  deleteOdysseyCourse: Maybe<OdysseyCourse>;
  /** Delete multiple Odyssey tasks by their IDs */
  deleteOdysseyTasks: Array<Maybe<OdysseyTask>>;
  /** Hard deletes the associated user. Throws an error otherwise with reason included. */
  hardDelete: Maybe<Scalars['Void']['output']>;
  /** Creates a new user API key for this user. */
  newKey: UserApiKey;
  /**
   * If this user has no active user API keys, this creates one for the user.
   * If this user has at least one active user API key, this returns one of those keys at random and does _not_ create a new key.
   */
  provisionKey: Maybe<ApiKeyProvision>;
  /** Refresh information about the user from its upstream service (e.g. list of organizations from GitHub) */
  refresh: Maybe<User>;
  /** Deletes the user API key with the provided ID, if any. */
  removeKey: Maybe<Scalars['Void']['output']>;
  /** Sets a new name for the user API key with the provided ID, if any. This does not invalidate the key or change its value. */
  renameKey: Maybe<UserApiKey>;
  resendVerificationEmail: Maybe<Scalars['Void']['output']>;
  /** Set or update an Odyssey course enrollment */
  setOdysseyCourse: Maybe<OdysseyCourse>;
  /** Set the language for an Odyssey course */
  setOdysseyCourseLanguage: OdysseyCourse;
  /** Set or update a response for an Odyssey attempt */
  setOdysseyResponse: Maybe<OdysseyResponse>;
  /** Set or update a single Odyssey task for the user */
  setOdysseyTask: Maybe<OdysseyTask>;
  /** Submit a support ticket for this user */
  submitSupportTicket: Maybe<SupportTicket>;
  /** Update information about a user; all arguments are optional */
  update: Maybe<User>;
  /** Updates this users' preference concerning opting into beta features. */
  updateBetaFeaturesOn: Maybe<User>;
  /** Update the status of a feature for this. For example, if you want to hide an introductory popup. */
  updateFeatureIntros: Maybe<User>;
  /** Update an existing Odyssey test attempt */
  updateOdysseyAttempt: Maybe<OdysseyAttempt>;
  /**
   * Update user to have the given internal mdg admin role.
   * It is necessary to be an MDG_INTERNAL_SUPER_ADMIN to perform update.
   * Additionally, upserting a null value explicitly revokes this user's
   * admin status.
   */
  updateRole: Maybe<User>;
  /** The user this mutation context belongs to */
  user: User;
  verifyEmail: Maybe<User>;
};


export type UserMutationchangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  previousPassword: Scalars['String']['input'];
};


export type UserMutationcompleteOdysseyAttemptArgs = {
  id: Scalars['ID']['input'];
  pass: Scalars['Boolean']['input'];
  responses: Array<OdysseyResponseCorrectnessInput>;
};


export type UserMutationcreateOdysseyAttemptArgs = {
  testId: Scalars['String']['input'];
};


export type UserMutationcreateOdysseyCertificationArgs = {
  certificationId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationcreateOdysseyCoursesArgs = {
  courses: Array<OdysseyCourseInput>;
};


export type UserMutationcreateOdysseyTasksArgs = {
  tasks: Array<OdysseyTaskInput>;
};


export type UserMutationdeleteOdysseyAttemptArgs = {
  id: Scalars['ID']['input'];
};


export type UserMutationdeleteOdysseyCertificationArgs = {
  id: Scalars['ID']['input'];
};


export type UserMutationdeleteOdysseyCourseArgs = {
  courseId: Scalars['String']['input'];
};


export type UserMutationdeleteOdysseyTasksArgs = {
  taskIds: Array<Scalars['String']['input']>;
};


export type UserMutationnewKeyArgs = {
  keyName: Scalars['String']['input'];
};


export type UserMutationprovisionKeyArgs = {
  keyName: Scalars['String']['input'];
};


export type UserMutationremoveKeyArgs = {
  id: Scalars['ID']['input'];
};


export type UserMutationrenameKeyArgs = {
  id: Scalars['ID']['input'];
  newKeyName?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationsetOdysseyCourseArgs = {
  course: OdysseyCourseInput;
};


export type UserMutationsetOdysseyCourseLanguageArgs = {
  courseId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


export type UserMutationsetOdysseyResponseArgs = {
  response: OdysseyResponseInput;
};


export type UserMutationsetOdysseyTaskArgs = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  courseLanguage?: InputMaybe<Scalars['String']['input']>;
  task: OdysseyTaskInput;
};


export type UserMutationsubmitSupportTicketArgs = {
  ticket: SupportTicketInput;
};


export type UserMutationupdateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  trackingGoogleClientId?: InputMaybe<Scalars['String']['input']>;
  trackingMarketoClientId?: InputMaybe<Scalars['String']['input']>;
  userSegment?: InputMaybe<UserSegment>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationupdateBetaFeaturesOnArgs = {
  betaFeaturesOn: Scalars['Boolean']['input'];
};


export type UserMutationupdateFeatureIntrosArgs = {
  newFeatureIntros?: InputMaybe<FeatureIntrosInput>;
};


export type UserMutationupdateOdysseyAttemptArgs = {
  completedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id: Scalars['ID']['input'];
  pass?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserMutationupdateRoleArgs = {
  newRole?: InputMaybe<InternalMdgAdminRole>;
};


export type UserMutationverifyEmailArgs = {
  token: Scalars['String']['input'];
};

export enum UserPermission {
  BILLING_MANAGER = 'BILLING_MANAGER',
  CONSUMER = 'CONSUMER',
  CONTRIBUTOR = 'CONTRIBUTOR',
  DOCUMENTER = 'DOCUMENTER',
  GRAPH_ADMIN = 'GRAPH_ADMIN',
  LEGACY_GRAPH_KEY = 'LEGACY_GRAPH_KEY',
  OBSERVER = 'OBSERVER',
  ORG_ADMIN = 'ORG_ADMIN',
  PERSISTED_QUERY_PUBLISHER = 'PERSISTED_QUERY_PUBLISHER'
}

export enum UserSegment {
  JOIN_MY_TEAM = 'JOIN_MY_TEAM',
  LOCAL_DEVELOPMENT = 'LOCAL_DEVELOPMENT',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  ODYSSEY = 'ODYSSEY',
  PRODUCTION_GRAPHS = 'PRODUCTION_GRAPHS',
  SANDBOX = 'SANDBOX',
  SANDBOX_OPERATION_COLLECTIONS = 'SANDBOX_OPERATION_COLLECTIONS',
  SANDBOX_PREFLIGHT_SCRIPTS = 'SANDBOX_PREFLIGHT_SCRIPTS',
  TRY_TEAM = 'TRY_TEAM'
}

export type UserSettings = {
  __typename: 'UserSettings';
  appNavCollapsed: Scalars['Boolean']['output'];
  autoManageVariables: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mockingResponses: Scalars['Boolean']['output'];
  preflightScriptEnabled: Scalars['Boolean']['output'];
  responseHints: ResponseHints;
  tableMode: Scalars['Boolean']['output'];
  themeName: ThemeName;
};

/** Explorer user settings input */
export type UserSettingsInput = {
  appNavCollapsed?: InputMaybe<Scalars['Boolean']['input']>;
  autoManageVariables?: InputMaybe<Scalars['Boolean']['input']>;
  mockingResponses?: InputMaybe<Scalars['Boolean']['input']>;
  preflightScriptEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  responseHints?: InputMaybe<ResponseHints>;
  tableMode?: InputMaybe<Scalars['Boolean']['input']>;
  themeName?: InputMaybe<ThemeName>;
};

export type UserTrackingInput = {
  referrer?: InputMaybe<Scalars['String']['input']>;
  referrerDetails?: InputMaybe<Scalars['String']['input']>;
  sessionReferrer?: InputMaybe<Scalars['String']['input']>;
  sessionReferrerCreatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  sessionReferrerDetail?: InputMaybe<Scalars['String']['input']>;
  trackingGoogleClientId?: InputMaybe<Scalars['String']['input']>;
  trackingMarketoClientId?: InputMaybe<Scalars['String']['input']>;
  userSegment?: InputMaybe<UserSegment>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export enum UserType {
  APOLLO = 'APOLLO',
  GITHUB = 'GITHUB',
  SSO = 'SSO'
}

export type ValidateOperationsResult = {
  __typename: 'ValidateOperationsResult';
  validationResults: Array<ValidationResult>;
};

/** An error that occurs when an operation contains invalid user input. */
export type ValidationError = Error & {
  __typename: 'ValidationError';
  /** The error's details. */
  message: Scalars['String']['output'];
};

export enum ValidationErrorCode {
  DEPRECATED_FIELD = 'DEPRECATED_FIELD',
  INVALID_OPERATION = 'INVALID_OPERATION',
  NON_PARSEABLE_DOCUMENT = 'NON_PARSEABLE_DOCUMENT'
}

export enum ValidationErrorType {
  FAILURE = 'FAILURE',
  INVALID = 'INVALID',
  WARNING = 'WARNING'
}

/**
 * Represents a single validation error, with information relating to the error
 * and its respective operation
 */
export type ValidationResult = {
  __typename: 'ValidationResult';
  /** The validation result's error code */
  code: ValidationErrorCode;
  /** Description of the validation error */
  description: Scalars['String']['output'];
  /** The operation related to this validation result */
  operation: OperationDocument;
  /** The type of validation error thrown - warning, failure, or invalid. */
  type: ValidationErrorType;
};

/** The result of a failed call to GraphVariantMutation.linkPersistedQueryList when the specified list is already linked. */
export type VariantAlreadyLinkedError = Error & {
  __typename: 'VariantAlreadyLinkedError';
  message: Scalars['String']['output'];
};

/** The result of a failed call to GraphVariantMutation.unlinkPersistedQueryList when the specified list isn't linked. */
export type VariantAlreadyUnlinkedError = Error & {
  __typename: 'VariantAlreadyUnlinkedError';
  message: Scalars['String']['output'];
};

/** Variant-level configuration of checks. */
export type VariantCheckConfiguration = {
  __typename: 'VariantCheckConfiguration';
  /** Time when the check configuration was created. */
  createdAt: Scalars['Timestamp']['output'];
  customChecksConfig: VariantCheckConfigurationCustomChecks;
  /** Operation checks configuration that allows associated checks to be downgraded from failure to passing. */
  downgradeChecksConfig: VariantCheckConfigurationDowngradeChecks;
  /**
   * Downstream checks configuration for which downstream variants should affect this variant's check
   * status.
   */
  downstreamVariantsConfig: VariantCheckConfigurationDownstreamVariants;
  /** Operation checks configuration for which clients to ignore. */
  excludedClientsConfig: VariantCheckConfigurationExcludedClients;
  /** Operation checks configuration for which operation to ignore. */
  excludedOperationsConfig: VariantCheckConfigurationExcludedOperations;
  /** Graph that this check configuration belongs to */
  graphID: Scalars['String']['output'];
  /** Graph variant that this check configuration belongs to */
  graphVariant: Scalars['String']['output'];
  /** ID of the check configuration */
  id: Scalars['ID']['output'];
  /** Operation checks configuration for which variants' metrics data to include. */
  includedVariantsConfig: VariantCheckConfigurationIncludedVariants;
  /** Whether operations checks are enabled. */
  operationsChecksEnabled: Scalars['Boolean']['output'];
  /** How submitted build input diffs are handled when they match (or don't) a Proposal at the variant level */
  proposalChangeMismatchSeverityConfig: VariantCheckConfigurationProposalChangeMismatchSeverity;
  /** Operation checks configuration for time range and associated thresholds. */
  timeRangeConfig: VariantCheckConfigurationTimeRange;
  /** Time when the check configuration was updated. */
  updatedAt: Scalars['Timestamp']['output'];
  /** Identity of the last actor to update the check configuration, if available. */
  updatedBy: Maybe<Identity>;
};

export type VariantCheckConfigurationCustomChecks = {
  __typename: 'VariantCheckConfigurationCustomChecks';
  /** ID of the check configuration */
  checkConfigurationId: Scalars['ID']['output'];
  /** Whether custom checks is enabled for this variant. Non-null if useGraphSettings is false, otherwise null. */
  enableCustomChecks: Maybe<Scalars['Boolean']['output']>;
  /** When true, indicates that graph-level configuration is used for this variant setting. The default at variant creation is true. */
  useGraphSettings: Scalars['Boolean']['output'];
};

export type VariantCheckConfigurationDowngradeChecks = {
  __typename: 'VariantCheckConfigurationDowngradeChecks';
  /**
   *  During operation checks, if this option is enabled, the check will not fail or mark any operations as
   * broken/changed if the default value has changed, only if the default value is removed completely.
   */
  downgradeDefaultValueChange: Maybe<Scalars['Boolean']['output']>;
  /**
   *  During operation checks, if this option is enabled, it evaluates a check run against zero operations
   * as a pass instead of a failure.
   */
  downgradeStaticChecks: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, indicates that graph-level configuration is used for this variant setting. The default
   * at variant creation is true.
   */
  useGraphSettings: Scalars['Boolean']['output'];
};

export type VariantCheckConfigurationDownstreamVariants = {
  __typename: 'VariantCheckConfigurationDownstreamVariants';
  /**
   * During downstream checks, this variant's check workflow will wait for all downstream check
   * workflows for <blockingDownstreamVariants> variants to complete, and if any of them fail, then
   * this variant's check workflow will fail.
   */
  blockingDownstreamVariants: Array<Scalars['String']['output']>;
};

export type VariantCheckConfigurationExcludedClients = {
  __typename: 'VariantCheckConfigurationExcludedClients';
  /**
   * When true, indicates that graph-level configuration is appended to the variant-level
   * configuration. The default at variant creation is true.
   */
  appendGraphSettings: Scalars['Boolean']['output'];
  /**
   * During operation checks, ignore clients matching any of the <excludedClients> filters. The
   * default at variant creation is the empty list.
   */
  excludedClients: Array<ClientFilter>;
};

export type VariantCheckConfigurationExcludedOperations = {
  __typename: 'VariantCheckConfigurationExcludedOperations';
  /**
   * When true, indicates that graph-level configuration is appended to the variant-level
   * configuration. The default at variant creation is true.
   */
  appendGraphSettings: Scalars['Boolean']['output'];
  /**
   * During operation checks, ignore operations matching any of the <excludedOperationNames> filters.
   * The default at variant creation is the empty list.
   */
  excludedOperationNames: Array<OperationNameFilter>;
  /**
   * During operation checks, ignore operations matching any of the <excludedOperations> filters. The
   * default at variant creation is the empty list.
   */
  excludedOperations: Array<OperationInfoFilter>;
};

export type VariantCheckConfigurationIncludedVariants = {
  __typename: 'VariantCheckConfigurationIncludedVariants';
  /**
   * During operation checks, fetch operations from the metrics data for <includedVariants> variants.
   * Non-null if useGraphSettings is false and is otherwise null.
   */
  includedVariants: Maybe<Array<Scalars['String']['output']>>;
  /**
   * When true, indicates that graph-level configuration is used for this variant setting. The default
   * at variant creation is true.
   */
  useGraphSettings: Scalars['Boolean']['output'];
};

export type VariantCheckConfigurationProposalChangeMismatchSeverity = {
  __typename: 'VariantCheckConfigurationProposalChangeMismatchSeverity';
  /** How submitted build input diffs are handled when they match (or don't) a Proposal. Non-null if useGraphSettings is false and is otherwise null. */
  proposalChangeMismatchSeverity: Maybe<ProposalChangeMismatchSeverity>;
  /** When true, indicates that graph-level configuration is used for this variant setting. The default at variant creation is true. */
  useGraphSettings: Scalars['Boolean']['output'];
};

export type VariantCheckConfigurationTimeRange = {
  __typename: 'VariantCheckConfigurationTimeRange';
  /**
   * During operation checks, ignore operations that executed less than <operationCountThreshold>
   * times in the time range. Non-null if useGraphSettings is false and is otherwise null.
   */
  operationCountThreshold: Maybe<Scalars['Int']['output']>;
  /**
   * Duration operation checks, ignore operations that constituted less than
   * <operationCountThresholdPercentage>% of the operations in the time range. Expected values are
   * between 0% and 5%. Non-null if useGraphSettings is false and is otherwise null.
   */
  operationCountThresholdPercentage: Maybe<Scalars['Float']['output']>;
  /**
   * During operation checks, fetch operations from the last <timeRangeSeconds> seconds. Non-null if
   * useGraphSettings is false and is otherwise null.
   */
  timeRangeSeconds: Maybe<Scalars['Long']['output']>;
  /**
   * When true, indicates that graph-level configuration is used for this variant setting. The default
   * at variant creation is true.
   */
  useGraphSettings: Scalars['Boolean']['output'];
};

export type VariantCreationConfig = {
  buildConfigInput: BuildConfigInput;
  endpointSlug?: InputMaybe<Scalars['String']['input']>;
  variantName: Scalars['String']['input'];
};

export enum ViolationLevel {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

/** Webhook notification channel */
export type WebhookChannel = Channel & {
  __typename: 'WebhookChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** List of the Schema Proposal Lifecycle Subscriptions this Channel is subscribed to. */
  proposalLifecycleSubscriptions: Array<ProposalLifecycleSubscription>;
  secretToken: Maybe<Scalars['String']['output']>;
  /** List of the subscriptions this channel is subscribed to, except for ProposalLifecycleSubscriptions. */
  subscriptions: Array<ChannelSubscription>;
  url: Scalars['String']['output'];
};

/** PagerDuty notification channel parameters */
export type WebhookChannelInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  secretToken?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type UI__AcceptInvitationMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  joinToken: Scalars['String']['input'];
}>;


export type UI__AcceptInvitationMutation = { joinAccount: { __typename: 'Account', id: ID['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier } } | null };

export type Account__AccountLayoutQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type Account__AccountLayoutQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', type: UserType, internalAdminRole: InternalMdgAdminRole | null, id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null, account: { __typename: 'Account', id: ID['output'], name: String['output'], isOnTrial: Boolean['output'], secondaryIDs: Array<ID['output']>, limits: { __typename: 'AccountLimits', maxAuditInDays: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, name: String['output'] }, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], state: SubscriptionState, trialExpiresAt: Timestamp['output'] | null } | null } | null };

export type DeleteV2ApiKeyVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  keyId: Scalars['ID']['input'];
}>;


export type DeleteV2ApiKey = { organization: { __typename: 'AccountMutation', deleteKey: ID['output'] } | null };

export type RenameKeyVariables = Exact<{
  keyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type RenameKey = { organization: { __typename: 'AccountMutation', renameKey: { __typename: 'GraphOsKey', id: ID['output'], keyName: String['output'] | null } } | null };

export type SetKeyExpirationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  expiration: Scalars['Timestamp']['input'];
  keyId: Scalars['ID']['input'];
}>;


export type SetKeyExpiration = { organization: { __typename: 'AccountMutation', setKeyExpiration: { __typename: 'GraphOsKey', expiresAt: Timestamp['output'] | null, id: ID['output'] } } | null };

export type RevokeV2ApiKeyVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  keyId: Scalars['ID']['input'];
}>;


export type RevokeV2ApiKey = { organization: { __typename: 'AccountMutation', revokeKey: ID['output'] } | null };

export type RotateV2ApiKeyVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  expireOldKeyAt?: InputMaybe<Scalars['Timestamp']['input']>;
  keyId: Scalars['ID']['input'];
  newKeyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RotateV2ApiKey = { organization: { __typename: 'AccountMutation', rotateKey: { __typename: 'GraphOsKey', id: ID['output'], token: String['output'] } } | null };

export type CreateV2ApiKeyVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: GraphOsKeyType;
  resources?: InputMaybe<ApiKeyResourceInput>;
}>;


export type CreateV2ApiKey = { organization: { __typename: 'AccountMutation', createKey: { __typename: 'GraphOsKey', id: ID['output'], token: String['output'], createdAt: Timestamp['output'], expiresAt: Timestamp['output'] | null, keyName: String['output'] | null, createdBy: { __typename: 'Actor', actorId: ID['output'], type: ActorType }, resources: Array<{ __typename: 'ApiKeyResource', resourceId: String['output'], resourceType: String['output'] }> } } | null };

export type FetchSubgraphsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
}>;


export type FetchSubgraphs = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], subgraphs: Array<{ __typename: 'FederatedImplementingService', name: String['output'] }> | null } | null } | null };

export type getV2ApiKeysVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type getV2ApiKeys = { organization: { __typename: 'Account', name: String['output'], id: ID['output'], apiKeys: { __typename: 'GraphOsKeyConnection', edges: Array<{ __typename: 'GraphOsKeyEdge', node: { __typename: 'GraphOsKey', id: ID['output'], keyName: String['output'] | null, createdAt: Timestamp['output'], expiresAt: Timestamp['output'] | null, lastUsed: Timestamp['output'] | null, keyType: GraphOsKeyType | null, revokedAt: Timestamp['output'] | null, createdBy: { __typename: 'Actor', actorId: ID['output'], type: ActorType }, resources: Array<{ __typename: 'ApiKeyResource', resourceId: String['output'], resourceType: String['output'] }> } }> } } | null };

export type ChampionDashboardQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type ChampionDashboardQuery = { account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, canChangePlan: Boolean['output'], limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxGraphOSSeats: Long['output'] | null, maxRequestsPerMonth: Long['output'] | null } | null, memberships: Array<{ __typename: 'AccountMembership', permission: UserPermission, user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'] } }> | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, name: String['output'], kind: BillingPlanKind } } | null };

export type ChecksWidgetQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
}>;


export type ChecksWidgetQuery = { account: { __typename: 'Account', id: ID['output'], registryStatsWindow: { __typename: 'RegistryStatsWindow', schemaCheckStats: Array<{ __typename: 'AccountChecksStatsRecord', id: ID['output'], timestamp: Timestamp['output'], metrics: { __typename: 'AccountChecksStatsMetrics', totalFailedChecks: Long['output'], totalSuccessfulChecks: Long['output'] } }> } | null } | null };

export type MembersWidgetFragment = { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, limits: { __typename: 'AccountLimits', maxGraphOSSeats: Long['output'] | null } | null, memberships: Array<{ __typename: 'AccountMembership', permission: UserPermission, user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'] } }> | null };

export type ChampionDashboard_NumGraphsWidgetVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type ChampionDashboard_NumGraphsWidget = { account: { __typename: 'Account', id: ID['output'], name: String['output'], graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'] }>, statsWindow: { __typename: 'ServiceStatsWindow', billingUsageStats: Array<{ __typename: 'ServiceBillingUsageStatsRecord', timestamp: Timestamp['output'], groupBy: { __typename: 'ServiceBillingUsageStatsDimensions', agentVersion: String['output'] | null, variant: String['output'] | null } }> } | null }> } | null };

export type ChampionDashboard_UpdatesAvailableModalVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ChampionDashboard_UpdatesAvailableModal = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], statsWindow: { __typename: 'ServiceStatsWindow', billingUsageStats: Array<{ __typename: 'ServiceBillingUsageStatsRecord', timestamp: Timestamp['output'], groupBy: { __typename: 'ServiceBillingUsageStatsDimensions', agentVersion: String['output'] | null, variant: String['output'] | null } }> } | null } | null };

export type PlanInfoWidgetFragment = { __typename: 'Account', id: ID['output'], canChangePlan: Boolean['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, name: String['output'], kind: BillingPlanKind }, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxRequestsPerMonth: Long['output'] | null } | null };

export type RequestsWidgetQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  resolution: Resolution;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<AccountQueryStatsFilter>;
}>;


export type RequestsWidgetQuery = { account: { __typename: 'Account', id: ID['output'], statsWindow: { __typename: 'AccountStatsWindow', queryStats: Array<{ __typename: 'AccountQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'AccountQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null } | null };

export type SchemaPublishesWidgetQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  resolution?: InputMaybe<Resolution>;
}>;


export type SchemaPublishesWidgetQuery = { account: { __typename: 'Account', id: ID['output'], registryStatsWindow: { __typename: 'RegistryStatsWindow', schemaPublishStats: Array<{ __typename: 'AccountPublishesStatsRecord', id: ID['output'], timestamp: Timestamp['output'], metrics: { __typename: 'AccountPublishesStatsMetrics', totalPublishes: Long['output'] } }> } | null } | null };

export type ChampionDashboard_SupportTicketsWidgetVariables = Exact<{ [key: string]: never; }>;


export type ChampionDashboard_SupportTicketsWidget = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], supportTickets: Array<{ __typename: 'SupportTicket', id: Int['output'], key: String['output'], summary: String['output'], priority: TicketPriority, created: Timestamp['output'], statusCategory: TicketStatusCategory }> | null }
   | null };

export type UI__FinalizeResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UI__FinalizeResetPasswordMutation = { finalizePasswordReset: String['output'] | null };

export type GetInternalOrgIdQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetInternalOrgIdQuery = { organization: { __typename: 'Account', id: ID['output'], internalID: ID['output'] } | null };

export type InviteModalAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'], availableRoles: Array<UserPermission> };

export type InviteModalInviteMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role?: InputMaybe<UserPermission>;
}>;


export type InviteModalInviteMutation = { account: { __typename: 'AccountMutation', invite: { __typename: 'AccountInvitation', id: ID['output'] } | null } | null };

export type MemberManagementAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'], availableRoles: Array<UserPermission>, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], billingModel: BillingModel } } | null, capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, limits: { __typename: 'AccountLimits', maxGraphOSSeats: Long['output'] | null } | null, invitations: Array<{ __typename: 'AccountInvitation', id: ID['output'], email: String['output'], createdAt: Timestamp['output'], lastSentAt: Timestamp['output'] | null, role: UserPermission }> | null, memberships: Array<{ __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null, githubUsername: String['output'] | null } & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }) & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }), account: { __typename: 'Account', id: ID['output'] } }> | null, roles: { __typename: 'AccountRoles', canQueryMembers: Boolean['output'], canManageMembers: Boolean['output'], canRemoveMembers: Boolean['output'], canSetConstrainedPlan: Boolean['output'], canQueryBillingInfo: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', name: String['output'], id: ID['output'] }> }> };

export type MemberManagementUserFragment = { __typename: 'User', id: ID['output'], fullName: String['output'] };

export type RemoveInvitationModalAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'] };

export type RemoveInvitationModalAccountInvitationFragment = { __typename: 'AccountInvitation', id: ID['output'], email: String['output'] };

export type UI__RemoveInvitationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
}>;


export type UI__RemoveInvitationMutation = { account: { __typename: 'AccountMutation', removeInvitation: Void['output'] | null } | null };

export type RemoveMemberModalAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'], sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'] } }> | null };

export type UI__removeMemberMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UI__removeMemberMutation = { account: { __typename: 'AccountMutation', removeMember: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'] } }> | null } | null } | null };

export type UI__revokeSessionsMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UI__revokeSessionsMutation = { account: { __typename: 'AccountMutation', revokeUserSessions: Void['output'] | null } | null };

export type UpdateRoleModalAccountFragment = { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null }> };

export type UpdateRoleModalMembershipFragment = { __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'] }, account: { __typename: 'Account', id: ID['output'] } };

export type UI__updateRoleMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  permission: UserPermission;
  userId: Scalars['ID']['input'];
}>;


export type UI__updateRoleMutation = { account: { __typename: 'AccountMutation', updateUserPermission: { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> } | null } | null };

export type MemberManagementStoryVariables = Exact<{ [key: string]: never; }>;


export type MemberManagementStory = { account: { __typename: 'Account', id: ID['output'], name: String['output'], availableRoles: Array<UserPermission>, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], billingModel: BillingModel } } | null, capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, limits: { __typename: 'AccountLimits', maxGraphOSSeats: Long['output'] | null } | null, invitations: Array<{ __typename: 'AccountInvitation', id: ID['output'], email: String['output'], createdAt: Timestamp['output'], lastSentAt: Timestamp['output'] | null, role: UserPermission }> | null, memberships: Array<{ __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null, githubUsername: String['output'] | null } & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }) & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }), account: { __typename: 'Account', id: ID['output'] } }> | null, roles: { __typename: 'AccountRoles', canQueryMembers: Boolean['output'], canManageMembers: Boolean['output'], canRemoveMembers: Boolean['output'], canSetConstrainedPlan: Boolean['output'], canQueryBillingInfo: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', name: String['output'], id: ID['output'] }> }> } | null };

export type MembersPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type MembersPageQuery = { canBypassPlanRestrictions: Boolean['output'], me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], fullName: String['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], name: String['output'], availableRoles: Array<UserPermission>, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], billingModel: BillingModel } } | null, capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, limits: { __typename: 'AccountLimits', maxGraphOSSeats: Long['output'] | null } | null, invitations: Array<{ __typename: 'AccountInvitation', id: ID['output'], email: String['output'], createdAt: Timestamp['output'], lastSentAt: Timestamp['output'] | null, role: UserPermission }> | null, memberships: Array<{ __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null, githubUsername: String['output'] | null } & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }) & ({ __typename: 'User', odysseyCertifications: Array<{ __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] }> } | { __typename: 'User', odysseyCertifications?: never }), account: { __typename: 'Account', id: ID['output'] } }> | null, roles: { __typename: 'AccountRoles', canQueryMembers: Boolean['output'], canManageMembers: Boolean['output'], canRemoveMembers: Boolean['output'], canSetConstrainedPlan: Boolean['output'], canQueryBillingInfo: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', name: String['output'], id: ID['output'] }> }> } | null };

export type BillingUsageStatsFragment = { __typename: 'AccountBillingUsageStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'AccountBillingUsageStatsMetrics', operationCount: Long['output'] }, groupBy: { __typename: 'AccountBillingUsageStatsDimensions', agentVersion: String['output'] | null, schemaTag: String['output'] | null, operationType: String['output'] | null, operationSubtype: String['output'] | null, serviceId: ID['output'] | null } };

export type Account__UsageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  from: Scalars['Timestamp']['input'];
}>;


export type Account__UsageQuery = { account: { __typename: 'Account', id: ID['output'], statsWindow: { __typename: 'AccountStatsWindow', billingUsageStats: Array<{ __typename: 'AccountBillingUsageStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'AccountBillingUsageStatsMetrics', operationCount: Long['output'] }, groupBy: { __typename: 'AccountBillingUsageStatsDimensions', agentVersion: String['output'] | null, schemaTag: String['output'] | null, operationType: String['output'] | null, operationSubtype: String['output'] | null, serviceId: ID['output'] | null } }> } | null } | null };

export type MeteredBillingUsageWidgetContainerStoryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  usageStartDate: Scalars['Date']['input'];
}>;


export type MeteredBillingUsageWidgetContainerStoryQuery = { account: { __typename: 'Account', id: ID['output'], currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], meteredBillingSummary: { __typename: 'MeteredBillingSummary', exportedMeterValues: Array<{ __typename: 'MeterSummaries', start: Date['output'], end: Date['output'], aggregatedValues: Array<{ __typename: 'MeterValue', meterKind: MeterKind, value: Long['output'] }> }> } | null } | null } | null };

export type MeteredBillingUsageAccountFragment = { __typename: 'Account', id: ID['output'], currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], meteredBillingSummary: { __typename: 'MeteredBillingSummary', exportedMeterValues: Array<{ __typename: 'MeterSummaries', start: Date['output'], end: Date['output'], aggregatedValues: Array<{ __typename: 'MeterValue', meterKind: MeterKind, value: Long['output'] }> }>, upcomingBill: { __typename: 'UpcomingMeteredBill', totalInCents: Int['output'], flatFeeLineItems: Array<{ __typename: 'MeteredBillFlatFeeLineItem', name: String['output'], amountInCents: Int['output'] }>, meteredLineItems: Array<{ __typename: 'MeteredBillMeteredLineItem', meterKind: MeterKind, amountInCents: Int['output'] }> } } | null } | null };

export type SettingsPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SettingsPageQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, capabilities: { __typename: 'AccountCapabilities', sso: Boolean['output'] } | null } | null };

export type OrgSettingMenuItemsFragment = { __typename: 'Account', id: ID['output'], sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, capabilities: { __typename: 'AccountCapabilities', sso: Boolean['output'] } | null };

export type PrepaidCreditCardFragment = { __typename: 'BillingSubscription', uuid: ID['output'], promoCreditSummaries: Array<{ __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] }> };

export type SSO_Wizard__SubmitBaseConfigVariables = Exact<{
  accountId: Scalars['ID']['input'];
  domains: Array<Scalars['String']['input']> | Scalars['String']['input'];
  idpId?: InputMaybe<Scalars['String']['input']>;
  useLegacyIdpId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SSO_Wizard__SubmitBaseConfig = { account: { __typename: 'AccountMutation', createBaseSsoConnection: { __typename: 'BaseConnection', id: ID['output'] } | null } | null };

export type SSO_Wizard__ReplaceDomainsVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  domains: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SSO_Wizard__ReplaceDomains = { account: { __typename: 'AccountMutation', replaceSsoConnectionDomains:
      | { __typename: 'BaseConnection', id: ID['output'] }
      | { __typename: 'OidcConnection', id: ID['output'] }
      | { __typename: 'SamlConnection', id: ID['output'] }
     | null } | null };

export type SubmitOidcCredentialVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  config: OidcConfigurationInput;
}>;


export type SubmitOidcCredential = { account: { __typename: 'AccountMutation', addOidcConfigurationToBaseConnection: { __typename: 'OidcConnection', id: ID['output'], idpId: ID['output'], issuer: String['output'], state: SsoConnectionState } | null } | null };

export type UpdateOidcCredentialVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  metadata: OidcConfigurationUpdateInput;
}>;


export type UpdateOidcCredential = { account: { __typename: 'AccountMutation', updateOidcConnectionMetadata: { __typename: 'OidcConnection', id: ID['output'], idpId: ID['output'], issuer: String['output'], state: SsoConnectionState } | null } | null };

export type SSO_Wizard__SubmitSamlConfigVariables = Exact<{
  id: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  metadata: SamlConfigurationInput;
}>;


export type SSO_Wizard__SubmitSamlConfig = { account: { __typename: 'AccountMutation', addSamlMetadataToBaseConnection: { __typename: 'SamlConnection', id: ID['output'] } | null } | null };

export type SSO_Wizard__ParseMetadataVariables = Exact<{
  metadata: Scalars['String']['input'];
}>;


export type SSO_Wizard__ParseMetadata = { sso: { __typename: 'SsoQuery', parseSamlIdpMetadata: { __typename: 'ParsedSamlIdpMetadata', wantsSignedRequests: Boolean['output'], entityId: String['output'], ssoUrl: String['output'], verificationCerts: Array<{ __typename: 'ParsedSamlCertInfo', pem: String['output'], subjectDN: String['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'] }>, encryptionCerts: Array<{ __typename: 'ParsedSamlCertInfo', pem: String['output'], subjectDN: String['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'] }> } | null } };

export type SSO_Wizard__FinalizeSSOVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SSO_Wizard__FinalizeSSO = { account: { __typename: 'AccountMutation', finalizeSsoV2Migration: Void['output'] | null } | null };

export type SSO_Wizard__FinalizeSSOReconfigurationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  newConnectionId: Scalars['ID']['input'];
}>;


export type SSO_Wizard__FinalizeSSOReconfiguration = { account: { __typename: 'AccountMutation', finalizeSsoReconfiguration: Void['output'] | null } | null };

export type SSO_Wizard__ValidateSSOVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SSO_Wizard__ValidateSSO = { account: { __typename: 'Account', id: ID['output'], ssoV2: { __typename: 'SsoConfig', allConnections: Array<
        | { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], stateV2: SsoConnectionStateV2 }
        | { __typename: 'OidcConnection', id: ID['output'], idpId: ID['output'], stateV2: SsoConnectionStateV2 }
        | { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], stateV2: SsoConnectionStateV2 }
      > } | null } | null };

export type UpcomingBillCardAccountFragment = { __typename: 'Account', id: ID['output'], currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], currentPeriodEndsAt: Timestamp['output'], promoCredits: { __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] } | null, meteredBillingSummary: { __typename: 'MeteredBillingSummary', upcomingBill: { __typename: 'UpcomingMeteredBill', totalInCents: Int['output'], meteredLineItems: Array<{ __typename: 'MeteredBillMeteredLineItem', meterKind: MeterKind, amountInCents: Int['output'] }>, discountLineItems: Array<{ __typename: 'MeteredBillDiscountLineItem', amountInCents: Int['output'] } | null>, creditGrantLineItems: Array<{ __typename: 'MeteredBillCreditGrantLineItem', amountInCents: Int['output'] } | null>, flatFeeLineItems: Array<{ __typename: 'MeteredBillFlatFeeLineItem', amountInCents: Int['output'] }> } } | null, promoCreditSummaries: Array<{ __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] }> } | null };

export type CreditGrantSectionFragment = { __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] };

export type UpcomingBillDetailsAccountFragment = { __typename: 'BillingSubscription', uuid: ID['output'], currentPeriodEndsAt: Timestamp['output'], meteredBillingSummary: { __typename: 'MeteredBillingSummary', upcomingBill: { __typename: 'UpcomingMeteredBill', totalInCents: Int['output'], meteredLineItems: Array<{ __typename: 'MeteredBillMeteredLineItem', meterKind: MeterKind, amountInCents: Int['output'] }>, discountLineItems: Array<{ __typename: 'MeteredBillDiscountLineItem', amountInCents: Int['output'] } | null>, creditGrantLineItems: Array<{ __typename: 'MeteredBillCreditGrantLineItem', amountInCents: Int['output'] } | null>, flatFeeLineItems: Array<{ __typename: 'MeteredBillFlatFeeLineItem', amountInCents: Int['output'] }> } } | null };

export type BillingPreviewStoryQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingPreviewStoryQuery = { account: { __typename: 'Account', id: ID['output'], seats: { __typename: 'Seats', fullPrice: Int['output'], free: Int['output'] } | null } | null };

export type BillingPreviewAccountFragment = { __typename: 'Account', id: ID['output'], seats: { __typename: 'Seats', fullPrice: Int['output'], free: Int['output'] } | null };

export type InvoiceDetailAccountFragment = { __typename: 'Account', id: ID['output'], internalID: ID['output'], isOnTrial: Boolean['output'], seats: { __typename: 'Seats', fullPrice: Int['output'], free: Int['output'] } | null, roles: { __typename: 'AccountRoles', canQueryBillingInfo: Boolean['output'], canQueryMembers: Boolean['output'] } | null, currentPlan: { __typename: 'BillingPlan', tier: BillingPlanTier, billingModel: BillingModel, billingPeriod: BillingPeriod | null, id: ID['output'] }, currentSubscription: { __typename: 'BillingSubscription', currentPeriodEndsAt: Timestamp['output'], pricePerSeatInUsdCents: Int['output'] | null, id: ID['output'] } | null, invoices: Array<{ __typename: 'Invoice', id: ID['output'], uuid: ID['output'], totalInCents: Int['output'], createdAt: Timestamp['output'], invoiceNumber: String['output'] }> };

export type PaymentCardAccountFragment = { __typename: 'Account', id: ID['output'], currentSubscription: { __typename: 'BillingSubscription', id: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null } } | null, billingInfo: { __typename: 'BillingInfo', name: String['output'] | null, cardType: String['output'] | null, year: Int['output'] | null, month: Int['output'] | null, lastFour: Int['output'] | null, vatNumber: String['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null };

export type CreateSetupIntentMutationVariables = Exact<{
  internalAccountId: Scalars['ID']['input'];
}>;


export type CreateSetupIntentMutation = { billing: { __typename: 'BillingMutation', createSetupIntent:
      | { __typename: 'NotFoundError', message: String['output'] }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'SetupIntentSuccess', clientSecret: String['output'] }
     | null } | null };

export type PlanCardAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'], canChangePlan: Boolean['output'], seats: { __typename: 'Seats', fullPrice: Int['output'], free: Int['output'] } | null, currentBillingMonth: { __typename: 'BillingMonth', start: Timestamp['output'], end: Timestamp['output'], requests: Long['output'] } | null, limits: { __typename: 'AccountLimits', maxRequestsPerMonth: Long['output'] | null } | null, currentPlan: { __typename: 'BillingPlan', name: String['output'], tier: BillingPlanTier, kind: BillingPlanKind, billingModel: BillingModel, billingPeriod: BillingPeriod | null, id: ID['output'] }, currentSubscription: { __typename: 'BillingSubscription', autoRenew: Boolean['output'], state: SubscriptionState, currentPeriodEndsAt: Timestamp['output'], pricePerUnitInUsdCents: Int['output'], pricePerSeatInUsdCents: Int['output'] | null, canceledAt: Timestamp['output'] | null, id: ID['output'] } | null, roles: { __typename: 'AccountRoles', canQueryBillingInfo: Boolean['output'] } | null };

export type ReactivateTeamSubscriptionMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type ReactivateTeamSubscriptionMutation = { organization: { __typename: 'AccountMutation', reactivateCurrentSubscription: { __typename: 'Account', id: ID['output'], name: String['output'], currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, canceledAt: Timestamp['output'] | null, id: ID['output'] } | null } | null } | null };

export type SubmitTeamCancellationFeedbackMutationVariables = Exact<{
  feedback: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
}>;


export type SubmitTeamCancellationFeedbackMutation = { organization: { __typename: 'AccountMutation', submitTeamCancellationFeedback: Void['output'] | null } | null };

export type CancelPaidSubscriptionModalFragment = { __typename: 'Account', id: ID['output'], name: String['output'] };

export type MemberSectionFragment = { __typename: 'Account', id: ID['output'], seats: { __typename: 'Seats', free: Int['output'], fullPrice: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, tier: BillingPlanTier } };

export type OrganizationLockFragment = { __typename: 'Account', id: ID['output'], name: String['output'], isLocked: Boolean['output'] | null, lockType: AccountLockType | null, isOnExpiredTrial: Boolean['output'], expiredTrialSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } };

export type SubscriptionCancellationFragment = { __typename: 'Account', id: ID['output'], name: String['output'], currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, canceledAt: Timestamp['output'] | null, id: ID['output'] } | null };

export type CancelTeamSubscriptionMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type CancelTeamSubscriptionMutation = { organization: { __typename: 'AccountMutation', cancelSubscriptions: { __typename: 'Account', id: ID['output'], name: String['output'], currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, canceledAt: Timestamp['output'] | null, id: ID['output'] } | null } | null } | null };

export type LockOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  type: AccountLockType;
}>;


export type LockOrganizationMutation = { organization: { __typename: 'AccountMutation', lock: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, lockType: AccountLockType | null, name: String['output'], isOnExpiredTrial: Boolean['output'], expiredTrialSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } } | null } | null };

export type StaticInvitationsCardVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type StaticInvitationsCard = { account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, staticInvitations: Array<{ __typename: 'OrganizationInviteLink', joinToken: String['output'], role: UserPermission, createdAt: Timestamp['output'] }> | null, roles: { __typename: 'AccountRoles', canManageMembers: Boolean['output'] } | null, limits: { __typename: 'AccountLimits', maxGraphOSSeats: Long['output'] | null } | null, memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null } | null };

export type RevokeStaticInvitationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  tokenToRevoke: Scalars['String']['input'];
}>;


export type RevokeStaticInvitation = { account: { __typename: 'AccountMutation', revokeStaticInvitation: { __typename: 'OrganizationInviteLink', joinToken: String['output'], role: UserPermission } | null } | null };

export type CreateStaticInvitationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  createStaticInvitationRole: UserPermission;
}>;


export type CreateStaticInvitation = { account: { __typename: 'AccountMutation', createStaticInvitation: { __typename: 'OrganizationInviteLink', joinToken: String['output'], role: UserPermission } | null } | null };

export type OrgBillingSettingsPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  usageStartDate: Scalars['Date']['input'];
}>;


export type OrgBillingSettingsPageQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], createdAt: Timestamp['output'] | null, name: String['output'], canChangePlan: Boolean['output'], internalID: ID['output'], isOnTrial: Boolean['output'], billingContactEmail: String['output'] | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxRequestsPerMonth: Long['output'] | null } | null, seats: { __typename: 'Seats', fullPrice: Int['output'], free: Int['output'] } | null, currentBillingMonth: { __typename: 'BillingMonth', start: Timestamp['output'], end: Timestamp['output'], requests: Long['output'] } | null, currentPlan: { __typename: 'BillingPlan', name: String['output'], tier: BillingPlanTier, kind: BillingPlanKind, billingModel: BillingModel, billingPeriod: BillingPeriod | null, id: ID['output'] }, currentSubscription: { __typename: 'BillingSubscription', autoRenew: Boolean['output'], state: SubscriptionState, currentPeriodEndsAt: Timestamp['output'], pricePerUnitInUsdCents: Int['output'], pricePerSeatInUsdCents: Int['output'] | null, canceledAt: Timestamp['output'] | null, uuid: ID['output'], id: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null }, promoCredits: { __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] } | null, meteredBillingSummary: { __typename: 'MeteredBillingSummary', exportedMeterValues: Array<{ __typename: 'MeterSummaries', start: Date['output'], end: Date['output'], aggregatedValues: Array<{ __typename: 'MeterValue', meterKind: MeterKind, value: Long['output'] }> }>, upcomingBill: { __typename: 'UpcomingMeteredBill', totalInCents: Int['output'], flatFeeLineItems: Array<{ __typename: 'MeteredBillFlatFeeLineItem', name: String['output'], amountInCents: Int['output'] }>, meteredLineItems: Array<{ __typename: 'MeteredBillMeteredLineItem', meterKind: MeterKind, amountInCents: Int['output'] }>, discountLineItems: Array<{ __typename: 'MeteredBillDiscountLineItem', amountInCents: Int['output'] } | null>, creditGrantLineItems: Array<{ __typename: 'MeteredBillCreditGrantLineItem', amountInCents: Int['output'] } | null> } } | null, promoCreditSummaries: Array<{ __typename: 'CreditGrant', expiresAt: Timestamp['output'] | null, remainingCreditsInUsdCents: Int['output'], totalCreditsInUsdCents: Int['output'] }> } | null, roles: { __typename: 'AccountRoles', canQueryBillingInfo: Boolean['output'], canQueryMembers: Boolean['output'] } | null, invoices: Array<{ __typename: 'Invoice', id: ID['output'], uuid: ID['output'], totalInCents: Int['output'], createdAt: Timestamp['output'], invoiceNumber: String['output'] }>, billingInfo: { __typename: 'BillingInfo', name: String['output'] | null, cardType: String['output'] | null, year: Int['output'] | null, month: Int['output'] | null, lastFour: Int['output'] | null, vatNumber: String['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null } | null };

export type OrgGeneralSettingsSettingsPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type OrgGeneralSettingsSettingsPageQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], createdAt: Timestamp['output'] | null, name: String['output'], isSelfServiceDeletable: Boolean['output'] | null, companyUrl: String['output'] | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, capabilities: { __typename: 'AccountCapabilities', sso: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }>, memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null, tier: BillingPlanTier, isTrial: Boolean['output'], name: String['output'], kind: BillingPlanKind } } | null } | null };

export type OrgSecuritySettingsSettingsPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type OrgSecuritySettingsSettingsPageQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], createdAt: Timestamp['output'] | null, sessionDurationInSeconds: Int['output'] | null, internalID: ID['output'], companyUrl: String['output'] | null, availableRoles: Array<UserPermission>, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider, defaultRole: UserPermission, idpid: ID['output'] } | null, capabilities: { __typename: 'AccountCapabilities', sso: Boolean['output'] } | null, ssoV2: { __typename: 'SsoConfig', defaultRole: UserPermission, currentConnection:
        | { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
        | { __typename: 'OidcConnection', id: ID['output'], discoveryUri: String['output'] | null, clientId: ID['output'], idpId: ID['output'], issuer: String['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
        | { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], wantsSignedRequests: Boolean['output'], encryptionCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }>, verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }> }, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
       | null, allConnections: Array<
        | { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
        | { __typename: 'OidcConnection', id: ID['output'], discoveryUri: String['output'] | null, clientId: ID['output'], idpId: ID['output'], issuer: String['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
        | { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], wantsSignedRequests: Boolean['output'], encryptionCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }>, verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }> }, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
      > } | null } | null };

export type AuditExportFragment = { __typename: 'Account', id: ID['output'], name: String['output'], auditLogExports: Array<{ __typename: 'AuditLogExport', completedAt: Timestamp['output'] | null, exportedFiles: Array<String['output']> | null, from: Timestamp['output'], id: ID['output'], status: AuditStatus, to: Timestamp['output'], requester: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null } | null, graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }> | null, actors: Array<
      | { __typename: 'InternalIdentity', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
      | { __typename: 'Service', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
      | { __typename: 'ServiceAccount', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
      | { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null, asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
    > | null }> | null };

export type AuditLogFiltersVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AuditLogFilters = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', email: String['output'] | null, id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', permission: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, avatarUrl: String['output'] | null } }> | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }> } | null };

export type RequestAuditExportMutationVariables = Exact<{
  requestAuditExportActors?: InputMaybe<Array<ActorInput> | ActorInput>;
  requestAuditExportFrom: Scalars['Timestamp']['input'];
  requestAuditExportTo: Scalars['Timestamp']['input'];
  requestAuditExportGraphIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  accountId: Scalars['ID']['input'];
}>;


export type RequestAuditExportMutation = { account: { __typename: 'AccountMutation', requestAuditExport: { __typename: 'Account', id: ID['output'], name: String['output'], auditLogExports: Array<{ __typename: 'AuditLogExport', completedAt: Timestamp['output'] | null, exportedFiles: Array<String['output']> | null, from: Timestamp['output'], id: ID['output'], status: AuditStatus, to: Timestamp['output'], requester: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null } | null, graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }> | null, actors: Array<
          | { __typename: 'InternalIdentity', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'Service', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'ServiceAccount', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null, asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        > | null }> | null } | null } | null };

export type AuditLogExportsAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AuditLogExportsAccountQuery = { account: { __typename: 'Account', id: ID['output'], name: String['output'], auditLogExports: Array<{ __typename: 'AuditLogExport', completedAt: Timestamp['output'] | null, exportedFiles: Array<String['output']> | null, from: Timestamp['output'], id: ID['output'], status: AuditStatus, to: Timestamp['output'], requester: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null } | null, graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }> | null, actors: Array<
        | { __typename: 'InternalIdentity', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'Service', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'ServiceAccount', id: ID['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null, email: String['output'] | null, asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
      > | null }> | null } | null };

export type AuditLogExportsCancelMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  auditExportId: Scalars['String']['input'];
}>;


export type AuditLogExportsCancelMutation = { account: { __typename: 'AccountMutation', auditExport: { __typename: 'AuditLogExportMutation', cancel: { __typename: 'Account', id: ID['output'], auditLogExports: Array<{ __typename: 'AuditLogExport', id: ID['output'], status: AuditStatus }> | null } | null } | null } | null };

export type AuditLogExportsDeleteMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  auditExportId: Scalars['String']['input'];
}>;


export type AuditLogExportsDeleteMutation = { account: { __typename: 'AccountMutation', auditExport: { __typename: 'AuditLogExportMutation', delete: { __typename: 'Account', id: ID['output'], auditLogExports: Array<{ __typename: 'AuditLogExport', id: ID['output'], status: AuditStatus }> | null } | null } | null } | null };

export type AccountAvatarCardVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type AccountAvatarCard = { account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, avatarUpload:
      | { __typename: 'AvatarUploadError' }
      | { __typename: 'MediaUploadInfo', csrfToken: String['output'], maxContentLength: Int['output'], url: String['output'] }
     | null } | null };

export type CompanyUrlCardAccountFragment = { __typename: 'Account', id: ID['output'], companyUrl: String['output'] | null };

export type CompanyUrlMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyUrlMutation = { account: { __typename: 'AccountMutation', updateCompanyUrl: { __typename: 'Account', id: ID['output'], companyUrl: String['output'] | null } | null } | null };

export type UpdateDefaultSSORoleVariables = Exact<{
  role: UserPermission;
  accountId: Scalars['ID']['input'];
}>;


export type UpdateDefaultSSORole = { account: { __typename: 'AccountMutation', updateSSODefaultRole: { __typename: 'OrganizationSSO', defaultRole: UserPermission } | null } | null };

export type UpdateDefaultSSORoleModal_account = { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, sso: { __typename: 'OrganizationSSO', defaultRole: UserPermission } | null };

export type DeleteOrganizationBillingPlanFragment = { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null, tier: BillingPlanTier, isTrial: Boolean['output'], name: String['output'], kind: BillingPlanKind };

export type DeleteOrganizationBillingSubscriptionFragment = { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null, tier: BillingPlanTier, isTrial: Boolean['output'], name: String['output'], kind: BillingPlanKind } };

export type DeleteOrganizationFragment = { __typename: 'Account', id: ID['output'], name: String['output'], isSelfServiceDeletable: Boolean['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }>, memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null, currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null, tier: BillingPlanTier, isTrial: Boolean['output'], name: String['output'], kind: BillingPlanKind } } | null };

export type UI__DeleteOrganizationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UI__DeleteOrganizationMutation = { account: { __typename: 'AccountMutation', hardDelete: Void['output'] | null } | null };

export type DisplayNameCardAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'] };

export type UpdateCompanyNameVariables = Exact<{
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateCompanyName = { account: { __typename: 'AccountMutation', updateName: Void['output'] | null } | null };

export type DisplayNameModalAccountFragment = { __typename: 'Account', id: ID['output'], name: String['output'] };

export type UpdateOrganizationIDVariables = Exact<{
  oldAccountID: Scalars['ID']['input'];
  newAccountID: Scalars['ID']['input'];
}>;


export type UpdateOrganizationID = { account: { __typename: 'AccountMutation', updateID: { __typename: 'Account', id: ID['output'] } | null } | null };

export type UPDATE_SESSION_DURATIONVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
}>;


export type UPDATE_SESSION_DURATION = { organization: { __typename: 'AccountMutation', setCustomSessionLength: Int['output'] } | null };

export type SessionConfigurationCardAccountFragment = { __typename: 'Account', id: ID['output'], sessionDurationInSeconds: Int['output'] | null };

type SSOConnectionFragment_BaseConnection = { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null };

type SSOConnectionFragment_OidcConnection = { __typename: 'OidcConnection', discoveryUri: String['output'] | null, clientId: ID['output'], idpId: ID['output'], issuer: String['output'], id: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null };

type SSOConnectionFragment_SamlConnection = { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], wantsSignedRequests: Boolean['output'], encryptionCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }>, verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }> }, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null };

export type SSOConnectionFragment =
  | SSOConnectionFragment_BaseConnection
  | SSOConnectionFragment_OidcConnection
  | SSOConnectionFragment_SamlConnection
;

export type SSOConfigurationCardAccountFragment = { __typename: 'Account', id: ID['output'], internalID: ID['output'], companyUrl: String['output'] | null, sessionDurationInSeconds: Int['output'] | null, availableRoles: Array<UserPermission>, sso: { __typename: 'OrganizationSSO', defaultRole: UserPermission, idpid: ID['output'], provider: OrganizationSSOProvider } | null, ssoV2: { __typename: 'SsoConfig', defaultRole: UserPermission, currentConnection:
      | { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
      | { __typename: 'OidcConnection', id: ID['output'], discoveryUri: String['output'] | null, clientId: ID['output'], idpId: ID['output'], issuer: String['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
      | { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], wantsSignedRequests: Boolean['output'], encryptionCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }>, verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }> }, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
     | null, allConnections: Array<
      | { __typename: 'BaseConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
      | { __typename: 'OidcConnection', id: ID['output'], discoveryUri: String['output'] | null, clientId: ID['output'], idpId: ID['output'], issuer: String['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
      | { __typename: 'SamlConnection', id: ID['output'], idpId: ID['output'], domains: Array<String['output']>, updatedAt: Timestamp['output'], state: SsoConnectionState, stateV2: SsoConnectionStateV2, metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], wantsSignedRequests: Boolean['output'], encryptionCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }>, verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'], pem: String['output'], subjectDN: String['output'] }> }, scim: { __typename: 'SsoScimProvisioningDetails', scimEnabled: Boolean['output'], scimEndpoint: String['output'] | null } | null }
    > } | null };

export type RemoveSamlCertificateVariables = Exact<{
  accountId: Scalars['ID']['input'];
  certId: Scalars['ID']['input'];
}>;


export type RemoveSamlCertificate = { account: { __typename: 'AccountMutation', saml: { __typename: 'SamlConnectionMutation', removeVerificationCert: { __typename: 'SamlConnection', id: ID['output'] } | null } | null } | null };

export type DeleteSsoConnectionVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type DeleteSsoConnection = { ssoV2: { __typename: 'SsoMutation', deleteSsoConnection:
      | { __typename: 'BaseConnection', id: ID['output'] }
      | { __typename: 'OidcConnection', id: ID['output'] }
      | { __typename: 'SamlConnection', id: ID['output'] }
     | null } };

export type UploadNewCertificateParseMetadataVariables = Exact<{
  metadata: Scalars['String']['input'];
}>;


export type UploadNewCertificateParseMetadata = { sso: { __typename: 'SsoQuery', parseSamlIdpMetadata: { __typename: 'ParsedSamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'], verificationCerts: Array<{ __typename: 'ParsedSamlCertInfo', pem: String['output'], subjectDN: String['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'] }> } | null } };

export type UploadNewCertificateVariables = Exact<{
  id: Scalars['ID']['input'];
  pem: Scalars['String']['input'];
}>;


export type UploadNewCertificate = { account: { __typename: 'AccountMutation', saml: { __typename: 'SamlConnectionMutation', addVerificationCert: { __typename: 'SamlConnection', id: ID['output'], metadata: { __typename: 'SamlIdpMetadata', entityId: String['output'], ssoUrl: String['output'] } } | null } | null } | null };

export type NoVariantsSupergraphDeleteMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type NoVariantsSupergraphDeleteMutation = { service: { __typename: 'ServiceMutation', delete: Void['output'] | null } | null };

export type SupergraphsListPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SupergraphsListPageQuery = { account: { __typename: 'Account', id: ID['output'], capabilities: { __typename: 'AccountCapabilities', connectorsInRouter: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], graphType: GraphType }>, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, tier: BillingPlanTier, name: String['output'] } } | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type SupergraphsListServiceFragment = { __typename: 'Service', id: ID['output'], graphType: GraphType, title: String['output'], avatarUrl: String['output'] | null, description: String['output'] | null, hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isPublic: Boolean['output'], requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, hasSupergraphSchema: Boolean['output'], derivedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] }> | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
          | { __typename: 'BuildSuccess' }
         | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] }, launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
           | null } | null } | null } | null }>, roles: { __typename: 'ServiceRoles', canQueryTokens: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateAvatar: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canQueryProposals: Boolean['output'], canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null };

export type SupergraphsListQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SupergraphsListQuery = { account: { __typename: 'Account', id: ID['output'], graphsConnection: { __typename: 'AccountGraphConnection', edges: Array<{ __typename: 'AccountGraphEdge', node: { __typename: 'Service', id: ID['output'], graphType: GraphType, title: String['output'], avatarUrl: String['output'] | null, description: String['output'] | null, hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isPublic: Boolean['output'], requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, hasSupergraphSchema: Boolean['output'], derivedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] }> | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
                  | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
                  | { __typename: 'BuildSuccess' }
                 | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] }, launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
                    | { __typename: 'BuildFailure' }
                    | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
                   | null } | null } | null } | null }>, roles: { __typename: 'ServiceRoles', canQueryTokens: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateAvatar: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canQueryProposals: Boolean['output'], canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null } | null }> | null } | null } | null };

export type SupergraphsListItemStoryQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type SupergraphsListItemStoryQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, title: String['output'], avatarUrl: String['output'] | null, description: String['output'] | null, hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], roles: { __typename: 'ServiceRoles', canQueryTokens: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateAvatar: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canQueryProposals: Boolean['output'], canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, hasSupergraphSchema: Boolean['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] }, launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
             | null } | null } | null } | null }> } | null };

export type SupergraphListGraphFirstLoadMetadataFragment = { __typename: 'GraphVariant', id: ID['output'], name: String['output'], url: String['output'] | null, isFavoriteOfCurrentUser: Boolean['output'], isProtected: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, hasSupergraphSchema: Boolean['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'] }> }
        | { __typename: 'BuildSuccess' }
       | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], typeCount: Int['output'], fieldCount: Int['output'] } } | null };

export type SupergraphsListItemGraphFragment = { __typename: 'Service', id: ID['output'], graphType: GraphType, title: String['output'], avatarUrl: String['output'] | null, description: String['output'] | null, hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], roles: { __typename: 'ServiceRoles', canQueryTokens: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateAvatar: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canQueryProposals: Boolean['output'], canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, hasSupergraphSchema: Boolean['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
          | { __typename: 'BuildSuccess' }
         | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] }, launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
           | null } | null } | null } | null }> };

export type SupergraphsVariantsTable_graph_Fragment = { __typename: 'Service', id: ID['output'], graphType: GraphType, title: String['output'], roles: { __typename: 'ServiceRoles', canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
          | { __typename: 'BuildSuccess' }
         | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] } } | null }> };

export type SupergraphsVariantsTable_graphDeferred_Fragment = { __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
           | null } | null } | null } | null }> };

export type UpgradeModalQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UpgradeModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', email: String['output'] | null, fullName: String['output'], id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'] } | null };

export type AppLayoutQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  canQueryBilling: Scalars['Boolean']['input'];
}>;


export type AppLayoutQuery = { account: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, currentSubscription?: { __typename: 'BillingSubscription', state: SubscriptionState, uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } } | null, currentPlan: { __typename: 'BillingPlan', tier: BillingPlanTier, isTrial: Boolean['output'], id: ID['output'], readableId: ID['output'] }, ssoV2: { __typename: 'SsoConfig', currentConnection:
        | { __typename: 'BaseConnection', id: ID['output'] }
        | { __typename: 'OidcConnection', id: ID['output'] }
        | { __typename: 'SamlConnection', id: ID['output'] }
       | null } | null } | null };

export type EOLBannerFragment = { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } };

export type GlobalHeaderGraphContentQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type GlobalHeaderGraphContentQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, service: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, roles: { __typename: 'ServiceRoles', canQueryPrivateInfo: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, compositionVersion: String['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canQueryBuildConfig: Boolean['output'] }, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
            | { __typename: 'BuildSuccess' }
           | null } | null, buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null } | null, account: { __typename: 'Account', id: ID['output'], name: String['output'], services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], isFavoriteOfCurrentUser: Boolean['output'], isContract: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canQueryBuildConfig: Boolean['output'] } }> }> } | null } | null };

export type ContractBadgeServiceFragment = { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
          | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
         | null } | null } | null } | null };

export type ContractBadgeStatusQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ContractBadgeStatusQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
           | null } | null } | null } | null } | null };

export type FederatedGraphWidgetGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
        | { __typename: 'BuildSuccess' }
       | null } | null, buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null };

export type GraphVariantSwitcherFragment = { __typename: 'Account', id: ID['output'], name: String['output'], services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], isFavoriteOfCurrentUser: Boolean['output'], isContract: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canQueryBuildConfig: Boolean['output'] } }> }> };

export type PublicGraphWidgetQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type PublicGraphWidgetQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, roles: { __typename: 'ServiceRoles', canManageVariants: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'] } | null } | null };

export type GlobalSandboxHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalSandboxHeaderQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type PublishThisGraphButtonFragment = { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null }, user: { __typename: 'User', id: ID['output'] } }> };

export type OrgProvisionerUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgProvisionerUserQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'] }
   | null };

export type OrgProvisionerCreateOrgMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgProvisionerCreateOrgMutation = { newAccount: { __typename: 'Account', id: ID['output'] } | null };

export type SamlCertBannerQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SamlCertBannerQuery = { account: { __typename: 'Account', id: ID['output'], ssoV2: { __typename: 'SsoConfig', currentConnection:
        | { __typename: 'BaseConnection', id: ID['output'] }
        | { __typename: 'OidcConnection', id: ID['output'] }
        | { __typename: 'SamlConnection', id: ID['output'], metadata: { __typename: 'SamlIdpMetadata', verificationCerts: Array<{ __typename: 'SamlCertInfo', id: ID['output'], notAfter: Timestamp['output'], notBefore: Timestamp['output'] }> } }
       | null } | null } | null };

export type EmbeddedAuthenticatorQueryVariables = Exact<{
  graphRef: Scalars['ID']['input'];
}>;


export type EmbeddedAuthenticatorQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], permissions: { __typename: 'GraphVariantPermissions', canQuerySchemas: Boolean['output'] } }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type GenerateEmbedApiKeyMutationVariables = Exact<{
  keyName: Scalars['String']['input'];
}>;


export type GenerateEmbedApiKeyMutation = { me:
    | { __typename: 'ServiceMutation' }
    | { __typename: 'UserMutation', newKey: { __typename: 'UserApiKey', id: ID['output'], token: String['output'] } }
   | null };

export type EmbedAcceptInvitationMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  joinToken: Scalars['String']['input'];
}>;


export type EmbedAcceptInvitationMutation = { joinAccount: { __typename: 'Account', id: ID['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier } } | null };

export type EmbeddedExplorerPermissionsQueryVariables = Exact<{
  graphRef: Scalars['ID']['input'];
}>;


export type EmbeddedExplorerPermissionsQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'], permissions: { __typename: 'GraphVariantPermissions', canQuerySchemas: Boolean['output'] } }
    | { __typename: 'InvalidRefFormat' }
   | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], apiKeys: Array<{ __typename: 'UserApiKey', id: ID['output'] }> }
   | null };

export type ChangeLogPageVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  historyOffset?: InputMaybe<Scalars['Int']['input']>;
  historyLimit: Scalars['Int']['input'];
  includeUnchanged: Scalars['Boolean']['input'];
}>;


export type ChangeLogPage = { service: { __typename: 'Service', id: ID['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'], history: Array<{ __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], diffToPrevious: { __typename: 'SchemaDiff', tag: String['output'] | null, changes: Array<{ __typename: 'Change', code: String['output'], parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null }> } | null }> } | null } | null };

export type SchemaTagDiffFragment = { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], diffToPrevious: { __typename: 'SchemaDiff', tag: String['output'] | null, changes: Array<{ __typename: 'Change', code: String['output'], parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null }> } | null };

export type SingleChangePageVariables = Exact<{
  schemaTagId: Scalars['ID']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type SingleChangePage = { service: { __typename: 'Service', id: ID['output'], schemaTagById: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], diffToPrevious: { __typename: 'SchemaDiff', tag: String['output'] | null, changes: Array<{ __typename: 'Change', code: String['output'], parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null }> } | null } | null } | null };

export type CheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], rerunOf: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } | null, triggeredBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, gitContext: { __typename: 'GitContext', commit: ID['output'] | null, branch: String['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', compositionPackageVersion: String['output'] | null, id: ID['output'], buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } }
            | { __typename: 'CompositionBuildCheckPassed', compositionPackageVersion: String['output'] | null, id: ID['output'], buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } }
           | null }
        | { __typename: 'CustomCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
        | { __typename: 'FilterCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
           | null }
        | { __typename: 'LintCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
        | { __typename: 'OperationsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, validationConfig: { __typename: 'SchemaDiffValidationConfig', includedVariants: Array<String['output']> | null, from: Timestamp['output'] | null, to: Timestamp['output'] | null, queryCountThreshold: Int['output'] | null, excludedClients: Array<{ __typename: 'ClientInfoFilterOutput', name: String['output'], version: String['output'] | null }> | null, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null } | null, operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], result: { __typename: 'OperationsCheckResult', id: ID['output'], enhancedModeEnabled: Boolean['output'] | null, enhancedModeStats: { __typename: 'EnhancedModeStats', queriesWithEnhancedMode: Int['output'], queriesWithoutEnhancedMode: Int['output'], latestTimeWithoutEnhancedMode: Timestamp['output'] | null } | null } | null } | null } | null } | null };

type BuildConfigBuildCheckResultFragment_CompositionBuildCheckFailed = { __typename: 'CompositionBuildCheckFailed', compositionPackageVersion: String['output'] | null, id: ID['output'], buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } };

type BuildConfigBuildCheckResultFragment_CompositionBuildCheckPassed = { __typename: 'CompositionBuildCheckPassed', compositionPackageVersion: String['output'] | null, id: ID['output'], buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } };

type BuildConfigBuildCheckResultFragment_FilterBuildCheckFailed = { __typename: 'FilterBuildCheckFailed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } };

type BuildConfigBuildCheckResultFragment_FilterBuildCheckPassed = { __typename: 'FilterBuildCheckPassed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } };

export type BuildConfigBuildCheckResultFragment =
  | BuildConfigBuildCheckResultFragment_CompositionBuildCheckFailed
  | BuildConfigBuildCheckResultFragment_CompositionBuildCheckPassed
  | BuildConfigBuildCheckResultFragment_FilterBuildCheckFailed
  | BuildConfigBuildCheckResultFragment_FilterBuildCheckPassed
;

export type CheckDetailsConfigurationWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], createdAt: Timestamp['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, validationConfig: { __typename: 'SchemaDiffValidationConfig', includedVariants: Array<String['output']> | null, from: Timestamp['output'] | null, to: Timestamp['output'] | null, queryCountThreshold: Int['output'] | null, excludedClients: Array<{ __typename: 'ClientInfoFilterOutput', name: String['output'], version: String['output'] | null }> | null, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null } | null, operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], result: { __typename: 'OperationsCheckResult', id: ID['output'], enhancedModeEnabled: Boolean['output'] | null, enhancedModeStats: { __typename: 'EnhancedModeStats', queriesWithEnhancedMode: Int['output'], queriesWithoutEnhancedMode: Int['output'], latestTimeWithoutEnhancedMode: Timestamp['output'] | null } | null } | null } | null, tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], buildResult:
        | { __typename: 'CompositionBuildCheckFailed', id: ID['output'], compositionPackageVersion: String['output'] | null, buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } }
        | { __typename: 'CompositionBuildCheckPassed', id: ID['output'], compositionPackageVersion: String['output'] | null, buildInputs: { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> } }
       | null }
    | { __typename: 'CustomCheckTask', id: ID['output'] }
    | { __typename: 'DownstreamCheckTask', id: ID['output'] }
    | { __typename: 'FilterCheckTask', id: ID['output'], buildResult:
        | { __typename: 'FilterBuildCheckFailed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
        | { __typename: 'FilterBuildCheckPassed', id: ID['output'], buildInputs: { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
       | null }
    | { __typename: 'LintCheckTask', id: ID['output'] }
    | { __typename: 'OperationsCheckTask', id: ID['output'] }
    | { __typename: 'ProposalsCheckTask', id: ID['output'] }
  > };

export type CheckDetailsConfigurationSchemaDiffValidationConfigFragment = { __typename: 'SchemaDiffValidationConfig', includedVariants: Array<String['output']> | null, from: Timestamp['output'] | null, to: Timestamp['output'] | null, queryCountThreshold: Int['output'] | null, excludedClients: Array<{ __typename: 'ClientInfoFilterOutput', name: String['output'], version: String['output'] | null }> | null, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null };

export type CheckLayoutQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckLayoutQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, status: CheckWorkflowStatus, gitContext: { __typename: 'GitContext', branch: String['output'] | null } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, baseVariant: { __typename: 'GraphVariant', id: ID['output'] } | null, upstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'] } | null } | null } | null };

export type IndividualAffectedQueryName = { __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null };

export type CheckSchemasQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckSchemasQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], proposedSchemaHash: String['output'] | null, baseSchemaHash: String['output'] | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> | null, baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, rerunOf: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus }
        | { __typename: 'CustomCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
        | { __typename: 'FilterCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus }
        | { __typename: 'LintCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
        | { __typename: 'OperationsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, baseVariant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'] } | null } | null } | null };

export type SchemaDiffQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  baseHash?: InputMaybe<Scalars['SHA256']['input']>;
  proposedHash?: InputMaybe<Scalars['SHA256']['input']>;
  isUnchanged: Scalars['Boolean']['input'];
}>;


export type SchemaDiffQuery = { service: { __typename: 'Service', id: ID['output'], baseDoc: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null, proposedDoc?: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null } | null };

export type CheckTasksQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckTasksQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], rerunOf: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null }, diffs: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], subgraph: String['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddDirective', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddDirectiveUsage', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddEnum', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddEnumValue', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddField', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddImplementation', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddInput', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddInterface', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddObject', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddScalar', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddSchemaDefinition', type: FlatDiffType }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage', type: FlatDiffType }
              | { __typename: 'FlatDiffAddSchemaRootOperation', type: FlatDiffType, rootType: String['output'] }
              | { __typename: 'FlatDiffAddUnion', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddUnionMember', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffAddValidLocation', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeArgumentDefault', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeDescription', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeInputFieldDefault', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeSchemaDescription', type: FlatDiffType }
              | { __typename: 'FlatDiffRemoveArgument', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveDirective', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveDirectiveUsage', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveEnum', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveEnumValue', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveField', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveImplementation', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveInput', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveInterface', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveObject', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveScalar', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveSchemaDefinition', type: FlatDiffType }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage', type: FlatDiffType }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation', type: FlatDiffType, rootType: String['output'] }
              | { __typename: 'FlatDiffRemoveUnion', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveUnionMember', type: FlatDiffType, coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveValidLocation', type: FlatDiffType, coordinate: String['output'] }
            , relatedProposalResults: Array<{ __typename: 'RelatedProposalResult', proposal: { __typename: 'Proposal', id: ID['output'] } }> }>, relatedProposalResults: Array<{ __typename: 'RelatedProposalResult', statusAtCheck: ProposalStatus, proposal: { __typename: 'Proposal', id: ID['output'], displayName: String['output'], description: String['output'], backingVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } } }> }
      > } | null } | null };

type TasksMenuTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type TasksMenuTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null };

type TasksMenuTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null };

type TasksMenuTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type TasksMenuTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null };

type TasksMenuTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null };

type TasksMenuTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument' }
      | { __typename: 'FlatDiffAddDirective' }
      | { __typename: 'FlatDiffAddDirectiveUsage' }
      | { __typename: 'FlatDiffAddEnum' }
      | { __typename: 'FlatDiffAddEnumValue' }
      | { __typename: 'FlatDiffAddField' }
      | { __typename: 'FlatDiffAddImplementation' }
      | { __typename: 'FlatDiffAddInput' }
      | { __typename: 'FlatDiffAddInterface' }
      | { __typename: 'FlatDiffAddObject' }
      | { __typename: 'FlatDiffAddScalar' }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation' }
      | { __typename: 'FlatDiffAddUnion' }
      | { __typename: 'FlatDiffAddUnionMember' }
      | { __typename: 'FlatDiffAddValidLocation' }
      | { __typename: 'FlatDiffChangeArgumentDefault' }
      | { __typename: 'FlatDiffChangeDescription' }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
      | { __typename: 'FlatDiffChangeInputFieldDefault' }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument' }
      | { __typename: 'FlatDiffRemoveDirective' }
      | { __typename: 'FlatDiffRemoveDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveEnum' }
      | { __typename: 'FlatDiffRemoveEnumValue' }
      | { __typename: 'FlatDiffRemoveField' }
      | { __typename: 'FlatDiffRemoveImplementation' }
      | { __typename: 'FlatDiffRemoveInput' }
      | { __typename: 'FlatDiffRemoveInterface' }
      | { __typename: 'FlatDiffRemoveObject' }
      | { __typename: 'FlatDiffRemoveScalar' }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
      | { __typename: 'FlatDiffRemoveUnion' }
      | { __typename: 'FlatDiffRemoveUnionMember' }
      | { __typename: 'FlatDiffRemoveValidLocation' }
     }> };

export type TasksMenuTaskFragment =
  | TasksMenuTaskFragment_CompositionCheckTask
  | TasksMenuTaskFragment_CustomCheckTask
  | TasksMenuTaskFragment_DownstreamCheckTask
  | TasksMenuTaskFragment_FilterCheckTask
  | TasksMenuTaskFragment_LintCheckTask
  | TasksMenuTaskFragment_OperationsCheckTask
  | TasksMenuTaskFragment_ProposalsCheckTask
;

type taskToTaskTypeTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'] };

type taskToTaskTypeTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'] };

export type taskToTaskTypeTaskFragment =
  | taskToTaskTypeTaskFragment_CompositionCheckTask
  | taskToTaskTypeTaskFragment_CustomCheckTask
  | taskToTaskTypeTaskFragment_DownstreamCheckTask
  | taskToTaskTypeTaskFragment_FilterCheckTask
  | taskToTaskTypeTaskFragment_LintCheckTask
  | taskToTaskTypeTaskFragment_OperationsCheckTask
  | taskToTaskTypeTaskFragment_ProposalsCheckTask
;

export type RerunBannerCheckFragment = { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

export type RerunBannerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type RerunBannerQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], upstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], reruns: Array<{ __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }> | null } | null, reruns: Array<{ __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }> | null } | null } | null };

type TaskStatusBarTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus };

type TaskStatusBarTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null };

type TaskStatusBarTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null };

type TaskStatusBarTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus };

type TaskStatusBarTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null };

type TaskStatusBarTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null };

type TaskStatusBarTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument' }
      | { __typename: 'FlatDiffAddDirective' }
      | { __typename: 'FlatDiffAddDirectiveUsage' }
      | { __typename: 'FlatDiffAddEnum' }
      | { __typename: 'FlatDiffAddEnumValue' }
      | { __typename: 'FlatDiffAddField' }
      | { __typename: 'FlatDiffAddImplementation' }
      | { __typename: 'FlatDiffAddInput' }
      | { __typename: 'FlatDiffAddInterface' }
      | { __typename: 'FlatDiffAddObject' }
      | { __typename: 'FlatDiffAddScalar' }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation' }
      | { __typename: 'FlatDiffAddUnion' }
      | { __typename: 'FlatDiffAddUnionMember' }
      | { __typename: 'FlatDiffAddValidLocation' }
      | { __typename: 'FlatDiffChangeArgumentDefault' }
      | { __typename: 'FlatDiffChangeDescription' }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
      | { __typename: 'FlatDiffChangeInputFieldDefault' }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument' }
      | { __typename: 'FlatDiffRemoveDirective' }
      | { __typename: 'FlatDiffRemoveDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveEnum' }
      | { __typename: 'FlatDiffRemoveEnumValue' }
      | { __typename: 'FlatDiffRemoveField' }
      | { __typename: 'FlatDiffRemoveImplementation' }
      | { __typename: 'FlatDiffRemoveInput' }
      | { __typename: 'FlatDiffRemoveInterface' }
      | { __typename: 'FlatDiffRemoveObject' }
      | { __typename: 'FlatDiffRemoveScalar' }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
      | { __typename: 'FlatDiffRemoveUnion' }
      | { __typename: 'FlatDiffRemoveUnionMember' }
      | { __typename: 'FlatDiffRemoveValidLocation' }
     }> };

export type TaskStatusBarTaskFragment =
  | TaskStatusBarTaskFragment_CompositionCheckTask
  | TaskStatusBarTaskFragment_CustomCheckTask
  | TaskStatusBarTaskFragment_DownstreamCheckTask
  | TaskStatusBarTaskFragment_FilterCheckTask
  | TaskStatusBarTaskFragment_LintCheckTask
  | TaskStatusBarTaskFragment_OperationsCheckTask
  | TaskStatusBarTaskFragment_ProposalsCheckTask
;

export type BuildCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type BuildCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], buildTask:
        | { __typename: 'CompositionCheckTask', id: ID['output'], result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], supergraphSdl: GraphQLDocument['output'] | null, errors: Array<{ __typename: 'SchemaCompositionError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], supergraphSdl: GraphQLDocument['output'] | null, errors: Array<{ __typename: 'SchemaCompositionError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null }
        | { __typename: 'FilterCheckTask', id: ID['output'] }
       | null, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null } | null } | null };

export type CustomCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type CustomCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, baseSchemaHash: String['output'] | null, proposedSchemaHash: String['output'] | null, isSandboxCheck: Boolean['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'] } | null, baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'] }
        | { __typename: 'CustomCheckTask', id: ID['output'], result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', rule: String['output'], level: ViolationLevel, coordinate: String['output'] | null, message: String['output'], sourceLocations: Array<{ __typename: 'FileLocation', subgraphName: String['output'] | null, end: { __typename: 'FileCoordinate', byteOffset: Int['output'], column: Int['output'], line: Int['output'] }, start: { __typename: 'FileCoordinate', byteOffset: Int['output'], column: Int['output'], line: Int['output'] } }> | null }> } | null }
        | { __typename: 'DownstreamCheckTask', id: ID['output'] }
        | { __typename: 'FilterCheckTask', id: ID['output'] }
        | { __typename: 'LintCheckTask', id: ID['output'] }
        | { __typename: 'OperationsCheckTask', id: ID['output'] }
        | { __typename: 'ProposalsCheckTask', id: ID['output'] }
      >, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null } | null } | null };

export type DownstreamCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type DownstreamCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], downstreamTask: { __typename: 'DownstreamCheckTask', status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, tasks: Array<
              | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, buildResult:
                  | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'] }> }
                  | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
                 | null }
              | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'] } | null }
              | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
            > } | null }> | null } | null } | null } | null };

export type FilterBuildCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type FilterBuildCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], buildTask:
        | { __typename: 'CompositionCheckTask', id: ID['output'] }
        | { __typename: 'FilterCheckTask', id: ID['output'], buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', supergraphSchemaHash: SHA256['output'], id: ID['output'] }
           | null }
       | null } | null } | null };

export type SupergraphShemaByHashVariables = Exact<{
  graphId: Scalars['ID']['input'];
  hash: Scalars['SHA256']['input'];
}>;


export type SupergraphShemaByHash = { service: { __typename: 'Service', id: ID['output'], document: GraphQLDocument['output'] | null } | null };

export type LintCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type LintCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], ignoredLinterViolations: Array<{ __typename: 'IgnoredRule', ignoredRule: LintRule, schemaCoordinate: String['output'] }>, linterConfiguration: { __typename: 'GraphLinterConfiguration', rules: Array<{ __typename: 'LinterRuleLevelConfiguration', rule: LintRule, goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, description: String['output'], level: LintDiagnosticLevel, category: LinterRuleCategory }> }, checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], baseSchemaHash: String['output'] | null, proposedSchemaHash: String['output'] | null, isSandboxCheck: Boolean['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'] } | null, baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'] }
        | { __typename: 'CustomCheckTask', id: ID['output'] }
        | { __typename: 'DownstreamCheckTask', id: ID['output'] }
        | { __typename: 'FilterCheckTask', id: ID['output'] }
        | { __typename: 'LintCheckTask', id: ID['output'], result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', rule: LintRule, level: LintDiagnosticLevel, coordinate: String['output'], message: String['output'], sourceLocations: Array<{ __typename: 'Location', subgraphName: String['output'] | null, end: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null, start: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null }> }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
        | { __typename: 'OperationsCheckTask', id: ID['output'] }
        | { __typename: 'ProposalsCheckTask', id: ID['output'] }
      >, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null } | null } | null };

export type EditorViolationLinterRuleLevelConfigurationFragment = { __typename: 'LinterRuleLevelConfiguration', rule: LintRule, goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null };

export type LintCheckListCheckWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], isSandboxCheck: Boolean['output'], proposedSchemaHash: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'] } | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null };

export type LintCheckListLinterRuleLevelConfigurationFragment = { __typename: 'LinterRuleLevelConfiguration', rule: LintRule, description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, level: LintDiagnosticLevel, category: LinterRuleCategory };

export type CustomCheckViolationListFragment = { __typename: 'CheckViolation', rule: String['output'], level: ViolationLevel, coordinate: String['output'] | null, message: String['output'], sourceLocations: Array<{ __typename: 'FileLocation', subgraphName: String['output'] | null, end: { __typename: 'FileCoordinate', byteOffset: Int['output'], column: Int['output'], line: Int['output'] }, start: { __typename: 'FileCoordinate', byteOffset: Int['output'], column: Int['output'], line: Int['output'] } }> | null };

export type RuleViolationListLintDiagnosticFragment = { __typename: 'LintDiagnostic', rule: LintRule, level: LintDiagnosticLevel, coordinate: String['output'], message: String['output'], sourceLocations: Array<{ __typename: 'Location', subgraphName: String['output'] | null, end: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null, start: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null }> };

export type RuleViolationListLinterRuleLevelConfigurationFragment = { __typename: 'LinterRuleLevelConfiguration', description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, level: LintDiagnosticLevel, category: LinterRuleCategory };

export type OverrideViolationButtonIgnoredRuleFragment = { __typename: 'IgnoredRule', ignoredRule: LintRule, schemaCoordinate: String['output'] };

export type OverrideViolationButtonLintDiagnosticFragment = { __typename: 'LintDiagnostic', rule: LintRule, coordinate: String['output'], level: LintDiagnosticLevel };

export type UpdateIgnoredRuleViolationsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  changes: LinterIgnoredRuleChangesInput;
}>;


export type UpdateIgnoredRuleViolationsMutation = { service: { __typename: 'ServiceMutation', id: ID['output'], updateIgnoredRuleViolations: Array<{ __typename: 'IgnoredRule', ignoredRule: LintRule, schemaCoordinate: String['output'], subgraphName: String['output'] | null }> } | null };

export type AffectedQueryDetailsFragment = { __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, alreadyApproved: Boolean['output'] | null, alreadyIgnored: Boolean['output'] | null };

export type OperationCheckDetailsAffectedQueryFragment = { __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, alreadyApproved: Boolean['output'] | null, alreadyIgnored: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', shortDescription: String['output'] | null, definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null };

export type OperationCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  isProposalRoute: Scalars['Boolean']['input'];
}>;


export type OperationCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], createdAt: Timestamp['output'], operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null, checkSeverity: ChangeSeverity, numberOfCheckedOperations: Int['output'], numberOfAffectedOperations: Int['output'], totalNumberOfAffectedOperations: Int['output'], changes: Array<{ __typename: 'Change', category: ChangeCategory, code: String['output'] }>, checkedVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null, proposal?: { __typename: 'Proposal', id: ID['output'], hasUpstreamChanges: Boolean['output'] } | null }, affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, alreadyApproved: Boolean['output'] | null, alreadyIgnored: Boolean['output'] | null }> | null, unaffectedOperations: Array<{ __typename: 'OperationDetails', id: String['output'], name: String['output'] | null }> | null } | null } | null, validationConfig: { __typename: 'SchemaDiffValidationConfig', from: Timestamp['output'] | null, to: Timestamp['output'] | null } | null, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null } | null } | null };

export type AffectedQueryDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  workflowId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type AffectedQueryDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], result: { __typename: 'OperationsCheckResult', id: ID['output'], affectedQuery: { __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, alreadyApproved: Boolean['output'] | null, alreadyIgnored: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', shortDescription: String['output'] | null, definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null } | null } | null } | null } | null } | null };

export type ChangeListChangeOnOperationFragment = { __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', shortDescription: String['output'] | null, definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } };

export type TimeRangeSentenceSchemaDiffValidationConfigFragment = { __typename: 'SchemaDiffValidationConfig', from: Timestamp['output'] | null, to: Timestamp['output'] | null, queryCountThreshold: Int['output'] | null, includedVariants: Array<String['output']> | null };

export type UI__OperationBodyModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type UI__OperationBodyModalQuery = { service: { __typename: 'Service', id: ID['output'], operation: { __typename: 'Operation', id: ID['output'], signature: String['output'] | null, truncated: Boolean['output'] } | null } | null };

export type CheckOperationsDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  resolution: Resolution;
  filter: ServiceQueryStatsFilter;
}>;


export type CheckOperationsDetailsQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], usageStats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null, perClientStats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', groupBy: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null }, metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null, perVariantStats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', groupBy: { __typename: 'ServiceQueryStatsDimensions', schemaTag: String['output'] | null }, metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null } | null };

export type UnmarkAsSafeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type UnmarkAsSafeMutation = { service: { __typename: 'ServiceMutation', unmarkChangesForOperationAsSafe: { __typename: 'MarkChangesForOperationAsSafeResult' } } | null };

export type UnignoreOperationsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnignoreOperationsMutation = { service: { __typename: 'ServiceMutation', unignoreOperationsInChecks: { __typename: 'UnignoreOperationsInChecksResult' } | null } | null };

export type MarkAsSafeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type MarkAsSafeMutation = { service: { __typename: 'ServiceMutation', markChangesForOperationAsSafe: { __typename: 'MarkChangesForOperationAsSafeResult' } } | null };

export type CheckOperationsListAffectedQueryFragment = { __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null };

export type IgnoreOperationsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type IgnoreOperationsMutation = { service: { __typename: 'ServiceMutation', ignoreOperationsInChecks: { __typename: 'IgnoreOperationsInChecksResult' } | null } | null };

export type MarkOperationsAsSafeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
  operationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkOperationsAsSafeMutation = { service: { __typename: 'ServiceMutation', markChangesForMultipleOperationsAsSafe: { __typename: 'MarkChangesForOperationAsSafeResult' } } | null };

export type markAllOperationsAsSafeVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationsCheckId: Scalars['ID']['input'];
}>;


export type markAllOperationsAsSafe = { service: { __typename: 'ServiceMutation', markChangesForAllOperationsAsSafe: { __typename: 'MarkChangesForOperationAsSafeResult', success: Boolean['output'] } } | null };

export type ignoreAllOperationsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationsCheckId: Scalars['ID']['input'];
}>;


export type ignoreAllOperations = { service: { __typename: 'ServiceMutation', ignoreAllOperationsInChecks: { __typename: 'IgnoreOperationsInChecksResult' } | null } | null };

export type MatchingProposalsDrawerFragment = { __typename: 'ProposalsCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null }, diffs: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], subgraph: String['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirective', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirectiveUsage', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnum', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnumValue', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddField', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddImplementation', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInput', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInterface', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddObject', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddScalar', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddSchemaDefinition', type: FlatDiffType }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage', type: FlatDiffType }
      | { __typename: 'FlatDiffAddSchemaRootOperation', type: FlatDiffType, rootType: String['output'] }
      | { __typename: 'FlatDiffAddUnion', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddUnionMember', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffAddValidLocation', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeArgumentDefault', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDescription', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeInputFieldDefault', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeSchemaDescription', type: FlatDiffType }
      | { __typename: 'FlatDiffRemoveArgument', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirective', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirectiveUsage', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnum', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnumValue', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveField', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveImplementation', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInput', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInterface', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveObject', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveScalar', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveSchemaDefinition', type: FlatDiffType }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage', type: FlatDiffType }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation', type: FlatDiffType, rootType: String['output'] }
      | { __typename: 'FlatDiffRemoveUnion', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveUnionMember', type: FlatDiffType, coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveValidLocation', type: FlatDiffType, coordinate: String['output'] }
    , relatedProposalResults: Array<{ __typename: 'RelatedProposalResult', proposal: { __typename: 'Proposal', id: ID['output'] } }> }>, relatedProposalResults: Array<{ __typename: 'RelatedProposalResult', statusAtCheck: ProposalStatus, proposal: { __typename: 'Proposal', id: ID['output'], displayName: String['output'], description: String['output'], backingVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } } }> };

export type ProposalCheckDetailsWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null };

type ProposalCheckDetailsTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'] };

type ProposalCheckDetailsTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', didOverrideProposalsCheckTask: Boolean['output'], hasExceededMaxDiffs: Boolean['output'] | null, severityLevel: ProposalChangeMismatchSeverity, id: ID['output'], diffs: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], subgraph: String['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
      | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
      | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
     }> };

export type ProposalCheckDetailsTaskFragment =
  | ProposalCheckDetailsTaskFragment_CompositionCheckTask
  | ProposalCheckDetailsTaskFragment_CustomCheckTask
  | ProposalCheckDetailsTaskFragment_DownstreamCheckTask
  | ProposalCheckDetailsTaskFragment_FilterCheckTask
  | ProposalCheckDetailsTaskFragment_LintCheckTask
  | ProposalCheckDetailsTaskFragment_OperationsCheckTask
  | ProposalCheckDetailsTaskFragment_ProposalsCheckTask
;

export type ProposalCheckDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type ProposalCheckDetailsQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'] }
        | { __typename: 'CustomCheckTask', id: ID['output'] }
        | { __typename: 'DownstreamCheckTask', id: ID['output'] }
        | { __typename: 'FilterCheckTask', id: ID['output'] }
        | { __typename: 'LintCheckTask', id: ID['output'] }
        | { __typename: 'OperationsCheckTask', id: ID['output'] }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], didOverrideProposalsCheckTask: Boolean['output'], hasExceededMaxDiffs: Boolean['output'] | null, severityLevel: ProposalChangeMismatchSeverity, diffs: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], subgraph: String['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
              | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
              | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
              | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
              | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
             }> }
      >, baseSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null, proposedSubgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> | null } | null } | null };

export type OverrideProposalsCheckTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  graphId: Scalars['ID']['input'];
  shouldOverride: Scalars['Boolean']['input'];
}>;


export type OverrideProposalsCheckTaskMutation = { graph: { __typename: 'ServiceMutation', overrideProposalsCheckTask: Boolean['output'] | null } | null };

export type ProposalCheckDetailsDiffDisplayFlatDiffItemFragment = { __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], subgraph: String['output'], diffItem:
    | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddSchemaDefinition' }
    | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
    | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
    | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
    | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
    | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
    | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
    | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
    | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
    | { __typename: 'FlatDiffChangeSchemaDescription' }
    | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveSchemaDefinition' }
    | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
    | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
    | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
    | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
   };

export type UseBaseAndProposedSchemaDocumentsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  baseSchemaHash?: InputMaybe<Scalars['SHA256']['input']>;
  proposedSchemaHash?: InputMaybe<Scalars['SHA256']['input']>;
  schemaHashesMatch: Scalars['Boolean']['input'];
}>;


export type UseBaseAndProposedSchemaDocumentsQuery = { service: { __typename: 'Service', id: ID['output'], baseSchema: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null, proposedSchema?: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null } | null };

export type CheckWorkflowsListPageWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, status: CheckWorkflowStatus, createdAt: Timestamp['output'], startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
        | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
        | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
       | null, buildResult:
        | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
        | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
        | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
        | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  >, gitContext: { __typename: 'GitContext', branch: String['output'] | null, commit: ID['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, triggeredBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null } | null };

export type CheckWorkflowsListPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  checkWorkflowsFilter: CheckFilterInput;
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckWorkflowsListPageQuery = { service: { __typename: 'Service', id: ID['output'], roles: { __typename: 'ServiceRoles', canQueryCheckConfiguration: Boolean['output'] } | null, checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, status: CheckWorkflowStatus, createdAt: Timestamp['output'], startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
            | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, gitContext: { __typename: 'GitContext', branch: String['output'] | null, commit: ID['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, triggeredBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null } | null }>, singleUnfilteredCheckWorkflow: Array<{ __typename: 'CheckWorkflow', id: ID['output'] }>, checkConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], enableLintChecks: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasManagedSubgraphs: Boolean['output'] | null, checkConfiguration: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'] } } | null } | null };

export type CheckWorkflowsListPagePollingQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowsFilter: CheckFilterInput;
  pendingFilters: CheckFilterInput;
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckWorkflowsListPagePollingQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'] }>, pendingCheckWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, status: CheckWorkflowStatus, createdAt: Timestamp['output'], startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
            | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, gitContext: { __typename: 'GitContext', branch: String['output'] | null, commit: ID['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, triggeredBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null } | null }>, singleUnfilteredCheckWorkflow: Array<{ __typename: 'CheckWorkflow', id: ID['output'] }> } | null };

export type CheckWorkflowItemFragment = { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, status: CheckWorkflowStatus, createdAt: Timestamp['output'], startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, gitContext: { __typename: 'GitContext', branch: String['output'] | null, commit: ID['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, triggeredBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null } | null, tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  > };

export type CheckWorkflowStatusBadgeCheckWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  > };

export type ChecksTableWorkflowCellWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'] }
    | { __typename: 'CustomCheckTask', id: ID['output'] }
    | { __typename: 'DownstreamCheckTask', id: ID['output'] }
    | { __typename: 'FilterCheckTask', id: ID['output'] }
    | { __typename: 'LintCheckTask', id: ID['output'] }
    | { __typename: 'OperationsCheckTask', id: ID['output'] }
    | { __typename: 'ProposalsCheckTask', id: ID['output'] }
  > };

export type DownstreamCheckWorkflowListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  workflowId: Scalars['ID']['input'];
}>;


export type DownstreamCheckWorkflowListQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, tasks: Array<
              | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, buildResult:
                  | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'] }> }
                  | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
                 | null }
              | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
              | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'] } | null }
              | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
            > } | null }> | null } | null } | null } | null };

export type DownstreamTaskCardFragment = { __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, tasks: Array<
      | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
      | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
      | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
      | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, buildResult:
          | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'] }> }
          | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
         | null }
      | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
      | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'] } | null }
      | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    > } | null };

export type DownstreamWorkflowStatusCountsFragment = { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null };

export type SuccessfulCheckWorkflowItemFragment = { __typename: 'CheckWorkflow', id: ID['output'], tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  >, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

type CheckWorkflowTaskItemFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
    | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
    | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
   | null, buildResult:
    | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
    | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
   | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
    | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
    | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
   | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } };

type CheckWorkflowTaskItemFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument' }
      | { __typename: 'FlatDiffAddDirective' }
      | { __typename: 'FlatDiffAddDirectiveUsage' }
      | { __typename: 'FlatDiffAddEnum' }
      | { __typename: 'FlatDiffAddEnumValue' }
      | { __typename: 'FlatDiffAddField' }
      | { __typename: 'FlatDiffAddImplementation' }
      | { __typename: 'FlatDiffAddInput' }
      | { __typename: 'FlatDiffAddInterface' }
      | { __typename: 'FlatDiffAddObject' }
      | { __typename: 'FlatDiffAddScalar' }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation' }
      | { __typename: 'FlatDiffAddUnion' }
      | { __typename: 'FlatDiffAddUnionMember' }
      | { __typename: 'FlatDiffAddValidLocation' }
      | { __typename: 'FlatDiffChangeArgumentDefault' }
      | { __typename: 'FlatDiffChangeDescription' }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
      | { __typename: 'FlatDiffChangeInputFieldDefault' }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument' }
      | { __typename: 'FlatDiffRemoveDirective' }
      | { __typename: 'FlatDiffRemoveDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveEnum' }
      | { __typename: 'FlatDiffRemoveEnumValue' }
      | { __typename: 'FlatDiffRemoveField' }
      | { __typename: 'FlatDiffRemoveImplementation' }
      | { __typename: 'FlatDiffRemoveInput' }
      | { __typename: 'FlatDiffRemoveInterface' }
      | { __typename: 'FlatDiffRemoveObject' }
      | { __typename: 'FlatDiffRemoveScalar' }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
      | { __typename: 'FlatDiffRemoveUnion' }
      | { __typename: 'FlatDiffRemoveUnionMember' }
      | { __typename: 'FlatDiffRemoveValidLocation' }
     }> };

export type CheckWorkflowTaskItemFragment =
  | CheckWorkflowTaskItemFragment_CompositionCheckTask
  | CheckWorkflowTaskItemFragment_CustomCheckTask
  | CheckWorkflowTaskItemFragment_DownstreamCheckTask
  | CheckWorkflowTaskItemFragment_FilterCheckTask
  | CheckWorkflowTaskItemFragment_LintCheckTask
  | CheckWorkflowTaskItemFragment_OperationsCheckTask
  | CheckWorkflowTaskItemFragment_ProposalsCheckTask
;

type GetTaskDisplayStatusTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type GetTaskDisplayStatusTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null };

type GetTaskDisplayStatusTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null };

type GetTaskDisplayStatusTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type GetTaskDisplayStatusTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null };

type GetTaskDisplayStatusTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null };

type GetTaskDisplayStatusTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument' }
      | { __typename: 'FlatDiffAddDirective' }
      | { __typename: 'FlatDiffAddDirectiveUsage' }
      | { __typename: 'FlatDiffAddEnum' }
      | { __typename: 'FlatDiffAddEnumValue' }
      | { __typename: 'FlatDiffAddField' }
      | { __typename: 'FlatDiffAddImplementation' }
      | { __typename: 'FlatDiffAddInput' }
      | { __typename: 'FlatDiffAddInterface' }
      | { __typename: 'FlatDiffAddObject' }
      | { __typename: 'FlatDiffAddScalar' }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation' }
      | { __typename: 'FlatDiffAddUnion' }
      | { __typename: 'FlatDiffAddUnionMember' }
      | { __typename: 'FlatDiffAddValidLocation' }
      | { __typename: 'FlatDiffChangeArgumentDefault' }
      | { __typename: 'FlatDiffChangeDescription' }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
      | { __typename: 'FlatDiffChangeInputFieldDefault' }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument' }
      | { __typename: 'FlatDiffRemoveDirective' }
      | { __typename: 'FlatDiffRemoveDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveEnum' }
      | { __typename: 'FlatDiffRemoveEnumValue' }
      | { __typename: 'FlatDiffRemoveField' }
      | { __typename: 'FlatDiffRemoveImplementation' }
      | { __typename: 'FlatDiffRemoveInput' }
      | { __typename: 'FlatDiffRemoveInterface' }
      | { __typename: 'FlatDiffRemoveObject' }
      | { __typename: 'FlatDiffRemoveScalar' }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
      | { __typename: 'FlatDiffRemoveUnion' }
      | { __typename: 'FlatDiffRemoveUnionMember' }
      | { __typename: 'FlatDiffRemoveValidLocation' }
     }> };

export type GetTaskDisplayStatusTaskFragment =
  | GetTaskDisplayStatusTaskFragment_CompositionCheckTask
  | GetTaskDisplayStatusTaskFragment_CustomCheckTask
  | GetTaskDisplayStatusTaskFragment_DownstreamCheckTask
  | GetTaskDisplayStatusTaskFragment_FilterCheckTask
  | GetTaskDisplayStatusTaskFragment_LintCheckTask
  | GetTaskDisplayStatusTaskFragment_OperationsCheckTask
  | GetTaskDisplayStatusTaskFragment_ProposalsCheckTask
;

export type CheckConfigFragment = { __typename: 'CheckConfiguration', id: ID['output'], includeBaseVariant: Boolean['output'], includedVariants: Array<String['output']>, operationCountThreshold: Int['output'], timeRangeSeconds: Long['output'], downgradeStaticChecks: Boolean['output'], downgradeDefaultValueChange: Boolean['output'], updatedAt: Timestamp['output'], updatedBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'] }
   | null, excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null };

export type ChecksConfigPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ChecksConfigPageQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], account: { __typename: 'Account', id: ID['output'], limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxRangeInDaysForChecks: Int['output'] } | null } | null, roles: { __typename: 'ServiceRoles', canQueryCheckConfiguration: Boolean['output'], canWriteCheckConfiguration: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, checkConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], includeBaseVariant: Boolean['output'], includedVariants: Array<String['output']>, operationCountThreshold: Int['output'], timeRangeSeconds: Long['output'], downgradeStaticChecks: Boolean['output'], downgradeDefaultValueChange: Boolean['output'], updatedAt: Timestamp['output'], updatedBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], id: ID['output'] }
       | null, excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null } | null } | null };

export type UpdateCheckConfigMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  includeBaseVariant: Scalars['Boolean']['input'];
  includedVariants?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operationCountThreshold: Scalars['Int']['input'];
  timeRangeSeconds: Scalars['Long']['input'];
  excludedClients?: InputMaybe<Array<ClientFilterInput> | ClientFilterInput>;
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput> | OperationNameFilterInput>;
  downgradeStaticChecks?: InputMaybe<Scalars['Boolean']['input']>;
  downgradeDefaultValueChange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCheckConfigMutation = { service: { __typename: 'ServiceMutation', updateCheckConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], includeBaseVariant: Boolean['output'], includedVariants: Array<String['output']>, operationCountThreshold: Int['output'], timeRangeSeconds: Long['output'], downgradeStaticChecks: Boolean['output'], downgradeDefaultValueChange: Boolean['output'], updatedAt: Timestamp['output'], updatedBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], id: ID['output'] }
       | null, excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null } } | null };

export type ListAllClientsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
}>;


export type ListAllClientsQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', operationCheckStats: Array<{ __typename: 'ServiceOperationCheckStatsRecord', group: { __typename: 'ServiceOperationCheckStatsDimensions', clientName: String['output'] | null } }> } | null } | null };

export type ListClientVersionsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  clientNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ListClientVersionsQuery = { service: { __typename: 'Service', id: ID['output'], versionStats: { __typename: 'ServiceStatsWindow', operationCheckStats: Array<{ __typename: 'ServiceOperationCheckStatsRecord', group: { __typename: 'ServiceOperationCheckStatsDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null } }> } | null } | null };

export type ExcludedClientsClientFilterFragment = { __typename: 'ClientFilter', name: String['output'], version: String['output'] | null };

export type ExcludedOperationNameFilterFragment = { __typename: 'OperationNameFilter', name: String['output'] };

export type ChecksFiltersQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  authorsFilter?: InputMaybe<CheckFilterInput>;
  subgraphsFilter?: InputMaybe<CheckFilterInput>;
  branchesFilter: CheckFilterInput;
  includeVariants: Scalars['Boolean']['input'];
}>;


export type ChecksFiltersQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, service: { __typename: 'Service', id: ID['output'], checksAuthorOptions: Array<String['output']>, checksSubgraphOptions: Array<String['output']>, checksBranchOptions: Array<String['output']>, checksCreatedByOptions: Array<
      | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'] }
      | { __typename: 'Service', id: ID['output'], name: String['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
      | { __typename: 'User', fullName: String['output'], id: ID['output'], name: String['output'] }
    >, variants?: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> } | null };

export type VariantCustomCheckConfigChangeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  useGraphSettings: Scalars['Boolean']['input'];
  enableCustomChecks: Scalars['Boolean']['input'];
}>;


export type VariantCustomCheckConfigChangeMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationCustomChecks: { __typename: 'VariantCheckConfiguration', id: ID['output'], updatedAt: Timestamp['output'], updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'Service', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
          | { __typename: 'User', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
         | null, customChecksConfig: { __typename: 'VariantCheckConfigurationCustomChecks', enableCustomChecks: Boolean['output'] | null, useGraphSettings: Boolean['output'] } } } | null } | null };

export type GraphCustomCheckConfigChangeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  enableCustomChecks: Scalars['Boolean']['input'];
}>;


export type GraphCustomCheckConfigChangeMutation = { service: { __typename: 'ServiceMutation', updateCheckConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], enableCustomChecks: Boolean['output'], updatedAt: Timestamp['output'], updatedBy:
        | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'Service', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
        | { __typename: 'User', id: ID['output'], name: String['output'], asActor: { __typename: 'Actor', actorId: ID['output'], type: ActorType } }
       | null } } | null };

export type CustomChecksConfigPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type CustomChecksConfigPageQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], name: String['output'] } | null, checkConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], enableCustomChecks: Boolean['output'] } | null, customCheckConfiguration: { __typename: 'CustomCheckConfiguration', id: ID['output'], channel: { __typename: 'CustomCheckWebhookChannel', id: ID['output'], url: String['output'], secretTokenIsSet: Boolean['output'] } } | null, variant: { __typename: 'GraphVariant', id: ID['output'], customCheckConfiguration: { __typename: 'CustomCheckConfiguration', id: ID['output'], channel: { __typename: 'CustomCheckWebhookChannel', id: ID['output'], url: String['output'], secretTokenIsSet: Boolean['output'] } } | null, checkConfiguration: { __typename: 'VariantCheckConfiguration', id: ID['output'], customChecksConfig: { __typename: 'VariantCheckConfigurationCustomChecks', useGraphSettings: Boolean['output'], enableCustomChecks: Boolean['output'] | null } } } | null } | null };

type CustomCheckConfigurationResultFragment_CustomCheckConfiguration = { __typename: 'CustomCheckConfiguration', id: ID['output'], channel: { __typename: 'CustomCheckWebhookChannel', id: ID['output'], url: String['output'], secretTokenIsSet: Boolean['output'], lastUpdatedAt: Timestamp['output'], lastUpdatedBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', id: ID['output'] }
     | null } };

type CustomCheckConfigurationResultFragment_PermissionError = { __typename: 'PermissionError', message: String['output'] };

type CustomCheckConfigurationResultFragment_ValidationError = { __typename: 'ValidationError', message: String['output'] };

export type CustomCheckConfigurationResultFragment =
  | CustomCheckConfigurationResultFragment_CustomCheckConfiguration
  | CustomCheckConfigurationResultFragment_PermissionError
  | CustomCheckConfigurationResultFragment_ValidationError
;

export type VariantSetCustomCheckConfigurationVariables = Exact<{
  input: SetCustomCheckConfigurationInput;
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type VariantSetCustomCheckConfiguration = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', setCustomCheckConfiguration:
        | { __typename: 'CustomCheckConfiguration', id: ID['output'], channel: { __typename: 'CustomCheckWebhookChannel', id: ID['output'], url: String['output'], secretTokenIsSet: Boolean['output'], lastUpdatedAt: Timestamp['output'], lastUpdatedBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', id: ID['output'] }
             | null } }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

export type GraphSetCustomCheckConfigurationVariables = Exact<{
  input: SetCustomCheckConfigurationInput;
  graphId: Scalars['ID']['input'];
}>;


export type GraphSetCustomCheckConfiguration = { graph: { __typename: 'ServiceMutation', setCustomCheckConfiguration:
      | { __typename: 'CustomCheckConfiguration', id: ID['output'], channel: { __typename: 'CustomCheckWebhookChannel', id: ID['output'], url: String['output'], secretTokenIsSet: Boolean['output'], lastUpdatedAt: Timestamp['output'], lastUpdatedBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', id: ID['output'] }
           | null } }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type SendTestNotificationMutationVariables = Exact<{
  variant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type SendTestNotificationMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', queueTestCustomChecksRequest:
        | { __typename: 'GraphVariant', id: ID['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

type getLinkToTaskWorkflowTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type getLinkToTaskWorkflowTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

export type getLinkToTaskWorkflowTaskFragment =
  | getLinkToTaskWorkflowTaskFragment_CompositionCheckTask
  | getLinkToTaskWorkflowTaskFragment_CustomCheckTask
  | getLinkToTaskWorkflowTaskFragment_DownstreamCheckTask
  | getLinkToTaskWorkflowTaskFragment_FilterCheckTask
  | getLinkToTaskWorkflowTaskFragment_LintCheckTask
  | getLinkToTaskWorkflowTaskFragment_OperationsCheckTask
  | getLinkToTaskWorkflowTaskFragment_ProposalsCheckTask
;

export type getLinkToTaskWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

export type getLinkToWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

export type LinterConfigPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
}>;


export type LinterConfigPageQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], account: { __typename: 'Account', id: ID['output'], name: String['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], hasManagedSubgraphs: Boolean['output'] | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'] } | null }>, checkConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], enableLintChecks: Boolean['output'] } | null, linterConfiguration: { __typename: 'GraphLinterConfiguration', ignoreDeprecated: Boolean['output'], ignoreInaccessible: Boolean['output'], allowedTagNames: Array<String['output']>, rules: Array<{ __typename: 'LinterRuleLevelConfiguration', rule: LintRule, level: LintDiagnosticLevel, description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, category: LinterRuleCategory }> } } | null };

export type AllowedTagNamesFragment = { __typename: 'GraphLinterConfiguration', allowedTagNames: Array<String['output']> };

export type LinterConfigAllowedTagsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  changes: GraphLinterConfigurationChangesInput;
}>;


export type LinterConfigAllowedTagsMutation = { service: { __typename: 'ServiceMutation', id: ID['output'], updateLinterConfiguration: { __typename: 'GraphLinterConfiguration', allowedTagNames: Array<String['output']> } } | null };

export type DefaultIgnoreLinterSettingsFragment = { __typename: 'GraphLinterConfiguration', ignoreDeprecated: Boolean['output'], ignoreInaccessible: Boolean['output'] };

export type LinterCheckConfigDefaultSettingsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  enableLintChecks?: InputMaybe<Scalars['Boolean']['input']>;
  changes: GraphLinterConfigurationChangesInput;
}>;


export type LinterCheckConfigDefaultSettingsMutation = { service: { __typename: 'ServiceMutation', id: ID['output'], updateCheckConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], enableLintChecks: Boolean['output'] }, updateLinterConfiguration: { __typename: 'GraphLinterConfiguration', ignoreDeprecated: Boolean['output'], ignoreInaccessible: Boolean['output'] } } | null };

export type LinterRulesCardFragment = { __typename: 'GraphLinterConfiguration', rules: Array<{ __typename: 'LinterRuleLevelConfiguration', rule: LintRule, level: LintDiagnosticLevel, description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, category: LinterRuleCategory }> };

export type LinterConfigRuleSeverityMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  changes: GraphLinterConfigurationChangesInput;
}>;


export type LinterConfigRuleSeverityMutation = { service: { __typename: 'ServiceMutation', id: ID['output'], updateLinterConfiguration: { __typename: 'GraphLinterConfiguration', rules: Array<{ __typename: 'LinterRuleLevelConfiguration', rule: LintRule, level: LintDiagnosticLevel }> } } | null };

export type ProposalChecksConfigVariantPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ProposalChecksConfigVariantPageQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], checkConfiguration: { __typename: 'VariantCheckConfiguration', id: ID['output'], proposalChangeMismatchSeverityConfig: { __typename: 'VariantCheckConfigurationProposalChangeMismatchSeverity', proposalChangeMismatchSeverity: ProposalChangeMismatchSeverity | null } } } | null } | null };

export type ProposalCheckRerunButtonWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null };

export type ReRunCheckForProposalRevisionMutationVariables = Exact<{
  input: ReRunCheckForRevisionInput;
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  filter?: InputMaybe<CheckFilterInput>;
}>;


export type ReRunCheckForProposalRevisionMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'ProposalMutation', reRunCheckForRevision:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], backingVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'], checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'] }> } } }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

export type ProposalCheckRerunBannerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkId: Scalars['ID']['input'];
}>;


export type ProposalCheckRerunBannerQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], reruns: Array<{ __typename: 'CheckWorkflow', id: ID['output'] }> | null } | null } | null };

export type RerunCheckWorkflowAsyncMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowId: Scalars['ID']['input'];
}>;


export type RerunCheckWorkflowAsyncMutation = { service: { __typename: 'ServiceMutation', checkWorkflow: { __typename: 'CheckWorkflowMutation', id: ID['output'], rerunAsync:
        | { __typename: 'CheckRequestSuccess', targetURL: String['output'], workflowID: ID['output'] }
        | { __typename: 'InvalidInputError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'PlanError', message: String['output'] }
        | { __typename: 'RateLimitExceededError' }
       } | null } | null };

export type SummaryRerunButtonWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], upstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'] } | null };

type TaskStatusIconTaskFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type TaskStatusIconTaskFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null };

type TaskStatusIconTaskFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null };

type TaskStatusIconTaskFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus };

type TaskStatusIconTaskFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null };

type TaskStatusIconTaskFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, result: { __typename: 'OperationsCheckResult', id: ID['output'], crossedOperationThreshold: Int['output'] | null } | null };

type TaskStatusIconTaskFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], severityLevel: ProposalChangeMismatchSeverity, hasWarnings?: Boolean['output'], status: CheckWorkflowTaskStatus, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument' }
      | { __typename: 'FlatDiffAddDirective' }
      | { __typename: 'FlatDiffAddDirectiveUsage' }
      | { __typename: 'FlatDiffAddEnum' }
      | { __typename: 'FlatDiffAddEnumValue' }
      | { __typename: 'FlatDiffAddField' }
      | { __typename: 'FlatDiffAddImplementation' }
      | { __typename: 'FlatDiffAddInput' }
      | { __typename: 'FlatDiffAddInterface' }
      | { __typename: 'FlatDiffAddObject' }
      | { __typename: 'FlatDiffAddScalar' }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation' }
      | { __typename: 'FlatDiffAddUnion' }
      | { __typename: 'FlatDiffAddUnionMember' }
      | { __typename: 'FlatDiffAddValidLocation' }
      | { __typename: 'FlatDiffChangeArgumentDefault' }
      | { __typename: 'FlatDiffChangeDescription' }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
      | { __typename: 'FlatDiffChangeInputFieldDefault' }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument' }
      | { __typename: 'FlatDiffRemoveDirective' }
      | { __typename: 'FlatDiffRemoveDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveEnum' }
      | { __typename: 'FlatDiffRemoveEnumValue' }
      | { __typename: 'FlatDiffRemoveField' }
      | { __typename: 'FlatDiffRemoveImplementation' }
      | { __typename: 'FlatDiffRemoveInput' }
      | { __typename: 'FlatDiffRemoveInterface' }
      | { __typename: 'FlatDiffRemoveObject' }
      | { __typename: 'FlatDiffRemoveScalar' }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
      | { __typename: 'FlatDiffRemoveUnion' }
      | { __typename: 'FlatDiffRemoveUnionMember' }
      | { __typename: 'FlatDiffRemoveValidLocation' }
     }> };

export type TaskStatusIconTaskFragment =
  | TaskStatusIconTaskFragment_CompositionCheckTask
  | TaskStatusIconTaskFragment_CustomCheckTask
  | TaskStatusIconTaskFragment_DownstreamCheckTask
  | TaskStatusIconTaskFragment_FilterCheckTask
  | TaskStatusIconTaskFragment_LintCheckTask
  | TaskStatusIconTaskFragment_OperationsCheckTask
  | TaskStatusIconTaskFragment_ProposalsCheckTask
;

export type OperationCheckRequestsForVariant = { __typename: 'RequestCountsPerGraphVariant', cachedRequestsCount: Long['output'], uncachedRequestsCount: Long['output'], variant: String['output'] | null };

export type UseVariantListStatsQueryQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
}>;


export type UseVariantListStatsQueryQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, operationCheckRequestsByVariant: Array<{ __typename: 'RequestCountsPerGraphVariant', cachedRequestsCount: Long['output'], uncachedRequestsCount: Long['output'], variant: String['output'] | null }> } | null };

export type VariantCheckConfigTimeRangeFragment = { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null };

export type VariantCheckConfigIncludedVariantsFragment = { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null };

export type VariantCheckConfigExcludedClientsFragment = { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> };

export type VariantCheckConfigExcludedOperationsFragment = { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> };

export type VariantCheckConfigurationDownstreamVariantsFragment = { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> };

export type VariantCheckConfigurationDowngradeChecksFragment = { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null };

export type VariantCheckConfigFragment = { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'] }
   | null };

export type VariantChecksConfigPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantChecksConfigPageQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxRangeInDaysForChecks: Int['output'] } | null } | null, roles: { __typename: 'ServiceRoles', canWriteCheckConfiguration: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, checkConfiguration: { __typename: 'CheckConfiguration', id: ID['output'], includeBaseVariant: Boolean['output'], includedVariants: Array<String['output']>, operationCountThreshold: Int['output'], timeRangeSeconds: Long['output'], downgradeStaticChecks: Boolean['output'], downgradeDefaultValueChange: Boolean['output'], updatedAt: Timestamp['output'], updatedBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], id: ID['output'] }
       | null, excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'] } | null> | null } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, checkConfiguration: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null }, downstreamVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> | null } | null } | null };

export type VariantCheckConfigDowngradeChecksMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  useGraphSettings: Scalars['Boolean']['input'];
  downgradeStaticChecks?: InputMaybe<Scalars['Boolean']['input']>;
  downgradeDefaultValueChange?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VariantCheckConfigDowngradeChecksMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationDowngradeChecks: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type VariantCheckConfigDownstreamVariantsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  blockingDownstreamVariants?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type VariantCheckConfigDownstreamVariantsMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationDownstreamVariants: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type VariantCheckConfigExcludedClientsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  appendGraphSettings: Scalars['Boolean']['input'];
  excludedClients?: InputMaybe<Array<ClientFilterInput> | ClientFilterInput>;
}>;


export type VariantCheckConfigExcludedClientsMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationExcludedClients: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type VariantCheckConfigExcludedOperationsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  appendGraphSettings: Scalars['Boolean']['input'];
  excludedOperationNames?: InputMaybe<Array<OperationNameFilterInput> | OperationNameFilterInput>;
}>;


export type VariantCheckConfigExcludedOperationsMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationExcludedOperations: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type VariantCheckConfigIncludedVariantsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  useGraphSettings: Scalars['Boolean']['input'];
  includedVariants?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type VariantCheckConfigIncludedVariantsMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationIncludedVariants: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type VariantCheckConfigEnableOperationsCheckMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type VariantCheckConfigEnableOperationsCheckMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationEnableOperationsCheck: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } | null } | null } | null };

export type VariantCheckConfigTimeRangeMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  useGraphSettings: Scalars['Boolean']['input'];
  timeRangeSeconds?: InputMaybe<Scalars['Long']['input']>;
  operationCountThreshold?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VariantCheckConfigTimeRangeMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationTimeRange: { __typename: 'VariantCheckConfiguration', id: ID['output'], operationsChecksEnabled: Boolean['output'], updatedAt: Timestamp['output'], createdAt: Timestamp['output'], timeRangeConfig: { __typename: 'VariantCheckConfigurationTimeRange', useGraphSettings: Boolean['output'], timeRangeSeconds: Long['output'] | null, operationCountThreshold: Int['output'] | null }, includedVariantsConfig: { __typename: 'VariantCheckConfigurationIncludedVariants', useGraphSettings: Boolean['output'], includedVariants: Array<String['output']> | null }, excludedClientsConfig: { __typename: 'VariantCheckConfigurationExcludedClients', appendGraphSettings: Boolean['output'], excludedClients: Array<{ __typename: 'ClientFilter', name: String['output'], version: String['output'] | null }> }, excludedOperationsConfig: { __typename: 'VariantCheckConfigurationExcludedOperations', appendGraphSettings: Boolean['output'], excludedOperations: Array<{ __typename: 'OperationInfoFilter', id: String['output'] }>, excludedOperationNames: Array<{ __typename: 'OperationNameFilter', name: String['output'], version: String['output'] | null }> }, downstreamVariantsConfig: { __typename: 'VariantCheckConfigurationDownstreamVariants', blockingDownstreamVariants: Array<String['output']> }, downgradeChecksConfig: { __typename: 'VariantCheckConfigurationDowngradeChecks', useGraphSettings: Boolean['output'], downgradeStaticChecks: Boolean['output'] | null, downgradeDefaultValueChange: Boolean['output'] | null }, updatedBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null } } | null } | null };

export type UI__ClientsDetailsQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<ServiceQueryStatsFilter>;
}>;


export type UI__ClientsDetailsQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], totalRequestCount: Long['output'] }, groupBy: { __typename: 'ServiceQueryStatsDimensions', querySignature: String['output'] | null, queryName: String['output'] | null, queryId: ID['output'] | null } }> } | null } | null };

export type UI__ClientsPageQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<ServiceQueryStatsFilter>;
}>;


export type UI__ClientsPageQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], totalRequestCount: Long['output'] }, groupBy: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null } }> } | null } | null };

export type DocumentationPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isProposal: Scalars['Boolean']['input'];
  historyOffset: Scalars['Int']['input'];
  shouldSkipFetchingLaunch: Scalars['Boolean']['input'];
}>;


export type DocumentationPageQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
          | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
          | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
         | null, launch: { __typename: 'Launch', id: ID['output'], upstreamLaunch: { __typename: 'Launch', id: ID['output'], publication: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
                | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
                | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
               | null } | null } | null } | null, history: Array<{ __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } }>, schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, failedStep: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess' }
           | null } | null, buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         } | null, entities:
        | { __typename: 'EntitiesErrorResponse' }
        | { __typename: 'EntitiesResponse', entities: Array<{ __typename: 'Entity', typename: String['output'], subgraphKeys: Array<{ __typename: 'SubgraphKeyMap', keys: Array<String['output']>, subgraphName: String['output'] }> | null }> }
       | null, firstLaunch: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
        , build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
           | null } | null }> | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
           | null } | null } | null } | null } | null };

export type DocumentationPageTitleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type DocumentationPageTitleQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, url: String['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null } | null } | null };

export type NewSdlPageContractQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type NewSdlPageContractQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } | null } | null };

export type NewSdlPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  subgraphVariant: Scalars['String']['input'];
}>;


export type NewSdlPageQuery = { service: { __typename: 'Service', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], subgraphs: Array<{ __typename: 'FederatedImplementingService', graphID: String['output'], graphVariant: String['output'], updatedAt: Timestamp['output'], revision: String['output'], name: String['output'], url: String['output'] | null, activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'], isLive: Boolean['output'] } }> | null } | null, variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'] }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], gitContext: { __typename: 'GitContext', commit: ID['output'] | null, committer: String['output'] | null } | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], gitContext: { __typename: 'GitContext', commit: ID['output'] | null, committer: String['output'] | null } | null, schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'] } } | null } | null } | null };

export type SupergraphAndApiSchemaChangesFragment = { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
       | null } | null } | null };

export type UseRemovedCoordinatesLookupGraphFragment = { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], firstLaunch: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
        | { __typename: 'FilterBuildInput' }
      , build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
         | null } | null }> | null, activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], history: Array<{ __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } }>, schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
        | { __typename: 'FilterBuildInput' }
       } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
         | null } | null } | null } | null };

export type ExplorerPageQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ExplorerPageQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], name: String['output'], url: String['output'] | null, sendCookies: Boolean['output'] | null, subscriptionUrl: String['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canQuerySchemas: Boolean['output'] }, graph: { __typename: 'Service', id: ID['output'], graphType: GraphType } } & ({ __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
          | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
          | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
         | null } | null, entities:
        | { __typename: 'EntitiesErrorResponse' }
        | { __typename: 'EntitiesResponse', entities: Array<{ __typename: 'Entity', typename: String['output'], subgraphKeys: Array<{ __typename: 'SubgraphKeyMap', keys: Array<String['output']>, subgraphName: String['output'] }> | null }> }
       | null } | { __typename: 'GraphVariant', id?: never, activeSchemaPublish?: never, entities?: never }) | null } | null };

export type Graph__SetVariantURLMutationVariables = Exact<{
  graph: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  subscriptionUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type Graph__SetVariantURLMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateURL: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null } | null, updateSubscriptionURL: { __typename: 'GraphVariant', id: ID['output'], subscriptionUrl: String['output'] | null } | null } | null } | null };

export type Graph__SetSendCookiesMutationVariables = Exact<{
  graph: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  sendCookies: Scalars['Boolean']['input'];
}>;


export type Graph__SetSendCookiesMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateSendCookies: { __typename: 'GraphVariant', id: ID['output'], sendCookies: Boolean['output'] | null } | null } | null } | null };

export type RegistryConnectionSettingsModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type RegistryConnectionSettingsModalQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, schemaTag: { __typename: 'SchemaTag', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], url: String['output'] | null, subscriptionUrl: String['output'] | null, sendCookies: Boolean['output'] | null } } | null } | null };

export type RegisteredGraphEndpointsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type RegisteredGraphEndpointsQuery = { service: { __typename: 'Service', id: ID['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, isPublic: Boolean['output'] } } | null, account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, roles: { __typename: 'AccountRoles', canManageMembers: Boolean['output'] } | null } | null } | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', type: UserType, id: ID['output'] }
   | null };

export type CreateEmbedInvitationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  currentStaticInvitationRole: UserPermission;
}>;


export type CreateEmbedInvitation = { account: { __typename: 'AccountMutation', createStaticInvitation: { __typename: 'OrganizationInviteLink', joinToken: String['output'] } | null } | null };

export type ExplorerSettingsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ExplorerSettingsQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, roles: { __typename: 'ServiceRoles', canQueryStats: Boolean['output'] } | null, account: { __typename: 'Account', id: ID['output'] } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, preflightScript: String['output'] | null, sharedHeaders: String['output'] | null, isPublic: Boolean['output'], hasSupergraphSchema: Boolean['output'] } } | null } | null };

export type SavePreflightScriptForGraphVariantVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  preflightScriptContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type SavePreflightScriptForGraphVariant = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updatePreflightScript: { __typename: 'GraphVariant', id: ID['output'], preflightScript: String['output'] | null } | null } | null } | null };

export type UseExplorerSettingsUserQueryVariables = Exact<{ [key: string]: never; }>;


export type UseExplorerSettingsUserQuery = { studioSettings: { __typename: 'UserSettings', id: String['output'], autoManageVariables: Boolean['output'], mockingResponses: Boolean['output'], responseHints: ResponseHints, tableMode: Boolean['output'] } | null };

export type UseExplorerSettingsVariantQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type UseExplorerSettingsVariantQuery = { service: { __typename: 'Service', id: ID['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], preflightScript: String['output'] | null } } | null } | null };

export type SetUserSettingsVariables = Exact<{
  newSettings?: InputMaybe<UserSettingsInput>;
}>;


export type SetUserSettings = { setUserSettings: { __typename: 'UserSettings', id: String['output'], autoManageVariables: Boolean['output'], mockingResponses: Boolean['output'], responseHints: ResponseHints, tableMode: Boolean['output'] } | null };

export type GetCollectionEntriesVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCollectionEntries = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], collection: { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } } }> };

export type UseSubgraphsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantId: Scalars['String']['input'];
}>;


export type UseSubgraphsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], subgraphs: Array<{ __typename: 'FederatedImplementingService', name: String['output'], url: String['output'] | null, activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } }> | null } | null } | null };

export type UseQueryPlanQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  document: Scalars['GraphQLDocument']['input'];
}>;


export type UseQueryPlanQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], plan: { __typename: 'QueryPlan', json: String['output'], object: Object['output'], text: String['output'] } | null } | null } | null };

export type UseHeadersManagerQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type UseHeadersManagerQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null } | null } | null };

export type PersistSharedHeadersForGraphVariantVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  sharedHeadersContent?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersistSharedHeadersForGraphVariant = { service: { __typename: 'ServiceMutation', id: ID['output'], variant: { __typename: 'GraphVariantMutation', id: ID['output'], updateSharedHeaders: { __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null } | null } | null } | null };

export type UsePreflightSandboxOperationCollectionFragment = { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> };

export type LoadSandboxOperationCollectionsVariables = Exact<{ [key: string]: never; }>;


export type LoadSandboxOperationCollections = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> }> }
   | null };

export type LoadRegisteredOperationCollectionsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type LoadRegisteredOperationCollections = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> }> } | null } | null };

export type LoadOperationCollectionEntryVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type LoadOperationCollectionEntry = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], collection: { __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }, currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'], variables: String['output'] | null, script: String['output'] | null, postflightOperationScript: String['output'] | null, headers: Array<{ __typename: 'OperationHeader', name: String['output'], value: String['output'] }> | null } }> };

export type Studio__IntrospectionQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  schemaTag: Scalars['String']['input'];
}>;


export type Studio__IntrospectionQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, schema: { __typename: 'Schema', document: GraphQLDocument['output'], createdAt: Timestamp['output'], hash: ID['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
          | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], supergraphSdl: GraphQLDocument['output'] | null }
          | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], supergraphSdl: GraphQLDocument['output'] | null }
         | null } | null } | null } | null };

export type GetUpdatedCollectionEntriesVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetUpdatedCollectionEntries = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], collection: { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], sharedHeaders: String['output'] | null }> }, currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'], variables: String['output'] | null, script: String['output'] | null, postflightOperationScript: String['output'] | null, headers: Array<{ __typename: 'OperationHeader', name: String['output'], value: String['output'] }> | null } }> };

export type LoadSavedOperationOperationFragment = { __typename: 'OperationCollection', id: ID['output'], operation:
    | { __typename: 'NotFoundError', message: String['output'] }
    | { __typename: 'OperationCollectionEntry', id: ID['output'], currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'], variables: String['output'] | null, script: String['output'] | null, postflightOperationScript: String['output'] | null, headers: Array<{ __typename: 'OperationHeader', name: String['output'], value: String['output'] }> | null } }
   | null };

export type LoadSavedOperationQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
  variantRef: Scalars['ID']['input'];
}>;


export type LoadSavedOperationQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null }
    | { __typename: 'InvalidRefFormat' }
   | null, operationCollection:
    | { __typename: 'NotFoundError', message: String['output'] }
    | { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null }>, operation:
        | { __typename: 'NotFoundError', message: String['output'] }
        | { __typename: 'OperationCollectionEntry', id: ID['output'], currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'], variables: String['output'] | null, script: String['output'] | null, postflightOperationScript: String['output'] | null, headers: Array<{ __typename: 'OperationHeader', name: String['output'], value: String['output'] }> | null } }
       | null }
    | { __typename: 'PermissionError', message: String['output'] }
    | { __typename: 'ValidationError', message: String['output'] }
   };

export type CollectionEntryOperationCollectionEntryFragment = { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], orderingIndex: String['output'] };

export type CollectionEntryOperationCollectionFragment = { __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, isSandbox: Boolean['output'], isShared: Boolean['output'], isFavorite: Boolean['output'], permissions: { __typename: 'OperationCollectionPermissions', canManage: Boolean['output'], canEditOperations: Boolean['output'] }, operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], orderingIndex: String['output'] }>, variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> };

export type UpdateIsFavoriteVariables = Exact<{
  isFavorite: Scalars['Boolean']['input'];
  operationCollectionId: Scalars['ID']['input'];
}>;


export type UpdateIsFavorite = { operationCollection: { __typename: 'OperationCollectionMutation', updateIsFavorite:
      | { __typename: 'OperationCollection', id: ID['output'], isFavorite: Boolean['output'] }
      | { __typename: 'PermissionError' }
      | { __typename: 'ValidationError' }
     | null } | null };

export type CollectionsOnServiceFragment = { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], operationCollectionsConnection: { __typename: 'GraphVariantOperationCollectionConnection', totalCount: Int['output'] } | null }> };

export type OperationCollectionsVariantsV2QueryVariables = Exact<{
  isSandbox: Scalars['Boolean']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type OperationCollectionsVariantsV2Query = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships?: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], operationCollectionsConnection: { __typename: 'GraphVariantOperationCollectionConnection', totalCount: Int['output'] } | null }> }> } }> }
   | null, service?: { __typename: 'Service', id: ID['output'], title: String['output'], account: { __typename: 'Account', id: ID['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], operationCollectionsConnection: { __typename: 'GraphVariantOperationCollectionConnection', totalCount: Int['output'] } | null }> } | null };

export type OperationCollectionsRegisteredQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type OperationCollectionsRegisteredQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], mcpDefaultCollection:
        | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, isSandbox: Boolean['output'], isShared: Boolean['output'], isFavorite: Boolean['output'], permissions: { __typename: 'OperationCollectionPermissions', canManage: Boolean['output'], canEditOperations: Boolean['output'] }, operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], orderingIndex: String['output'] }>, variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }
        | { __typename: 'PermissionError' }
      , permissions: { __typename: 'GraphVariantPermissions', canShareCollectionInVariant: Boolean['output'], canCreateCollectionInVariant: Boolean['output'] }, operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, isSandbox: Boolean['output'], isShared: Boolean['output'], isFavorite: Boolean['output'], permissions: { __typename: 'OperationCollectionPermissions', canManage: Boolean['output'], canEditOperations: Boolean['output'] }, operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], orderingIndex: String['output'] }>, variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }> } | null } | null };

export type OperationCollectionsSandboxQueryVariables = Exact<{ [key: string]: never; }>;


export type OperationCollectionsSandboxQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, isSandbox: Boolean['output'], isShared: Boolean['output'], isFavorite: Boolean['output'], permissions: { __typename: 'OperationCollectionPermissions', canManage: Boolean['output'], canEditOperations: Boolean['output'] }, operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], orderingIndex: String['output'] }>, variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }> }
   | null };

export type MoveEntryBetweenCollectionsVariables = Exact<{
  collectionEntryId: Scalars['ID']['input'];
  originCollectionId: Scalars['ID']['input'];
  targetCollectionId: Scalars['ID']['input'];
  lowerOrderingBound?: InputMaybe<Scalars['String']['input']>;
  upperOrderingBound?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveEntryBetweenCollections = { operationCollection: { __typename: 'OperationCollectionMutation', operation:
      | { __typename: 'NotFoundError', message: String['output'] }
      | { __typename: 'OperationCollectionEntryMutation', moveToCollection:
          | { __typename: 'InvalidTarget', message: String['output'] }
          | { __typename: 'MoveOperationCollectionEntrySuccess', originCollection: { __typename: 'OperationCollection', id: ID['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], orderingIndex: String['output'] }> }, targetCollection: { __typename: 'OperationCollection', id: ID['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], orderingIndex: String['output'] }> } }
          | { __typename: 'PermissionError', message: String['output'] }
         }
      | { __typename: 'PermissionError', message: String['output'] }
     | null } | null };

export type UpdateCollectionEntryOrderVariables = Exact<{
  collectionEntryId: Scalars['ID']['input'];
  collectionId: Scalars['ID']['input'];
  lowerOrderingBound?: InputMaybe<Scalars['String']['input']>;
  upperOrderingBound?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCollectionEntryOrder = { operationCollection: { __typename: 'OperationCollectionMutation', operation:
      | { __typename: 'NotFoundError', message: String['output'] }
      | { __typename: 'OperationCollectionEntryMutation', reorderEntry:
          | { __typename: 'OperationCollection', id: ID['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], orderingIndex: String['output'] }> }
          | { __typename: 'PermissionError', message: String['output'] }
          | { __typename: 'ValidationError', message: String['output'] }
         | null }
      | { __typename: 'PermissionError', message: String['output'] }
     | null } | null };

export type ConfigureCollectionEntryModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type ConfigureCollectionEntryModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], description: String['output'] | null, minEditRole: UserPermission | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type UpdateCollectionNameVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateCollectionName = { operationCollection: { __typename: 'OperationCollectionMutation', updateName:
      | { __typename: 'OperationCollection', id: ID['output'], name: String['output'] }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type UpdateCollectionDescriptionVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCollectionDescription = { operationCollection: { __typename: 'OperationCollectionMutation', updateDescription:
      | { __typename: 'OperationCollection', id: ID['output'], description: String['output'] | null }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type CreateOperationCollectionMutationVariables = Exact<{
  collectionName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  variantRefs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isShared: Scalars['Boolean']['input'];
  isSandbox: Scalars['Boolean']['input'];
}>;


export type CreateOperationCollectionMutation = { createOperationCollection:
    | { __typename: 'NotFoundError', message: String['output'] }
    | { __typename: 'OperationCollection', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }>, createdBy?:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }
       | null }
    | { __typename: 'PermissionError', message: String['output'] }
    | { __typename: 'ValidationError', message: String['output'] }
   };

export type DeleteCollectionEntryModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
}>;


export type DeleteCollectionEntryModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], operation:
        | { __typename: 'NotFoundError' }
        | { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }
       | null }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type DeleteOperationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
}>;


export type DeleteOperation = { operationCollection: { __typename: 'OperationCollectionMutation', deleteOperation:
      | { __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'] }> }
      | { __typename: 'PermissionError' }
     | null } | null };

export type DeleteCollectionModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type DeleteCollectionModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'] }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type DeleteOperationCollectionMutationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type DeleteOperationCollectionMutation = { operationCollection: { __typename: 'OperationCollectionMutation', delete:
      | { __typename: 'DeleteOperationCollectionSuccess', variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }>, sandboxOwner: { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> } | null }
      | { __typename: 'PermissionError' }
     | null } | null };

export type DuplicateCollectionModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type DuplicateCollectionModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } }> }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
  , me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], description: String['output'] | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canShareCollectionInVariant: Boolean['output'] }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null } }> }
   | null };

export type DuplicateCollectionVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionName: Scalars['String']['input'];
  isSandbox: Scalars['Boolean']['input'];
  isShared: Scalars['Boolean']['input'];
  variantRef?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DuplicateCollection = { operationCollection: { __typename: 'OperationCollectionMutation', duplicateCollection:
      | { __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }>, createdBy?:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }
         | null }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type RenameCollectionEntryModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
}>;


export type RenameCollectionEntryModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], operation:
        | { __typename: 'NotFoundError' }
        | { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }
       | null }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type RenameOperationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameOperation = { operationCollection: { __typename: 'OperationCollectionMutation', operation:
      | { __typename: 'NotFoundError' }
      | { __typename: 'OperationCollectionEntryMutation', updateName:
          | { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }
          | { __typename: 'PermissionError', message: String['output'] }
          | { __typename: 'ValidationError', message: String['output'] }
         | null }
      | { __typename: 'PermissionError' }
     | null } | null };

export type UseCollectionNameValidationCollectionFragment = { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], name: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> };

export type UseUpsertCollectionValidationQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type UseUpsertCollectionValidationQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'] }> }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type UseUpsertSandboxCollectionValidationQueryVariables = Exact<{ [key: string]: never; }>;


export type UseUpsertSandboxCollectionValidationQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'] }> }
   | null };

export type UseCollectionEntryNameValidationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type UseCollectionEntryNameValidation = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], name: String['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type SetMinEditRoleVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  minEditRole?: InputMaybe<UserPermission>;
}>;


export type SetMinEditRole = { operationCollection: { __typename: 'OperationCollectionMutation', setMinEditRole:
      | { __typename: 'OperationCollection', id: ID['output'], minEditRole: UserPermission | null }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type ViewDetailsModalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type ViewDetailsModalQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, createdAt: Timestamp['output'], createdBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], id: ID['output'] }
       | null }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type ViewCollectionDetailsModalVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
}>;


export type ViewCollectionDetailsModal = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], operation:
        | { __typename: 'NotFoundError' }
        | { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], createdAt: Timestamp['output'], lastUpdatedAt: Timestamp['output'], createdBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', fullName: String['output'], id: ID['output'] }
           | null, lastUpdatedBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', fullName: String['output'], id: ID['output'] }
           | null }
       | null }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type UpdateOperationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionEntryId: Scalars['ID']['input'];
  operationInput: OperationCollectionEntryStateInput;
}>;


export type UpdateOperation = { operationCollection: { __typename: 'OperationCollectionMutation', operation:
      | { __typename: 'NotFoundError' }
      | { __typename: 'OperationCollectionEntryMutation', updateValues:
          | { __typename: 'OperationCollectionEntry', id: ID['output'], lastUpdatedAt: Timestamp['output'], lastUpdatedBy:
              | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'] }
              | { __typename: 'Service', id: ID['output'], name: String['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
              | { __typename: 'User', id: ID['output'], name: String['output'] }
             | null, currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'], variables: String['output'] | null, script: String['output'] | null, postflightOperationScript: String['output'] | null, headers: Array<{ __typename: 'OperationHeader', name: String['output'], value: String['output'] }> | null }, collection: { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'] } }
          | { __typename: 'PermissionError', message: String['output'] }
          | { __typename: 'ValidationError', message: String['output'] }
         | null }
      | { __typename: 'PermissionError' }
     | null } | null };

export type OperationsPaneCollectionDetailsQueryVariables = Exact<{
  operationCollectionId: Scalars['ID']['input'];
}>;


export type OperationsPaneCollectionDetailsQuery = { operationCollection:
    | { __typename: 'NotFoundError' }
    | { __typename: 'OperationCollection', id: ID['output'], permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }
    | { __typename: 'PermissionError' }
    | { __typename: 'ValidationError' }
   };

export type TimingHintsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  percentile: Scalars['Float']['input'];
}>;


export type TimingHintsQuery = { service: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', fieldExecutions: Array<{ __typename: 'ServiceFieldExecutionsRecord', metrics: { __typename: 'ServiceFieldExecutionsMetrics', fieldHistogram: { __typename: 'DurationHistogram', durationMs: Float['output'] | null } }, groupBy: { __typename: 'ServiceFieldExecutionsDimensions', fieldName: String['output'] | null, parentType: String['output'] | null } }> } | null } | null };

export type UseScriptModalAutocompleteCurrentOperationVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UseScriptModalAutocompleteCurrentOperation = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], collection: { __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> } }> };

export type UseScriptModalStateAllGraphsVariables = Exact<{ [key: string]: never; }>;


export type UseScriptModalStateAllGraphs = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], graphs: Array<{ __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], isShared: Boolean['output'] }> }> }> } }> }
   | null };

export type UseScriptModalStateGraphVariantsVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type UseScriptModalStateGraphVariants = { service: { __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], isSandbox: Boolean['output'], isShared: Boolean['output'] }> }> } | null };

export type UseScriptModalSandboxCompletionVariables = Exact<{ [key: string]: never; }>;


export type UseScriptModalSandboxCompletion = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isSandbox: Boolean['output'], isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> }> }
   | null };

export type PreflightScriptCompletionCollectionQueryVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PreflightScriptCompletionCollectionQuery = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], collection: { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> }, currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'] } }> };

export type GraphArtifactErrorModalQueryVariables = Exact<{
  graphArtifactId: Scalars['ID']['input'];
  graphID: Scalars['ID']['input'];
}>;


export type GraphArtifactErrorModalQuery = { graphArtifactById: { __typename: 'GraphArtifact', id: ID['output'], errors: Array<{ __typename: 'GraphArtifactError', message: String['output'] }> } | null };

export type GraphLayoutQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type GraphLayoutQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', internalAdminRole: InternalMdgAdminRole | null, id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null, graph: { __typename: 'Service', id: ID['output'], title: String['output'], account: { __typename: 'Account', id: ID['output'] } | null, apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }> | null } | null };

export type PersistedQueryListNameVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type PersistedQueryListName = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'] } | null } | null };

export type PersistedQueriesHomePageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type PersistedQueriesHomePageQuery = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], persistedQueryLists: Array<{ __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'], createdAt: Timestamp['output'], linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], revision: Int['output'], totalOperationsInList: Int['output'], publish: { __typename: 'PersistedQueriesPublish', publishedAt: Timestamp['output'] } } }> | null } | null };

export type PersistedQueryListDetailsFragment = { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'], createdAt: Timestamp['output'], linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], revision: Int['output'], totalOperationsInList: Int['output'], publish: { __typename: 'PersistedQueriesPublish', publishedAt: Timestamp['output'] } } };

export type PersistedQueryListActionsMenuDownloadQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersistedQueryListActionsMenuDownloadQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], revision: Int['output'] }, operations: { __typename: 'PersistedQueryConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: Boolean['output'], endCursor: String['output'] | null }, edges: Array<{ __typename: 'PersistedQueryEdge', node: { __typename: 'PersistedQuery', id: ID['output'], name: String['output'], type: OperationType, body: GraphQLDocument['output'], clientName: String['output'] | null } }> } } | null } | null };

export type PQListDeleteModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type PQListDeleteModalQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'], currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], totalOperationsInList: Int['output'] }, linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> } | null } | null };

export type PQListDeleteModalMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type PQListDeleteModalMutation = { service: { __typename: 'ServiceMutation', persistedQueryList: { __typename: 'PersistedQueryListMutation', id: ID['output'], delete:
        | { __typename: 'CannotDeleteLinkedPersistedQueryListError', message: String['output'] }
        | { __typename: 'DeletePersistedQueryListResult' }
        | { __typename: 'PermissionError', message: String['output'] }
       } } | null };

export type PQListMetaModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type PQListMetaModalQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'] } | null } | null };

export type PQListMetaUpdateModalMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type PQListMetaUpdateModalMutation = { service: { __typename: 'ServiceMutation', persistedQueryList: { __typename: 'PersistedQueryListMutation', id: ID['output'], updateMetadata:
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'UpdatePersistedQueryListMetadataResult', persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'] } }
       } } | null };

export type PQListRepublishModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type PQListRepublishModalQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'], linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> } | null } | null };

export type CreatePersistedQueryListMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePersistedQueryListMutation = { service: { __typename: 'ServiceMutation', createPersistedQueryList:
      | { __typename: 'CreatePersistedQueryListResult', persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], description: String['output'], createdAt: Timestamp['output'], linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], revision: Int['output'], totalOperationsInList: Int['output'], publish: { __typename: 'PersistedQueriesPublish', publishedAt: Timestamp['output'] } } } }
      | { __typename: 'PermissionError', message: String['output'] }
     } | null };

export type UsePQBatchLinkVariantsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
}>;


export type UsePQBatchLinkVariantsQuery = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> } | null } | null };

export type UsePQLinkVariantMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
}>;


export type UsePQLinkVariantMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', id: ID['output'], name: String['output'], linkResult:
        | { __typename: 'LinkPersistedQueryListResult', persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'] } }
        | { __typename: 'ListNotFoundError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'VariantAlreadyLinkedError', message: String['output'] }
       } | null } | null };

export type UsePQUnlinkVariantMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
}>;


export type UsePQUnlinkVariantMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', id: ID['output'], name: String['output'], linkResult:
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'UnlinkPersistedQueryListResult', unlinkedPersistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'] } }
        | { __typename: 'VariantAlreadyUnlinkedError', message: String['output'] }
       } | null } | null };

export type VariantPersistedQueriesLayoutQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantPersistedQueriesLayoutQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'] } | null } | null } | null };

export type PersistedQueryIndividualDeleteMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  remove?: InputMaybe<Array<PersistedQueryIdInput> | PersistedQueryIdInput>;
}>;


export type PersistedQueryIndividualDeleteMutation = { graph: { __typename: 'ServiceMutation', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryListMutation', id: ID['output'], publishOperations:
        | { __typename: 'CannotModifyOperationBodyError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'PublishOperationsResult', unchanged: Boolean['output'], build: { __typename: 'PersistedQueryListBuild', id: String['output'], totalOperationsInList: Int['output'] } }
       } } | null };

export type PersistedQueryBulkDeleteMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  filter: PersistedQueryFilterInput;
  exclude?: InputMaybe<Array<PersistedQueryIdInput> | PersistedQueryIdInput>;
}>;


export type PersistedQueryBulkDeleteMutation = { graph: { __typename: 'ServiceMutation', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryListMutation', id: ID['output'], deleteOperationsByFilter:
        | { __typename: 'DeleteOperationsByFilterResult', build: { __typename: 'PersistedQueryListBuild', id: String['output'], totalOperationsInList: Int['output'] } | null }
        | { __typename: 'PermissionError', message: String['output'] }
       } } | null };

export type PersistedQueryStartBulkDeletionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  filter: PersistedQueryFilterInput;
  exclude?: InputMaybe<Array<PersistedQueryIdInput> | PersistedQueryIdInput>;
}>;


export type PersistedQueryStartBulkDeletionMutation = { graph: { __typename: 'ServiceMutation', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryListMutation', id: ID['output'], startBulkDeletion:
        | { __typename: 'BulkDeletionAlreadyInProgressError' }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'StartBulkDeletionResult', jobId: ID['output'] }
       } } | null };

export type PersistedQueryTotalRequestCountQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  from: Scalars['Timestamp']['input'];
  graphVariant: Scalars['String']['input'];
  pqId: Scalars['String']['input'];
}>;


export type PersistedQueryTotalRequestCountQuery = { graph: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null } | null };

export type PersistedQueryDetailsDrawerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
  clientName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersistedQueryDetailsDrawerQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], operation: { __typename: 'PersistedQuery', id: ID['output'], clientName: String['output'] | null, name: String['output'], body: GraphQLDocument['output'], firstPublishedAt: Timestamp['output'], lastPublishedAt: Timestamp['output'] } | null } | null } | null };

export type PersistedQueryOperationStatsFragment = { __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } };

export type PersistedQueryRequestChartQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  pqId: Scalars['String']['input'];
}>;


export type PersistedQueryRequestChartQuery = { graph: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'] } }> } | null } | null };

export type PersistedQueryListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PersistedQueryFilterInput>;
  sort?: InputMaybe<PersistedQuerySortInput>;
  clientNamesFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PersistedQueryListQuery = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'], clientNames: { __typename: 'StringConnection', edges: Array<{ __typename: 'StringEdge', node: String['output'] }> }, currentBuild: { __typename: 'PersistedQueryListBuild', id: String['output'], totalOperationsInList: Int['output'] }, linkedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, operations: { __typename: 'PersistedQueryConnection', totalCount: Int['output'], pageInfo: { __typename: 'PageInfo', startCursor: String['output'] | null, endCursor: String['output'] | null, hasNextPage: Boolean['output'], hasPreviousPage: Boolean['output'] }, edges: Array<{ __typename: 'PersistedQueryEdge', cursor: String['output'], node: { __typename: 'PersistedQuery', id: ID['output'], clientName: String['output'] | null, name: String['output'], body: GraphQLDocument['output'], firstPublishedAt: Timestamp['output'], lastPublishedAt: Timestamp['output'] } }> } } | null } | null };

export type BulkDeletionStatusQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type BulkDeletionStatusQuery = { graph: { __typename: 'Service', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], bulkDeletionStatus:
        | { __typename: 'BulkDeletionFailure', error: String['output'] }
        | { __typename: 'BulkDeletionPending', operationsDeletedSoFar: Int['output'], status: BulkDeletionJobStatus }
        | { __typename: 'BulkDeletionSuccess', build: { __typename: 'PersistedQueryListBuild', id: String['output'], totalOperationsInList: Int['output'] } | null }
       | null } | null } | null };

export type ProposalListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<ProposalsFilterInput>;
}>;


export type ProposalListQuery = { graph: { __typename: 'Service', id: ID['output'], name: String['output'], proposalDescriptionTemplate: String['output'] | null, roles: { __typename: 'ServiceRoles', canCreateProposal: Boolean['output'] } | null, hasProposals: { __typename: 'ProposalsResult', totalCount: Int['output'] }, proposals: { __typename: 'ProposalsResult', totalCount: Int['output'], proposals: Array<{ __typename: 'Proposal', id: ID['output'], mergeBaseCompositionId: ID['output'] | null, canEditProposal: Boolean['output'], displayName: String['output'], status: ProposalStatus, createdAt: Timestamp['output'], hasUpstreamChanges: Boolean['output'], createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, latestRevision: { __typename: 'ProposalRevision', id: ID['output'], mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
             } | null, launch: { __typename: 'Launch', id: ID['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
             } | null, previousRevision: { __typename: 'ProposalRevision', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], buildInput:
                | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
                | { __typename: 'FilterBuildInput' }
               } | null } | null }, backingVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
             } | null, firstLaunch: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
             }> | null } }> } } | null };

export type ProposalRebaseConflictsQueryVariables = Exact<{
  proposalId: Scalars['ID']['input'];
}>;


export type ProposalRebaseConflictsQuery = { proposal: { __typename: 'Proposal', id: ID['output'], rebaseConflicts:
      | { __typename: 'NotFoundError' }
      | { __typename: 'RebaseConflictData', count: Int['output'] }
      | { __typename: 'SchemaValidationError' }
     | null } | null };

export type ProposalListPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ProposalListPageQuery = { graph: { __typename: 'Service', id: ID['output'], name: String['output'], proposalNotificationStatus: NotificationStatus, roles: { __typename: 'ServiceRoles', canCreateProposal: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', isContract: Boolean['output'] | null, id: ID['output'], name: String['output'], subgraphs: Array<{ __typename: 'FederatedImplementingService', name: String['output'] }> | null }> } | null };

export type SetProposalNotificationStatusModalServiceFragment = { __typename: 'Service', id: ID['output'], name: String['output'], proposalNotificationStatus: NotificationStatus };

export type SetProposalNotificationStatusMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: SetProposalNotificationStatusInput;
}>;


export type SetProposalNotificationStatusMutation = { service: { __typename: 'ServiceMutation', setProposalNotificationStatus:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], proposalNotificationStatus: NotificationStatus }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type GraphSettingsLayoutQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type GraphSettingsLayoutQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], hasSupergraphSchema: Boolean['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null }> } | null };

export type GraphSettings__APIKeysPageVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type GraphSettings__APIKeysPage = { service: { __typename: 'Service', id: ID['output'], title: String['output'], account: { __typename: 'Account', id: ID['output'] } | null, apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], keyName: String['output'] | null, role: UserPermission, createdAt: Timestamp['output'], lastUsed: Timestamp['output'] | null, createdBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, githubUsername: String['output'] | null, id: ID['output'] }
       | null }> | null } | null };

export type RenameAPIKeyMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameAPIKeyMutation = { service: { __typename: 'ServiceMutation', service: { __typename: 'Service', id: ID['output'] }, renameKey: { __typename: 'GraphApiKey', id: ID['output'], keyName: String['output'] | null } | null } | null };

export type RemoveAPIKeyMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveAPIKeyMutation = { service: { __typename: 'ServiceMutation', removeKey: Void['output'] | null, service: { __typename: 'Service', id: ID['output'] } } | null };

export type GraphSettings__APIKeysModalVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type GraphSettings__APIKeysModal = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission> } | null } | null };

export type GenerateAPIKeyMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role: UserPermission;
}>;


export type GenerateAPIKeyMutation = { service: { __typename: 'ServiceMutation', service: { __typename: 'Service', id: ID['output'] }, newKey: { __typename: 'GraphApiKey', role: UserPermission, id: ID['output'], token: String['output'], keyName: String['output'] | null } } | null };

export type GeneralGraphSettingsCardFragment = { __typename: 'Service', id: ID['output'], description: String['output'] | null, title: String['output'], avatarUrl: String['output'] | null, avatarUpload:
    | { __typename: 'AvatarUploadError', clientMessage: String['output'], code: AvatarUploadErrorCode, serverMessage: String['output'] }
    | { __typename: 'MediaUploadInfo', csrfToken: String['output'], maxContentLength: Int['output'], url: String['output'] }
   | null };

export type Graph__UpdateDescriptionGraphMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
}>;


export type Graph__UpdateDescriptionGraphMutation = { service: { __typename: 'ServiceMutation', updateDescription: { __typename: 'Service', id: ID['output'], description: String['output'] | null } | null } | null };

export type Graph__UpdateTitleGraphMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type Graph__UpdateTitleGraphMutation = { service: { __typename: 'ServiceMutation', updateTitle: { __typename: 'Service', id: ID['output'], title: String['output'] } | null } | null };

export type Graph__GraphSettingsQueryVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
}>;


export type Graph__GraphSettingsQuery = { service: { __typename: 'Service', id: ID['output'], hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], description: String['output'] | null, title: String['output'], avatarUrl: String['output'] | null, graphType: GraphType, defaultBuildPipelineTrack: String['output'] | null, defaultBuildPipelineTrackUpdatedAt: Timestamp['output'] | null, roles: { __typename: 'ServiceRoles', canQueryPrivateInfo: Boolean['output'], canManageAccess: Boolean['output'], canManageBuildConfig: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], compositionVersion: String['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, buildConfigUpdatedAt: Timestamp['output'] | null, name: String['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'] } | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null> } | null, account: { __typename: 'Account', id: ID['output'], name: String['output'], capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'], cloudGraphs: Boolean['output'] } | null, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, name: String['output'] } } | null, roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, avatarUpload:
      | { __typename: 'AvatarUploadError', clientMessage: String['output'], code: AvatarUploadErrorCode, serverMessage: String['output'] }
      | { __typename: 'MediaUploadInfo', csrfToken: String['output'], maxContentLength: Int['output'], url: String['output'] }
     | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, persistedQueryLists: Array<{ __typename: 'PersistedQueryList', id: ID['output'] }> | null } | null };

export type Graph__GraphSettingsAccountListQueryVariables = Exact<{ [key: string]: never; }>;


export type Graph__GraphSettingsAccountListQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], name: String['output'], capabilities: { __typename: 'AccountCapabilities', cloudGraphs: Boolean['output'] } | null, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, name: String['output'] } }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type DeleteGraphCardServiceFragment = { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, account: { __typename: 'Account', id: ID['output'] } | null };

export type Graph__DeleteGraphMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type Graph__DeleteGraphMutation = { service: { __typename: 'ServiceMutation', delete: Void['output'] | null, service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } } | null };

export type ServiceGraphOwnerCardFragment = { __typename: 'Service', id: ID['output'], graphType: GraphType, account: { __typename: 'Account', id: ID['output'], name: String['output'], capabilities: { __typename: 'AccountCapabilities', cloudGraphs: Boolean['output'] } | null, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, name: String['output'] } } | null };

export type UserGraphOwnerCardFragment = { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], name: String['output'], capabilities: { __typename: 'AccountCapabilities', cloudGraphs: Boolean['output'] } | null, limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, name: String['output'] } }, user: { __typename: 'User', id: ID['output'] } }> };

export type Graph__TransferGraphOwnerMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  toAccountId: Scalars['String']['input'];
}>;


export type Graph__TransferGraphOwnerMutation = { service: { __typename: 'ServiceMutation', transfer: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } | null } | null };

export type GraphVisibilityCardFragment = { __typename: 'Service', id: ID['output'], hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], account: { __typename: 'Account', id: ID['output'], capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null } | null, roles: { __typename: 'ServiceRoles', canManageAccess: Boolean['output'] } | null, roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null };

export type SetIsGraphHiddenFromUninvitedNonAdminAccountMembersMutationVariables = Exact<{
  hiddenFromUninvitedNonAdminAccountMembers: Scalars['Boolean']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type SetIsGraphHiddenFromUninvitedNonAdminAccountMembersMutation = { service: { __typename: 'ServiceMutation', updateHiddenFromUninvitedNonAdminAccountMembers: { __typename: 'Service', id: ID['output'], hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'] } | null } | null };

export type AccessPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type AccessPageQuery = { canBypassPlanRestrictions: Boolean['output'], service: { __typename: 'Service', id: ID['output'], hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, permissions: { __typename: 'ServiceRoles', canManageAccess: Boolean['output'] } | null, account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission>, memberships: Array<{ __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, githubUsername: String['output'] | null }, account: { __typename: 'Account', id: ID['output'] } }> | null, permissions: { __typename: 'AccountRoles', canQueryMembers: Boolean['output'], canManageMembers: Boolean['output'] } | null } | null, createdBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', id: ID['output'], fullName: String['output'] }
     | null } | null };

export type AddHiddenGraphMemberModalMembershipFragment = { __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null }, account: { __typename: 'Account', id: ID['output'] } };

export type AddHiddenGraphMemberMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  role?: InputMaybe<UserPermission>;
}>;


export type AddHiddenGraphMemberMutation = { service: { __typename: 'ServiceMutation', overrideUserPermission: { __typename: 'Service', id: ID['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null } | null } | null };

export type RemoveGraphRoleOverrideModalMembershipFragment = { __typename: 'AccountMembership', createdAt: Timestamp['output'], role: UserPermission, user: { __typename: 'User', id: ID['output'], fullName: String['output'] }, account: { __typename: 'Account', id: ID['output'] } };

export type RemoveGraphRoleMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
}>;


export type RemoveGraphRoleMutation = { service: { __typename: 'ServiceMutation', overrideUserPermission: { __typename: 'Service', id: ID['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null } | null } | null };

export type UpdateGraphRoleMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  role?: InputMaybe<UserPermission>;
}>;


export type UpdateGraphRoleMutation = { service: { __typename: 'ServiceMutation', overrideUserPermission: { __typename: 'Service', id: ID['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null } | null } | null };

export type ProposalsPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ProposalsPageQuery = { service: { __typename: 'Service', id: ID['output'], proposalDescriptionTemplate: String['output'] | null, proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], minProposalApprovers: Int['output'], proposalsMustBeReApprovedOnChange: Boolean['output'], minProposalRoles: { __typename: 'ProposalRoles', create: UserPermission, edit: UserPermission }, defaultProposalReviewers: Array<
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null>, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null } }> | null } | null } | null };

export type ApprovalsAndPermissionsCardFragment = { __typename: 'Service', id: ID['output'], proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], minProposalApprovers: Int['output'], proposalsMustBeReApprovedOnChange: Boolean['output'], minProposalRoles: { __typename: 'ProposalRoles', create: UserPermission, edit: UserPermission }, defaultProposalReviewers: Array<
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null>, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null } }> | null } | null };

export type ProposalNumberOfApproversModalMinProposalApproversMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: SetMinProposalApproversInput;
}>;


export type ProposalNumberOfApproversModalMinProposalApproversMutation = { service: { __typename: 'ServiceMutation', setMinProposalApprovers:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], minProposalApprovers: Int['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type ProposalPermissionsModalUpdatePermissionsMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: SetProposalRolesInput;
}>;


export type ProposalPermissionsModalUpdatePermissionsMutation = { service: { __typename: 'ServiceMutation', setMinProposalRoles:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], minProposalRoles: { __typename: 'ProposalRoles', create: UserPermission } }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type SetProposalsMustBeReApprovedOnChangeVariables = Exact<{
  graphId: Scalars['ID']['input'];
  approvalRequiredOnChange: Scalars['Boolean']['input'];
}>;


export type SetProposalsMustBeReApprovedOnChange = { service: { __typename: 'ServiceMutation', setProposalsMustBeReApprovedOnChange:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], proposalsMustBeReApprovedOnChange: Boolean['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type ApproversRequiredSectionServiceFragment = { __typename: 'Service', id: ID['output'], minProposalApprovers: Int['output'] };

export type DefaultReviewersSectionServiceFragment = { __typename: 'Service', id: ID['output'], proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], minProposalApprovers: Int['output'], defaultProposalReviewers: Array<
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null>, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null } }> | null } | null };

export type DefaultReviewersSectionSetDefaultReviewersMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: SetProposalDefaultReviewersInput;
}>;


export type DefaultReviewersSectionSetDefaultReviewersMutation = { service: { __typename: 'ServiceMutation', setProposalDefaultReviewers:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], defaultProposalReviewers: Array<
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null> }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type DefaultReviewersSectionSetMandatoryDefaultReviewersMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checked: Scalars['Boolean']['input'];
}>;


export type DefaultReviewersSectionSetMandatoryDefaultReviewersMutation = { service: { __typename: 'ServiceMutation', proposalsMustBeApprovedByADefaultReviewer:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], proposalsMustBeApprovedByADefaultReviewer: Boolean['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type ProposalDescriptionTemplateModalMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: SetProposalDescriptionTemplateInput;
}>;


export type ProposalDescriptionTemplateModalMutation = { service: { __typename: 'ServiceMutation', setProposalDescriptionTemplate:
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'Service', id: ID['output'], proposalDescriptionTemplate: String['output'] | null }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type ProposalDescriptionTemplateCardFragment = { __typename: 'Service', id: ID['output'], proposalDescriptionTemplate: String['output'] | null };

export type ProposalsCheckConfigVariantFragment = { __typename: 'VariantCheckConfiguration', id: ID['output'], proposalChangeMismatchSeverityConfig: { __typename: 'VariantCheckConfigurationProposalChangeMismatchSeverity', proposalChangeMismatchSeverity: ProposalChangeMismatchSeverity | null } };

export type VariantCheckConfigProposalChangeMismatchSeverityMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  proposalChangeMismatchSeverity?: InputMaybe<ProposalChangeMismatchSeverity>;
}>;


export type VariantCheckConfigProposalChangeMismatchSeverityMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateCheckConfigurationProposalChangeMismatchSeverity: { __typename: 'VariantCheckConfiguration', id: ID['output'], proposalChangeMismatchSeverityConfig: { __typename: 'VariantCheckConfigurationProposalChangeMismatchSeverity', proposalChangeMismatchSeverity: ProposalChangeMismatchSeverity | null } } } | null } | null };

export type ReApprovalRequirementsSectionServiceFragment = { __typename: 'Service', id: ID['output'], proposalsMustBeReApprovedOnChange: Boolean['output'] };

export type NotificationsSettingsPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type NotificationsSettingsPageQuery = { service: { __typename: 'Service', id: ID['output'], channels: Array<
      | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], routingKey: String['output'], subscriptions: Array<
          | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
          | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        > }
      | { __typename: 'SlackChannel', id: ID['output'], name: String['output'], url: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
          | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
          | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        > }
      | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], url: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
          | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
          | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        > }
    > | null } | null };

export type UpsertPagerDutyChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channel: PagerDutyChannelInput;
}>;


export type UpsertPagerDutyChannelMutation = { service: { __typename: 'ServiceMutation', upsertPagerDutyChannel: { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
        | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
        | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
      > } | null } | null };

export type CreateProposalSubscriptionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: CreateProposalLifecycleSubscriptionInput;
}>;


export type CreateProposalSubscriptionMutation = { service: { __typename: 'ServiceMutation', createProposalLifecycleSubscription:
      | { __typename: 'PermissionError' }
      | { __typename: 'ProposalLifecycleSubscription', id: ID['output'], channels: Array<
          | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
              | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
              | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            > }
          | { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
              | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
              | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            > }
          | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
              | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
              | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
              | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            > }
        > }
      | { __typename: 'ValidationError' }
     } | null };

export type CreateSchemaPublishSubscriptionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type CreateSchemaPublishSubscriptionMutation = { service: { __typename: 'ServiceMutation', createSchemaPublishSubscription: { __typename: 'SchemaPublishSubscription', id: ID['output'], channels: Array<
        | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
      > } } | null };

export type AllTimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTimezonesQuery = { allTimezoneOffsets: Array<{ __typename: 'TimezoneOffset', zoneID: String['output'], minutesOffsetFromUTC: Int['output'] }> };

export type UpsertSummaryMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  summaryId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertSummaryMutation = { service: { __typename: 'ServiceMutation', upsertScheduledSummary: { __typename: 'ScheduledSummary', id: ID['output'], channels: Array<
        | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
      > } | null } | null };

export type ServiceUpsertSlackChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channel: SlackChannelInput;
}>;


export type ServiceUpsertSlackChannelMutation = { service: { __typename: 'ServiceMutation', upsertSlackChannel: { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
        | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
        | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
      > } | null } | null };

export type UpsertWebhookChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  secretToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertWebhookChannelMutation = { service: { __typename: 'ServiceMutation', upsertWebhookChannel: { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
        | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
        | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
        | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
      > } | null } | null };

export type TestSlackChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  notification: SlackNotificationInput;
}>;


export type TestSlackChannelMutation = { service: { __typename: 'ServiceMutation', testSlackChannel: Void['output'] | null } | null };

type AddNotificationWizardChannelFragment_PagerDutyChannel = { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'] };

type AddNotificationWizardChannelFragment_SlackChannel = { __typename: 'SlackChannel', id: ID['output'], name: String['output'] };

type AddNotificationWizardChannelFragment_WebhookChannel = { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] };

export type AddNotificationWizardChannelFragment =
  | AddNotificationWizardChannelFragment_PagerDutyChannel
  | AddNotificationWizardChannelFragment_SlackChannel
  | AddNotificationWizardChannelFragment_WebhookChannel
;

export type SelectVariantAndChannelModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type SelectVariantAndChannelModalQuery = { service: { __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, channels: Array<
      | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'] }
      | { __typename: 'SlackChannel', id: ID['output'], name: String['output'] }
      | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] }
    > | null } | null };

export type PerformanceAlertsTriggerInputsVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
}>;


export type PerformanceAlertsTriggerInputs = { service: { __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }>, stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', group: { __typename: 'ServiceQueryStatsDimensions', queryName: String['output'] | null } }> } | null, channels: Array<
      | { __typename: 'PagerDutyChannel', routingKey: String['output'], id: ID['output'], name: String['output'] }
      | { __typename: 'SlackChannel', url: String['output'], id: ID['output'], name: String['output'] }
      | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] }
    > | null, roles: { __typename: 'ServiceRoles', canQueryPrivateInfo: Boolean['output'], canManageIntegrations: Boolean['output'] } | null } | null };

export type QueryTriggerFragment = { __typename: 'QueryTrigger', id: ID['output'], scope: QueryTriggerScope, operationNames: Array<String['output']>, excludedOperationNames: Array<String['output']>, metric: QueryTriggerMetric, percentile: Float['output'] | null, threshold: Float['output'], comparisonOperator: ComparisonOperator, window: QueryTriggerWindow, enabled: Boolean['output'], variant: String['output'] | null, state: { __typename: 'QueryTriggerState', triggered: Boolean['output'], evaluatedAt: Timestamp['output'], lastTriggeredAt: Timestamp['output'] | null }, channels: Array<
    | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'] }
    | { __typename: 'SlackChannel', id: ID['output'], name: String['output'] }
    | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] }
  > };

export type PerformanceAlertsTriggersVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type PerformanceAlertsTriggers = { service: { __typename: 'Service', id: ID['output'], queryTriggers: Array<{ __typename: 'QueryTrigger', id: ID['output'], scope: QueryTriggerScope, operationNames: Array<String['output']>, excludedOperationNames: Array<String['output']>, metric: QueryTriggerMetric, percentile: Float['output'] | null, threshold: Float['output'], comparisonOperator: ComparisonOperator, window: QueryTriggerWindow, enabled: Boolean['output'], variant: String['output'] | null, state: { __typename: 'QueryTriggerState', triggered: Boolean['output'], evaluatedAt: Timestamp['output'], lastTriggeredAt: Timestamp['output'] | null }, channels: Array<
        | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'] }
        | { __typename: 'SlackChannel', id: ID['output'], name: String['output'] }
        | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] }
      > }> | null } | null };

export type UpsertQueryTriggerMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  triggerId?: InputMaybe<Scalars['ID']['input']>;
  trigger: QueryTriggerInput;
}>;


export type UpsertQueryTriggerMutation = { service: { __typename: 'ServiceMutation', upsertQueryTrigger: { __typename: 'QueryTrigger', id: ID['output'], scope: QueryTriggerScope, operationNames: Array<String['output']>, excludedOperationNames: Array<String['output']>, metric: QueryTriggerMetric, percentile: Float['output'] | null, threshold: Float['output'], comparisonOperator: ComparisonOperator, window: QueryTriggerWindow, enabled: Boolean['output'], variant: String['output'] | null, state: { __typename: 'QueryTriggerState', triggered: Boolean['output'], evaluatedAt: Timestamp['output'], lastTriggeredAt: Timestamp['output'] | null }, channels: Array<
        | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'] }
        | { __typename: 'SlackChannel', id: ID['output'], name: String['output'] }
        | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'] }
      > } | null } | null };

export type AlertsChartStatsVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  filter?: InputMaybe<ServiceQueryStatsFilter>;
  resolution: Resolution;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
}>;


export type AlertsChartStats = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], uncachedRequestsCount: Long['output'], cachedRequestsCount: Long['output'], totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'], serviceTimeP99: Float['output'] | null, serviceTimeP95: Float['output'] | null, serviceTimeP50: Float['output'] | null } } }> } | null } | null };

export type DeleteQueryTriggerMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  triggerId: Scalars['ID']['input'];
}>;


export type DeleteQueryTriggerMutation = { service: { __typename: 'ServiceMutation', deleteQueryTrigger: Boolean['output'] } | null };

type ChannelCardChannelFragment_PagerDutyChannel = { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
    | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
    | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
  > };

type ChannelCardChannelFragment_SlackChannel = { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
    | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
    | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
  > };

type ChannelCardChannelFragment_WebhookChannel = { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
    | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
    | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
    | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
  > };

export type ChannelCardChannelFragment =
  | ChannelCardChannelFragment_PagerDutyChannel
  | ChannelCardChannelFragment_SlackChannel
  | ChannelCardChannelFragment_WebhookChannel
;

export type ChannelActionMenuDeleteChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;


export type ChannelActionMenuDeleteChannelMutation = { service: { __typename: 'ServiceMutation', deleteChannel: Boolean['output'] } | null };

export type TestWebhookChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
}>;


export type TestWebhookChannelMutation = { service: { __typename: 'ServiceMutation', testSubscriptionForChannel: String['output'] } | null };

export type QueueTestProposalLifecycleNotificationMutationVariables = Exact<{
  input: QueueTestProposalLifecycleNotificationInput;
  graphId: Scalars['ID']['input'];
}>;


export type QueueTestProposalLifecycleNotificationMutation = { graph: { __typename: 'ServiceMutation', queueTestProposalLifecycleNotification:
      | { __typename: 'NotFoundError', message: String['output'] }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'QueueTestProposalLifecycleNotificationError', message: String['output'] }
      | { __typename: 'QueueTestProposalLifecycleNotificationSuccess', queued: Boolean['output'] | null }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type UpdateProposalLifecycleSubscriptionMutationVariables = Exact<{
  input: UpdateProposalLifecycleSubscriptionInput;
  graphId: Scalars['ID']['input'];
}>;


export type UpdateProposalLifecycleSubscriptionMutation = { graph: { __typename: 'ServiceMutation', updateProposalLifecycleSubscription:
      | { __typename: 'NotFoundError' }
      | { __typename: 'PermissionError' }
      | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'] }
      | { __typename: 'ValidationError' }
     } | null };

export type DeleteRegistrySubscriptionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
}>;


export type DeleteRegistrySubscriptionMutation = { service: { __typename: 'ServiceMutation', deleteRegistrySubscription: Boolean['output'] } | null };

export type DeleteProposalLifecycleSubscriptionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: DeleteProposalLifecycleSubscriptionInput;
}>;


export type DeleteProposalLifecycleSubscriptionMutation = { service: { __typename: 'ServiceMutation', deleteProposalLifecycleSubscription:
      | { __typename: 'DeleteProposalLifecycleSubscriptionSuccess', id: ID['output'] }
      | { __typename: 'NotFoundError' }
      | { __typename: 'PermissionError' }
      | { __typename: 'ValidationError' }
     } | null };

export type DeleteScheduledSummaryMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
}>;


export type DeleteScheduledSummaryMutation = { service: { __typename: 'ServiceMutation', deleteScheduledSummary: Boolean['output'] } | null };

export type CreateBuildSubscriptionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type CreateBuildSubscriptionMutation = { service: { __typename: 'ServiceMutation', createCompositionStatusSubscription: { __typename: 'SchemaPublishSubscription', id: ID['output'], channels: Array<
        | { __typename: 'PagerDutyChannel', id: ID['output'], name: String['output'], subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'SlackChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
        | { __typename: 'WebhookChannel', id: ID['output'], name: String['output'], proposalLifecycleSubscriptions: Array<{ __typename: 'ProposalLifecycleSubscription', id: ID['output'], enabled: Boolean['output'], events: Array<ProposalLifecycleEvent>, variant: String['output'] | null }>, subscriptions: Array<
            | { __typename: 'CompositionStatusSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ProposalLifecycleSubscription', events: Array<ProposalLifecycleEvent>, id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'QueryTrigger', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'RegistrySubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
            | { __typename: 'ScheduledSummary', id: ID['output'], enabled: Boolean['output'], variant: String['output'] }
            | { __typename: 'SchemaPublishSubscription', id: ID['output'], enabled: Boolean['output'], variant: String['output'] | null }
          > }
      > } } | null };

export type DatadogConfigQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type DatadogConfigQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], datadogMetricsConfig: { __typename: 'DatadogMetricsConfig', apiKey: String['output'], apiRegion: DatadogApiRegion, enabled: Boolean['output'], legacyMetricNames: Boolean['output'] } | null, roles: { __typename: 'ServiceRoles', canQueryIntegrations: Boolean['output'], canManageIntegrations: Boolean['output'] } | null, account: { __typename: 'Account', id: ID['output'], roles: { __typename: 'AccountRoles', canSetConstrainedPlan: Boolean['output'] } | null } | null } | null };

export type UpdateDatadogApiKeyAndRegionMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
  apiRegion: DatadogApiRegion;
}>;


export type UpdateDatadogApiKeyAndRegionMutation = { service: { __typename: 'ServiceMutation', updateDatadogMetricsConfig: { __typename: 'DatadogMetricsConfig', apiKey: String['output'], apiRegion: DatadogApiRegion, enabled: Boolean['output'] } | null } | null };

export type UpdateDatadogEnabledMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateDatadogEnabledMutation = { service: { __typename: 'ServiceMutation', updateDatadogMetricsConfig: { __typename: 'DatadogMetricsConfig', enabled: Boolean['output'] } | null } | null };

export type DisableDatadogForwardingLegacyMetricNamesVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type DisableDatadogForwardingLegacyMetricNames = { service: { __typename: 'ServiceMutation', disableDatadogForwardingLegacyMetricNames: { __typename: 'Service', id: ID['output'], datadogMetricsConfig: { __typename: 'DatadogMetricsConfig', legacyMetricNames: Boolean['output'] } | null } | null } | null };

export type EditChannelModalUpsertChannelMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
  slackChannel?: InputMaybe<SlackChannelInput>;
  pagerDutyChannel?: InputMaybe<PagerDutyChannelInput>;
  webhookChannel?: InputMaybe<WebhookChannelInput>;
}>;


export type EditChannelModalUpsertChannelMutation = { service: { __typename: 'ServiceMutation', upsertChannel:
      | { __typename: 'PagerDutyChannel', id: ID['output'] }
      | { __typename: 'SlackChannel', id: ID['output'] }
      | { __typename: 'WebhookChannel', id: ID['output'] }
     | null } | null };

type EditChannelModalChannelFragment_PagerDutyChannel = { __typename: 'PagerDutyChannel', routingKey: String['output'], id: ID['output'] };

type EditChannelModalChannelFragment_SlackChannel = { __typename: 'SlackChannel', url: String['output'], id: ID['output'] };

type EditChannelModalChannelFragment_WebhookChannel = { __typename: 'WebhookChannel', url: String['output'], id: ID['output'] };

export type EditChannelModalChannelFragment =
  | EditChannelModalChannelFragment_PagerDutyChannel
  | EditChannelModalChannelFragment_SlackChannel
  | EditChannelModalChannelFragment_WebhookChannel
;

export type GraphSettings__VariantsPageVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type GraphSettings__VariantsPage = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], registrySubscriptionsEnabled: Boolean['output'], graphType: GraphType, roles: { __typename: 'ServiceRoles', canQuerySchemas: Boolean['output'], canManageVariants: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, sendCookies: Boolean['output'] | null, subscriptionUrl: String['output'] | null, name: String['output'], compositionVersion: String['output'] | null, isContract: Boolean['output'] | null, isProtected: Boolean['output'], isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, derivedVariantCount: Int['output'], supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', name: String['output'], enabled: Boolean['output'] }> | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], compositionVersion: String['output'] | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', name: String['output'], enabled: Boolean['output'] }> | null, contractFilterConfig: { __typename: 'FilterConfig', include: Array<String['output']>, exclude: Array<String['output']> } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], typeCount: Int['output'] } } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], typeCount: Int['output'] } } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', badge: BuildPipelineTrackBadge | null, federationVersion: FederationVersion['output'], compositionVersion: String['output'], deprecatedAt: Timestamp['output'] | null, displayName: String['output'], minimumGatewayVersion: String['output'] | null, minimumRouterVersion: String['output'] | null, notSupportedAt: Timestamp['output'] | null } | null>, buildConfig: { __typename: 'BuildConfig', tagInApiSchema: Boolean['output'], federationVersion: FederationVersion['output'] } | null }>, graphCapabilities: { __typename: 'GraphCapabilities', minimumBuildPipelineTrack: BuildPipelineTrack } } | null };

export type VariantSettings__DeleteVariantMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  schemaTag: Scalars['String']['input'];
}>;


export type VariantSettings__DeleteVariantMutation = { service: { __typename: 'ServiceMutation', service: { __typename: 'Service', id: ID['output'] }, deleteSchemaTag: { __typename: 'DeleteSchemaTagResult', deleted: Boolean['output'] } } | null };

export type AddNewVariantMutationVariables = Exact<{
  variant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  uploadSchemaSchemaDocument: Scalars['String']['input'];
}>;


export type AddNewVariantMutation = { service: { __typename: 'ServiceMutation', uploadSchema: { __typename: 'UploadSchemaMutationResponse', success: Boolean['output'] } | null } | null };

export type AddVariantModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AddVariantModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type AddVariantModalProvisionKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AddVariantModalProvisionKeyMutation = { user: { __typename: 'UserMutation', provisionKey: { __typename: 'ApiKeyProvision', apiKey:
        | { __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }
        | { __typename: 'GraphOsKey', id: ID['output'], token: String['output'] }
        | { __typename: 'UserApiKey', id: ID['output'], token: String['output'] }
       } | null } | null };

export type UseIsLoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type UseIsLoggedInQuery = { isLoggedIn: Boolean['output'] | null };

export type UseIsPublicMemberOnlyQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type UseIsPublicMemberOnlyQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'] } | null } | null };

export type CoordinateEmptyStateQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type CoordinateEmptyStateQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], routerLastSeenAt: Timestamp['output'] | null, fieldUsageLastReportedAt: Timestamp['output'] | null, fieldExecutionsLastReportedAt: Timestamp['output'] | null, extendedRefsUsage: { __typename: 'ExtendedRefsUsage', firstSeenAt: Timestamp['output'] | null, lastSeenAt: Timestamp['output'] | null } } | null } | null };

export type FieldInsightsEmptyStateFragment = { __typename: 'GraphVariant', id: ID['output'], routerLastSeenAt: Timestamp['output'] | null, fieldUsageLastReportedAt: Timestamp['output'] | null, fieldExecutionsLastReportedAt: Timestamp['output'] | null, extendedRefsUsage: { __typename: 'ExtendedRefsUsage', firstSeenAt: Timestamp['output'] | null, lastSeenAt: Timestamp['output'] | null } };

export type FieldLandingPageMetricsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filterFieldUsage?: InputMaybe<ServiceFieldUsageFilter>;
  filterFieldExecutions?: InputMaybe<ServiceFieldExecutionsFilter>;
  resolution?: InputMaybe<Resolution>;
}>;


export type FieldLandingPageMetricsQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', fieldUsageByContextAndQuery: Array<{ __typename: 'ServiceFieldUsageRecord', groupBy: { __typename: 'ServiceFieldUsageDimensions', clientName: String['output'] | null, operationType: String['output'] | null, queryName: String['output'] | null, queryId: ID['output'] | null }, metrics: { __typename: 'ServiceFieldUsageMetrics', executionCount: Long['output'], estimatedExecutionCount: Long['output'], referencingOperationCount: Long['output'] } }> } | null, allStats: { __typename: 'ServiceStatsWindow', fieldExecutions: Array<{ __typename: 'ServiceFieldExecutionsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceFieldExecutionsMetrics', errorsCount: Long['output'], observedExecutionCount: Long['output'], estimatedExecutionCount: Long['output'], referencingOperationCount: Long['output'], fieldHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null } } }> } | null } | null };

export type ServiceFieldUsageRecordFragment = { __typename: 'ServiceFieldUsageRecord', groupBy: { __typename: 'ServiceFieldUsageDimensions', clientName: String['output'] | null, operationType: String['output'] | null, queryName: String['output'] | null, queryId: ID['output'] | null }, metrics: { __typename: 'ServiceFieldUsageMetrics', executionCount: Long['output'], estimatedExecutionCount: Long['output'], referencingOperationCount: Long['output'] } };

export type ServiceCoordinateUsageRecordFragment = { __typename: 'ServiceCoordinateUsageRecord', groupBy: { __typename: 'ServiceCoordinateUsageDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null, operationType: String['output'] | null, queryName: String['output'] | null, queryId: String['output'] | null }, metrics: { __typename: 'ServiceCoordinateUsageMetrics', referencingOperationCount: Long['output'], executionCount: Long['output'], requestCountNull: Long['output'] } };

export type CoordinateLandingPageSchemaQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type CoordinateLandingPageSchemaQuery = { service: { __typename: 'Service', id: ID['output'], schema: { __typename: 'Schema', document: GraphQLDocument['output'], createdAt: Timestamp['output'], hash: ID['output'], fieldCount: Int['output'], typeCount: Int['output'], gitContext: { __typename: 'GitContext', commit: ID['output'] | null } | null } | null, variant: { __typename: 'GraphVariant', id: ID['output'], usageLastReportedAt: Timestamp['output'] | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
           | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
          | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
          | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
         | null } | null, permissions: { __typename: 'GraphVariantPermissions', canQuerySchemas: Boolean['output'] }, entities:
        | { __typename: 'EntitiesErrorResponse' }
        | { __typename: 'EntitiesResponse', entities: Array<{ __typename: 'Entity', typename: String['output'], subgraphKeys: Array<{ __typename: 'SubgraphKeyMap', keys: Array<String['output']>, subgraphName: String['output'] }> | null }> }
       | null } | null } | null };

export type CoordinateLandingPageBoundsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  parentType: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  coordinateKind: CoordinateKind;
  isObjectField: Scalars['Boolean']['input'];
}>;


export type CoordinateLandingPageBoundsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], usageLastReportedAt: Timestamp['output'] | null, fieldInsights?: { __typename: 'FieldInsights', firstSeen: Timestamp['output'] | null, lastSeen: Timestamp['output'] | null, earliestRetentionTime: Timestamp['output'] | null } | null, coordinateInsights?: { __typename: 'CoordinateInsights', firstSeen: Timestamp['output'] | null, lastSeen: Timestamp['output'] | null, earliestRetentionTime: Timestamp['output'] | null } | null } | null } | null };

export type CoordinateLandingPageMetricsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filterFieldUsage?: InputMaybe<ServiceFieldUsageFilter>;
  filterFieldExecutions?: InputMaybe<ServiceFieldExecutionsFilter>;
  filterCoordinateUsage?: InputMaybe<ServiceCoordinateUsageFilter>;
  resolution?: InputMaybe<Resolution>;
  isObjectField: Scalars['Boolean']['input'];
}>;


export type CoordinateLandingPageMetricsQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', fieldUsageByContextAndQuery?: Array<{ __typename: 'ServiceFieldUsageRecord', groupBy: { __typename: 'ServiceFieldUsageDimensions', clientName: String['output'] | null, operationType: String['output'] | null, queryName: String['output'] | null, queryId: ID['output'] | null }, metrics: { __typename: 'ServiceFieldUsageMetrics', executionCount: Long['output'], estimatedExecutionCount: Long['output'], referencingOperationCount: Long['output'] } }>, coordinateUsageByContextAndQuery?: Array<{ __typename: 'ServiceCoordinateUsageRecord', groupBy: { __typename: 'ServiceCoordinateUsageDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null, operationType: String['output'] | null, queryName: String['output'] | null, queryId: String['output'] | null }, metrics: { __typename: 'ServiceCoordinateUsageMetrics', referencingOperationCount: Long['output'], executionCount: Long['output'], requestCountNull: Long['output'] } }> } | null, allStats: { __typename: 'ServiceStatsWindow', fieldExecutions?: Array<{ __typename: 'ServiceFieldExecutionsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceFieldExecutionsMetrics', errorsCount: Long['output'], observedExecutionCount: Long['output'], estimatedExecutionCount: Long['output'], referencingOperationCount: Long['output'], fieldHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null } } }>, coordinateUsage?: Array<{ __typename: 'ServiceCoordinateUsageRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceCoordinateUsageMetrics', referencingOperationCount: Long['output'], estimatedExecutionCount: Long['output'] } }> } | null } | null };

export type FetchErrorsOverTimeResultFragment = { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchesWithErrorsCount: Long['output'], fetchesWithErrorsCountPerMin: Float['output'], fetchErrorPercentage: Float['output'] } }> };

export type FetchLatencyOverTimeResultFragment = { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchLatencyHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null, p99: Float['output'] | null } | null } }> };

export type FetchesOverTimeResultFragment = { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchCount: Long['output'], fetchCountPerMin: Float['output'] } }> };

export type SubgraphServiceReportQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  resolution: Resolution;
  filter: SubgraphInsightsListFilterInput;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
}>;


export type SubgraphServiceReportQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], subgraphInsightsTimeseries: { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchCount: Long['output'], fetchCountPerMin: Float['output'], fetchesWithErrorsCount: Long['output'], fetchesWithErrorsCountPerMin: Float['output'], fetchErrorPercentage: Float['output'], fetchLatencyHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null, p99: Float['output'] | null } | null } }> } } | null } | null };

export type SubgraphInsightsPageSDLQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  subgraphName: Scalars['ID']['input'];
}>;


export type SubgraphInsightsPageSDLQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, subgraph: { __typename: 'FederatedImplementingService', url: String['output'] | null, revision: String['output'], updatedAt: Timestamp['output'], activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], subgraph: { __typename: 'FederatedImplementingService', url: String['output'] | null, revision: String['output'], updatedAt: Timestamp['output'], activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } } | null } | null } | null } | null };

export type SubgraphInsightsSubgraphFragment = { __typename: 'FederatedImplementingService', url: String['output'] | null, revision: String['output'], updatedAt: Timestamp['output'], activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } };

export type TopNSubgraphOperationDetailsFragment = { __typename: 'SubgraphInsightsListItem', operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null };

export type TopNSubgraphClientDetailsFragment = { __typename: 'SubgraphInsightsListItem', clientName: String['output'] | null };

export type SubgraphTrafficTopOperationsFragment = { __typename: 'GraphVariant', id: ID['output'], opsByFetchRate: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null }, opsByErrorPercentage: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchErrorPercentage: Float['output'], operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null }, opsByP95: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', serviceTimeP95Ms: Float['output'] | null, operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null } };

export type SubgraphTrafficTopClientsFragment = { __typename: 'GraphVariant', id: ID['output'], clientsByFetchRate: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], clientName: String['output'] | null }> | null }, clientsByErrorPercentage: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchErrorPercentage: Float['output'], clientName: String['output'] | null }> | null }, clientsByP95: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', serviceTimeP95Ms: Float['output'] | null, clientName: String['output'] | null }> | null } };

export type SubgraphTopTrafficSourcesQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  topN: Scalars['Int']['input'];
  resolution: Resolution;
  insightsFilter?: InputMaybe<SubgraphInsightsListFilterInput>;
  forClients: Scalars['Boolean']['input'];
}>;


export type SubgraphTopTrafficSourcesQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], sparklines: { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], fetchErrorPercentage: Float['output'], serviceTimeP95Ms: Float['output'] | null } }> }, opsByFetchRate: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null }, opsByErrorPercentage: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchErrorPercentage: Float['output'], operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null }, opsByP95: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', serviceTimeP95Ms: Float['output'] | null, operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null }> | null }, clientsByFetchRate: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], clientName: String['output'] | null }> | null }, clientsByErrorPercentage: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', fetchErrorPercentage: Float['output'], clientName: String['output'] | null }> | null }, clientsByP95: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', nodes: Array<{ __typename: 'SubgraphInsightsListItem', serviceTimeP95Ms: Float['output'] | null, clientName: String['output'] | null }> | null } } | null } | null };

export type SubgraphTrafficSparkLinesFragment = { __typename: 'GraphVariant', id: ID['output'], sparklines: { __typename: 'SubgraphInsightsTimeseriesResult', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], records: Array<{ __typename: 'SubgraphInsightsTimeseriesRecord', timestamp: Timestamp['output'], data: { __typename: 'SubgraphInsightsListItem', fetchCountPerMin: Float['output'], fetchErrorPercentage: Float['output'], serviceTimeP95Ms: Float['output'] | null } }> } };

export type SubgraphsListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  filter?: InputMaybe<SubgraphInsightsListFilterInput>;
  orderBy?: InputMaybe<SubgraphInsightsListOrderByInput>;
  groupBy?: InputMaybe<Array<SubgraphInsightsListGroupByColumn> | SubgraphInsightsListGroupByColumn>;
}>;


export type SubgraphsListQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], subgraphInsightsList: { __typename: 'GraphVariantSubgraphInsightsListItemConnection', totalCount: Int['output'], subgraphs: Array<{ __typename: 'SubgraphInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, fetchCount: Long['output'], fetchCountPerMin: Float['output'], fetchErrorPercentage: Float['output'], fetchesWithErrorsCount: Long['output'], fetchesWithErrorsCountPerMin: Float['output'], operationId: ID['output'] | null, operationName: String['output'] | null, operationType: OperationType | null, serviceTimeP50Ms: Float['output'] | null, serviceTimeP90Ms: Float['output'] | null, serviceTimeP95Ms: Float['output'] | null, serviceTimeP99Ms: Float['output'] | null, subgraphId: ID['output'] | null, subgraphName: String['output'], totalDurationMs: Float['output'] | null }> | null, pageInfo: { __typename: 'SubgraphInsightsListPageInfo', startCursor: String['output'] | null, endCursor: String['output'] | null } } } | null } | null };

export type SubgraphInsightsPreflightQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type SubgraphInsightsPreflightQuery = { graph: { __typename: 'Service', id: ID['output'], lastReportedAt: Timestamp['output'] | null, variant: { __typename: 'GraphVariant', id: ID['output'], requestsInLastDay: Long['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, hasSupergraphSchema: Boolean['output'], subgraphInsightsLastReportedAt: Timestamp['output'] | null, lastReportedAgent: { __typename: 'ReportingAgent', isRouter: Boolean['output'], version: String['output'] | null } | null } | null, account: { __typename: 'Account', id: ID['output'] } | null } | null };

export type LaunchesListGraphArtifactDetailsFragment = { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } };

export type LaunchesListGraphArtifactItemFragment = { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus };

export type LaunchesListItemFragment = { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep' }
  >, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null };

export type LaunchesListFragment = { __typename: 'Launch', id: ID['output'], downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }>, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null };

export type LaunchStepStatusFragment = { __typename: 'Launch', id: ID['output'], sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep' }
  >, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null };

export type LaunchesPageQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type LaunchesPageQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorCount: Int['output'] }
            | { __typename: 'BuildSuccess' }
           | null } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null } | null } | null };

export type ManageTagsModalQueryVariables = Exact<{
  graphArtifactId: Scalars['ID']['input'];
  graphID: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ManageTagsModalQuery = { graphArtifactById: { __typename: 'GraphArtifact', id: ID['output'], tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }>, pageInfo: { __typename: 'PageInfo', endCursor: String['output'] | null, hasNextPage: Boolean['output'] } } } | null };

export type LaunchHistoryLaunchFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure', errorCount: Int['output'] }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type LaunchHistoryGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null, launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure', errorCount: Int['output'] }
        | { __typename: 'BuildSuccess' }
       | null } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
        | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceSupersededStep' }
      >, build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess' }
         | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
        | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceSupersededStep' }
      >, build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess' }
         | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null };

export type LaunchDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchDetailsQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], variant: { __typename: 'GraphVariant', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, launch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: LaunchStatus, shortenedID: String['output'], isPublished: Boolean['output'] | null, isCompleted: Boolean['output'] | null, graphId: String['output'], graphVariant: String['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null, input:
            | { __typename: 'CompositionBuildInput' }
            | { __typename: 'FilterBuildInput' }
           } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null }> | null, changeSummary: { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } } } | null } | null, results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, upstreamLaunch: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }>, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } }, tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> } } | null, buildInput:
          | { __typename: 'CompositionBuildInput' }
          | { __typename: 'FilterBuildInput' }
        , sequence: Array<
          | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null }
        >, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null } | null } | null } | null };

export type LaunchHistorySchemaDiffFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null };

export type LaunchChangelogResultFragment = { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> };

export type LaunchDetailsCardFragment = { __typename: 'Launch', id: ID['output'], isCompleted: Boolean['output'] | null, status: LaunchStatus, graphId: String['output'], graphVariant: String['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null }> | null, changeSummary: { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } } } | null } | null, build: { __typename: 'Build', id: ID['output'], input:
      | { __typename: 'CompositionBuildInput' }
      | { __typename: 'FilterBuildInput' }
    , result:
      | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
      | { __typename: 'BuildSuccess' }
     | null } | null, results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, upstreamLaunch: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> }>, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } }, tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> } } | null };

export type LaunchSchemaChangeSummaryFragment = { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } };

type LaunchSequenceStepFragment_LaunchSequenceBuildStep = { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null };

type LaunchSequenceStepFragment_LaunchSequenceCompletedStep = { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null };

type LaunchSequenceStepFragment_LaunchSequenceInitiatedStep = { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null };

type LaunchSequenceStepFragment_LaunchSequencePublishStep = { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null };

type LaunchSequenceStepFragment_LaunchSequenceSupersededStep = { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null };

export type LaunchSequenceStepFragment =
  | LaunchSequenceStepFragment_LaunchSequenceBuildStep
  | LaunchSequenceStepFragment_LaunchSequenceCompletedStep
  | LaunchSequenceStepFragment_LaunchSequenceInitiatedStep
  | LaunchSequenceStepFragment_LaunchSequencePublishStep
  | LaunchSequenceStepFragment_LaunchSequenceSupersededStep
;

export type LaunchSequenceLaunchFragment = { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, buildInput:
    | { __typename: 'CompositionBuildInput' }
    | { __typename: 'FilterBuildInput' }
  , schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null, sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null }
  >, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type LaunchBuildInputsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchBuildInputs = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] } | null, launch: { __typename: 'Launch', id: ID['output'], completedAt: Timestamp['output'] | null, buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null, subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'], routingURL: String['output'], numberOfFields: Int['output'] | null, numberOfTypes: Int['output'] | null, updatedAt: Timestamp['output'] | null, revision: String['output'] | null }> }
          | { __typename: 'FilterBuildInput', schemaHash: String['output'], filterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
         } | null } | null } | null };

export type FetchAndViewSchemaModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type FetchAndViewSchemaModalQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type LaunchHistoryListItemFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure', errorCount: Int['output'] }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type LaunchSupergraphDiffViewerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchSupergraphDiffViewerQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type NewLaunchesListGraphArtifactDetailsFragment = { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } };

export type NewLaunchesListItemFragment = { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep' }
  >, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null };

export type NewLaunchesListFragment = { __typename: 'Launch', id: ID['output'], downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }>, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null };

export type NewLaunchStepStatusFragment = { __typename: 'Launch', id: ID['output'], sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep' }
  >, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null };

export type NewLaunchHistoryLaunchFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type NewLaunchHistoryGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null, derivedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> | null, launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
        | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceSupersededStep' }
      >, build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess' }
         | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
        | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
        | { __typename: 'LaunchSequenceSupersededStep' }
      >, build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess' }
         | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null };

export type NewLaunchesPageQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type NewLaunchesPageQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess' }
           | null } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null, derivedVariants: Array<{ __typename: 'GraphVariant', id: ID['output'] }> | null } | null } | null };

export type NewLaunchDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type NewLaunchDetailsQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], variant: { __typename: 'GraphVariant', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] } | null, launch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, status: LaunchStatus, shortenedID: String['output'], isPublished: Boolean['output'] | null, isCompleted: Boolean['output'] | null, graphId: String['output'], graphVariant: String['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null, input:
            | { __typename: 'CompositionBuildInput' }
            | { __typename: 'FilterBuildInput' }
           } | null, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null }> | null, changeSummary: { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } } } | null } | null, results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }>, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } }, tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> } } | null, buildInput:
          | { __typename: 'CompositionBuildInput' }
          | { __typename: 'FilterBuildInput' }
        , sequence: Array<
          | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
          | { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null }
        > } | null } | null } | null };

export type NewLaunchHistorySchemaDiffFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null };

export type LaunchDetailsTabsBuildInputsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchDetailsTabsBuildInputs = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], completedAt: Timestamp['output'] | null, buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null, subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'], routingURL: String['output'] }> }
          | { __typename: 'FilterBuildInput', schemaHash: String['output'], filterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
         } | null } | null } | null };

export type LaunchDetailsTabsSupergraphSchemaVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchDetailsTabsSupergraphSchema = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type NewLaunchChangelogResultFragment = { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> };

export type NewLaunchDetailsCardFragment = { __typename: 'Launch', id: ID['output'], isCompleted: Boolean['output'] | null, status: LaunchStatus, graphId: String['output'], graphVariant: String['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null, changes: Array<{ __typename: 'ChangeOnOperation', semanticChange: { __typename: 'SemanticChange', definition: { __typename: 'ChangeDefinition', code: ChangeCode, category: ChangeCategory }, parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null, kind: IntrospectionTypeKind | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null } }> | null }> | null, changeSummary: { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } } } | null } | null, build: { __typename: 'Build', id: ID['output'], input:
      | { __typename: 'CompositionBuildInput' }
      | { __typename: 'FilterBuildInput' }
    , result:
      | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
      | { __typename: 'BuildSuccess' }
     | null } | null, results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }>, supersededBy: { __typename: 'Launch', id: ID['output'] } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], results: Array<{ __typename: 'ChangelogLaunchResult', schemaTagID: ID['output'] }> }>, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } }, tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> } } | null };

export type NewLaunchSchemaChangeSummaryFragment = { __typename: 'ChangeSummary', type: { __typename: 'TypeChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] }, field: { __typename: 'FieldChangeSummaryCounts', additions: Int['output'], removals: Int['output'], edits: Int['output'] } };

type NewLaunchSequenceStepFragment_LaunchSequenceBuildStep = { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null };

type NewLaunchSequenceStepFragment_LaunchSequenceCompletedStep = { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null };

type NewLaunchSequenceStepFragment_LaunchSequenceInitiatedStep = { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null };

type NewLaunchSequenceStepFragment_LaunchSequencePublishStep = { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null };

type NewLaunchSequenceStepFragment_LaunchSequenceSupersededStep = { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null };

export type NewLaunchSequenceStepFragment =
  | NewLaunchSequenceStepFragment_LaunchSequenceBuildStep
  | NewLaunchSequenceStepFragment_LaunchSequenceCompletedStep
  | NewLaunchSequenceStepFragment_LaunchSequenceInitiatedStep
  | NewLaunchSequenceStepFragment_LaunchSequencePublishStep
  | NewLaunchSequenceStepFragment_LaunchSequenceSupersededStep
;

export type NewLaunchSequenceLaunchFragment = { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], status: LaunchStatus, build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess' }
     | null } | null, buildInput:
    | { __typename: 'CompositionBuildInput' }
    | { __typename: 'FilterBuildInput' }
  , schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null, sequence: Array<
    | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
    | { __typename: 'LaunchSequenceSupersededStep', completedAt: Timestamp['output'] | null }
  >, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], status: GraphArtifactStatus, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type LaunchHistoryTableLaunchFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type LaunchHistoryTableRowFragment = { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
      | { __typename: 'LaunchSequenceSupersededStep' }
    >, build: { __typename: 'Build', id: ID['output'], result:
        | { __typename: 'BuildFailure' }
        | { __typename: 'BuildSuccess' }
       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> };

export type PrimingScanQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type PrimingScanQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess' }
           | null } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null } | null } | null };

export type LaunchesPageLaunchByIdQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type LaunchesPageLaunchByIdQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess' }
           | null } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> } | null } | null } | null };

export type LaunchesPageDeepSearchScanQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type LaunchesPageDeepSearchScanQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launchHistory: Array<{ __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess' }
           | null } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
            | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
            | { __typename: 'LaunchSequenceSupersededStep' }
          >, build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess' }
             | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> }> | null } | null } | null };

export type LaunchesPageTagLookupQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  tag: Scalars['String']['input'];
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type LaunchesPageTagLookupQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], graphArtifactTag: { __typename: 'GraphArtifactTag', tag: String['output'], graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], content: { __typename: 'GraphArtifactContent', launch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
                  | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceSupersededStep' }
                >, build: { __typename: 'Build', id: ID['output'], result:
                    | { __typename: 'BuildFailure' }
                    | { __typename: 'BuildSuccess' }
                   | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, build: { __typename: 'Build', id: ID['output'], result:
                  | { __typename: 'BuildFailure' }
                  | { __typename: 'BuildSuccess' }
                 | null } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
                  | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                  | { __typename: 'LaunchSequenceSupersededStep' }
                >, build: { __typename: 'Build', id: ID['output'], result:
                    | { __typename: 'BuildFailure' }
                    | { __typename: 'BuildSuccess' }
                   | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> } } } } | null } | null } | null };

export type LaunchesPageVariantTagOptionsQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  includeGraphArtifactTags: Scalars['Boolean']['input'];
}>;


export type LaunchesPageVariantTagOptionsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], graphArtifactTags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'], graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], content: { __typename: 'GraphArtifactContent', launch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isPublished: Boolean['output'] | null, status: LaunchStatus, subgraphChanges: Array<{ __typename: 'SubgraphChange', name: ID['output'], type: SubgraphChangeType }> | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity, numberOfAffectedOperations: Int['output'] } | null } | null, supersededBy: { __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
                      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceSupersededStep' }
                    >, build: { __typename: 'Build', id: ID['output'], result:
                        | { __typename: 'BuildFailure' }
                        | { __typename: 'BuildSuccess' }
                       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null } | null, upstreamLaunch: { __typename: 'Launch', id: ID['output'], shortenedID: String['output'] } | null, graphArtifact: { __typename: 'GraphArtifact', id: ID['output'], digest: String['output'] | null, status: GraphArtifactStatus, location: { __typename: 'GraphArtifactLocation', uri: String['output'] } | null, tags?: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }> }, graphVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'] } } } | null, build: { __typename: 'Build', id: ID['output'], result:
                      | { __typename: 'BuildFailure' }
                      | { __typename: 'BuildSuccess' }
                     | null } | null, downstreamLaunches: Array<{ __typename: 'Launch', id: ID['output'], graphId: String['output'], graphVariant: String['output'], shortenedID: String['output'], sequence: Array<
                      | { __typename: 'LaunchSequenceBuildStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceCompletedStep', completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceInitiatedStep', startedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequencePublishStep', startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null }
                      | { __typename: 'LaunchSequenceSupersededStep' }
                    >, build: { __typename: 'Build', id: ID['output'], result:
                        | { __typename: 'BuildFailure' }
                        | { __typename: 'BuildSuccess' }
                       | null } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'], diffToPrevious: { __typename: 'SchemaDiff', severity: ChangeSeverity } | null } | null }> } } } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: Boolean['output'], endCursor: String['output'] | null } } } | null } | null };

export type NewLaunchSupergraphDiffViewerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type NewLaunchSupergraphDiffViewerQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type OperationsPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isOperationLandingPage: Scalars['Boolean']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type OperationsPageQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], hasManagedSubgraphs: Boolean['output'] | null, hasSupergraphSchema: Boolean['output'], url: String['output'] | null, requestsInLastDay: Long['output'] | null } | null, account: { __typename: 'Account', id: ID['output'] } | null, operation?: { __typename: 'Operation', id: ID['output'], name: String['output'] | null, signature: String['output'] | null } | null } | null };

export type OperationsPageHeavyQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isOperationLandingPage: Scalars['Boolean']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type OperationsPageHeavyQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, lastReportedAt: Timestamp['output'] | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasManagedSubgraphs: Boolean['output'] | null, hasSupergraphSchema: Boolean['output'], url: String['output'] | null } | null, account: { __typename: 'Account', id: ID['output'] } | null, operation?: { __typename: 'Operation', id: ID['output'], name: String['output'] | null, signature: String['output'] | null } | null } | null };

export type FieldsListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<FieldInsightsListFilterInput>;
  orderBy?: InputMaybe<FieldInsightsListOrderByInput>;
}>;


export type FieldsListQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], fieldInsightsList: { __typename: 'GraphVariantFieldInsightsListItemConnection', totalCount: Int['output'], fields: Array<{ __typename: 'FieldInsightsListItem', parentType: String['output'], fieldName: String['output'], referencingOperationCount: Long['output'] | null, referencingOperationCountPerMin: Float['output'] | null, executionCount: Long['output'] | null, estimatedExecutionCount: Long['output'] | null, errorCount: Long['output'] | null, errorCountPerMin: Float['output'] | null, errorPercentage: Float['output'] | null, p50LatencyMs: Float['output'] | null, p90LatencyMs: Float['output'] | null, p95LatencyMs: Float['output'] | null, p99LatencyMs: Float['output'] | null }> | null, pageInfo: { __typename: 'FieldInsightsListPageInfo', startCursor: String['output'] | null, endCursor: String['output'] | null } } } | null } | null };

export type UI__OperationsListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  filter?: InputMaybe<OperationInsightsListFilterInput>;
  orderBy?: InputMaybe<OperationInsightsListOrderByInput>;
}>;


export type UI__OperationsListQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], operationInsightsList: { __typename: 'GraphVariantOperationInsightsListItemConnection', totalCount: Int['output'], operations: Array<{ __typename: 'OperationInsightsListItem', id: ID['output'], name: String['output'] | null, displayName: String['output'], type: OperationType | null, requestCount: Long['output'], requestCountPerMin: Float['output'], errorCount: Long['output'], errorCountPerMin: Float['output'], errorPercentage: Float['output'], cacheHitRate: Float['output'], cacheTtlP50Ms: Float['output'] | null, serviceTimeP50Ms: Float['output'] | null, serviceTimeP90Ms: Float['output'] | null, serviceTimeP95Ms: Float['output'] | null, serviceTimeP99Ms: Float['output'] | null, totalDurationMs: Float['output'] | null, signatureBytes: Long['output'] | null }> | null, pageInfo: { __typename: 'OperationInsightsListPageInfo', startCursor: String['output'] | null, endCursor: String['output'] | null } } } | null } | null };

export type CoordinateInsightsListItemFragment = { __typename: 'CoordinateInsightsListItem', namedType: String['output'], namedAttribute: String['output'], referencingOperationCount: Long['output'] | null, referencingOperationCountPerMin: Float['output'] | null, executionCount: Long['output'] | null, estimatedExecutionCount: Long['output'] | null };

export type FieldInsightsEmptyStateQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type FieldInsightsEmptyStateQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], routerLastSeenAt: Timestamp['output'] | null, fieldUsageLastReportedAt: Timestamp['output'] | null, fieldExecutionsLastReportedAt: Timestamp['output'] | null, extendedRefsUsage: { __typename: 'ExtendedRefsUsage', firstSeenAt: Timestamp['output'] | null, lastSeenAt: Timestamp['output'] | null } } | null } | null };

export type LastReportedQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type LastReportedQuery = { service: { __typename: 'Service', id: ID['output'], lastReportedAt: Timestamp['output'] | null } | null };

export type CoordinateListQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<CoordinateInsightsListFilterInput>;
  orderBy?: InputMaybe<CoordinateInsightsListOrderByInput>;
}>;


export type CoordinateListQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], coordinateInsightsList: { __typename: 'GraphVariantCoordinateInsightsListItemConnection', totalCount: Int['output'], coordinates: Array<{ __typename: 'CoordinateInsightsListItem', namedType: String['output'], namedAttribute: String['output'], referencingOperationCount: Long['output'] | null, referencingOperationCountPerMin: Float['output'] | null, executionCount: Long['output'] | null, estimatedExecutionCount: Long['output'] | null }> | null, pageInfo: { __typename: 'CoordinateInsightsListPageInfo', startCursor: String['output'] | null, endCursor: String['output'] | null } } } | null } | null };

export type OperationDetailsSignatureQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type OperationDetailsSignatureQuery = { service: { __typename: 'Service', id: ID['output'], operation: { __typename: 'Operation', id: ID['output'], signature: String['output'] | null } | null } | null };

export type OperationDetailsQueryPlanQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  document: Scalars['GraphQLDocument']['input'];
  includePlan: Scalars['Boolean']['input'];
}>;


export type OperationDetailsQueryPlanQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], compositionVersion: String['output'] | null, plan?: { __typename: 'QueryPlan', object: Object['output'], text: String['output'] } | null } | null } | null };

export type ErrorInsightsListItemFragment = { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, errorCount: Long['output'], operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null, severity: ErrorInsightsSeverity | null };

export type ErrorInsightsTimeseriesRecordFragment = { __typename: 'ErrorInsightsTimeseriesRecord', timestamp: Timestamp['output'], strategy: ErrorInsightsStrategy, data: { __typename: 'ErrorInsightsListItem', code: String['output'] | null, service: String['output'] | null, clientName: String['output'] | null, errorCount: Long['output'] } };

export type ErrorInsightsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  resolution: Resolution;
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  legendFilter?: InputMaybe<ErrorInsightsListFilterInput>;
  statsWindowFilter?: InputMaybe<ServiceQueryStatsFilter>;
  groupBy?: InputMaybe<Array<ErrorInsightsListGroupByColumn> | ErrorInsightsListGroupByColumn>;
  timeseriesGroupBy: ErrorInsightsListGroupByColumn;
}>;


export type ErrorInsightsQuery = { graph: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', roundedUpTo: Timestamp['output'], roundedDownFrom: Timestamp['output'], queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'], requestsWithErrorsCount: Long['output'] } }> } | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasManagedSubgraphs: Boolean['output'] | null, hasSupergraphSchema: Boolean['output'], errorInsightsList: { __typename: 'GraphVariantErrorInsightsListItemConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphVariantErrorInsightsListItemEdge', cursor: String['output'], node: { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, errorCount: Long['output'], operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null, severity: ErrorInsightsSeverity | null } | null }> | null, pageInfo: { __typename: 'ErrorInsightsListPageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null } }, legendItems: { __typename: 'GraphVariantErrorInsightsListItemConnection', edges: Array<{ __typename: 'GraphVariantErrorInsightsListItemEdge', node: { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, errorCount: Long['output'], operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null, severity: ErrorInsightsSeverity | null } | null }> | null }, errorInsightsTimeseries: { __typename: 'ErrorInsightsTimeseriesResult', roundedDownFrom: Timestamp['output'], roundedUpTo: Timestamp['output'], totalErrors: Int['output'], records: Array<{ __typename: 'ErrorInsightsTimeseriesRecord', timestamp: Timestamp['output'], strategy: ErrorInsightsStrategy, data: { __typename: 'ErrorInsightsListItem', code: String['output'] | null, service: String['output'] | null, clientName: String['output'] | null, errorCount: Long['output'] } }> } } | null } | null };

export type UI__ErroredTracePathsQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  resolution: Resolution;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  errorFilter?: InputMaybe<ServiceErrorStatsFilter>;
  queryFilter?: InputMaybe<ServiceQueryStatsFilter>;
  noFilter: Scalars['Boolean']['input'];
}>;


export type UI__ErroredTracePathsQuery = { service: { __typename: 'Service', id: ID['output'], counts?: { __typename: 'ServiceStatsWindow', errorStats: Array<{ __typename: 'ServiceErrorStatsRecord', metrics: { __typename: 'ServiceErrorStatsMetrics', errorsCount: Long['output'], requestsWithErrorsCount: Long['output'] }, group: { __typename: 'ServiceErrorStatsDimensions', path: String['output'] | null } }> } | null, histograms: { __typename: 'ServiceStatsWindow', queryStats?: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], uncachedRequestsCount: Long['output'], cachedRequestsCount: Long['output'] } }> } | null } | null };

export type ErrorInsightsBreakdownItemFragment = { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, errorCount: Long['output'], operationCount?: Long['output'] | null, operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null, severity: ErrorInsightsSeverity | null, traceRefs: { __typename: 'ErrorTraceRefsResult', totalCount: Int['output'], items: Array<{ __typename: 'ErrorTraceRef', traceId: String['output'], operationId: String['output'], errorMessage: String['output'] | null, timestamp: Timestamp['output'] }> } | null };

export type ErrorInsightsBreakdownQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  first: Scalars['Int']['input'];
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  groupBy?: InputMaybe<Array<ErrorInsightsListGroupByColumn> | ErrorInsightsListGroupByColumn>;
  isOverview: Scalars['Boolean']['input'];
  traceRefsLimit: Scalars['Int']['input'];
}>;


export type ErrorInsightsBreakdownQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], errorInsightsList: { __typename: 'GraphVariantErrorInsightsListItemConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphVariantErrorInsightsListItemEdge', cursor: String['output'], node: { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, errorCount: Long['output'], operationCount?: Long['output'] | null, operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null, severity: ErrorInsightsSeverity | null, traceRefs: { __typename: 'ErrorTraceRefsResult', totalCount: Int['output'], items: Array<{ __typename: 'ErrorTraceRef', traceId: String['output'], operationId: String['output'], errorMessage: String['output'] | null, timestamp: Timestamp['output'] }> } | null } | null }> | null, pageInfo: { __typename: 'ErrorInsightsListPageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null } } } | null } | null };

export type ErrorInsightsOperationStatsFragment = { __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalRequestCount: Long['output'], requestsWithErrorsCount: Long['output'] } };

export type ErrorInsightsFilterFragment = { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null };

export type ErrorInsightsFilterQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  groupBy?: InputMaybe<Array<ErrorInsightsListGroupByColumn> | ErrorInsightsListGroupByColumn>;
}>;


export type ErrorInsightsFilterQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], errorInsightsList: { __typename: 'GraphVariantErrorInsightsListItemConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphVariantErrorInsightsListItemEdge', cursor: String['output'], node: { __typename: 'ErrorInsightsListItem', clientName: String['output'] | null, clientVersion: String['output'] | null, code: String['output'] | null, operationId: String['output'] | null, operationName: String['output'] | null, path: String['output'] | null, service: String['output'] | null } | null }> | null, pageInfo: { __typename: 'ErrorInsightsListPageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null } } } | null } | null };

export type ErrorInsightsOpItemFragment = { __typename: 'ErrorInsightsListItem', errorCount: Long['output'], operationId: String['output'] | null, operationName: String['output'] | null, traceRefs: { __typename: 'ErrorTraceRefsResult', totalCount: Int['output'], items: Array<{ __typename: 'ErrorTraceRef', traceId: String['output'], operationId: String['output'], errorMessage: String['output'] | null, timestamp: Timestamp['output'] }> } | null };

export type ErrorInsightsOpDrilldownQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  first: Scalars['Int']['input'];
  filter?: InputMaybe<ErrorInsightsListFilterInput>;
  groupBy?: InputMaybe<Array<ErrorInsightsListGroupByColumn> | ErrorInsightsListGroupByColumn>;
  traceRefsLimit: Scalars['Int']['input'];
}>;


export type ErrorInsightsOpDrilldownQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], errorInsightsList: { __typename: 'GraphVariantErrorInsightsListItemConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphVariantErrorInsightsListItemEdge', cursor: String['output'], node: { __typename: 'ErrorInsightsListItem', errorCount: Long['output'], operationId: String['output'] | null, operationName: String['output'] | null, traceRefs: { __typename: 'ErrorTraceRefsResult', totalCount: Int['output'], items: Array<{ __typename: 'ErrorTraceRef', traceId: String['output'], operationId: String['output'], errorMessage: String['output'] | null, timestamp: Timestamp['output'] }> } | null } | null }> | null, pageInfo: { __typename: 'ErrorInsightsListPageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null } } } | null } | null };

export type ErrorTraceRefFragment = { __typename: 'ErrorTraceRef', traceId: String['output'], operationId: String['output'], errorMessage: String['output'] | null, timestamp: Timestamp['output'] };

export type RouterLastSeenAtQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type RouterLastSeenAtQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], routerLastSeenAt: Timestamp['output'] | null } | null } | null };

export type UI__ServiceReportQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  resolution: Resolution;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<ServiceQueryStatsFilter>;
}>;


export type UI__ServiceReportQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', uncachedHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'], sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null }, cachedHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'], sparseBuckets: Array<Long['output']>, p50: Float['output'] | null, p90: Float['output'] | null, p95: Float['output'] | null } } }> } | null } | null };

export type QueryTraceHistogramQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  histogramFilter?: InputMaybe<ServiceQueryStatsFilter>;
  traceRefsFilter?: InputMaybe<ServiceTraceRefsFilter>;
  noFilter: Scalars['Boolean']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
}>;


export type QueryTraceHistogramQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', queryStats?: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', uncachedHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']> }, cachedHistogram: { __typename: 'DurationHistogram', sparseBuckets: Array<Long['output']> } } }>, traceRefs?: Array<{ __typename: 'ServiceTraceRefsRecord', group: { __typename: 'ServiceTraceRefsDimensions', durationBucket: Int['output'] | null } }> } | null } | null };

export type DurationToTraceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  filter?: InputMaybe<ServiceTraceRefsFilter>;
  noFilter: Scalars['Boolean']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
}>;


export type DurationToTraceQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', traceRefs?: Array<{ __typename: 'ServiceTraceRefsRecord', group: { __typename: 'ServiceTraceRefsDimensions', generatedTraceId: String['output'] | null, durationBucket: Int['output'] | null } }> } | null } | null };

export type QueryTraceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  traceId: Scalars['ID']['input'];
}>;


export type QueryTraceQuery = { service: { __typename: 'Service', id: ID['output'], trace: { __typename: 'Trace', id: ID['output'], startTime: Timestamp['output'], endTime: Timestamp['output'], operationName: String['output'] | null, cacheMaxAgeMs: Float['output'] | null, isIncomplete: Boolean['output'], agentVersion: String['output'] | null, clientName: String['output'] | null, clientVersion: String['output'] | null, durationMs: Float['output'], cacheScope: CacheScope | null, signature: String['output'], unexecutedOperationName: String['output'] | null, unexecutedOperationBody: String['output'] | null, root: { __typename: 'TraceNode', id: ID['output'], kind: TraceNodeKind, subgraphName: String['output'] | null, parentId: ID['output'] | null, startTime: Timestamp['output'], endTime: Timestamp['output'], isFetch: Boolean['output'], isDeferredFetch: Boolean['output'], subgraphStartTime: Timestamp['output'] | null, subgraphEndTime: Timestamp['output'] | null, childCount: Int['output'], childrenAreTruncated: Boolean['output'], cacheMaxAgeMs: Float['output'] | null, key: StringOrInt['output'] | null, type: String['output'] | null, cacheScope: CacheScope | null, descendants: Array<{ __typename: 'TraceNode', id: ID['output'], kind: TraceNodeKind, subgraphName: String['output'] | null, parentId: ID['output'] | null, startTime: Timestamp['output'], endTime: Timestamp['output'], isFetch: Boolean['output'], isDeferredFetch: Boolean['output'], subgraphStartTime: Timestamp['output'] | null, subgraphEndTime: Timestamp['output'] | null, childCount: Int['output'], childrenAreTruncated: Boolean['output'], cacheMaxAgeMs: Float['output'] | null, key: StringOrInt['output'] | null, type: String['output'] | null, cacheScope: CacheScope | null, attributes: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, errors: Array<{ __typename: 'TraceError', message: String['output'], timestamp: Timestamp['output'] | null, locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> }> }>, attributes: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, errors: Array<{ __typename: 'TraceError', message: String['output'], timestamp: Timestamp['output'] | null, locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> }> }, http: { __typename: 'TraceHTTP', statusCode: Int['output'], requestHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, responseHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> } | null, variables: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> } | null } | null };

export type TraceNodeErrorFragment = { __typename: 'TraceError', message: String['output'], locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> };

export type TraceNodeFragment = { __typename: 'TraceNode', id: ID['output'], kind: TraceNodeKind, subgraphName: String['output'] | null, parentId: ID['output'] | null, startTime: Timestamp['output'], endTime: Timestamp['output'], isFetch: Boolean['output'], isDeferredFetch: Boolean['output'], subgraphStartTime: Timestamp['output'] | null, subgraphEndTime: Timestamp['output'] | null, childCount: Int['output'], childrenAreTruncated: Boolean['output'], cacheMaxAgeMs: Float['output'] | null, key: StringOrInt['output'] | null, type: String['output'] | null, attributes: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, errors: Array<{ __typename: 'TraceError', message: String['output'], locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> }> };

export type TraceFragment = { __typename: 'Trace', id: ID['output'], startTime: Timestamp['output'], endTime: Timestamp['output'], operationName: String['output'] | null, cacheMaxAgeMs: Float['output'] | null, isIncomplete: Boolean['output'], agentVersion: String['output'] | null, root: { __typename: 'TraceNode', id: ID['output'], kind: TraceNodeKind, subgraphName: String['output'] | null, parentId: ID['output'] | null, startTime: Timestamp['output'], endTime: Timestamp['output'], isFetch: Boolean['output'], isDeferredFetch: Boolean['output'], subgraphStartTime: Timestamp['output'] | null, subgraphEndTime: Timestamp['output'] | null, childCount: Int['output'], childrenAreTruncated: Boolean['output'], cacheMaxAgeMs: Float['output'] | null, key: StringOrInt['output'] | null, type: String['output'] | null, descendants: Array<{ __typename: 'TraceNode', id: ID['output'], kind: TraceNodeKind, subgraphName: String['output'] | null, parentId: ID['output'] | null, startTime: Timestamp['output'], endTime: Timestamp['output'], isFetch: Boolean['output'], isDeferredFetch: Boolean['output'], subgraphStartTime: Timestamp['output'] | null, subgraphEndTime: Timestamp['output'] | null, childCount: Int['output'], childrenAreTruncated: Boolean['output'], cacheMaxAgeMs: Float['output'] | null, key: StringOrInt['output'] | null, type: String['output'] | null, attributes: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, errors: Array<{ __typename: 'TraceError', message: String['output'], locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> }> }>, attributes: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, errors: Array<{ __typename: 'TraceError', message: String['output'], locations: Array<{ __typename: 'TraceSourceLocation', line: Int['output'], column: Int['output'] }> }> } };

export type QueryTraceSummaryCardFragment = { __typename: 'Trace', id: ID['output'], agentVersion: String['output'] | null, clientName: String['output'] | null, clientVersion: String['output'] | null, startTime: Timestamp['output'], durationMs: Float['output'], cacheMaxAgeMs: Float['output'] | null, cacheScope: CacheScope | null, signature: String['output'], operationName: String['output'] | null, unexecutedOperationName: String['output'] | null, unexecutedOperationBody: String['output'] | null, root: { __typename: 'TraceNode', cacheScope: CacheScope | null, descendants: Array<{ __typename: 'TraceNode', cacheScope: CacheScope | null, errors: Array<{ __typename: 'TraceError', message: String['output'], timestamp: Timestamp['output'] | null }> }>, errors: Array<{ __typename: 'TraceError', message: String['output'], timestamp: Timestamp['output'] | null }> }, http: { __typename: 'TraceHTTP', statusCode: Int['output'], requestHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, responseHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> } | null, variables: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> };

export type QueryTraceSummaryCardNodeFragment = { __typename: 'TraceNode', cacheScope: CacheScope | null, errors: Array<{ __typename: 'TraceError', message: String['output'], timestamp: Timestamp['output'] | null }> };

export type QueryTraceInspectorTraceFragment = { __typename: 'Trace', id: ID['output'], signature: String['output'], operationName: String['output'] | null, unexecutedOperationName: String['output'] | null, unexecutedOperationBody: String['output'] | null, http: { __typename: 'TraceHTTP', statusCode: Int['output'], requestHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }>, responseHeaders: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> } | null, variables: Array<{ __typename: 'StringToString', key: String['output'], value: String['output'] }> };

export type SaveCollectionEntryFromOperationsPaneQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type SaveCollectionEntryFromOperationsPaneQuery = { service: { __typename: 'Service', id: ID['output'], operation: { __typename: 'Operation', id: ID['output'], name: String['output'] | null, signature: String['output'] | null } | null } | null };

export type UseMentionUsersServiceFragment = { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'] } }> | null } | null };

export type DiffSummarySummaryFragment = { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] };

export type DiffSummaryDiffFragment = { __typename: 'FlatDiff', id: ID['output'], summary: { __typename: 'FlatDiffSummary', object: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, directive: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, enum: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, input: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, interface: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, scalar: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, schema: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, union: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] } } };

export type ProposalLayoutGraphQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ProposalLayoutGraphQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], defaultProposalReviewers: Array<
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', id: ID['output'] }
     | null>, variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], url: String['output'] | null, isProposal: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, compositionVersion: String['output'] | null, proposal: { __typename: 'Proposal', id: ID['output'], displayName: String['output'], status: ProposalStatus, canEditProposal: Boolean['output'], mergeBaseCompositionId: ID['output'] | null, hasUpstreamChanges: Boolean['output'], rebaseConflicts:
          | { __typename: 'NotFoundError' }
          | { __typename: 'RebaseConflictData', count: Int['output'] }
          | { __typename: 'SchemaValidationError' }
         | null, requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', user:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', id: ID['output'] }
           | null, currentReview: { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, isDismissed: Boolean['output'] } | null } | null>, reviews: Array<{ __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, createdAt: Timestamp['output'], isDismissed: Boolean['output'], comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'] } | null, createdBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', id: ID['output'] }
           | null }>, latestRevision: { __typename: 'ProposalRevision', id: ID['output'] }, createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', id: ID['output'] }
         | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], compositionVersion: String['output'] | null } } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], historyLength: Int['output'] } | null } | null, account: { __typename: 'Account', id: ID['output'] } | null } | null };

export type RequestedReviewersSectionMembershipsVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type RequestedReviewersSectionMemberships = { service: { __typename: 'Service', id: ID['output'], minProposalApprovers: Int['output'], account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null } }> | null } | null } | null };

export type ProposalLayoutUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ProposalLayoutUserQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', internalAdminRole: InternalMdgAdminRole | null, id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

type FlatDiffItemFragment_FlatDiffAddArgument = { __typename: 'FlatDiffAddArgument', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddDirective = { __typename: 'FlatDiffAddDirective', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddDirectiveUsage = { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddEnum = { __typename: 'FlatDiffAddEnum', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddEnumValue = { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddField = { __typename: 'FlatDiffAddField', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddImplementation = { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddInput = { __typename: 'FlatDiffAddInput', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddInterface = { __typename: 'FlatDiffAddInterface', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddObject = { __typename: 'FlatDiffAddObject', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddScalar = { __typename: 'FlatDiffAddScalar', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddSchemaDefinition = { __typename: 'FlatDiffAddSchemaDefinition' };

type FlatDiffItemFragment_FlatDiffAddSchemaDirectiveUsage = { __typename: 'FlatDiffAddSchemaDirectiveUsage' };

type FlatDiffItemFragment_FlatDiffAddSchemaRootOperation = { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] };

type FlatDiffItemFragment_FlatDiffAddUnion = { __typename: 'FlatDiffAddUnion', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddUnionMember = { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffAddValidLocation = { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffChangeArgumentDefault = { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffChangeDescription = { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffChangeDirectiveRepeatable = { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffChangeInputFieldDefault = { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffChangeSchemaDescription = { __typename: 'FlatDiffChangeSchemaDescription' };

type FlatDiffItemFragment_FlatDiffRemoveArgument = { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveDirective = { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveDirectiveUsage = { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveEnum = { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveEnumValue = { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveField = { __typename: 'FlatDiffRemoveField', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveImplementation = { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveInput = { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveInterface = { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveObject = { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveScalar = { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveSchemaDefinition = { __typename: 'FlatDiffRemoveSchemaDefinition' };

type FlatDiffItemFragment_FlatDiffRemoveSchemaDirectiveUsage = { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' };

type FlatDiffItemFragment_FlatDiffRemoveSchemaRootOperation = { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveUnion = { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveUnionMember = { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] };

type FlatDiffItemFragment_FlatDiffRemoveValidLocation = { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] };

export type FlatDiffItemFragment =
  | FlatDiffItemFragment_FlatDiffAddArgument
  | FlatDiffItemFragment_FlatDiffAddDirective
  | FlatDiffItemFragment_FlatDiffAddDirectiveUsage
  | FlatDiffItemFragment_FlatDiffAddEnum
  | FlatDiffItemFragment_FlatDiffAddEnumValue
  | FlatDiffItemFragment_FlatDiffAddField
  | FlatDiffItemFragment_FlatDiffAddImplementation
  | FlatDiffItemFragment_FlatDiffAddInput
  | FlatDiffItemFragment_FlatDiffAddInterface
  | FlatDiffItemFragment_FlatDiffAddObject
  | FlatDiffItemFragment_FlatDiffAddScalar
  | FlatDiffItemFragment_FlatDiffAddSchemaDefinition
  | FlatDiffItemFragment_FlatDiffAddSchemaDirectiveUsage
  | FlatDiffItemFragment_FlatDiffAddSchemaRootOperation
  | FlatDiffItemFragment_FlatDiffAddUnion
  | FlatDiffItemFragment_FlatDiffAddUnionMember
  | FlatDiffItemFragment_FlatDiffAddValidLocation
  | FlatDiffItemFragment_FlatDiffChangeArgumentDefault
  | FlatDiffItemFragment_FlatDiffChangeDescription
  | FlatDiffItemFragment_FlatDiffChangeDirectiveRepeatable
  | FlatDiffItemFragment_FlatDiffChangeInputFieldDefault
  | FlatDiffItemFragment_FlatDiffChangeSchemaDescription
  | FlatDiffItemFragment_FlatDiffRemoveArgument
  | FlatDiffItemFragment_FlatDiffRemoveDirective
  | FlatDiffItemFragment_FlatDiffRemoveDirectiveUsage
  | FlatDiffItemFragment_FlatDiffRemoveEnum
  | FlatDiffItemFragment_FlatDiffRemoveEnumValue
  | FlatDiffItemFragment_FlatDiffRemoveField
  | FlatDiffItemFragment_FlatDiffRemoveImplementation
  | FlatDiffItemFragment_FlatDiffRemoveInput
  | FlatDiffItemFragment_FlatDiffRemoveInterface
  | FlatDiffItemFragment_FlatDiffRemoveObject
  | FlatDiffItemFragment_FlatDiffRemoveScalar
  | FlatDiffItemFragment_FlatDiffRemoveSchemaDefinition
  | FlatDiffItemFragment_FlatDiffRemoveSchemaDirectiveUsage
  | FlatDiffItemFragment_FlatDiffRemoveSchemaRootOperation
  | FlatDiffItemFragment_FlatDiffRemoveUnion
  | FlatDiffItemFragment_FlatDiffRemoveUnionMember
  | FlatDiffItemFragment_FlatDiffRemoveValidLocation
;

export type UseChangedSubgraphHashesFirstLaunchFragment = { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
    | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
    | { __typename: 'FilterBuildInput' }
  , build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
     | null } | null };

export type UseMultipleDiffsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  newHash?: InputMaybe<Scalars['SHA256']['input']>;
  oldHash?: InputMaybe<Scalars['SHA256']['input']>;
}>;


export type UseMultipleDiffsQuery = { service: { __typename: 'Service', id: ID['output'], flatDiff:
      | { __typename: 'FlatDiff', id: ID['output'], diff: Array<
          | { __typename: 'FlatDiffAddArgument', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddField', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage', value: String['output'] }
          | { __typename: 'FlatDiffAddSchemaRootOperation', value: String['output'], rootType: String['output'] }
          | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveField', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage', value: String['output'] }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
          | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'], value: String['output'] }
          | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'], value: String['output'] }
        > }
      | { __typename: 'NotFoundError' }
      | { __typename: 'SchemaValidationError' }
     } | null };

export type ImplementedChangesFragment = { __typename: 'Proposal', id: ID['output'], implementedChanges: Array<{ __typename: 'ProposalImplementedChange', launchId: ID['output'], subgraph: String['output'], diffItem:
      | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddSchemaDefinition' }
      | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
      | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
      | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
      | { __typename: 'FlatDiffChangeSchemaDescription' }
      | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveSchemaDefinition' }
      | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
      | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
      | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
      | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
     }> };

export type ChangesDiffsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  newSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
  oldSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
  hasOldSdlHash: Scalars['Boolean']['input'];
  hasNewSdlHash: Scalars['Boolean']['input'];
}>;


export type ChangesDiffsQuery = { service: { __typename: 'Service', id: ID['output'], oldDoc?: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null, newDoc?: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null, flatDiff:
      | { __typename: 'FlatDiff', id: ID['output'], diff: Array<
          | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
          | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
          | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
        >, summary: { __typename: 'FlatDiffSummary', object: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, directive: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, enum: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, input: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, interface: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, scalar: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, schema: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, union: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] } } }
      | { __typename: 'NotFoundError' }
      | { __typename: 'SchemaValidationError' }
     } | null };

export type ProposalRevisionInfoFragment = { __typename: 'ProposalRevision', id: ID['output'], createdAt: Timestamp['output'], summary: String['output'], createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'] }
   | null };

export type RevisionHistoryLaunchFragment = { __typename: 'Launch', id: ID['output'], buildInput:
    | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
    | { __typename: 'FilterBuildInput' }
  , build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure' }
      | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
     | null } | null };

export type ProposalChangesQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  historyOffset: Scalars['Int']['input'];
  shouldSkipFetchingMergeBase: Scalars['Boolean']['input'];
  shouldSkipFetchingLaunch: Scalars['Boolean']['input'];
}>;


export type ProposalChangesQuery = { service: { __typename: 'Service', id: ID['output'], roles: { __typename: 'ServiceRoles', canQueryImplementingServices: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', status: ProposalStatus, id: ID['output'], updatedAt: Timestamp['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, parentComments: Array<
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], outdated: Boolean['output'] }
          | { __typename: 'ParentGeneralProposalComment' }
        >, latestRevision: { __typename: 'ProposalRevision', id: ID['output'], summary: String['output'], mergeBaseSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, createdBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', fullName: String['output'], id: ID['output'] }
           | null, mergeBaseLaunch?: { __typename: 'Launch', id: ID['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
            , build: { __typename: 'Build', id: ID['output'], result:
                | { __typename: 'BuildFailure' }
                | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
               | null } | null } | null, launch: { __typename: 'Launch', id: ID['output'] } | null } } & ({ __typename: 'Proposal', id: ID['output'], implementedChanges: Array<{ __typename: 'ProposalImplementedChange', launchId: ID['output'], subgraph: String['output'], diffItem:
            | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddSchemaDefinition' }
            | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeSchemaDescription' }
            | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveSchemaDefinition' }
            | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
           }> } | { __typename: 'Proposal', id?: never, implementedChanges?: never }) | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
           | null } | null } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null, failedStep: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess' }
           | null } | null, buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         } | null, firstLaunch: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
        , build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
           | null } | null }> | null, activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], history: Array<{ __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } }>, schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null } | null } | null };

export type ProposalChangesSelectedRevisionQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  revisionId: Scalars['ID']['input'];
}>;


export type ProposalChangesSelectedRevisionQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], revision:
          | { __typename: 'NotFoundError' }
          | { __typename: 'ProposalRevision', id: ID['output'], isMerge: Boolean['output'], createdAt: Timestamp['output'], summary: String['output'], schemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, launch: { __typename: 'Launch', id: ID['output'], buildInput:
                | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
                | { __typename: 'FilterBuildInput' }
              , build: { __typename: 'Build', id: ID['output'], result:
                  | { __typename: 'BuildFailure' }
                  | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
                 | null } | null } | null, mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
                | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
                | { __typename: 'FilterBuildInput' }
              , build: { __typename: 'Build', id: ID['output'], result:
                  | { __typename: 'BuildFailure' }
                  | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
                 | null } | null } | null, previousRevision: { __typename: 'ProposalRevision', id: ID['output'], schemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, launch: { __typename: 'Launch', id: ID['output'], buildInput:
                  | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'] }> }
                  | { __typename: 'FilterBuildInput' }
                , build: { __typename: 'Build', id: ID['output'], result:
                    | { __typename: 'BuildFailure' }
                    | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
                   | null } | null } | null, mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
                  | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'] }> }
                  | { __typename: 'FilterBuildInput' }
                 } | null } | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], id: ID['output'] }
             | null }
         | null } | null } | null } | null };

export type ProposalChangesSupergraphAndApiSchemaPollQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  shouldSkipFetchingLaunch: Scalars['Boolean']['input'];
}>;


export type ProposalChangesSupergraphAndApiSchemaPollQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiHash: String['output'] } }
           | null } | null } | null } | null } | null };

export type ProposalChangesBaseSdlQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  newSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
  oldSdlHash?: InputMaybe<Scalars['SHA256']['input']>;
}>;


export type ProposalChangesBaseSdlQuery = { service: { __typename: 'Service', id: ID['output'], flatDiff:
      | { __typename: 'FlatDiff', id: ID['output'], diff: Array<
          | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
          | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
          | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
          | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
          | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
        >, summary: { __typename: 'FlatDiffSummary', object: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, directive: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, enum: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, input: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, interface: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, scalar: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, schema: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] }, union: { __typename: 'FlatDiffTypeSummary', add: Int['output'], remove: Int['output'], change: Int['output'], typeCount: Int['output'] } } }
      | { __typename: 'NotFoundError' }
      | { __typename: 'SchemaValidationError' }
     } | null };

export type ReportFalsePositiveDiffItemsVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  input: ReportFalsePositiveDiffItemsInput;
}>;


export type ReportFalsePositiveDiffItems = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', reportFalsePositiveDiffItems:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'ReportFalsePositiveDiffItemsSuccess', flagIds: Array<ID['output']> }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type RevisionHistoryDrawerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RevisionHistoryDrawerQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], revisionHistory: { __typename: 'ProposalRevisionHistoryResult', totalCount: Int['output'], revisions: Array<{ __typename: 'ProposalRevision', id: ID['output'], createdAt: Timestamp['output'], summary: String['output'], createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }> } } | null } | null } | null };

export type ChecksForRevisionCardWorfklowFragment = { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, subgraphNames: Array<String['output']>, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
        | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
        | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
       | null, buildResult:
        | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
        | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
        | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
        | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  >, triggeredBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

export type RetryCheckForProposalRevisionMutationVariables = Exact<{
  input: ReRunCheckForRevisionInput;
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type RetryCheckForProposalRevisionMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', reRunCheckForRevision:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'] }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type ProposalsCheckWorkflowItemFragment = { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, subgraphNames: Array<String['output']>, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null, tasks: Array<
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
        | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
        | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
       | null, buildResult:
        | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
        | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
        | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
        | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
          | { __typename: 'FlatDiffAddArgument' }
          | { __typename: 'FlatDiffAddDirective' }
          | { __typename: 'FlatDiffAddDirectiveUsage' }
          | { __typename: 'FlatDiffAddEnum' }
          | { __typename: 'FlatDiffAddEnumValue' }
          | { __typename: 'FlatDiffAddField' }
          | { __typename: 'FlatDiffAddImplementation' }
          | { __typename: 'FlatDiffAddInput' }
          | { __typename: 'FlatDiffAddInterface' }
          | { __typename: 'FlatDiffAddObject' }
          | { __typename: 'FlatDiffAddScalar' }
          | { __typename: 'FlatDiffAddSchemaDefinition' }
          | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffAddSchemaRootOperation' }
          | { __typename: 'FlatDiffAddUnion' }
          | { __typename: 'FlatDiffAddUnionMember' }
          | { __typename: 'FlatDiffAddValidLocation' }
          | { __typename: 'FlatDiffChangeArgumentDefault' }
          | { __typename: 'FlatDiffChangeDescription' }
          | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
          | { __typename: 'FlatDiffChangeInputFieldDefault' }
          | { __typename: 'FlatDiffChangeSchemaDescription' }
          | { __typename: 'FlatDiffRemoveArgument' }
          | { __typename: 'FlatDiffRemoveDirective' }
          | { __typename: 'FlatDiffRemoveDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveEnum' }
          | { __typename: 'FlatDiffRemoveEnumValue' }
          | { __typename: 'FlatDiffRemoveField' }
          | { __typename: 'FlatDiffRemoveImplementation' }
          | { __typename: 'FlatDiffRemoveInput' }
          | { __typename: 'FlatDiffRemoveInterface' }
          | { __typename: 'FlatDiffRemoveObject' }
          | { __typename: 'FlatDiffRemoveScalar' }
          | { __typename: 'FlatDiffRemoveSchemaDefinition' }
          | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
          | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
          | { __typename: 'FlatDiffRemoveUnion' }
          | { __typename: 'FlatDiffRemoveUnionMember' }
          | { __typename: 'FlatDiffRemoveValidLocation' }
         }> }
  >, triggeredBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null };

export type ProposalChecksQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filter?: InputMaybe<CheckFilterInput>;
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type ProposalChecksQuery = { service: { __typename: 'Service', id: ID['output'], totalCheckWorkflowCount: Int['output'], checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, subgraphNames: Array<String['output']>, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
            | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, triggeredBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }>, variant: { __typename: 'GraphVariant', id: ID['output'], launchHistoryLength: Long['output'] | null, proposal: { __typename: 'Proposal', id: ID['output'], latestRevision: { __typename: 'ProposalRevision', id: ID['output'] } } | null } | null } | null };

type SingleProposalCommentFragment_ParentChangeProposalComment = { __typename: 'ParentChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

type SingleProposalCommentFragment_ParentGeneralProposalComment = { __typename: 'ParentGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

type SingleProposalCommentFragment_ReplyChangeProposalComment = { __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

type SingleProposalCommentFragment_ReplyGeneralProposalComment = { __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

type SingleProposalCommentFragment_ReviewProposalComment = { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type SingleProposalCommentFragment =
  | SingleProposalCommentFragment_ParentChangeProposalComment
  | SingleProposalCommentFragment_ParentGeneralProposalComment
  | SingleProposalCommentFragment_ReplyChangeProposalComment
  | SingleProposalCommentFragment_ReplyGeneralProposalComment
  | SingleProposalCommentFragment_ReviewProposalComment
;

export type DeleteCommentModalParentChangeCommentFragment = { __typename: 'ParentChangeProposalComment', id: ID['output'], status: CommentStatus, message: String['output'], replyCount: Int['output'] };

export type DeleteCommentModalParentGeneralCommentFragment = { __typename: 'ParentGeneralProposalComment', id: ID['output'], status: CommentStatus, message: String['output'], replyCount: Int['output'] };

export type DeleteProposalCommentQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type DeleteProposalCommentQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], comment:
          | { __typename: 'NotFoundError', message: String['output'] }
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ParentGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
         | null } | null } | null, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'] } }> | null } | null } | null };

export type DeleteCommentModalDeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type DeleteCommentModalDeleteCommentMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', deleteComment:
            | { __typename: 'DeleteCommentSuccess', comment:
                | { __typename: 'ParentChangeProposalComment', id: ID['output'], status: CommentStatus, message: String['output'], replyCount: Int['output'] }
                | { __typename: 'ParentGeneralProposalComment', id: ID['output'], status: CommentStatus, message: String['output'], replyCount: Int['output'] }
               | null }
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type ProposalCommentsParentCommentFragment = { __typename: 'ParentChangeProposalComment', id: ID['output'], replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], outdated: Boolean['output'] };

export type UseAddCommentNewReplyChangeCommentFragment = { __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type UseAddCommentNewReplyGeneralCommentFragment = { __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type UseAddCommentNewChangeParentCommentFragment = { __typename: 'ParentChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null }>, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type UseAddCommentNewGeneralParentCommentFragment = { __typename: 'ParentGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, replyCount: Int['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null }>, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type UseAddCommentProposalFragment = { __typename: 'Proposal', id: ID['output'], status: ProposalStatus, latestRevision: { __typename: 'ProposalRevision', id: ID['output'] } };

export type ProposalCommentDrawerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
  shouldQueryComments: Scalars['Boolean']['input'];
}>;


export type ProposalCommentDrawerQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], status: ProposalStatus, comment?:
          | { __typename: 'NotFoundError', message: String['output'] }
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }>, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ParentGeneralProposalComment' }
          | { __typename: 'ReplyChangeProposalComment' }
          | { __typename: 'ReplyGeneralProposalComment' }
          | { __typename: 'ReviewProposalComment' }
         | null, latestRevision: { __typename: 'ProposalRevision', id: ID['output'] } } | null } | null, account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'] } }> | null } | null } | null };

export type UseAddCommentMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  input: AddCommentInput;
}>;


export type UseAddCommentMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError', message: String['output'] }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', addComment:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'ParentChangeProposalComment', id: ID['output'], replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
                  | { __typename: 'InternalIdentity', id: ID['output'] }
                  | { __typename: 'Service', id: ID['output'] }
                  | { __typename: 'ServiceAccount', id: ID['output'] }
                  | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                 | null }>, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }
            | { __typename: 'ParentGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, replyCount: Int['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
                  | { __typename: 'InternalIdentity', id: ID['output'] }
                  | { __typename: 'Service', id: ID['output'] }
                  | { __typename: 'ServiceAccount', id: ID['output'] }
                  | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                 | null }>, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }
            | { __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }
            | { __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, status: CommentStatus, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

export type ProposalCommentEditMutationVariables = Exact<{
  input: EditCommentInput;
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ProposalCommentEditMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', editComment:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'ParentChangeProposalComment', id: ID['output'], message: String['output'], updatedAt: Timestamp['output'] | null }
            | { __typename: 'ParentGeneralProposalComment', id: ID['output'], message: String['output'], updatedAt: Timestamp['output'] | null }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], updatedAt: Timestamp['output'] | null }
            | { __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], updatedAt: Timestamp['output'] | null }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type SupergraphAndApiSchemaFragment = { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], status: ProposalStatus } | null, activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure' }
          | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
         | null } | null } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], failedStep: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
          | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
         | null } | null } | null } | null };

export type ProposalEditorQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  canQueryCheckConfiguration: Scalars['Boolean']['input'];
  pullUpstreamChanges: Scalars['Boolean']['input'];
  hasMergeBaseCompositionId: Scalars['Boolean']['input'];
  shouldFetchActiveSchemaPublish: Scalars['Boolean']['input'];
}>;


export type ProposalEditorQuery = { service: { __typename: 'Service', id: ID['output'], name: String['output'], linterConfiguration?: { __typename: 'GraphLinterConfiguration', rules: Array<{ __typename: 'LinterRuleLevelConfiguration', rule: LintRule, description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, level: LintDiagnosticLevel, category: LinterRuleCategory }> }, variant: { __typename: 'GraphVariant', id: ID['output'], firstLaunch?: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         }> | null, updatedSubgraphsSinceCreation: Array<{ __typename: 'Subgraph', name: String['output'], updatedAt: Timestamp['output'] | null }> | null, proposal: { __typename: 'Proposal', id: ID['output'], canEditProposal: Boolean['output'], status: ProposalStatus, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
              | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'] }
              | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'] }
             | null } | null }, parentComments: Array<
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], replyCount: Int['output'], schemaCoordinate: String['output'], schemaScope: String['output'], createdAt: Timestamp['output'], outdated: Boolean['output'] }
          | { __typename: 'ParentGeneralProposalComment' }
        >, latestRevision: { __typename: 'ProposalRevision', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'] } | null, mergeBaseLaunch?: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
              | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
              | { __typename: 'FilterBuildInput' }
             } | null } } & ({ __typename: 'Proposal', id: ID['output'], implementedChanges: Array<{ __typename: 'ProposalImplementedChange', launchId: ID['output'], subgraph: String['output'], diffItem:
            | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddSchemaDefinition' }
            | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeSchemaDescription' }
            | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveSchemaDefinition' }
            | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
           }> } | { __typename: 'Proposal', id?: never, implementedChanges?: never }) & ({ __typename: 'Proposal', id: ID['output'], implementedChanges: Array<{ __typename: 'ProposalImplementedChange', launchId: ID['output'], subgraph: String['output'], diffItem:
            | { __typename: 'FlatDiffAddArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddField', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddSchemaDefinition' }
            | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffAddSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffAddUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffAddValidLocation', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeArgumentDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDescription', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeDirectiveRepeatable', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeInputFieldDefault', coordinate: String['output'] }
            | { __typename: 'FlatDiffChangeSchemaDescription' }
            | { __typename: 'FlatDiffRemoveArgument', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirective', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveDirectiveUsage', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnum', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveEnumValue', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveField', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveImplementation', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInput', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveInterface', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveObject', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveScalar', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveSchemaDefinition' }
            | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
            | { __typename: 'FlatDiffRemoveSchemaRootOperation', rootType: String['output'] }
            | { __typename: 'FlatDiffRemoveUnion', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveUnionMember', coordinate: String['output'] }
            | { __typename: 'FlatDiffRemoveValidLocation', coordinate: String['output'] }
           }> } | { __typename: 'Proposal', id?: never, implementedChanges?: never }) | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', sdl: String['output'], hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
        , build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], failedStep: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
           | null } | null } | null, activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type ProposalEditorSupergraphAndApiSchemaPollQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  shouldFetchActiveSchemaPublish: Scalars['Boolean']['input'];
}>;


export type ProposalEditorSupergraphAndApiSchemaPollQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], status: ProposalStatus } | null, activeSchemaPublish?: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
           | null } | null } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], failedStep: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], coreDocument: GraphQLDocument['output'], apiHash: String['output'], apiDocument: GraphQLDocument['output'] } }
           | null } | null } | null } | null } | null };

export type DeleteProposalSubgraphMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: DeleteProposalSubgraphInput;
  graphVariant: Scalars['String']['input'];
}>;


export type DeleteProposalSubgraphMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', deleteSubgraph:
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], latestRevision: { __typename: 'ProposalRevision', id: ID['output'] }, backingVariant: { __typename: 'GraphVariant', id: ID['output'], graph: { __typename: 'Service', id: ID['output'], mostRecentCompositionPublish: { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'] } | null }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'] } | null } }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type UseFetchUpstreamSourceVariantSdlsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type UseFetchUpstreamSourceVariantSdlsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], baseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'], sdl: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'], hash: String['output'], sdl: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         } | null } | null } | null };

export type SchemaFromHashQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  schemaHash?: InputMaybe<Scalars['SHA256']['input']>;
}>;


export type SchemaFromHashQuery = { service: { __typename: 'Service', id: ID['output'], doc: { __typename: 'GraphQLDoc', source: GraphQLDocument['output'] } | null } | null };

export type SchemaLinterDrawerLinterRuleLevelConfigurationFragment = { __typename: 'LinterRuleLevelConfiguration', rule: LintRule, description: String['output'], goodExampleCode: String['output'] | null, badExampleCode: String['output'] | null, level: LintDiagnosticLevel, category: LinterRuleCategory };

export type SchemaLinterDrawerLintSchemaMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  baseSdl?: InputMaybe<Scalars['String']['input']>;
  proposedSdl: Scalars['String']['input'];
}>;


export type SchemaLinterDrawerLintSchemaMutation = { graph: { __typename: 'ServiceMutation', lintSchema: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', rule: LintRule, level: LintDiagnosticLevel, coordinate: String['output'], message: String['output'], sourceLocations: Array<{ __typename: 'Location', subgraphName: String['output'] | null, end: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null, start: { __typename: 'Coordinate', line: Int['output'], column: Int['output'], byteOffset: Int['output'] } | null }> }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } } | null };

export type PublishProposalRevisionMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  input: PublishProposalSubgraphsInput;
}>;


export type PublishProposalRevisionMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', publishSubgraphs:
            | { __typename: 'NotFoundError', message: String['output'] }
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], latestRevision: { __typename: 'ProposalRevision', id: ID['output'] }, backingVariant: { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
                    | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                    | { __typename: 'FilterBuildInput' }
                   } | null } }
            | { __typename: 'SchemaValidationError', message: String['output'] }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type ProposalBuildInputFragment = { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
      | { __typename: 'FilterBuildInput' }
     } | null };

export type ProposalHeaderDataVariantFragment = { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], status: ProposalStatus, displayName: String['output'], createdAt: Timestamp['output'], canEditProposal: Boolean['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } } | null };

export type ProposalHomepageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  canQueryLaunches: Scalars['Boolean']['input'];
  threadId: Scalars['ID']['input'];
  shouldShowDeepLinkedComment: Scalars['Boolean']['input'];
}>;


export type ProposalHomepageQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], minProposalApprovers: Int['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, proposal: { __typename: 'Proposal', id: ID['output'], description: String['output'], descriptionUpdatedAt: Timestamp['output'] | null, canEditProposal: Boolean['output'], status: ProposalStatus, displayName: String['output'], createdAt: Timestamp['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, descriptionUpdatedBy:
          | { __typename: 'InternalIdentity', name: String['output'], id: ID['output'] }
          | { __typename: 'Service', id: ID['output'], title: String['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null, createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null, reviews: Array<{ __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, createdAt: Timestamp['output'], isDismissed: Boolean['output'], comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'] } | null, createdBy:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', id: ID['output'] }
           | null }>, latestRevision: { __typename: 'ProposalRevision', id: ID['output'], previousRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null }, comment?:
          | { __typename: 'NotFoundError' }
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], schemaCoordinate: String['output'], schemaScope?: String['output'], replyCount: Int['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }>, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ParentGeneralProposalComment', id: ID['output'], replyCount: Int['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }>, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ReplyChangeProposalComment' }
          | { __typename: 'ReplyGeneralProposalComment' }
          | { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
         | null, requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', user:
            | { __typename: 'InternalIdentity', id: ID['output'] }
            | { __typename: 'Service', id: ID['output'] }
            | { __typename: 'ServiceAccount', id: ID['output'] }
            | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
           | null, currentReview: { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, isDismissed: Boolean['output'] } | null } | null> } | null } | null, defaultProposalReviewers: Array<
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', avatarUrl: String['output'] | null, id: ID['output'], fullName: String['output'] }
     | null> } | null };

export type ProposalHomepageActivityFeedQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  canQueryLaunches: Scalars['Boolean']['input'];
}>;


export type ProposalHomepageActivityFeedQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], status: ProposalStatus, activities: { __typename: 'ProposalActivityConnection', totalCount: Int['output'], pageInfo: { __typename: 'PageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null, hasPreviousPage: Boolean['output'], hasNextPage: Boolean['output'] }, edges: Array<{ __typename: 'ProposalActivityEdge', cursor: String['output'], node: { __typename: 'ProposalActivity', id: ID['output'], activity: ProposalActivityAction | null, createdAt: Timestamp['output'], createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null, target:
                | { __typename: 'ParentChangeProposalComment', id: ID['output'], schemaCoordinate: String['output'], schemaScope?: String['output'], replyCount: Int['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                      | { __typename: 'InternalIdentity', id: ID['output'] }
                      | { __typename: 'Service', id: ID['output'] }
                      | { __typename: 'ServiceAccount', id: ID['output'] }
                      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                     | null }>, createdBy:
                    | { __typename: 'InternalIdentity', id: ID['output'] }
                    | { __typename: 'Service', id: ID['output'] }
                    | { __typename: 'ServiceAccount', id: ID['output'] }
                    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                   | null }
                | { __typename: 'ParentGeneralProposalComment', id: ID['output'], replyCount: Int['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                      | { __typename: 'InternalIdentity', id: ID['output'] }
                      | { __typename: 'Service', id: ID['output'] }
                      | { __typename: 'ServiceAccount', id: ID['output'] }
                      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                     | null }>, createdBy:
                    | { __typename: 'InternalIdentity', id: ID['output'] }
                    | { __typename: 'Service', id: ID['output'] }
                    | { __typename: 'ServiceAccount', id: ID['output'] }
                    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                   | null }
                | { __typename: 'Proposal' }
                | { __typename: 'ProposalFullImplementationProposalOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, revision?: { __typename: 'ProposalRevision', id: ID['output'] } }
                | { __typename: 'ProposalFullImplementationVariantOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, launch?: { __typename: 'Launch', id: ID['output'] } | null }
                | { __typename: 'ProposalPartialImplementationProposalOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, revision?: { __typename: 'ProposalRevision', id: ID['output'] } }
                | { __typename: 'ProposalPartialImplementationVariantOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, launch?: { __typename: 'Launch', id: ID['output'] } | null }
                | { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'] } | null, createdBy:
                    | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'] }
                    | { __typename: 'Service', id: ID['output'], name: String['output'] }
                    | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
                    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'], name: String['output'] }
                   | null }
                | { __typename: 'ProposalRevision', id: ID['output'], summary: String['output'], isMerge: Boolean['output'], launch?: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
                      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                      | { __typename: 'FilterBuildInput' }
                     } | null, mergeBaseLaunch?: { __typename: 'Launch', id: ID['output'], buildInput:
                      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                      | { __typename: 'FilterBuildInput' }
                     } | null, previousRevision?: { __typename: 'ProposalRevision', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
                        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                        | { __typename: 'FilterBuildInput' }
                       } | null, mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
                        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'] }> }
                        | { __typename: 'FilterBuildInput' }
                       } | null } | null }
               | null } | null }> | null }, latestRevision: { __typename: 'ProposalRevision', id: ID['output'] } } | null, launchHistory?: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
          | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
          | { __typename: 'FilterBuildInput' }
         }> | null } | null } | null };

export type ProposalHomepageGraphForMentionsVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ProposalHomepageGraphForMentions = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'] } }> | null } | null } | null };

export type ActivityFeedProposalFragment = { __typename: 'Proposal', id: ID['output'], activities: { __typename: 'ProposalActivityConnection', totalCount: Int['output'], pageInfo: { __typename: 'PageInfo', endCursor: String['output'] | null, startCursor: String['output'] | null, hasPreviousPage: Boolean['output'], hasNextPage: Boolean['output'] }, edges: Array<{ __typename: 'ProposalActivityEdge', cursor: String['output'], node: { __typename: 'ProposalActivity', id: ID['output'], activity: ProposalActivityAction | null, createdAt: Timestamp['output'], createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null, target:
          | { __typename: 'ParentChangeProposalComment', id: ID['output'], schemaCoordinate: String['output'], schemaScope?: String['output'], replyCount: Int['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }>, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'ParentGeneralProposalComment', id: ID['output'], replyCount: Int['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
                | { __typename: 'InternalIdentity', id: ID['output'] }
                | { __typename: 'Service', id: ID['output'] }
                | { __typename: 'ServiceAccount', id: ID['output'] }
                | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
               | null }>, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'] }
              | { __typename: 'Service', id: ID['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
             | null }
          | { __typename: 'Proposal' }
          | { __typename: 'ProposalFullImplementationProposalOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, revision?: { __typename: 'ProposalRevision', id: ID['output'] } }
          | { __typename: 'ProposalFullImplementationVariantOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, launch?: { __typename: 'Launch', id: ID['output'] } | null }
          | { __typename: 'ProposalPartialImplementationProposalOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, revision?: { __typename: 'ProposalRevision', id: ID['output'] } }
          | { __typename: 'ProposalPartialImplementationVariantOrigin', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }, launch?: { __typename: 'Launch', id: ID['output'] } | null }
          | { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'] } | null, createdBy:
              | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'] }
              | { __typename: 'Service', id: ID['output'], name: String['output'] }
              | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
              | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'], name: String['output'] }
             | null }
          | { __typename: 'ProposalRevision', id: ID['output'], summary: String['output'], isMerge: Boolean['output'], launch?: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
                | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                | { __typename: 'FilterBuildInput' }
               } | null, mergeBaseLaunch?: { __typename: 'Launch', id: ID['output'], buildInput:
                | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                | { __typename: 'FilterBuildInput' }
               } | null, previousRevision?: { __typename: 'ProposalRevision', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
                  | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
                  | { __typename: 'FilterBuildInput' }
                 } | null, mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
                  | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'] }> }
                  | { __typename: 'FilterBuildInput' }
                 } | null } | null }
         | null } | null }> | null } };

export type ActivityFeedFirstLaunchGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], launchHistory?: Array<{ __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
      | { __typename: 'FilterBuildInput' }
     }> | null };

export type ActivityFeedCommentThreadChangeProposalCommentFragment = { __typename: 'ParentChangeProposalComment', id: ID['output'], schemaCoordinate: String['output'], schemaScope?: String['output'], replyCount: Int['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null }>, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type ActivityFeedCommentThreadGeneralProposalCommentFragment = { __typename: 'ParentGeneralProposalComment', id: ID['output'], replyCount: Int['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null }>, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type ActivityFeedCommentThreadReviewCommentFragment = { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
   | null };

export type ActivityFeedRevisionFragment = { __typename: 'ProposalRevision', id: ID['output'], summary: String['output'], isMerge: Boolean['output'], launch?: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
      | { __typename: 'FilterBuildInput' }
     } | null, mergeBaseLaunch?: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
      | { __typename: 'FilterBuildInput' }
     } | null, previousRevision?: { __typename: 'ProposalRevision', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'], createdAt: Timestamp['output'], buildInput:
        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', hash: String['output'], name: String['output'] }> }
        | { __typename: 'FilterBuildInput' }
       } | null, mergeBaseLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
        | { __typename: 'CompositionBuildInput', subgraphs: Array<{ __typename: 'Subgraph', name: String['output'] }> }
        | { __typename: 'FilterBuildInput' }
       } | null } | null };

export type ChangeProposalStatusMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  status: ProposalStatus;
}>;


export type ChangeProposalStatusMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', updateStatus:
            | { __typename: 'PermissionError' }
            | { __typename: 'Proposal', id: ID['output'], status: ProposalStatus }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type CheckOverviewSectionQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowsFilter?: InputMaybe<CheckFilterInput>;
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckOverviewSectionQuery = { service: { __typename: 'Service', id: ID['output'], totalCheckWorkflowCount: Int['output'], checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'], subgraphNames: Array<String['output']>, status: CheckWorkflowStatus, createdAt: Timestamp['output'], startedAt: Timestamp['output'] | null, completedAt: Timestamp['output'] | null, isSandboxCheck: Boolean['output'], introspectionEndpoint: String['output'] | null, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'] } | null, tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
            | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'CustomCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'CustomCheckResult', violations: Array<{ __typename: 'CheckViolation', level: ViolationLevel }> } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'LintCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'LintResult', diagnostics: Array<{ __typename: 'LintDiagnostic', level: LintDiagnosticLevel }>, stats: { __typename: 'LintStats', ignoredCount: Int['output'] } } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, severityLevel: ProposalChangeMismatchSeverity, proposalCoverage: ProposalCoverage, didOverrideProposalsCheckTask: Boolean['output'], createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, hasWarnings?: Boolean['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null }, diffs?: Array<{ __typename: 'ProposalsCheckTaskDiff', hasApprovedProposal: Boolean['output'], diffItem:
              | { __typename: 'FlatDiffAddArgument' }
              | { __typename: 'FlatDiffAddDirective' }
              | { __typename: 'FlatDiffAddDirectiveUsage' }
              | { __typename: 'FlatDiffAddEnum' }
              | { __typename: 'FlatDiffAddEnumValue' }
              | { __typename: 'FlatDiffAddField' }
              | { __typename: 'FlatDiffAddImplementation' }
              | { __typename: 'FlatDiffAddInput' }
              | { __typename: 'FlatDiffAddInterface' }
              | { __typename: 'FlatDiffAddObject' }
              | { __typename: 'FlatDiffAddScalar' }
              | { __typename: 'FlatDiffAddSchemaDefinition' }
              | { __typename: 'FlatDiffAddSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffAddSchemaRootOperation' }
              | { __typename: 'FlatDiffAddUnion' }
              | { __typename: 'FlatDiffAddUnionMember' }
              | { __typename: 'FlatDiffAddValidLocation' }
              | { __typename: 'FlatDiffChangeArgumentDefault' }
              | { __typename: 'FlatDiffChangeDescription' }
              | { __typename: 'FlatDiffChangeDirectiveRepeatable' }
              | { __typename: 'FlatDiffChangeInputFieldDefault' }
              | { __typename: 'FlatDiffChangeSchemaDescription' }
              | { __typename: 'FlatDiffRemoveArgument' }
              | { __typename: 'FlatDiffRemoveDirective' }
              | { __typename: 'FlatDiffRemoveDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveEnum' }
              | { __typename: 'FlatDiffRemoveEnumValue' }
              | { __typename: 'FlatDiffRemoveField' }
              | { __typename: 'FlatDiffRemoveImplementation' }
              | { __typename: 'FlatDiffRemoveInput' }
              | { __typename: 'FlatDiffRemoveInterface' }
              | { __typename: 'FlatDiffRemoveObject' }
              | { __typename: 'FlatDiffRemoveScalar' }
              | { __typename: 'FlatDiffRemoveSchemaDefinition' }
              | { __typename: 'FlatDiffRemoveSchemaDirectiveUsage' }
              | { __typename: 'FlatDiffRemoveSchemaRootOperation' }
              | { __typename: 'FlatDiffRemoveUnion' }
              | { __typename: 'FlatDiffRemoveUnionMember' }
              | { __typename: 'FlatDiffRemoveValidLocation' }
             }> }
      >, gitContext: { __typename: 'GitContext', branch: String['output'] | null, commit: ID['output'] | null, committer: String['output'] | null, commitUrl: String['output'] | null } | null, triggeredBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, downstreamTask: { __typename: 'DownstreamCheckTask', id: ID['output'], results: Array<{ __typename: 'DownstreamCheckResult', failsUpstreamWorkflow: Boolean['output'] | null, downstreamWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null }> | null } | null }> } | null };

export type ProposalReviewModalProposalReviewFragment = { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, createdAt: Timestamp['output'], isDismissed: Boolean['output'], comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'] } | null, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type ProposalUpsertReviewMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  input: UpsertReviewInput;
}>;


export type ProposalUpsertReviewMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', upsertReview:
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', currentReview: { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision } | null, user:
                  | { __typename: 'InternalIdentity', id: ID['output'] }
                  | { __typename: 'Service', id: ID['output'] }
                  | { __typename: 'ServiceAccount', id: ID['output'] }
                  | { __typename: 'User', id: ID['output'] }
                 | null } | null>, reviews: Array<{ __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, comment: { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], createdAt: Timestamp['output'], createdBy:
                    | { __typename: 'InternalIdentity', id: ID['output'] }
                    | { __typename: 'Service', id: ID['output'] }
                    | { __typename: 'ServiceAccount', id: ID['output'] }
                    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                   | null } | null }> }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type RenameProposalTitleMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
}>;


export type RenameProposalTitleMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', updateDisplayName:
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], displayName: String['output'] }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type RequestedReviewersSectionProposalFragment = { __typename: 'Proposal', id: ID['output'], status: ProposalStatus, createdBy:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', user:
      | { __typename: 'InternalIdentity', id: ID['output'] }
      | { __typename: 'Service', id: ID['output'] }
      | { __typename: 'ServiceAccount', id: ID['output'] }
      | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
     | null, currentReview: { __typename: 'ProposalReview', id: ID['output'], decision: ReviewDecision, isDismissed: Boolean['output'] } | null } | null> };

export type RequestedReviewersSectionServiceFragment = { __typename: 'Service', id: ID['output'], proposalsMustBeApprovedByADefaultReviewer: Boolean['output'], minProposalApprovers: Int['output'], defaultProposalReviewers: Array<
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', avatarUrl: String['output'] | null, id: ID['output'], fullName: String['output'] }
   | null> };

export type ProposalUpdateRequestedReviewersMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  input: UpdateRequestedReviewersInput;
}>;


export type ProposalUpdateRequestedReviewersMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'ProposalMutation', updateRequestedReviewers:
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', user:
                  | { __typename: 'InternalIdentity', id: ID['output'] }
                  | { __typename: 'Service', id: ID['output'] }
                  | { __typename: 'ServiceAccount', id: ID['output'] }
                  | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                 | null } | null> }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

export type ReviewerMultiselectPopoverUsersServiceFragment = { __typename: 'Service', id: ID['output'], minProposalApprovers: Int['output'], account: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], fullName: String['output'], avatarUrl: String['output'] | null } }> | null } | null };

export type ReplaceReviewersWithDefaultReviewersMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ReplaceReviewersWithDefaultReviewersMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError', message: String['output'] }
        | { __typename: 'PermissionError', message: String['output'] }
        | { __typename: 'ProposalMutation', replaceReviewersWithDefaultReviewers:
            | { __typename: 'PermissionError', message: String['output'] }
            | { __typename: 'Proposal', id: ID['output'], requestedReviewers: Array<{ __typename: 'ProposalRequestedReviewer', user:
                  | { __typename: 'InternalIdentity', id: ID['output'] }
                  | { __typename: 'Service', id: ID['output'] }
                  | { __typename: 'ServiceAccount', id: ID['output'] }
                  | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
                 | null } | null> }
            | { __typename: 'ValidationError', message: String['output'] }
           }
        | { __typename: 'ValidationError', message: String['output'] }
       } | null } | null };

export type SingleDeepLinkedProposalCommentProposalFragment = { __typename: 'Proposal', id: ID['output'], comment?:
    | { __typename: 'NotFoundError' }
    | { __typename: 'ParentChangeProposalComment', id: ID['output'], schemaCoordinate: String['output'], schemaScope?: String['output'], replyCount: Int['output'], outdated: Boolean['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyChangeProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null }>, createdBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null }
    | { __typename: 'ParentGeneralProposalComment', id: ID['output'], replyCount: Int['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, replies: Array<{ __typename: 'ReplyGeneralProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
         | null }>, createdBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null }
    | { __typename: 'ReplyChangeProposalComment' }
    | { __typename: 'ReplyGeneralProposalComment' }
    | { __typename: 'ReviewProposalComment', id: ID['output'], message: String['output'], status: CommentStatus, createdAt: Timestamp['output'], updatedAt: Timestamp['output'] | null, createdBy:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, id: ID['output'] }
       | null }
   | null };

export type UpgradeFederationButtonGraphQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type UpgradeFederationButtonGraphQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], compositionVersion: String['output'] | null, name: String['output'], proposal: { __typename: 'Proposal', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], compositionVersion: String['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
              | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'] }
              | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'] }
             | null } | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', name: String['output'], enabled: Boolean['output'] }> | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', badge: BuildPipelineTrackBadge | null, compositionVersion: String['output'], deprecatedAt: Timestamp['output'] | null, displayName: String['output'], minimumGatewayVersion: String['output'] | null, minimumRouterVersion: String['output'] | null, notSupportedAt: Timestamp['output'] | null, federationVersion: FederationVersion['output'] } | null>, buildConfig: { __typename: 'BuildConfig', tagInApiSchema: Boolean['output'], federationVersion: FederationVersion['output'] } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
              | { __typename: 'CompositionBuildInput', version: String['output'] | null }
              | { __typename: 'FilterBuildInput' }
             } | null } } | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null>, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null } | null } | null };

export type ProposalStalenessVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type ProposalStaleness = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], proposal: { __typename: 'Proposal', id: ID['output'], latestRevision: { __typename: 'ProposalRevision', id: ID['output'] } } | null } | null } | null };

export type UseRecentPublishChecksToastQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowLimit?: InputMaybe<Scalars['Int']['input']>;
  checkWorkflowFilter?: InputMaybe<CheckFilterInput>;
}>;


export type UseRecentPublishChecksToastQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, service: { __typename: 'Service', id: ID['output'], checkWorkflows: Array<{ __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, proposalRevision: { __typename: 'ProposalRevision', id: ID['output'], createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'] }
          | { __typename: 'Service', id: ID['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'] }
          | { __typename: 'User', id: ID['output'] }
         | null } | null }> } | null };

export type QuickDeploy__UpdateVariantURLMutationVariables = Exact<{
  graph: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  subscriptionUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuickDeploy__UpdateVariantURLMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateURL: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null } | null, updateSubscriptionURL: { __typename: 'GraphVariant', id: ID['output'], subscriptionUrl: String['output'] | null } | null } | null } | null };

export type QuickDeploy__UpdateSendCookiesMutationVariables = Exact<{
  graph: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  sendCookies: Scalars['Boolean']['input'];
}>;


export type QuickDeploy__UpdateSendCookiesMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateSendCookies: { __typename: 'GraphVariant', id: ID['output'], sendCookies: Boolean['output'] | null } | null } | null } | null };

export type QuickDeploy__UpdateSharedHeadersMutationVariables = Exact<{
  graph: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  sharedHeaders?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuickDeploy__UpdateSharedHeadersMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateSharedHeaders: { __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null } | null } | null } | null };

export type SandboxCheckWorkflowFragment = { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null };

type SandboxCheckWorkflowTaskByIdFragment_CompositionCheckTask = { __typename: 'CompositionCheckTask', id: ID['output'], result:
    | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'] }
    | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
   | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_CustomCheckTask = { __typename: 'CustomCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_DownstreamCheckTask = { __typename: 'DownstreamCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_FilterCheckTask = { __typename: 'FilterCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_LintCheckTask = { __typename: 'LintCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_OperationsCheckTask = { __typename: 'OperationsCheckTask', id: ID['output'], result: { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'], numberOfCheckedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null }> | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

type SandboxCheckWorkflowTaskByIdFragment_ProposalsCheckTask = { __typename: 'ProposalsCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } };

export type SandboxCheckWorkflowTaskByIdFragment =
  | SandboxCheckWorkflowTaskByIdFragment_CompositionCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_CustomCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_DownstreamCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_FilterCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_LintCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_OperationsCheckTask
  | SandboxCheckWorkflowTaskByIdFragment_ProposalsCheckTask
;

export type SandboxCompositionCheckResultByIdFragment = { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> };

export type SandboxOperationsCheckResultByIdFragment = { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'], numberOfCheckedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null }> | null };

export type SandboxCheckSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type SandboxCheckSelectorQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], description: String['output'] | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canShareCollectionInVariant: Boolean['output'] }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null } }> }
   | null };

export type SandboxCheckWorkflowResultByIdVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowID: Scalars['ID']['input'];
}>;


export type SandboxCheckWorkflowResultById = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], tasks: Array<
        | { __typename: 'CompositionCheckTask', id: ID['output'], result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'] }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'CustomCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'DownstreamCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'LintCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'OperationsCheckTask', id: ID['output'], result: { __typename: 'OperationsCheckResult', id: ID['output'], numberOfAffectedOperations: Int['output'], numberOfCheckedOperations: Int['output'], affectedQueries: Array<{ __typename: 'AffectedQuery', id: ID['output'], name: String['output'] | null, isValid: Boolean['output'] | null, markedAsIgnored: Boolean['output'] | null, markedAsSafe: Boolean['output'] | null }> | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
        | { __typename: 'ProposalsCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, introspectionEndpoint: String['output'] | null, implementingServiceName: String['output'] | null, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], usageLastReportedAt: Timestamp['output'] | null } | null } }
      > } | null } | null };

export type SandboxCheckPage_RunCheckMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
  proposedSchemaDocument?: InputMaybe<Scalars['String']['input']>;
  isSandboxCheck: Scalars['Boolean']['input'];
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type SandboxCheckPage_RunCheckMutation = { service: { __typename: 'ServiceMutation', checkSchema: { __typename: 'CheckSchemaResult', workflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus } | null } } | null };

export type SandboxCheckPage_RunSubgraphCheckMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  proposedSchemaDocument: PartialSchemaInput;
  isSandboxCheck: Scalars['Boolean']['input'];
  introspectionEndpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type SandboxCheckPage_RunSubgraphCheckMutation = { service: { __typename: 'ServiceMutation', checkPartialSchema: { __typename: 'CheckPartialSchemaResult', compositionValidationResult: { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], workflowTask: { __typename: 'CompositionCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'] } } | null } } } | null };

export type DiffPageHeaderContentFragment = { __typename: 'GraphVariant', id: ID['output'], name: String['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], document: GraphQLDocument['output'], typeCount: Int['output'], fieldCount: Int['output'], gitContext: { __typename: 'GitContext', commit: ID['output'] | null } | null } } | null, graph: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } };

export type SandboxDiffPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SandboxDiffPageQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], description: String['output'] | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canShareCollectionInVariant: Boolean['output'] }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null } }> }
   | null };

export type SandboxDiffSelectedSchemaQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
}>;


export type SandboxDiffSelectedSchemaQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, name: String['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], document: GraphQLDocument['output'], typeCount: Int['output'], fieldCount: Int['output'], gitContext: { __typename: 'GitContext', commit: ID['output'] | null } | null } } | null, graph: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } } | null, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null, account: { __typename: 'Account', id: ID['output'] } | null } | null };

export type GraphSelectFragment = { __typename: 'Service', description: String['output'] | null, title: String['output'], id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null };

export type MultiOrgSelectFragment = { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], description: String['output'] | null, title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null };

export type SandboxGraphRefSelectorsUserFragment = { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], description: String['output'] | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canShareCollectionInVariant: Boolean['output'] }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null } }> };

export type VariantSelectFragment = { __typename: 'GraphVariant', id: ID['output'], name: String['output'], isFavoriteOfCurrentUser: Boolean['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null };

export type ContinueOnboardingWidgetFragment = { __typename: 'Service', id: ID['output'], apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }> | null };

export type AddSubgraphFormMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  routingUrl: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  partialSchema: PartialSchemaInput;
}>;


export type AddSubgraphFormMutation = { service: { __typename: 'ServiceMutation', publishSubgraph: { __typename: 'CompositionAndUpsertResult', graphCompositionID: String['output'], updatedGateway: Boolean['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] } | null> } | null> } | null } | null };

export type CompositionBuildInputsFragment = { __typename: 'CompositionBuildInputs', subgraphs: Array<{ __typename: 'CompositionBuildInputSubgraph', name: String['output'], schemaHash: SHA256['output'], routingUrl: String['output'] }> };

export type FilterBuildInputsFragment = { __typename: 'FilterBuildInputs', supergraphSchemaHash: SHA256['output'], include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] };

export type ProposeChangesModalCreateProposalMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  input: CreateProposalInput;
}>;


export type ProposeChangesModalCreateProposalMutation = { graph: { __typename: 'ServiceMutation', createProposal:
      | { __typename: 'CreateProposalError', message: String['output'] }
      | { __typename: 'GraphVariant', id: ID['output'], name: String['output'] }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     } | null };

export type ProposeChangesModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ProposeChangesModalQuery = { graph: { __typename: 'Service', id: ID['output'], name: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], hasManagedSubgraphs: Boolean['output'] | null }> } | null };

export type SaveCollectionEntryModalQueryOperationCollectionFragment = { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } };

export type SaveCollectionEntryModalQueryCollectionsOnServiceFragment = { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], mcpDefaultCollection:
      | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }
      | { __typename: 'PermissionError' }
    , operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }> }> };

export type SaveCollectionEntryModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
  hasGraphVariant: Scalars['Boolean']['input'];
  isSandbox: Scalars['Boolean']['input'];
}>;


export type SaveCollectionEntryModalQuery = { service?: { __typename: 'Service', id: ID['output'], title: String['output'], variant: { __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }> } | null, account: { __typename: 'Account', id: ID['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], mcpDefaultCollection:
        | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }
        | { __typename: 'PermissionError' }
      , operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }> }> } | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }>, memberships?: Array<{ __typename: 'UserMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], mcpDefaultCollection:
                | { __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }
                | { __typename: 'PermissionError' }
              , operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'] }>, permissions: { __typename: 'OperationCollectionPermissions', canEditOperations: Boolean['output'] } }> }> }> } }> }
   | null };

export type AddOperationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  operationInput: OperationCollectionEntryStateInput;
}>;


export type AddOperation = { operationCollection: { __typename: 'OperationCollectionMutation', addOperation:
      | { __typename: 'OperationCollectionEntry', id: ID['output'], createdBy:
          | { __typename: 'InternalIdentity', id: ID['output'], name: String['output'] }
          | { __typename: 'Service', id: ID['output'], name: String['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
          | { __typename: 'User', id: ID['output'], name: String['output'] }
         | null, collection: { __typename: 'OperationCollection', id: ID['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'] }>, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], sharedHeaders: String['output'] | null }> } }
      | { __typename: 'PermissionError', message: String['output'] }
      | { __typename: 'ValidationError', message: String['output'] }
     | null } | null };

export type CreateDefaultOperationCollectionMutationVariables = Exact<{
  variantRefs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isSandbox: Scalars['Boolean']['input'];
}>;


export type CreateDefaultOperationCollectionMutation = { createOperationCollection:
    | { __typename: 'NotFoundError', message: String['output'] }
    | { __typename: 'OperationCollection', id: ID['output'], isShared: Boolean['output'], isSandbox: Boolean['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }>, createdBy?:
        | { __typename: 'InternalIdentity', id: ID['output'] }
        | { __typename: 'Service', id: ID['output'] }
        | { __typename: 'ServiceAccount', id: ID['output'] }
        | { __typename: 'User', id: ID['output'], sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }
       | null }
    | { __typename: 'PermissionError', message: String['output'] }
    | { __typename: 'ValidationError', message: String['output'] }
   };

export type SubgraphConfigPageQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type SubgraphConfigPageQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], avatarUrl: String['output'] | null, roles: { __typename: 'ServiceRoles', canQueryStats: Boolean['output'], canManageVariants: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], subgraphs: Array<{ __typename: 'FederatedImplementingService', name: String['output'], updatedAt: Timestamp['output'], url: String['output'] | null, activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } }> | null } | null, subgraphs: Array<{ __typename: 'FederatedImplementingService', name: String['output'], updatedAt: Timestamp['output'], url: String['output'] | null, activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } }> | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'] }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null } | null } | null };

export type SubgraphConfigPageSubgraphs = { __typename: 'FederatedImplementingService', name: String['output'], updatedAt: Timestamp['output'], url: String['output'] | null, activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } };

export type AddSubgraphCheckSchemaMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  partialSchema: PartialSchemaInput;
}>;


export type AddSubgraphCheckSchemaMutation = { service: { __typename: 'ServiceMutation', checkPartialSchema: { __typename: 'CheckPartialSchemaResult', compositionValidationResult: { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] } | null> }> } } } | null };

export type DeleteSubgraphModalValidatePartialSchemaMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  runCheckOnly: Scalars['Boolean']['input'];
}>;


export type DeleteSubgraphModalValidatePartialSchemaMutation = { service: { __typename: 'ServiceMutation', removeImplementingServiceAndTriggerComposition: { __typename: 'CompositionAndRemoveResult', graphCompositionID: String['output'], updatedGateway: Boolean['output'], errors: Array<{ __typename: 'SchemaCompositionError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] } | null> } | null> } } | null };

export type EditSubgraphRoutingUrlModalQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  subgraphName: Scalars['ID']['input'];
}>;


export type EditSubgraphRoutingUrlModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], subgraph: { __typename: 'FederatedImplementingService', activePartialSchema: { __typename: 'PartialSchema', sdl: String['output'] } } | null } | null } | null };

export type EditRoutingUrlModalMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
  newRoutingUrl: Scalars['String']['input'];
  revision: Scalars['String']['input'];
  partialSchema: PartialSchemaInput;
}>;


export type EditRoutingUrlModalMutation = { service: { __typename: 'ServiceMutation', upsertImplementingServiceAndTriggerComposition: { __typename: 'CompositionAndUpsertResult', graphCompositionID: String['output'], updatedGateway: Boolean['output'] } | null } | null };

export type AddSubgraphModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AddSubgraphModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type AddSubgraphModalProvisionKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AddSubgraphModalProvisionKeyMutation = { user: { __typename: 'UserMutation', provisionKey: { __typename: 'ApiKeyProvision', apiKey:
        | { __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }
        | { __typename: 'GraphOsKey', id: ID['output'], token: String['output'] }
        | { __typename: 'UserApiKey', id: ID['output'], token: String['output'] }
       } | null } | null };

export type SandboxLayoutVariables = Exact<{ [key: string]: never; }>;


export type SandboxLayout = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type VariantLayoutUserQueryVariables = Exact<{ [key: string]: never; }>;


export type VariantLayoutUserQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', internalAdminRole: InternalMdgAdminRole | null, id: ID['output'], memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type VariantLayoutGraphQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantLayoutGraphQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, isContract: Boolean['output'] | null, url: String['output'] | null, isProposal: Boolean['output'] | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null } | null, account: { __typename: 'Account', id: ID['output'] } | null, apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }> | null } | null };

export type BuildErrorModalQueryVariables = Exact<{
  graphRef: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type BuildErrorModalQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null, graph: { __typename: 'Service', id: ID['output'], mostRecentCompositionPublish: { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] } | null> }> } | null } }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type LaunchErrorModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
  skipLatestLaunch: Scalars['Boolean']['input'];
  skipSpecificLaunch: Scalars['Boolean']['input'];
}>;


export type LaunchErrorModalQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], isContract: Boolean['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canManageBuildConfig: Boolean['output'] }, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, latestLaunch?: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
           | null } | null } | null, launch?: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
           | null } | null } | null } | null } | null };

export type LaunchFragment = { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
      | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', code: String['output'] | null, message: String['output'], locations: Array<{ __typename: 'SourceLocation', column: Int['output'], line: Int['output'] }> }> }
      | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'] } }
     | null } | null };

export type ContractVariantFragment = { __typename: 'GraphVariant', id: ID['output'], name: String['output'], isContract: Boolean['output'] | null, derivedVariantCount: Int['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null } | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null };

export type VariantSettings__ContractsPageVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantSettings__ContractsPage = { graph: { __typename: 'Service', id: ID['output'], registrySubscriptionsEnabled: Boolean['output'], roles: { __typename: 'ServiceRoles', canManageVariants: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], hasManagedSubgraphs: Boolean['output'] | null, name: String['output'], isContract: Boolean['output'] | null, derivedVariantCount: Int['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], createdAt: Timestamp['output'] } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null } | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'], isProtected: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, name: String['output'], isContract: Boolean['output'] | null, derivedVariantCount: Int['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], typeCount: Int['output'] } } | null, contractFilterConfig: { __typename: 'FilterConfig', include: Array<String['output']>, exclude: Array<String['output']> } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null } | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null }> } | null };

export type VariantSettings__ExplorerPageVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantSettings__ExplorerPage = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, account: { __typename: 'Account', id: ID['output'] } | null, schemaTag: { __typename: 'SchemaTag', id: ID['output'] } | null, variant: { __typename: 'GraphVariant', url: String['output'] | null, id: ID['output'], subscriptionUrl: String['output'] | null, sendCookies: Boolean['output'] | null } | null } | null };

export type VariantGeneralSettingsPageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantGeneralSettingsPageQuery = { graph: { __typename: 'Service', id: ID['output'], title: String['output'], defaultBuildPipelineTrack: String['output'] | null, defaultBuildPipelineTrackUpdatedAt: Timestamp['output'] | null, graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], isProtected: Boolean['output'], isPublic: Boolean['output'], isContract: Boolean['output'] | null, name: String['output'], derivedVariantCount: Int['output'], compositionVersion: String['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, buildConfigUpdatedAt: Timestamp['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] } } | null, contractFilterConfig: { __typename: 'FilterConfig', include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null, persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'] } | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null> } | null, roles: { __typename: 'ServiceRoles', canManageBuildConfig: Boolean['output'] } | null, persistedQueryLists: Array<{ __typename: 'PersistedQueryList', id: ID['output'] }> | null } | null };

export type BuildConfigCard_graph_Fragment = { __typename: 'Service', id: ID['output'], defaultBuildPipelineTrack: String['output'] | null, defaultBuildPipelineTrackUpdatedAt: Timestamp['output'] | null, graphType: GraphType, roles: { __typename: 'ServiceRoles', canManageBuildConfig: Boolean['output'] } | null };

export type BuildConfigCard_variant_Fragment = { __typename: 'GraphVariant', id: ID['output'], compositionVersion: String['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, buildConfigUpdatedAt: Timestamp['output'] | null, name: String['output'], buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null> };

export type ContractVariantSettingsCardFragment = { __typename: 'Service', id: ID['output'], roles: { __typename: 'ServiceRoles', canManageBuildConfig: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] } } | null, contractFilterConfig: { __typename: 'FilterConfig', include: Array<String['output']>, exclude: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } | null };

export type DeleteVariantSettingsCardFragment = { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], derivedVariantCount: Int['output'] } | null };

export type FederationVersionInfoFragment = { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null> };

export type PersistedQueriesConfigCardServiceFragment = { __typename: 'Service', id: ID['output'], persistedQueryLists: Array<{ __typename: 'PersistedQueryList', id: ID['output'] }> | null };

export type PersistedQueriesConfigCardVariantFragment = { __typename: 'GraphVariant', id: ID['output'], persistedQueryList: { __typename: 'PersistedQueryList', id: ID['output'], name: String['output'] } | null };

export type UpdateIsProtectedVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isProtected: Scalars['Boolean']['input'];
}>;


export type UpdateIsProtected = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateIsProtected: { __typename: 'GraphVariant', id: ID['output'], isProtected: Boolean['output'] } | null } | null } | null };

export type UpdateIsPublicVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isPublic: Scalars['Boolean']['input'];
}>;


export type UpdateIsPublic = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', id: ID['output'], updateVariantIsPublic: { __typename: 'GraphVariant', id: ID['output'], isPublic: Boolean['output'] } | null } | null } | null };

export type ConfigureBuildPipelineModalFragment = { __typename: 'GraphVariant', id: ID['output'], name: String['output'], compositionVersion: String['output'] | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null>, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null };

export type UpdateBuildPipelineConfigMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
  federationVersion: Scalars['FederationVersion']['input'];
  tagInApiSchema: Scalars['Boolean']['input'];
  skipLaunch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBuildPipelineConfigMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', buildConfig: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], compositionVersion: String['output'] | null, buildConfig: { __typename: 'BuildConfig', federationVersion: FederationVersion['output'], tagInApiSchema: Boolean['output'] } | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', federationVersion: FederationVersion['output'], displayName: String['output'], badge: BuildPipelineTrackBadge | null, minimumRouterVersion: String['output'] | null, compositionVersion: String['output'] } | null>, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
            | { __typename: 'CompositionBuildInput', version: String['output'] | null }
            | { __typename: 'FilterBuildInput' }
           } | null } | null } | null } | null };

export type ContractBasicDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type ContractBasicDetailsQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], isContract: Boolean['output'] | null, compositionVersion: String['output'] | null, supportedDirectives: Array<{ __typename: 'DirectiveSupportStatus', enabled: Boolean['output'], name: String['output'] }> | null }> } | null };

export type CheckWorkflowStatusWidgetFragment = { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, graph: { __typename: 'Service', id: ID['output'] }, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'] } | null, buildTask:
    | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
        | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
        | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
       | null, buildResult:
        | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
        | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
    | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
        | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
        | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
       | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
   | null, operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], createdAt: Timestamp['output'], numberOfCheckedOperations: Int['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } } | null };

export type UpsertContractMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  sourceVariant: Scalars['String']['input'];
  contractVariantName: Scalars['String']['input'];
  filterConfig: FilterConfigInput;
  initiateLaunch: Scalars['Boolean']['input'];
}>;


export type UpsertContractMutation = { service: { __typename: 'ServiceMutation', upsertContractVariant:
      | { __typename: 'ContractVariantUpsertErrors', errorMessages: Array<String['output']> }
      | { __typename: 'ContractVariantUpsertSuccess', contractVariant: { __typename: 'GraphVariant', id: ID['output'] } }
     } | null };

export type CheckWorkflowStatusQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  checkWorkflowId: Scalars['ID']['input'];
  proposalsUseHasWarnings: Scalars['Boolean']['input'];
}>;


export type CheckWorkflowStatusQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], status: CheckWorkflowStatus, baseVariant: { __typename: 'GraphVariant', id: ID['output'], graphId: String['output'], name: String['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'] } | null } | null, graph: { __typename: 'Service', id: ID['output'] }, buildTask:
        | { __typename: 'CompositionCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], errors: Array<{ __typename: 'SchemaCompositionError', message: String['output'], code: String['output'] | null, locations: Array<{ __typename: 'SourceLocation', line: Int['output'], column: Int['output'] } | null> }> }
           | null, buildResult:
            | { __typename: 'CompositionBuildCheckFailed', id: ID['output'] }
            | { __typename: 'CompositionBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
        | { __typename: 'FilterCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, buildResult:
            | { __typename: 'FilterBuildCheckFailed', id: ID['output'], errors: Array<{ __typename: 'BuildError', message: String['output'], failedStep: String['output'] | null }> }
            | { __typename: 'FilterBuildCheckPassed', id: ID['output'] }
           | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
       | null, operationsTask: { __typename: 'OperationsCheckTask', id: ID['output'], status: CheckWorkflowTaskStatus, createdAt: Timestamp['output'], completedAt: Timestamp['output'] | null, result: { __typename: 'OperationsCheckResult', id: ID['output'], createdAt: Timestamp['output'], numberOfCheckedOperations: Int['output'], checkSeverity: ChangeSeverity, numberOfAffectedOperations: Int['output'], crossedOperationThreshold: Int['output'] | null } | null, workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } } | null } | null } | null };

export type ContractFilterConfigEditModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  sourceVariant: Scalars['String']['input'];
  contractName: Scalars['String']['input'];
  isCreateWorkflow: Scalars['Boolean']['input'];
}>;


export type ContractFilterConfigEditModalQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiDocument: GraphQLDocument['output'], coreDocument: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'], tags: Array<String['output']> } }
           | null } | null } | null } | null, contractVariant?: { __typename: 'GraphVariant', id: ID['output'], contractFilterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], input:
            | { __typename: 'CompositionBuildInput' }
            | { __typename: 'FilterBuildInput', filterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
          , result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiDocument: GraphQLDocument['output'], coreDocument: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'] } }
           | null } | null } | null } | null } | null };

export type LatestContractLaunchQueryVariables = Exact<{
  contractGraphRef: Scalars['ID']['input'];
  fetchLatestContract: Scalars['Boolean']['input'];
}>;


export type LatestContractLaunchQuery = { latestContract:
    | { __typename: 'GraphVariant', id: ID['output'], latestApprovedLaunch: { __typename: 'Launch', id: ID['output'], build?: { __typename: 'Build', id: ID['output'], input:
            | { __typename: 'CompositionBuildInput' }
            | { __typename: 'FilterBuildInput', schemaHash: String['output'], filterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } }
          , result:
            | { __typename: 'BuildFailure' }
            | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiDocument: GraphQLDocument['output'], coreDocument: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'] } }
           | null } | null } | null }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type StartContractPreviewMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  sourceVariant: Scalars['String']['input'];
  filters: FilterConfigInput;
}>;


export type StartContractPreviewMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', contractPreviewAsync: { __typename: 'ContractPreviewAsyncBuild', buildID: ID['output'] } } | null } | null };

export type ContractPreviewPollStatusQueryVariables = Exact<{
  sourceGraphRef: Scalars['ID']['input'];
  buildID: Scalars['ID']['input'];
}>;


export type ContractPreviewPollStatusQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], contractPreviewStatus:
        | { __typename: 'ContractPreviewAsyncPending', status: ContractPreviewAsyncPendingStatus }
        | { __typename: 'ContractPreviewErrors' }
        | { __typename: 'ContractPreviewSuccess' }
       | null }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type ContractPreviewResultQueryVariables = Exact<{
  sourceGraphRef: Scalars['ID']['input'];
  buildID: Scalars['ID']['input'];
}>;


export type ContractPreviewResultQuery = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], contractPreviewStatus:
        | { __typename: 'ContractPreviewAsyncPending' }
        | { __typename: 'ContractPreviewErrors', errors: Array<String['output']>, failedAt: ContractVariantFailedStep, upstreamLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
                | { __typename: 'BuildFailure' }
                | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiDocument: GraphQLDocument['output'], coreDocument: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'] } }
               | null } | null } }
        | { __typename: 'ContractPreviewSuccess', apiDocument: String['output'], coreDocument: String['output'], fieldCount: Int['output'], typeCount: Int['output'], upstreamLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
                | { __typename: 'BuildFailure' }
                | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], apiDocument: GraphQLDocument['output'], coreDocument: GraphQLDocument['output'], fieldCount: Int['output'], typeCount: Int['output'] } }
               | null } | null } }
       | null }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type SubmitFilterCheckAsyncMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  checkConfig: FilterCheckAsyncInput;
}>;


export type SubmitFilterCheckAsyncMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', submitFilterCheckAsync:
        | { __typename: 'CheckRequestSuccess', workflowID: ID['output'] }
        | { __typename: 'InvalidInputError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'PlanError' }
        | { __typename: 'RateLimitExceededError' }
       } | null } | null };

export type LatestLaunchDetailsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type LatestLaunchDetailsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'] } | null } | null } | null };

export type ContractDetailsHeaderFragment = { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canQueryBuildConfig: Boolean['output'], canManageExplorerSettings: Boolean['output'] }, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'] } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, gitContext: { __typename: 'GitContext', committer: String['output'] | null } | null } | null } | null };

export type ContractDetailsModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type ContractDetailsModalQuery = { service: { __typename: 'Service', id: ID['output'], avatarUrl: String['output'] | null, title: String['output'], schemaTag: { __typename: 'SchemaTag', id: ID['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], url: String['output'] | null, permissions: { __typename: 'GraphVariantPermissions', canManageBuildConfig: Boolean['output'], canQueryBuildConfig: Boolean['output'], canManageExplorerSettings: Boolean['output'] }, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, contractFilterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']>, hideUnreachableTypes: Boolean['output'] } | null, latestApprovedLaunch: { __typename: 'Launch', id: ID['output'] } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'] }, gitContext: { __typename: 'GitContext', committer: String['output'] | null } | null } | null } | null } | null };

export type CollectionEntryOperationFragment = { __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] };

export type CollectionEntryFragment = { __typename: 'OperationCollection', id: ID['output'], isFavorite: Boolean['output'], name: String['output'], description: String['output'] | null, isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> };

export type VariantsHomepageQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type VariantsHomepageQuery = { service: { __typename: 'Service', id: ID['output'], title: String['output'], avatarUrl: String['output'] | null, accountId: ID['output'] | null, variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], isContract: Boolean['output'] | null, url: String['output'] | null, isFavoriteOfCurrentUser: Boolean['output'], readme: { __typename: 'Readme', id: ID['output'], content: String['output'], lastUpdatedTime: Timestamp['output'] | null, lastUpdatedBy:
          | { __typename: 'InternalIdentity', name: String['output'], id: ID['output'] }
          | { __typename: 'Service', id: ID['output'], title: String['output'] }
          | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
          | { __typename: 'User', fullName: String['output'], id: ID['output'] }
         | null }, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], createdAt: Timestamp['output'], gitContext: { __typename: 'GitContext', committer: String['output'] | null } | null, schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], typeCount: Int['output'], fieldCount: Int['output'] } } & ({ __typename: 'SchemaTag', history: Array<{ __typename: 'SchemaTag', id: ID['output'], createdAt: Timestamp['output'], publishedAt: Timestamp['output'], diffToPrevious: { __typename: 'SchemaDiff', tag: String['output'] | null, changes: Array<{ __typename: 'Change', code: String['output'], parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null }> } | null }> } | { __typename: 'SchemaTag', history?: never }) & ({ __typename: 'SchemaTag', history: Array<{ __typename: 'SchemaTag', id: ID['output'], createdAt: Timestamp['output'], publishedAt: Timestamp['output'], diffToPrevious: { __typename: 'SchemaDiff', tag: String['output'] | null, changes: Array<{ __typename: 'Change', code: String['output'], parentNode: { __typename: 'NamedIntrospectionType', name: String['output'] | null } | null, childNode: { __typename: 'NamedIntrospectionValue', name: String['output'] | null, printedType: String['output'] | null } | null, argNode: { __typename: 'NamedIntrospectionArg', name: String['output'] | null } | null }> } | null }> } | { __typename: 'SchemaTag', history?: never }) | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, contractFilterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']> } | null, links: Array<{ __typename: 'LinkInfo', id: ID['output'], title: String['output'] | null, type: LinkInfoType, url: String['output'] }> | null } | null } | null };

export type ContractHomePageGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], sourceVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null, contractFilterConfig: { __typename: 'FilterConfig', exclude: Array<String['output']>, include: Array<String['output']> } | null };

export type ReadmeModalQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  isProposalRoute: Scalars['Boolean']['input'];
}>;


export type ReadmeModalQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], readme?: { __typename: 'Readme', id: ID['output'], content: String['output'] }, proposal?: { __typename: 'Proposal', id: ID['output'], description: String['output'] } | null } | null } | null };

export type UpdateVariantReadmeMutationVariables = Exact<{
  readmeContent: Scalars['String']['input'];
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type UpdateVariantReadmeMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateVariantReadme: { __typename: 'GraphVariant', id: ID['output'], readme: { __typename: 'Readme', id: ID['output'], content: String['output'] } } | null } | null } | null };

export type UpdateProposalDescriptionMutationVariables = Exact<{
  input: UpdateDescriptionInput;
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type UpdateProposalDescriptionMutation = { graph: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', proposal:
        | { __typename: 'NotFoundError' }
        | { __typename: 'PermissionError' }
        | { __typename: 'ProposalMutation', updateDescription:
            | { __typename: 'PermissionError' }
            | { __typename: 'Proposal', id: ID['output'], description: String['output'] }
            | { __typename: 'ValidationError' }
           }
        | { __typename: 'ValidationError' }
       } | null } | null };

export type OperationCollectionReadMeQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type OperationCollectionReadMeQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], isFavorite: Boolean['output'], name: String['output'], description: String['output'] | null, isShared: Boolean['output'], operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'] }> }> } | null } | null };

export type GraphHeaderDataServiceFragment = { __typename: 'Service', accountId: ID['output'] | null, id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null, isFavoriteOfCurrentUser: Boolean['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], createdAt: Timestamp['output'], gitContext: { __typename: 'GitContext', committer: String['output'] | null } | null, schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], typeCount: Int['output'], fieldCount: Int['output'] } } | null } | null };

export type AddHomepageLinkMutationVariables = Exact<{
  linkType: LinkInfoType;
  linkUrl: Scalars['String']['input'];
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type AddHomepageLinkMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', id: ID['output'], addLinkToVariant: { __typename: 'GraphVariant', id: ID['output'], links: Array<{ __typename: 'LinkInfo', type: LinkInfoType, url: String['output'], title: String['output'] | null, id: ID['output'] }> | null } } | null } | null };

export type RemoveLinkFromVariantMutationVariables = Exact<{
  linkId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type RemoveLinkFromVariantMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', id: ID['output'], removeLinkFromVariant: { __typename: 'GraphVariant', id: ID['output'], links: Array<{ __typename: 'LinkInfo', type: LinkInfoType, url: String['output'], title: String['output'] | null, id: ID['output'] }> | null } } | null } | null };

export type LinksContentGraphVariantFragment = { __typename: 'GraphVariant', id: ID['output'], links: Array<{ __typename: 'LinkInfo', id: ID['output'], title: String['output'] | null, type: LinkInfoType, url: String['output'] }> | null };

export type ReadmeCardReadmeFragment = { __typename: 'Readme', id: ID['output'], content: String['output'], lastUpdatedTime: Timestamp['output'] | null, lastUpdatedBy:
    | { __typename: 'InternalIdentity', name: String['output'], id: ID['output'] }
    | { __typename: 'Service', id: ID['output'], title: String['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'], name: String['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'] }
   | null };

export type ReadmeMarkdownServiceFragment = { __typename: 'Service', id: ID['output'], title: String['output'], variant: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null } | null };

export type OperationCollectionEntriesReadmeQueryVariables = Exact<{
  collectionEntryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OperationCollectionEntriesReadmeQuery = { operationCollectionEntries: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'], name: String['output'], currentOperationRevision: { __typename: 'OperationCollectionEntryState', body: String['output'] }, collection: { __typename: 'OperationCollection', id: ID['output'], name: String['output'] } }> };

export type OperationCollectionCollectionsReadmeQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  variant: Scalars['String']['input'];
}>;


export type OperationCollectionCollectionsReadmeQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'], description: String['output'] | null, operations: Array<{ __typename: 'OperationCollectionEntry', id: ID['output'] }> }> } | null } | null };

export type UI__AccountIdAvailableQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UI__AccountIdAvailableQuery = { accountIDAvailable: Boolean['output'] };

export type NewOrganizationModalDefaultPlanQueryVariables = Exact<{
  planId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NewOrganizationModalDefaultPlanQuery = { plan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'] } | null };

export type NewOrgMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewOrgMutation = { newAccount: { __typename: 'Account', id: ID['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'], tier: BillingPlanTier } } | null };

export type UI__SignUpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  trackingValues?: InputMaybe<UserTrackingInput>;
}>;


export type UI__SignUpMutation = { signUp: { __typename: 'User', id: ID['output'], email: String['output'] | null, fullName: String['output'] } | null };

export type UI__SetUserDetailsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
}>;


export type UI__SetUserDetailsMutation = { userAccept: { __typename: 'UserMutation', acceptPrivacyPolicy: Void['output'] | null } | null, user: { __typename: 'UserMutation', update: { __typename: 'User', id: ID['output'], email: String['output'] | null, fullName: String['output'], acceptedPrivacyPolicyAt: Timestamp['output'] | null } | null } | null };

export type AccountIdsAvailableQueryVariables = Exact<{
  accountId1: Scalars['ID']['input'];
  accountId2: Scalars['ID']['input'];
  accountId3: Scalars['ID']['input'];
  accountId4: Scalars['ID']['input'];
}>;


export type AccountIdsAvailableQuery = { accountId1: Boolean['output'], accountId2: Boolean['output'], accountId3: Boolean['output'], accountId4: Boolean['output'] };

export type UpdateSurveyVariables = Exact<{
  orgId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
  surveyState: Array<SurveyQuestionInput> | SurveyQuestionInput;
  surveyIdVersion: Scalars['Int']['input'];
}>;


export type UpdateSurvey = { updateSurvey: { __typename: 'Survey', id: String['output'], questionAnswers: Array<{ __typename: 'SurveyQuestionAnswer', questionKey: String['output'], answerValue: String['output'] | null }> } };

export type UI__VerifyEmailMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}>;


export type UI__VerifyEmailMutation = { user: { __typename: 'UserMutation', verifyEmail: { __typename: 'User', id: ID['output'], email: String['output'] | null, emailVerified: Boolean['output'] } | null } | null };

export type UI__ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UI__ResetPasswordMutation = { resetPassword: Void['output'] | null };

export type CloudyGraphsWidgetStoryVariables = Exact<{ [key: string]: never; }>;


export type CloudyGraphsWidgetStory = { account: { __typename: 'Account', id: ID['output'], graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], requestsInLastDay: Long['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }> }> } | null };

export type CloudyGraphsWidgetAccountFragment = { __typename: 'Account', id: ID['output'], graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], requestsInLastDay: Long['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }> }> };

export type CloudyGraphsWidget__DeleteGraphMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type CloudyGraphsWidget__DeleteGraphMutation = { service: { __typename: 'ServiceMutation', delete: Void['output'] | null } | null };

export type CloudyGraphsWidget__MigrateGraphMutationVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type CloudyGraphsWidget__MigrateGraphMutation = { service: { __typename: 'ServiceMutation', makeSelfHostedIfCloudy: Void['output'] | null } | null };

export type MemberManagementWidgetStoryVariables = Exact<{ [key: string]: never; }>;


export type MemberManagementWidgetStory = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, billingContactEmail: String['output'] | null, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], avatarUrl: String['output'] | null, fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null } }> | null } | null };

export type MemberManagementWidgetAccountFragment = { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, billingContactEmail: String['output'] | null, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], avatarUrl: String['output'] | null, fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null } }> | null };

export type MemberManagementWidget__RemoveMemberMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type MemberManagementWidget__RemoveMemberMutation = { account: { __typename: 'AccountMutation', removeMember: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'] } }> | null } | null } | null };

export type ResolvePlanIssuesPageQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type ResolvePlanIssuesPageQuery = { account: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, billingContactEmail: String['output'] | null, planUpgradeOptions: Array<{ __typename: 'OnboardingPlanOption', name: String['output'], planReadableId: ID['output'] | null, billingCycleAnchor: BillingCycleAnchor, canTransitionTo: Boolean['output'], description: String['output'] | null, isSelfService: Boolean['output'], pricePerUnitDescription: String['output'], priceSimpleDescription: String['output'], includedFeatures: Array<String['output']>, excludedFeatures: Array<String['output']>, promoCreditsInCents: Int['output'] | null, totalDueOnSignupInCents: Int['output'] | null, ineligibleReasons: Array<
        | { __typename: 'HasCloudyGraphs', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'SsoEnabled', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'TooManyUsers', severity: PlanIneligibilityReasonSeverity, currentUsers: Int['output'], maxUsers: Int['output'] }
      > }> | null, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'], avatarUrl: String['output'] | null, fullName: String['output'], email: String['output'] | null, lastAuthenticatedAt: Timestamp['output'] | null } }> | null, graphs: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], requestsInLastDay: Long['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }> }> } | null };

export type SelectPlanCreditCardFormFragment = { __typename: 'Account', id: ID['output'], internalID: ID['output'], billingContactEmail: String['output'] | null, billingInfo: { __typename: 'BillingInfo', name: String['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null, subscriptions: Array<{ __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] }> };

export type SelectPlanPageWrapperQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SelectPlanPageWrapperQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', email: String['output'] | null, id: ID['output'] }
   | null, account: { __typename: 'Account', id: ID['output'], internalID: ID['output'], billingContactEmail: String['output'] | null, isLocked: Boolean['output'] | null, billingInfo: { __typename: 'BillingInfo', name: String['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null, subscriptions: Array<{ __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] }>, currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'], kind: BillingPlanKind, tier: BillingPlanTier, readableId: ID['output'] }, planUpgradeOptions: Array<{ __typename: 'OnboardingPlanOption', name: String['output'], planReadableId: ID['output'] | null, billingCycleAnchor: BillingCycleAnchor, canTransitionTo: Boolean['output'], description: String['output'] | null, isSelfService: Boolean['output'], pricePerUnitDescription: String['output'], priceSimpleDescription: String['output'], includedFeatures: Array<String['output']>, excludedFeatures: Array<String['output']>, promoCreditsInCents: Int['output'] | null, totalDueOnSignupInCents: Int['output'] | null, ineligibleReasons: Array<
        | { __typename: 'HasCloudyGraphs', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'SsoEnabled', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'TooManyUsers', severity: PlanIneligibilityReasonSeverity, currentUsers: Int['output'], maxUsers: Int['output'] }
      > }> | null } | null, recommendedPlanOnSignup: { __typename: 'OnboardingPlanOption', planReadableId: ID['output'] | null } | null };

export type SelectPlanToSignUpPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectPlanToSignUpPageQuery = { recommendedPlanOnSignup: { __typename: 'OnboardingPlanOption', name: String['output'], planReadableId: ID['output'] | null, description: String['output'] | null, pricePerUnitDescription: String['output'], priceSimpleDescription: String['output'], promoCreditsInCents: Int['output'] | null, includedFeatures: Array<String['output']> } | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], email: String['output'] | null, id: ID['output'] }
   | null };

export type SelectPlanToSignUpPageAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type SelectPlanToSignUpPageAccountQuery = { account: { __typename: 'Account', id: ID['output'], currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], readableId: ID['output'] }, subscriptions: Array<{ __typename: 'BillingSubscription', uuid: ID['output'], state: SubscriptionState }> } | null };

export type SelectPlanToUpgradeStoryQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectPlanToUpgradeStoryQuery = { account: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'], kind: BillingPlanKind, tier: BillingPlanTier, readableId: ID['output'] }, planUpgradeOptions: Array<{ __typename: 'OnboardingPlanOption', name: String['output'], planReadableId: ID['output'] | null, billingCycleAnchor: BillingCycleAnchor, canTransitionTo: Boolean['output'], description: String['output'] | null, isSelfService: Boolean['output'], pricePerUnitDescription: String['output'], priceSimpleDescription: String['output'], includedFeatures: Array<String['output']>, excludedFeatures: Array<String['output']>, promoCreditsInCents: Int['output'] | null, totalDueOnSignupInCents: Int['output'] | null, ineligibleReasons: Array<
        | { __typename: 'HasCloudyGraphs', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'SsoEnabled', severity: PlanIneligibilityReasonSeverity }
        | { __typename: 'TooManyUsers', severity: PlanIneligibilityReasonSeverity, currentUsers: Int['output'], maxUsers: Int['output'] }
      > }> | null } | null, recommendedPlanOnSignup: { __typename: 'OnboardingPlanOption', planReadableId: ID['output'] | null } | null };

export type SelectPlanToUpgradePageFragment = { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, currentSubscription: { __typename: 'BillingSubscription', state: SubscriptionState, id: ID['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'], kind: BillingPlanKind, tier: BillingPlanTier, readableId: ID['output'] } };

export type SelectPlanToUpgradePageRecommendedPlanFragment = { recommendedPlanOnSignup: { __typename: 'OnboardingPlanOption', planReadableId: ID['output'] | null } | null };

export type PlanUpgradeOptionsFragment = { __typename: 'Account', id: ID['output'], planUpgradeOptions: Array<{ __typename: 'OnboardingPlanOption', name: String['output'], planReadableId: ID['output'] | null, billingCycleAnchor: BillingCycleAnchor, canTransitionTo: Boolean['output'], description: String['output'] | null, isSelfService: Boolean['output'], pricePerUnitDescription: String['output'], priceSimpleDescription: String['output'], includedFeatures: Array<String['output']>, excludedFeatures: Array<String['output']>, promoCreditsInCents: Int['output'] | null, totalDueOnSignupInCents: Int['output'] | null, ineligibleReasons: Array<
      | { __typename: 'HasCloudyGraphs', severity: PlanIneligibilityReasonSeverity }
      | { __typename: 'SsoEnabled', severity: PlanIneligibilityReasonSeverity }
      | { __typename: 'TooManyUsers', severity: PlanIneligibilityReasonSeverity, currentUsers: Int['output'], maxUsers: Int['output'] }
    > }> | null };

export type UpdateOidcConfigurationVariables = Exact<{
  key: Scalars['String']['input'];
  config: OidcConfigurationInput;
}>;


export type UpdateOidcConfiguration = { addOidcConfigurationToBaseConnection:
    | { __typename: 'BaseConnection', id: ID['output'] }
    | { __typename: 'OidcConnection', id: ID['output'] }
    | { __typename: 'SamlConnection', id: ID['output'] }
   | null };

export type CheckOidcConfigurationKeyVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CheckOidcConfigurationKey = { checkSsoConfigurationKey: Boolean['output'] };

export type DefaultPlanNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DefaultPlanNameQuery = { plan: { __typename: 'BillingPlan', id: ID['output'], name: String['output'] } | null };

export type WelcomeFormAcceptInvitationMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  joinToken: Scalars['String']['input'];
}>;


export type WelcomeFormAcceptInvitationMutation = { joinAccount: { __typename: 'Account', id: ID['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier } } | null };

export type UserMembershipDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMembershipDataQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], email: String['output'] | null, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type LegacyBuildTaskRedirectQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
}>;


export type LegacyBuildTaskRedirectQuery = { service: { __typename: 'Service', id: ID['output'], checkWorkflowTask:
      | { __typename: 'CompositionCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'CustomCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'DownstreamCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'FilterCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'LintCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'OperationsCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
      | { __typename: 'ProposalsCheckTask', id: ID['output'], workflow: { __typename: 'CheckWorkflow', id: ID['output'], baseVariant: { __typename: 'GraphVariant', id: ID['output'], name: String['output'] } | null } }
     | null } | null };

export type UserApiKeysCardFragment = { __typename: 'User', id: ID['output'], apiKeys: Array<{ __typename: 'UserApiKey', id: ID['output'], keyName: String['output'] | null, lastUsed: Timestamp['output'] | null }> };

export type GenerateUserAPIKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  keyName: Scalars['String']['input'];
}>;


export type GenerateUserAPIKeyMutation = { user: { __typename: 'UserMutation', user: { __typename: 'User', id: ID['output'] }, newKey: { __typename: 'UserApiKey', id: ID['output'], token: String['output'], keyName: String['output'] | null } } | null };

export type RenameUserAPIKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newKey: Scalars['String']['input'];
}>;


export type RenameUserAPIKeyMutation = { user: { __typename: 'UserMutation', user: { __typename: 'User', id: ID['output'] }, renameKey: { __typename: 'UserApiKey', id: ID['output'], token: String['output'], keyName: String['output'] | null } | null } | null };

export type RemoveUserAPIKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type RemoveUserAPIKeyMutation = { user: { __typename: 'UserMutation', removeKey: Void['output'] | null, user: { __typename: 'User', id: ID['output'] } } | null };

export type UI__DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UI__DeleteUserMutation = { user: { __typename: 'UserMutation', hardDelete: Void['output'] | null } | null };

export type UI__IsUserProbablyBillingContactQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UI__IsUserProbablyBillingContactQuery = { user: { __typename: 'User', id: ID['output'], email: String['output'] | null, memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], name: String['output'], billingContactEmail: String['output'] | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind }, memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null }, user: { __typename: 'User', id: ID['output'] } }> } | null };

export type UserAvatarCardVariables = Exact<{ [key: string]: never; }>;


export type UserAvatarCard = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], avatarUrl: String['output'] | null, canUpdateAvatar: Boolean['output'], id: ID['output'], avatarUpload:
        | { __typename: 'AvatarUploadError' }
        | { __typename: 'MediaUploadInfo', csrfToken: String['output'], maxContentLength: Int['output'], url: String['output'] }
       | null }
   | null };

export type BetaFeaturesCardUserFragment = { __typename: 'User', id: ID['output'], betaFeaturesOn: Boolean['output'] };

export type UI__BetaFeaturesCardChangeBetaFeaturesOnMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  newSetting: Scalars['Boolean']['input'];
}>;


export type UI__BetaFeaturesCardChangeBetaFeaturesOnMutation = { user: { __typename: 'UserMutation', updateBetaFeaturesOn: { __typename: 'User', id: ID['output'], betaFeaturesOn: Boolean['output'] } | null } | null };

export type DeleteUserCardUserFragment = { __typename: 'User', id: ID['output'], email: String['output'] | null };

export type EmailCardUserFragment = { __typename: 'User', id: ID['output'], email: String['output'] | null, canUpdateEmail: Boolean['output'] };

export type UI__EmailCardChangeEmailMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  newEmail: Scalars['String']['input'];
}>;


export type UI__EmailCardChangeEmailMutation = { user: { __typename: 'UserMutation', update: { __typename: 'User', id: ID['output'], email: String['output'] | null } | null } | null };

export type NameCardUserFragment = { __typename: 'User', id: ID['output'], fullName: String['output'], canUpdateFullName: Boolean['output'] };

export type UI__NameCardChangeNameMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
}>;


export type UI__NameCardChangeNameMutation = { user: { __typename: 'UserMutation', update: { __typename: 'User', id: ID['output'], fullName: String['output'] } | null } | null };

export type OrganizationsCardSettingsCommonFragment = { __typename: 'User', id: ID['output'], type: UserType, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], avatarUrl: String['output'] | null, name: String['output'], sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> }>, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null }, user: { __typename: 'User', id: ID['output'] } }> };

export type OrganizationsCardSettingsFragment = { __typename: 'User', id: ID['output'], type: UserType, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], avatarUrl: String['output'] | null, name: String['output'], capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> }>, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null }, user: { __typename: 'User', id: ID['output'] } }> };

export type User__SettingsPageLeaveOrganizationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type User__SettingsPageLeaveOrganizationMutation = { account: { __typename: 'AccountMutation', removeMember: { __typename: 'Account', id: ID['output'], memberships: Array<{ __typename: 'AccountMembership', account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null } | null } | null };

export type PasswordCardSettingsFragment = { __typename: 'User', id: ID['output'], synchronized: Boolean['output'] };

export type UI__PasswordCardChangePasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UI__PasswordCardChangePasswordMutation = { user: { __typename: 'UserMutation', changePassword: Void['output'] | null } | null };

export type GraphvizErrorFieldsVariables = Exact<{
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  ref: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GraphvizErrorFields = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], fieldInsightsList: { __typename: 'GraphVariantFieldInsightsListItemConnection', totalCount: Int['output'], nodes: Array<{ __typename: 'FieldInsightsListItem', parentType: String['output'], fieldName: String['output'], count: Long['output'] | null }> | null } }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type GraphvizUsageFieldsVariables = Exact<{
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  ref: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GraphvizUsageFields = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], fieldInsightsList: { __typename: 'GraphVariantFieldInsightsListItemConnection', totalCount: Int['output'], nodes: Array<{ __typename: 'FieldInsightsListItem', parentType: String['output'], fieldName: String['output'], count: Long['output'] | null }> | null } }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type GraphvizLatencyFieldsVariables = Exact<{
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  ref: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GraphvizLatencyFields = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], fieldInsightsList: { __typename: 'GraphVariantFieldInsightsListItemConnection', totalCount: Int['output'], nodes: Array<{ __typename: 'FieldInsightsListItem', parentType: String['output'], fieldName: String['output'], count: Float['output'] | null }> | null } }
    | { __typename: 'InvalidRefFormat' }
   | null };

export type GraphvizLatencyTypesVariables = Exact<{
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  graphId: Scalars['ID']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
}>;


export type GraphvizLatencyTypes = { service: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', metric: Array<{ __typename: 'ServiceFieldExecutionsRecord', groupBy: { __typename: 'ServiceFieldExecutionsDimensions', parentType: String['output'] | null }, metrics: { __typename: 'ServiceFieldExecutionsMetrics', fieldHistogram: { __typename: 'DurationHistogram', count: Float['output'] | null } } }> } | null } | null };

export type GraphvizUsageTypesVariables = Exact<{
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  graphId: Scalars['ID']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
}>;


export type GraphvizUsageTypes = { service: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', metric: Array<{ __typename: 'ServiceFieldExecutionsRecord', groupBy: { __typename: 'ServiceFieldExecutionsDimensions', parentType: String['output'] | null }, metrics: { __typename: 'ServiceFieldExecutionsMetrics', count: Long['output'] } }> } | null } | null };

export type GraphvizErrorTypesVariables = Exact<{
  filter?: InputMaybe<ServiceFieldExecutionsFilter>;
  graphId: Scalars['ID']['input'];
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
}>;


export type GraphvizErrorTypes = { service: { __typename: 'Service', id: ID['output'], statsWindow: { __typename: 'ServiceStatsWindow', metric: Array<{ __typename: 'ServiceFieldExecutionsRecord', groupBy: { __typename: 'ServiceFieldExecutionsDimensions', parentType: String['output'] | null }, metrics: { __typename: 'ServiceFieldExecutionsMetrics', count: Long['output'] } }> } | null } | null };

export type GraphvizUnusedFieldsVariables = Exact<{
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
  ref: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type GraphvizUnusedFields = { variant:
    | { __typename: 'GraphVariant', id: ID['output'], fieldInsightsList: { __typename: 'GraphVariantFieldInsightsListItemConnection', totalCount: Int['output'], nodes: Array<{ __typename: 'FieldInsightsListItem', parentType: String['output'], fieldName: String['output'] }> | null } }
    | { __typename: 'InvalidRefFormat' }
   | null };

type TopNOperationDetailsFragment_TopNOperationsByErrorPercentageRecord = { __typename: 'TopNOperationsByErrorPercentageRecord', displayName: String['output'], type: OperationType | null, id: String['output'] };

type TopNOperationDetailsFragment_TopNOperationsByP95Record = { __typename: 'TopNOperationsByP95Record', displayName: String['output'], type: OperationType | null, id: String['output'] };

type TopNOperationDetailsFragment_TopNOperationsByRequestRateRecord = { __typename: 'TopNOperationsByRequestRateRecord', displayName: String['output'], type: OperationType | null, id: String['output'] };

export type TopNOperationDetailsFragment =
  | TopNOperationDetailsFragment_TopNOperationsByErrorPercentageRecord
  | TopNOperationDetailsFragment_TopNOperationsByP95Record
  | TopNOperationDetailsFragment_TopNOperationsByRequestRateRecord
;

export type OperationsOverviewQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  compareToTimeFrom: Scalars['Timestamp']['input'];
  compareToTimeTo: Scalars['Timestamp']['input'];
  includeDeltaValues: Scalars['Boolean']['input'];
  topN: Scalars['Int']['input'];
  resolution: Resolution;
  queryStatsFilter?: InputMaybe<ServiceQueryStatsFilter>;
  topNFilter?: InputMaybe<TopNOperationsFilterInput>;
}>;


export type OperationsOverviewQuery = { service: { __typename: 'Service', id: ID['output'], sparklines: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'], serviceTimeP95: Float['output'] | null } } }> } | null, currentStats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', totalLatencyHistogram: { __typename: 'DurationHistogram', serviceTimeP95: Float['output'] | null } } }> } | null, pastStats?: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', requestsWithErrorsCount: Long['output'], totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'], serviceTimeP95: Float['output'] | null } } }> } | null, variant: { __typename: 'GraphVariant', id: ID['output'], topNOperations: { __typename: 'TopNOperationsResult', byRequestRate: Array<{ __typename: 'TopNOperationsByRequestRateRecord', requestCountPerMin: Float['output'], displayName: String['output'], type: OperationType | null, id: String['output'] }>, byErrorPercentage: Array<{ __typename: 'TopNOperationsByErrorPercentageRecord', errorPercentage: Float['output'], displayName: String['output'], type: OperationType | null, id: String['output'] }>, byP95: Array<{ __typename: 'TopNOperationsByP95Record', serviceTimeP95Ms: Float['output'], displayName: String['output'], type: OperationType | null, id: String['output'] }> } } | null } | null };

export type TestStatsWindowFromValidationWindowQueryVariables = Exact<{ [key: string]: never; }>;


export type TestStatsWindowFromValidationWindowQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, checkWorkflow: { __typename: 'CheckWorkflow', id: ID['output'], createdAt: Timestamp['output'], validationConfig: { __typename: 'SchemaDiffValidationConfig', from: Timestamp['output'] | null, to: Timestamp['output'] | null } | null } | null } | null };

export type StatsWindowFromValidationWindowOperationsCheckFragment = { __typename: 'CheckWorkflow', id: ID['output'], createdAt: Timestamp['output'], validationConfig: { __typename: 'SchemaDiffValidationConfig', from: Timestamp['output'] | null, to: Timestamp['output'] | null } | null };

export type GraphNavQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type GraphNavQuery = { service: { __typename: 'Service', id: ID['output'], graphType: GraphType, variant: { __typename: 'GraphVariant', id: ID['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null } | null, account: { __typename: 'Account', id: ID['output'], name: String['output'] } | null } | null };

export type OrgSwitcherQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgSwitcherQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], isSsoV2: Boolean['output'], email: String['output'] | null, fullName: String['output'], avatarUrl: String['output'] | null, internalAdminRole: InternalMdgAdminRole | null, type: UserType, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, user: { __typename: 'User', id: ID['output'] }, account: { __typename: 'Account', id: ID['output'], name: String['output'], avatarUrl: String['output'] | null, isLocked: Boolean['output'] | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, name: String['output'] } } }> }
   | null };

export type BillingContactEmailSectionAccountFragment = { __typename: 'Account', id: ID['output'], billingContactEmail: String['output'] | null };

export type BillingContactEmailModalAccountFragment = { __typename: 'Account', id: ID['output'], billingContactEmail: String['output'] | null };

export type UI__ClientListQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  filter?: InputMaybe<ServiceQueryStatsFilter>;
}>;


export type UI__ClientListQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', group: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, clientVersion: String['output'] | null } }> } | null } | null };

export type UI__SubmitPostDeletionFeedbackMutationVariables = Exact<{
  feedback: Scalars['String']['input'];
  targetType: DeletionTargetType;
  targetIdentifier: Scalars['ID']['input'];
}>;


export type UI__SubmitPostDeletionFeedbackMutation = { submitPostDeletionFeedback: Void['output'] | null };

export type CreditCardDisplayAccountFragment = { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', name: String['output'] | null, cardType: String['output'] | null, year: Int['output'] | null, month: Int['output'] | null, lastFour: Int['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null };

export type TEST__AccountProviderQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type TEST__AccountProviderQuery = { account: { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', vatNumber: String['output'] | null, name: String['output'] | null, month: Int['output'] | null, year: Int['output'] | null, cardType: String['output'] | null, lastFour: Int['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null } | null };

export type CreditCardFormAccountFragment = { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', vatNumber: String['output'] | null, name: String['output'] | null, month: Int['output'] | null, year: Int['output'] | null, cardType: String['output'] | null, lastFour: Int['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null };

export type Org__UpdateBillingInfoVariables = Exact<{
  accountId: Scalars['ID']['input'];
  tokenId: Scalars['String']['input'];
}>;


export type Org__UpdateBillingInfo = { account: { __typename: 'AccountMutation', updateBillingInfo: Void['output'] | null } | null };

export type Org__UpdateBillingAddressVariables = Exact<{
  accountId: Scalars['ID']['input'];
  address: BillingAddressInput;
}>;


export type Org__UpdateBillingAddress = { account: { __typename: 'AccountMutation', updateBillingAddress: { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', vatNumber: String['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null } | null } | null };

export type CreditCardFormStripeFragment = { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', vatNumber: String['output'] | null, name: String['output'] | null, month: Int['output'] | null, year: Int['output'] | null, lastFour: Int['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null };

export type UpdatePaymentMethodMutationVariables = Exact<{
  internalAccountId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type UpdatePaymentMethodMutation = { billing: { __typename: 'BillingMutation', updatePaymentMethod:
      | { __typename: 'Account', id: ID['output'], billingInfo: { __typename: 'BillingInfo', vatNumber: String['output'] | null, name: String['output'] | null, month: Int['output'] | null, year: Int['output'] | null, lastFour: Int['output'] | null, address: { __typename: 'BillingAddress', address1: String['output'] | null, address2: String['output'] | null, city: String['output'] | null, state: String['output'] | null, country: String['output'] | null, zip: String['output'] | null } } | null }
      | { __typename: 'NotFoundError' }
      | { __typename: 'PermissionError' }
      | { __typename: 'UpdatePaymentMethodSuccess', paymentMethodId: String['output'] }
     | null } | null };

export type EnterpriseEntitlementsExpiryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type EnterpriseEntitlementsExpiry = { account: { __typename: 'Account', id: ID['output'], routerEntitlement: { __typename: 'RouterEntitlement', warnAt: Timestamp['output'] | null, haltAt: Timestamp['output'] | null } | null } | null };

export type Service_ErroredTraceSummariesQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  filter: ServiceTracePathErrorsRefsFilter;
  timeFrom: Scalars['Timestamp']['input'];
  timeTo: Scalars['Timestamp']['input'];
  limit: Scalars['Int']['input'];
}>;


export type Service_ErroredTraceSummariesQuery = { service: { __typename: 'Service', id: ID['output'], stats: { __typename: 'ServiceStatsWindow', tracePathErrorsRefs: Array<{ __typename: 'ServiceTracePathErrorsRefsRecord', group: { __typename: 'ServiceTracePathErrorsRefsDimensions', errorMessage: String['output'] | null, queryId: ID['output'] | null, queryName: String['output'] | null, traceStartsAt: Timestamp['output'] | null, traceId: ID['output'] | null, traceHttpStatusCode: Int['output'] | null }, metrics: { __typename: 'ServiceTracePathErrorsRefsMetrics', errorsCountInPath: Long['output'] } }> } | null } | null };

export type UI__resendInvitationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  inviteId: Scalars['ID']['input'];
}>;


export type UI__resendInvitationMutation = { account: { __typename: 'AccountMutation', resendInvitation: { __typename: 'AccountInvitation', id: ID['output'], lastSentAt: Timestamp['output'] | null } | null } | null };

export type GraphArtifactTagsModalQueryVariables = Exact<{
  graphArtifactId: Scalars['ID']['input'];
  graphID: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GraphArtifactTagsModalQuery = { graphArtifactById: { __typename: 'GraphArtifact', id: ID['output'], tags: { __typename: 'GraphArtifactTagConnection', totalCount: Int['output'], edges: Array<{ __typename: 'GraphArtifactTagEdge', node: { __typename: 'GraphArtifactTag', tag: String['output'] } }>, pageInfo: { __typename: 'PageInfo', endCursor: String['output'] | null, hasNextPage: Boolean['output'] } } } | null };

export type AddExistingGraphFormContentGraphIDAvailableQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type AddExistingGraphFormContentGraphIDAvailableQuery = { account: { __typename: 'Account', id: ID['output'], graphIDAvailable: Boolean['output'] } | null };

export type GraphSetupModalQueryVariables = Exact<{ [key: string]: never; }>;


export type GraphSetupModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], name: String['output'], roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'] }>, capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type AddGraphMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  graphId: Scalars['ID']['input'];
  graphTitle: Scalars['String']['input'];
  hiddenFromUninvitedNonAdminAccountMembers: Scalars['Boolean']['input'];
  onboardingArchitecture: OnboardingArchitecture;
}>;


export type AddGraphMutation = { newService: { __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType, avatarUrl: String['output'] | null, description: String['output'] | null, hiddenFromUninvitedNonAdminAccountMembers: Boolean['output'], account: { __typename: 'Account', id: ID['output'] } | null, roles: { __typename: 'ServiceRoles', canQueryTokens: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateAvatar: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canQueryProposals: Boolean['output'], canQueryStats: Boolean['output'], canQueryImplementingServices: Boolean['output'] } | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], url: String['output'] | null, isProtected: Boolean['output'], isContract: Boolean['output'] | null, isPublic: Boolean['output'], hasManagedSubgraphs: Boolean['output'] | null, requestsInLastDay: Long['output'] | null, usageLastReportedAt: Timestamp['output'] | null, subgraphCount: Int['output'] | null, hasSupergraphSchema: Boolean['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'], code: String['output'] | null }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], fieldCount: Int['output'], typeCount: Int['output'] }, launch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
              | { __typename: 'BuildFailure' }
              | { __typename: 'BuildSuccess', coreSchema: { __typename: 'CoreSchema', coreHash: String['output'], metadata: { __typename: 'SchemaMetadata', entityCount: Int['output'] | null } | null } }
             | null } | null } | null } | null }> } | null };

export type InsightsEnforcementWarningQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type InsightsEnforcementWarningQuery = { graph: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], ruleEnforcements: Array<{ __typename: 'RuleEnforcement', id: ID['output'], policy: EnforcementPolicy, deletedAt: Timestamp['output'] | null }> } | null } | null };

export type MultiSelectStoryQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type MultiSelectStoryQuery = { service: { __typename: 'Service', id: ID['output'], checksBranchOptions: Array<String['output']> } | null };

export type UI__accountBillingEmailQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UI__accountBillingEmailQuery = { account: { __typename: 'Account', id: ID['output'], name: String['output'], billingContactEmail: String['output'] | null, isOnTrial: Boolean['output'], currentSubscription: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], provider: BillingProvider | null } } | null } | null };

export type UI__userResendVerificationEmailVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UI__userResendVerificationEmail = { user: { __typename: 'UserMutation', resendVerificationEmail: Void['output'] | null } | null };

export type OdysseyCertificationColumnFragment = { __typename: 'OdysseyCertification', id: ID['output'], certificationId: String['output'] };

export type TotalCountForSparklineFragment = { __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'] } }, groupBy: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, operationType: String['output'] | null, operationSubtype: String['output'] | null } };

export type OperationClientUsageSparklinesQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  timeFrom: Scalars['Timestamp']['input'];
  timeTo?: InputMaybe<Scalars['Timestamp']['input']>;
  resolution: Resolution;
  filter?: InputMaybe<ServiceQueryStatsFilter>;
}>;


export type OperationClientUsageSparklinesQuery = { service: { __typename: 'Service', id: ID['output'], totalCount: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', metrics: { __typename: 'ServiceQueryStatsMetrics', totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'] } }, groupBy: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, operationType: String['output'] | null, operationSubtype: String['output'] | null } }> } | null, sparklines: { __typename: 'ServiceStatsWindow', queryStats: Array<{ __typename: 'ServiceQueryStatsRecord', timestamp: Timestamp['output'], metrics: { __typename: 'ServiceQueryStatsMetrics', totalLatencyHistogram: { __typename: 'DurationHistogram', totalCount: Long['output'] } }, groupBy: { __typename: 'ServiceQueryStatsDimensions', clientName: String['output'] | null, operationType: String['output'] | null, operationSubtype: String['output'] | null } }> } | null } | null };

export type UsePermissionsAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UsePermissionsAccountQuery = { account: { __typename: 'Account', id: ID['output'], roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'], canDelete: Boolean['output'], canQuery: Boolean['output'], canManageMembers: Boolean['output'], canManageSessions: Boolean['output'], canUpdateBillingInfo: Boolean['output'], canUpdateMetadata: Boolean['output'], canQueryMembers: Boolean['output'], canQueryBillingInfo: Boolean['output'], canSetConstrainedPlan: Boolean['output'], canRemoveMembers: Boolean['output'], canAudit: Boolean['output'], canQueryStats: Boolean['output'], canReadTickets: Boolean['output'], canProvisionSSO: Boolean['output'], canViewApiKeyManagementPage: Boolean['output'] } | null } | null };

export type UsePermissionsServiceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type UsePermissionsServiceQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null, roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, roles: { __typename: 'ServiceRoles', canCreateVariants: Boolean['output'], canCheckSchemas: Boolean['output'], canDelete: Boolean['output'], canQueryProposals: Boolean['output'], canManageAccess: Boolean['output'], canManageIntegrations: Boolean['output'], canManageKeys: Boolean['output'], canManageProposalPermissions: Boolean['output'], canManageVariants: Boolean['output'], canQueryCheckConfiguration: Boolean['output'], canQueryDeletedImplementingServices: Boolean['output'], canQueryImplementingServices: Boolean['output'], canQueryIntegrations: Boolean['output'], canQueryPrivateInfo: Boolean['output'], canQueryPublicInfo: Boolean['output'], canQueryRoleOverrides: Boolean['output'], canQuerySchemas: Boolean['output'], canQueryTokens: Boolean['output'], canRegisterOperations: Boolean['output'], canUndelete: Boolean['output'], canUpdateAvatar: Boolean['output'], canUpdateTitle: Boolean['output'], canUpdateDescription: Boolean['output'], canWriteCheckConfiguration: Boolean['output'], canQueryStats: Boolean['output'], canQueryTraces: Boolean['output'], canQueryReadmeAuthor: Boolean['output'], canQueryPersistedQueryLists: Boolean['output'], canManagePersistedQueryLists: Boolean['output'], canManageProposalSettings: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], isProtected: Boolean['output'], permissions: { __typename: 'GraphVariantPermissions', canPushSchemas: Boolean['output'], canManageExplorerSettings: Boolean['output'], canUpdateVariantReadme: Boolean['output'], canUpdateVariantLinkInfo: Boolean['output'], canManageBuildConfig: Boolean['output'], canQueryBuildConfig: Boolean['output'], canManageCloudRouter: Boolean['output'], canQueryCloudRouter: Boolean['output'], canQuerySchemas: Boolean['output'], canQueryLaunches: Boolean['output'] } } | null } | null };

export type PlanProtectedAreaQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  canQueryBilling: Scalars['Boolean']['input'];
  shouldQueryCapabilities: Scalars['Boolean']['input'];
}>;


export type PlanProtectedAreaQuery = { account: { __typename: 'Account', id: ID['output'], name: String['output'], isOnExpiredTrial: Boolean['output'], lockType: AccountLockType | null, isLocked: Boolean['output'] | null, expiredTrialSubscription?: { __typename: 'BillingSubscription', uuid: ID['output'], plan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind } } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, tier: BillingPlanTier }, roles: { __typename: 'AccountRoles', canSetConstrainedPlan: Boolean['output'], canQueryBillingInfo: Boolean['output'] } | null, capabilities: { __typename: 'AccountCapabilities', connectorsInRouter: Boolean['output'], proposals: Boolean['output'], webhooks: Boolean['output'], persistedQueries: Boolean['output'], launches: Boolean['output'], clients: Boolean['output'], metrics: Boolean['output'], cloudGraphs: Boolean['output'], clientVersions: Boolean['output'], traces: Boolean['output'], datadog: Boolean['output'], notifications: Boolean['output'], contracts: Boolean['output'], userRoles: Boolean['output'] } | null } | null };

export type PublicVariantPreviewBannerQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type PublicVariantPreviewBannerQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'] } | null } | null };

export type PublishSchemaGraphFragment = { __typename: 'Service', id: ID['output'], graphType: GraphType, onboardingArchitecture: OnboardingArchitecture | null, account: { __typename: 'Account', id: ID['output'] } | null, variant?: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], hasManagedSubgraphs: Boolean['output'] | null, latestPublication: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
          | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'] }> }
          | { __typename: 'BuildSuccess' }
         | null } | null } | null } | null };

export type PublishSchemaApiKeysQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type PublishSchemaApiKeysQuery = { graph: { __typename: 'Service', id: ID['output'], apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], keyName: String['output'] | null, token: String['output'] }> | null } | null };

export type UploadSchemaIntrospectionMutationVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  uploadSchemaSchema?: InputMaybe<IntrospectionSchemaInput>;
}>;


export type UploadSchemaIntrospectionMutation = { service: { __typename: 'ServiceMutation', uploadSchema: { __typename: 'UploadSchemaMutationResponse', success: Boolean['output'] } | null } | null };

export type UpdateVariantUrlMutationVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVariantUrlMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateURL: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null } | null } | null } | null };

export type PublishUsingFederationQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type PublishUsingFederationQuery = { graph: { __typename: 'Service', id: ID['output'], defaultBuildPipelineTrack: String['output'] | null } | null };

export type UploadSchemaDocumentMutationVariables = Exact<{
  uploadSchemaTag: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
  uploadSchemaSchemaDocument?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadSchemaDocumentMutation = { service: { __typename: 'ServiceMutation', uploadSchema: { __typename: 'UploadSchemaMutationResponse', success: Boolean['output'] } | null } | null };

export type UsePublishedSchemaQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  noVariant: Scalars['Boolean']['input'];
}>;


export type UsePublishedSchemaQuery = { graph: { __typename: 'Service', id: ID['output'], graphType: GraphType, onboardingArchitecture: OnboardingArchitecture | null, account: { __typename: 'Account', id: ID['output'] } | null, variant?: { __typename: 'GraphVariant', id: ID['output'], name: String['output'], hasManagedSubgraphs: Boolean['output'] | null, latestPublication: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', createdAt: Timestamp['output'], hash: ID['output'], document: GraphQLDocument['output'] } } | null, latestLaunch: { __typename: 'Launch', id: ID['output'], build: { __typename: 'Build', id: ID['output'], result:
            | { __typename: 'BuildFailure', errorMessages: Array<{ __typename: 'BuildError', message: String['output'] }> }
            | { __typename: 'BuildSuccess' }
           | null } | null } | null } | null } | null };

export type PublishToNewGraphModalGraphIDAvailableQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  graphId: Scalars['ID']['input'];
}>;


export type PublishToNewGraphModalGraphIDAvailableQuery = { account: { __typename: 'Account', id: ID['output'], graphIDAvailable: Boolean['output'] } | null };

export type PublishToNewGraphModalQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishToNewGraphModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', name: String['output'], id: ID['output'], avatarUrl: String['output'] | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], description: String['output'] | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'], name: String['output'], isContract: Boolean['output'] | null, hasManagedSubgraphs: Boolean['output'] | null, activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], publishedAt: Timestamp['output'] } | null }>, roles: { __typename: 'ServiceRoles', canCheckSchemas: Boolean['output'] } | null }>, roles: { __typename: 'AccountRoles', canCreateService: Boolean['output'] } | null }, user: { __typename: 'User', id: ID['output'] } }>, sandboxOperationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'], name: String['output'] }> }
   | null };

export type DuplicateSandboxCollectionToVariantVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  collectionName: Scalars['String']['input'];
  variantRef?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DuplicateSandboxCollectionToVariant = { operationCollection: { __typename: 'OperationCollectionMutation', duplicateCollection:
      | { __typename: 'OperationCollection', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], operationCollections: Array<{ __typename: 'OperationCollection', id: ID['output'] }> }> }
      | { __typename: 'PermissionError' }
      | { __typename: 'ValidationError' }
     } | null };

export type SandboxPublish_UploadSchemaIntrospectionMutationVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  uploadSchemaSchemaDocument: Scalars['String']['input'];
}>;


export type SandboxPublish_UploadSchemaIntrospectionMutation = { service: { __typename: 'ServiceMutation', uploadSchema: { __typename: 'UploadSchemaMutationResponse', success: Boolean['output'] } | null } | null };

export type SandboxPublish_UpdateVariantUrlMutationVariables = Exact<{
  graphVariant: Scalars['String']['input'];
  graphId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type SandboxPublish_UpdateVariantUrlMutation = { service: { __typename: 'ServiceMutation', variant: { __typename: 'GraphVariantMutation', updateURL: { __typename: 'GraphVariant', id: ID['output'], url: String['output'] | null } | null } | null } | null };

export type SetupMetricsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type SetupMetricsQuery = { service: { __typename: 'Service', id: ID['output'], account: { __typename: 'Account', id: ID['output'], availableRoles: Array<UserPermission> } | null, apiKeys: Array<{ __typename: 'GraphApiKey', id: ID['output'], token: String['output'] }> | null } | null };

type SupportRequestModalCommonFragment_InternalIdentity = { __typename: 'InternalIdentity', id: ID['output'] };

type SupportRequestModalCommonFragment_Service = { __typename: 'Service', id: ID['output'] };

type SupportRequestModalCommonFragment_ServiceAccount = { __typename: 'ServiceAccount', id: ID['output'] };

type SupportRequestModalCommonFragment_User = { __typename: 'User', id: ID['output'], email: String['output'] | null, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], name: String['output'], services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType }> }, user: { __typename: 'User', id: ID['output'] } }> };

export type SupportRequestModalCommonFragment =
  | SupportRequestModalCommonFragment_InternalIdentity
  | SupportRequestModalCommonFragment_Service
  | SupportRequestModalCommonFragment_ServiceAccount
  | SupportRequestModalCommonFragment_User
;

export type SupportRequestModalQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportRequestModalQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], id: ID['output'], email: String['output'] | null, memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], internalID: ID['output'], name: String['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, name: String['output'] }, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], graphType: GraphType }> }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type SubmitSupportTicketVariables = Exact<{
  ticket: SupportTicketInput;
  userId: Scalars['ID']['input'];
}>;


export type SubmitSupportTicket = { user: { __typename: 'UserMutation', submitSupportTicket: { __typename: 'SupportTicket', id: Int['output'] } | null } | null };

export type UserThemeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserThemeQuery = { studioSettings: { __typename: 'UserSettings', id: String['output'], themeName: ThemeName } | null };

export type GetCurrentUserVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUser = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type ApiKeyFragment = { __typename: 'UserApiKey', id: ID['output'], token: String['output'], keyName: String['output'] | null };

export type GenerateUserAPIKeyVariables = Exact<{
  userId: Scalars['ID']['input'];
  keyName: Scalars['String']['input'];
}>;


export type GenerateUserAPIKey = { user: { __typename: 'UserMutation', user: { __typename: 'User', id: ID['output'] }, newKey: { __typename: 'UserApiKey', id: ID['output'], token: String['output'], keyName: String['output'] | null } } | null };

export type GetSchemaByHashVariables = Exact<{
  graphId: Scalars['ID']['input'];
  hash: Scalars['SHA256']['input'];
}>;


export type GetSchemaByHash = { service: { __typename: 'Service', id: ID['output'], document: GraphQLDocument['output'] | null } | null };

export type NewFedVersionToastQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type NewFedVersionToastQuery = { service: { __typename: 'Service', id: ID['output'], roles: { __typename: 'ServiceRoles', canManageBuildConfig: Boolean['output'] } | null, variant: { __typename: 'GraphVariant', id: ID['output'], federationVersion: String['output'] | null, compositionVersion: String['output'] | null, allowedTracks: Array<{ __typename: 'BuildPipelineTrackDetails', badge: BuildPipelineTrackBadge | null, compositionVersion: String['output'], buildPipelineTrack: BuildPipelineTrack, deprecatedAt: Timestamp['output'] | null, displayName: String['output'], minimumGatewayVersion: String['output'] | null, minimumRouterVersion: String['output'] | null, notSupportedAt: Timestamp['output'] | null, federationVersion: FederationVersion['output'] } | null>, latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
          | { __typename: 'CompositionBuildInput', version: String['output'] | null }
          | { __typename: 'FilterBuildInput' }
         } | null } | null } | null };

export type UseCurrentPlanQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UseCurrentPlanQuery = { account: { __typename: 'Account', id: ID['output'], limits: { __typename: 'AccountLimits', maxRangeInDays: Int['output'], maxAuditInDays: Int['output'], maxRangeInDaysForChecks: Int['output'], maxRequestsPerMonth: Long['output'] | null } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, tier: BillingPlanTier, provider: BillingProvider | null } } | null };

export type UseAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAppSettingsQuery = { studioSettings: { __typename: 'UserSettings', id: String['output'], appNavCollapsed: Boolean['output'] } | null };

export type SetAppSettingsVariablesVariables = Exact<{
  newSettings?: InputMaybe<UserSettingsInput>;
}>;


export type SetAppSettingsVariables = { setUserSettings: { __typename: 'UserSettings', id: String['output'], appNavCollapsed: Boolean['output'] } | null };

export type UseCapabilitiesFragment = { __typename: 'Account', id: ID['output'], capabilities: { __typename: 'AccountCapabilities', connectorsInRouter: Boolean['output'], proposals: Boolean['output'], webhooks: Boolean['output'], persistedQueries: Boolean['output'], launches: Boolean['output'], clients: Boolean['output'], metrics: Boolean['output'], cloudGraphs: Boolean['output'], clientVersions: Boolean['output'], traces: Boolean['output'], datadog: Boolean['output'], notifications: Boolean['output'], contracts: Boolean['output'], userRoles: Boolean['output'] } | null };

export type UseCapabilitiesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UseCapabilitiesQuery = { account: { __typename: 'Account', id: ID['output'], capabilities: { __typename: 'AccountCapabilities', connectorsInRouter: Boolean['output'], proposals: Boolean['output'], webhooks: Boolean['output'], persistedQueries: Boolean['output'], launches: Boolean['output'], clients: Boolean['output'], metrics: Boolean['output'], cloudGraphs: Boolean['output'], clientVersions: Boolean['output'], traces: Boolean['output'], datadog: Boolean['output'], notifications: Boolean['output'], contracts: Boolean['output'], userRoles: Boolean['output'] } | null } | null };

export type ConditionalTrialForwardingQueryVariables = Exact<{ [key: string]: never; }>;


export type ConditionalTrialForwardingQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], memberships: Array<{ __typename: 'UserMembership', account: { __typename: 'Account', id: ID['output'], hasBeenOnTrial: Boolean['output'], currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier, kind: BillingPlanKind, isTrial: Boolean['output'] } }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type SetCurrentAccountIdMutationVariables = Exact<{
  currentAccountId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetCurrentAccountIdMutation = { setCurrentAccountId: ID['output'] | null };

export type CurrentAccountIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountIdQuery = { currentAccountId: ID['output'] | null };

export type UseCurrentSubscriptionQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  canQueryBilling: Scalars['Boolean']['input'];
}>;


export type UseCurrentSubscriptionQuery = { account: { __typename: 'Account', id: ID['output'], isLocked: Boolean['output'] | null, currentSubscription?: { __typename: 'BillingSubscription', canceledAt: Timestamp['output'] | null, autoRenew: Boolean['output'], pricePerSeatInUsdCents: Int['output'] | null, pricePerUnitInUsdCents: Int['output'], currentPeriodStartedAt: Timestamp['output'], currentPeriodEndsAt: Timestamp['output'], state: SubscriptionState, trialExpiresAt: Timestamp['output'] | null, id: ID['output'] } | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], readableId: ID['output'] } } | null };

export type UseSelectedVariantQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
}>;


export type UseSelectedVariantQuery = { service: { __typename: 'Service', id: ID['output'], variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'], isFavoriteOfCurrentUser: Boolean['output'] }> } | null };

export type HandleFavoriteMutationVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  variantName: Scalars['String']['input'];
  favorite: Scalars['Boolean']['input'];
}>;


export type HandleFavoriteMutation = { __typename: 'Mutation', service: { __typename: 'ServiceMutation', id: ID['output'], variant: { __typename: 'GraphVariantMutation', id: ID['output'], setIsFavoriteOfCurrentUser: { __typename: 'GraphVariant', id: ID['output'], isFavoriteOfCurrentUser: Boolean['output'] } } | null } | null };

export type UserIdentityAnalyticsFragment = { __typename: 'User', id: ID['output'], fullName: String['output'], email: String['output'] | null, avatarUrl: String['output'] | null, createdAt: Timestamp['output'] };

export type AccountIdentityAccountFragment = { __typename: 'Account', id: ID['output'], internalID: ID['output'], name: String['output'], avatarUrl: String['output'] | null, createdAt: Timestamp['output'] | null, isLocked: Boolean['output'] | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier } };

export type UI__IdentityQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UI__IdentityQuery = { isLoggedIn: Boolean['output'] | null, ssoLoginUrl: String['output'] | null, me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'], email: String['output'] | null, emailVerified: Boolean['output'], fullName: String['output'], avatarUrl: String['output'] | null, internalAdminRole: InternalMdgAdminRole | null, canUpdateEmail: Boolean['output'], canUpdateFullName: Boolean['output'], acceptedPrivacyPolicyAt: Timestamp['output'] | null, type: UserType, logoutAfterIdleMs: Int['output'] | null, createdAt: Timestamp['output'], memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], internalID: ID['output'], name: String['output'], avatarUrl: String['output'] | null, createdAt: Timestamp['output'] | null, isLocked: Boolean['output'] | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], tier: BillingPlanTier } }, user: { __typename: 'User', id: ID['output'] } }> }
   | null };

export type UseNewFedNextVersionAvailableFragment = { __typename: 'GraphVariant', id: ID['output'], latestLaunch: { __typename: 'Launch', id: ID['output'], buildInput:
      | { __typename: 'CompositionBuildInput', version: String['output'] | null }
      | { __typename: 'FilterBuildInput' }
     } | null };

export type User__PersonalSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type User__PersonalSettingsQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', type: UserType, id: ID['output'], fullName: String['output'], canUpdateFullName: Boolean['output'], email: String['output'] | null, canUpdateEmail: Boolean['output'], synchronized: Boolean['output'], betaFeaturesOn: Boolean['output'], memberships: Array<{ __typename: 'UserMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'], avatarUrl: String['output'] | null, name: String['output'], capabilities: { __typename: 'AccountCapabilities', userRoles: Boolean['output'] } | null, sso: { __typename: 'OrganizationSSO', provider: OrganizationSSOProvider } | null, services: Array<{ __typename: 'Service', id: ID['output'], title: String['output'], roleOverrides: Array<{ __typename: 'RoleOverride', role: UserPermission, user: { __typename: 'User', id: ID['output'] } }> | null, variants: Array<{ __typename: 'GraphVariant', id: ID['output'], name: String['output'] }> }>, memberships: Array<{ __typename: 'AccountMembership', role: UserPermission, account: { __typename: 'Account', id: ID['output'] }, user: { __typename: 'User', id: ID['output'] } }> | null }, user: { __typename: 'User', id: ID['output'] } }>, apiKeys: Array<{ __typename: 'UserApiKey', id: ID['output'], keyName: String['output'] | null, lastUsed: Timestamp['output'] | null }> }
   | null };

export type ProvisionDefaultKeyVariables = Exact<{ [key: string]: never; }>;


export type ProvisionDefaultKey = { me:
    | { __typename: 'ServiceMutation' }
    | { __typename: 'UserMutation', user: { __typename: 'User', id: ID['output'] }, provisionKey: { __typename: 'ApiKeyProvision', created: Boolean['output'], apiKey:
          | { __typename: 'GraphApiKey', id: ID['output'], keyName: String['output'] | null, token: String['output'] }
          | { __typename: 'GraphOsKey', id: ID['output'], keyName: String['output'] | null, token: String['output'] }
          | { __typename: 'UserApiKey', id: ID['output'], keyName: String['output'] | null, token: String['output'] }
         } | null }
   | null };

export type PublishedSubgraphsQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
}>;


export type PublishedSubgraphsQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'], document: GraphQLDocument['output'] }, compositionResult:
          | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
          | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
         | null } | null, sourceVariant: { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], schema: { __typename: 'Schema', hash: ID['output'], createdAt: Timestamp['output'] }, compositionResult:
            | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
            | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
           | null } | null } | null } | null } | null };

export type SetDefaultBuildPipelineTrackVariables = Exact<{
  graphId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
}>;


export type SetDefaultBuildPipelineTrack = { graph: { __typename: 'ServiceMutation', setDefaultBuildPipelineTrack: String['output'] | null } | null };

export type SetPlanMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
}>;


export type SetPlanMutation = { account: { __typename: 'AccountMutation', setPlan: Void['output'] | null } | null };

export type UseSubgraphMetaHelpersFragment = { __typename: 'GraphVariant', id: ID['output'], activeSchemaPublish: { __typename: 'SchemaTag', id: ID['output'], compositionResult:
      | { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
      | { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> }
     | null } | null, entities:
    | { __typename: 'EntitiesErrorResponse' }
    | { __typename: 'EntitiesResponse', entities: Array<{ __typename: 'Entity', typename: String['output'], subgraphKeys: Array<{ __typename: 'SubgraphKeyMap', keys: Array<String['output']>, subgraphName: String['output'] }> | null }> }
   | null };

export type RoutedAppMeQueryVariables = Exact<{ [key: string]: never; }>;


export type RoutedAppMeQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type TrackMutationVariables = Exact<{
  event: EventEnum;
  graphVariant: Scalars['String']['input'];
  graphID: Scalars['String']['input'];
}>;


export type TrackMutation = { track: Void['output'] | null };

export type UpdateBillingContactEmailVariables = Exact<{
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateBillingContactEmail = { account: { __typename: 'AccountMutation', updateEmail: Void['output'] | null } | null };

export type CatchErrorsTestQueryVariables = Exact<{ [key: string]: never; }>;


export type CatchErrorsTestQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type ClientSchemaSetCurrentAccountIdCacheWriteQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSchemaSetCurrentAccountIdCacheWriteQuery = { currentAccountId: ID['output'] | null };

export type IsLoggedInInitialCacheSeedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedInInitialCacheSeedQuery = { isLoggedIn: Boolean['output'] | null };

export type SentryIgnoreErrorsTestQueryVariables = Exact<{ [key: string]: never; }>;


export type SentryIgnoreErrorsTestQuery = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', id: ID['output'] }
   | null };

export type LaunchLookupQueryVariables = Exact<{
  graphId: Scalars['ID']['input'];
  graphVariant: Scalars['String']['input'];
  launchId: Scalars['ID']['input'];
}>;


export type LaunchLookupQuery = { service: { __typename: 'Service', id: ID['output'], variant: { __typename: 'GraphVariant', id: ID['output'], launch: { __typename: 'Launch', id: ID['output'] } | null } | null } | null };

export type TestLaunchEntity = { __typename: 'Launch', id: ID['output'] };

type SubgraphMetaSubgraphsFragment_CompositionPublishResult = { __typename: 'CompositionPublishResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> };

type SubgraphMetaSubgraphsFragment_CompositionValidationResult = { __typename: 'CompositionValidationResult', graphCompositionID: ID['output'], subgraphConfigs: Array<{ __typename: 'SubgraphConfig', id: ID['output'], name: String['output'], sdl: String['output'] }> };

export type SubgraphMetaSubgraphsFragment =
  | SubgraphMetaSubgraphsFragment_CompositionPublishResult
  | SubgraphMetaSubgraphsFragment_CompositionValidationResult
;

export type SubgraphMetaEntitiesFragment = { __typename: 'EntitiesResponse', entities: Array<{ __typename: 'Entity', typename: String['output'], subgraphKeys: Array<{ __typename: 'SubgraphKeyMap', keys: Array<String['output']>, subgraphName: String['output'] }> | null }> };

export type LaunchDarklyProviderUserFragment = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', email: String['output'] | null, id: ID['output'] }
   | null };

export type LD_ME_QUERYVariables = Exact<{ [key: string]: never; }>;


export type LD_ME_QUERY = { me:
    | { __typename: 'InternalIdentity', id: ID['output'] }
    | { __typename: 'Service', id: ID['output'] }
    | { __typename: 'ServiceAccount', id: ID['output'] }
    | { __typename: 'User', fullName: String['output'], email: String['output'] | null, id: ID['output'] }
   | null };

export type LD_ACCOUNT_QUERYVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type LD_ACCOUNT_QUERY = { account: { __typename: 'Account', internalID: ID['output'], id: ID['output'], createdAt: Timestamp['output'] | null, currentPlan: { __typename: 'BillingPlan', id: ID['output'], kind: BillingPlanKind, tier: BillingPlanTier } } | null };
